import { api } from '@/app/api/baseApi';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  LocalDate: { input: any; output: any; }
  Long: { input: any; output: any; }
  UUID: { input: string; output: string; }
  UnsignedByte: { input: any; output: any; }
};

export type Account = {
  __typename: 'Account';
  accountStatus: Maybe<Scalars['Int']['output']>;
  aging30: Maybe<Scalars['Decimal']['output']>;
  aging30Base: Maybe<Scalars['Decimal']['output']>;
  aging60: Maybe<Scalars['Decimal']['output']>;
  aging60Base: Maybe<Scalars['Decimal']['output']>;
  aging90: Maybe<Scalars['Decimal']['output']>;
  aging90Base: Maybe<Scalars['Decimal']['output']>;
  aging120: Maybe<Scalars['Decimal']['output']>;
  aging120Base: Maybe<Scalars['Decimal']['output']>;
  aging180: Maybe<Scalars['Decimal']['output']>;
  aging180Base: Maybe<Scalars['Decimal']['output']>;
  aging365: Maybe<Scalars['Decimal']['output']>;
  aging365Base: Maybe<Scalars['Decimal']['output']>;
  aging365Plus: Maybe<Scalars['Decimal']['output']>;
  aging365PlusBase: Maybe<Scalars['Decimal']['output']>;
  annotations: Array<Annotation>;
  billingAddress: Maybe<CustomerAddress>;
  billingDonorSchedules: Array<DonorSchedule>;
  code: Maybe<Scalars['String']['output']>;
  commercialOperations: Maybe<Scalars['Boolean']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  customerServiceRepresentative: Maybe<SystemUser>;
  customerServiceRepresentativeId: Maybe<Scalars['UUID']['output']>;
  doNotAllowTexting: Maybe<Scalars['Boolean']['output']>;
  doNotBulkEMail: Maybe<Scalars['Boolean']['output']>;
  doNotBulkPostalMail: Maybe<Scalars['Boolean']['output']>;
  doNotEMail: Maybe<Scalars['Boolean']['output']>;
  doNotFax: Maybe<Scalars['Boolean']['output']>;
  doNotPhone: Maybe<Scalars['Boolean']['output']>;
  doNotPostalMail: Maybe<Scalars['Boolean']['output']>;
  doNotSendMM: Maybe<Scalars['Boolean']['output']>;
  donorSchedules: Array<DonorSchedule>;
  emailAddress1: Maybe<Scalars['String']['output']>;
  emailAddress2: Maybe<Scalars['String']['output']>;
  emailAddress3: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isPwp: Maybe<Scalars['Boolean']['output']>;
  ivfPerEmbryo: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  priceTier: Maybe<Scalars['Int']['output']>;
  primaryContact: Maybe<Contact>;
  primaryContactId: Maybe<Scalars['UUID']['output']>;
  primaryTextingNumber: Maybe<Scalars['String']['output']>;
  ranchAddress: Maybe<CustomerAddress>;
  semenOwnerDonorSchedules: Array<DonorSchedule>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  tog90DayOverrideExpireDate: Maybe<Scalars['DateTime']['output']>;
  tog90daysPastDue: Maybe<Scalars['Int']['output']>;
};


export type AccountannotationsArgs = {
  order: InputMaybe<Array<AnnotationSortInput>>;
  where: InputMaybe<AnnotationFilterInput>;
};

export type AccountBreed = {
  __typename: 'AccountBreed';
  account: Account;
  accountId: Scalars['UUID']['output'];
  breed: Breed;
  breedId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
};

export type AccountBreedFilterInput = {
  account?: InputMaybe<AccountFilterInput>;
  accountId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<AccountBreedFilterInput>>;
  breed?: InputMaybe<BreedFilterInput>;
  breedId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<AccountBreedFilterInput>>;
};

export type AccountBreedInput = {
  account: AccountInput;
  accountId: Scalars['UUID']['input'];
  breed: BreedInput;
  breedId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
};

export type AccountDto = {
  __typename: 'AccountDto';
  accountCode: Scalars['String']['output'];
  accountId: Scalars['UUID']['output'];
  accountName: Scalars['String']['output'];
};

export type AccountFilterInput = {
  accountStatus?: InputMaybe<IntOperationFilterInput>;
  aging30?: InputMaybe<DecimalOperationFilterInput>;
  aging30Base?: InputMaybe<DecimalOperationFilterInput>;
  aging60?: InputMaybe<DecimalOperationFilterInput>;
  aging60Base?: InputMaybe<DecimalOperationFilterInput>;
  aging90?: InputMaybe<DecimalOperationFilterInput>;
  aging90Base?: InputMaybe<DecimalOperationFilterInput>;
  aging120?: InputMaybe<DecimalOperationFilterInput>;
  aging120Base?: InputMaybe<DecimalOperationFilterInput>;
  aging180?: InputMaybe<DecimalOperationFilterInput>;
  aging180Base?: InputMaybe<DecimalOperationFilterInput>;
  aging365?: InputMaybe<DecimalOperationFilterInput>;
  aging365Base?: InputMaybe<DecimalOperationFilterInput>;
  aging365Plus?: InputMaybe<DecimalOperationFilterInput>;
  aging365PlusBase?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<AccountFilterInput>>;
  billingDonorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  commercialOperations?: InputMaybe<BooleanOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  customerServiceRepresentative?: InputMaybe<SystemUserFilterInput>;
  customerServiceRepresentativeId?: InputMaybe<UuidOperationFilterInput>;
  doNotAllowTexting?: InputMaybe<BooleanOperationFilterInput>;
  doNotBulkEMail?: InputMaybe<BooleanOperationFilterInput>;
  doNotBulkPostalMail?: InputMaybe<BooleanOperationFilterInput>;
  doNotEMail?: InputMaybe<BooleanOperationFilterInput>;
  doNotFax?: InputMaybe<BooleanOperationFilterInput>;
  doNotPhone?: InputMaybe<BooleanOperationFilterInput>;
  doNotPostalMail?: InputMaybe<BooleanOperationFilterInput>;
  doNotSendMM?: InputMaybe<BooleanOperationFilterInput>;
  donorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  emailAddress1?: InputMaybe<StringOperationFilterInput>;
  emailAddress2?: InputMaybe<StringOperationFilterInput>;
  emailAddress3?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isPwp?: InputMaybe<BooleanOperationFilterInput>;
  ivfPerEmbryo?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountFilterInput>>;
  priceTier?: InputMaybe<IntOperationFilterInput>;
  primaryContact?: InputMaybe<ContactFilterInput>;
  primaryContactId?: InputMaybe<UuidOperationFilterInput>;
  primaryTextingNumber?: InputMaybe<StringOperationFilterInput>;
  semenOwnerDonorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  tog90DayOverrideExpireDate?: InputMaybe<DateTimeOperationFilterInput>;
  tog90daysPastDue?: InputMaybe<IntOperationFilterInput>;
};

export type AccountInput = {
  accountStatus?: InputMaybe<Scalars['Int']['input']>;
  aging30?: InputMaybe<Scalars['Decimal']['input']>;
  aging30Base?: InputMaybe<Scalars['Decimal']['input']>;
  aging60?: InputMaybe<Scalars['Decimal']['input']>;
  aging60Base?: InputMaybe<Scalars['Decimal']['input']>;
  aging90?: InputMaybe<Scalars['Decimal']['input']>;
  aging90Base?: InputMaybe<Scalars['Decimal']['input']>;
  aging120?: InputMaybe<Scalars['Decimal']['input']>;
  aging120Base?: InputMaybe<Scalars['Decimal']['input']>;
  aging180?: InputMaybe<Scalars['Decimal']['input']>;
  aging180Base?: InputMaybe<Scalars['Decimal']['input']>;
  aging365?: InputMaybe<Scalars['Decimal']['input']>;
  aging365Base?: InputMaybe<Scalars['Decimal']['input']>;
  aging365Plus?: InputMaybe<Scalars['Decimal']['input']>;
  aging365PlusBase?: InputMaybe<Scalars['Decimal']['input']>;
  billingDonorSchedules: Array<DonorScheduleInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  commercialOperations?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  customerServiceRepresentative?: InputMaybe<SystemUserInput>;
  customerServiceRepresentativeId?: InputMaybe<Scalars['UUID']['input']>;
  doNotAllowTexting?: InputMaybe<Scalars['Boolean']['input']>;
  doNotBulkEMail?: InputMaybe<Scalars['Boolean']['input']>;
  doNotBulkPostalMail?: InputMaybe<Scalars['Boolean']['input']>;
  doNotEMail?: InputMaybe<Scalars['Boolean']['input']>;
  doNotFax?: InputMaybe<Scalars['Boolean']['input']>;
  doNotPhone?: InputMaybe<Scalars['Boolean']['input']>;
  doNotPostalMail?: InputMaybe<Scalars['Boolean']['input']>;
  doNotSendMM?: InputMaybe<Scalars['Boolean']['input']>;
  donorSchedules: Array<DonorScheduleInput>;
  emailAddress1?: InputMaybe<Scalars['String']['input']>;
  emailAddress2?: InputMaybe<Scalars['String']['input']>;
  emailAddress3?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isPwp?: InputMaybe<Scalars['Boolean']['input']>;
  ivfPerEmbryo?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceTier?: InputMaybe<Scalars['Int']['input']>;
  primaryContact?: InputMaybe<ContactInput>;
  primaryContactId?: InputMaybe<Scalars['UUID']['input']>;
  primaryTextingNumber?: InputMaybe<Scalars['String']['input']>;
  semenOwnerDonorSchedules: Array<DonorScheduleInput>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  tog90DayOverrideExpireDate?: InputMaybe<Scalars['DateTime']['input']>;
  tog90daysPastDue?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountPartial = {
  __typename: 'AccountPartial';
  accountStatus: Maybe<Scalars['Int']['output']>;
  aging60: Maybe<Scalars['Decimal']['output']>;
  aging90: Maybe<Scalars['Decimal']['output']>;
  aging120: Maybe<Scalars['Decimal']['output']>;
  aging180: Maybe<Scalars['Decimal']['output']>;
  aging365: Maybe<Scalars['Decimal']['output']>;
  code: Scalars['String']['output'];
  id: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  tog90DayOverrideExpireDate: Maybe<Scalars['DateTime']['output']>;
  tog90daysPastDue: Maybe<Scalars['Int']['output']>;
};

export type AccountPartialFilterInput = {
  accountStatus?: InputMaybe<IntOperationFilterInput>;
  aging60?: InputMaybe<DecimalOperationFilterInput>;
  aging90?: InputMaybe<DecimalOperationFilterInput>;
  aging120?: InputMaybe<DecimalOperationFilterInput>;
  aging180?: InputMaybe<DecimalOperationFilterInput>;
  aging365?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<AccountPartialFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountPartialFilterInput>>;
  tog90DayOverrideExpireDate?: InputMaybe<DateTimeOperationFilterInput>;
  tog90daysPastDue?: InputMaybe<IntOperationFilterInput>;
};

export type AccountPartialSortInput = {
  accountStatus?: InputMaybe<SortEnumType>;
  aging60?: InputMaybe<SortEnumType>;
  aging90?: InputMaybe<SortEnumType>;
  aging120?: InputMaybe<SortEnumType>;
  aging180?: InputMaybe<SortEnumType>;
  aging365?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tog90DayOverrideExpireDate?: InputMaybe<SortEnumType>;
  tog90daysPastDue?: InputMaybe<SortEnumType>;
};

export type AccountSortInput = {
  accountStatus?: InputMaybe<SortEnumType>;
  aging30?: InputMaybe<SortEnumType>;
  aging30Base?: InputMaybe<SortEnumType>;
  aging60?: InputMaybe<SortEnumType>;
  aging60Base?: InputMaybe<SortEnumType>;
  aging90?: InputMaybe<SortEnumType>;
  aging90Base?: InputMaybe<SortEnumType>;
  aging120?: InputMaybe<SortEnumType>;
  aging120Base?: InputMaybe<SortEnumType>;
  aging180?: InputMaybe<SortEnumType>;
  aging180Base?: InputMaybe<SortEnumType>;
  aging365?: InputMaybe<SortEnumType>;
  aging365Base?: InputMaybe<SortEnumType>;
  aging365Plus?: InputMaybe<SortEnumType>;
  aging365PlusBase?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  commercialOperations?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  customerServiceRepresentative?: InputMaybe<SystemUserSortInput>;
  customerServiceRepresentativeId?: InputMaybe<SortEnumType>;
  doNotAllowTexting?: InputMaybe<SortEnumType>;
  doNotBulkEMail?: InputMaybe<SortEnumType>;
  doNotBulkPostalMail?: InputMaybe<SortEnumType>;
  doNotEMail?: InputMaybe<SortEnumType>;
  doNotFax?: InputMaybe<SortEnumType>;
  doNotPhone?: InputMaybe<SortEnumType>;
  doNotPostalMail?: InputMaybe<SortEnumType>;
  doNotSendMM?: InputMaybe<SortEnumType>;
  emailAddress1?: InputMaybe<SortEnumType>;
  emailAddress2?: InputMaybe<SortEnumType>;
  emailAddress3?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPwp?: InputMaybe<SortEnumType>;
  ivfPerEmbryo?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  priceTier?: InputMaybe<SortEnumType>;
  primaryContact?: InputMaybe<ContactSortInput>;
  primaryContactId?: InputMaybe<SortEnumType>;
  primaryTextingNumber?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  tog90DayOverrideExpireDate?: InputMaybe<SortEnumType>;
  tog90daysPastDue?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AccountsCollectionSegment = {
  __typename: 'AccountsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Account>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdUser = {
  __typename: 'AdUser';
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AddCalvesToCalfBasePayload = {
  __typename: 'AddCalvesToCalfBasePayload';
  /** The TOG_calfBase table that contains the newly added calf. */
  calves: Maybe<Array<Calf>>;
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The owner of the newly added calf. */
  owner: Maybe<Owner>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type AddViewInput = {
  app: Scalars['String']['input'];
  name: Scalars['String']['input'];
  usage: Scalars['String']['input'];
  username: Scalars['String']['input'];
  view: Scalars['String']['input'];
};

export type AetaResult = {
  __typename: 'AetaResult';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<SystemUser>;
  createdById: Scalars['UUID']['output'];
  embryoDevelopmentRate: Scalars['Float']['output'];
  embryosPerAspiration: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  oocytesPerAspiration: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<SystemUser>;
  updatedById: Maybe<Scalars['UUID']['output']>;
  year: Scalars['Int']['output'];
};

export type AetaResultFilterInput = {
  and?: InputMaybe<Array<AetaResultFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  embryoDevelopmentRate?: InputMaybe<FloatOperationFilterInput>;
  embryosPerAspiration?: InputMaybe<FloatOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  oocytesPerAspiration?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<AetaResultFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedById?: InputMaybe<UuidOperationFilterInput>;
  year?: InputMaybe<IntOperationFilterInput>;
};

export type AetaResultSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  embryoDevelopmentRate?: InputMaybe<SortEnumType>;
  embryosPerAspiration?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  oocytesPerAspiration?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export enum AetaResultType {
  BEEF = 'BEEF',
  DAIRY = 'DAIRY'
}

/** A segment of a collection. */
export type AetaResultsCollectionSegment = {
  __typename: 'AetaResultsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<AetaResult>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AllShipmentGroupMastersCollectionSegment = {
  __typename: 'AllShipmentGroupMastersCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<ShipmentGroupMaster>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AllShipmentsCollectionSegment = {
  __typename: 'AllShipmentsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Shipment>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Annotation = {
  __typename: 'Annotation';
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<Scalars['UUID']['output']>;
  documentBody: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  importSequenceNumber: Maybe<Scalars['Int']['output']>;
  isDocument: Scalars['Boolean']['output'];
  isPrivate: Maybe<Scalars['Boolean']['output']>;
  langId: Maybe<Scalars['String']['output']>;
  mimeType: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<Scalars['UUID']['output']>;
  noteText: Maybe<Scalars['String']['output']>;
  objectId: Maybe<Scalars['UUID']['output']>;
  objectTypeCode: Maybe<Scalars['Int']['output']>;
  overriddenCreatedOn: Maybe<Scalars['DateTime']['output']>;
  owner: OwnerBase;
  ownerId: Scalars['UUID']['output'];
  ownerIdType: Scalars['Int']['output'];
  owningBusinessUnit: Maybe<Scalars['UUID']['output']>;
  stepId: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  versionNumber: Maybe<Array<Scalars['UnsignedByte']['output']>>;
};

export type AnnotationFilterInput = {
  and?: InputMaybe<Array<AnnotationFilterInput>>;
  createdBy?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<UuidOperationFilterInput>;
  documentBody?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  fileSize?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  importSequenceNumber?: InputMaybe<IntOperationFilterInput>;
  isDocument?: InputMaybe<BooleanOperationFilterInput>;
  isPrivate?: InputMaybe<BooleanOperationFilterInput>;
  langId?: InputMaybe<StringOperationFilterInput>;
  mimeType?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<UuidOperationFilterInput>;
  noteText?: InputMaybe<StringOperationFilterInput>;
  objectId?: InputMaybe<UuidOperationFilterInput>;
  objectTypeCode?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<AnnotationFilterInput>>;
  overriddenCreatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  owner?: InputMaybe<OwnerBaseFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  ownerIdType?: InputMaybe<IntOperationFilterInput>;
  owningBusinessUnit?: InputMaybe<UuidOperationFilterInput>;
  stepId?: InputMaybe<StringOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  versionNumber?: InputMaybe<ListUnsignedByteOperationFilterInput>;
};

export type AnnotationSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SortEnumType>;
  documentBody?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  fileSize?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importSequenceNumber?: InputMaybe<SortEnumType>;
  isDocument?: InputMaybe<SortEnumType>;
  isPrivate?: InputMaybe<SortEnumType>;
  langId?: InputMaybe<SortEnumType>;
  mimeType?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SortEnumType>;
  noteText?: InputMaybe<SortEnumType>;
  objectId?: InputMaybe<SortEnumType>;
  objectTypeCode?: InputMaybe<SortEnumType>;
  overriddenCreatedOn?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<OwnerBaseSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  ownerIdType?: InputMaybe<SortEnumType>;
  owningBusinessUnit?: InputMaybe<SortEnumType>;
  stepId?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AnnotationsCollectionSegment = {
  __typename: 'AnnotationsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Annotation>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type App = {
  __typename: 'App';
  description: Scalars['String']['output'];
  environmentId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inactiveAt: Maybe<Scalars['DateTime']['output']>;
  isFavorite: Scalars['Boolean']['output'];
  isLegacy: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A segment of a collection. */
export type AppConfigCollectionSegment = {
  __typename: 'AppConfigCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<AppsConfig>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AFTER_RESOLVER = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BEFORE_RESOLVER = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  VALIDATION = 'VALIDATION'
}

export type AppsConfig = {
  __typename: 'AppsConfig';
  connectionStringKey: Maybe<Scalars['String']['output']>;
  connectionType: Maybe<Scalars['String']['output']>;
  contextName: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  countryName: Maybe<Scalars['String']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  environment: Maybe<Scalars['String']['output']>;
  environmentId: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  languageCode: Maybe<Scalars['String']['output']>;
  linkString: Maybe<Scalars['String']['output']>;
  xrm: Maybe<Scalars['String']['output']>;
};

export type AppsConfigFilterInput = {
  and?: InputMaybe<Array<AppsConfigFilterInput>>;
  connectionStringKey?: InputMaybe<StringOperationFilterInput>;
  connectionType?: InputMaybe<StringOperationFilterInput>;
  contextName?: InputMaybe<StringOperationFilterInput>;
  countryCode?: InputMaybe<StringOperationFilterInput>;
  countryName?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  environment?: InputMaybe<StringOperationFilterInput>;
  environmentId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  languageCode?: InputMaybe<StringOperationFilterInput>;
  linkString?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AppsConfigFilterInput>>;
  xrm?: InputMaybe<StringOperationFilterInput>;
};

export type AppsConfigSortInput = {
  connectionStringKey?: InputMaybe<SortEnumType>;
  connectionType?: InputMaybe<SortEnumType>;
  contextName?: InputMaybe<SortEnumType>;
  countryCode?: InputMaybe<SortEnumType>;
  countryName?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  environment?: InputMaybe<SortEnumType>;
  environmentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  languageCode?: InputMaybe<SortEnumType>;
  linkString?: InputMaybe<SortEnumType>;
  xrm?: InputMaybe<SortEnumType>;
};

export type Aspiration = {
  __typename: 'Aspiration';
  aspDate: Maybe<Scalars['DateTime']['output']>;
  aspTime: Maybe<Scalars['String']['output']>;
  aspirationPool: Maybe<AspirationPool>;
  aspirationPoolId: Maybe<Scalars['UUID']['output']>;
  aspstatus: Maybe<Scalars['Int']['output']>;
  assistant: Maybe<Equipment>;
  assistantId: Maybe<Scalars['UUID']['output']>;
  billDate: Maybe<Scalars['DateTime']['output']>;
  billDrugs: Maybe<Scalars['Boolean']['output']>;
  billStatus: Maybe<Scalars['Int']['output']>;
  bodyConditionScore: Maybe<Scalars['Int']['output']>;
  category: Maybe<Scalars['Int']['output']>;
  cdComment: Maybe<Scalars['String']['output']>;
  chuteNumber: Maybe<Scalars['Int']['output']>;
  cll: Maybe<Scalars['Int']['output']>;
  clr: Maybe<Scalars['Int']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  completeOrder: Maybe<Scalars['Int']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  cystl: Maybe<Scalars['String']['output']>;
  cystr: Maybe<Scalars['String']['output']>;
  dead: Maybe<Scalars['Int']['output']>;
  dishType: Maybe<Scalars['Int']['output']>;
  donor: Maybe<Donor>;
  donorCategory: Maybe<Scalars['Int']['output']>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorProcedure: Maybe<DonorProcedure>;
  donorProcedureId: Maybe<Scalars['UUID']['output']>;
  donorSchedules: Array<DonorSchedule>;
  embCompleteOrder: Maybe<Scalars['Int']['output']>;
  embryoPlan: Maybe<Scalars['Int']['output']>;
  fertPlan: Maybe<tog_fertplan>;
  fertilizations: Array<Fertilization>;
  flexFieldPartner: Maybe<Scalars['String']['output']>;
  flshid: Maybe<Scalars['Int']['output']>;
  fshNext: Maybe<Scalars['Int']['output']>;
  fshType: Maybe<Scalars['Int']['output']>;
  gpBatch: Maybe<Scalars['String']['output']>;
  gradeA: Maybe<Scalars['Int']['output']>;
  gradeB: Maybe<Scalars['Int']['output']>;
  gradeC: Maybe<Scalars['Int']['output']>;
  gradeD: Maybe<Scalars['Int']['output']>;
  gradeE: Maybe<Scalars['Int']['output']>;
  histId: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  ivmComment: Maybe<Scalars['String']['output']>;
  ivmCyto: Maybe<Scalars['Int']['output']>;
  ivmMat: Maybe<Scalars['Int']['output']>;
  ivmMature: Maybe<Scalars['Int']['output']>;
  ivmRec: Maybe<Scalars['Int']['output']>;
  ivmTechnician: Maybe<Equipment>;
  ivmTechnicianId: Maybe<Scalars['UUID']['output']>;
  ivmTime: Maybe<Scalars['String']['output']>;
  matStatus: Maybe<Scalars['Int']['output']>;
  mean: Maybe<Scalars['Decimal']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nextScheduleMaster: Maybe<ScheduleMaster>;
  nextScheduleMasterId: Maybe<Scalars['UUID']['output']>;
  nofollll: Maybe<Scalars['Int']['output']>;
  nofolllm: Maybe<Scalars['Int']['output']>;
  nofollls: Maybe<Scalars['Int']['output']>;
  nofollrl: Maybe<Scalars['Int']['output']>;
  nofollrm: Maybe<Scalars['Int']['output']>;
  nofollrs: Maybe<Scalars['Int']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  procId: Maybe<Scalars['String']['output']>;
  qcAirQuality: Maybe<Scalars['Int']['output']>;
  qcBrennerNeedleLotNo: Maybe<Scalars['String']['output']>;
  qcCellstrainer: Maybe<Scalars['String']['output']>;
  qcCollectionRoomTemp: Maybe<Scalars['String']['output']>;
  qcComment: Maybe<Scalars['String']['output']>;
  qcCommentChuteside: Maybe<Scalars['String']['output']>;
  qcFiftyMLLotNumber: Maybe<Scalars['String']['output']>;
  qcFiftyMLTubeType: Maybe<Scalars['String']['output']>;
  qcFlowRate: Maybe<Scalars['String']['output']>;
  qcFreezeTemp: Maybe<Scalars['String']['output']>;
  qcHepDate: Maybe<Scalars['DateTime']['output']>;
  qcIncubatorNumber: Maybe<Scalars['String']['output']>;
  qcMatDate: Maybe<Scalars['DateTime']['output']>;
  qcOpuFlush: Maybe<Scalars['String']['output']>;
  qcOpuFlushDate: Maybe<Scalars['DateTime']['output']>;
  qcOpuHolding: Maybe<Scalars['String']['output']>;
  qcOpuHoldingDate: Maybe<Scalars['DateTime']['output']>;
  qcOutsideTemp: Maybe<Scalars['String']['output']>;
  qcOutsideWeatherConditions: Maybe<Scalars['String']['output']>;
  qcPocketTubeWarmerTemp: Maybe<Scalars['String']['output']>;
  qcPumpPressure: Maybe<Scalars['String']['output']>;
  qcPumpTubeWarmerTemp: Maybe<Scalars['String']['output']>;
  qcRinseMediaLotDate: Maybe<Scalars['DateTime']['output']>;
  qcSlideWarmer: Maybe<Scalars['String']['output']>;
  qcTenMLSyringe: Maybe<Scalars['String']['output']>;
  qcThirtyMLSyringe: Maybe<Scalars['String']['output']>;
  qcTokaiHit: Maybe<Scalars['String']['output']>;
  qcWaterBathTemperature: Maybe<Scalars['String']['output']>;
  resultsEnteredAspiration: Maybe<Scalars['Boolean']['output']>;
  resultsEnteredMaturation: Maybe<Scalars['Boolean']['output']>;
  scheduleMaster: Maybe<ScheduleMaster>;
  scheduleMasterId: Maybe<Scalars['UUID']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  soSchedule: Maybe<SuperOvulationSchedule>;
  soScheduleId: Maybe<Scalars['UUID']['output']>;
  soSchedules: Array<SuperOvulationSchedule>;
  splitOver40: Maybe<Scalars['Int']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  technician: Maybe<Equipment>;
  technicianId: Maybe<Scalars['UUID']['output']>;
  togK1Banamine: Maybe<Scalars['Int']['output']>;
  totTrans: Maybe<Scalars['Int']['output']>;
  totalFroze: Maybe<Scalars['Int']['output']>;
  totalShip: Maybe<Scalars['Int']['output']>;
  totdisc: Maybe<Scalars['Int']['output']>;
  totfolll: Maybe<Scalars['Int']['output']>;
  totfollr: Maybe<Scalars['Int']['output']>;
  usdaSeal: Maybe<Scalars['String']['output']>;
};

export type AspirationDataEntryInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  aspirationDate: Scalars['DateTime']['input'];
  aspirationId: Scalars['String']['input'];
  banamine?: InputMaybe<Scalars['Int']['input']>;
  bodyConditionScore?: InputMaybe<Scalars['Int']['input']>;
  cdCommentMaster?: InputMaybe<Scalars['String']['input']>;
  cdComments?: InputMaybe<Scalars['String']['input']>;
  cdCommentsMaster?: InputMaybe<Array<SelectListItemInput>>;
  chuteNumber?: InputMaybe<Scalars['Int']['input']>;
  chuteTech?: InputMaybe<Scalars['String']['input']>;
  closeEdr?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  commentsJson?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['String']['input']>;
  didNotAspirate: Scalars['Boolean']['input'];
  donor?: InputMaybe<Scalars['String']['input']>;
  donorCategory?: InputMaybe<Scalars['Int']['input']>;
  donorCondition?: InputMaybe<Scalars['String']['input']>;
  donorConditionChanged?: InputMaybe<Scalars['Boolean']['input']>;
  donorId: Scalars['String']['input'];
  environment?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['Int']['input']>;
  export?: InputMaybe<Scalars['String']['input']>;
  fertData?: InputMaybe<Array<FertilizationDataInput>>;
  fertPlan?: InputMaybe<Scalars['String']['input']>;
  fromEdr?: InputMaybe<Scalars['Boolean']['input']>;
  indexChuteTech?: InputMaybe<Scalars['String']['input']>;
  indexOpuTech?: InputMaybe<Scalars['String']['input']>;
  itDept?: InputMaybe<Scalars['String']['input']>;
  k1?: InputMaybe<Scalars['Int']['input']>;
  k1Banamine?: InputMaybe<Scalars['Int']['input']>;
  lastBredInterval?: InputMaybe<Scalars['String']['input']>;
  leftCls: Scalars['Int']['input'];
  leftCysts: Scalars['Int']['input'];
  leftLarge: Scalars['Int']['input'];
  leftMedium: Scalars['Int']['input'];
  leftSmall: Scalars['Int']['input'];
  leftTotal: Scalars['Int']['input'];
  linkString?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['String']['input']>;
  nextScheduleId: Scalars['String']['input'];
  nextScheduleIds?: InputMaybe<Array<SelectListItemInput>>;
  opuTech?: InputMaybe<Scalars['String']['input']>;
  opuTime: Scalars['String']['input'];
  pregValue?: InputMaybe<Scalars['String']['input']>;
  pregnant?: InputMaybe<Scalars['Boolean']['input']>;
  pwpUserId?: InputMaybe<Scalars['Int']['input']>;
  rightCls: Scalars['Int']['input'];
  rightCysts: Scalars['Int']['input'];
  rightLarge: Scalars['Int']['input'];
  rightMedium: Scalars['Int']['input'];
  rightSmall: Scalars['Int']['input'];
  rightTotal: Scalars['Int']['input'];
  schedule?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
  stats?: InputMaybe<TeamStatsInput>;
  techId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  vetId: Scalars['String']['input'];
  weight: Scalars['String']['input'];
  weightIn?: InputMaybe<Scalars['String']['input']>;
};

export type AspirationFilterInput = {
  and?: InputMaybe<Array<AspirationFilterInput>>;
  aspDate?: InputMaybe<DateTimeOperationFilterInput>;
  aspTime?: InputMaybe<StringOperationFilterInput>;
  aspirationPool?: InputMaybe<AspirationPoolFilterInput>;
  aspirationPoolId?: InputMaybe<UuidOperationFilterInput>;
  aspstatus?: InputMaybe<IntOperationFilterInput>;
  assistant?: InputMaybe<EquipmentFilterInput>;
  assistantId?: InputMaybe<UuidOperationFilterInput>;
  billDate?: InputMaybe<DateTimeOperationFilterInput>;
  billDrugs?: InputMaybe<BooleanOperationFilterInput>;
  billStatus?: InputMaybe<IntOperationFilterInput>;
  bodyConditionScore?: InputMaybe<IntOperationFilterInput>;
  category?: InputMaybe<IntOperationFilterInput>;
  cdComment?: InputMaybe<StringOperationFilterInput>;
  chuteNumber?: InputMaybe<IntOperationFilterInput>;
  cll?: InputMaybe<IntOperationFilterInput>;
  clr?: InputMaybe<IntOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  completeOrder?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  cystl?: InputMaybe<StringOperationFilterInput>;
  cystr?: InputMaybe<StringOperationFilterInput>;
  dead?: InputMaybe<IntOperationFilterInput>;
  dishType?: InputMaybe<IntOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorCategory?: InputMaybe<IntOperationFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  donorProcedure?: InputMaybe<DonorProcedureFilterInput>;
  donorProcedureId?: InputMaybe<UuidOperationFilterInput>;
  donorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  embCompleteOrder?: InputMaybe<IntOperationFilterInput>;
  embryoPlan?: InputMaybe<IntOperationFilterInput>;
  fertPlan?: InputMaybe<NullableOftog_fertplanOperationFilterInput>;
  fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  flexFieldPartner?: InputMaybe<StringOperationFilterInput>;
  flshid?: InputMaybe<IntOperationFilterInput>;
  fshNext?: InputMaybe<IntOperationFilterInput>;
  fshType?: InputMaybe<IntOperationFilterInput>;
  gpBatch?: InputMaybe<StringOperationFilterInput>;
  gradeA?: InputMaybe<IntOperationFilterInput>;
  gradeB?: InputMaybe<IntOperationFilterInput>;
  gradeC?: InputMaybe<IntOperationFilterInput>;
  gradeD?: InputMaybe<IntOperationFilterInput>;
  gradeE?: InputMaybe<IntOperationFilterInput>;
  histId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  ivmComment?: InputMaybe<StringOperationFilterInput>;
  ivmCyto?: InputMaybe<IntOperationFilterInput>;
  ivmMat?: InputMaybe<IntOperationFilterInput>;
  ivmMature?: InputMaybe<IntOperationFilterInput>;
  ivmRec?: InputMaybe<IntOperationFilterInput>;
  ivmTechnician?: InputMaybe<EquipmentFilterInput>;
  ivmTechnicianId?: InputMaybe<UuidOperationFilterInput>;
  ivmTime?: InputMaybe<StringOperationFilterInput>;
  matStatus?: InputMaybe<IntOperationFilterInput>;
  mean?: InputMaybe<DecimalOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nextScheduleMaster?: InputMaybe<ScheduleMasterFilterInput>;
  nextScheduleMasterId?: InputMaybe<UuidOperationFilterInput>;
  nofollll?: InputMaybe<IntOperationFilterInput>;
  nofolllm?: InputMaybe<IntOperationFilterInput>;
  nofollls?: InputMaybe<IntOperationFilterInput>;
  nofollrl?: InputMaybe<IntOperationFilterInput>;
  nofollrm?: InputMaybe<IntOperationFilterInput>;
  nofollrs?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<AspirationFilterInput>>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  procId?: InputMaybe<StringOperationFilterInput>;
  qcAirQuality?: InputMaybe<IntOperationFilterInput>;
  qcBrennerNeedleLotNo?: InputMaybe<StringOperationFilterInput>;
  qcCellstrainer?: InputMaybe<StringOperationFilterInput>;
  qcCollectionRoomTemp?: InputMaybe<StringOperationFilterInput>;
  qcComment?: InputMaybe<StringOperationFilterInput>;
  qcCommentChuteside?: InputMaybe<StringOperationFilterInput>;
  qcFiftyMLLotNumber?: InputMaybe<StringOperationFilterInput>;
  qcFiftyMLTubeType?: InputMaybe<StringOperationFilterInput>;
  qcFlowRate?: InputMaybe<StringOperationFilterInput>;
  qcFreezeTemp?: InputMaybe<StringOperationFilterInput>;
  qcHepDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcIncubatorNumber?: InputMaybe<StringOperationFilterInput>;
  qcMatDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcOpuFlush?: InputMaybe<StringOperationFilterInput>;
  qcOpuFlushDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcOpuHolding?: InputMaybe<StringOperationFilterInput>;
  qcOpuHoldingDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcOutsideTemp?: InputMaybe<StringOperationFilterInput>;
  qcOutsideWeatherConditions?: InputMaybe<StringOperationFilterInput>;
  qcPocketTubeWarmerTemp?: InputMaybe<StringOperationFilterInput>;
  qcPumpPressure?: InputMaybe<StringOperationFilterInput>;
  qcPumpTubeWarmerTemp?: InputMaybe<StringOperationFilterInput>;
  qcRinseMediaLotDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcSlideWarmer?: InputMaybe<StringOperationFilterInput>;
  qcTenMLSyringe?: InputMaybe<StringOperationFilterInput>;
  qcThirtyMLSyringe?: InputMaybe<StringOperationFilterInput>;
  qcTokaiHit?: InputMaybe<StringOperationFilterInput>;
  qcWaterBathTemperature?: InputMaybe<StringOperationFilterInput>;
  resultsEnteredAspiration?: InputMaybe<BooleanOperationFilterInput>;
  resultsEnteredMaturation?: InputMaybe<BooleanOperationFilterInput>;
  scheduleMaster?: InputMaybe<ScheduleMasterFilterInput>;
  scheduleMasterId?: InputMaybe<UuidOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  soSchedule?: InputMaybe<SuperOvulationScheduleFilterInput>;
  soScheduleId?: InputMaybe<UuidOperationFilterInput>;
  soSchedules?: InputMaybe<ListFilterInputTypeOfSuperOvulationScheduleFilterInput>;
  splitOver40?: InputMaybe<IntOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  technician?: InputMaybe<EquipmentFilterInput>;
  technicianId?: InputMaybe<UuidOperationFilterInput>;
  togK1Banamine?: InputMaybe<IntOperationFilterInput>;
  totTrans?: InputMaybe<IntOperationFilterInput>;
  totalFroze?: InputMaybe<IntOperationFilterInput>;
  totalShip?: InputMaybe<IntOperationFilterInput>;
  totdisc?: InputMaybe<IntOperationFilterInput>;
  totfolll?: InputMaybe<IntOperationFilterInput>;
  totfollr?: InputMaybe<IntOperationFilterInput>;
  usdaSeal?: InputMaybe<StringOperationFilterInput>;
};

export type AspirationHistoryData = {
  __typename: 'AspirationHistoryData';
  aspirationDate: Scalars['String']['output'];
  comments: Scalars['String']['output'];
};

export type AspirationInput = {
  aspDate?: InputMaybe<Scalars['DateTime']['input']>;
  aspTime?: InputMaybe<Scalars['String']['input']>;
  aspirationPool?: InputMaybe<AspirationPoolInput>;
  aspirationPoolId?: InputMaybe<Scalars['UUID']['input']>;
  aspstatus?: InputMaybe<Scalars['Int']['input']>;
  assistant?: InputMaybe<EquipmentInput>;
  assistantId?: InputMaybe<Scalars['UUID']['input']>;
  billDate?: InputMaybe<Scalars['DateTime']['input']>;
  billDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  billStatus?: InputMaybe<Scalars['Int']['input']>;
  bodyConditionScore?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['Int']['input']>;
  cdComment?: InputMaybe<Scalars['String']['input']>;
  chuteNumber?: InputMaybe<Scalars['Int']['input']>;
  cll?: InputMaybe<Scalars['Int']['input']>;
  clr?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  completeOrder?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  cystl?: InputMaybe<Scalars['String']['input']>;
  cystr?: InputMaybe<Scalars['String']['input']>;
  dead?: InputMaybe<Scalars['Int']['input']>;
  dishType?: InputMaybe<Scalars['Int']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorCategory?: InputMaybe<Scalars['Int']['input']>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorProcedure?: InputMaybe<DonorProcedureInput>;
  donorProcedureId?: InputMaybe<Scalars['UUID']['input']>;
  donorSchedules: Array<DonorScheduleInput>;
  embCompleteOrder?: InputMaybe<Scalars['Int']['input']>;
  embryoPlan?: InputMaybe<Scalars['Int']['input']>;
  fertPlan?: InputMaybe<tog_fertplan>;
  fertilizations: Array<FertilizationInput>;
  flexFieldPartner?: InputMaybe<Scalars['String']['input']>;
  flshid?: InputMaybe<Scalars['Int']['input']>;
  fshNext?: InputMaybe<Scalars['Int']['input']>;
  fshType?: InputMaybe<Scalars['Int']['input']>;
  gpBatch?: InputMaybe<Scalars['String']['input']>;
  gradeA?: InputMaybe<Scalars['Int']['input']>;
  gradeB?: InputMaybe<Scalars['Int']['input']>;
  gradeC?: InputMaybe<Scalars['Int']['input']>;
  gradeD?: InputMaybe<Scalars['Int']['input']>;
  gradeE?: InputMaybe<Scalars['Int']['input']>;
  histId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  ivmComment?: InputMaybe<Scalars['String']['input']>;
  ivmCyto?: InputMaybe<Scalars['Int']['input']>;
  ivmMat?: InputMaybe<Scalars['Int']['input']>;
  ivmMature?: InputMaybe<Scalars['Int']['input']>;
  ivmRec?: InputMaybe<Scalars['Int']['input']>;
  ivmTechnician?: InputMaybe<EquipmentInput>;
  ivmTechnicianId?: InputMaybe<Scalars['UUID']['input']>;
  ivmTime?: InputMaybe<Scalars['String']['input']>;
  matStatus?: InputMaybe<Scalars['Int']['input']>;
  mean?: InputMaybe<Scalars['Decimal']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextScheduleMaster?: InputMaybe<ScheduleMasterInput>;
  nextScheduleMasterId?: InputMaybe<Scalars['UUID']['input']>;
  nofollll?: InputMaybe<Scalars['Int']['input']>;
  nofolllm?: InputMaybe<Scalars['Int']['input']>;
  nofollls?: InputMaybe<Scalars['Int']['input']>;
  nofollrl?: InputMaybe<Scalars['Int']['input']>;
  nofollrm?: InputMaybe<Scalars['Int']['input']>;
  nofollrs?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  procId?: InputMaybe<Scalars['String']['input']>;
  qcAirQuality?: InputMaybe<Scalars['Int']['input']>;
  qcBrennerNeedleLotNo?: InputMaybe<Scalars['String']['input']>;
  qcCellstrainer?: InputMaybe<Scalars['String']['input']>;
  qcCollectionRoomTemp?: InputMaybe<Scalars['String']['input']>;
  qcComment?: InputMaybe<Scalars['String']['input']>;
  qcCommentChuteside?: InputMaybe<Scalars['String']['input']>;
  qcFiftyMLLotNumber?: InputMaybe<Scalars['String']['input']>;
  qcFiftyMLTubeType?: InputMaybe<Scalars['String']['input']>;
  qcFlowRate?: InputMaybe<Scalars['String']['input']>;
  qcFreezeTemp?: InputMaybe<Scalars['String']['input']>;
  qcHepDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcIncubatorNumber?: InputMaybe<Scalars['String']['input']>;
  qcMatDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcOpuFlush?: InputMaybe<Scalars['String']['input']>;
  qcOpuFlushDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcOpuHolding?: InputMaybe<Scalars['String']['input']>;
  qcOpuHoldingDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcOutsideTemp?: InputMaybe<Scalars['String']['input']>;
  qcOutsideWeatherConditions?: InputMaybe<Scalars['String']['input']>;
  qcPocketTubeWarmerTemp?: InputMaybe<Scalars['String']['input']>;
  qcPumpPressure?: InputMaybe<Scalars['String']['input']>;
  qcPumpTubeWarmerTemp?: InputMaybe<Scalars['String']['input']>;
  qcRinseMediaLotDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcSlideWarmer?: InputMaybe<Scalars['String']['input']>;
  qcTenMLSyringe?: InputMaybe<Scalars['String']['input']>;
  qcThirtyMLSyringe?: InputMaybe<Scalars['String']['input']>;
  qcTokaiHit?: InputMaybe<Scalars['String']['input']>;
  qcWaterBathTemperature?: InputMaybe<Scalars['String']['input']>;
  resultsEnteredAspiration?: InputMaybe<Scalars['Boolean']['input']>;
  resultsEnteredMaturation?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleMaster?: InputMaybe<ScheduleMasterInput>;
  scheduleMasterId?: InputMaybe<Scalars['UUID']['input']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  soSchedule?: InputMaybe<SuperOvulationScheduleInput>;
  soScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  soSchedules: Array<SuperOvulationScheduleInput>;
  splitOver40?: InputMaybe<Scalars['Int']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  technician?: InputMaybe<EquipmentInput>;
  technicianId?: InputMaybe<Scalars['UUID']['input']>;
  togK1Banamine?: InputMaybe<Scalars['Int']['input']>;
  totTrans?: InputMaybe<Scalars['Int']['input']>;
  totalFroze?: InputMaybe<Scalars['Int']['input']>;
  totalShip?: InputMaybe<Scalars['Int']['input']>;
  totdisc?: InputMaybe<Scalars['Int']['input']>;
  totfolll?: InputMaybe<Scalars['Int']['input']>;
  totfollr?: InputMaybe<Scalars['Int']['input']>;
  usdaSeal?: InputMaybe<Scalars['String']['input']>;
};

export type AspirationPayload = {
  __typename: 'AspirationPayload';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AspirationPool = {
  __typename: 'AspirationPool';
  aspirations: Array<Aspiration>;
  breed: Maybe<Breed>;
  breedId: Maybe<Scalars['UUID']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  donorsInPool: Maybe<Scalars['String']['output']>;
  fertilizations: Array<Fertilization>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  numberInPool: Maybe<Scalars['Int']['output']>;
  opuSite: Maybe<Site>;
  opuSiteId: Maybe<Scalars['UUID']['output']>;
  poolNumber: Maybe<Scalars['Int']['output']>;
  pooledBy: Maybe<Scalars['Int']['output']>;
  probableDonor: Maybe<Donor>;
  probableDonorId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  timeZoneRuleVersionNumber: Maybe<Scalars['Int']['output']>;
  togIdsInPool: Maybe<Scalars['String']['output']>;
  utcConversionTimeZoneCode: Maybe<Scalars['Int']['output']>;
};

export type AspirationPoolFilterInput = {
  and?: InputMaybe<Array<AspirationPoolFilterInput>>;
  aspirations?: InputMaybe<ListFilterInputTypeOfAspirationFilterInput>;
  breed?: InputMaybe<BreedFilterInput>;
  breedId?: InputMaybe<UuidOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  donorsInPool?: InputMaybe<StringOperationFilterInput>;
  fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberInPool?: InputMaybe<IntOperationFilterInput>;
  opuSite?: InputMaybe<SiteFilterInput>;
  opuSiteId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<AspirationPoolFilterInput>>;
  poolNumber?: InputMaybe<IntOperationFilterInput>;
  pooledBy?: InputMaybe<IntOperationFilterInput>;
  probableDonor?: InputMaybe<DonorFilterInput>;
  probableDonorId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  timeZoneRuleVersionNumber?: InputMaybe<IntOperationFilterInput>;
  togIdsInPool?: InputMaybe<StringOperationFilterInput>;
  utcConversionTimeZoneCode?: InputMaybe<IntOperationFilterInput>;
};

export type AspirationPoolInput = {
  aspirations: Array<AspirationInput>;
  breed?: InputMaybe<BreedInput>;
  breedId?: InputMaybe<Scalars['UUID']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donorsInPool?: InputMaybe<Scalars['String']['input']>;
  fertilizations: Array<FertilizationInput>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberInPool?: InputMaybe<Scalars['Int']['input']>;
  opuSite?: InputMaybe<SiteInput>;
  opuSiteId?: InputMaybe<Scalars['UUID']['input']>;
  poolNumber?: InputMaybe<Scalars['Int']['input']>;
  pooledBy?: InputMaybe<Scalars['Int']['input']>;
  probableDonor?: InputMaybe<DonorInput>;
  probableDonorId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  timeZoneRuleVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  togIdsInPool?: InputMaybe<Scalars['String']['input']>;
  utcConversionTimeZoneCode?: InputMaybe<Scalars['Int']['input']>;
};

export type AspirationPoolSortInput = {
  breed?: InputMaybe<BreedSortInput>;
  breedId?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  donorsInPool?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  numberInPool?: InputMaybe<SortEnumType>;
  opuSite?: InputMaybe<SiteSortInput>;
  opuSiteId?: InputMaybe<SortEnumType>;
  poolNumber?: InputMaybe<SortEnumType>;
  pooledBy?: InputMaybe<SortEnumType>;
  probableDonor?: InputMaybe<DonorSortInput>;
  probableDonorId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  timeZoneRuleVersionNumber?: InputMaybe<SortEnumType>;
  togIdsInPool?: InputMaybe<SortEnumType>;
  utcConversionTimeZoneCode?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AspirationPoolsCollectionSegment = {
  __typename: 'AspirationPoolsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<AspirationPool>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AspirationResultRow = {
  __typename: 'AspirationResultRow';
  account: Maybe<Scalars['String']['output']>;
  aspirationComment: Maybe<Scalars['String']['output']>;
  aspirationId: Scalars['UUID']['output'];
  birthDate: Maybe<Scalars['DateTime']['output']>;
  breed: Maybe<Scalars['String']['output']>;
  collectionCode: Maybe<Scalars['String']['output']>;
  csr: Maybe<Scalars['String']['output']>;
  dead: Maybe<Scalars['Int']['output']>;
  donorLocation: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  donorScheduleId: Maybe<Scalars['UUID']['output']>;
  dsAspirationComment: Maybe<Scalars['String']['output']>;
  embryoPlan: Maybe<Scalars['String']['output']>;
  export: Maybe<Scalars['String']['output']>;
  fertSite: Maybe<Scalars['String']['output']>;
  freeze: Maybe<Scalars['String']['output']>;
  freezeInstructions: Maybe<Scalars['String']['output']>;
  gradeAbc: Maybe<Scalars['Int']['output']>;
  gradeD: Maybe<Scalars['Int']['output']>;
  gradeE: Maybe<Scalars['Int']['output']>;
  inMat: Scalars['Long']['output'];
  ivmTechnician: Maybe<Scalars['String']['output']>;
  matTime: Maybe<Scalars['String']['output']>;
  maturationComment: Maybe<Scalars['String']['output']>;
  medTotal: Maybe<Scalars['String']['output']>;
  opuTechnician: Maybe<Scalars['String']['output']>;
  poolNum: Maybe<Scalars['Int']['output']>;
  pooled: Maybe<Scalars['String']['output']>;
  procedureDate: Maybe<Scalars['DateTime']['output']>;
  programName: Maybe<Scalars['String']['output']>;
  ranchId: Maybe<Scalars['String']['output']>;
  revisionComment: Maybe<Scalars['String']['output']>;
  revisionNumber: Maybe<Scalars['String']['output']>;
  schedCode: Maybe<Scalars['String']['output']>;
  semenType: Maybe<Scalars['String']['output']>;
  ship: Maybe<Scalars['String']['output']>;
  shipmentGroupName: Maybe<Scalars['String']['output']>;
  sire: Maybe<Scalars['String']['output']>;
  sireBrd: Maybe<Scalars['String']['output']>;
  storageLocation: Maybe<Scalars['String']['output']>;
  totalOocytes: Scalars['Long']['output'];
  transfer: Maybe<Scalars['String']['output']>;
  transferEmbryoComment: Maybe<Scalars['String']['output']>;
};

export type AspirationSite = {
  __typename: 'AspirationSite';
  fertilizationSite: Maybe<Site>;
  fertilizationSiteId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type AspirationSiteFilterInput = {
  and?: InputMaybe<Array<AspirationSiteFilterInput>>;
  fertilizationSite?: InputMaybe<SiteFilterInput>;
  fertilizationSiteId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AspirationSiteFilterInput>>;
};

export type AspirationSiteSortInput = {
  fertilizationSite?: InputMaybe<SiteSortInput>;
  fertilizationSiteId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AspirationSortInput = {
  aspDate?: InputMaybe<SortEnumType>;
  aspTime?: InputMaybe<SortEnumType>;
  aspirationPool?: InputMaybe<AspirationPoolSortInput>;
  aspirationPoolId?: InputMaybe<SortEnumType>;
  aspstatus?: InputMaybe<SortEnumType>;
  assistant?: InputMaybe<EquipmentSortInput>;
  assistantId?: InputMaybe<SortEnumType>;
  billDate?: InputMaybe<SortEnumType>;
  billDrugs?: InputMaybe<SortEnumType>;
  billStatus?: InputMaybe<SortEnumType>;
  bodyConditionScore?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  cdComment?: InputMaybe<SortEnumType>;
  chuteNumber?: InputMaybe<SortEnumType>;
  cll?: InputMaybe<SortEnumType>;
  clr?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  completeOrder?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  cystl?: InputMaybe<SortEnumType>;
  cystr?: InputMaybe<SortEnumType>;
  dead?: InputMaybe<SortEnumType>;
  dishType?: InputMaybe<SortEnumType>;
  donor?: InputMaybe<DonorSortInput>;
  donorCategory?: InputMaybe<SortEnumType>;
  donorId?: InputMaybe<SortEnumType>;
  donorProcedure?: InputMaybe<DonorProcedureSortInput>;
  donorProcedureId?: InputMaybe<SortEnumType>;
  embCompleteOrder?: InputMaybe<SortEnumType>;
  embryoPlan?: InputMaybe<SortEnumType>;
  fertPlan?: InputMaybe<SortEnumType>;
  flexFieldPartner?: InputMaybe<SortEnumType>;
  flshid?: InputMaybe<SortEnumType>;
  fshNext?: InputMaybe<SortEnumType>;
  fshType?: InputMaybe<SortEnumType>;
  gpBatch?: InputMaybe<SortEnumType>;
  gradeA?: InputMaybe<SortEnumType>;
  gradeB?: InputMaybe<SortEnumType>;
  gradeC?: InputMaybe<SortEnumType>;
  gradeD?: InputMaybe<SortEnumType>;
  gradeE?: InputMaybe<SortEnumType>;
  histId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ivmComment?: InputMaybe<SortEnumType>;
  ivmCyto?: InputMaybe<SortEnumType>;
  ivmMat?: InputMaybe<SortEnumType>;
  ivmMature?: InputMaybe<SortEnumType>;
  ivmRec?: InputMaybe<SortEnumType>;
  ivmTechnician?: InputMaybe<EquipmentSortInput>;
  ivmTechnicianId?: InputMaybe<SortEnumType>;
  ivmTime?: InputMaybe<SortEnumType>;
  matStatus?: InputMaybe<SortEnumType>;
  mean?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  nextScheduleMaster?: InputMaybe<ScheduleMasterSortInput>;
  nextScheduleMasterId?: InputMaybe<SortEnumType>;
  nofollll?: InputMaybe<SortEnumType>;
  nofolllm?: InputMaybe<SortEnumType>;
  nofollls?: InputMaybe<SortEnumType>;
  nofollrl?: InputMaybe<SortEnumType>;
  nofollrm?: InputMaybe<SortEnumType>;
  nofollrs?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  procId?: InputMaybe<SortEnumType>;
  qcAirQuality?: InputMaybe<SortEnumType>;
  qcBrennerNeedleLotNo?: InputMaybe<SortEnumType>;
  qcCellstrainer?: InputMaybe<SortEnumType>;
  qcCollectionRoomTemp?: InputMaybe<SortEnumType>;
  qcComment?: InputMaybe<SortEnumType>;
  qcCommentChuteside?: InputMaybe<SortEnumType>;
  qcFiftyMLLotNumber?: InputMaybe<SortEnumType>;
  qcFiftyMLTubeType?: InputMaybe<SortEnumType>;
  qcFlowRate?: InputMaybe<SortEnumType>;
  qcFreezeTemp?: InputMaybe<SortEnumType>;
  qcHepDate?: InputMaybe<SortEnumType>;
  qcIncubatorNumber?: InputMaybe<SortEnumType>;
  qcMatDate?: InputMaybe<SortEnumType>;
  qcOpuFlush?: InputMaybe<SortEnumType>;
  qcOpuFlushDate?: InputMaybe<SortEnumType>;
  qcOpuHolding?: InputMaybe<SortEnumType>;
  qcOpuHoldingDate?: InputMaybe<SortEnumType>;
  qcOutsideTemp?: InputMaybe<SortEnumType>;
  qcOutsideWeatherConditions?: InputMaybe<SortEnumType>;
  qcPocketTubeWarmerTemp?: InputMaybe<SortEnumType>;
  qcPumpPressure?: InputMaybe<SortEnumType>;
  qcPumpTubeWarmerTemp?: InputMaybe<SortEnumType>;
  qcRinseMediaLotDate?: InputMaybe<SortEnumType>;
  qcSlideWarmer?: InputMaybe<SortEnumType>;
  qcTenMLSyringe?: InputMaybe<SortEnumType>;
  qcThirtyMLSyringe?: InputMaybe<SortEnumType>;
  qcTokaiHit?: InputMaybe<SortEnumType>;
  qcWaterBathTemperature?: InputMaybe<SortEnumType>;
  resultsEnteredAspiration?: InputMaybe<SortEnumType>;
  resultsEnteredMaturation?: InputMaybe<SortEnumType>;
  scheduleMaster?: InputMaybe<ScheduleMasterSortInput>;
  scheduleMasterId?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  soSchedule?: InputMaybe<SuperOvulationScheduleSortInput>;
  soScheduleId?: InputMaybe<SortEnumType>;
  splitOver40?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  technician?: InputMaybe<EquipmentSortInput>;
  technicianId?: InputMaybe<SortEnumType>;
  togK1Banamine?: InputMaybe<SortEnumType>;
  totTrans?: InputMaybe<SortEnumType>;
  totalFroze?: InputMaybe<SortEnumType>;
  totalShip?: InputMaybe<SortEnumType>;
  totdisc?: InputMaybe<SortEnumType>;
  totfolll?: InputMaybe<SortEnumType>;
  totfollr?: InputMaybe<SortEnumType>;
  usdaSeal?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AspirationsCollectionSegment = {
  __typename: 'AspirationsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Aspiration>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AspirationsPayload = {
  __typename: 'AspirationsPayload';
  aspirations: Array<Aspiration>;
};

export type AspirationsToday = {
  __typename: 'AspirationsToday';
  account: Maybe<Scalars['String']['output']>;
  accountName: Maybe<Scalars['String']['output']>;
  aspComments: Maybe<Scalars['String']['output']>;
  aspirationDate: Maybe<Scalars['DateTime']['output']>;
  aspirationId: Maybe<Scalars['String']['output']>;
  aspirationTime: Maybe<Scalars['String']['output']>;
  asstId: Maybe<Scalars['String']['output']>;
  breed: Maybe<Scalars['String']['output']>;
  chuteNumber: Maybe<Scalars['Int']['output']>;
  chuteTech: Maybe<Scalars['String']['output']>;
  cll: Maybe<Scalars['Int']['output']>;
  clr: Maybe<Scalars['Int']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  completeOrder: Maybe<Scalars['Int']['output']>;
  csa: Maybe<Scalars['String']['output']>;
  csr: Maybe<Scalars['String']['output']>;
  cystl: Maybe<Scalars['Int']['output']>;
  cystr: Maybe<Scalars['Int']['output']>;
  donor: Maybe<Scalars['String']['output']>;
  donorCondition: Maybe<Scalars['String']['output']>;
  donorId: Maybe<Scalars['String']['output']>;
  donorLocation: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  donorRegNum: Maybe<Scalars['String']['output']>;
  dsAspirationComment: Maybe<Scalars['String']['output']>;
  embCompleteOrder: Maybe<Scalars['Int']['output']>;
  export: Maybe<Scalars['String']['output']>;
  fertPlan: Maybe<Scalars['Int']['output']>;
  fertSite: Maybe<Scalars['String']['output']>;
  ivmId: Maybe<Scalars['String']['output']>;
  ivmMat: Maybe<Scalars['Int']['output']>;
  ivmTech: Maybe<Scalars['String']['output']>;
  ivmTime: Maybe<Scalars['String']['output']>;
  ll: Maybe<Scalars['Int']['output']>;
  lm: Maybe<Scalars['Int']['output']>;
  location: Maybe<Scalars['String']['output']>;
  ls: Maybe<Scalars['Int']['output']>;
  matTime: Maybe<Scalars['String']['output']>;
  medTotal: Maybe<Scalars['String']['output']>;
  nextSchedule: Maybe<Scalars['String']['output']>;
  nextScheduleId: Maybe<Scalars['String']['output']>;
  nonEuComment: Maybe<Scalars['String']['output']>;
  numInMat: Maybe<Scalars['String']['output']>;
  opuNum: Maybe<Scalars['String']['output']>;
  opuTech: Maybe<Scalars['String']['output']>;
  poolNum: Maybe<Scalars['String']['output']>;
  pooled: Maybe<Scalars['String']['output']>;
  pregnant: Maybe<Scalars['String']['output']>;
  programName: Maybe<Scalars['String']['output']>;
  rl: Maybe<Scalars['Int']['output']>;
  rm: Maybe<Scalars['Int']['output']>;
  rs: Maybe<Scalars['Int']['output']>;
  scheduleId: Maybe<Scalars['String']['output']>;
  semenType: Maybe<Scalars['String']['output']>;
  sire: Maybe<Scalars['String']['output']>;
  siteId: Maybe<Scalars['String']['output']>;
  totalFollicles: Maybe<Scalars['String']['output']>;
  totalLeft: Maybe<Scalars['Int']['output']>;
  totalOocytes: Maybe<Scalars['String']['output']>;
  totalRight: Maybe<Scalars['Int']['output']>;
  vetId: Maybe<Scalars['String']['output']>;
  weight: Maybe<Scalars['String']['output']>;
};

export type AuditLog = {
  __typename: 'AuditLog';
  columns: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  metadata: Maybe<Scalars['String']['output']>;
  newValues: Maybe<Scalars['String']['output']>;
  objectId: Scalars['UUID']['output'];
  objectType: Scalars['String']['output'];
  operationTimestamp: Scalars['DateTime']['output'];
  operationType: Scalars['String']['output'];
  originalValues: Maybe<Scalars['String']['output']>;
  transactionId: Maybe<Scalars['UUID']['output']>;
  userEmail: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['UUID']['output']>;
};

export type AuditLogChange = {
  __typename: 'AuditLogChange';
  columnName: Scalars['String']['output'];
  dataType: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  newValue: Maybe<AuditLogItemValue>;
  originalValue: Maybe<AuditLogItemValue>;
};

export type AuditLogCollection = {
  __typename: 'AuditLogCollection';
  entityDisplayName: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<AuditLogItem>;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AuditLogCollectionSegment = {
  __typename: 'AuditLogCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<AuditLog>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditLogColumnMetadata = {
  __typename: 'AuditLogColumnMetadata';
  columnName: Scalars['String']['output'];
  dataType: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  relation: Maybe<AuditLogRelationMetadata>;
};

export type AuditLogFilterInput = {
  and?: InputMaybe<Array<AuditLogFilterInput>>;
  columns?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  metadata?: InputMaybe<StringOperationFilterInput>;
  newValues?: InputMaybe<StringOperationFilterInput>;
  objectId?: InputMaybe<UuidOperationFilterInput>;
  objectType?: InputMaybe<StringOperationFilterInput>;
  operationTimestamp?: InputMaybe<DateTimeOperationFilterInput>;
  operationType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AuditLogFilterInput>>;
  originalValues?: InputMaybe<StringOperationFilterInput>;
  transactionId?: InputMaybe<UuidOperationFilterInput>;
  userEmail?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type AuditLogItem = {
  __typename: 'AuditLogItem';
  changes: Array<AuditLogChange>;
  id: Scalars['UUID']['output'];
  metadata: Maybe<Scalars['String']['output']>;
  operationTimestamp: Scalars['DateTime']['output'];
  operationType: Scalars['String']['output'];
  userEmail: Maybe<Scalars['String']['output']>;
};

export type AuditLogItemValue = {
  __typename: 'AuditLogItemValue';
  id: Maybe<Scalars['UUID']['output']>;
  value: Scalars['String']['output'];
};

export type AuditLogRelationMetadata = {
  __typename: 'AuditLogRelationMetadata';
  columnName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  primaryNameColumnName: Scalars['String']['output'];
  tableName: Scalars['String']['output'];
};

export type AuditLogSortInput = {
  columns?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  metadata?: InputMaybe<SortEnumType>;
  newValues?: InputMaybe<SortEnumType>;
  objectId?: InputMaybe<SortEnumType>;
  objectType?: InputMaybe<SortEnumType>;
  operationTimestamp?: InputMaybe<SortEnumType>;
  operationType?: InputMaybe<SortEnumType>;
  originalValues?: InputMaybe<SortEnumType>;
  transactionId?: InputMaybe<SortEnumType>;
  userEmail?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type AuditLogTableMetadata = {
  __typename: 'AuditLogTableMetadata';
  collectionName: Scalars['String']['output'];
  columns: Array<AuditLogColumnMetadata>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Avgs = {
  __typename: 'Avgs';
  blank: Scalars['String']['output'];
  blank1: Scalars['String']['output'];
  follicles: Scalars['String']['output'];
  numInMat: Scalars['String']['output'];
  oocytes: Scalars['String']['output'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Breed = {
  __typename: 'Breed';
  accountBreeds: Array<AccountBreed>;
  aspirationPools: Array<AspirationPool>;
  breedEmbryos: Array<Embryo>;
  category: Maybe<tog_category>;
  code: Maybe<Scalars['String']['output']>;
  /** Comma-separated RGB values */
  color: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  donors: Array<Donor>;
  frameSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  recipBreedEmbryos: Array<Embryo>;
  recipients: Array<Recipient>;
  sires: Array<Sire>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  subFamily: Maybe<tog_subfamily>;
  type: Maybe<Scalars['Int']['output']>;
};

export type BreedFilterInput = {
  accountBreeds?: InputMaybe<ListFilterInputTypeOfAccountBreedFilterInput>;
  and?: InputMaybe<Array<BreedFilterInput>>;
  aspirationPools?: InputMaybe<ListFilterInputTypeOfAspirationPoolFilterInput>;
  breedEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  category?: InputMaybe<NullableOftog_categoryOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  donors?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
  frameSize?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BreedFilterInput>>;
  recipBreedEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  recipients?: InputMaybe<ListFilterInputTypeOfRecipientFilterInput>;
  sires?: InputMaybe<ListFilterInputTypeOfSireFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  subFamily?: InputMaybe<NullableOftog_subfamilyOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type BreedInput = {
  accountBreeds: Array<AccountBreedInput>;
  aspirationPools: Array<AspirationPoolInput>;
  breedEmbryos: Array<EmbryoInput>;
  category?: InputMaybe<tog_category>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  donors: Array<DonorInput>;
  frameSize?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipBreedEmbryos: Array<EmbryoInput>;
  recipients: Array<RecipientInput>;
  sires: Array<SireInput>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  subFamily?: InputMaybe<tog_subfamily>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type BreedSortInput = {
  category?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  frameSize?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  subFamily?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BreedsCollectionSegment = {
  __typename: 'BreedsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Breed>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type BusinessUnit = {
  __typename: 'BusinessUnit';
  calendars: Array<Calendar>;
  companyId: Scalars['UUID']['output'];
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
};

export type BusinessUnitFilterInput = {
  and?: InputMaybe<Array<BusinessUnitFilterInput>>;
  calendars?: InputMaybe<ListFilterInputTypeOfCalendarFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BusinessUnitFilterInput>>;
};

export type BusinessUnitInput = {
  calendars: Array<CalendarInput>;
  companyId: Scalars['UUID']['input'];
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type BusinessUnitSortInput = {
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Calendar = {
  __typename: 'Calendar';
  businessUnit: Maybe<BusinessUnit>;
  businessUnitId: Maybe<Scalars['UUID']['output']>;
  companyId: Scalars['UUID']['output'];
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isShared: Scalars['Boolean']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Scalars['Int']['output'];
};

export type CalendarFilterInput = {
  and?: InputMaybe<Array<CalendarFilterInput>>;
  businessUnit?: InputMaybe<BusinessUnitFilterInput>;
  businessUnitId?: InputMaybe<UuidOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isShared?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CalendarFilterInput>>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type CalendarInput = {
  businessUnit?: InputMaybe<BusinessUnitInput>;
  businessUnitId?: InputMaybe<Scalars['UUID']['input']>;
  companyId: Scalars['UUID']['input'];
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isShared: Scalars['Boolean']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['Int']['input'];
};

export type CalendarSortInput = {
  businessUnit?: InputMaybe<BusinessUnitSortInput>;
  businessUnitId?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isShared?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type Calf = {
  __typename: 'Calf';
  activityDate: Maybe<Scalars['DateTime']['output']>;
  billComment: Maybe<Scalars['String']['output']>;
  billInstructions: Maybe<Scalars['Int']['output']>;
  birth: Maybe<Scalars['DateTime']['output']>;
  birthTime: Maybe<Scalars['Int']['output']>;
  birthWeight: Maybe<Scalars['Int']['output']>;
  boardBilledDate: Maybe<Scalars['DateTime']['output']>;
  breed: Maybe<Breed>;
  breedId: Maybe<Scalars['UUID']['output']>;
  calfOrigin: Maybe<Scalars['String']['output']>;
  calfType: Maybe<Scalars['Int']['output']>;
  /** @deprecated Unknown */
  calfd: Maybe<Scalars['Int']['output']>;
  clientPlans: Maybe<Scalars['String']['output']>;
  /** @deprecated What is cm? */
  cm: Maybe<Scalars['Int']['output']>;
  /** @deprecated What is cod? */
  cod: Maybe<Scalars['String']['output']>;
  color: Maybe<Color>;
  colorId: Maybe<Scalars['UUID']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  ddEntryDate: Maybe<Scalars['DateTime']['output']>;
  destination: Maybe<Scalars['String']['output']>;
  dnaBarcode: Maybe<Scalars['String']['output']>;
  dnaReceivedOn: Maybe<Scalars['DateTime']['output']>;
  dnaSentOn: Maybe<Scalars['DateTime']['output']>;
  donor: Maybe<Donor>;
  donorId: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Unknown */
  dtogid: Maybe<Scalars['Int']['output']>;
  embryo: Maybe<Embryo>;
  embryoId: Maybe<Scalars['UUID']['output']>;
  estimatedDueDate: Maybe<Scalars['DateTime']['output']>;
  fetalSex: Maybe<Scalars['Int']['output']>;
  fosterRecipient: Maybe<Recipient>;
  fosterRecipientId: Maybe<Scalars['UUID']['output']>;
  genomicDecision: Maybe<Scalars['Int']['output']>;
  haveTesticlesDecended: Maybe<Scalars['Boolean']['output']>;
  herdOrigin: Maybe<Scalars['String']['output']>;
  hipHeight: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['UUID']['output'];
  /** @deprecated Unknown */
  impid: Maybe<Scalars['Int']['output']>;
  isInduced: Maybe<Scalars['Boolean']['output']>;
  lopuDonor: Maybe<Donor>;
  lopuDonorId: Maybe<Scalars['UUID']['output']>;
  metalTag: Maybe<Scalars['String']['output']>;
  method: Maybe<Scalars['Int']['output']>;
  methodValue: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  /** @deprecated What is nm? */
  nm: Maybe<Scalars['Int']['output']>;
  opuProgram: Maybe<Scalars['Int']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  pedigreeName: Maybe<Scalars['String']['output']>;
  pen: Maybe<Pen>;
  penId: Maybe<Scalars['UUID']['output']>;
  preEntryBvdpiTesting: Maybe<Scalars['Int']['output']>;
  /** @deprecated Unknown */
  procedureUser: Maybe<SystemUser>;
  /** @deprecated Unknown */
  procedureUserId: Maybe<Scalars['UUID']['output']>;
  quarantine: Maybe<Scalars['Int']['output']>;
  recipient: Maybe<Recipient>;
  recipientId: Maybe<Scalars['UUID']['output']>;
  /** Registry (RFID) */
  registry: Maybe<Scalars['String']['output']>;
  secondTissue: Maybe<Scalars['String']['output']>;
  sex: Maybe<Scalars['Int']['output']>;
  sexValue: Maybe<Scalars['String']['output']>;
  ship: Maybe<Scalars['DateTime']['output']>;
  shipment: Maybe<Shipment>;
  shipmentId: Maybe<Scalars['UUID']['output']>;
  shipmentPlan: Maybe<Scalars['String']['output']>;
  sire: Maybe<Sire>;
  sireId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  status: Maybe<OptionSet>;
  statusCode: Maybe<Scalars['Int']['output']>;
  statusId: Maybe<Scalars['UUID']['output']>;
  stopBoardOn: Maybe<Scalars['DateTime']['output']>;
  tag: Maybe<Scalars['String']['output']>;
  tattoo: Maybe<Scalars['String']['output']>;
  testiclesDecendedOn: Maybe<Scalars['DateTime']['output']>;
  testicularDevelopment: Maybe<Scalars['Int']['output']>;
  togId: Maybe<Scalars['Int']['output']>;
  /** @deprecated Unknown */
  tog_ocv: Maybe<Scalars['String']['output']>;
  /** @deprecated What is tpi? */
  tpi: Maybe<Scalars['Int']['output']>;
  weanOn: Maybe<Scalars['DateTime']['output']>;
  weanWeight: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Scalars['Int']['output']>;
  yard: Maybe<Yard>;
  yardId: Maybe<Scalars['UUID']['output']>;
};

export type CalfEntryRequirementsInput = {
  herdsmanId?: InputMaybe<Scalars['UUID']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  receivedDate?: InputMaybe<Scalars['String']['input']>;
};

export type CalfFilterInput = {
  activityDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<CalfFilterInput>>;
  billComment?: InputMaybe<StringOperationFilterInput>;
  billInstructions?: InputMaybe<IntOperationFilterInput>;
  birth?: InputMaybe<DateTimeOperationFilterInput>;
  birthTime?: InputMaybe<IntOperationFilterInput>;
  birthWeight?: InputMaybe<IntOperationFilterInput>;
  boardBilledDate?: InputMaybe<DateTimeOperationFilterInput>;
  breed?: InputMaybe<BreedFilterInput>;
  breedId?: InputMaybe<UuidOperationFilterInput>;
  calfOrigin?: InputMaybe<StringOperationFilterInput>;
  calfType?: InputMaybe<IntOperationFilterInput>;
  clientPlans?: InputMaybe<StringOperationFilterInput>;
  color?: InputMaybe<ColorFilterInput>;
  colorId?: InputMaybe<UuidOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  ddEntryDate?: InputMaybe<DateTimeOperationFilterInput>;
  destination?: InputMaybe<StringOperationFilterInput>;
  dnaBarcode?: InputMaybe<StringOperationFilterInput>;
  dnaReceivedOn?: InputMaybe<DateTimeOperationFilterInput>;
  dnaSentOn?: InputMaybe<DateTimeOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  embryo?: InputMaybe<EmbryoFilterInput>;
  embryoId?: InputMaybe<UuidOperationFilterInput>;
  estimatedDueDate?: InputMaybe<DateTimeOperationFilterInput>;
  fetalSex?: InputMaybe<IntOperationFilterInput>;
  fosterRecipient?: InputMaybe<RecipientFilterInput>;
  fosterRecipientId?: InputMaybe<UuidOperationFilterInput>;
  genomicDecision?: InputMaybe<IntOperationFilterInput>;
  haveTesticlesDecended?: InputMaybe<BooleanOperationFilterInput>;
  herdOrigin?: InputMaybe<StringOperationFilterInput>;
  hipHeight?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isInduced?: InputMaybe<BooleanOperationFilterInput>;
  lopuDonor?: InputMaybe<DonorFilterInput>;
  lopuDonorId?: InputMaybe<UuidOperationFilterInput>;
  metalTag?: InputMaybe<StringOperationFilterInput>;
  method?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  opuProgram?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CalfFilterInput>>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  pedigreeName?: InputMaybe<StringOperationFilterInput>;
  pen?: InputMaybe<PenFilterInput>;
  penId?: InputMaybe<UuidOperationFilterInput>;
  preEntryBvdpiTesting?: InputMaybe<IntOperationFilterInput>;
  quarantine?: InputMaybe<IntOperationFilterInput>;
  recipient?: InputMaybe<RecipientFilterInput>;
  recipientId?: InputMaybe<UuidOperationFilterInput>;
  /** Registry (RFID) */
  registry?: InputMaybe<StringOperationFilterInput>;
  secondTissue?: InputMaybe<StringOperationFilterInput>;
  sex?: InputMaybe<IntOperationFilterInput>;
  ship?: InputMaybe<DateTimeOperationFilterInput>;
  shipment?: InputMaybe<ShipmentFilterInput>;
  shipmentId?: InputMaybe<UuidOperationFilterInput>;
  shipmentPlan?: InputMaybe<StringOperationFilterInput>;
  sire?: InputMaybe<SireFilterInput>;
  sireId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<OptionSetFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  statusId?: InputMaybe<UuidOperationFilterInput>;
  stopBoardOn?: InputMaybe<DateTimeOperationFilterInput>;
  tag?: InputMaybe<StringOperationFilterInput>;
  tattoo?: InputMaybe<StringOperationFilterInput>;
  testiclesDecendedOn?: InputMaybe<DateTimeOperationFilterInput>;
  testicularDevelopment?: InputMaybe<IntOperationFilterInput>;
  togId?: InputMaybe<IntOperationFilterInput>;
  weanOn?: InputMaybe<DateTimeOperationFilterInput>;
  weanWeight?: InputMaybe<IntOperationFilterInput>;
  weight?: InputMaybe<IntOperationFilterInput>;
  yard?: InputMaybe<YardFilterInput>;
  yardId?: InputMaybe<UuidOperationFilterInput>;
};

export type CalfInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  billComment?: InputMaybe<Scalars['String']['input']>;
  billInstructions?: InputMaybe<Scalars['Int']['input']>;
  birth?: InputMaybe<Scalars['DateTime']['input']>;
  birthTime?: InputMaybe<Scalars['Int']['input']>;
  birthWeight?: InputMaybe<Scalars['Int']['input']>;
  boardBilledDate?: InputMaybe<Scalars['DateTime']['input']>;
  breed?: InputMaybe<BreedInput>;
  breedId?: InputMaybe<Scalars['UUID']['input']>;
  calfOrigin?: InputMaybe<Scalars['String']['input']>;
  calfType?: InputMaybe<Scalars['Int']['input']>;
  clientPlans?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<ColorInput>;
  colorId?: InputMaybe<Scalars['UUID']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  ddEntryDate?: InputMaybe<Scalars['DateTime']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  dnaBarcode?: InputMaybe<Scalars['String']['input']>;
  dnaReceivedOn?: InputMaybe<Scalars['DateTime']['input']>;
  dnaSentOn?: InputMaybe<Scalars['DateTime']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  embryo?: InputMaybe<EmbryoInput>;
  embryoId?: InputMaybe<Scalars['UUID']['input']>;
  estimatedDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  fetalSex?: InputMaybe<Scalars['Int']['input']>;
  fosterRecipient?: InputMaybe<RecipientInput>;
  fosterRecipientId?: InputMaybe<Scalars['UUID']['input']>;
  genomicDecision?: InputMaybe<Scalars['Int']['input']>;
  haveTesticlesDecended?: InputMaybe<Scalars['Boolean']['input']>;
  herdOrigin?: InputMaybe<Scalars['String']['input']>;
  hipHeight?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['UUID']['input'];
  isInduced?: InputMaybe<Scalars['Boolean']['input']>;
  lopuDonor?: InputMaybe<DonorInput>;
  lopuDonorId?: InputMaybe<Scalars['UUID']['input']>;
  metalTag?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  opuProgram?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  pedigreeName?: InputMaybe<Scalars['String']['input']>;
  pen?: InputMaybe<PenInput>;
  penId?: InputMaybe<Scalars['UUID']['input']>;
  preEntryBvdpiTesting?: InputMaybe<Scalars['Int']['input']>;
  quarantine?: InputMaybe<Scalars['Int']['input']>;
  recipient?: InputMaybe<RecipientInput>;
  recipientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Registry (RFID) */
  registry?: InputMaybe<Scalars['String']['input']>;
  secondTissue?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['Int']['input']>;
  ship?: InputMaybe<Scalars['DateTime']['input']>;
  shipment?: InputMaybe<ShipmentInput>;
  shipmentId?: InputMaybe<Scalars['UUID']['input']>;
  shipmentPlan?: InputMaybe<Scalars['String']['input']>;
  sire?: InputMaybe<SireInput>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  status?: InputMaybe<OptionSetInput>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  statusId?: InputMaybe<Scalars['UUID']['input']>;
  stopBoardOn?: InputMaybe<Scalars['DateTime']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tattoo?: InputMaybe<Scalars['String']['input']>;
  testiclesDecendedOn?: InputMaybe<Scalars['DateTime']['input']>;
  testicularDevelopment?: InputMaybe<Scalars['Int']['input']>;
  togId?: InputMaybe<Scalars['Int']['input']>;
  weanOn?: InputMaybe<Scalars['DateTime']['input']>;
  weanWeight?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  yard?: InputMaybe<YardInput>;
  yardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CalfProcCodeBase = {
  __typename: 'CalfProcCodeBase';
  billingCode: Maybe<Scalars['UUID']['output']>;
  code: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  dose: Maybe<Scalars['Decimal']['output']>;
  drugId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isBillable: Maybe<Scalars['Boolean']['output']>;
  lot: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  search: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  unit: Maybe<Scalars['String']['output']>;
};

export type CalfProcCodeBaseFilterInput = {
  and?: InputMaybe<Array<CalfProcCodeBaseFilterInput>>;
  billingCode?: InputMaybe<UuidOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  dose?: InputMaybe<DecimalOperationFilterInput>;
  drugId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isBillable?: InputMaybe<BooleanOperationFilterInput>;
  lot?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CalfProcCodeBaseFilterInput>>;
  search?: InputMaybe<StringOperationFilterInput>;
  shortDescription?: InputMaybe<StringOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInput>;
};

export type CalfProcCodeBaseInput = {
  billingCode?: InputMaybe<Scalars['UUID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dose?: InputMaybe<Scalars['Decimal']['input']>;
  drugId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CalfProcedure = {
  __typename: 'CalfProcedure';
  calf: Maybe<Calf>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  fosterRecipient: Maybe<Recipient>;
  fosterRecipientId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  newYard: Maybe<Yard>;
  newYardId: Maybe<Scalars['UUID']['output']>;
  procCode: Maybe<CalfProcCodeBase>;
  stateCode: Scalars['Int']['output'];
  status: Maybe<OptionSet>;
  statusCode: Maybe<Scalars['Int']['output']>;
  statusId: Maybe<Scalars['UUID']['output']>;
  tog_Date: Maybe<Scalars['DateTime']['output']>;
  tog_Description: Maybe<Scalars['String']['output']>;
  tog_DiagnosisId: Maybe<Scalars['UUID']['output']>;
  tog_Dose: Maybe<Scalars['Decimal']['output']>;
  tog_Lot: Maybe<Scalars['String']['output']>;
  tog_NewPenId: Maybe<Scalars['UUID']['output']>;
  tog_PenId: Maybe<Scalars['UUID']['output']>;
  tog_Procedure: Maybe<Scalars['String']['output']>;
  tog_Tag: Maybe<Scalars['String']['output']>;
  tog_Unit: Maybe<Scalars['String']['output']>;
  tog_Weight: Maybe<Scalars['Int']['output']>;
  tog_Who: Maybe<Scalars['String']['output']>;
  tog_billstatus: Maybe<Scalars['Int']['output']>;
  tog_boardtypechange: Maybe<Scalars['Int']['output']>;
  tog_calfid: Maybe<Scalars['UUID']['output']>;
  tog_drugid: Maybe<Scalars['UUID']['output']>;
  tog_hipheight: Maybe<Scalars['Decimal']['output']>;
  tog_histid: Maybe<Scalars['Int']['output']>;
  tog_ownerid: Maybe<Scalars['UUID']['output']>;
  tog_proccodeid: Maybe<Scalars['UUID']['output']>;
  tog_temp: Maybe<Scalars['Decimal']['output']>;
  tog_timeofday: Maybe<Scalars['Int']['output']>;
  tog_togid: Maybe<Scalars['Int']['output']>;
  yard: Maybe<Yard>;
  yardId: Maybe<Scalars['UUID']['output']>;
};

export type CalfProcedureFilterInput = {
  and?: InputMaybe<Array<CalfProcedureFilterInput>>;
  calf?: InputMaybe<CalfFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  fosterRecipient?: InputMaybe<RecipientFilterInput>;
  fosterRecipientId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  newYard?: InputMaybe<YardFilterInput>;
  newYardId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CalfProcedureFilterInput>>;
  procCode?: InputMaybe<CalfProcCodeBaseFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<OptionSetFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  statusId?: InputMaybe<UuidOperationFilterInput>;
  tog_Date?: InputMaybe<DateTimeOperationFilterInput>;
  tog_Description?: InputMaybe<StringOperationFilterInput>;
  tog_DiagnosisId?: InputMaybe<UuidOperationFilterInput>;
  tog_Dose?: InputMaybe<DecimalOperationFilterInput>;
  tog_Lot?: InputMaybe<StringOperationFilterInput>;
  tog_NewPenId?: InputMaybe<UuidOperationFilterInput>;
  tog_PenId?: InputMaybe<UuidOperationFilterInput>;
  tog_Procedure?: InputMaybe<StringOperationFilterInput>;
  tog_Tag?: InputMaybe<StringOperationFilterInput>;
  tog_Unit?: InputMaybe<StringOperationFilterInput>;
  tog_Weight?: InputMaybe<IntOperationFilterInput>;
  tog_Who?: InputMaybe<StringOperationFilterInput>;
  tog_billstatus?: InputMaybe<IntOperationFilterInput>;
  tog_boardtypechange?: InputMaybe<IntOperationFilterInput>;
  tog_calfid?: InputMaybe<UuidOperationFilterInput>;
  tog_drugid?: InputMaybe<UuidOperationFilterInput>;
  tog_hipheight?: InputMaybe<DecimalOperationFilterInput>;
  tog_histid?: InputMaybe<IntOperationFilterInput>;
  tog_ownerid?: InputMaybe<UuidOperationFilterInput>;
  tog_proccodeid?: InputMaybe<UuidOperationFilterInput>;
  tog_temp?: InputMaybe<DecimalOperationFilterInput>;
  tog_timeofday?: InputMaybe<IntOperationFilterInput>;
  tog_togid?: InputMaybe<IntOperationFilterInput>;
  yard?: InputMaybe<YardFilterInput>;
  yardId?: InputMaybe<UuidOperationFilterInput>;
};

export type CalfProcedureInput = {
  calf?: InputMaybe<CalfInput>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  fosterRecipient?: InputMaybe<RecipientInput>;
  fosterRecipientId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  newYard?: InputMaybe<YardInput>;
  newYardId?: InputMaybe<Scalars['UUID']['input']>;
  procCode?: InputMaybe<CalfProcCodeBaseInput>;
  stateCode: Scalars['Int']['input'];
  status?: InputMaybe<OptionSetInput>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  statusId?: InputMaybe<Scalars['UUID']['input']>;
  tog_Date?: InputMaybe<Scalars['DateTime']['input']>;
  tog_Description?: InputMaybe<Scalars['String']['input']>;
  tog_DiagnosisId?: InputMaybe<Scalars['UUID']['input']>;
  tog_Dose?: InputMaybe<Scalars['Decimal']['input']>;
  tog_Lot?: InputMaybe<Scalars['String']['input']>;
  tog_NewPenId?: InputMaybe<Scalars['UUID']['input']>;
  tog_PenId?: InputMaybe<Scalars['UUID']['input']>;
  tog_Procedure?: InputMaybe<Scalars['String']['input']>;
  tog_Tag?: InputMaybe<Scalars['String']['input']>;
  tog_Unit?: InputMaybe<Scalars['String']['input']>;
  tog_Weight?: InputMaybe<Scalars['Int']['input']>;
  tog_Who?: InputMaybe<Scalars['String']['input']>;
  tog_billstatus?: InputMaybe<Scalars['Int']['input']>;
  tog_boardtypechange?: InputMaybe<Scalars['Int']['input']>;
  tog_calfid?: InputMaybe<Scalars['UUID']['input']>;
  tog_drugid?: InputMaybe<Scalars['UUID']['input']>;
  tog_hipheight?: InputMaybe<Scalars['Decimal']['input']>;
  tog_histid?: InputMaybe<Scalars['Int']['input']>;
  tog_ownerid?: InputMaybe<Scalars['UUID']['input']>;
  tog_proccodeid?: InputMaybe<Scalars['UUID']['input']>;
  tog_temp?: InputMaybe<Scalars['Decimal']['input']>;
  tog_timeofday?: InputMaybe<Scalars['Int']['input']>;
  tog_togid?: InputMaybe<Scalars['Int']['input']>;
  yard?: InputMaybe<YardInput>;
  yardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CalfSortInput = {
  activityDate?: InputMaybe<SortEnumType>;
  billComment?: InputMaybe<SortEnumType>;
  billInstructions?: InputMaybe<SortEnumType>;
  birth?: InputMaybe<SortEnumType>;
  birthTime?: InputMaybe<SortEnumType>;
  birthWeight?: InputMaybe<SortEnumType>;
  boardBilledDate?: InputMaybe<SortEnumType>;
  breed?: InputMaybe<BreedSortInput>;
  breedId?: InputMaybe<SortEnumType>;
  calfOrigin?: InputMaybe<SortEnumType>;
  calfType?: InputMaybe<SortEnumType>;
  clientPlans?: InputMaybe<SortEnumType>;
  color?: InputMaybe<ColorSortInput>;
  colorId?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  ddEntryDate?: InputMaybe<SortEnumType>;
  destination?: InputMaybe<SortEnumType>;
  dnaBarcode?: InputMaybe<SortEnumType>;
  dnaReceivedOn?: InputMaybe<SortEnumType>;
  dnaSentOn?: InputMaybe<SortEnumType>;
  donor?: InputMaybe<DonorSortInput>;
  donorId?: InputMaybe<SortEnumType>;
  embryo?: InputMaybe<EmbryoSortInput>;
  embryoId?: InputMaybe<SortEnumType>;
  estimatedDueDate?: InputMaybe<SortEnumType>;
  fetalSex?: InputMaybe<SortEnumType>;
  fosterRecipient?: InputMaybe<RecipientSortInput>;
  fosterRecipientId?: InputMaybe<SortEnumType>;
  genomicDecision?: InputMaybe<SortEnumType>;
  haveTesticlesDecended?: InputMaybe<SortEnumType>;
  herdOrigin?: InputMaybe<SortEnumType>;
  hipHeight?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isInduced?: InputMaybe<SortEnumType>;
  lopuDonor?: InputMaybe<DonorSortInput>;
  lopuDonorId?: InputMaybe<SortEnumType>;
  metalTag?: InputMaybe<SortEnumType>;
  method?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  opuProgram?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  pedigreeName?: InputMaybe<SortEnumType>;
  pen?: InputMaybe<PenSortInput>;
  penId?: InputMaybe<SortEnumType>;
  preEntryBvdpiTesting?: InputMaybe<SortEnumType>;
  quarantine?: InputMaybe<SortEnumType>;
  recipient?: InputMaybe<RecipientSortInput>;
  recipientId?: InputMaybe<SortEnumType>;
  /** Registry (RFID) */
  registry?: InputMaybe<SortEnumType>;
  secondTissue?: InputMaybe<SortEnumType>;
  sex?: InputMaybe<SortEnumType>;
  ship?: InputMaybe<SortEnumType>;
  shipment?: InputMaybe<ShipmentSortInput>;
  shipmentId?: InputMaybe<SortEnumType>;
  shipmentPlan?: InputMaybe<SortEnumType>;
  sire?: InputMaybe<SireSortInput>;
  sireId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<OptionSetSortInput>;
  statusCode?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  stopBoardOn?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<SortEnumType>;
  tattoo?: InputMaybe<SortEnumType>;
  testiclesDecendedOn?: InputMaybe<SortEnumType>;
  testicularDevelopment?: InputMaybe<SortEnumType>;
  togId?: InputMaybe<SortEnumType>;
  weanOn?: InputMaybe<SortEnumType>;
  weanWeight?: InputMaybe<SortEnumType>;
  weight?: InputMaybe<SortEnumType>;
  yard?: InputMaybe<YardSortInput>;
  yardId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CalvesCollectionSegment = {
  __typename: 'CalvesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Calf>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CellLine = {
  __typename: 'CellLine';
  accountId: Maybe<Scalars['UUID']['output']>;
  cellLineId: Maybe<Scalars['String']['output']>;
  clone: Maybe<Scalars['Int']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  fetalAdult: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  received: Maybe<Scalars['DateTime']['output']>;
  stateCode: Maybe<Scalars['Int']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  togId: Maybe<Scalars['Int']['output']>;
};

export type CellLineFilterInput = {
  accountId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<CellLineFilterInput>>;
  cellLineId?: InputMaybe<StringOperationFilterInput>;
  clone?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  fetalAdult?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CellLineFilterInput>>;
  received?: InputMaybe<DateTimeOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  togId?: InputMaybe<IntOperationFilterInput>;
};

export type CellLineSortInput = {
  accountId?: InputMaybe<SortEnumType>;
  cellLineId?: InputMaybe<SortEnumType>;
  clone?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  fetalAdult?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  received?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  togId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CellLinesCollectionSegment = {
  __typename: 'CellLinesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<CellLine>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChuteSchedule = {
  __typename: 'ChuteSchedule';
  aspirationComment: Maybe<Scalars['String']['output']>;
  aspirationDate: Maybe<Scalars['DateTime']['output']>;
  aspirationId: Maybe<Scalars['UUID']['output']>;
  aspirationTime: Maybe<Scalars['String']['output']>;
  breedCode: Maybe<Scalars['String']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  export: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  parity: Maybe<Scalars['String']['output']>;
  pool: Maybe<Scalars['String']['output']>;
  ptComment: Maybe<Scalars['String']['output']>;
  rowNum: Scalars['Long']['output'];
  semenType: Maybe<Scalars['String']['output']>;
  sireName: Maybe<Scalars['String']['output']>;
};

export type ChuteScheduleCombined = {
  __typename: 'ChuteScheduleCombined';
  results: Array<AspirationResultRow>;
  scheduling: Array<ChuteScheduleRow>;
};

export type ChuteScheduleFilterInput = {
  and?: InputMaybe<Array<ChuteScheduleFilterInput>>;
  aspirationComment?: InputMaybe<StringOperationFilterInput>;
  aspirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  aspirationId?: InputMaybe<UuidOperationFilterInput>;
  aspirationTime?: InputMaybe<StringOperationFilterInput>;
  breedCode?: InputMaybe<StringOperationFilterInput>;
  clientName?: InputMaybe<StringOperationFilterInput>;
  donorName?: InputMaybe<StringOperationFilterInput>;
  export?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ChuteScheduleFilterInput>>;
  parity?: InputMaybe<StringOperationFilterInput>;
  pool?: InputMaybe<StringOperationFilterInput>;
  ptComment?: InputMaybe<StringOperationFilterInput>;
  rowNum?: InputMaybe<LongOperationFilterInput>;
  semenType?: InputMaybe<StringOperationFilterInput>;
  sireName?: InputMaybe<StringOperationFilterInput>;
};

export type ChuteScheduleRow = {
  __typename: 'ChuteScheduleRow';
  account: Maybe<Scalars['String']['output']>;
  aspTime: Maybe<Scalars['String']['output']>;
  aspirationComment: Maybe<Scalars['String']['output']>;
  aspirationDate: Scalars['DateTime']['output'];
  aspirationId: Scalars['UUID']['output'];
  birthDate: Maybe<Scalars['DateTime']['output']>;
  breed: Maybe<Scalars['String']['output']>;
  collectionCode: Maybe<Scalars['String']['output']>;
  csa: Maybe<Scalars['String']['output']>;
  csr: Maybe<Scalars['String']['output']>;
  donor: Scalars['Long']['output'];
  donorLocation: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  dsAspirationComment: Maybe<Scalars['String']['output']>;
  dsSemenComment: Maybe<Scalars['String']['output']>;
  earTag: Maybe<Scalars['String']['output']>;
  embryoPlan: Maybe<Scalars['String']['output']>;
  export: Maybe<Scalars['String']['output']>;
  fertSite: Maybe<Scalars['String']['output']>;
  freeze: Maybe<Scalars['String']['output']>;
  freezeInstructions: Maybe<Scalars['String']['output']>;
  maturationComment: Maybe<Scalars['String']['output']>;
  parity: Maybe<Scalars['String']['output']>;
  pool: Maybe<Scalars['String']['output']>;
  pooled: Maybe<Scalars['String']['output']>;
  procedureDate: Maybe<Scalars['DateTime']['output']>;
  programName: Maybe<Scalars['String']['output']>;
  ptComment: Maybe<Scalars['String']['output']>;
  ranchId: Maybe<Scalars['String']['output']>;
  schedCode: Maybe<Scalars['String']['output']>;
  semenType: Maybe<Scalars['String']['output']>;
  ship: Maybe<Scalars['String']['output']>;
  shipmentGroupName: Maybe<Scalars['String']['output']>;
  sire: Maybe<Scalars['String']['output']>;
  sireBrd: Maybe<Scalars['String']['output']>;
  storageLocation: Maybe<Scalars['String']['output']>;
  transfer: Maybe<Scalars['String']['output']>;
  transferEmbryoComment: Maybe<Scalars['String']['output']>;
};

export type ChuteScheduleSortInput = {
  aspirationComment?: InputMaybe<SortEnumType>;
  aspirationDate?: InputMaybe<SortEnumType>;
  aspirationId?: InputMaybe<SortEnumType>;
  aspirationTime?: InputMaybe<SortEnumType>;
  breedCode?: InputMaybe<SortEnumType>;
  clientName?: InputMaybe<SortEnumType>;
  donorName?: InputMaybe<SortEnumType>;
  export?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  parity?: InputMaybe<SortEnumType>;
  pool?: InputMaybe<SortEnumType>;
  ptComment?: InputMaybe<SortEnumType>;
  rowNum?: InputMaybe<SortEnumType>;
  semenType?: InputMaybe<SortEnumType>;
  sireName?: InputMaybe<SortEnumType>;
};

export type ChuteSchedulerInput = {
  id: Scalars['UUID']['input'];
  time: Scalars['String']['input'];
};

export type ChuteSchedulerPayload = {
  __typename: 'ChuteSchedulerPayload';
  /** The TOG_aspirationBase table that contains the newly updated aspiration times. */
  chuteSchedules: Maybe<Array<Aspiration>>;
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

/** A segment of a collection. */
export type ChuteSchedulesCollectionSegment = {
  __typename: 'ChuteSchedulesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<ChuteSchedule>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClinicTransferEmbryoInput = {
  calfType?: InputMaybe<Scalars['Int']['input']>;
  clinicRanchHaulin?: InputMaybe<Scalars['Int']['input']>;
  fertilizationId?: InputMaybe<Scalars['String']['input']>;
  gradeTime?: InputMaybe<Scalars['String']['input']>;
  gradeValues: Array<KeyValuePairOfStringAndInt32Input>;
  graderId?: InputMaybe<Scalars['String']['input']>;
  totalDegenerates?: InputMaybe<Scalars['Int']['input']>;
  totalDiscarded?: InputMaybe<Scalars['Int']['input']>;
  transferDay?: InputMaybe<Scalars['DateTime']['input']>;
  transferSiteId?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicTransferEmbryoPayload = {
  __typename: 'ClinicTransferEmbryoPayload';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A segment of a collection. */
export type ClosedItRequestsCollectionSegment = {
  __typename: 'ClosedItRequestsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Request>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type Color = {
  __typename: 'Color';
  calves: Array<Calf>;
  code: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  recipients: Array<Recipient>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type ColorFilterInput = {
  and?: InputMaybe<Array<ColorFilterInput>>;
  calves?: InputMaybe<ListFilterInputTypeOfCalfFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ColorFilterInput>>;
  recipients?: InputMaybe<ListFilterInputTypeOfRecipientFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
};

export type ColorInput = {
  calves: Array<CalfInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<RecipientInput>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
};

export type ColorSortInput = {
  code?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
};

export type CommentType = {
  __typename: 'CommentType';
  text: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type CommentTypeFilterInput = {
  and?: InputMaybe<Array<CommentTypeFilterInput>>;
  or?: InputMaybe<Array<CommentTypeFilterInput>>;
  text?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<IntOperationFilterInput>;
};

export type CommentTypeSortInput = {
  text?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type Connection = {
  __typename: 'Connection';
  connectionStringKey: Scalars['String']['output'];
  connectionType: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  crmUrl: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  overrideEnvironmentId: Scalars['Int']['output'];
};

export type ConnectionFilterInput = {
  and?: InputMaybe<Array<ConnectionFilterInput>>;
  connectionStringKey?: InputMaybe<StringOperationFilterInput>;
  connectionType?: InputMaybe<StringOperationFilterInput>;
  countryCode?: InputMaybe<StringOperationFilterInput>;
  countryName?: InputMaybe<StringOperationFilterInput>;
  crmUrl?: InputMaybe<StringOperationFilterInput>;
  languageCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConnectionFilterInput>>;
  overrideEnvironmentId?: InputMaybe<IntOperationFilterInput>;
};

export type ConnectionSortInput = {
  connectionStringKey?: InputMaybe<SortEnumType>;
  connectionType?: InputMaybe<SortEnumType>;
  countryCode?: InputMaybe<SortEnumType>;
  countryName?: InputMaybe<SortEnumType>;
  crmUrl?: InputMaybe<SortEnumType>;
  languageCode?: InputMaybe<SortEnumType>;
  overrideEnvironmentId?: InputMaybe<SortEnumType>;
};

export type Contact = {
  __typename: 'Contact';
  accountRoleCode: Maybe<Scalars['Int']['output']>;
  accountsPrimaryContact: Array<Account>;
  aging30: Maybe<Scalars['Decimal']['output']>;
  aging30_Base: Maybe<Scalars['Decimal']['output']>;
  aging60: Maybe<Scalars['Decimal']['output']>;
  aging60_Base: Maybe<Scalars['Decimal']['output']>;
  aging90: Maybe<Scalars['Decimal']['output']>;
  aging90_Base: Maybe<Scalars['Decimal']['output']>;
  anniversary: Maybe<Scalars['DateTime']['output']>;
  annualIncome_Base: Maybe<Scalars['Decimal']['output']>;
  assistantName: Maybe<Scalars['String']['output']>;
  assistantPhone: Maybe<Scalars['String']['output']>;
  birthDate: Maybe<Scalars['DateTime']['output']>;
  business2: Maybe<Scalars['String']['output']>;
  childrensNames: Maybe<Scalars['String']['output']>;
  company: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<SystemUser>;
  createdByExternalParty: Maybe<Scalars['UUID']['output']>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  creditLimit: Maybe<Scalars['Decimal']['output']>;
  creditLimit_Base: Maybe<Scalars['Decimal']['output']>;
  creditOnHold: Maybe<Scalars['Boolean']['output']>;
  customerSizeCode: Maybe<Scalars['Int']['output']>;
  customerTypeCode: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  doNotBulkEmail: Maybe<Scalars['Boolean']['output']>;
  doNotBulkPostalMail: Maybe<Scalars['Boolean']['output']>;
  doNotEmail: Maybe<Scalars['Boolean']['output']>;
  doNotFax: Maybe<Scalars['Boolean']['output']>;
  doNotPhone: Maybe<Scalars['Boolean']['output']>;
  doNotPostalMail: Maybe<Scalars['Boolean']['output']>;
  doNotSendMM: Maybe<Scalars['Boolean']['output']>;
  educationCode: Maybe<Scalars['Int']['output']>;
  emailAddress1: Maybe<Scalars['String']['output']>;
  emailAddress2: Maybe<Scalars['String']['output']>;
  emailAddress3: Maybe<Scalars['String']['output']>;
  employeeId: Maybe<Scalars['String']['output']>;
  employeeStatus: Maybe<Scalars['Int']['output']>;
  entityImageId: Maybe<Scalars['UUID']['output']>;
  exchangeRate: Maybe<Scalars['Decimal']['output']>;
  extension: Maybe<Scalars['String']['output']>;
  externalUserIdentifier: Maybe<Scalars['String']['output']>;
  familyStatusCode: Maybe<Scalars['Int']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  followEmail: Maybe<Scalars['Boolean']['output']>;
  ftpSiteUrl: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  genderCode: Maybe<Scalars['Int']['output']>;
  hasChildrenCode: Maybe<Scalars['Int']['output']>;
  home2: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  importSequenceNumber: Maybe<Scalars['Int']['output']>;
  isAutoCreate: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  lastUsedInCampaign: Maybe<Scalars['DateTime']['output']>;
  managerName: Maybe<Scalars['String']['output']>;
  managerPhone: Maybe<Scalars['String']['output']>;
  marketingOnly: Maybe<Scalars['Boolean']['output']>;
  masterId: Maybe<Scalars['UUID']['output']>;
  merged: Maybe<Scalars['Boolean']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  mobilePhone: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedByExternalParty: Maybe<Scalars['UUID']['output']>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  nickName: Maybe<Scalars['String']['output']>;
  numberOfChildren: Maybe<Scalars['Int']['output']>;
  ownerId: Scalars['UUID']['output'];
  ownerIdType: Scalars['Int']['output'];
  pager: Maybe<Scalars['String']['output']>;
  parentCustomerId: Maybe<Scalars['UUID']['output']>;
  parentCustomerIdName: Maybe<Scalars['String']['output']>;
  parentCustomerIdType: Maybe<Scalars['Int']['output']>;
  parentCustomerIdYomiName: Maybe<Scalars['String']['output']>;
  paymentTermsCode: Maybe<Scalars['Int']['output']>;
  preferredAppointmentDayCode: Maybe<Scalars['Int']['output']>;
  preferredAppointmentTimeCode: Maybe<Scalars['Int']['output']>;
  preferredContactMethodCode: Maybe<Scalars['Int']['output']>;
  preferredEquipmentId: Maybe<Scalars['UUID']['output']>;
  preferredServiceId: Maybe<Scalars['UUID']['output']>;
  preferredSystemUserId: Maybe<Scalars['UUID']['output']>;
  processId: Maybe<Scalars['UUID']['output']>;
  shippingMethodCode: Maybe<Scalars['Int']['output']>;
  spousesName: Maybe<Scalars['String']['output']>;
  stageId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  subscriptionId: Maybe<Scalars['UUID']['output']>;
  suffix: Maybe<Scalars['String']['output']>;
  telephone1: Maybe<Scalars['String']['output']>;
  telephone2: Maybe<Scalars['String']['output']>;
  telephone3: Maybe<Scalars['String']['output']>;
  territoryCode: Maybe<Scalars['Int']['output']>;
  timeZoneRuleVersionNumber: Maybe<Scalars['Int']['output']>;
  tog_SiteId: Maybe<Scalars['UUID']['output']>;
  tog_annotationid: Maybe<Scalars['String']['output']>;
  tog_contactid: Maybe<Scalars['UUID']['output']>;
  transactionCurrencyId: Maybe<Scalars['UUID']['output']>;
  traversedPath: Maybe<Scalars['String']['output']>;
  utcConversionTimeZoneCode: Maybe<Scalars['Int']['output']>;
  webSiteUrl: Maybe<Scalars['String']['output']>;
};

export type ContactFilterInput = {
  accountRoleCode?: InputMaybe<IntOperationFilterInput>;
  accountsPrimaryContact?: InputMaybe<ListFilterInputTypeOfAccountFilterInput>;
  aging30?: InputMaybe<DecimalOperationFilterInput>;
  aging30_Base?: InputMaybe<DecimalOperationFilterInput>;
  aging60?: InputMaybe<DecimalOperationFilterInput>;
  aging60_Base?: InputMaybe<DecimalOperationFilterInput>;
  aging90?: InputMaybe<DecimalOperationFilterInput>;
  aging90_Base?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<ContactFilterInput>>;
  anniversary?: InputMaybe<DateTimeOperationFilterInput>;
  annualIncome_Base?: InputMaybe<DecimalOperationFilterInput>;
  assistantName?: InputMaybe<StringOperationFilterInput>;
  assistantPhone?: InputMaybe<StringOperationFilterInput>;
  birthDate?: InputMaybe<DateTimeOperationFilterInput>;
  business2?: InputMaybe<StringOperationFilterInput>;
  childrensNames?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdByExternalParty?: InputMaybe<UuidOperationFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  creditLimit?: InputMaybe<DecimalOperationFilterInput>;
  creditLimit_Base?: InputMaybe<DecimalOperationFilterInput>;
  creditOnHold?: InputMaybe<BooleanOperationFilterInput>;
  customerSizeCode?: InputMaybe<IntOperationFilterInput>;
  customerTypeCode?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  doNotBulkEmail?: InputMaybe<BooleanOperationFilterInput>;
  doNotBulkPostalMail?: InputMaybe<BooleanOperationFilterInput>;
  doNotEmail?: InputMaybe<BooleanOperationFilterInput>;
  doNotFax?: InputMaybe<BooleanOperationFilterInput>;
  doNotPhone?: InputMaybe<BooleanOperationFilterInput>;
  doNotPostalMail?: InputMaybe<BooleanOperationFilterInput>;
  doNotSendMM?: InputMaybe<BooleanOperationFilterInput>;
  educationCode?: InputMaybe<IntOperationFilterInput>;
  emailAddress1?: InputMaybe<StringOperationFilterInput>;
  emailAddress2?: InputMaybe<StringOperationFilterInput>;
  emailAddress3?: InputMaybe<StringOperationFilterInput>;
  employeeId?: InputMaybe<StringOperationFilterInput>;
  employeeStatus?: InputMaybe<IntOperationFilterInput>;
  entityImageId?: InputMaybe<UuidOperationFilterInput>;
  exchangeRate?: InputMaybe<DecimalOperationFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  externalUserIdentifier?: InputMaybe<StringOperationFilterInput>;
  familyStatusCode?: InputMaybe<IntOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  followEmail?: InputMaybe<BooleanOperationFilterInput>;
  ftpSiteUrl?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  genderCode?: InputMaybe<IntOperationFilterInput>;
  hasChildrenCode?: InputMaybe<IntOperationFilterInput>;
  home2?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  importSequenceNumber?: InputMaybe<IntOperationFilterInput>;
  isAutoCreate?: InputMaybe<BooleanOperationFilterInput>;
  isPrivate?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  lastUsedInCampaign?: InputMaybe<DateTimeOperationFilterInput>;
  managerName?: InputMaybe<StringOperationFilterInput>;
  managerPhone?: InputMaybe<StringOperationFilterInput>;
  marketingOnly?: InputMaybe<BooleanOperationFilterInput>;
  masterId?: InputMaybe<UuidOperationFilterInput>;
  merged?: InputMaybe<BooleanOperationFilterInput>;
  middleName?: InputMaybe<StringOperationFilterInput>;
  mobilePhone?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedByExternalParty?: InputMaybe<UuidOperationFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  nickName?: InputMaybe<StringOperationFilterInput>;
  numberOfChildren?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  ownerIdType?: InputMaybe<IntOperationFilterInput>;
  pager?: InputMaybe<StringOperationFilterInput>;
  parentCustomerId?: InputMaybe<UuidOperationFilterInput>;
  parentCustomerIdName?: InputMaybe<StringOperationFilterInput>;
  parentCustomerIdType?: InputMaybe<IntOperationFilterInput>;
  parentCustomerIdYomiName?: InputMaybe<StringOperationFilterInput>;
  paymentTermsCode?: InputMaybe<IntOperationFilterInput>;
  preferredAppointmentDayCode?: InputMaybe<IntOperationFilterInput>;
  preferredAppointmentTimeCode?: InputMaybe<IntOperationFilterInput>;
  preferredContactMethodCode?: InputMaybe<IntOperationFilterInput>;
  preferredEquipmentId?: InputMaybe<UuidOperationFilterInput>;
  preferredServiceId?: InputMaybe<UuidOperationFilterInput>;
  preferredSystemUserId?: InputMaybe<UuidOperationFilterInput>;
  processId?: InputMaybe<UuidOperationFilterInput>;
  shippingMethodCode?: InputMaybe<IntOperationFilterInput>;
  spousesName?: InputMaybe<StringOperationFilterInput>;
  stageId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  subscriptionId?: InputMaybe<UuidOperationFilterInput>;
  suffix?: InputMaybe<StringOperationFilterInput>;
  telephone1?: InputMaybe<StringOperationFilterInput>;
  telephone2?: InputMaybe<StringOperationFilterInput>;
  telephone3?: InputMaybe<StringOperationFilterInput>;
  territoryCode?: InputMaybe<IntOperationFilterInput>;
  timeZoneRuleVersionNumber?: InputMaybe<IntOperationFilterInput>;
  tog_SiteId?: InputMaybe<UuidOperationFilterInput>;
  tog_annotationid?: InputMaybe<StringOperationFilterInput>;
  tog_contactid?: InputMaybe<UuidOperationFilterInput>;
  transactionCurrencyId?: InputMaybe<UuidOperationFilterInput>;
  traversedPath?: InputMaybe<StringOperationFilterInput>;
  utcConversionTimeZoneCode?: InputMaybe<IntOperationFilterInput>;
  webSiteUrl?: InputMaybe<StringOperationFilterInput>;
};

export type ContactInput = {
  accountRoleCode?: InputMaybe<Scalars['Int']['input']>;
  accountsPrimaryContact: Array<AccountInput>;
  aging30?: InputMaybe<Scalars['Decimal']['input']>;
  aging30_Base?: InputMaybe<Scalars['Decimal']['input']>;
  aging60?: InputMaybe<Scalars['Decimal']['input']>;
  aging60_Base?: InputMaybe<Scalars['Decimal']['input']>;
  aging90?: InputMaybe<Scalars['Decimal']['input']>;
  aging90_Base?: InputMaybe<Scalars['Decimal']['input']>;
  anniversary?: InputMaybe<Scalars['DateTime']['input']>;
  annualIncome_Base?: InputMaybe<Scalars['Decimal']['input']>;
  assistantName?: InputMaybe<Scalars['String']['input']>;
  assistantPhone?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  business2?: InputMaybe<Scalars['String']['input']>;
  childrensNames?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdByExternalParty?: InputMaybe<Scalars['UUID']['input']>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  creditLimit?: InputMaybe<Scalars['Decimal']['input']>;
  creditLimit_Base?: InputMaybe<Scalars['Decimal']['input']>;
  creditOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  customerSizeCode?: InputMaybe<Scalars['Int']['input']>;
  customerTypeCode?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doNotBulkEmail?: InputMaybe<Scalars['Boolean']['input']>;
  doNotBulkPostalMail?: InputMaybe<Scalars['Boolean']['input']>;
  doNotEmail?: InputMaybe<Scalars['Boolean']['input']>;
  doNotFax?: InputMaybe<Scalars['Boolean']['input']>;
  doNotPhone?: InputMaybe<Scalars['Boolean']['input']>;
  doNotPostalMail?: InputMaybe<Scalars['Boolean']['input']>;
  doNotSendMM?: InputMaybe<Scalars['Boolean']['input']>;
  educationCode?: InputMaybe<Scalars['Int']['input']>;
  emailAddress1?: InputMaybe<Scalars['String']['input']>;
  emailAddress2?: InputMaybe<Scalars['String']['input']>;
  emailAddress3?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employeeStatus?: InputMaybe<Scalars['Int']['input']>;
  entityImageId?: InputMaybe<Scalars['UUID']['input']>;
  exchangeRate?: InputMaybe<Scalars['Decimal']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  externalUserIdentifier?: InputMaybe<Scalars['String']['input']>;
  familyStatusCode?: InputMaybe<Scalars['Int']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  followEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ftpSiteUrl?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  genderCode?: InputMaybe<Scalars['Int']['input']>;
  hasChildrenCode?: InputMaybe<Scalars['Int']['input']>;
  home2?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  importSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  isAutoCreate?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastUsedInCampaign?: InputMaybe<Scalars['DateTime']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  managerPhone?: InputMaybe<Scalars['String']['input']>;
  marketingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  masterId?: InputMaybe<Scalars['UUID']['input']>;
  merged?: InputMaybe<Scalars['Boolean']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedByExternalParty?: InputMaybe<Scalars['UUID']['input']>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
  numberOfChildren?: InputMaybe<Scalars['Int']['input']>;
  ownerId: Scalars['UUID']['input'];
  ownerIdType: Scalars['Int']['input'];
  pager?: InputMaybe<Scalars['String']['input']>;
  parentCustomerId?: InputMaybe<Scalars['UUID']['input']>;
  parentCustomerIdName?: InputMaybe<Scalars['String']['input']>;
  parentCustomerIdType?: InputMaybe<Scalars['Int']['input']>;
  parentCustomerIdYomiName?: InputMaybe<Scalars['String']['input']>;
  paymentTermsCode?: InputMaybe<Scalars['Int']['input']>;
  preferredAppointmentDayCode?: InputMaybe<Scalars['Int']['input']>;
  preferredAppointmentTimeCode?: InputMaybe<Scalars['Int']['input']>;
  preferredContactMethodCode?: InputMaybe<Scalars['Int']['input']>;
  preferredEquipmentId?: InputMaybe<Scalars['UUID']['input']>;
  preferredServiceId?: InputMaybe<Scalars['UUID']['input']>;
  preferredSystemUserId?: InputMaybe<Scalars['UUID']['input']>;
  processId?: InputMaybe<Scalars['UUID']['input']>;
  shippingMethodCode?: InputMaybe<Scalars['Int']['input']>;
  spousesName?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId?: InputMaybe<Scalars['UUID']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  telephone1?: InputMaybe<Scalars['String']['input']>;
  telephone2?: InputMaybe<Scalars['String']['input']>;
  telephone3?: InputMaybe<Scalars['String']['input']>;
  territoryCode?: InputMaybe<Scalars['Int']['input']>;
  timeZoneRuleVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  tog_SiteId?: InputMaybe<Scalars['UUID']['input']>;
  tog_annotationid?: InputMaybe<Scalars['String']['input']>;
  tog_contactid?: InputMaybe<Scalars['UUID']['input']>;
  transactionCurrencyId?: InputMaybe<Scalars['UUID']['input']>;
  traversedPath?: InputMaybe<Scalars['String']['input']>;
  utcConversionTimeZoneCode?: InputMaybe<Scalars['Int']['input']>;
  webSiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ContactSortInput = {
  accountRoleCode?: InputMaybe<SortEnumType>;
  aging30?: InputMaybe<SortEnumType>;
  aging30_Base?: InputMaybe<SortEnumType>;
  aging60?: InputMaybe<SortEnumType>;
  aging60_Base?: InputMaybe<SortEnumType>;
  aging90?: InputMaybe<SortEnumType>;
  aging90_Base?: InputMaybe<SortEnumType>;
  anniversary?: InputMaybe<SortEnumType>;
  annualIncome_Base?: InputMaybe<SortEnumType>;
  assistantName?: InputMaybe<SortEnumType>;
  assistantPhone?: InputMaybe<SortEnumType>;
  birthDate?: InputMaybe<SortEnumType>;
  business2?: InputMaybe<SortEnumType>;
  childrensNames?: InputMaybe<SortEnumType>;
  company?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdByExternalParty?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  creditLimit?: InputMaybe<SortEnumType>;
  creditLimit_Base?: InputMaybe<SortEnumType>;
  creditOnHold?: InputMaybe<SortEnumType>;
  customerSizeCode?: InputMaybe<SortEnumType>;
  customerTypeCode?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  doNotBulkEmail?: InputMaybe<SortEnumType>;
  doNotBulkPostalMail?: InputMaybe<SortEnumType>;
  doNotEmail?: InputMaybe<SortEnumType>;
  doNotFax?: InputMaybe<SortEnumType>;
  doNotPhone?: InputMaybe<SortEnumType>;
  doNotPostalMail?: InputMaybe<SortEnumType>;
  doNotSendMM?: InputMaybe<SortEnumType>;
  educationCode?: InputMaybe<SortEnumType>;
  emailAddress1?: InputMaybe<SortEnumType>;
  emailAddress2?: InputMaybe<SortEnumType>;
  emailAddress3?: InputMaybe<SortEnumType>;
  employeeId?: InputMaybe<SortEnumType>;
  employeeStatus?: InputMaybe<SortEnumType>;
  entityImageId?: InputMaybe<SortEnumType>;
  exchangeRate?: InputMaybe<SortEnumType>;
  extension?: InputMaybe<SortEnumType>;
  externalUserIdentifier?: InputMaybe<SortEnumType>;
  familyStatusCode?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  followEmail?: InputMaybe<SortEnumType>;
  ftpSiteUrl?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  genderCode?: InputMaybe<SortEnumType>;
  hasChildrenCode?: InputMaybe<SortEnumType>;
  home2?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importSequenceNumber?: InputMaybe<SortEnumType>;
  isAutoCreate?: InputMaybe<SortEnumType>;
  isPrivate?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lastUsedInCampaign?: InputMaybe<SortEnumType>;
  managerName?: InputMaybe<SortEnumType>;
  managerPhone?: InputMaybe<SortEnumType>;
  marketingOnly?: InputMaybe<SortEnumType>;
  masterId?: InputMaybe<SortEnumType>;
  merged?: InputMaybe<SortEnumType>;
  middleName?: InputMaybe<SortEnumType>;
  mobilePhone?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedByExternalParty?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  nickName?: InputMaybe<SortEnumType>;
  numberOfChildren?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  ownerIdType?: InputMaybe<SortEnumType>;
  pager?: InputMaybe<SortEnumType>;
  parentCustomerId?: InputMaybe<SortEnumType>;
  parentCustomerIdName?: InputMaybe<SortEnumType>;
  parentCustomerIdType?: InputMaybe<SortEnumType>;
  parentCustomerIdYomiName?: InputMaybe<SortEnumType>;
  paymentTermsCode?: InputMaybe<SortEnumType>;
  preferredAppointmentDayCode?: InputMaybe<SortEnumType>;
  preferredAppointmentTimeCode?: InputMaybe<SortEnumType>;
  preferredContactMethodCode?: InputMaybe<SortEnumType>;
  preferredEquipmentId?: InputMaybe<SortEnumType>;
  preferredServiceId?: InputMaybe<SortEnumType>;
  preferredSystemUserId?: InputMaybe<SortEnumType>;
  processId?: InputMaybe<SortEnumType>;
  shippingMethodCode?: InputMaybe<SortEnumType>;
  spousesName?: InputMaybe<SortEnumType>;
  stageId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  subscriptionId?: InputMaybe<SortEnumType>;
  suffix?: InputMaybe<SortEnumType>;
  telephone1?: InputMaybe<SortEnumType>;
  telephone2?: InputMaybe<SortEnumType>;
  telephone3?: InputMaybe<SortEnumType>;
  territoryCode?: InputMaybe<SortEnumType>;
  timeZoneRuleVersionNumber?: InputMaybe<SortEnumType>;
  tog_SiteId?: InputMaybe<SortEnumType>;
  tog_annotationid?: InputMaybe<SortEnumType>;
  tog_contactid?: InputMaybe<SortEnumType>;
  transactionCurrencyId?: InputMaybe<SortEnumType>;
  traversedPath?: InputMaybe<SortEnumType>;
  utcConversionTimeZoneCode?: InputMaybe<SortEnumType>;
  webSiteUrl?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ContactsCollectionSegment = {
  __typename: 'ContactsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateAetaResultInput = {
  embryoDevelopmentRate: Scalars['Float']['input'];
  embryosPerAspiration: Scalars['Float']['input'];
  oocytesPerAspiration: Scalars['Float']['input'];
  type: AetaResultType;
  year: Scalars['Int']['input'];
};

export type CreateAetaResultPayload = {
  __typename: 'CreateAetaResultPayload';
  aetaResult: Maybe<AetaResult>;
};

export type CreateFertilizationInput = {
  billUnits: Scalars['Decimal']['input'];
  cultureIncubatorNo?: InputMaybe<Scalars['UUID']['input']>;
  culturePlateLotNo: Scalars['String']['input'];
  donorScheduleDate: Scalars['DateTime']['input'];
  dsid: Array<Scalars['String']['input']>;
  ehmMedia: Scalars['DateTime']['input'];
  fertComment: Array<Scalars['String']['input']>;
  fertCommentList: Array<Scalars['Int']['input']>;
  fertDate: Scalars['DateTime']['input'];
  fertMediaLotNo: Scalars['DateTime']['input'];
  fertPlate: Scalars['String']['input'];
  fertTechID: Scalars['UUID']['input'];
  fertTime: Array<Scalars['String']['input']>;
  gridFertCommentsDDL: Array<Array<Scalars['Int']['input']>>;
  isContaminated: Array<Scalars['Boolean']['input']>;
  ivfNum: Array<Scalars['Int']['input']>;
  mineralOilLot: Scalars['String']['input'];
  mofloList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  moveTechID: Scalars['UUID']['input'];
  numFerts: Scalars['Int']['input'];
  pooledSires: Scalars['Boolean']['input'];
  procTechID: Scalars['UUID']['input'];
  qcIsolate: Scalars['String']['input'];
  semenID: Array<Scalars['String']['input']>;
  semenQtyUse: Array<Scalars['Int']['input']>;
  semenTypeList: Array<Scalars['String']['input']>;
  serum: Scalars['String']['input'];
  sofDate: Scalars['DateTime']['input'];
};

export type CreateFertilizationPayload = {
  __typename: 'CreateFertilizationPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** The id of the affected fertilization, if applicable. */
  fertilizationIds: Maybe<Array<Scalars['UUID']['output']>>;
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type CreateNewDonorInput = {
  birth?: InputMaybe<Scalars['DateTime']['input']>;
  breedId: Scalars['UUID']['input'];
  donorName?: InputMaybe<Scalars['String']['input']>;
  exportDonor?: InputMaybe<Scalars['Int']['input']>;
  housingId?: InputMaybe<Scalars['UUID']['input']>;
  ivfStatusId?: InputMaybe<Scalars['UUID']['input']>;
  lastActivity?: InputMaybe<Scalars['String']['input']>;
  metalTag?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['UUID']['input'];
  pedName?: InputMaybe<Scalars['String']['input']>;
  pregnant: Scalars['Int']['input'];
  received?: InputMaybe<Scalars['DateTime']['input']>;
  regPrefix?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  tattoo?: InputMaybe<Scalars['String']['input']>;
  yardId: Scalars['UUID']['input'];
};

export type CreateNewSemenPayload = {
  __typename: 'CreateNewSemenPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The id of the newly added semen. */
  semenId: Maybe<Scalars['UUID']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type CreateNewShipmentGroupInput = {
  estimations?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNewShipmentGroupMasterInput = {
  billIncubator?: InputMaybe<Scalars['Boolean']['input']>;
  billShipping?: InputMaybe<Scalars['Boolean']['input']>;
  callTagComment?: InputMaybe<Scalars['String']['input']>;
  callTagContactId?: InputMaybe<Scalars['UUID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  shipComment?: InputMaybe<Scalars['String']['input']>;
  shipmentGroupId: Scalars['UUID']['input'];
  shippingMethod?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateNewSireInput = {
  birth?: InputMaybe<Scalars['DateTime']['input']>;
  breedId: Scalars['UUID']['input'];
  breedReg?: InputMaybe<Scalars['String']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  heparin?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  regPrefix?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  sexedCane?: InputMaybe<Scalars['String']['input']>;
  sire: Scalars['String']['input'];
  sireCm?: InputMaybe<Scalars['Int']['input']>;
  sireJpi?: InputMaybe<Scalars['Int']['input']>;
  sireNm?: InputMaybe<Scalars['Int']['input']>;
  sireTpi?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatedFertType = {
  __typename: 'CreatedFertType';
  accountID: Scalars['UUID']['output'];
  accountNumber: Scalars['String']['output'];
  exportName: Scalars['String']['output'];
  exportValue: Scalars['String']['output'];
  fertComment: Scalars['String']['output'];
  fertComments: Scalars['String']['output'];
  fertID: Scalars['UUID']['output'];
  fertName: Scalars['String']['output'];
  ivfNum: Scalars['String']['output'];
  matTime: Scalars['String']['output'];
  numSemenUnits: Scalars['String']['output'];
  semenType: Scalars['String']['output'];
};

export type CreatedFertTypeFilterInput = {
  accountID?: InputMaybe<UuidOperationFilterInput>;
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CreatedFertTypeFilterInput>>;
  exportName?: InputMaybe<StringOperationFilterInput>;
  exportValue?: InputMaybe<StringOperationFilterInput>;
  fertComment?: InputMaybe<StringOperationFilterInput>;
  fertComments?: InputMaybe<StringOperationFilterInput>;
  fertID?: InputMaybe<UuidOperationFilterInput>;
  fertName?: InputMaybe<StringOperationFilterInput>;
  ivfNum?: InputMaybe<StringOperationFilterInput>;
  matTime?: InputMaybe<StringOperationFilterInput>;
  numSemenUnits?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CreatedFertTypeFilterInput>>;
  semenType?: InputMaybe<StringOperationFilterInput>;
};

export type CreatedFertTypeSortInput = {
  accountID?: InputMaybe<SortEnumType>;
  accountNumber?: InputMaybe<SortEnumType>;
  exportName?: InputMaybe<SortEnumType>;
  exportValue?: InputMaybe<SortEnumType>;
  fertComment?: InputMaybe<SortEnumType>;
  fertComments?: InputMaybe<SortEnumType>;
  fertID?: InputMaybe<SortEnumType>;
  fertName?: InputMaybe<SortEnumType>;
  ivfNum?: InputMaybe<SortEnumType>;
  matTime?: InputMaybe<SortEnumType>;
  numSemenUnits?: InputMaybe<SortEnumType>;
  semenType?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CreatedFertsCollectionSegment = {
  __typename: 'CreatedFertsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<CreatedFertType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CryoBabyLabelInput = {
  accountCode?: InputMaybe<Scalars['String']['input']>;
  donorName?: InputMaybe<Scalars['String']['input']>;
  donorRegNum?: InputMaybe<Scalars['String']['input']>;
  export?: InputMaybe<Scalars['String']['input']>;
  nonEuComment?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type CurrentEquipmentsCollectionSegment = {
  __typename: 'CurrentEquipmentsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Equipment>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomerAddress = {
  __typename: 'CustomerAddress';
  addressNumber: Maybe<Scalars['Int']['output']>;
  city: Maybe<Scalars['String']['output']>;
  composite: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  freightTermsCode: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  line1: Maybe<Scalars['String']['output']>;
  line2: Maybe<Scalars['String']['output']>;
  line3: Maybe<Scalars['String']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['UUID']['output']>;
  postOfficeBox: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  primaryContactName: Maybe<Scalars['String']['output']>;
  shippingMethodCode: Maybe<Scalars['Int']['output']>;
  stateOrProvince: Maybe<Scalars['String']['output']>;
  telephone1: Maybe<Scalars['String']['output']>;
  telephone2: Maybe<Scalars['String']['output']>;
  telephone3: Maybe<Scalars['String']['output']>;
  upsZone: Maybe<Scalars['String']['output']>;
  utcOffset: Maybe<Scalars['Int']['output']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Day7FrozenEmbryo = {
  __typename: 'Day7FrozenEmbryo';
  cane: Maybe<Scalars['String']['output']>;
  freezeSite: Maybe<Scalars['String']['output']>;
  freezeTime: Maybe<Scalars['String']['output']>;
  grade: Maybe<Scalars['Int']['output']>;
  mating: Maybe<Scalars['String']['output']>;
  plateNumber: Maybe<Scalars['Decimal']['output']>;
  stage: Maybe<Scalars['Int']['output']>;
  straw: Maybe<Scalars['Int']['output']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type Donor = {
  __typename: 'Donor';
  activityDate: Maybe<Scalars['DateTime']['output']>;
  birth: Maybe<Scalars['DateTime']['output']>;
  blood: Maybe<Scalars['Boolean']['output']>;
  breed: Maybe<Breed>;
  breedId: Maybe<Scalars['UUID']['output']>;
  breedPct: Maybe<Scalars['Decimal']['output']>;
  calf: Maybe<Scalars['Boolean']['output']>;
  calfSex: Maybe<Scalars['Int']['output']>;
  calfType: Maybe<Scalars['Int']['output']>;
  category: Maybe<Scalars['Int']['output']>;
  cemMergeXml: Maybe<Scalars['String']['output']>;
  cfTogId: Maybe<Scalars['Int']['output']>;
  cm: Maybe<Scalars['Int']['output']>;
  cod: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  condition: Maybe<Scalars['String']['output']>;
  consolidatedHealthStatus: Maybe<Scalars['String']['output']>;
  contract: Maybe<Scalars['Boolean']['output']>;
  countryCodeId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  dam: Maybe<Scalars['String']['output']>;
  damReg: Maybe<Scalars['String']['output']>;
  damSire: Maybe<Scalars['String']['output']>;
  damSrReg: Maybe<Scalars['String']['output']>;
  destination: Maybe<Scalars['String']['output']>;
  discontinueIvf: Maybe<Scalars['DateTime']['output']>;
  dnaBarcode: Maybe<Scalars['String']['output']>;
  dnaReceived: Maybe<Scalars['DateTime']['output']>;
  dnaSent: Maybe<Scalars['DateTime']['output']>;
  donorGroup: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  donorSchedule: Array<DonorSchedule>;
  edonorClientId: Maybe<Scalars['String']['output']>;
  edonorId: Maybe<Scalars['String']['output']>;
  embryoPlan: Maybe<Scalars['Int']['output']>;
  embryos: Array<Embryo>;
  exportDonor: Maybe<Scalars['Int']['output']>;
  fertilizations: Array<Fertilization>;
  flexFieldPartner: Maybe<Scalars['String']['output']>;
  freezeInstructions: Maybe<Scalars['String']['output']>;
  grp: Maybe<Scalars['Int']['output']>;
  hairSample: Maybe<Scalars['Boolean']['output']>;
  healthStatus: Maybe<Scalars['String']['output']>;
  heiferCow: Maybe<Scalars['Int']['output']>;
  housing: Maybe<OptionSet>;
  housingId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  inversePooledDonor: Array<Donor>;
  itComm: Maybe<Scalars['String']['output']>;
  ivfStatus: Maybe<OptionSet>;
  ivfStatusId: Maybe<Scalars['UUID']['output']>;
  jpi: Maybe<Scalars['Int']['output']>;
  lastActivity: Maybe<Scalars['String']['output']>;
  lastAspirationOn: Maybe<Scalars['DateTime']['output']>;
  lastBred: Maybe<Scalars['DateTime']['output']>;
  lastBredSire: Maybe<Sire>;
  lastBredSireId: Maybe<Scalars['UUID']['output']>;
  lastFetalSex: Maybe<Scalars['Int']['output']>;
  lastFlush: Maybe<Scalars['DateTime']['output']>;
  lastHeat: Maybe<Scalars['DateTime']['output']>;
  leaseOrigin: Maybe<Account>;
  leaseOriginId: Maybe<Scalars['UUID']['output']>;
  liveCalf: Maybe<Scalars['Boolean']['output']>;
  lopuCalf: Maybe<Scalars['UUID']['output']>;
  metalTag: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nm: Maybe<Scalars['Int']['output']>;
  numCalves: Maybe<Scalars['Int']['output']>;
  ocvStatus: Maybe<OptionSet>;
  ocvStatusId: Maybe<Scalars['UUID']['output']>;
  onFarm: Maybe<Scalars['Boolean']['output']>;
  opuProgram: Maybe<Scalars['Int']['output']>;
  origin: Maybe<Scalars['String']['output']>;
  ourTag: Maybe<Scalars['String']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  ownerships: Array<Ownership>;
  pairedCalf: Maybe<Donor>;
  pairedCalfId: Maybe<Scalars['UUID']['output']>;
  pairedCalved: Array<Donor>;
  partnerships: Array<Partnership>;
  pedName: Maybe<Scalars['String']['output']>;
  pedigree: Maybe<Scalars['Boolean']['output']>;
  pooledDonor: Maybe<Donor>;
  pooledDonorId: Maybe<Scalars['UUID']['output']>;
  pregnant: Maybe<Scalars['Int']['output']>;
  pregnantValue: Maybe<Scalars['String']['output']>;
  probableDonorEmbryos: Array<Embryo>;
  probableDonorFertilizations: Array<Fertilization>;
  programName: Maybe<Scalars['String']['output']>;
  psi: Maybe<Scalars['Int']['output']>;
  ranchTag: Maybe<Scalars['String']['output']>;
  received: Maybe<Scalars['DateTime']['output']>;
  regPrefix: Maybe<Scalars['String']['output']>;
  registrationNumber: Maybe<Scalars['String']['output']>;
  ship: Maybe<Scalars['DateTime']['output']>;
  shipment: Maybe<Shipment>;
  shipmentId: Maybe<Scalars['UUID']['output']>;
  shipmentPlan: Maybe<Scalars['String']['output']>;
  sire: Maybe<Scalars['String']['output']>;
  sireReg: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  status: Maybe<OptionSet>;
  statusCode: Maybe<Scalars['Int']['output']>;
  statusId: Maybe<Scalars['UUID']['output']>;
  tattoo: Maybe<Scalars['String']['output']>;
  togId: Maybe<Scalars['Int']['output']>;
  tpi: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Scalars['Int']['output']>;
  yard: Maybe<Yard>;
  yardBeforeChangeId: Maybe<Scalars['UUID']['output']>;
  yardId: Maybe<Scalars['UUID']['output']>;
};

export type DonorFilterInput = {
  activityDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<DonorFilterInput>>;
  birth?: InputMaybe<DateTimeOperationFilterInput>;
  blood?: InputMaybe<BooleanOperationFilterInput>;
  breed?: InputMaybe<BreedFilterInput>;
  breedId?: InputMaybe<UuidOperationFilterInput>;
  breedPct?: InputMaybe<DecimalOperationFilterInput>;
  calf?: InputMaybe<BooleanOperationFilterInput>;
  calfSex?: InputMaybe<IntOperationFilterInput>;
  calfType?: InputMaybe<IntOperationFilterInput>;
  category?: InputMaybe<IntOperationFilterInput>;
  cemMergeXml?: InputMaybe<StringOperationFilterInput>;
  cfTogId?: InputMaybe<IntOperationFilterInput>;
  cm?: InputMaybe<IntOperationFilterInput>;
  cod?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  condition?: InputMaybe<StringOperationFilterInput>;
  consolidatedHealthStatus?: InputMaybe<StringOperationFilterInput>;
  contract?: InputMaybe<BooleanOperationFilterInput>;
  countryCodeId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  dam?: InputMaybe<StringOperationFilterInput>;
  damReg?: InputMaybe<StringOperationFilterInput>;
  damSire?: InputMaybe<StringOperationFilterInput>;
  damSrReg?: InputMaybe<StringOperationFilterInput>;
  destination?: InputMaybe<StringOperationFilterInput>;
  discontinueIvf?: InputMaybe<DateTimeOperationFilterInput>;
  dnaBarcode?: InputMaybe<StringOperationFilterInput>;
  dnaReceived?: InputMaybe<DateTimeOperationFilterInput>;
  dnaSent?: InputMaybe<DateTimeOperationFilterInput>;
  donorGroup?: InputMaybe<StringOperationFilterInput>;
  donorName?: InputMaybe<StringOperationFilterInput>;
  donorSchedule?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  edonorClientId?: InputMaybe<StringOperationFilterInput>;
  edonorId?: InputMaybe<StringOperationFilterInput>;
  embryoPlan?: InputMaybe<IntOperationFilterInput>;
  embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  exportDonor?: InputMaybe<IntOperationFilterInput>;
  fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  flexFieldPartner?: InputMaybe<StringOperationFilterInput>;
  freezeInstructions?: InputMaybe<StringOperationFilterInput>;
  grp?: InputMaybe<IntOperationFilterInput>;
  hairSample?: InputMaybe<BooleanOperationFilterInput>;
  healthStatus?: InputMaybe<StringOperationFilterInput>;
  heiferCow?: InputMaybe<IntOperationFilterInput>;
  housing?: InputMaybe<OptionSetFilterInput>;
  housingId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  inversePooledDonor?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
  itComm?: InputMaybe<StringOperationFilterInput>;
  ivfStatus?: InputMaybe<OptionSetFilterInput>;
  ivfStatusId?: InputMaybe<UuidOperationFilterInput>;
  jpi?: InputMaybe<IntOperationFilterInput>;
  lastActivity?: InputMaybe<StringOperationFilterInput>;
  lastAspirationOn?: InputMaybe<DateTimeOperationFilterInput>;
  lastBred?: InputMaybe<DateTimeOperationFilterInput>;
  lastBredSire?: InputMaybe<SireFilterInput>;
  lastBredSireId?: InputMaybe<UuidOperationFilterInput>;
  lastFetalSex?: InputMaybe<IntOperationFilterInput>;
  lastFlush?: InputMaybe<DateTimeOperationFilterInput>;
  lastHeat?: InputMaybe<DateTimeOperationFilterInput>;
  leaseOrigin?: InputMaybe<AccountFilterInput>;
  leaseOriginId?: InputMaybe<UuidOperationFilterInput>;
  liveCalf?: InputMaybe<BooleanOperationFilterInput>;
  lopuCalf?: InputMaybe<UuidOperationFilterInput>;
  metalTag?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nm?: InputMaybe<IntOperationFilterInput>;
  numCalves?: InputMaybe<IntOperationFilterInput>;
  ocvStatus?: InputMaybe<OptionSetFilterInput>;
  ocvStatusId?: InputMaybe<UuidOperationFilterInput>;
  onFarm?: InputMaybe<BooleanOperationFilterInput>;
  opuProgram?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DonorFilterInput>>;
  origin?: InputMaybe<StringOperationFilterInput>;
  ourTag?: InputMaybe<StringOperationFilterInput>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  ownerships?: InputMaybe<ListFilterInputTypeOfOwnershipFilterInput>;
  pairedCalf?: InputMaybe<DonorFilterInput>;
  pairedCalfId?: InputMaybe<UuidOperationFilterInput>;
  pairedCalved?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
  partnerships?: InputMaybe<ListFilterInputTypeOfPartnershipFilterInput>;
  pedName?: InputMaybe<StringOperationFilterInput>;
  pedigree?: InputMaybe<BooleanOperationFilterInput>;
  pooledDonor?: InputMaybe<DonorFilterInput>;
  pooledDonorId?: InputMaybe<UuidOperationFilterInput>;
  pregnant?: InputMaybe<IntOperationFilterInput>;
  probableDonorEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  probableDonorFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  programName?: InputMaybe<StringOperationFilterInput>;
  psi?: InputMaybe<IntOperationFilterInput>;
  ranchTag?: InputMaybe<StringOperationFilterInput>;
  received?: InputMaybe<DateTimeOperationFilterInput>;
  regPrefix?: InputMaybe<StringOperationFilterInput>;
  registrationNumber?: InputMaybe<StringOperationFilterInput>;
  ship?: InputMaybe<DateTimeOperationFilterInput>;
  shipment?: InputMaybe<ShipmentFilterInput>;
  shipmentId?: InputMaybe<UuidOperationFilterInput>;
  shipmentPlan?: InputMaybe<StringOperationFilterInput>;
  sire?: InputMaybe<StringOperationFilterInput>;
  sireReg?: InputMaybe<StringOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<OptionSetFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  statusId?: InputMaybe<UuidOperationFilterInput>;
  tattoo?: InputMaybe<StringOperationFilterInput>;
  togId?: InputMaybe<IntOperationFilterInput>;
  tpi?: InputMaybe<IntOperationFilterInput>;
  weight?: InputMaybe<IntOperationFilterInput>;
  yard?: InputMaybe<YardFilterInput>;
  yardBeforeChangeId?: InputMaybe<UuidOperationFilterInput>;
  yardId?: InputMaybe<UuidOperationFilterInput>;
};

export type DonorInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  birth?: InputMaybe<Scalars['DateTime']['input']>;
  blood?: InputMaybe<Scalars['Boolean']['input']>;
  breed?: InputMaybe<BreedInput>;
  breedId?: InputMaybe<Scalars['UUID']['input']>;
  breedPct?: InputMaybe<Scalars['Decimal']['input']>;
  calf?: InputMaybe<Scalars['Boolean']['input']>;
  calfSex?: InputMaybe<Scalars['Int']['input']>;
  calfType?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['Int']['input']>;
  cemMergeXml?: InputMaybe<Scalars['String']['input']>;
  cfTogId?: InputMaybe<Scalars['Int']['input']>;
  cm?: InputMaybe<Scalars['Int']['input']>;
  cod?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  consolidatedHealthStatus?: InputMaybe<Scalars['String']['input']>;
  contract?: InputMaybe<Scalars['Boolean']['input']>;
  countryCodeId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  dam?: InputMaybe<Scalars['String']['input']>;
  damReg?: InputMaybe<Scalars['String']['input']>;
  damSire?: InputMaybe<Scalars['String']['input']>;
  damSrReg?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  discontinueIvf?: InputMaybe<Scalars['DateTime']['input']>;
  dnaBarcode?: InputMaybe<Scalars['String']['input']>;
  dnaReceived?: InputMaybe<Scalars['DateTime']['input']>;
  dnaSent?: InputMaybe<Scalars['DateTime']['input']>;
  donorGroup?: InputMaybe<Scalars['String']['input']>;
  donorName?: InputMaybe<Scalars['String']['input']>;
  donorSchedule: Array<DonorScheduleInput>;
  edonorClientId?: InputMaybe<Scalars['String']['input']>;
  edonorId?: InputMaybe<Scalars['String']['input']>;
  embryoPlan?: InputMaybe<Scalars['Int']['input']>;
  embryos: Array<EmbryoInput>;
  exportDonor?: InputMaybe<Scalars['Int']['input']>;
  fertilizations: Array<FertilizationInput>;
  flexFieldPartner?: InputMaybe<Scalars['String']['input']>;
  freezeInstructions?: InputMaybe<Scalars['String']['input']>;
  grp?: InputMaybe<Scalars['Int']['input']>;
  hairSample?: InputMaybe<Scalars['Boolean']['input']>;
  healthStatus?: InputMaybe<Scalars['String']['input']>;
  heiferCow?: InputMaybe<Scalars['Int']['input']>;
  housing?: InputMaybe<OptionSetInput>;
  housingId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  inversePooledDonor: Array<DonorInput>;
  itComm?: InputMaybe<Scalars['String']['input']>;
  ivfStatus?: InputMaybe<OptionSetInput>;
  ivfStatusId?: InputMaybe<Scalars['UUID']['input']>;
  jpi?: InputMaybe<Scalars['Int']['input']>;
  lastActivity?: InputMaybe<Scalars['String']['input']>;
  lastAspirationOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastBred?: InputMaybe<Scalars['DateTime']['input']>;
  lastBredSire?: InputMaybe<SireInput>;
  lastBredSireId?: InputMaybe<Scalars['UUID']['input']>;
  lastFetalSex?: InputMaybe<Scalars['Int']['input']>;
  lastFlush?: InputMaybe<Scalars['DateTime']['input']>;
  lastHeat?: InputMaybe<Scalars['DateTime']['input']>;
  leaseOrigin?: InputMaybe<AccountInput>;
  leaseOriginId?: InputMaybe<Scalars['UUID']['input']>;
  liveCalf?: InputMaybe<Scalars['Boolean']['input']>;
  lopuCalf?: InputMaybe<Scalars['UUID']['input']>;
  metalTag?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nm?: InputMaybe<Scalars['Int']['input']>;
  numCalves?: InputMaybe<Scalars['Int']['input']>;
  ocvStatus?: InputMaybe<OptionSetInput>;
  ocvStatusId?: InputMaybe<Scalars['UUID']['input']>;
  onFarm?: InputMaybe<Scalars['Boolean']['input']>;
  opuProgram?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  ourTag?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  ownerships: Array<OwnershipInput>;
  pairedCalf?: InputMaybe<DonorInput>;
  pairedCalfId?: InputMaybe<Scalars['UUID']['input']>;
  pairedCalved: Array<DonorInput>;
  partnerships: Array<PartnershipInput>;
  pedName?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['Boolean']['input']>;
  pooledDonor?: InputMaybe<DonorInput>;
  pooledDonorId?: InputMaybe<Scalars['UUID']['input']>;
  pregnant?: InputMaybe<Scalars['Int']['input']>;
  probableDonorEmbryos: Array<EmbryoInput>;
  probableDonorFertilizations: Array<FertilizationInput>;
  programName?: InputMaybe<Scalars['String']['input']>;
  psi?: InputMaybe<Scalars['Int']['input']>;
  ranchTag?: InputMaybe<Scalars['String']['input']>;
  received?: InputMaybe<Scalars['DateTime']['input']>;
  regPrefix?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  ship?: InputMaybe<Scalars['DateTime']['input']>;
  shipment?: InputMaybe<ShipmentInput>;
  shipmentId?: InputMaybe<Scalars['UUID']['input']>;
  shipmentPlan?: InputMaybe<Scalars['String']['input']>;
  sire?: InputMaybe<Scalars['String']['input']>;
  sireReg?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['Int']['input'];
  status?: InputMaybe<OptionSetInput>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  statusId?: InputMaybe<Scalars['UUID']['input']>;
  tattoo?: InputMaybe<Scalars['String']['input']>;
  togId?: InputMaybe<Scalars['Int']['input']>;
  tpi?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  yard?: InputMaybe<YardInput>;
  yardBeforeChangeId?: InputMaybe<Scalars['UUID']['input']>;
  yardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DonorPayload = {
  __typename: 'DonorPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** The tog_donorBase table that contains the newly added donor. */
  donor: Maybe<Donor>;
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type DonorProcCodeBase = {
  __typename: 'DonorProcCodeBase';
  activity: Maybe<Scalars['String']['output']>;
  billingCode: Maybe<Scalars['UUID']['output']>;
  code: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  dose: Maybe<Scalars['Decimal']['output']>;
  drugId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isBillable: Maybe<Scalars['Boolean']['output']>;
  lot: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  search: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['Int']['output']>;
  unit: Maybe<Scalars['String']['output']>;
};

export type DonorProcCodeBaseFilterInput = {
  activity?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<DonorProcCodeBaseFilterInput>>;
  billingCode?: InputMaybe<UuidOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  dose?: InputMaybe<DecimalOperationFilterInput>;
  drugId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isBillable?: InputMaybe<BooleanOperationFilterInput>;
  lot?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<DonorProcCodeBaseFilterInput>>;
  search?: InputMaybe<StringOperationFilterInput>;
  shortDescription?: InputMaybe<StringOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInput>;
};

export type DonorProcCodeBaseInput = {
  activity?: InputMaybe<Scalars['String']['input']>;
  billingCode?: InputMaybe<Scalars['UUID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dose?: InputMaybe<Scalars['Decimal']['input']>;
  drugId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type DonorProcCodeBaseSortInput = {
  activity?: InputMaybe<SortEnumType>;
  billingCode?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  dose?: InputMaybe<SortEnumType>;
  drugId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isBillable?: InputMaybe<SortEnumType>;
  lot?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  shortDescription?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
};

export type DonorProcedure = {
  __typename: 'DonorProcedure';
  aspirationId: Maybe<Scalars['UUID']['output']>;
  breedingId: Maybe<Scalars['UUID']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  currentWeight: Maybe<Scalars['Decimal']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  dateBilled: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  donor: Maybe<Donor>;
  donorId: Maybe<Scalars['UUID']['output']>;
  dose: Maybe<Scalars['Decimal']['output']>;
  drugId: Maybe<Scalars['UUID']['output']>;
  exchangeRate: Maybe<Scalars['Decimal']['output']>;
  flushId: Maybe<Scalars['UUID']['output']>;
  hipHeight: Maybe<Scalars['Decimal']['output']>;
  histId: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  importSequenceNumber: Maybe<Scalars['Int']['output']>;
  lot: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  newYardId: Maybe<Scalars['UUID']['output']>;
  overriddenCreatedOn: Maybe<Scalars['DateTime']['output']>;
  overridePrice: Maybe<Scalars['Decimal']['output']>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  pcPregnant: Maybe<Scalars['Int']['output']>;
  preg: Maybe<Scalars['Boolean']['output']>;
  pregnant: Maybe<Scalars['Int']['output']>;
  procCode: Maybe<DonorProcCodeBase>;
  procCodeId: Maybe<Scalars['UUID']['output']>;
  procedure: Maybe<Scalars['String']['output']>;
  soScheduleId: Maybe<Scalars['UUID']['output']>;
  stateCode: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['UUID']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  tattoo: Maybe<Scalars['String']['output']>;
  time: Maybe<Scalars['Int']['output']>;
  togId: Maybe<Scalars['Int']['output']>;
  transactionCurrencyId: Maybe<Scalars['UUID']['output']>;
  type: Maybe<Scalars['Int']['output']>;
  unit: Maybe<Scalars['String']['output']>;
  utcConversionTimeZoneCode: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Scalars['Int']['output']>;
  who: Maybe<Scalars['String']['output']>;
  yardId: Maybe<Scalars['UUID']['output']>;
};

export type DonorProcedureFilterInput = {
  and?: InputMaybe<Array<DonorProcedureFilterInput>>;
  aspirationId?: InputMaybe<UuidOperationFilterInput>;
  breedingId?: InputMaybe<UuidOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  currentWeight?: InputMaybe<DecimalOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  dateBilled?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  dose?: InputMaybe<DecimalOperationFilterInput>;
  drugId?: InputMaybe<UuidOperationFilterInput>;
  exchangeRate?: InputMaybe<DecimalOperationFilterInput>;
  flushId?: InputMaybe<UuidOperationFilterInput>;
  hipHeight?: InputMaybe<DecimalOperationFilterInput>;
  histId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  importSequenceNumber?: InputMaybe<IntOperationFilterInput>;
  lot?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  newYardId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<DonorProcedureFilterInput>>;
  overriddenCreatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  overridePrice?: InputMaybe<DecimalOperationFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  pcPregnant?: InputMaybe<IntOperationFilterInput>;
  preg?: InputMaybe<BooleanOperationFilterInput>;
  pregnant?: InputMaybe<IntOperationFilterInput>;
  procCode?: InputMaybe<DonorProcCodeBaseFilterInput>;
  procCodeId?: InputMaybe<UuidOperationFilterInput>;
  procedure?: InputMaybe<StringOperationFilterInput>;
  soScheduleId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<UuidOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  tattoo?: InputMaybe<StringOperationFilterInput>;
  time?: InputMaybe<IntOperationFilterInput>;
  togId?: InputMaybe<IntOperationFilterInput>;
  transactionCurrencyId?: InputMaybe<UuidOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInput>;
  utcConversionTimeZoneCode?: InputMaybe<IntOperationFilterInput>;
  weight?: InputMaybe<IntOperationFilterInput>;
  who?: InputMaybe<StringOperationFilterInput>;
  yardId?: InputMaybe<UuidOperationFilterInput>;
};

export type DonorProcedureInput = {
  aspirationId?: InputMaybe<Scalars['UUID']['input']>;
  breedingId?: InputMaybe<Scalars['UUID']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  currentWeight?: InputMaybe<Scalars['Decimal']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBilled?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  dose?: InputMaybe<Scalars['Decimal']['input']>;
  drugId?: InputMaybe<Scalars['UUID']['input']>;
  exchangeRate?: InputMaybe<Scalars['Decimal']['input']>;
  flushId?: InputMaybe<Scalars['UUID']['input']>;
  hipHeight?: InputMaybe<Scalars['Decimal']['input']>;
  histId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  importSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  lot?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  newYardId?: InputMaybe<Scalars['UUID']['input']>;
  overriddenCreatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  overridePrice?: InputMaybe<Scalars['Decimal']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  pcPregnant?: InputMaybe<Scalars['Int']['input']>;
  preg?: InputMaybe<Scalars['Boolean']['input']>;
  pregnant?: InputMaybe<Scalars['Int']['input']>;
  procCode?: InputMaybe<DonorProcCodeBaseInput>;
  procCodeId?: InputMaybe<Scalars['UUID']['input']>;
  procedure?: InputMaybe<Scalars['String']['input']>;
  soScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['UUID']['input']>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  tattoo?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  togId?: InputMaybe<Scalars['Int']['input']>;
  transactionCurrencyId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  utcConversionTimeZoneCode?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  who?: InputMaybe<Scalars['String']['input']>;
  yardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DonorProcedureSortInput = {
  aspirationId?: InputMaybe<SortEnumType>;
  breedingId?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  currentWeight?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  dateBilled?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  donor?: InputMaybe<DonorSortInput>;
  donorId?: InputMaybe<SortEnumType>;
  dose?: InputMaybe<SortEnumType>;
  drugId?: InputMaybe<SortEnumType>;
  exchangeRate?: InputMaybe<SortEnumType>;
  flushId?: InputMaybe<SortEnumType>;
  hipHeight?: InputMaybe<SortEnumType>;
  histId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importSequenceNumber?: InputMaybe<SortEnumType>;
  lot?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  newYardId?: InputMaybe<SortEnumType>;
  overriddenCreatedOn?: InputMaybe<SortEnumType>;
  overridePrice?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  pcPregnant?: InputMaybe<SortEnumType>;
  preg?: InputMaybe<SortEnumType>;
  pregnant?: InputMaybe<SortEnumType>;
  procCode?: InputMaybe<DonorProcCodeBaseSortInput>;
  procCodeId?: InputMaybe<SortEnumType>;
  procedure?: InputMaybe<SortEnumType>;
  soScheduleId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  tattoo?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
  togId?: InputMaybe<SortEnumType>;
  transactionCurrencyId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
  utcConversionTimeZoneCode?: InputMaybe<SortEnumType>;
  weight?: InputMaybe<SortEnumType>;
  who?: InputMaybe<SortEnumType>;
  yardId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type DonorProceduresCollectionSegment = {
  __typename: 'DonorProceduresCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<DonorProcedure>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type DonorSchedule = {
  __typename: 'DonorSchedule';
  accountComment: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `annotations` instead */
  annotation: Maybe<Annotation>;
  annotations: Array<Annotation>;
  aspirationSite: Maybe<Site>;
  aspirationSiteId: Maybe<Scalars['UUID']['output']>;
  backupCsrId: Maybe<Scalars['UUID']['output']>;
  backupSemen: Maybe<Semen>;
  backupSemenId: Maybe<Scalars['UUID']['output']>;
  backupSemenType: Maybe<Scalars['Int']['output']>;
  backupSire: Maybe<Sire>;
  backupSireId: Maybe<Scalars['UUID']['output']>;
  billAccountCaningOption: Maybe<Scalars['Int']['output']>;
  billDrugs: Maybe<Scalars['Boolean']['output']>;
  billingAccount: Maybe<Account>;
  billingAccountId: Maybe<Scalars['UUID']['output']>;
  billingComment: Maybe<Scalars['String']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  clinicRanchHaulIn: Maybe<Scalars['Int']['output']>;
  colCode: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  contact: Maybe<Scalars['String']['output']>;
  contractSemen: Maybe<Scalars['Boolean']['output']>;
  createSOAuto: Maybe<Scalars['Int']['output']>;
  createdBy: Maybe<SystemUser>;
  createdByApp: Maybe<Scalars['Int']['output']>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  creditRebill: Maybe<Scalars['Boolean']['output']>;
  critical: Maybe<Scalars['Int']['output']>;
  csr: Maybe<SystemUser>;
  csrId: Maybe<Scalars['UUID']['output']>;
  csrfrztrf: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  day7pickup: Maybe<Scalars['Int']['output']>;
  donor: Maybe<Donor>;
  donorComment: Maybe<Scalars['String']['output']>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorLocation: Maybe<Scalars['String']['output']>;
  dow: Maybe<Scalars['String']['output']>;
  drug: Maybe<Drug>;
  drug2: Maybe<Drug>;
  drugShippingFee: Maybe<Scalars['Int']['output']>;
  drugStatus: Maybe<Scalars['Int']['output']>;
  embryoComment: Maybe<Scalars['String']['output']>;
  expectedSemenQty: Maybe<Scalars['Int']['output']>;
  export: Maybe<Scalars['Int']['output']>;
  /** @deprecated Unreliable: usually empty. */
  fertilization: Maybe<Fertilization>;
  /** @deprecated Unreliable: usually empty. */
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  fertilizationSite: Maybe<Site>;
  fertilizationSiteId: Maybe<Scalars['UUID']['output']>;
  fertilizations: Maybe<Array<Fertilization>>;
  flexFieldPartner: Maybe<Scalars['String']['output']>;
  freeze: Maybe<Scalars['Int']['output']>;
  freezeInstructions: Maybe<Scalars['String']['output']>;
  freezeMethod: Maybe<OptionSet>;
  freezeMethodId: Maybe<Scalars['UUID']['output']>;
  freshShipmentComments: Maybe<Scalars['String']['output']>;
  fsh2Id: Maybe<Scalars['UUID']['output']>;
  fshId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  implantType: Maybe<Scalars['Int']['output']>;
  implantTypeValue: Maybe<Scalars['String']['output']>;
  ivfLabSemen: Maybe<Semen>;
  ivfLabSemenId: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Unreliable: usually empty. */
  linkedAspiration: Maybe<Aspiration>;
  /** @deprecated Unreliable: usually empty. */
  linkedAspirationId: Maybe<Scalars['UUID']['output']>;
  loadDonorPartners: Maybe<Scalars['Int']['output']>;
  loadDonorPartnersfrz: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  naab: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nonEUCountry: Maybe<Scalars['Int']['output']>;
  notify: Maybe<Scalars['Boolean']['output']>;
  oocyteShipping: Maybe<Scalars['Int']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  parity: Maybe<Scalars['Int']['output']>;
  partnerships: Maybe<Array<Partnership>>;
  pool: Maybe<Scalars['Boolean']['output']>;
  pregnant: Maybe<Scalars['Int']['output']>;
  priority: Maybe<Scalars['Int']['output']>;
  procedureTime: Maybe<Scalars['Int']['output']>;
  procedureTimeComment: Maybe<Scalars['String']['output']>;
  programName: Maybe<Scalars['String']['output']>;
  revision: Maybe<Scalars['String']['output']>;
  revisionComment: Maybe<Scalars['String']['output']>;
  scheduleMaster: Maybe<ScheduleMaster>;
  scheduleMasterId: Maybe<Scalars['UUID']['output']>;
  scheduleStatus: Maybe<Scalars['String']['output']>;
  scheduled: Maybe<Scalars['Boolean']['output']>;
  semen: Maybe<Semen>;
  semenComment: Maybe<Scalars['String']['output']>;
  semenId: Maybe<Scalars['UUID']['output']>;
  semenLocation: Maybe<StorageLocation>;
  semenLocationId: Maybe<Scalars['UUID']['output']>;
  semenOwner: Maybe<Account>;
  semenOwnerId: Maybe<Scalars['UUID']['output']>;
  semenPrice: Maybe<Scalars['Decimal']['output']>;
  semenReleased: Maybe<Scalars['Boolean']['output']>;
  semenType: Maybe<Scalars['Int']['output']>;
  semenTypeValue: Maybe<Scalars['String']['output']>;
  separateFert: Maybe<Scalars['Boolean']['output']>;
  ship: Maybe<Scalars['Int']['output']>;
  shipGroup: Maybe<Scalars['String']['output']>;
  shipInstructions: Maybe<Scalars['String']['output']>;
  shipToFbd: Maybe<Scalars['String']['output']>;
  shipmentGroup: Maybe<ShipmentGroup>;
  shipmentGroupId: Maybe<Scalars['UUID']['output']>;
  sire: Maybe<Sire>;
  sireId: Maybe<Scalars['UUID']['output']>;
  sireSelectionRequest: Maybe<SireSelectionRequest>;
  sireSelectionRequestId: Maybe<Scalars['UUID']['output']>;
  siteCapacity: Maybe<Scalars['Int']['output']>;
  soSchedule: Maybe<SuperOvulationSchedule>;
  soScheduleId: Maybe<Scalars['UUID']['output']>;
  soSchedules: Maybe<Array<SuperOvulationSchedule>>;
  specialBilling: Maybe<Scalars['Int']['output']>;
  specialInstructions: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  suggestedSemenMove: Maybe<Scalars['Int']['output']>;
  targetTime: Maybe<Scalars['Boolean']['output']>;
  textingAccount: Maybe<Account>;
  textingAccountId: Maybe<Scalars['UUID']['output']>;
  textingNumber: Maybe<Scalars['String']['output']>;
  transfer: Maybe<Scalars['Int']['output']>;
  tt: Maybe<Scalars['Boolean']['output']>;
  validationMessage: Maybe<Scalars['String']['output']>;
  validationSts: Maybe<Scalars['Int']['output']>;
  versionNumber: Maybe<Array<Scalars['UnsignedByte']['output']>>;
  week: Maybe<Scalars['Int']['output']>;
};


export type DonorScheduleannotationsArgs = {
  order: InputMaybe<Array<AnnotationSortInput>>;
  where: InputMaybe<AnnotationFilterInput>;
};

export type DonorScheduleFilterInput = {
  accountComment?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<DonorScheduleFilterInput>>;
  aspirationSite?: InputMaybe<SiteFilterInput>;
  aspirationSiteId?: InputMaybe<UuidOperationFilterInput>;
  backupCsrId?: InputMaybe<UuidOperationFilterInput>;
  backupSemen?: InputMaybe<SemenFilterInput>;
  backupSemenId?: InputMaybe<UuidOperationFilterInput>;
  backupSemenType?: InputMaybe<IntOperationFilterInput>;
  backupSire?: InputMaybe<SireFilterInput>;
  backupSireId?: InputMaybe<UuidOperationFilterInput>;
  billAccountCaningOption?: InputMaybe<IntOperationFilterInput>;
  billDrugs?: InputMaybe<BooleanOperationFilterInput>;
  billingAccount?: InputMaybe<AccountFilterInput>;
  billingAccountId?: InputMaybe<UuidOperationFilterInput>;
  billingComment?: InputMaybe<StringOperationFilterInput>;
  cane?: InputMaybe<StringOperationFilterInput>;
  clinicRanchHaulIn?: InputMaybe<IntOperationFilterInput>;
  colCode?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  contact?: InputMaybe<StringOperationFilterInput>;
  contractSemen?: InputMaybe<BooleanOperationFilterInput>;
  createSOAuto?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdByApp?: InputMaybe<IntOperationFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  creditRebill?: InputMaybe<BooleanOperationFilterInput>;
  critical?: InputMaybe<IntOperationFilterInput>;
  csr?: InputMaybe<SystemUserFilterInput>;
  csrId?: InputMaybe<UuidOperationFilterInput>;
  csrfrztrf?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  day7pickup?: InputMaybe<IntOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorComment?: InputMaybe<StringOperationFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  donorLocation?: InputMaybe<StringOperationFilterInput>;
  dow?: InputMaybe<StringOperationFilterInput>;
  drug?: InputMaybe<DrugFilterInput>;
  drug2?: InputMaybe<DrugFilterInput>;
  drugShippingFee?: InputMaybe<IntOperationFilterInput>;
  drugStatus?: InputMaybe<IntOperationFilterInput>;
  embryoComment?: InputMaybe<StringOperationFilterInput>;
  expectedSemenQty?: InputMaybe<IntOperationFilterInput>;
  export?: InputMaybe<IntOperationFilterInput>;
  fertilizationSite?: InputMaybe<SiteFilterInput>;
  fertilizationSiteId?: InputMaybe<UuidOperationFilterInput>;
  fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  flexFieldPartner?: InputMaybe<StringOperationFilterInput>;
  freeze?: InputMaybe<IntOperationFilterInput>;
  freezeInstructions?: InputMaybe<StringOperationFilterInput>;
  freezeMethod?: InputMaybe<OptionSetFilterInput>;
  freezeMethodId?: InputMaybe<UuidOperationFilterInput>;
  freshShipmentComments?: InputMaybe<StringOperationFilterInput>;
  fsh2Id?: InputMaybe<UuidOperationFilterInput>;
  fshId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  implantType?: InputMaybe<IntOperationFilterInput>;
  ivfLabSemen?: InputMaybe<SemenFilterInput>;
  ivfLabSemenId?: InputMaybe<UuidOperationFilterInput>;
  loadDonorPartners?: InputMaybe<IntOperationFilterInput>;
  loadDonorPartnersfrz?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  naab?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nonEUCountry?: InputMaybe<IntOperationFilterInput>;
  notify?: InputMaybe<BooleanOperationFilterInput>;
  oocyteShipping?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DonorScheduleFilterInput>>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  parity?: InputMaybe<IntOperationFilterInput>;
  partnerships?: InputMaybe<ListFilterInputTypeOfPartnershipFilterInput>;
  pool?: InputMaybe<BooleanOperationFilterInput>;
  pregnant?: InputMaybe<IntOperationFilterInput>;
  priority?: InputMaybe<IntOperationFilterInput>;
  procedureTime?: InputMaybe<IntOperationFilterInput>;
  procedureTimeComment?: InputMaybe<StringOperationFilterInput>;
  programName?: InputMaybe<StringOperationFilterInput>;
  revision?: InputMaybe<StringOperationFilterInput>;
  revisionComment?: InputMaybe<StringOperationFilterInput>;
  scheduleMaster?: InputMaybe<ScheduleMasterFilterInput>;
  scheduleMasterId?: InputMaybe<UuidOperationFilterInput>;
  scheduleStatus?: InputMaybe<StringOperationFilterInput>;
  scheduled?: InputMaybe<BooleanOperationFilterInput>;
  semen?: InputMaybe<SemenFilterInput>;
  semenComment?: InputMaybe<StringOperationFilterInput>;
  semenId?: InputMaybe<UuidOperationFilterInput>;
  semenLocation?: InputMaybe<StorageLocationFilterInput>;
  semenLocationId?: InputMaybe<UuidOperationFilterInput>;
  semenOwner?: InputMaybe<AccountFilterInput>;
  semenOwnerId?: InputMaybe<UuidOperationFilterInput>;
  semenPrice?: InputMaybe<DecimalOperationFilterInput>;
  semenReleased?: InputMaybe<BooleanOperationFilterInput>;
  semenType?: InputMaybe<IntOperationFilterInput>;
  separateFert?: InputMaybe<BooleanOperationFilterInput>;
  ship?: InputMaybe<IntOperationFilterInput>;
  shipGroup?: InputMaybe<StringOperationFilterInput>;
  shipInstructions?: InputMaybe<StringOperationFilterInput>;
  shipToFbd?: InputMaybe<StringOperationFilterInput>;
  shipmentGroup?: InputMaybe<ShipmentGroupFilterInput>;
  shipmentGroupId?: InputMaybe<UuidOperationFilterInput>;
  sire?: InputMaybe<SireFilterInput>;
  sireId?: InputMaybe<UuidOperationFilterInput>;
  sireSelectionRequest?: InputMaybe<SireSelectionRequestFilterInput>;
  sireSelectionRequestId?: InputMaybe<UuidOperationFilterInput>;
  siteCapacity?: InputMaybe<IntOperationFilterInput>;
  soSchedule?: InputMaybe<SuperOvulationScheduleFilterInput>;
  soScheduleId?: InputMaybe<UuidOperationFilterInput>;
  soSchedules?: InputMaybe<ListFilterInputTypeOfSuperOvulationScheduleFilterInput>;
  specialBilling?: InputMaybe<IntOperationFilterInput>;
  specialInstructions?: InputMaybe<StringOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  suggestedSemenMove?: InputMaybe<IntOperationFilterInput>;
  targetTime?: InputMaybe<BooleanOperationFilterInput>;
  textingAccount?: InputMaybe<AccountFilterInput>;
  textingAccountId?: InputMaybe<UuidOperationFilterInput>;
  textingNumber?: InputMaybe<StringOperationFilterInput>;
  transfer?: InputMaybe<IntOperationFilterInput>;
  tt?: InputMaybe<BooleanOperationFilterInput>;
  validationMessage?: InputMaybe<StringOperationFilterInput>;
  validationSts?: InputMaybe<IntOperationFilterInput>;
  versionNumber?: InputMaybe<ListUnsignedByteOperationFilterInput>;
  week?: InputMaybe<IntOperationFilterInput>;
};

export type DonorScheduleInput = {
  accountComment?: InputMaybe<Scalars['String']['input']>;
  aspirationSite?: InputMaybe<SiteInput>;
  aspirationSiteId?: InputMaybe<Scalars['UUID']['input']>;
  backupCsrId?: InputMaybe<Scalars['UUID']['input']>;
  backupSemen?: InputMaybe<SemenInput>;
  backupSemenId?: InputMaybe<Scalars['UUID']['input']>;
  backupSemenType?: InputMaybe<Scalars['Int']['input']>;
  backupSire?: InputMaybe<SireInput>;
  backupSireId?: InputMaybe<Scalars['UUID']['input']>;
  billAccountCaningOption?: InputMaybe<Scalars['Int']['input']>;
  billDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  billingAccount?: InputMaybe<AccountInput>;
  billingAccountId?: InputMaybe<Scalars['UUID']['input']>;
  billingComment?: InputMaybe<Scalars['String']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  clinicRanchHaulIn?: InputMaybe<Scalars['Int']['input']>;
  colCode?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  contractSemen?: InputMaybe<Scalars['Boolean']['input']>;
  createSOAuto?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdByApp?: InputMaybe<Scalars['Int']['input']>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  creditRebill?: InputMaybe<Scalars['Boolean']['input']>;
  critical?: InputMaybe<Scalars['Int']['input']>;
  csr?: InputMaybe<SystemUserInput>;
  csrId?: InputMaybe<Scalars['UUID']['input']>;
  csrfrztrf?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  day7pickup?: InputMaybe<Scalars['Int']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorComment?: InputMaybe<Scalars['String']['input']>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorLocation?: InputMaybe<Scalars['String']['input']>;
  dow?: InputMaybe<Scalars['String']['input']>;
  drug?: InputMaybe<DrugInput>;
  drug2?: InputMaybe<DrugInput>;
  drugShippingFee?: InputMaybe<Scalars['Int']['input']>;
  drugStatus?: InputMaybe<Scalars['Int']['input']>;
  embryoComment?: InputMaybe<Scalars['String']['input']>;
  expectedSemenQty?: InputMaybe<Scalars['Int']['input']>;
  export?: InputMaybe<Scalars['Int']['input']>;
  fertilizationSite?: InputMaybe<SiteInput>;
  fertilizationSiteId?: InputMaybe<Scalars['UUID']['input']>;
  fertilizations?: InputMaybe<Array<FertilizationInput>>;
  flexFieldPartner?: InputMaybe<Scalars['String']['input']>;
  freeze?: InputMaybe<Scalars['Int']['input']>;
  freezeInstructions?: InputMaybe<Scalars['String']['input']>;
  freezeMethod?: InputMaybe<OptionSetInput>;
  freezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  freshShipmentComments?: InputMaybe<Scalars['String']['input']>;
  fsh2Id?: InputMaybe<Scalars['UUID']['input']>;
  fshId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  implantType?: InputMaybe<Scalars['Int']['input']>;
  ivfLabSemen?: InputMaybe<SemenInput>;
  ivfLabSemenId?: InputMaybe<Scalars['UUID']['input']>;
  loadDonorPartners?: InputMaybe<Scalars['Int']['input']>;
  loadDonorPartnersfrz?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  naab?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonEUCountry?: InputMaybe<Scalars['Int']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  oocyteShipping?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  parity?: InputMaybe<Scalars['Int']['input']>;
  partnerships?: InputMaybe<Array<PartnershipInput>>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  pregnant?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  procedureTime?: InputMaybe<Scalars['Int']['input']>;
  procedureTimeComment?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  revisionComment?: InputMaybe<Scalars['String']['input']>;
  scheduleMaster?: InputMaybe<ScheduleMasterInput>;
  scheduleMasterId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleStatus?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  semen?: InputMaybe<SemenInput>;
  semenComment?: InputMaybe<Scalars['String']['input']>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  semenLocation?: InputMaybe<StorageLocationInput>;
  semenLocationId?: InputMaybe<Scalars['UUID']['input']>;
  semenOwner?: InputMaybe<AccountInput>;
  semenOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  semenPrice?: InputMaybe<Scalars['Decimal']['input']>;
  semenReleased?: InputMaybe<Scalars['Boolean']['input']>;
  semenType?: InputMaybe<Scalars['Int']['input']>;
  separateFert?: InputMaybe<Scalars['Boolean']['input']>;
  ship?: InputMaybe<Scalars['Int']['input']>;
  shipGroup?: InputMaybe<Scalars['String']['input']>;
  shipInstructions?: InputMaybe<Scalars['String']['input']>;
  shipToFbd?: InputMaybe<Scalars['String']['input']>;
  shipmentGroup?: InputMaybe<ShipmentGroupInput>;
  shipmentGroupId?: InputMaybe<Scalars['UUID']['input']>;
  sire?: InputMaybe<SireInput>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  sireSelectionRequest?: InputMaybe<SireSelectionRequestInput>;
  sireSelectionRequestId?: InputMaybe<Scalars['UUID']['input']>;
  siteCapacity?: InputMaybe<Scalars['Int']['input']>;
  soSchedule?: InputMaybe<SuperOvulationScheduleInput>;
  soScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  soSchedules?: InputMaybe<Array<SuperOvulationScheduleInput>>;
  specialBilling?: InputMaybe<Scalars['Int']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  suggestedSemenMove?: InputMaybe<Scalars['Int']['input']>;
  targetTime?: InputMaybe<Scalars['Boolean']['input']>;
  textingAccount?: InputMaybe<AccountInput>;
  textingAccountId?: InputMaybe<Scalars['UUID']['input']>;
  textingNumber?: InputMaybe<Scalars['String']['input']>;
  transfer?: InputMaybe<Scalars['Int']['input']>;
  tt?: InputMaybe<Scalars['Boolean']['input']>;
  validationMessage?: InputMaybe<Scalars['String']['input']>;
  validationSts?: InputMaybe<Scalars['Int']['input']>;
  versionNumber?: InputMaybe<Array<Scalars['UnsignedByte']['input']>>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export type DonorScheduleSortInput = {
  accountComment?: InputMaybe<SortEnumType>;
  aspirationSite?: InputMaybe<SiteSortInput>;
  aspirationSiteId?: InputMaybe<SortEnumType>;
  backupCsrId?: InputMaybe<SortEnumType>;
  backupSemen?: InputMaybe<SemenSortInput>;
  backupSemenId?: InputMaybe<SortEnumType>;
  backupSemenType?: InputMaybe<SortEnumType>;
  backupSire?: InputMaybe<SireSortInput>;
  backupSireId?: InputMaybe<SortEnumType>;
  billAccountCaningOption?: InputMaybe<SortEnumType>;
  billDrugs?: InputMaybe<SortEnumType>;
  billingAccount?: InputMaybe<AccountSortInput>;
  billingAccountId?: InputMaybe<SortEnumType>;
  billingComment?: InputMaybe<SortEnumType>;
  cane?: InputMaybe<SortEnumType>;
  clinicRanchHaulIn?: InputMaybe<SortEnumType>;
  colCode?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  contact?: InputMaybe<SortEnumType>;
  contractSemen?: InputMaybe<SortEnumType>;
  createSOAuto?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdByApp?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  creditRebill?: InputMaybe<SortEnumType>;
  critical?: InputMaybe<SortEnumType>;
  csr?: InputMaybe<SystemUserSortInput>;
  csrId?: InputMaybe<SortEnumType>;
  csrfrztrf?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  day7pickup?: InputMaybe<SortEnumType>;
  donor?: InputMaybe<DonorSortInput>;
  donorComment?: InputMaybe<SortEnumType>;
  donorId?: InputMaybe<SortEnumType>;
  donorLocation?: InputMaybe<SortEnumType>;
  dow?: InputMaybe<SortEnumType>;
  drug?: InputMaybe<DrugSortInput>;
  drug2?: InputMaybe<DrugSortInput>;
  drugShippingFee?: InputMaybe<SortEnumType>;
  drugStatus?: InputMaybe<SortEnumType>;
  embryoComment?: InputMaybe<SortEnumType>;
  expectedSemenQty?: InputMaybe<SortEnumType>;
  export?: InputMaybe<SortEnumType>;
  fertilizationSite?: InputMaybe<SiteSortInput>;
  fertilizationSiteId?: InputMaybe<SortEnumType>;
  flexFieldPartner?: InputMaybe<SortEnumType>;
  freeze?: InputMaybe<SortEnumType>;
  freezeInstructions?: InputMaybe<SortEnumType>;
  freezeMethod?: InputMaybe<OptionSetSortInput>;
  freezeMethodId?: InputMaybe<SortEnumType>;
  freshShipmentComments?: InputMaybe<SortEnumType>;
  fsh2Id?: InputMaybe<SortEnumType>;
  fshId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  implantType?: InputMaybe<SortEnumType>;
  ivfLabSemen?: InputMaybe<SemenSortInput>;
  ivfLabSemenId?: InputMaybe<SortEnumType>;
  loadDonorPartners?: InputMaybe<SortEnumType>;
  loadDonorPartnersfrz?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  naab?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  nonEUCountry?: InputMaybe<SortEnumType>;
  notify?: InputMaybe<SortEnumType>;
  oocyteShipping?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  parity?: InputMaybe<SortEnumType>;
  pool?: InputMaybe<SortEnumType>;
  pregnant?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  procedureTime?: InputMaybe<SortEnumType>;
  procedureTimeComment?: InputMaybe<SortEnumType>;
  programName?: InputMaybe<SortEnumType>;
  revision?: InputMaybe<SortEnumType>;
  revisionComment?: InputMaybe<SortEnumType>;
  scheduleMaster?: InputMaybe<ScheduleMasterSortInput>;
  scheduleMasterId?: InputMaybe<SortEnumType>;
  scheduleStatus?: InputMaybe<SortEnumType>;
  scheduled?: InputMaybe<SortEnumType>;
  semen?: InputMaybe<SemenSortInput>;
  semenComment?: InputMaybe<SortEnumType>;
  semenId?: InputMaybe<SortEnumType>;
  semenLocation?: InputMaybe<StorageLocationSortInput>;
  semenLocationId?: InputMaybe<SortEnumType>;
  semenOwner?: InputMaybe<AccountSortInput>;
  semenOwnerId?: InputMaybe<SortEnumType>;
  semenPrice?: InputMaybe<SortEnumType>;
  semenReleased?: InputMaybe<SortEnumType>;
  semenType?: InputMaybe<SortEnumType>;
  separateFert?: InputMaybe<SortEnumType>;
  ship?: InputMaybe<SortEnumType>;
  shipGroup?: InputMaybe<SortEnumType>;
  shipInstructions?: InputMaybe<SortEnumType>;
  shipToFbd?: InputMaybe<SortEnumType>;
  shipmentGroup?: InputMaybe<ShipmentGroupSortInput>;
  shipmentGroupId?: InputMaybe<SortEnumType>;
  sire?: InputMaybe<SireSortInput>;
  sireId?: InputMaybe<SortEnumType>;
  sireSelectionRequest?: InputMaybe<SireSelectionRequestSortInput>;
  sireSelectionRequestId?: InputMaybe<SortEnumType>;
  siteCapacity?: InputMaybe<SortEnumType>;
  soSchedule?: InputMaybe<SuperOvulationScheduleSortInput>;
  soScheduleId?: InputMaybe<SortEnumType>;
  specialBilling?: InputMaybe<SortEnumType>;
  specialInstructions?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  suggestedSemenMove?: InputMaybe<SortEnumType>;
  targetTime?: InputMaybe<SortEnumType>;
  textingAccount?: InputMaybe<AccountSortInput>;
  textingAccountId?: InputMaybe<SortEnumType>;
  textingNumber?: InputMaybe<SortEnumType>;
  transfer?: InputMaybe<SortEnumType>;
  tt?: InputMaybe<SortEnumType>;
  validationMessage?: InputMaybe<SortEnumType>;
  validationSts?: InputMaybe<SortEnumType>;
  week?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type DonorSchedulesCollectionSegment = {
  __typename: 'DonorSchedulesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<DonorSchedule>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type DonorSchedulesPayload = {
  __typename: 'DonorSchedulesPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** The tog_donorscheduleBase table that contains the newly added donor schedule. */
  donorSchedules: Maybe<Array<DonorSchedule>>;
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type DonorSortInput = {
  activityDate?: InputMaybe<SortEnumType>;
  birth?: InputMaybe<SortEnumType>;
  blood?: InputMaybe<SortEnumType>;
  breed?: InputMaybe<BreedSortInput>;
  breedId?: InputMaybe<SortEnumType>;
  breedPct?: InputMaybe<SortEnumType>;
  calf?: InputMaybe<SortEnumType>;
  calfSex?: InputMaybe<SortEnumType>;
  calfType?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  cemMergeXml?: InputMaybe<SortEnumType>;
  cfTogId?: InputMaybe<SortEnumType>;
  cm?: InputMaybe<SortEnumType>;
  cod?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  condition?: InputMaybe<SortEnumType>;
  consolidatedHealthStatus?: InputMaybe<SortEnumType>;
  contract?: InputMaybe<SortEnumType>;
  countryCodeId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  dam?: InputMaybe<SortEnumType>;
  damReg?: InputMaybe<SortEnumType>;
  damSire?: InputMaybe<SortEnumType>;
  damSrReg?: InputMaybe<SortEnumType>;
  destination?: InputMaybe<SortEnumType>;
  discontinueIvf?: InputMaybe<SortEnumType>;
  dnaBarcode?: InputMaybe<SortEnumType>;
  dnaReceived?: InputMaybe<SortEnumType>;
  dnaSent?: InputMaybe<SortEnumType>;
  donorGroup?: InputMaybe<SortEnumType>;
  donorName?: InputMaybe<SortEnumType>;
  edonorClientId?: InputMaybe<SortEnumType>;
  edonorId?: InputMaybe<SortEnumType>;
  embryoPlan?: InputMaybe<SortEnumType>;
  exportDonor?: InputMaybe<SortEnumType>;
  flexFieldPartner?: InputMaybe<SortEnumType>;
  freezeInstructions?: InputMaybe<SortEnumType>;
  grp?: InputMaybe<SortEnumType>;
  hairSample?: InputMaybe<SortEnumType>;
  healthStatus?: InputMaybe<SortEnumType>;
  heiferCow?: InputMaybe<SortEnumType>;
  housing?: InputMaybe<OptionSetSortInput>;
  housingId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itComm?: InputMaybe<SortEnumType>;
  ivfStatus?: InputMaybe<OptionSetSortInput>;
  ivfStatusId?: InputMaybe<SortEnumType>;
  jpi?: InputMaybe<SortEnumType>;
  lastActivity?: InputMaybe<SortEnumType>;
  lastAspirationOn?: InputMaybe<SortEnumType>;
  lastBred?: InputMaybe<SortEnumType>;
  lastBredSire?: InputMaybe<SireSortInput>;
  lastBredSireId?: InputMaybe<SortEnumType>;
  lastFetalSex?: InputMaybe<SortEnumType>;
  lastFlush?: InputMaybe<SortEnumType>;
  lastHeat?: InputMaybe<SortEnumType>;
  leaseOrigin?: InputMaybe<AccountSortInput>;
  leaseOriginId?: InputMaybe<SortEnumType>;
  liveCalf?: InputMaybe<SortEnumType>;
  lopuCalf?: InputMaybe<SortEnumType>;
  metalTag?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  nm?: InputMaybe<SortEnumType>;
  numCalves?: InputMaybe<SortEnumType>;
  ocvStatus?: InputMaybe<OptionSetSortInput>;
  ocvStatusId?: InputMaybe<SortEnumType>;
  onFarm?: InputMaybe<SortEnumType>;
  opuProgram?: InputMaybe<SortEnumType>;
  origin?: InputMaybe<SortEnumType>;
  ourTag?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  pairedCalf?: InputMaybe<DonorSortInput>;
  pairedCalfId?: InputMaybe<SortEnumType>;
  pedName?: InputMaybe<SortEnumType>;
  pedigree?: InputMaybe<SortEnumType>;
  pooledDonor?: InputMaybe<DonorSortInput>;
  pooledDonorId?: InputMaybe<SortEnumType>;
  pregnant?: InputMaybe<SortEnumType>;
  programName?: InputMaybe<SortEnumType>;
  psi?: InputMaybe<SortEnumType>;
  ranchTag?: InputMaybe<SortEnumType>;
  received?: InputMaybe<SortEnumType>;
  regPrefix?: InputMaybe<SortEnumType>;
  registrationNumber?: InputMaybe<SortEnumType>;
  ship?: InputMaybe<SortEnumType>;
  shipment?: InputMaybe<ShipmentSortInput>;
  shipmentId?: InputMaybe<SortEnumType>;
  shipmentPlan?: InputMaybe<SortEnumType>;
  sire?: InputMaybe<SortEnumType>;
  sireReg?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<OptionSetSortInput>;
  statusCode?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  tattoo?: InputMaybe<SortEnumType>;
  togId?: InputMaybe<SortEnumType>;
  tpi?: InputMaybe<SortEnumType>;
  weight?: InputMaybe<SortEnumType>;
  yard?: InputMaybe<YardSortInput>;
  yardBeforeChangeId?: InputMaybe<SortEnumType>;
  yardId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type DonorsCollectionSegment = {
  __typename: 'DonorsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Donor>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Drug = {
  __typename: 'Drug';
  comp: Maybe<Scalars['String']['output']>;
  companyId: Scalars['UUID']['output'];
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  importSequenceNumber: Maybe<Scalars['Int']['output']>;
  lot: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  overriddenCreatedOn: Maybe<Scalars['DateTime']['output']>;
  pricePerBottle: Maybe<Scalars['Decimal']['output']>;
  pricePerCc: Maybe<Scalars['Decimal']['output']>;
  searchName: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  timeZoneRuleVersionNumber: Maybe<Scalars['Int']['output']>;
  utcConversionTimeZoneCode: Maybe<Scalars['Int']['output']>;
  versionNumber: Maybe<Scalars['String']['output']>;
};

export type DrugFilterInput = {
  and?: InputMaybe<Array<DrugFilterInput>>;
  comp?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  importSequenceNumber?: InputMaybe<IntOperationFilterInput>;
  lot?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DrugFilterInput>>;
  overriddenCreatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  pricePerBottle?: InputMaybe<DecimalOperationFilterInput>;
  pricePerCc?: InputMaybe<DecimalOperationFilterInput>;
  searchName?: InputMaybe<StringOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  timeZoneRuleVersionNumber?: InputMaybe<IntOperationFilterInput>;
  utcConversionTimeZoneCode?: InputMaybe<IntOperationFilterInput>;
  versionNumber?: InputMaybe<StringOperationFilterInput>;
};

export type DrugInput = {
  comp?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['UUID']['input'];
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  importSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  lot?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overriddenCreatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  pricePerBottle?: InputMaybe<Scalars['Decimal']['input']>;
  pricePerCc?: InputMaybe<Scalars['Decimal']['input']>;
  searchName?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  timeZoneRuleVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  utcConversionTimeZoneCode?: InputMaybe<Scalars['Int']['input']>;
  versionNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DrugSortInput = {
  comp?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importSequenceNumber?: InputMaybe<SortEnumType>;
  lot?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  overriddenCreatedOn?: InputMaybe<SortEnumType>;
  pricePerBottle?: InputMaybe<SortEnumType>;
  pricePerCc?: InputMaybe<SortEnumType>;
  searchName?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  timeZoneRuleVersionNumber?: InputMaybe<SortEnumType>;
  utcConversionTimeZoneCode?: InputMaybe<SortEnumType>;
  versionNumber?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type DrugsCollectionSegment = {
  __typename: 'DrugsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Drug>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EditBulkDonorScheduleInput = {
  accountComment?: InputMaybe<Scalars['String']['input']>;
  annotation?: InputMaybe<Scalars['String']['input']>;
  aspirationSiteId?: InputMaybe<Scalars['UUID']['input']>;
  backupCsrId?: InputMaybe<Scalars['UUID']['input']>;
  backupSemenId?: InputMaybe<Scalars['UUID']['input']>;
  backupSemenType?: InputMaybe<Scalars['Int']['input']>;
  backupSireId?: InputMaybe<Scalars['UUID']['input']>;
  billAccountCaningOption?: InputMaybe<Scalars['Int']['input']>;
  billDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  billingAccountId?: InputMaybe<Scalars['UUID']['input']>;
  billingComment?: InputMaybe<Scalars['String']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  clinicRanchHaulIn?: InputMaybe<Scalars['Int']['input']>;
  colCode?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  contractSemen?: InputMaybe<Scalars['Boolean']['input']>;
  createSOAuto?: InputMaybe<Scalars['Int']['input']>;
  createdByApp?: InputMaybe<Scalars['Int']['input']>;
  creditRebill?: InputMaybe<Scalars['Boolean']['input']>;
  critical?: InputMaybe<Scalars['Int']['input']>;
  csrId?: InputMaybe<Scalars['UUID']['input']>;
  csrfrztrf?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  day7pickup?: InputMaybe<Scalars['Int']['input']>;
  donorComment?: InputMaybe<Scalars['String']['input']>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorLocation?: InputMaybe<Scalars['String']['input']>;
  dow?: InputMaybe<Scalars['String']['input']>;
  drug2?: InputMaybe<Scalars['String']['input']>;
  drugShippingFee?: InputMaybe<Scalars['Int']['input']>;
  drugStatus?: InputMaybe<Scalars['Int']['input']>;
  embryoComment?: InputMaybe<Scalars['String']['input']>;
  expectedSemenQty?: InputMaybe<Scalars['Int']['input']>;
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  export?: InputMaybe<Scalars['Int']['input']>;
  fertilizationId?: InputMaybe<Scalars['UUID']['input']>;
  fertilizationSiteId?: InputMaybe<Scalars['UUID']['input']>;
  flexFieldPartner?: InputMaybe<Scalars['String']['input']>;
  freeze?: InputMaybe<Scalars['Int']['input']>;
  freezeInstructions?: InputMaybe<Scalars['String']['input']>;
  freezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  fsh2Id?: InputMaybe<Scalars['UUID']['input']>;
  fshId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  implantType?: InputMaybe<Scalars['Int']['input']>;
  ivfLabSemenId?: InputMaybe<Scalars['UUID']['input']>;
  loadDonorPartners?: InputMaybe<Scalars['Int']['input']>;
  loadDonorPartnersfrz?: InputMaybe<Scalars['Int']['input']>;
  naab?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonEUCountry?: InputMaybe<Scalars['Int']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  oocyteShipping?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  parity?: InputMaybe<Scalars['Int']['input']>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  pregnant?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  procedureTime?: InputMaybe<Scalars['Int']['input']>;
  procedureTimeComment?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  revisionComment?: InputMaybe<Scalars['String']['input']>;
  scheduleMasterId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleStatus?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  semenComment?: InputMaybe<Scalars['String']['input']>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  semenLocationId?: InputMaybe<Scalars['UUID']['input']>;
  semenOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  semenPrice?: InputMaybe<Scalars['Decimal']['input']>;
  semenReleased?: InputMaybe<Scalars['Boolean']['input']>;
  semenType?: InputMaybe<Scalars['Int']['input']>;
  separateFert?: InputMaybe<Scalars['Boolean']['input']>;
  ship?: InputMaybe<Scalars['Int']['input']>;
  shipGroup?: InputMaybe<Scalars['String']['input']>;
  shipInstructions?: InputMaybe<Scalars['String']['input']>;
  shipToFbd?: InputMaybe<Scalars['String']['input']>;
  shipmentGroupId?: InputMaybe<Scalars['UUID']['input']>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  sireSelectionRequestId?: InputMaybe<Scalars['UUID']['input']>;
  soScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  specialBilling?: InputMaybe<Scalars['Int']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  suggestedSemenMove?: InputMaybe<Scalars['Int']['input']>;
  targetTime?: InputMaybe<Scalars['Boolean']['input']>;
  textingAccountId?: InputMaybe<Scalars['UUID']['input']>;
  textingNumber?: InputMaybe<Scalars['String']['input']>;
  transfer?: InputMaybe<Scalars['Int']['input']>;
  tt?: InputMaybe<Scalars['Boolean']['input']>;
  validationMessage?: InputMaybe<Scalars['String']['input']>;
  validationSts?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export type Embryo = {
  __typename: 'Embryo';
  abort: Maybe<Scalars['Int']['output']>;
  accountType: Maybe<Scalars['Int']['output']>;
  additionalEmbryoImplant: Maybe<Scalars['Boolean']['output']>;
  approvalNumber: TOG_FacilityApprovalNumbersBase;
  approvalNumberId: Maybe<Scalars['UUID']['output']>;
  betaCasein: Maybe<Scalars['String']['output']>;
  billStatusCrt: Maybe<Scalars['Int']['output']>;
  billStatusImp: Maybe<Scalars['Int']['output']>;
  billingOwner: Maybe<Account>;
  billingOwnerId: Maybe<Scalars['UUID']['output']>;
  breed: Maybe<Breed>;
  breedId: Maybe<Scalars['UUID']['output']>;
  calfSex: Maybe<Scalars['Int']['output']>;
  calfType: Maybe<Scalars['Int']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  cellId: Maybe<Scalars['String']['output']>;
  cellLineId: Maybe<Scalars['UUID']['output']>;
  clientRecipient: Maybe<Scalars['String']['output']>;
  clinic: Maybe<Scalars['Int']['output']>;
  clinicRanchHaulIn: Maybe<Scalars['Int']['output']>;
  comm: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  crackedZona: Maybe<Scalars['Boolean']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  creation: Maybe<Scalars['DateTime']['output']>;
  dairyCompEmbryoId: Maybe<Scalars['Int']['output']>;
  dateUsed: Maybe<Scalars['DateTime']['output']>;
  dist: Maybe<Scalars['Int']['output']>;
  donor: Maybe<Donor>;
  donorAge: Maybe<Scalars['String']['output']>;
  donorCheeseMerit: Maybe<Scalars['Int']['output']>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorJpi: Maybe<Scalars['Int']['output']>;
  donorNetMerit: Maybe<Scalars['Int']['output']>;
  donorTpi: Maybe<Scalars['Int']['output']>;
  dtPlus: Maybe<Scalars['Boolean']['output']>;
  edonorId: Maybe<Scalars['String']['output']>;
  embTag: Maybe<Scalars['String']['output']>;
  embTagNumber: Maybe<Scalars['Int']['output']>;
  embryoOutsideEntryId: Maybe<Scalars['UUID']['output']>;
  embryoPa: Maybe<Scalars['Int']['output']>;
  embryoStagingId: Maybe<Scalars['Int']['output']>;
  equilibrationSolutionDate: Maybe<Scalars['DateTime']['output']>;
  estDueDate: Maybe<Scalars['DateTime']['output']>;
  estrusSync: Maybe<Scalars['Int']['output']>;
  estrusSyncNumber: Maybe<Scalars['Decimal']['output']>;
  exchangeRate: Maybe<Scalars['Decimal']['output']>;
  export: Maybe<Scalars['Int']['output']>;
  feeder: Maybe<Scalars['Int']['output']>;
  fertilization: Maybe<Fertilization>;
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  flexFieldPartners: Maybe<Scalars['String']['output']>;
  flshId: Maybe<Scalars['String']['output']>;
  flush: Maybe<Flush>;
  flushId: Maybe<Scalars['UUID']['output']>;
  flushIdNumber: Maybe<Scalars['Int']['output']>;
  freezeComment: Maybe<Scalars['String']['output']>;
  freezeMethod: Maybe<OptionSet>;
  freezeMethodId: Maybe<Scalars['UUID']['output']>;
  freezeTech: Maybe<Equipment>;
  freezeTechId: Maybe<Scalars['UUID']['output']>;
  freezeTechName: Maybe<Scalars['String']['output']>;
  freezeTime: Maybe<Scalars['String']['output']>;
  freezer: Maybe<Scalars['String']['output']>;
  freshFrozen: Maybe<Scalars['Int']['output']>;
  freshStrawNo: Maybe<Scalars['Int']['output']>;
  frozenGrade: Maybe<Scalars['Int']['output']>;
  frozenStage: Maybe<Scalars['Int']['output']>;
  gnrhUsedAtImplant: Maybe<Scalars['Boolean']['output']>;
  grade: Maybe<Scalars['Int']['output']>;
  grader7: Maybe<Equipment>;
  grader7Id: Maybe<Scalars['UUID']['output']>;
  grader7Name: Maybe<Scalars['String']['output']>;
  grader65: Maybe<Scalars['String']['output']>;
  group: Maybe<Scalars['Int']['output']>;
  hcgApplied: Maybe<Scalars['Int']['output']>;
  heat1: Maybe<Scalars['DateTime']['output']>;
  holsteinPtanetMerit: Maybe<Scalars['Int']['output']>;
  hornStatus: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  impId: Maybe<Scalars['Int']['output']>;
  implantBillingAccount: Maybe<Account>;
  implantBillingAccountId: Maybe<Scalars['UUID']['output']>;
  implantDate: Maybe<Scalars['DateTime']['output']>;
  implantStatusCode: Maybe<Scalars['Int']['output']>;
  implantStatusCodeValue: Maybe<Scalars['String']['output']>;
  jerseyPtanetMerit: Maybe<Scalars['Int']['output']>;
  jpi: Maybe<Scalars['Int']['output']>;
  kappaCasein: Maybe<Scalars['String']['output']>;
  label1: Maybe<Scalars['String']['output']>;
  label2: Maybe<Scalars['String']['output']>;
  lastAct: Maybe<Scalars['String']['output']>;
  loadBy: Maybe<Equipment>;
  loadById: Maybe<Scalars['UUID']['output']>;
  loadTime: Maybe<Scalars['String']['output']>;
  lowQuality: Maybe<Scalars['Boolean']['output']>;
  method: Maybe<Scalars['Int']['output']>;
  methodValue: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  oldOwner: Maybe<Account>;
  oldOwnerId: Maybe<Scalars['UUID']['output']>;
  oldStorageLocation: Maybe<StorageLocation>;
  oldStorageLocationId: Maybe<Scalars['UUID']['output']>;
  origin: Maybe<Scalars['String']['output']>;
  originalFreezeSite: Maybe<Site>;
  originalFreezeSiteId: Maybe<Scalars['UUID']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  pc1Date: Maybe<Scalars['DateTime']['output']>;
  pc1Res: Maybe<Scalars['Int']['output']>;
  pc2Date: Maybe<Scalars['DateTime']['output']>;
  pc2Res: Maybe<Scalars['Int']['output']>;
  pc3Date: Maybe<Scalars['DateTime']['output']>;
  pc3Res: Maybe<Scalars['Int']['output']>;
  pc4Date: Maybe<Scalars['DateTime']['output']>;
  pc4Res: Maybe<Scalars['Int']['output']>;
  pc5Date: Maybe<Scalars['DateTime']['output']>;
  pc5Res: Maybe<Scalars['Int']['output']>;
  pc6Date: Maybe<Scalars['DateTime']['output']>;
  pc6Res: Maybe<Scalars['Int']['output']>;
  pc7Date: Maybe<Scalars['DateTime']['output']>;
  pc7Res: Maybe<Scalars['Int']['output']>;
  pc8Date: Maybe<Scalars['DateTime']['output']>;
  pc8Res: Maybe<Scalars['Int']['output']>;
  pc9Date: Maybe<Scalars['DateTime']['output']>;
  pc9Res: Maybe<Scalars['Int']['output']>;
  plan1: Maybe<Scalars['String']['output']>;
  plan2: Maybe<Scalars['String']['output']>;
  plan3: Maybe<Scalars['String']['output']>;
  ppapy: Maybe<Scalars['Int']['output']>;
  preBook: Maybe<Scalars['Int']['output']>;
  price: Maybe<Scalars['Decimal']['output']>;
  probableDonorId: Maybe<Scalars['UUID']['output']>;
  probabledonor: Maybe<Donor>;
  profit: Maybe<Scalars['Int']['output']>;
  programName: Maybe<Scalars['String']['output']>;
  proj: Maybe<Scalars['String']['output']>;
  projd: Maybe<Scalars['String']['output']>;
  psi: Maybe<Scalars['Int']['output']>;
  qc12WellPlates: Maybe<Scalars['String']['output']>;
  qc12WellPlatesOld: Maybe<Scalars['Int']['output']>;
  qcEg10: Maybe<Scalars['String']['output']>;
  qcEg10Date: Maybe<Scalars['DateTime']['output']>;
  qcEmbHolding: Maybe<Scalars['String']['output']>;
  qcEmbHoldingExpDate: Maybe<Scalars['DateTime']['output']>;
  qcSterileStrawLotNumber: Maybe<Scalars['String']['output']>;
  qcStrawIncubatorNumber: Maybe<Scalars['String']['output']>;
  qcStrawLotNumber: Maybe<Scalars['String']['output']>;
  qcSucroseDate: Maybe<Scalars['DateTime']['output']>;
  qcThawThermosTemp: Maybe<Scalars['String']['output']>;
  qcTryPsInDate: Maybe<Scalars['DateTime']['output']>;
  qcVitStrawLotNumber: Maybe<Scalars['String']['output']>;
  qcehmDate: Maybe<Scalars['DateTime']['output']>;
  qcfreezingComment: Maybe<Scalars['String']['output']>;
  qual: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  ranchValue: Maybe<Scalars['Int']['output']>;
  recId: Maybe<Scalars['String']['output']>;
  recaned: Maybe<Scalars['Boolean']['output']>;
  receivedOn: Maybe<Scalars['DateTime']['output']>;
  recipBirthDate: Maybe<Scalars['DateTime']['output']>;
  recipBreed: Maybe<Breed>;
  recipBreedId: Maybe<Scalars['UUID']['output']>;
  recipCalvingDate: Maybe<Scalars['DateTime']['output']>;
  recipOwner: Maybe<Account>;
  recipOwnerId: Maybe<Scalars['UUID']['output']>;
  recipRegNum: Maybe<Scalars['String']['output']>;
  recipient: Maybe<Recipient>;
  recipientId: Maybe<Scalars['UUID']['output']>;
  recoveryFirmCode: Maybe<Scalars['String']['output']>;
  recoveryFirmName: Maybe<Scalars['String']['output']>;
  rightLeft: Maybe<Scalars['Int']['output']>;
  rightLeftHidden: Maybe<Scalars['String']['output']>;
  scHerdman: Maybe<Scalars['String']['output']>;
  scHnDate: Maybe<Scalars['DateTime']['output']>;
  scIpDate: Maybe<Scalars['DateTime']['output']>;
  scLastHeat: Maybe<Scalars['DateTime']['output']>;
  scPreviousHeat: Maybe<Scalars['DateTime']['output']>;
  scRpDate: Maybe<Scalars['DateTime']['output']>;
  scSyDate: Maybe<Scalars['DateTime']['output']>;
  semen: Maybe<Semen>;
  semenId: Maybe<Scalars['UUID']['output']>;
  sex: Maybe<Scalars['Int']['output']>;
  sexValue: Maybe<Scalars['String']['output']>;
  shipCity: Maybe<Scalars['String']['output']>;
  shipState: Maybe<Scalars['String']['output']>;
  shipToFbd: Maybe<Scalars['String']['output']>;
  shipment: Maybe<Shipment>;
  shipmentId: Maybe<Scalars['UUID']['output']>;
  sire: Maybe<Sire>;
  sireCheeseMerit: Maybe<Scalars['Int']['output']>;
  sireId: Maybe<Scalars['UUID']['output']>;
  sireJpi: Maybe<Scalars['Int']['output']>;
  sireNetMerit: Maybe<Scalars['Int']['output']>;
  sireTpi: Maybe<Scalars['Int']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  soldTo: Maybe<Scalars['String']['output']>;
  stage: Maybe<Scalars['Int']['output']>;
  stateCode: Scalars['Int']['output'];
  status: Maybe<Scalars['Int']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  statusValue: Maybe<Scalars['String']['output']>;
  stopId: Maybe<Scalars['Int']['output']>;
  storageLocation: Maybe<StorageLocation>;
  storageLocationId: Maybe<Scalars['UUID']['output']>;
  straw: Maybe<Scalars['String']['output']>;
  strawDisclaimer: Maybe<Scalars['String']['output']>;
  strawNumber: Maybe<Scalars['Int']['output']>;
  sync: Maybe<Scalars['String']['output']>;
  technician1: Maybe<Equipment>;
  technician1Id: Maybe<Scalars['UUID']['output']>;
  technician1Name: Maybe<Scalars['String']['output']>;
  technician2Name: Maybe<Scalars['String']['output']>;
  tempEmbryoId: Maybe<Scalars['String']['output']>;
  thawBy: Maybe<Equipment>;
  thawById: Maybe<Scalars['UUID']['output']>;
  thawByName: Maybe<Scalars['String']['output']>;
  thawMethodId: Maybe<Scalars['Int']['output']>;
  togId: Maybe<Scalars['Int']['output']>;
  tpi: Maybe<Scalars['Int']['output']>;
  transComment: Maybe<Scalars['String']['output']>;
  transactionCurrencyId: Maybe<Scalars['UUID']['output']>;
  transferDate: Maybe<Scalars['DateTime']['output']>;
  transferFarmLocation: Maybe<Equipment>;
  transferFarmLocationId: Maybe<Scalars['UUID']['output']>;
  transferPrice: Maybe<Scalars['Decimal']['output']>;
  transferPriceBase: Maybe<Scalars['Decimal']['output']>;
  transferTime: Maybe<Scalars['String']['output']>;
  tt: Maybe<Scalars['Boolean']['output']>;
  versionNumber: Maybe<Array<Scalars['UnsignedByte']['output']>>;
  vialId: Maybe<Scalars['String']['output']>;
  vitrificationSolutionDate: Maybe<Scalars['DateTime']['output']>;
};

export type EmbryoFilterInput = {
  abort?: InputMaybe<IntOperationFilterInput>;
  accountType?: InputMaybe<IntOperationFilterInput>;
  additionalEmbryoImplant?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmbryoFilterInput>>;
  approvalNumber?: InputMaybe<TOG_FacilityApprovalNumbersBaseFilterInput>;
  approvalNumberId?: InputMaybe<UuidOperationFilterInput>;
  betaCasein?: InputMaybe<StringOperationFilterInput>;
  billStatusCrt?: InputMaybe<IntOperationFilterInput>;
  billStatusImp?: InputMaybe<IntOperationFilterInput>;
  billingOwner?: InputMaybe<AccountFilterInput>;
  billingOwnerId?: InputMaybe<UuidOperationFilterInput>;
  breed?: InputMaybe<BreedFilterInput>;
  breedId?: InputMaybe<UuidOperationFilterInput>;
  calfSex?: InputMaybe<IntOperationFilterInput>;
  calfType?: InputMaybe<IntOperationFilterInput>;
  cane?: InputMaybe<StringOperationFilterInput>;
  cellId?: InputMaybe<StringOperationFilterInput>;
  cellLineId?: InputMaybe<UuidOperationFilterInput>;
  clientRecipient?: InputMaybe<StringOperationFilterInput>;
  clinic?: InputMaybe<IntOperationFilterInput>;
  clinicRanchHaulIn?: InputMaybe<IntOperationFilterInput>;
  comm?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  crackedZona?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  creation?: InputMaybe<DateTimeOperationFilterInput>;
  dairyCompEmbryoId?: InputMaybe<IntOperationFilterInput>;
  dateUsed?: InputMaybe<DateTimeOperationFilterInput>;
  dist?: InputMaybe<IntOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorAge?: InputMaybe<StringOperationFilterInput>;
  donorCheeseMerit?: InputMaybe<IntOperationFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  donorJpi?: InputMaybe<IntOperationFilterInput>;
  donorNetMerit?: InputMaybe<IntOperationFilterInput>;
  donorTpi?: InputMaybe<IntOperationFilterInput>;
  dtPlus?: InputMaybe<BooleanOperationFilterInput>;
  edonorId?: InputMaybe<StringOperationFilterInput>;
  embTag?: InputMaybe<StringOperationFilterInput>;
  embTagNumber?: InputMaybe<IntOperationFilterInput>;
  embryoOutsideEntryId?: InputMaybe<UuidOperationFilterInput>;
  embryoPa?: InputMaybe<IntOperationFilterInput>;
  embryoStagingId?: InputMaybe<IntOperationFilterInput>;
  equilibrationSolutionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estDueDate?: InputMaybe<DateTimeOperationFilterInput>;
  estrusSync?: InputMaybe<IntOperationFilterInput>;
  estrusSyncNumber?: InputMaybe<DecimalOperationFilterInput>;
  exchangeRate?: InputMaybe<DecimalOperationFilterInput>;
  export?: InputMaybe<IntOperationFilterInput>;
  feeder?: InputMaybe<IntOperationFilterInput>;
  fertilization?: InputMaybe<FertilizationFilterInput>;
  fertilizationId?: InputMaybe<UuidOperationFilterInput>;
  flexFieldPartners?: InputMaybe<StringOperationFilterInput>;
  flshId?: InputMaybe<StringOperationFilterInput>;
  flush?: InputMaybe<FlushFilterInput>;
  flushId?: InputMaybe<UuidOperationFilterInput>;
  flushIdNumber?: InputMaybe<IntOperationFilterInput>;
  freezeComment?: InputMaybe<StringOperationFilterInput>;
  freezeMethod?: InputMaybe<OptionSetFilterInput>;
  freezeMethodId?: InputMaybe<UuidOperationFilterInput>;
  freezeTech?: InputMaybe<EquipmentFilterInput>;
  freezeTechId?: InputMaybe<UuidOperationFilterInput>;
  freezeTechName?: InputMaybe<StringOperationFilterInput>;
  freezeTime?: InputMaybe<StringOperationFilterInput>;
  freezer?: InputMaybe<StringOperationFilterInput>;
  freshFrozen?: InputMaybe<IntOperationFilterInput>;
  freshStrawNo?: InputMaybe<IntOperationFilterInput>;
  frozenGrade?: InputMaybe<IntOperationFilterInput>;
  frozenStage?: InputMaybe<IntOperationFilterInput>;
  gnrhUsedAtImplant?: InputMaybe<BooleanOperationFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  grader7?: InputMaybe<EquipmentFilterInput>;
  grader7Id?: InputMaybe<UuidOperationFilterInput>;
  grader7Name?: InputMaybe<StringOperationFilterInput>;
  grader65?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<IntOperationFilterInput>;
  hcgApplied?: InputMaybe<IntOperationFilterInput>;
  heat1?: InputMaybe<DateTimeOperationFilterInput>;
  holsteinPtanetMerit?: InputMaybe<IntOperationFilterInput>;
  hornStatus?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  impId?: InputMaybe<IntOperationFilterInput>;
  implantBillingAccount?: InputMaybe<AccountFilterInput>;
  implantBillingAccountId?: InputMaybe<UuidOperationFilterInput>;
  implantDate?: InputMaybe<DateTimeOperationFilterInput>;
  implantStatusCode?: InputMaybe<IntOperationFilterInput>;
  jerseyPtanetMerit?: InputMaybe<IntOperationFilterInput>;
  jpi?: InputMaybe<IntOperationFilterInput>;
  kappaCasein?: InputMaybe<StringOperationFilterInput>;
  label1?: InputMaybe<StringOperationFilterInput>;
  label2?: InputMaybe<StringOperationFilterInput>;
  lastAct?: InputMaybe<StringOperationFilterInput>;
  loadBy?: InputMaybe<EquipmentFilterInput>;
  loadById?: InputMaybe<UuidOperationFilterInput>;
  loadTime?: InputMaybe<StringOperationFilterInput>;
  lowQuality?: InputMaybe<BooleanOperationFilterInput>;
  method?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oldOwner?: InputMaybe<AccountFilterInput>;
  oldOwnerId?: InputMaybe<UuidOperationFilterInput>;
  oldStorageLocation?: InputMaybe<StorageLocationFilterInput>;
  oldStorageLocationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<EmbryoFilterInput>>;
  origin?: InputMaybe<StringOperationFilterInput>;
  originalFreezeSite?: InputMaybe<SiteFilterInput>;
  originalFreezeSiteId?: InputMaybe<UuidOperationFilterInput>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  pc1Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc1Res?: InputMaybe<IntOperationFilterInput>;
  pc2Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc2Res?: InputMaybe<IntOperationFilterInput>;
  pc3Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc3Res?: InputMaybe<IntOperationFilterInput>;
  pc4Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc4Res?: InputMaybe<IntOperationFilterInput>;
  pc5Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc5Res?: InputMaybe<IntOperationFilterInput>;
  pc6Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc6Res?: InputMaybe<IntOperationFilterInput>;
  pc7Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc7Res?: InputMaybe<IntOperationFilterInput>;
  pc8Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc8Res?: InputMaybe<IntOperationFilterInput>;
  pc9Date?: InputMaybe<DateTimeOperationFilterInput>;
  pc9Res?: InputMaybe<IntOperationFilterInput>;
  plan1?: InputMaybe<StringOperationFilterInput>;
  plan2?: InputMaybe<StringOperationFilterInput>;
  plan3?: InputMaybe<StringOperationFilterInput>;
  ppapy?: InputMaybe<IntOperationFilterInput>;
  preBook?: InputMaybe<IntOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  probableDonorId?: InputMaybe<UuidOperationFilterInput>;
  probabledonor?: InputMaybe<DonorFilterInput>;
  profit?: InputMaybe<IntOperationFilterInput>;
  programName?: InputMaybe<StringOperationFilterInput>;
  proj?: InputMaybe<StringOperationFilterInput>;
  projd?: InputMaybe<StringOperationFilterInput>;
  psi?: InputMaybe<IntOperationFilterInput>;
  qc12WellPlates?: InputMaybe<StringOperationFilterInput>;
  qc12WellPlatesOld?: InputMaybe<IntOperationFilterInput>;
  qcEg10?: InputMaybe<StringOperationFilterInput>;
  qcEg10Date?: InputMaybe<DateTimeOperationFilterInput>;
  qcEmbHolding?: InputMaybe<StringOperationFilterInput>;
  qcEmbHoldingExpDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcSterileStrawLotNumber?: InputMaybe<StringOperationFilterInput>;
  qcStrawIncubatorNumber?: InputMaybe<StringOperationFilterInput>;
  qcStrawLotNumber?: InputMaybe<StringOperationFilterInput>;
  qcSucroseDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcThawThermosTemp?: InputMaybe<StringOperationFilterInput>;
  qcTryPsInDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcVitStrawLotNumber?: InputMaybe<StringOperationFilterInput>;
  qcehmDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcfreezingComment?: InputMaybe<StringOperationFilterInput>;
  qual?: InputMaybe<IntOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  ranchValue?: InputMaybe<IntOperationFilterInput>;
  recId?: InputMaybe<StringOperationFilterInput>;
  recaned?: InputMaybe<BooleanOperationFilterInput>;
  receivedOn?: InputMaybe<DateTimeOperationFilterInput>;
  recipBirthDate?: InputMaybe<DateTimeOperationFilterInput>;
  recipBreed?: InputMaybe<BreedFilterInput>;
  recipBreedId?: InputMaybe<UuidOperationFilterInput>;
  recipCalvingDate?: InputMaybe<DateTimeOperationFilterInput>;
  recipOwner?: InputMaybe<AccountFilterInput>;
  recipOwnerId?: InputMaybe<UuidOperationFilterInput>;
  recipRegNum?: InputMaybe<StringOperationFilterInput>;
  recipient?: InputMaybe<RecipientFilterInput>;
  recipientId?: InputMaybe<UuidOperationFilterInput>;
  recoveryFirmCode?: InputMaybe<StringOperationFilterInput>;
  recoveryFirmName?: InputMaybe<StringOperationFilterInput>;
  rightLeft?: InputMaybe<IntOperationFilterInput>;
  rightLeftHidden?: InputMaybe<StringOperationFilterInput>;
  scHerdman?: InputMaybe<StringOperationFilterInput>;
  scHnDate?: InputMaybe<DateTimeOperationFilterInput>;
  scIpDate?: InputMaybe<DateTimeOperationFilterInput>;
  scLastHeat?: InputMaybe<DateTimeOperationFilterInput>;
  scPreviousHeat?: InputMaybe<DateTimeOperationFilterInput>;
  scRpDate?: InputMaybe<DateTimeOperationFilterInput>;
  scSyDate?: InputMaybe<DateTimeOperationFilterInput>;
  semen?: InputMaybe<SemenFilterInput>;
  semenId?: InputMaybe<UuidOperationFilterInput>;
  sex?: InputMaybe<IntOperationFilterInput>;
  shipCity?: InputMaybe<StringOperationFilterInput>;
  shipState?: InputMaybe<StringOperationFilterInput>;
  shipToFbd?: InputMaybe<StringOperationFilterInput>;
  shipment?: InputMaybe<ShipmentFilterInput>;
  shipmentId?: InputMaybe<UuidOperationFilterInput>;
  sire?: InputMaybe<SireFilterInput>;
  sireCheeseMerit?: InputMaybe<IntOperationFilterInput>;
  sireId?: InputMaybe<UuidOperationFilterInput>;
  sireJpi?: InputMaybe<IntOperationFilterInput>;
  sireNetMerit?: InputMaybe<IntOperationFilterInput>;
  sireTpi?: InputMaybe<IntOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  soldTo?: InputMaybe<StringOperationFilterInput>;
  stage?: InputMaybe<IntOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  stopId?: InputMaybe<IntOperationFilterInput>;
  storageLocation?: InputMaybe<StorageLocationFilterInput>;
  storageLocationId?: InputMaybe<UuidOperationFilterInput>;
  straw?: InputMaybe<StringOperationFilterInput>;
  strawDisclaimer?: InputMaybe<StringOperationFilterInput>;
  strawNumber?: InputMaybe<IntOperationFilterInput>;
  sync?: InputMaybe<StringOperationFilterInput>;
  technician1?: InputMaybe<EquipmentFilterInput>;
  technician1Id?: InputMaybe<UuidOperationFilterInput>;
  technician1Name?: InputMaybe<StringOperationFilterInput>;
  technician2Name?: InputMaybe<StringOperationFilterInput>;
  tempEmbryoId?: InputMaybe<StringOperationFilterInput>;
  thawBy?: InputMaybe<EquipmentFilterInput>;
  thawById?: InputMaybe<UuidOperationFilterInput>;
  thawByName?: InputMaybe<StringOperationFilterInput>;
  thawMethodId?: InputMaybe<IntOperationFilterInput>;
  togId?: InputMaybe<IntOperationFilterInput>;
  tpi?: InputMaybe<IntOperationFilterInput>;
  transComment?: InputMaybe<StringOperationFilterInput>;
  transactionCurrencyId?: InputMaybe<UuidOperationFilterInput>;
  transferDate?: InputMaybe<DateTimeOperationFilterInput>;
  transferFarmLocation?: InputMaybe<EquipmentFilterInput>;
  transferFarmLocationId?: InputMaybe<UuidOperationFilterInput>;
  transferPrice?: InputMaybe<DecimalOperationFilterInput>;
  transferPriceBase?: InputMaybe<DecimalOperationFilterInput>;
  transferTime?: InputMaybe<StringOperationFilterInput>;
  tt?: InputMaybe<BooleanOperationFilterInput>;
  versionNumber?: InputMaybe<ListUnsignedByteOperationFilterInput>;
  vialId?: InputMaybe<StringOperationFilterInput>;
  vitrificationSolutionDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EmbryoFreezeEntry = {
  __typename: 'EmbryoFreezeEntry';
  cane: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  crackedZona: Maybe<Scalars['Boolean']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  discard: Maybe<Scalars['Boolean']['output']>;
  embryo: Maybe<Embryo>;
  embryoCreated: Maybe<Scalars['DateTime']['output']>;
  embryoId: Maybe<Scalars['UUID']['output']>;
  embryoOutsideId: Maybe<Scalars['UUID']['output']>;
  fertilization: Maybe<Fertilization>;
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  flushId: Maybe<Scalars['UUID']['output']>;
  freezeMethod: Maybe<OptionSet>;
  freezeMethodId: Maybe<Scalars['UUID']['output']>;
  freezeTech: Maybe<Scalars['String']['output']>;
  freezeTime: Maybe<Scalars['String']['output']>;
  freezer: Maybe<Scalars['String']['output']>;
  grade: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  lowQuality: Maybe<Scalars['Boolean']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  sex: Maybe<Scalars['Int']['output']>;
  stage: Maybe<Scalars['Int']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  storageLocation: Maybe<StorageLocation>;
  storageLocationId: Maybe<Scalars['UUID']['output']>;
  straw: Maybe<Scalars['Int']['output']>;
  tt: Maybe<Scalars['Boolean']['output']>;
};

export type EmbryoFreezeEntryFilterInput = {
  and?: InputMaybe<Array<EmbryoFreezeEntryFilterInput>>;
  cane?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  crackedZona?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  discard?: InputMaybe<BooleanOperationFilterInput>;
  embryo?: InputMaybe<EmbryoFilterInput>;
  embryoCreated?: InputMaybe<DateTimeOperationFilterInput>;
  embryoId?: InputMaybe<UuidOperationFilterInput>;
  embryoOutsideId?: InputMaybe<UuidOperationFilterInput>;
  fertilization?: InputMaybe<FertilizationFilterInput>;
  fertilizationId?: InputMaybe<UuidOperationFilterInput>;
  flushId?: InputMaybe<UuidOperationFilterInput>;
  freezeMethod?: InputMaybe<OptionSetFilterInput>;
  freezeMethodId?: InputMaybe<UuidOperationFilterInput>;
  freezeTech?: InputMaybe<StringOperationFilterInput>;
  freezeTime?: InputMaybe<StringOperationFilterInput>;
  freezer?: InputMaybe<StringOperationFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lowQuality?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmbryoFreezeEntryFilterInput>>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  sex?: InputMaybe<IntOperationFilterInput>;
  stage?: InputMaybe<IntOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  storageLocation?: InputMaybe<StorageLocationFilterInput>;
  storageLocationId?: InputMaybe<UuidOperationFilterInput>;
  straw?: InputMaybe<IntOperationFilterInput>;
  tt?: InputMaybe<BooleanOperationFilterInput>;
};

export type EmbryoFreezeEntryInput = {
  cane?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  crackedZona?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  discard?: InputMaybe<Scalars['Boolean']['input']>;
  embryo?: InputMaybe<EmbryoInput>;
  embryoCreated?: InputMaybe<Scalars['DateTime']['input']>;
  embryoId?: InputMaybe<Scalars['UUID']['input']>;
  embryoOutsideId?: InputMaybe<Scalars['UUID']['input']>;
  fertilization?: InputMaybe<FertilizationInput>;
  fertilizationId?: InputMaybe<Scalars['UUID']['input']>;
  flushId?: InputMaybe<Scalars['UUID']['input']>;
  freezeMethod?: InputMaybe<OptionSetInput>;
  freezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  freezeTech?: InputMaybe<Scalars['String']['input']>;
  freezeTime?: InputMaybe<Scalars['String']['input']>;
  freezer?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  lowQuality?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  sex?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  storageLocation?: InputMaybe<StorageLocationInput>;
  storageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  straw?: InputMaybe<Scalars['Int']['input']>;
  tt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmbryoFreezeEntrySortInput = {
  cane?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  crackedZona?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  discard?: InputMaybe<SortEnumType>;
  embryo?: InputMaybe<EmbryoSortInput>;
  embryoCreated?: InputMaybe<SortEnumType>;
  embryoId?: InputMaybe<SortEnumType>;
  embryoOutsideId?: InputMaybe<SortEnumType>;
  fertilization?: InputMaybe<FertilizationSortInput>;
  fertilizationId?: InputMaybe<SortEnumType>;
  flushId?: InputMaybe<SortEnumType>;
  freezeMethod?: InputMaybe<OptionSetSortInput>;
  freezeMethodId?: InputMaybe<SortEnumType>;
  freezeTech?: InputMaybe<SortEnumType>;
  freezeTime?: InputMaybe<SortEnumType>;
  freezer?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lowQuality?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  sex?: InputMaybe<SortEnumType>;
  stage?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  storageLocation?: InputMaybe<StorageLocationSortInput>;
  storageLocationId?: InputMaybe<SortEnumType>;
  straw?: InputMaybe<SortEnumType>;
  tt?: InputMaybe<SortEnumType>;
};

export type EmbryoInput = {
  abort?: InputMaybe<Scalars['Int']['input']>;
  accountType?: InputMaybe<Scalars['Int']['input']>;
  additionalEmbryoImplant?: InputMaybe<Scalars['Boolean']['input']>;
  approvalNumber: TOG_FacilityApprovalNumbersBaseInput;
  approvalNumberId?: InputMaybe<Scalars['UUID']['input']>;
  betaCasein?: InputMaybe<Scalars['String']['input']>;
  billStatusCrt?: InputMaybe<Scalars['Int']['input']>;
  billStatusImp?: InputMaybe<Scalars['Int']['input']>;
  billingOwner?: InputMaybe<AccountInput>;
  billingOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  breed?: InputMaybe<BreedInput>;
  breedId?: InputMaybe<Scalars['UUID']['input']>;
  calfSex?: InputMaybe<Scalars['Int']['input']>;
  calfType?: InputMaybe<Scalars['Int']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  cellId?: InputMaybe<Scalars['String']['input']>;
  cellLineId?: InputMaybe<Scalars['UUID']['input']>;
  clientRecipient?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['Int']['input']>;
  clinicRanchHaulIn?: InputMaybe<Scalars['Int']['input']>;
  comm?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  crackedZona?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  creation?: InputMaybe<Scalars['DateTime']['input']>;
  dairyCompEmbryoId?: InputMaybe<Scalars['Int']['input']>;
  dateUsed?: InputMaybe<Scalars['DateTime']['input']>;
  dist?: InputMaybe<Scalars['Int']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorAge?: InputMaybe<Scalars['String']['input']>;
  donorCheeseMerit?: InputMaybe<Scalars['Int']['input']>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorJpi?: InputMaybe<Scalars['Int']['input']>;
  donorNetMerit?: InputMaybe<Scalars['Int']['input']>;
  donorTpi?: InputMaybe<Scalars['Int']['input']>;
  dtPlus?: InputMaybe<Scalars['Boolean']['input']>;
  edonorId?: InputMaybe<Scalars['String']['input']>;
  embTag?: InputMaybe<Scalars['String']['input']>;
  embTagNumber?: InputMaybe<Scalars['Int']['input']>;
  embryoOutsideEntryId?: InputMaybe<Scalars['UUID']['input']>;
  embryoPa?: InputMaybe<Scalars['Int']['input']>;
  embryoStagingId?: InputMaybe<Scalars['Int']['input']>;
  equilibrationSolutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  estDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  estrusSync?: InputMaybe<Scalars['Int']['input']>;
  estrusSyncNumber?: InputMaybe<Scalars['Decimal']['input']>;
  exchangeRate?: InputMaybe<Scalars['Decimal']['input']>;
  export?: InputMaybe<Scalars['Int']['input']>;
  feeder?: InputMaybe<Scalars['Int']['input']>;
  fertilization?: InputMaybe<FertilizationInput>;
  fertilizationId?: InputMaybe<Scalars['UUID']['input']>;
  flexFieldPartners?: InputMaybe<Scalars['String']['input']>;
  flshId?: InputMaybe<Scalars['String']['input']>;
  flush?: InputMaybe<FlushInput>;
  flushId?: InputMaybe<Scalars['UUID']['input']>;
  flushIdNumber?: InputMaybe<Scalars['Int']['input']>;
  freezeComment?: InputMaybe<Scalars['String']['input']>;
  freezeMethod?: InputMaybe<OptionSetInput>;
  freezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  freezeTech?: InputMaybe<EquipmentInput>;
  freezeTechId?: InputMaybe<Scalars['UUID']['input']>;
  freezeTechName?: InputMaybe<Scalars['String']['input']>;
  freezeTime?: InputMaybe<Scalars['String']['input']>;
  freezer?: InputMaybe<Scalars['String']['input']>;
  freshFrozen?: InputMaybe<Scalars['Int']['input']>;
  freshStrawNo?: InputMaybe<Scalars['Int']['input']>;
  frozenGrade?: InputMaybe<Scalars['Int']['input']>;
  frozenStage?: InputMaybe<Scalars['Int']['input']>;
  gnrhUsedAtImplant?: InputMaybe<Scalars['Boolean']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  grader7?: InputMaybe<EquipmentInput>;
  grader7Id?: InputMaybe<Scalars['UUID']['input']>;
  grader7Name?: InputMaybe<Scalars['String']['input']>;
  grader65?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  hcgApplied?: InputMaybe<Scalars['Int']['input']>;
  heat1?: InputMaybe<Scalars['DateTime']['input']>;
  holsteinPtanetMerit?: InputMaybe<Scalars['Int']['input']>;
  hornStatus?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  impId?: InputMaybe<Scalars['Int']['input']>;
  implantBillingAccount?: InputMaybe<AccountInput>;
  implantBillingAccountId?: InputMaybe<Scalars['UUID']['input']>;
  implantDate?: InputMaybe<Scalars['DateTime']['input']>;
  implantStatusCode?: InputMaybe<Scalars['Int']['input']>;
  jerseyPtanetMerit?: InputMaybe<Scalars['Int']['input']>;
  jpi?: InputMaybe<Scalars['Int']['input']>;
  kappaCasein?: InputMaybe<Scalars['String']['input']>;
  label1?: InputMaybe<Scalars['String']['input']>;
  label2?: InputMaybe<Scalars['String']['input']>;
  lastAct?: InputMaybe<Scalars['String']['input']>;
  loadBy?: InputMaybe<EquipmentInput>;
  loadById?: InputMaybe<Scalars['UUID']['input']>;
  loadTime?: InputMaybe<Scalars['String']['input']>;
  lowQuality?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oldOwner?: InputMaybe<AccountInput>;
  oldOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  oldStorageLocation?: InputMaybe<StorageLocationInput>;
  oldStorageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  originalFreezeSite?: InputMaybe<SiteInput>;
  originalFreezeSiteId?: InputMaybe<Scalars['UUID']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  pc1Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc1Res?: InputMaybe<Scalars['Int']['input']>;
  pc2Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc2Res?: InputMaybe<Scalars['Int']['input']>;
  pc3Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc3Res?: InputMaybe<Scalars['Int']['input']>;
  pc4Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc4Res?: InputMaybe<Scalars['Int']['input']>;
  pc5Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc5Res?: InputMaybe<Scalars['Int']['input']>;
  pc6Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc6Res?: InputMaybe<Scalars['Int']['input']>;
  pc7Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc7Res?: InputMaybe<Scalars['Int']['input']>;
  pc8Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc8Res?: InputMaybe<Scalars['Int']['input']>;
  pc9Date?: InputMaybe<Scalars['DateTime']['input']>;
  pc9Res?: InputMaybe<Scalars['Int']['input']>;
  plan1?: InputMaybe<Scalars['String']['input']>;
  plan2?: InputMaybe<Scalars['String']['input']>;
  plan3?: InputMaybe<Scalars['String']['input']>;
  ppapy?: InputMaybe<Scalars['Int']['input']>;
  preBook?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  probableDonorId?: InputMaybe<Scalars['UUID']['input']>;
  probabledonor?: InputMaybe<DonorInput>;
  profit?: InputMaybe<Scalars['Int']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  proj?: InputMaybe<Scalars['String']['input']>;
  projd?: InputMaybe<Scalars['String']['input']>;
  psi?: InputMaybe<Scalars['Int']['input']>;
  qc12WellPlates?: InputMaybe<Scalars['String']['input']>;
  qc12WellPlatesOld?: InputMaybe<Scalars['Int']['input']>;
  qcEg10?: InputMaybe<Scalars['String']['input']>;
  qcEg10Date?: InputMaybe<Scalars['DateTime']['input']>;
  qcEmbHolding?: InputMaybe<Scalars['String']['input']>;
  qcEmbHoldingExpDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcSterileStrawLotNumber?: InputMaybe<Scalars['String']['input']>;
  qcStrawIncubatorNumber?: InputMaybe<Scalars['String']['input']>;
  qcStrawLotNumber?: InputMaybe<Scalars['String']['input']>;
  qcSucroseDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcThawThermosTemp?: InputMaybe<Scalars['String']['input']>;
  qcTryPsInDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcVitStrawLotNumber?: InputMaybe<Scalars['String']['input']>;
  qcehmDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcfreezingComment?: InputMaybe<Scalars['String']['input']>;
  qual?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  ranchValue?: InputMaybe<Scalars['Int']['input']>;
  recId?: InputMaybe<Scalars['String']['input']>;
  recaned?: InputMaybe<Scalars['Boolean']['input']>;
  receivedOn?: InputMaybe<Scalars['DateTime']['input']>;
  recipBirthDate?: InputMaybe<Scalars['DateTime']['input']>;
  recipBreed?: InputMaybe<BreedInput>;
  recipBreedId?: InputMaybe<Scalars['UUID']['input']>;
  recipCalvingDate?: InputMaybe<Scalars['DateTime']['input']>;
  recipOwner?: InputMaybe<AccountInput>;
  recipOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  recipRegNum?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<RecipientInput>;
  recipientId?: InputMaybe<Scalars['UUID']['input']>;
  recoveryFirmCode?: InputMaybe<Scalars['String']['input']>;
  recoveryFirmName?: InputMaybe<Scalars['String']['input']>;
  rightLeft?: InputMaybe<Scalars['Int']['input']>;
  rightLeftHidden?: InputMaybe<Scalars['String']['input']>;
  scHerdman?: InputMaybe<Scalars['String']['input']>;
  scHnDate?: InputMaybe<Scalars['DateTime']['input']>;
  scIpDate?: InputMaybe<Scalars['DateTime']['input']>;
  scLastHeat?: InputMaybe<Scalars['DateTime']['input']>;
  scPreviousHeat?: InputMaybe<Scalars['DateTime']['input']>;
  scRpDate?: InputMaybe<Scalars['DateTime']['input']>;
  scSyDate?: InputMaybe<Scalars['DateTime']['input']>;
  semen?: InputMaybe<SemenInput>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  sex?: InputMaybe<Scalars['Int']['input']>;
  shipCity?: InputMaybe<Scalars['String']['input']>;
  shipState?: InputMaybe<Scalars['String']['input']>;
  shipToFbd?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentInput>;
  shipmentId?: InputMaybe<Scalars['UUID']['input']>;
  sire?: InputMaybe<SireInput>;
  sireCheeseMerit?: InputMaybe<Scalars['Int']['input']>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  sireJpi?: InputMaybe<Scalars['Int']['input']>;
  sireNetMerit?: InputMaybe<Scalars['Int']['input']>;
  sireTpi?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  stateCode: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  stopId?: InputMaybe<Scalars['Int']['input']>;
  storageLocation?: InputMaybe<StorageLocationInput>;
  storageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  straw?: InputMaybe<Scalars['String']['input']>;
  strawDisclaimer?: InputMaybe<Scalars['String']['input']>;
  strawNumber?: InputMaybe<Scalars['Int']['input']>;
  sync?: InputMaybe<Scalars['String']['input']>;
  technician1?: InputMaybe<EquipmentInput>;
  technician1Id?: InputMaybe<Scalars['UUID']['input']>;
  technician1Name?: InputMaybe<Scalars['String']['input']>;
  technician2Name?: InputMaybe<Scalars['String']['input']>;
  tempEmbryoId?: InputMaybe<Scalars['String']['input']>;
  thawBy?: InputMaybe<EquipmentInput>;
  thawById?: InputMaybe<Scalars['UUID']['input']>;
  thawByName?: InputMaybe<Scalars['String']['input']>;
  thawMethodId?: InputMaybe<Scalars['Int']['input']>;
  togId?: InputMaybe<Scalars['Int']['input']>;
  tpi?: InputMaybe<Scalars['Int']['input']>;
  transComment?: InputMaybe<Scalars['String']['input']>;
  transactionCurrencyId?: InputMaybe<Scalars['UUID']['input']>;
  transferDate?: InputMaybe<Scalars['DateTime']['input']>;
  transferFarmLocation?: InputMaybe<EquipmentInput>;
  transferFarmLocationId?: InputMaybe<Scalars['UUID']['input']>;
  transferPrice?: InputMaybe<Scalars['Decimal']['input']>;
  transferPriceBase?: InputMaybe<Scalars['Decimal']['input']>;
  transferTime?: InputMaybe<Scalars['String']['input']>;
  tt?: InputMaybe<Scalars['Boolean']['input']>;
  versionNumber?: InputMaybe<Array<Scalars['UnsignedByte']['input']>>;
  vialId?: InputMaybe<Scalars['String']['input']>;
  vitrificationSolutionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmbryoSortInput = {
  abort?: InputMaybe<SortEnumType>;
  accountType?: InputMaybe<SortEnumType>;
  additionalEmbryoImplant?: InputMaybe<SortEnumType>;
  approvalNumber?: InputMaybe<TOG_FacilityApprovalNumbersBaseSortInput>;
  approvalNumberId?: InputMaybe<SortEnumType>;
  betaCasein?: InputMaybe<SortEnumType>;
  billStatusCrt?: InputMaybe<SortEnumType>;
  billStatusImp?: InputMaybe<SortEnumType>;
  billingOwner?: InputMaybe<AccountSortInput>;
  billingOwnerId?: InputMaybe<SortEnumType>;
  breed?: InputMaybe<BreedSortInput>;
  breedId?: InputMaybe<SortEnumType>;
  calfSex?: InputMaybe<SortEnumType>;
  calfType?: InputMaybe<SortEnumType>;
  cane?: InputMaybe<SortEnumType>;
  cellId?: InputMaybe<SortEnumType>;
  cellLineId?: InputMaybe<SortEnumType>;
  clientRecipient?: InputMaybe<SortEnumType>;
  clinic?: InputMaybe<SortEnumType>;
  clinicRanchHaulIn?: InputMaybe<SortEnumType>;
  comm?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  crackedZona?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  creation?: InputMaybe<SortEnumType>;
  dairyCompEmbryoId?: InputMaybe<SortEnumType>;
  dateUsed?: InputMaybe<SortEnumType>;
  dist?: InputMaybe<SortEnumType>;
  donor?: InputMaybe<DonorSortInput>;
  donorAge?: InputMaybe<SortEnumType>;
  donorCheeseMerit?: InputMaybe<SortEnumType>;
  donorId?: InputMaybe<SortEnumType>;
  donorJpi?: InputMaybe<SortEnumType>;
  donorNetMerit?: InputMaybe<SortEnumType>;
  donorTpi?: InputMaybe<SortEnumType>;
  dtPlus?: InputMaybe<SortEnumType>;
  edonorId?: InputMaybe<SortEnumType>;
  embTag?: InputMaybe<SortEnumType>;
  embTagNumber?: InputMaybe<SortEnumType>;
  embryoOutsideEntryId?: InputMaybe<SortEnumType>;
  embryoPa?: InputMaybe<SortEnumType>;
  embryoStagingId?: InputMaybe<SortEnumType>;
  equilibrationSolutionDate?: InputMaybe<SortEnumType>;
  estDueDate?: InputMaybe<SortEnumType>;
  estrusSync?: InputMaybe<SortEnumType>;
  estrusSyncNumber?: InputMaybe<SortEnumType>;
  exchangeRate?: InputMaybe<SortEnumType>;
  export?: InputMaybe<SortEnumType>;
  feeder?: InputMaybe<SortEnumType>;
  fertilization?: InputMaybe<FertilizationSortInput>;
  fertilizationId?: InputMaybe<SortEnumType>;
  flexFieldPartners?: InputMaybe<SortEnumType>;
  flshId?: InputMaybe<SortEnumType>;
  flush?: InputMaybe<FlushSortInput>;
  flushId?: InputMaybe<SortEnumType>;
  flushIdNumber?: InputMaybe<SortEnumType>;
  freezeComment?: InputMaybe<SortEnumType>;
  freezeMethod?: InputMaybe<OptionSetSortInput>;
  freezeMethodId?: InputMaybe<SortEnumType>;
  freezeTech?: InputMaybe<EquipmentSortInput>;
  freezeTechId?: InputMaybe<SortEnumType>;
  freezeTechName?: InputMaybe<SortEnumType>;
  freezeTime?: InputMaybe<SortEnumType>;
  freezer?: InputMaybe<SortEnumType>;
  freshFrozen?: InputMaybe<SortEnumType>;
  freshStrawNo?: InputMaybe<SortEnumType>;
  frozenGrade?: InputMaybe<SortEnumType>;
  frozenStage?: InputMaybe<SortEnumType>;
  gnrhUsedAtImplant?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  grader7?: InputMaybe<EquipmentSortInput>;
  grader7Id?: InputMaybe<SortEnumType>;
  grader7Name?: InputMaybe<SortEnumType>;
  grader65?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  hcgApplied?: InputMaybe<SortEnumType>;
  heat1?: InputMaybe<SortEnumType>;
  holsteinPtanetMerit?: InputMaybe<SortEnumType>;
  hornStatus?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  impId?: InputMaybe<SortEnumType>;
  implantBillingAccount?: InputMaybe<AccountSortInput>;
  implantBillingAccountId?: InputMaybe<SortEnumType>;
  implantDate?: InputMaybe<SortEnumType>;
  implantStatusCode?: InputMaybe<SortEnumType>;
  jerseyPtanetMerit?: InputMaybe<SortEnumType>;
  jpi?: InputMaybe<SortEnumType>;
  kappaCasein?: InputMaybe<SortEnumType>;
  label1?: InputMaybe<SortEnumType>;
  label2?: InputMaybe<SortEnumType>;
  lastAct?: InputMaybe<SortEnumType>;
  loadBy?: InputMaybe<EquipmentSortInput>;
  loadById?: InputMaybe<SortEnumType>;
  loadTime?: InputMaybe<SortEnumType>;
  lowQuality?: InputMaybe<SortEnumType>;
  method?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  oldOwner?: InputMaybe<AccountSortInput>;
  oldOwnerId?: InputMaybe<SortEnumType>;
  oldStorageLocation?: InputMaybe<StorageLocationSortInput>;
  oldStorageLocationId?: InputMaybe<SortEnumType>;
  origin?: InputMaybe<SortEnumType>;
  originalFreezeSite?: InputMaybe<SiteSortInput>;
  originalFreezeSiteId?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  pc1Date?: InputMaybe<SortEnumType>;
  pc1Res?: InputMaybe<SortEnumType>;
  pc2Date?: InputMaybe<SortEnumType>;
  pc2Res?: InputMaybe<SortEnumType>;
  pc3Date?: InputMaybe<SortEnumType>;
  pc3Res?: InputMaybe<SortEnumType>;
  pc4Date?: InputMaybe<SortEnumType>;
  pc4Res?: InputMaybe<SortEnumType>;
  pc5Date?: InputMaybe<SortEnumType>;
  pc5Res?: InputMaybe<SortEnumType>;
  pc6Date?: InputMaybe<SortEnumType>;
  pc6Res?: InputMaybe<SortEnumType>;
  pc7Date?: InputMaybe<SortEnumType>;
  pc7Res?: InputMaybe<SortEnumType>;
  pc8Date?: InputMaybe<SortEnumType>;
  pc8Res?: InputMaybe<SortEnumType>;
  pc9Date?: InputMaybe<SortEnumType>;
  pc9Res?: InputMaybe<SortEnumType>;
  plan1?: InputMaybe<SortEnumType>;
  plan2?: InputMaybe<SortEnumType>;
  plan3?: InputMaybe<SortEnumType>;
  ppapy?: InputMaybe<SortEnumType>;
  preBook?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  probableDonorId?: InputMaybe<SortEnumType>;
  probabledonor?: InputMaybe<DonorSortInput>;
  profit?: InputMaybe<SortEnumType>;
  programName?: InputMaybe<SortEnumType>;
  proj?: InputMaybe<SortEnumType>;
  projd?: InputMaybe<SortEnumType>;
  psi?: InputMaybe<SortEnumType>;
  qc12WellPlates?: InputMaybe<SortEnumType>;
  qc12WellPlatesOld?: InputMaybe<SortEnumType>;
  qcEg10?: InputMaybe<SortEnumType>;
  qcEg10Date?: InputMaybe<SortEnumType>;
  qcEmbHolding?: InputMaybe<SortEnumType>;
  qcEmbHoldingExpDate?: InputMaybe<SortEnumType>;
  qcSterileStrawLotNumber?: InputMaybe<SortEnumType>;
  qcStrawIncubatorNumber?: InputMaybe<SortEnumType>;
  qcStrawLotNumber?: InputMaybe<SortEnumType>;
  qcSucroseDate?: InputMaybe<SortEnumType>;
  qcThawThermosTemp?: InputMaybe<SortEnumType>;
  qcTryPsInDate?: InputMaybe<SortEnumType>;
  qcVitStrawLotNumber?: InputMaybe<SortEnumType>;
  qcehmDate?: InputMaybe<SortEnumType>;
  qcfreezingComment?: InputMaybe<SortEnumType>;
  qual?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  ranchValue?: InputMaybe<SortEnumType>;
  recId?: InputMaybe<SortEnumType>;
  recaned?: InputMaybe<SortEnumType>;
  receivedOn?: InputMaybe<SortEnumType>;
  recipBirthDate?: InputMaybe<SortEnumType>;
  recipBreed?: InputMaybe<BreedSortInput>;
  recipBreedId?: InputMaybe<SortEnumType>;
  recipCalvingDate?: InputMaybe<SortEnumType>;
  recipOwner?: InputMaybe<AccountSortInput>;
  recipOwnerId?: InputMaybe<SortEnumType>;
  recipRegNum?: InputMaybe<SortEnumType>;
  recipient?: InputMaybe<RecipientSortInput>;
  recipientId?: InputMaybe<SortEnumType>;
  recoveryFirmCode?: InputMaybe<SortEnumType>;
  recoveryFirmName?: InputMaybe<SortEnumType>;
  rightLeft?: InputMaybe<SortEnumType>;
  rightLeftHidden?: InputMaybe<SortEnumType>;
  scHerdman?: InputMaybe<SortEnumType>;
  scHnDate?: InputMaybe<SortEnumType>;
  scIpDate?: InputMaybe<SortEnumType>;
  scLastHeat?: InputMaybe<SortEnumType>;
  scPreviousHeat?: InputMaybe<SortEnumType>;
  scRpDate?: InputMaybe<SortEnumType>;
  scSyDate?: InputMaybe<SortEnumType>;
  semen?: InputMaybe<SemenSortInput>;
  semenId?: InputMaybe<SortEnumType>;
  sex?: InputMaybe<SortEnumType>;
  shipCity?: InputMaybe<SortEnumType>;
  shipState?: InputMaybe<SortEnumType>;
  shipToFbd?: InputMaybe<SortEnumType>;
  shipment?: InputMaybe<ShipmentSortInput>;
  shipmentId?: InputMaybe<SortEnumType>;
  sire?: InputMaybe<SireSortInput>;
  sireCheeseMerit?: InputMaybe<SortEnumType>;
  sireId?: InputMaybe<SortEnumType>;
  sireJpi?: InputMaybe<SortEnumType>;
  sireNetMerit?: InputMaybe<SortEnumType>;
  sireTpi?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  soldTo?: InputMaybe<SortEnumType>;
  stage?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  stopId?: InputMaybe<SortEnumType>;
  storageLocation?: InputMaybe<StorageLocationSortInput>;
  storageLocationId?: InputMaybe<SortEnumType>;
  straw?: InputMaybe<SortEnumType>;
  strawDisclaimer?: InputMaybe<SortEnumType>;
  strawNumber?: InputMaybe<SortEnumType>;
  sync?: InputMaybe<SortEnumType>;
  technician1?: InputMaybe<EquipmentSortInput>;
  technician1Id?: InputMaybe<SortEnumType>;
  technician1Name?: InputMaybe<SortEnumType>;
  technician2Name?: InputMaybe<SortEnumType>;
  tempEmbryoId?: InputMaybe<SortEnumType>;
  thawBy?: InputMaybe<EquipmentSortInput>;
  thawById?: InputMaybe<SortEnumType>;
  thawByName?: InputMaybe<SortEnumType>;
  thawMethodId?: InputMaybe<SortEnumType>;
  togId?: InputMaybe<SortEnumType>;
  tpi?: InputMaybe<SortEnumType>;
  transComment?: InputMaybe<SortEnumType>;
  transactionCurrencyId?: InputMaybe<SortEnumType>;
  transferDate?: InputMaybe<SortEnumType>;
  transferFarmLocation?: InputMaybe<EquipmentSortInput>;
  transferFarmLocationId?: InputMaybe<SortEnumType>;
  transferPrice?: InputMaybe<SortEnumType>;
  transferPriceBase?: InputMaybe<SortEnumType>;
  transferTime?: InputMaybe<SortEnumType>;
  tt?: InputMaybe<SortEnumType>;
  vialId?: InputMaybe<SortEnumType>;
  vitrificationSolutionDate?: InputMaybe<SortEnumType>;
};

export type EmbryoUpdateInput = {
  embryoId?: InputMaybe<Scalars['String']['input']>;
  embryoToBe?: InputMaybe<Scalars['String']['input']>;
  fertilizationId?: InputMaybe<Scalars['String']['input']>;
  implantType?: InputMaybe<Scalars['String']['input']>;
};

export type EmbryoUpdatePayload = {
  __typename: 'EmbryoUpdatePayload';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EmbryologistDataEntryInput = {
  aspirationDate: Scalars['String']['input'];
  aspirationId: Scalars['String']['input'];
  dishType?: InputMaybe<Scalars['String']['input']>;
  enim?: InputMaybe<Scalars['Int']['input']>;
  fertPlan?: InputMaybe<Scalars['String']['input']>;
  gradeAbc?: InputMaybe<Scalars['Int']['input']>;
  gradeD?: InputMaybe<Scalars['Int']['input']>;
  gradeE?: InputMaybe<Scalars['Int']['input']>;
  indexIvmTech?: InputMaybe<Scalars['String']['input']>;
  ivmComment?: InputMaybe<Scalars['String']['input']>;
  ivmCyto?: InputMaybe<Scalars['String']['input']>;
  ivmMat?: InputMaybe<Scalars['Int']['input']>;
  ivmRec?: InputMaybe<Scalars['Int']['input']>;
  ivmTechId?: InputMaybe<Scalars['String']['input']>;
  ivmTechTime: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  usdaSeal?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type EmbryosCollectionSegment = {
  __typename: 'EmbryosCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Embryo>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Equipment = {
  __typename: 'Equipment';
  activeInactive: Maybe<Scalars['Boolean']['output']>;
  assistantAspirations: Array<Aspiration>;
  businessUnitId: Scalars['UUID']['output'];
  calendar: Maybe<Calendar>;
  calendarId: Scalars['UUID']['output'];
  companyId: Scalars['UUID']['output'];
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayInServiceViews: Maybe<Scalars['Boolean']['output']>;
  emailAddress: Maybe<Scalars['String']['output']>;
  embryologist: Maybe<Scalars['Boolean']['output']>;
  equipmentType: Maybe<Scalars['Int']['output']>;
  etSearch: Maybe<Scalars['String']['output']>;
  farmlocation: Maybe<Scalars['Boolean']['output']>;
  fertValidatorFertilizations: Array<Fertilization>;
  flushTechnicianFlushes: Array<Flush>;
  freezeTechnicianEmbryos: Array<Embryo>;
  freezeTechnicianFertilizations: Array<Fertilization>;
  frozeValidatorFertilizations: Array<Fertilization>;
  grader7Embryos: Array<Embryo>;
  graderFertilizations: Array<Fertilization>;
  graderFlushes: Array<Flush>;
  herdsman: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  inTraining: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  ivcTechnicianFertilizations: Array<Fertilization>;
  ivfLabTechnician1Fertilizations: Array<Fertilization>;
  ivfLabTechnician2Fertilizations: Array<Fertilization>;
  ivmTechnicianAspirations: Array<Aspiration>;
  loadByEmbryos: Array<Embryo>;
  lowProdValidatorFertilizations: Array<Fertilization>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  packedShipments: Array<Shipment>;
  predictedByFertilizations: Array<Fertilization>;
  processingTechnicianFertilizations: Array<Fertilization>;
  shipValidatorFertilizations: Array<Fertilization>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  skills: Maybe<Scalars['String']['output']>;
  systemUser: Maybe<SystemUser>;
  systemUserId: Maybe<Scalars['UUID']['output']>;
  technician: Maybe<Scalars['Boolean']['output']>;
  technician1Embryos: Array<Embryo>;
  technicianAspirations: Array<Aspiration>;
  thawByEmbryos: Array<Embryo>;
  timeZoneCode: Maybe<Scalars['Int']['output']>;
  togEmployee: Maybe<Scalars['Int']['output']>;
  transValidatorFertilizations: Array<Fertilization>;
  transferFarmLocationEmbryos: Array<Embryo>;
  veterinarian: Maybe<Scalars['Boolean']['output']>;
};

export type EquipmentFilterInput = {
  activeInactive?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EquipmentFilterInput>>;
  assistantAspirations?: InputMaybe<ListFilterInputTypeOfAspirationFilterInput>;
  businessUnitId?: InputMaybe<UuidOperationFilterInput>;
  calendar?: InputMaybe<CalendarFilterInput>;
  calendarId?: InputMaybe<UuidOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  displayInServiceViews?: InputMaybe<BooleanOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  embryologist?: InputMaybe<BooleanOperationFilterInput>;
  equipmentType?: InputMaybe<IntOperationFilterInput>;
  etSearch?: InputMaybe<StringOperationFilterInput>;
  farmlocation?: InputMaybe<BooleanOperationFilterInput>;
  fertValidatorFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  flushTechnicianFlushes?: InputMaybe<ListFilterInputTypeOfFlushFilterInput>;
  freezeTechnicianEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  freezeTechnicianFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  frozeValidatorFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  grader7Embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  graderFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  graderFlushes?: InputMaybe<ListFilterInputTypeOfFlushFilterInput>;
  herdsman?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  inTraining?: InputMaybe<BooleanOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  ivcTechnicianFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  ivfLabTechnician1Fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  ivfLabTechnician2Fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  ivmTechnicianAspirations?: InputMaybe<ListFilterInputTypeOfAspirationFilterInput>;
  loadByEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  lowProdValidatorFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EquipmentFilterInput>>;
  packedShipments?: InputMaybe<ListFilterInputTypeOfShipmentFilterInput>;
  predictedByFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  processingTechnicianFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  shipValidatorFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  skills?: InputMaybe<StringOperationFilterInput>;
  systemUser?: InputMaybe<SystemUserFilterInput>;
  systemUserId?: InputMaybe<UuidOperationFilterInput>;
  technician?: InputMaybe<BooleanOperationFilterInput>;
  technician1Embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  technicianAspirations?: InputMaybe<ListFilterInputTypeOfAspirationFilterInput>;
  thawByEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  timeZoneCode?: InputMaybe<IntOperationFilterInput>;
  togEmployee?: InputMaybe<IntOperationFilterInput>;
  transValidatorFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  transferFarmLocationEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  veterinarian?: InputMaybe<BooleanOperationFilterInput>;
};

export type EquipmentInput = {
  activeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  assistantAspirations: Array<AspirationInput>;
  businessUnitId: Scalars['UUID']['input'];
  calendar?: InputMaybe<CalendarInput>;
  calendarId: Scalars['UUID']['input'];
  companyId: Scalars['UUID']['input'];
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayInServiceViews?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  embryologist?: InputMaybe<Scalars['Boolean']['input']>;
  equipmentType?: InputMaybe<Scalars['Int']['input']>;
  etSearch?: InputMaybe<Scalars['String']['input']>;
  farmlocation?: InputMaybe<Scalars['Boolean']['input']>;
  fertValidatorFertilizations: Array<FertilizationInput>;
  flushTechnicianFlushes: Array<FlushInput>;
  freezeTechnicianEmbryos: Array<EmbryoInput>;
  freezeTechnicianFertilizations: Array<FertilizationInput>;
  frozeValidatorFertilizations: Array<FertilizationInput>;
  grader7Embryos: Array<EmbryoInput>;
  graderFertilizations: Array<FertilizationInput>;
  graderFlushes: Array<FlushInput>;
  herdsman?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  inTraining?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  ivcTechnicianFertilizations: Array<FertilizationInput>;
  ivfLabTechnician1Fertilizations: Array<FertilizationInput>;
  ivfLabTechnician2Fertilizations: Array<FertilizationInput>;
  ivmTechnicianAspirations: Array<AspirationInput>;
  loadByEmbryos: Array<EmbryoInput>;
  lowProdValidatorFertilizations: Array<FertilizationInput>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  packedShipments: Array<ShipmentInput>;
  predictedByFertilizations: Array<FertilizationInput>;
  processingTechnicianFertilizations: Array<FertilizationInput>;
  shipValidatorFertilizations: Array<FertilizationInput>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  systemUser?: InputMaybe<SystemUserInput>;
  systemUserId?: InputMaybe<Scalars['UUID']['input']>;
  technician?: InputMaybe<Scalars['Boolean']['input']>;
  technician1Embryos: Array<EmbryoInput>;
  technicianAspirations: Array<AspirationInput>;
  thawByEmbryos: Array<EmbryoInput>;
  timeZoneCode?: InputMaybe<Scalars['Int']['input']>;
  togEmployee?: InputMaybe<Scalars['Int']['input']>;
  transValidatorFertilizations: Array<FertilizationInput>;
  transferFarmLocationEmbryos: Array<EmbryoInput>;
  veterinarian?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EquipmentSortInput = {
  activeInactive?: InputMaybe<SortEnumType>;
  businessUnitId?: InputMaybe<SortEnumType>;
  calendar?: InputMaybe<CalendarSortInput>;
  calendarId?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  displayInServiceViews?: InputMaybe<SortEnumType>;
  emailAddress?: InputMaybe<SortEnumType>;
  embryologist?: InputMaybe<SortEnumType>;
  equipmentType?: InputMaybe<SortEnumType>;
  etSearch?: InputMaybe<SortEnumType>;
  farmlocation?: InputMaybe<SortEnumType>;
  herdsman?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inTraining?: InputMaybe<SortEnumType>;
  isDisabled?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  skills?: InputMaybe<SortEnumType>;
  systemUser?: InputMaybe<SystemUserSortInput>;
  systemUserId?: InputMaybe<SortEnumType>;
  technician?: InputMaybe<SortEnumType>;
  timeZoneCode?: InputMaybe<SortEnumType>;
  togEmployee?: InputMaybe<SortEnumType>;
  veterinarian?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EquipmentsCollectionSegment = {
  __typename: 'EquipmentsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Equipment>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Feature = {
  __typename: 'Feature';
  accounts: Array<FeatureTogAccount>;
  adGroups: Array<FeatureAdGroup>;
  adUsers: Array<FeatureAdUser>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureAdGroup = {
  __typename: 'FeatureAdGroup';
  adGroup: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  feature: Feature;
  featureId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureAdGroupFilterInput = {
  adGroup?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<FeatureAdGroupFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  feature?: InputMaybe<FeatureFilterInput>;
  featureId?: InputMaybe<UuidOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FeatureAdGroupFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FeatureAdUser = {
  __typename: 'FeatureAdUser';
  adUserId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  feature: Feature;
  featureId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  user: Maybe<SystemUser>;
};

export type FeatureAdUserFilterInput = {
  adUserId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<FeatureAdUserFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  feature?: InputMaybe<FeatureFilterInput>;
  featureId?: InputMaybe<UuidOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FeatureAdUserFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FeatureFilterInput = {
  accounts?: InputMaybe<ListFilterInputTypeOfFeatureTogAccountFilterInput>;
  adGroups?: InputMaybe<ListFilterInputTypeOfFeatureAdGroupFilterInput>;
  adUsers?: InputMaybe<ListFilterInputTypeOfFeatureAdUserFilterInput>;
  and?: InputMaybe<Array<FeatureFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FeatureFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FeatureSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type FeatureTogAccount = {
  __typename: 'FeatureTogAccount';
  account: Account;
  accountId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  feature: Feature;
  featureId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureTogAccountFilterInput = {
  accountId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<FeatureTogAccountFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  feature?: InputMaybe<FeatureFilterInput>;
  featureId?: InputMaybe<UuidOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FeatureTogAccountFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A segment of a collection. */
export type FeaturesCollectionSegment = {
  __typename: 'FeaturesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Feature>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type FertCommentsInGridListCollectionSegment = {
  __typename: 'FertCommentsInGridListCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<CommentType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type FertCommentsListCollectionSegment = {
  __typename: 'FertCommentsListCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<CommentType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type FertSiteType = {
  __typename: 'FertSiteType';
  guidValue: Scalars['UUID']['output'];
  intValue: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FertSiteTypeFilterInput = {
  and?: InputMaybe<Array<FertSiteTypeFilterInput>>;
  guidValue?: InputMaybe<UuidOperationFilterInput>;
  intValue?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FertSiteTypeFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type FertSiteTypeSortInput = {
  guidValue?: InputMaybe<SortEnumType>;
  intValue?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type FertSitesCollectionSegment = {
  __typename: 'FertSitesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<FertSiteType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Fertilization = {
  __typename: 'Fertilization';
  aspiration: Maybe<Aspiration>;
  aspirationId: Maybe<Scalars['UUID']['output']>;
  aspirationPool: Maybe<AspirationPool>;
  aspirationPoolId: Maybe<Scalars['UUID']['output']>;
  batch: Maybe<Scalars['String']['output']>;
  billIncubator: Maybe<Scalars['Boolean']['output']>;
  billIncubator2: Maybe<Scalars['Boolean']['output']>;
  billShipping: Maybe<Scalars['Boolean']['output']>;
  billStatus: Maybe<Scalars['Int']['output']>;
  billUnits: Maybe<Scalars['Decimal']['output']>;
  billshipping2: Maybe<Scalars['Boolean']['output']>;
  breed: Maybe<Breed>;
  bsVerified: Maybe<Scalars['Boolean']['output']>;
  cleaved: Maybe<Scalars['Int']['output']>;
  /** @deprecated use tog_discardclient instead */
  clientDiscard: Maybe<Scalars['Int']['output']>;
  clientGrade1: Maybe<Scalars['Int']['output']>;
  clientGrade2: Maybe<Scalars['Int']['output']>;
  clientGrade3: Maybe<Scalars['Int']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  conc: Maybe<Scalars['Float']['output']>;
  contaminantPresent: Maybe<tog_contaminations>;
  contaminationInFert: Maybe<tog_contaminations>;
  contaminationInMat: Maybe<tog_contaminations>;
  createdBy: Maybe<SystemUser>;
  createdByApp: Maybe<Scalars['Int']['output']>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  credSemenComment: Maybe<Scalars['String']['output']>;
  creditSemen: Maybe<Scalars['Int']['output']>;
  day5esttrans: Maybe<Scalars['Int']['output']>;
  deRecip: Maybe<Scalars['String']['output']>;
  deYard: Maybe<Yard>;
  deYardId: Maybe<Scalars['UUID']['output']>;
  debugInfo: Maybe<Scalars['String']['output']>;
  degenerates: Maybe<Scalars['Int']['output']>;
  discardClient: Maybe<Scalars['Int']['output']>;
  discarded: Maybe<Scalars['Int']['output']>;
  discardedGrade1: Maybe<Scalars['Int']['output']>;
  discardedGrade2: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `donorSchedule.donor` instead */
  donor: Maybe<Donor>;
  /** @deprecated Use `donorSchedule.donorId` instead */
  donorId: Maybe<Scalars['UUID']['output']>;
  donorSchedule: Maybe<DonorSchedule>;
  donorScheduleId: Maybe<Scalars['UUID']['output']>;
  donorSchedules: Array<DonorSchedule>;
  embryoScore: Maybe<Scalars['Int']['output']>;
  embryos: Array<Embryo>;
  errorCode: Maybe<Scalars['Decimal']['output']>;
  export: Maybe<Scalars['Int']['output']>;
  fdcLot: Maybe<Scalars['String']['output']>;
  fertValidationDate: Maybe<Scalars['DateTime']['output']>;
  fertValidator: Maybe<Equipment>;
  fertValidatorId: Maybe<Scalars['UUID']['output']>;
  flexFieldPartner: Maybe<Scalars['String']['output']>;
  flshId: Maybe<Scalars['String']['output']>;
  flushIdNumber: Maybe<Scalars['Int']['output']>;
  freezable: Maybe<Scalars['Int']['output']>;
  freezeComment: Maybe<Scalars['String']['output']>;
  freezeMethod: Maybe<OptionSet>;
  freezeMethodId: Maybe<Scalars['UUID']['output']>;
  freezeTechnician: Maybe<Equipment>;
  freezeTechnicianId: Maybe<Scalars['UUID']['output']>;
  freshShipment: Maybe<tog_freshshipmentBase>;
  freshShipment2: Maybe<tog_freshshipmentBase>;
  freshShipmentId: Maybe<Scalars['UUID']['output']>;
  freshShipmentId2: Maybe<Scalars['UUID']['output']>;
  frozeClient: Maybe<Scalars['Int']['output']>;
  frozeValidationDate: Maybe<Scalars['DateTime']['output']>;
  frozeValidator: Maybe<Equipment>;
  frozeValidatorId: Maybe<Scalars['UUID']['output']>;
  frozen: Maybe<Scalars['Int']['output']>;
  frzCane: Maybe<Scalars['String']['output']>;
  frzFreezeMethod: Maybe<OptionSet>;
  frzFreezeMethodId: Maybe<Scalars['UUID']['output']>;
  frzFreezeTechnician: Maybe<Scalars['String']['output']>;
  frzFreezeTime: Maybe<Scalars['String']['output']>;
  frzFreezer: Maybe<Scalars['String']['output']>;
  frzOwner: Maybe<Account>;
  frzOwnerId: Maybe<Scalars['UUID']['output']>;
  frzStorageLocation: Maybe<StorageLocation>;
  frzStorageLocationId: Maybe<Scalars['UUID']['output']>;
  frzTt: Maybe<Scalars['Boolean']['output']>;
  gpBatch: Maybe<Scalars['String']['output']>;
  grade1: Maybe<Scalars['Int']['output']>;
  grade2: Maybe<Scalars['Int']['output']>;
  grade2Minus: Maybe<Scalars['Int']['output']>;
  grade3: Maybe<Scalars['Int']['output']>;
  grade42Minus: Maybe<Scalars['Int']['output']>;
  grader: Maybe<Equipment>;
  grader6: Maybe<Scalars['String']['output']>;
  graderId: Maybe<Scalars['UUID']['output']>;
  hasFewMotileSperm: Maybe<Scalars['Boolean']['output']>;
  hasNoMotileSperm: Maybe<Scalars['Boolean']['output']>;
  hasPoorCytoplasmQuality: Maybe<Scalars['Boolean']['output']>;
  hasTwoCellCleavage: Maybe<Scalars['Boolean']['output']>;
  heldAtTogForTransfer: Maybe<Scalars['Int']['output']>;
  heldAtTogFreezeTransferLowGrade: Maybe<Scalars['Int']['output']>;
  heldAtTogToFreeze: Maybe<Scalars['Int']['output']>;
  heparIn: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  implantPriceOf: Maybe<Scalars['Decimal']['output']>;
  implantTierOf: Maybe<Scalars['Int']['output']>;
  isFragile: Maybe<Scalars['Boolean']['output']>;
  isHardToStrip: Maybe<Scalars['Boolean']['output']>;
  ivcBroken: Maybe<Scalars['Int']['output']>;
  ivcComment: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `strippedAt` instead */
  ivcDate: Maybe<Scalars['DateTime']['output']>;
  ivcDead: Maybe<Scalars['Int']['output']>;
  ivcExtra: Maybe<Scalars['Int']['output']>;
  ivcImmature: Maybe<Scalars['Int']['output']>;
  ivcMissing: Maybe<Scalars['Int']['output']>;
  ivcNumber: Maybe<Scalars['Int']['output']>;
  ivcTechnician: Maybe<Equipment>;
  ivcTechnicianId: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Use `strippedAt` instead */
  ivcTime: Maybe<Scalars['String']['output']>;
  ivfDate: Maybe<Scalars['Date']['output']>;
  ivfLabTechnician1: Maybe<Equipment>;
  ivfLabTechnician1Id: Maybe<Scalars['UUID']['output']>;
  ivfLabTechnician2: Maybe<Equipment>;
  ivfLabTechnician2Id: Maybe<Scalars['UUID']['output']>;
  ivfNumber: Maybe<Scalars['Int']['output']>;
  ivfTime: Maybe<Scalars['String']['output']>;
  loadDonorPartners: Maybe<Scalars['Int']['output']>;
  loadDonorPartnersFrz: Maybe<Scalars['Int']['output']>;
  loadedInStraws: Maybe<Scalars['Int']['output']>;
  lowProdValidationDate: Maybe<Scalars['DateTime']['output']>;
  lowProdValidator: Maybe<Equipment>;
  lowProdValidatorId: Maybe<Scalars['UUID']['output']>;
  mating: Maybe<Scalars['String']['output']>;
  matings: Maybe<Scalars['Int']['output']>;
  matings2: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  mofloNum: Maybe<Scalars['String']['output']>;
  noEmbryosProduced: Maybe<tog_noembryosproduced>;
  number: Maybe<Scalars['Int']['output']>;
  oocyteScore: Maybe<Scalars['Int']['output']>;
  origHeldAtTog: Maybe<Scalars['Int']['output']>;
  origShipped: Maybe<Scalars['Int']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  packagingFee: Maybe<Scalars['Boolean']['output']>;
  packagingFee2: Maybe<Scalars['Boolean']['output']>;
  plan: Maybe<Scalars['Int']['output']>;
  plate: Maybe<Scalars['Int']['output']>;
  plateNumber: Maybe<Scalars['Decimal']['output']>;
  predictedBy: Maybe<Equipment>;
  predictedById: Maybe<Scalars['UUID']['output']>;
  predictedByName: Maybe<Scalars['String']['output']>;
  predictedComment: Maybe<Scalars['String']['output']>;
  predictedCommentOnly: Maybe<Scalars['String']['output']>;
  predictedGood: Maybe<Scalars['Int']['output']>;
  predictedLow: Maybe<Scalars['Int']['output']>;
  predictedVeryLow: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `donorSchedule.donor` instead */
  probableDonor: Maybe<Donor>;
  /** @deprecated Use `donorSchedule.donorId` instead */
  probableDonorId: Maybe<Scalars['UUID']['output']>;
  procId: Maybe<Scalars['String']['output']>;
  processingTechnician: Maybe<Equipment>;
  processingTechnicianId: Maybe<Scalars['UUID']['output']>;
  prodres: Maybe<Scalars['Int']['output']>;
  programName: Maybe<Scalars['String']['output']>;
  qcCultureIncubator: Maybe<Scalars['String']['output']>;
  qcCulturePlate: Maybe<Scalars['String']['output']>;
  qcEHMDate: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate10ml: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate20ml: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate40ml: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate125ml: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate250ml: Maybe<Scalars['DateTime']['output']>;
  qcFertMedia: Maybe<Scalars['DateTime']['output']>;
  qcFertPlate: Maybe<Scalars['String']['output']>;
  qcHoeschtLot: Maybe<Scalars['String']['output']>;
  qcHoldingsOfDate: Maybe<Scalars['DateTime']['output']>;
  qcIncubator: Maybe<incubators>;
  qcIncubatorId: Maybe<Scalars['UUID']['output']>;
  qcIsolate: Maybe<Scalars['String']['output']>;
  qcMineralOil: Maybe<Scalars['String']['output']>;
  qcOvaHepesLot: Maybe<Scalars['String']['output']>;
  qcSerum: Maybe<Scalars['String']['output']>;
  qcShippingTubeExpirationDate: Maybe<Scalars['DateTime']['output']>;
  qcShippingsOfDate: Maybe<Scalars['DateTime']['output']>;
  qcSofDate: Maybe<Scalars['DateTime']['output']>;
  qcTrisLot: Maybe<Scalars['String']['output']>;
  recipOwner: Maybe<Account>;
  recipOwnerId: Maybe<Scalars['UUID']['output']>;
  recipient: Maybe<Recipient>;
  recipientId: Maybe<Scalars['UUID']['output']>;
  resultsComment: Maybe<Scalars['String']['output']>;
  rsPool: Maybe<Scalars['Int']['output']>;
  semen: Maybe<Semen>;
  semenFee: Maybe<Scalars['Decimal']['output']>;
  semenId: Maybe<Scalars['UUID']['output']>;
  semenOwner: Maybe<Account>;
  semenOwnerId: Maybe<Scalars['UUID']['output']>;
  semenScore: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `donorSchedule.semenType` instead */
  semenType: Maybe<Scalars['Int']['output']>;
  semenUnits: Maybe<Scalars['Int']['output']>;
  sheathFluidDate: Maybe<Scalars['DateTime']['output']>;
  shipGroup: Maybe<Scalars['String']['output']>;
  shipRecipGroup: Maybe<Scalars['String']['output']>;
  shipValidationDate: Maybe<Scalars['DateTime']['output']>;
  shipValidator: Maybe<Equipment>;
  shipValidatorId: Maybe<Scalars['UUID']['output']>;
  shipmentGroupId: Maybe<Scalars['UUID']['output']>;
  shipmentGroupMaster: Maybe<ShipmentGroupMaster>;
  shipmentGroupMaster2: Maybe<ShipmentGroupMaster>;
  shipmentGroupMaster2Id: Maybe<Scalars['UUID']['output']>;
  shipmentGroupMasterId: Maybe<Scalars['UUID']['output']>;
  shipped: Maybe<Scalars['Int']['output']>;
  shipped2: Maybe<Scalars['Int']['output']>;
  shippedBillable: Maybe<Scalars['Decimal']['output']>;
  shippedBillable2: Maybe<Scalars['Decimal']['output']>;
  shippedTog: Maybe<Scalars['Int']['output']>;
  shippedTog2: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `donorSchedule.sire` instead */
  sire: Maybe<Sire>;
  /** @deprecated Use `donorSchedule.sireId` instead */
  sireId: Maybe<Scalars['UUID']['output']>;
  sireTogIds: Maybe<Scalars['String']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  /** Combines ivcDate + ivcTime in UTC */
  strippedAt: Maybe<Scalars['DateTime']['output']>;
  stripperTipLotNumber: Maybe<Scalars['String']['output']>;
  transValidationDate: Maybe<Scalars['DateTime']['output']>;
  transValidator: Maybe<Equipment>;
  transValidatorId: Maybe<Scalars['UUID']['output']>;
  transferClient: Maybe<Scalars['Int']['output']>;
  transferable: Maybe<Scalars['Int']['output']>;
  transferred: Maybe<Scalars['Int']['output']>;
  trfClinicRanchHaulIn: Maybe<Scalars['Int']['output']>;
  trfOwner: Maybe<Account>;
  trfOwnerId: Maybe<Scalars['UUID']['output']>;
  trfSite: Maybe<Site>;
  trfSiteId: Maybe<Scalars['UUID']['output']>;
  tt: Maybe<Scalars['Boolean']['output']>;
  tubeNumber: Maybe<Scalars['Decimal']['output']>;
  updateSemen: Maybe<Scalars['Boolean']['output']>;
};


export type FertilizationstrippedAtArgs = {
  ianaTimeZone: Scalars['String']['input'];
};

export type FertilizationData = {
  __typename: 'FertilizationData';
  aspDate: Maybe<Scalars['String']['output']>;
  clv: Maybe<Scalars['String']['output']>;
  donorId: Maybe<Scalars['String']['output']>;
  fert: Maybe<Scalars['String']['output']>;
  follL: Maybe<Scalars['String']['output']>;
  follM: Maybe<Scalars['String']['output']>;
  follS: Maybe<Scalars['String']['output']>;
  follicles: Maybe<Scalars['String']['output']>;
  fsh: Maybe<Scalars['String']['output']>;
  gradeAbc: Maybe<Scalars['String']['output']>;
  gradeD: Maybe<Scalars['String']['output']>;
  gradeE: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  oocytes: Maybe<Scalars['String']['output']>;
  sched: Maybe<Scalars['String']['output']>;
  sire: Maybe<Scalars['String']['output']>;
  sireId: Maybe<Scalars['UUID']['output']>;
  viable: Maybe<Scalars['String']['output']>;
};

export type FertilizationDataChuteside = {
  __typename: 'FertilizationDataChuteside';
  aspDate: Scalars['String']['output'];
  clls: Scalars['String']['output'];
  clrs: Scalars['String']['output'];
  clv: Scalars['String']['output'];
  cystsL: Scalars['String']['output'];
  cystsR: Scalars['String']['output'];
  donorId: Scalars['String']['output'];
  fert: Scalars['String']['output'];
  follL: Scalars['String']['output'];
  follM: Scalars['String']['output'];
  follS: Scalars['String']['output'];
  fsh: Scalars['String']['output'];
  id: Maybe<Scalars['Long']['output']>;
  ooc: Scalars['String']['output'];
  percentAbc: Scalars['String']['output'];
  sched: Scalars['String']['output'];
  sire: Scalars['String']['output'];
  tech: Scalars['String']['output'];
  viable: Scalars['String']['output'];
};

export type FertilizationDataInput = {
  aspDate?: InputMaybe<Scalars['String']['input']>;
  clv?: InputMaybe<Scalars['String']['input']>;
  donorId?: InputMaybe<Scalars['String']['input']>;
  fert?: InputMaybe<Scalars['String']['input']>;
  follL?: InputMaybe<Scalars['String']['input']>;
  follM?: InputMaybe<Scalars['String']['input']>;
  follS?: InputMaybe<Scalars['String']['input']>;
  follicles?: InputMaybe<Scalars['String']['input']>;
  fsh?: InputMaybe<Scalars['String']['input']>;
  gradeAbc?: InputMaybe<Scalars['String']['input']>;
  gradeD?: InputMaybe<Scalars['String']['input']>;
  gradeE?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  oocytes?: InputMaybe<Scalars['String']['input']>;
  sched?: InputMaybe<Scalars['String']['input']>;
  sire?: InputMaybe<Scalars['String']['input']>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  viable?: InputMaybe<Scalars['String']['input']>;
};

export type FertilizationDonorScheduleType = {
  __typename: 'FertilizationDonorScheduleType';
  accountID: Scalars['UUID']['output'];
  accountNumber: Scalars['String']['output'];
  aspDate: Scalars['DateTime']['output'];
  aspirationID: Maybe<Scalars['UUID']['output']>;
  aspirationPoolID: Maybe<Scalars['UUID']['output']>;
  backupSemenID: Maybe<Scalars['UUID']['output']>;
  backupSemenName: Scalars['String']['output'];
  donorBreed: Scalars['String']['output'];
  donorBreedName: Scalars['String']['output'];
  donorName: Scalars['String']['output'];
  donorScheduleID: Scalars['UUID']['output'];
  exportName: Scalars['String']['output'];
  ivmMat: Scalars['String']['output'];
  matTime: Scalars['String']['output'];
  name_Type: Scalars['String']['output'];
  semenComment: Scalars['String']['output'];
  semenID: Maybe<Scalars['UUID']['output']>;
  semenName: Scalars['String']['output'];
  semenTypeName: Scalars['String']['output'];
};

export type FertilizationDonorScheduleTypeFilterInput = {
  accountID?: InputMaybe<UuidOperationFilterInput>;
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<FertilizationDonorScheduleTypeFilterInput>>;
  aspDate?: InputMaybe<DateTimeOperationFilterInput>;
  aspirationID?: InputMaybe<UuidOperationFilterInput>;
  aspirationPoolID?: InputMaybe<UuidOperationFilterInput>;
  backupSemenID?: InputMaybe<UuidOperationFilterInput>;
  backupSemenName?: InputMaybe<StringOperationFilterInput>;
  donorBreed?: InputMaybe<StringOperationFilterInput>;
  donorBreedName?: InputMaybe<StringOperationFilterInput>;
  donorName?: InputMaybe<StringOperationFilterInput>;
  donorScheduleID?: InputMaybe<UuidOperationFilterInput>;
  exportName?: InputMaybe<StringOperationFilterInput>;
  ivmMat?: InputMaybe<StringOperationFilterInput>;
  matTime?: InputMaybe<StringOperationFilterInput>;
  name_Type?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FertilizationDonorScheduleTypeFilterInput>>;
  semenComment?: InputMaybe<StringOperationFilterInput>;
  semenID?: InputMaybe<UuidOperationFilterInput>;
  semenName?: InputMaybe<StringOperationFilterInput>;
  semenTypeName?: InputMaybe<StringOperationFilterInput>;
};

export type FertilizationDonorScheduleTypeSortInput = {
  accountID?: InputMaybe<SortEnumType>;
  accountNumber?: InputMaybe<SortEnumType>;
  aspDate?: InputMaybe<SortEnumType>;
  aspirationID?: InputMaybe<SortEnumType>;
  aspirationPoolID?: InputMaybe<SortEnumType>;
  backupSemenID?: InputMaybe<SortEnumType>;
  backupSemenName?: InputMaybe<SortEnumType>;
  donorBreed?: InputMaybe<SortEnumType>;
  donorBreedName?: InputMaybe<SortEnumType>;
  donorName?: InputMaybe<SortEnumType>;
  donorScheduleID?: InputMaybe<SortEnumType>;
  exportName?: InputMaybe<SortEnumType>;
  ivmMat?: InputMaybe<SortEnumType>;
  matTime?: InputMaybe<SortEnumType>;
  name_Type?: InputMaybe<SortEnumType>;
  semenComment?: InputMaybe<SortEnumType>;
  semenID?: InputMaybe<SortEnumType>;
  semenName?: InputMaybe<SortEnumType>;
  semenTypeName?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type FertilizationDonorSchedulesCollectionSegment = {
  __typename: 'FertilizationDonorSchedulesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<FertilizationDonorScheduleType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type FertilizationFilterInput = {
  and?: InputMaybe<Array<FertilizationFilterInput>>;
  aspiration?: InputMaybe<AspirationFilterInput>;
  aspirationId?: InputMaybe<UuidOperationFilterInput>;
  aspirationPool?: InputMaybe<AspirationPoolFilterInput>;
  aspirationPoolId?: InputMaybe<UuidOperationFilterInput>;
  batch?: InputMaybe<StringOperationFilterInput>;
  billIncubator?: InputMaybe<BooleanOperationFilterInput>;
  billIncubator2?: InputMaybe<BooleanOperationFilterInput>;
  billShipping?: InputMaybe<BooleanOperationFilterInput>;
  billStatus?: InputMaybe<IntOperationFilterInput>;
  billUnits?: InputMaybe<DecimalOperationFilterInput>;
  billshipping2?: InputMaybe<BooleanOperationFilterInput>;
  bsVerified?: InputMaybe<BooleanOperationFilterInput>;
  cleaved?: InputMaybe<IntOperationFilterInput>;
  clientGrade1?: InputMaybe<IntOperationFilterInput>;
  clientGrade2?: InputMaybe<IntOperationFilterInput>;
  clientGrade3?: InputMaybe<IntOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  conc?: InputMaybe<FloatOperationFilterInput>;
  contaminantPresent?: InputMaybe<NullableOftog_contaminationsOperationFilterInput>;
  contaminationInFert?: InputMaybe<NullableOftog_contaminationsOperationFilterInput>;
  contaminationInMat?: InputMaybe<NullableOftog_contaminationsOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdByApp?: InputMaybe<IntOperationFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  credSemenComment?: InputMaybe<StringOperationFilterInput>;
  creditSemen?: InputMaybe<IntOperationFilterInput>;
  day5esttrans?: InputMaybe<IntOperationFilterInput>;
  deRecip?: InputMaybe<StringOperationFilterInput>;
  deYard?: InputMaybe<YardFilterInput>;
  deYardId?: InputMaybe<UuidOperationFilterInput>;
  debugInfo?: InputMaybe<StringOperationFilterInput>;
  degenerates?: InputMaybe<IntOperationFilterInput>;
  discardClient?: InputMaybe<IntOperationFilterInput>;
  discarded?: InputMaybe<IntOperationFilterInput>;
  discardedGrade1?: InputMaybe<IntOperationFilterInput>;
  discardedGrade2?: InputMaybe<IntOperationFilterInput>;
  donorSchedule?: InputMaybe<DonorScheduleFilterInput>;
  donorScheduleId?: InputMaybe<UuidOperationFilterInput>;
  donorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  embryoScore?: InputMaybe<IntOperationFilterInput>;
  embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  errorCode?: InputMaybe<DecimalOperationFilterInput>;
  export?: InputMaybe<IntOperationFilterInput>;
  fdcLot?: InputMaybe<StringOperationFilterInput>;
  fertValidationDate?: InputMaybe<DateTimeOperationFilterInput>;
  fertValidator?: InputMaybe<EquipmentFilterInput>;
  fertValidatorId?: InputMaybe<UuidOperationFilterInput>;
  flexFieldPartner?: InputMaybe<StringOperationFilterInput>;
  flshId?: InputMaybe<StringOperationFilterInput>;
  flushIdNumber?: InputMaybe<IntOperationFilterInput>;
  freezable?: InputMaybe<IntOperationFilterInput>;
  freezeComment?: InputMaybe<StringOperationFilterInput>;
  freezeMethod?: InputMaybe<OptionSetFilterInput>;
  freezeMethodId?: InputMaybe<UuidOperationFilterInput>;
  freezeTechnician?: InputMaybe<EquipmentFilterInput>;
  freezeTechnicianId?: InputMaybe<UuidOperationFilterInput>;
  freshShipment?: InputMaybe<tog_freshshipmentBaseFilterInput>;
  freshShipment2?: InputMaybe<tog_freshshipmentBaseFilterInput>;
  freshShipmentId?: InputMaybe<UuidOperationFilterInput>;
  freshShipmentId2?: InputMaybe<UuidOperationFilterInput>;
  frozeClient?: InputMaybe<IntOperationFilterInput>;
  frozeValidationDate?: InputMaybe<DateTimeOperationFilterInput>;
  frozeValidator?: InputMaybe<EquipmentFilterInput>;
  frozeValidatorId?: InputMaybe<UuidOperationFilterInput>;
  frozen?: InputMaybe<IntOperationFilterInput>;
  frzCane?: InputMaybe<StringOperationFilterInput>;
  frzFreezeMethod?: InputMaybe<OptionSetFilterInput>;
  frzFreezeMethodId?: InputMaybe<UuidOperationFilterInput>;
  frzFreezeTechnician?: InputMaybe<StringOperationFilterInput>;
  frzFreezeTime?: InputMaybe<StringOperationFilterInput>;
  frzFreezer?: InputMaybe<StringOperationFilterInput>;
  frzOwner?: InputMaybe<AccountFilterInput>;
  frzOwnerId?: InputMaybe<UuidOperationFilterInput>;
  frzStorageLocation?: InputMaybe<StorageLocationFilterInput>;
  frzStorageLocationId?: InputMaybe<UuidOperationFilterInput>;
  frzTt?: InputMaybe<BooleanOperationFilterInput>;
  gpBatch?: InputMaybe<StringOperationFilterInput>;
  grade1?: InputMaybe<IntOperationFilterInput>;
  grade2?: InputMaybe<IntOperationFilterInput>;
  grade2Minus?: InputMaybe<IntOperationFilterInput>;
  grade3?: InputMaybe<IntOperationFilterInput>;
  grade42Minus?: InputMaybe<IntOperationFilterInput>;
  grader?: InputMaybe<EquipmentFilterInput>;
  grader6?: InputMaybe<StringOperationFilterInput>;
  graderId?: InputMaybe<UuidOperationFilterInput>;
  hasFewMotileSperm?: InputMaybe<BooleanOperationFilterInput>;
  hasNoMotileSperm?: InputMaybe<BooleanOperationFilterInput>;
  hasPoorCytoplasmQuality?: InputMaybe<BooleanOperationFilterInput>;
  hasTwoCellCleavage?: InputMaybe<BooleanOperationFilterInput>;
  heldAtTogForTransfer?: InputMaybe<IntOperationFilterInput>;
  heldAtTogFreezeTransferLowGrade?: InputMaybe<IntOperationFilterInput>;
  heldAtTogToFreeze?: InputMaybe<IntOperationFilterInput>;
  heparIn?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  implantPriceOf?: InputMaybe<DecimalOperationFilterInput>;
  implantTierOf?: InputMaybe<IntOperationFilterInput>;
  isFragile?: InputMaybe<BooleanOperationFilterInput>;
  isHardToStrip?: InputMaybe<BooleanOperationFilterInput>;
  ivcBroken?: InputMaybe<IntOperationFilterInput>;
  ivcComment?: InputMaybe<StringOperationFilterInput>;
  ivcDead?: InputMaybe<IntOperationFilterInput>;
  ivcExtra?: InputMaybe<IntOperationFilterInput>;
  ivcImmature?: InputMaybe<IntOperationFilterInput>;
  ivcMissing?: InputMaybe<IntOperationFilterInput>;
  ivcNumber?: InputMaybe<IntOperationFilterInput>;
  ivcTechnician?: InputMaybe<EquipmentFilterInput>;
  ivcTechnicianId?: InputMaybe<UuidOperationFilterInput>;
  ivfDate?: InputMaybe<DateTimeOperationFilterInput>;
  ivfLabTechnician1?: InputMaybe<EquipmentFilterInput>;
  ivfLabTechnician1Id?: InputMaybe<UuidOperationFilterInput>;
  ivfLabTechnician2?: InputMaybe<EquipmentFilterInput>;
  ivfLabTechnician2Id?: InputMaybe<UuidOperationFilterInput>;
  ivfNumber?: InputMaybe<IntOperationFilterInput>;
  ivfTime?: InputMaybe<StringOperationFilterInput>;
  loadDonorPartners?: InputMaybe<IntOperationFilterInput>;
  loadDonorPartnersFrz?: InputMaybe<IntOperationFilterInput>;
  loadedInStraws?: InputMaybe<IntOperationFilterInput>;
  lowProdValidationDate?: InputMaybe<DateTimeOperationFilterInput>;
  lowProdValidator?: InputMaybe<EquipmentFilterInput>;
  lowProdValidatorId?: InputMaybe<UuidOperationFilterInput>;
  mating?: InputMaybe<StringOperationFilterInput>;
  matings?: InputMaybe<IntOperationFilterInput>;
  matings2?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  mofloNum?: InputMaybe<StringOperationFilterInput>;
  noEmbryosProduced?: InputMaybe<NullableOftog_noembryosproducedOperationFilterInput>;
  number?: InputMaybe<IntOperationFilterInput>;
  oocyteScore?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FertilizationFilterInput>>;
  origHeldAtTog?: InputMaybe<IntOperationFilterInput>;
  origShipped?: InputMaybe<IntOperationFilterInput>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  packagingFee?: InputMaybe<BooleanOperationFilterInput>;
  packagingFee2?: InputMaybe<BooleanOperationFilterInput>;
  plan?: InputMaybe<IntOperationFilterInput>;
  plate?: InputMaybe<IntOperationFilterInput>;
  plateNumber?: InputMaybe<DecimalOperationFilterInput>;
  predictedBy?: InputMaybe<EquipmentFilterInput>;
  predictedById?: InputMaybe<UuidOperationFilterInput>;
  predictedByName?: InputMaybe<StringOperationFilterInput>;
  predictedComment?: InputMaybe<StringOperationFilterInput>;
  predictedCommentOnly?: InputMaybe<StringOperationFilterInput>;
  predictedGood?: InputMaybe<IntOperationFilterInput>;
  predictedLow?: InputMaybe<IntOperationFilterInput>;
  predictedVeryLow?: InputMaybe<IntOperationFilterInput>;
  procId?: InputMaybe<StringOperationFilterInput>;
  processingTechnician?: InputMaybe<EquipmentFilterInput>;
  processingTechnicianId?: InputMaybe<UuidOperationFilterInput>;
  prodres?: InputMaybe<IntOperationFilterInput>;
  programName?: InputMaybe<StringOperationFilterInput>;
  qcCultureIncubator?: InputMaybe<StringOperationFilterInput>;
  qcCulturePlate?: InputMaybe<StringOperationFilterInput>;
  qcEHMDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcEHMDate10ml?: InputMaybe<DateTimeOperationFilterInput>;
  qcEHMDate20ml?: InputMaybe<DateTimeOperationFilterInput>;
  qcEHMDate40ml?: InputMaybe<DateTimeOperationFilterInput>;
  qcEHMDate125ml?: InputMaybe<DateTimeOperationFilterInput>;
  qcEHMDate250ml?: InputMaybe<DateTimeOperationFilterInput>;
  qcFertMedia?: InputMaybe<DateTimeOperationFilterInput>;
  qcFertPlate?: InputMaybe<StringOperationFilterInput>;
  qcHoeschtLot?: InputMaybe<StringOperationFilterInput>;
  qcHoldingsOfDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcIncubator?: InputMaybe<incubatorsFilterInput>;
  qcIncubatorId?: InputMaybe<UuidOperationFilterInput>;
  qcIsolate?: InputMaybe<StringOperationFilterInput>;
  qcMineralOil?: InputMaybe<StringOperationFilterInput>;
  qcOvaHepesLot?: InputMaybe<StringOperationFilterInput>;
  qcSerum?: InputMaybe<StringOperationFilterInput>;
  qcShippingTubeExpirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcShippingsOfDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcSofDate?: InputMaybe<DateTimeOperationFilterInput>;
  qcTrisLot?: InputMaybe<StringOperationFilterInput>;
  recipOwner?: InputMaybe<AccountFilterInput>;
  recipOwnerId?: InputMaybe<UuidOperationFilterInput>;
  recipient?: InputMaybe<RecipientFilterInput>;
  recipientId?: InputMaybe<UuidOperationFilterInput>;
  resultsComment?: InputMaybe<StringOperationFilterInput>;
  rsPool?: InputMaybe<IntOperationFilterInput>;
  semen?: InputMaybe<SemenFilterInput>;
  semenFee?: InputMaybe<DecimalOperationFilterInput>;
  semenId?: InputMaybe<UuidOperationFilterInput>;
  semenOwner?: InputMaybe<AccountFilterInput>;
  semenOwnerId?: InputMaybe<UuidOperationFilterInput>;
  semenScore?: InputMaybe<IntOperationFilterInput>;
  semenUnits?: InputMaybe<IntOperationFilterInput>;
  sheathFluidDate?: InputMaybe<DateTimeOperationFilterInput>;
  shipGroup?: InputMaybe<StringOperationFilterInput>;
  shipRecipGroup?: InputMaybe<StringOperationFilterInput>;
  shipValidationDate?: InputMaybe<DateTimeOperationFilterInput>;
  shipValidator?: InputMaybe<EquipmentFilterInput>;
  shipValidatorId?: InputMaybe<UuidOperationFilterInput>;
  shipmentGroupId?: InputMaybe<UuidOperationFilterInput>;
  shipmentGroupMaster?: InputMaybe<ShipmentGroupMasterFilterInput>;
  shipmentGroupMaster2?: InputMaybe<ShipmentGroupMasterFilterInput>;
  shipmentGroupMaster2Id?: InputMaybe<UuidOperationFilterInput>;
  shipmentGroupMasterId?: InputMaybe<UuidOperationFilterInput>;
  shipped?: InputMaybe<IntOperationFilterInput>;
  shipped2?: InputMaybe<IntOperationFilterInput>;
  shippedBillable?: InputMaybe<DecimalOperationFilterInput>;
  shippedBillable2?: InputMaybe<DecimalOperationFilterInput>;
  shippedTog?: InputMaybe<IntOperationFilterInput>;
  shippedTog2?: InputMaybe<IntOperationFilterInput>;
  sireTogIds?: InputMaybe<StringOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  stripperTipLotNumber?: InputMaybe<StringOperationFilterInput>;
  transValidationDate?: InputMaybe<DateTimeOperationFilterInput>;
  transValidator?: InputMaybe<EquipmentFilterInput>;
  transValidatorId?: InputMaybe<UuidOperationFilterInput>;
  transferClient?: InputMaybe<IntOperationFilterInput>;
  transferable?: InputMaybe<IntOperationFilterInput>;
  transferred?: InputMaybe<IntOperationFilterInput>;
  trfClinicRanchHaulIn?: InputMaybe<IntOperationFilterInput>;
  trfOwner?: InputMaybe<AccountFilterInput>;
  trfOwnerId?: InputMaybe<UuidOperationFilterInput>;
  trfSite?: InputMaybe<SiteFilterInput>;
  trfSiteId?: InputMaybe<UuidOperationFilterInput>;
  tt?: InputMaybe<BooleanOperationFilterInput>;
  tubeNumber?: InputMaybe<DecimalOperationFilterInput>;
  updateSemen?: InputMaybe<BooleanOperationFilterInput>;
};

export type FertilizationInput = {
  aspiration?: InputMaybe<AspirationInput>;
  aspirationId?: InputMaybe<Scalars['UUID']['input']>;
  aspirationPool?: InputMaybe<AspirationPoolInput>;
  aspirationPoolId?: InputMaybe<Scalars['UUID']['input']>;
  batch?: InputMaybe<Scalars['String']['input']>;
  billIncubator?: InputMaybe<Scalars['Boolean']['input']>;
  billIncubator2?: InputMaybe<Scalars['Boolean']['input']>;
  billShipping?: InputMaybe<Scalars['Boolean']['input']>;
  billStatus?: InputMaybe<Scalars['Int']['input']>;
  billUnits?: InputMaybe<Scalars['Decimal']['input']>;
  billshipping2?: InputMaybe<Scalars['Boolean']['input']>;
  bsVerified?: InputMaybe<Scalars['Boolean']['input']>;
  cleaved?: InputMaybe<Scalars['Int']['input']>;
  clientGrade1?: InputMaybe<Scalars['Int']['input']>;
  clientGrade2?: InputMaybe<Scalars['Int']['input']>;
  clientGrade3?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  conc?: InputMaybe<Scalars['Float']['input']>;
  contaminantPresent?: InputMaybe<tog_contaminations>;
  contaminationInFert?: InputMaybe<tog_contaminations>;
  contaminationInMat?: InputMaybe<tog_contaminations>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdByApp?: InputMaybe<Scalars['Int']['input']>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  credSemenComment?: InputMaybe<Scalars['String']['input']>;
  creditSemen?: InputMaybe<Scalars['Int']['input']>;
  day5esttrans?: InputMaybe<Scalars['Int']['input']>;
  deRecip?: InputMaybe<Scalars['String']['input']>;
  deYard?: InputMaybe<YardInput>;
  deYardId?: InputMaybe<Scalars['UUID']['input']>;
  debugInfo?: InputMaybe<Scalars['String']['input']>;
  degenerates?: InputMaybe<Scalars['Int']['input']>;
  discardClient?: InputMaybe<Scalars['Int']['input']>;
  discarded?: InputMaybe<Scalars['Int']['input']>;
  discardedGrade1?: InputMaybe<Scalars['Int']['input']>;
  discardedGrade2?: InputMaybe<Scalars['Int']['input']>;
  donorSchedule?: InputMaybe<DonorScheduleInput>;
  donorScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  donorSchedules: Array<DonorScheduleInput>;
  embryoScore?: InputMaybe<Scalars['Int']['input']>;
  embryos: Array<EmbryoInput>;
  errorCode?: InputMaybe<Scalars['Decimal']['input']>;
  export?: InputMaybe<Scalars['Int']['input']>;
  fdcLot?: InputMaybe<Scalars['String']['input']>;
  fertValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  fertValidator?: InputMaybe<EquipmentInput>;
  fertValidatorId?: InputMaybe<Scalars['UUID']['input']>;
  flexFieldPartner?: InputMaybe<Scalars['String']['input']>;
  flshId?: InputMaybe<Scalars['String']['input']>;
  flushIdNumber?: InputMaybe<Scalars['Int']['input']>;
  freezable?: InputMaybe<Scalars['Int']['input']>;
  freezeComment?: InputMaybe<Scalars['String']['input']>;
  freezeMethod?: InputMaybe<OptionSetInput>;
  freezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  freezeTechnician?: InputMaybe<EquipmentInput>;
  freezeTechnicianId?: InputMaybe<Scalars['UUID']['input']>;
  freshShipment?: InputMaybe<tog_freshshipmentBaseInput>;
  freshShipment2?: InputMaybe<tog_freshshipmentBaseInput>;
  freshShipmentId?: InputMaybe<Scalars['UUID']['input']>;
  freshShipmentId2?: InputMaybe<Scalars['UUID']['input']>;
  frozeClient?: InputMaybe<Scalars['Int']['input']>;
  frozeValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  frozeValidator?: InputMaybe<EquipmentInput>;
  frozeValidatorId?: InputMaybe<Scalars['UUID']['input']>;
  frozen?: InputMaybe<Scalars['Int']['input']>;
  frzCane?: InputMaybe<Scalars['String']['input']>;
  frzFreezeMethod?: InputMaybe<OptionSetInput>;
  frzFreezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  frzFreezeTechnician?: InputMaybe<Scalars['String']['input']>;
  frzFreezeTime?: InputMaybe<Scalars['String']['input']>;
  frzFreezer?: InputMaybe<Scalars['String']['input']>;
  frzOwner?: InputMaybe<AccountInput>;
  frzOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  frzStorageLocation?: InputMaybe<StorageLocationInput>;
  frzStorageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  frzTt?: InputMaybe<Scalars['Boolean']['input']>;
  gpBatch?: InputMaybe<Scalars['String']['input']>;
  grade1?: InputMaybe<Scalars['Int']['input']>;
  grade2?: InputMaybe<Scalars['Int']['input']>;
  grade2Minus?: InputMaybe<Scalars['Int']['input']>;
  grade3?: InputMaybe<Scalars['Int']['input']>;
  grade42Minus?: InputMaybe<Scalars['Int']['input']>;
  grader?: InputMaybe<EquipmentInput>;
  grader6?: InputMaybe<Scalars['String']['input']>;
  graderId?: InputMaybe<Scalars['UUID']['input']>;
  hasFewMotileSperm?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoMotileSperm?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoorCytoplasmQuality?: InputMaybe<Scalars['Boolean']['input']>;
  hasTwoCellCleavage?: InputMaybe<Scalars['Boolean']['input']>;
  heldAtTogForTransfer?: InputMaybe<Scalars['Int']['input']>;
  heldAtTogFreezeTransferLowGrade?: InputMaybe<Scalars['Int']['input']>;
  heldAtTogToFreeze?: InputMaybe<Scalars['Int']['input']>;
  heparIn?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  implantPriceOf?: InputMaybe<Scalars['Decimal']['input']>;
  implantTierOf?: InputMaybe<Scalars['Int']['input']>;
  isFragile?: InputMaybe<Scalars['Boolean']['input']>;
  isHardToStrip?: InputMaybe<Scalars['Boolean']['input']>;
  ivcBroken?: InputMaybe<Scalars['Int']['input']>;
  ivcComment?: InputMaybe<Scalars['String']['input']>;
  ivcDead?: InputMaybe<Scalars['Int']['input']>;
  ivcExtra?: InputMaybe<Scalars['Int']['input']>;
  ivcImmature?: InputMaybe<Scalars['Int']['input']>;
  ivcMissing?: InputMaybe<Scalars['Int']['input']>;
  ivcNumber?: InputMaybe<Scalars['Int']['input']>;
  ivcTechnician?: InputMaybe<EquipmentInput>;
  ivcTechnicianId?: InputMaybe<Scalars['UUID']['input']>;
  ivfDate?: InputMaybe<Scalars['Date']['input']>;
  ivfLabTechnician1?: InputMaybe<EquipmentInput>;
  ivfLabTechnician1Id?: InputMaybe<Scalars['UUID']['input']>;
  ivfLabTechnician2?: InputMaybe<EquipmentInput>;
  ivfLabTechnician2Id?: InputMaybe<Scalars['UUID']['input']>;
  ivfNumber?: InputMaybe<Scalars['Int']['input']>;
  ivfTime?: InputMaybe<Scalars['String']['input']>;
  loadDonorPartners?: InputMaybe<Scalars['Int']['input']>;
  loadDonorPartnersFrz?: InputMaybe<Scalars['Int']['input']>;
  loadedInStraws?: InputMaybe<Scalars['Int']['input']>;
  lowProdValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  lowProdValidator?: InputMaybe<EquipmentInput>;
  lowProdValidatorId?: InputMaybe<Scalars['UUID']['input']>;
  mating?: InputMaybe<Scalars['String']['input']>;
  matings?: InputMaybe<Scalars['Int']['input']>;
  matings2?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  mofloNum?: InputMaybe<Scalars['String']['input']>;
  noEmbryosProduced?: InputMaybe<tog_noembryosproduced>;
  number?: InputMaybe<Scalars['Int']['input']>;
  oocyteScore?: InputMaybe<Scalars['Int']['input']>;
  origHeldAtTog?: InputMaybe<Scalars['Int']['input']>;
  origShipped?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  packagingFee?: InputMaybe<Scalars['Boolean']['input']>;
  packagingFee2?: InputMaybe<Scalars['Boolean']['input']>;
  plan?: InputMaybe<Scalars['Int']['input']>;
  plate?: InputMaybe<Scalars['Int']['input']>;
  plateNumber?: InputMaybe<Scalars['Decimal']['input']>;
  predictedBy?: InputMaybe<EquipmentInput>;
  predictedById?: InputMaybe<Scalars['UUID']['input']>;
  predictedByName?: InputMaybe<Scalars['String']['input']>;
  predictedComment?: InputMaybe<Scalars['String']['input']>;
  predictedCommentOnly?: InputMaybe<Scalars['String']['input']>;
  predictedGood?: InputMaybe<Scalars['Int']['input']>;
  predictedLow?: InputMaybe<Scalars['Int']['input']>;
  predictedVeryLow?: InputMaybe<Scalars['Int']['input']>;
  procId?: InputMaybe<Scalars['String']['input']>;
  processingTechnician?: InputMaybe<EquipmentInput>;
  processingTechnicianId?: InputMaybe<Scalars['UUID']['input']>;
  prodres?: InputMaybe<Scalars['Int']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  qcCultureIncubator?: InputMaybe<Scalars['String']['input']>;
  qcCulturePlate?: InputMaybe<Scalars['String']['input']>;
  qcEHMDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate10ml?: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate20ml?: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate40ml?: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate125ml?: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate250ml?: InputMaybe<Scalars['DateTime']['input']>;
  qcFertMedia?: InputMaybe<Scalars['DateTime']['input']>;
  qcFertPlate?: InputMaybe<Scalars['String']['input']>;
  qcHoeschtLot?: InputMaybe<Scalars['String']['input']>;
  qcHoldingsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcIncubator?: InputMaybe<incubatorsInput>;
  qcIncubatorId?: InputMaybe<Scalars['UUID']['input']>;
  qcIsolate?: InputMaybe<Scalars['String']['input']>;
  qcMineralOil?: InputMaybe<Scalars['String']['input']>;
  qcOvaHepesLot?: InputMaybe<Scalars['String']['input']>;
  qcSerum?: InputMaybe<Scalars['String']['input']>;
  qcShippingTubeExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcShippingsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcSofDate?: InputMaybe<Scalars['DateTime']['input']>;
  qcTrisLot?: InputMaybe<Scalars['String']['input']>;
  recipOwner?: InputMaybe<AccountInput>;
  recipOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  recipient?: InputMaybe<RecipientInput>;
  recipientId?: InputMaybe<Scalars['UUID']['input']>;
  resultsComment?: InputMaybe<Scalars['String']['input']>;
  rsPool?: InputMaybe<Scalars['Int']['input']>;
  semen?: InputMaybe<SemenInput>;
  semenFee?: InputMaybe<Scalars['Decimal']['input']>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  semenOwner?: InputMaybe<AccountInput>;
  semenOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  semenScore?: InputMaybe<Scalars['Int']['input']>;
  semenUnits?: InputMaybe<Scalars['Int']['input']>;
  sheathFluidDate?: InputMaybe<Scalars['DateTime']['input']>;
  shipGroup?: InputMaybe<Scalars['String']['input']>;
  shipRecipGroup?: InputMaybe<Scalars['String']['input']>;
  shipValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  shipValidator?: InputMaybe<EquipmentInput>;
  shipValidatorId?: InputMaybe<Scalars['UUID']['input']>;
  shipmentGroupId?: InputMaybe<Scalars['UUID']['input']>;
  shipmentGroupMaster?: InputMaybe<ShipmentGroupMasterInput>;
  shipmentGroupMaster2?: InputMaybe<ShipmentGroupMasterInput>;
  shipmentGroupMaster2Id?: InputMaybe<Scalars['UUID']['input']>;
  shipmentGroupMasterId?: InputMaybe<Scalars['UUID']['input']>;
  shipped?: InputMaybe<Scalars['Int']['input']>;
  shipped2?: InputMaybe<Scalars['Int']['input']>;
  shippedBillable?: InputMaybe<Scalars['Decimal']['input']>;
  shippedBillable2?: InputMaybe<Scalars['Decimal']['input']>;
  shippedTog?: InputMaybe<Scalars['Int']['input']>;
  shippedTog2?: InputMaybe<Scalars['Int']['input']>;
  sireTogIds?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  stripperTipLotNumber?: InputMaybe<Scalars['String']['input']>;
  transValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  transValidator?: InputMaybe<EquipmentInput>;
  transValidatorId?: InputMaybe<Scalars['UUID']['input']>;
  transferClient?: InputMaybe<Scalars['Int']['input']>;
  transferable?: InputMaybe<Scalars['Int']['input']>;
  transferred?: InputMaybe<Scalars['Int']['input']>;
  trfClinicRanchHaulIn?: InputMaybe<Scalars['Int']['input']>;
  trfOwner?: InputMaybe<AccountInput>;
  trfOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  trfSite?: InputMaybe<SiteInput>;
  trfSiteId?: InputMaybe<Scalars['UUID']['input']>;
  tt?: InputMaybe<Scalars['Boolean']['input']>;
  tubeNumber?: InputMaybe<Scalars['Decimal']['input']>;
  updateSemen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FertilizationPayload = {
  __typename: 'FertilizationPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** The id of the affected fertilization, if applicable. */
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type FertilizationQCResponse = {
  __typename: 'FertilizationQCResponse';
  qcEHMDate10ml: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate20ml: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate40ml: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate125ml: Maybe<Scalars['DateTime']['output']>;
  qcEHMDate250ml: Maybe<Scalars['DateTime']['output']>;
  qcShippingTubeExpirationDate: Maybe<Scalars['DateTime']['output']>;
  qcSofDate: Maybe<Scalars['DateTime']['output']>;
};

export type FertilizationSortInput = {
  aspiration?: InputMaybe<AspirationSortInput>;
  aspirationId?: InputMaybe<SortEnumType>;
  aspirationPool?: InputMaybe<AspirationPoolSortInput>;
  aspirationPoolId?: InputMaybe<SortEnumType>;
  batch?: InputMaybe<SortEnumType>;
  billIncubator?: InputMaybe<SortEnumType>;
  billIncubator2?: InputMaybe<SortEnumType>;
  billShipping?: InputMaybe<SortEnumType>;
  billStatus?: InputMaybe<SortEnumType>;
  billUnits?: InputMaybe<SortEnumType>;
  billshipping2?: InputMaybe<SortEnumType>;
  bsVerified?: InputMaybe<SortEnumType>;
  cleaved?: InputMaybe<SortEnumType>;
  clientGrade1?: InputMaybe<SortEnumType>;
  clientGrade2?: InputMaybe<SortEnumType>;
  clientGrade3?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  conc?: InputMaybe<SortEnumType>;
  contaminantPresent?: InputMaybe<SortEnumType>;
  contaminationInFert?: InputMaybe<SortEnumType>;
  contaminationInMat?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdByApp?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  credSemenComment?: InputMaybe<SortEnumType>;
  creditSemen?: InputMaybe<SortEnumType>;
  day5esttrans?: InputMaybe<SortEnumType>;
  deRecip?: InputMaybe<SortEnumType>;
  deYard?: InputMaybe<YardSortInput>;
  deYardId?: InputMaybe<SortEnumType>;
  debugInfo?: InputMaybe<SortEnumType>;
  degenerates?: InputMaybe<SortEnumType>;
  discardClient?: InputMaybe<SortEnumType>;
  discarded?: InputMaybe<SortEnumType>;
  discardedGrade1?: InputMaybe<SortEnumType>;
  discardedGrade2?: InputMaybe<SortEnumType>;
  donorSchedule?: InputMaybe<DonorScheduleSortInput>;
  donorScheduleId?: InputMaybe<SortEnumType>;
  embryoScore?: InputMaybe<SortEnumType>;
  errorCode?: InputMaybe<SortEnumType>;
  export?: InputMaybe<SortEnumType>;
  fdcLot?: InputMaybe<SortEnumType>;
  fertValidationDate?: InputMaybe<SortEnumType>;
  fertValidator?: InputMaybe<EquipmentSortInput>;
  fertValidatorId?: InputMaybe<SortEnumType>;
  flexFieldPartner?: InputMaybe<SortEnumType>;
  flshId?: InputMaybe<SortEnumType>;
  flushIdNumber?: InputMaybe<SortEnumType>;
  freezable?: InputMaybe<SortEnumType>;
  freezeComment?: InputMaybe<SortEnumType>;
  freezeMethod?: InputMaybe<OptionSetSortInput>;
  freezeMethodId?: InputMaybe<SortEnumType>;
  freezeTechnician?: InputMaybe<EquipmentSortInput>;
  freezeTechnicianId?: InputMaybe<SortEnumType>;
  freshShipment?: InputMaybe<tog_freshshipmentBaseSortInput>;
  freshShipment2?: InputMaybe<tog_freshshipmentBaseSortInput>;
  freshShipmentId?: InputMaybe<SortEnumType>;
  freshShipmentId2?: InputMaybe<SortEnumType>;
  frozeClient?: InputMaybe<SortEnumType>;
  frozeValidationDate?: InputMaybe<SortEnumType>;
  frozeValidator?: InputMaybe<EquipmentSortInput>;
  frozeValidatorId?: InputMaybe<SortEnumType>;
  frozen?: InputMaybe<SortEnumType>;
  frzCane?: InputMaybe<SortEnumType>;
  frzFreezeMethod?: InputMaybe<OptionSetSortInput>;
  frzFreezeMethodId?: InputMaybe<SortEnumType>;
  frzFreezeTechnician?: InputMaybe<SortEnumType>;
  frzFreezeTime?: InputMaybe<SortEnumType>;
  frzFreezer?: InputMaybe<SortEnumType>;
  frzOwner?: InputMaybe<AccountSortInput>;
  frzOwnerId?: InputMaybe<SortEnumType>;
  frzStorageLocation?: InputMaybe<StorageLocationSortInput>;
  frzStorageLocationId?: InputMaybe<SortEnumType>;
  frzTt?: InputMaybe<SortEnumType>;
  gpBatch?: InputMaybe<SortEnumType>;
  grade1?: InputMaybe<SortEnumType>;
  grade2?: InputMaybe<SortEnumType>;
  grade2Minus?: InputMaybe<SortEnumType>;
  grade3?: InputMaybe<SortEnumType>;
  grade42Minus?: InputMaybe<SortEnumType>;
  grader?: InputMaybe<EquipmentSortInput>;
  grader6?: InputMaybe<SortEnumType>;
  graderId?: InputMaybe<SortEnumType>;
  hasFewMotileSperm?: InputMaybe<SortEnumType>;
  hasNoMotileSperm?: InputMaybe<SortEnumType>;
  hasPoorCytoplasmQuality?: InputMaybe<SortEnumType>;
  hasTwoCellCleavage?: InputMaybe<SortEnumType>;
  heldAtTogForTransfer?: InputMaybe<SortEnumType>;
  heldAtTogFreezeTransferLowGrade?: InputMaybe<SortEnumType>;
  heldAtTogToFreeze?: InputMaybe<SortEnumType>;
  heparIn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  implantPriceOf?: InputMaybe<SortEnumType>;
  implantTierOf?: InputMaybe<SortEnumType>;
  isFragile?: InputMaybe<SortEnumType>;
  isHardToStrip?: InputMaybe<SortEnumType>;
  ivcBroken?: InputMaybe<SortEnumType>;
  ivcComment?: InputMaybe<SortEnumType>;
  ivcDead?: InputMaybe<SortEnumType>;
  ivcExtra?: InputMaybe<SortEnumType>;
  ivcImmature?: InputMaybe<SortEnumType>;
  ivcMissing?: InputMaybe<SortEnumType>;
  ivcNumber?: InputMaybe<SortEnumType>;
  ivcTechnician?: InputMaybe<EquipmentSortInput>;
  ivcTechnicianId?: InputMaybe<SortEnumType>;
  ivfDate?: InputMaybe<SortEnumType>;
  ivfLabTechnician1?: InputMaybe<EquipmentSortInput>;
  ivfLabTechnician1Id?: InputMaybe<SortEnumType>;
  ivfLabTechnician2?: InputMaybe<EquipmentSortInput>;
  ivfLabTechnician2Id?: InputMaybe<SortEnumType>;
  ivfNumber?: InputMaybe<SortEnumType>;
  ivfTime?: InputMaybe<SortEnumType>;
  loadDonorPartners?: InputMaybe<SortEnumType>;
  loadDonorPartnersFrz?: InputMaybe<SortEnumType>;
  loadedInStraws?: InputMaybe<SortEnumType>;
  lowProdValidationDate?: InputMaybe<SortEnumType>;
  lowProdValidator?: InputMaybe<EquipmentSortInput>;
  lowProdValidatorId?: InputMaybe<SortEnumType>;
  mating?: InputMaybe<SortEnumType>;
  matings?: InputMaybe<SortEnumType>;
  matings2?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  mofloNum?: InputMaybe<SortEnumType>;
  noEmbryosProduced?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  oocyteScore?: InputMaybe<SortEnumType>;
  origHeldAtTog?: InputMaybe<SortEnumType>;
  origShipped?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  packagingFee?: InputMaybe<SortEnumType>;
  packagingFee2?: InputMaybe<SortEnumType>;
  plan?: InputMaybe<SortEnumType>;
  plate?: InputMaybe<SortEnumType>;
  plateNumber?: InputMaybe<SortEnumType>;
  predictedBy?: InputMaybe<EquipmentSortInput>;
  predictedById?: InputMaybe<SortEnumType>;
  predictedByName?: InputMaybe<SortEnumType>;
  predictedComment?: InputMaybe<SortEnumType>;
  predictedCommentOnly?: InputMaybe<SortEnumType>;
  predictedGood?: InputMaybe<SortEnumType>;
  predictedLow?: InputMaybe<SortEnumType>;
  predictedVeryLow?: InputMaybe<SortEnumType>;
  procId?: InputMaybe<SortEnumType>;
  processingTechnician?: InputMaybe<EquipmentSortInput>;
  processingTechnicianId?: InputMaybe<SortEnumType>;
  prodres?: InputMaybe<SortEnumType>;
  programName?: InputMaybe<SortEnumType>;
  qcCultureIncubator?: InputMaybe<SortEnumType>;
  qcCulturePlate?: InputMaybe<SortEnumType>;
  qcEHMDate?: InputMaybe<SortEnumType>;
  qcEHMDate10ml?: InputMaybe<SortEnumType>;
  qcEHMDate20ml?: InputMaybe<SortEnumType>;
  qcEHMDate40ml?: InputMaybe<SortEnumType>;
  qcEHMDate125ml?: InputMaybe<SortEnumType>;
  qcEHMDate250ml?: InputMaybe<SortEnumType>;
  qcFertMedia?: InputMaybe<SortEnumType>;
  qcFertPlate?: InputMaybe<SortEnumType>;
  qcHoeschtLot?: InputMaybe<SortEnumType>;
  qcHoldingsOfDate?: InputMaybe<SortEnumType>;
  qcIncubator?: InputMaybe<incubatorsSortInput>;
  qcIncubatorId?: InputMaybe<SortEnumType>;
  qcIsolate?: InputMaybe<SortEnumType>;
  qcMineralOil?: InputMaybe<SortEnumType>;
  qcOvaHepesLot?: InputMaybe<SortEnumType>;
  qcSerum?: InputMaybe<SortEnumType>;
  qcShippingTubeExpirationDate?: InputMaybe<SortEnumType>;
  qcShippingsOfDate?: InputMaybe<SortEnumType>;
  qcSofDate?: InputMaybe<SortEnumType>;
  qcTrisLot?: InputMaybe<SortEnumType>;
  recipOwner?: InputMaybe<AccountSortInput>;
  recipOwnerId?: InputMaybe<SortEnumType>;
  recipient?: InputMaybe<RecipientSortInput>;
  recipientId?: InputMaybe<SortEnumType>;
  resultsComment?: InputMaybe<SortEnumType>;
  rsPool?: InputMaybe<SortEnumType>;
  semen?: InputMaybe<SemenSortInput>;
  semenFee?: InputMaybe<SortEnumType>;
  semenId?: InputMaybe<SortEnumType>;
  semenOwner?: InputMaybe<AccountSortInput>;
  semenOwnerId?: InputMaybe<SortEnumType>;
  semenScore?: InputMaybe<SortEnumType>;
  semenUnits?: InputMaybe<SortEnumType>;
  sheathFluidDate?: InputMaybe<SortEnumType>;
  shipGroup?: InputMaybe<SortEnumType>;
  shipRecipGroup?: InputMaybe<SortEnumType>;
  shipValidationDate?: InputMaybe<SortEnumType>;
  shipValidator?: InputMaybe<EquipmentSortInput>;
  shipValidatorId?: InputMaybe<SortEnumType>;
  shipmentGroupId?: InputMaybe<SortEnumType>;
  shipmentGroupMaster?: InputMaybe<ShipmentGroupMasterSortInput>;
  shipmentGroupMaster2?: InputMaybe<ShipmentGroupMasterSortInput>;
  shipmentGroupMaster2Id?: InputMaybe<SortEnumType>;
  shipmentGroupMasterId?: InputMaybe<SortEnumType>;
  shipped?: InputMaybe<SortEnumType>;
  shipped2?: InputMaybe<SortEnumType>;
  shippedBillable?: InputMaybe<SortEnumType>;
  shippedBillable2?: InputMaybe<SortEnumType>;
  shippedTog?: InputMaybe<SortEnumType>;
  shippedTog2?: InputMaybe<SortEnumType>;
  sireTogIds?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  stripperTipLotNumber?: InputMaybe<SortEnumType>;
  transValidationDate?: InputMaybe<SortEnumType>;
  transValidator?: InputMaybe<EquipmentSortInput>;
  transValidatorId?: InputMaybe<SortEnumType>;
  transferClient?: InputMaybe<SortEnumType>;
  transferable?: InputMaybe<SortEnumType>;
  transferred?: InputMaybe<SortEnumType>;
  trfClinicRanchHaulIn?: InputMaybe<SortEnumType>;
  trfOwner?: InputMaybe<AccountSortInput>;
  trfOwnerId?: InputMaybe<SortEnumType>;
  trfSite?: InputMaybe<SiteSortInput>;
  trfSiteId?: InputMaybe<SortEnumType>;
  tt?: InputMaybe<SortEnumType>;
  tubeNumber?: InputMaybe<SortEnumType>;
  updateSemen?: InputMaybe<SortEnumType>;
};

export type FertilizationStorageLocationType = {
  __typename: 'FertilizationStorageLocationType';
  guidValue: Scalars['UUID']['output'];
  intValue: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FertilizationStorageLocationTypeFilterInput = {
  and?: InputMaybe<Array<FertilizationStorageLocationTypeFilterInput>>;
  guidValue?: InputMaybe<UuidOperationFilterInput>;
  intValue?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FertilizationStorageLocationTypeFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type FertilizationStorageLocationTypeSortInput = {
  guidValue?: InputMaybe<SortEnumType>;
  intValue?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type FertilizationStorageLocationsCollectionSegment = {
  __typename: 'FertilizationStorageLocationsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<FertilizationStorageLocationType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type FertilizationWithEmbryos = {
  __typename: 'FertilizationWithEmbryos';
  fertId: Scalars['UUID']['output'];
  liveEmbryos: Array<TOA_GetFertilizationsEmbryos>;
  tempEmbryos: Array<TOA_GetFertilizationsIntEmbryos>;
};

/** A segment of a collection. */
export type FertilizationsCollectionSegment = {
  __typename: 'FertilizationsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Fertilization>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type Flush = {
  __typename: 'Flush';
  billDrugs: Maybe<Scalars['Boolean']['output']>;
  billStatus: Maybe<Scalars['Int']['output']>;
  bredBy: Maybe<Scalars['String']['output']>;
  breedingDate: Maybe<Scalars['DateTime']['output']>;
  breedingId: Maybe<Scalars['UUID']['output']>;
  breedingcomment: Maybe<Scalars['String']['output']>;
  breedingtime: Maybe<Scalars['Int']['output']>;
  clinic: Maybe<Scalars['Int']['output']>;
  clinicRanchHaulIn: Maybe<Scalars['Int']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  deYard: Maybe<Yard>;
  deYardId: Maybe<Scalars['UUID']['output']>;
  degenerate: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  donor: Maybe<Donor>;
  donorId: Maybe<Scalars['UUID']['output']>;
  drugUsedId: Maybe<Scalars['UUID']['output']>;
  embryoPlan: Maybe<Scalars['Int']['output']>;
  embryos: Array<Embryo>;
  errorCode: Maybe<Scalars['Decimal']['output']>;
  estrusDate: Maybe<Scalars['DateTime']['output']>;
  estrusToFlush: Maybe<Scalars['Decimal']['output']>;
  flexFieldPartner: Maybe<Scalars['String']['output']>;
  flshId: Maybe<Scalars['Int']['output']>;
  flushDate: Maybe<Scalars['DateTime']['output']>;
  flushTechId: Maybe<Scalars['UUID']['output']>;
  flushTechnician: Maybe<Equipment>;
  flushTechnicianId: Maybe<Scalars['UUID']['output']>;
  flushTime: Maybe<Scalars['String']['output']>;
  flushToImplant: Maybe<Scalars['Decimal']['output']>;
  flushType: Maybe<Scalars['Int']['output']>;
  freezeComment: Maybe<Scalars['String']['output']>;
  frozen: Maybe<Scalars['Int']['output']>;
  frzCane: Maybe<Scalars['String']['output']>;
  frzFreezeMethod: Maybe<OptionSet>;
  frzFreezeMethodId: Maybe<Scalars['UUID']['output']>;
  frzFreezeTechnician: Maybe<Scalars['String']['output']>;
  frzFreezeTime: Maybe<Scalars['String']['output']>;
  frzFreezer: Maybe<Scalars['String']['output']>;
  frzStorageLocation: Maybe<StorageLocation>;
  frzStorageLocationId: Maybe<Scalars['UUID']['output']>;
  frzTt: Maybe<Scalars['Boolean']['output']>;
  grade3: Maybe<Scalars['Int']['output']>;
  grader: Maybe<Equipment>;
  graderId: Maybe<Scalars['UUID']['output']>;
  histId: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  implantTierOf: Maybe<Scalars['Int']['output']>;
  leftCl: Maybe<Scalars['Int']['output']>;
  loadDonorPartners: Maybe<Scalars['Int']['output']>;
  mileage: Maybe<Scalars['Decimal']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  msgSemenQty: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  pgfToEstrus: Maybe<Scalars['Decimal']['output']>;
  previousFlush: Maybe<Scalars['DateTime']['output']>;
  procId: Maybe<Scalars['String']['output']>;
  recipOwner: Maybe<Account>;
  recipOwnerId: Maybe<Scalars['UUID']['output']>;
  recoveryEtCode: Maybe<Scalars['String']['output']>;
  recoveryFirm: Maybe<Scalars['String']['output']>;
  righCl: Maybe<Scalars['Int']['output']>;
  semen: Maybe<Semen>;
  semenId: Maybe<Scalars['UUID']['output']>;
  semenLocation: Maybe<StorageLocation>;
  semenLocationId: Maybe<Scalars['UUID']['output']>;
  semenOwner: Maybe<Account>;
  semenOwnerId: Maybe<Scalars['UUID']['output']>;
  semenQty: Maybe<Scalars['Int']['output']>;
  semenQtyOverTime: Maybe<Scalars['String']['output']>;
  semenQuality: Maybe<Scalars['Int']['output']>;
  semenTransactionId: Maybe<Scalars['UUID']['output']>;
  semenType: Maybe<Scalars['Int']['output']>;
  sire: Maybe<Sire>;
  sireId: Maybe<Scalars['UUID']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  soSchedule: Maybe<SuperOvulationSchedule>;
  soScheduleId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  status: Maybe<Scalars['Int']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  stopId: Maybe<Scalars['Int']['output']>;
  togId: Maybe<Scalars['Int']['output']>;
  totalCollected: Maybe<Scalars['Int']['output']>;
  transferred: Maybe<Scalars['Int']['output']>;
  trfClinicRanchHaulIn: Maybe<Scalars['Int']['output']>;
  trfFrzEmbryos: Maybe<Scalars['Boolean']['output']>;
  tripCharge: Maybe<Scalars['Decimal']['output']>;
  type: Maybe<Scalars['Int']['output']>;
  unFertilized: Maybe<Scalars['Int']['output']>;
};

export type FlushFilterInput = {
  and?: InputMaybe<Array<FlushFilterInput>>;
  billDrugs?: InputMaybe<BooleanOperationFilterInput>;
  billStatus?: InputMaybe<IntOperationFilterInput>;
  bredBy?: InputMaybe<StringOperationFilterInput>;
  breedingDate?: InputMaybe<DateTimeOperationFilterInput>;
  breedingId?: InputMaybe<UuidOperationFilterInput>;
  breedingcomment?: InputMaybe<StringOperationFilterInput>;
  breedingtime?: InputMaybe<IntOperationFilterInput>;
  clinic?: InputMaybe<IntOperationFilterInput>;
  clinicRanchHaulIn?: InputMaybe<IntOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  deYard?: InputMaybe<YardFilterInput>;
  deYardId?: InputMaybe<UuidOperationFilterInput>;
  degenerate?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  drugUsedId?: InputMaybe<UuidOperationFilterInput>;
  embryoPlan?: InputMaybe<IntOperationFilterInput>;
  embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  errorCode?: InputMaybe<DecimalOperationFilterInput>;
  estrusDate?: InputMaybe<DateTimeOperationFilterInput>;
  estrusToFlush?: InputMaybe<DecimalOperationFilterInput>;
  flexFieldPartner?: InputMaybe<StringOperationFilterInput>;
  flshId?: InputMaybe<IntOperationFilterInput>;
  flushDate?: InputMaybe<DateTimeOperationFilterInput>;
  flushTechId?: InputMaybe<UuidOperationFilterInput>;
  flushTechnician?: InputMaybe<EquipmentFilterInput>;
  flushTechnicianId?: InputMaybe<UuidOperationFilterInput>;
  flushTime?: InputMaybe<StringOperationFilterInput>;
  flushToImplant?: InputMaybe<DecimalOperationFilterInput>;
  flushType?: InputMaybe<IntOperationFilterInput>;
  freezeComment?: InputMaybe<StringOperationFilterInput>;
  frozen?: InputMaybe<IntOperationFilterInput>;
  frzCane?: InputMaybe<StringOperationFilterInput>;
  frzFreezeMethod?: InputMaybe<OptionSetFilterInput>;
  frzFreezeMethodId?: InputMaybe<UuidOperationFilterInput>;
  frzFreezeTechnician?: InputMaybe<StringOperationFilterInput>;
  frzFreezeTime?: InputMaybe<StringOperationFilterInput>;
  frzFreezer?: InputMaybe<StringOperationFilterInput>;
  frzStorageLocation?: InputMaybe<StorageLocationFilterInput>;
  frzStorageLocationId?: InputMaybe<UuidOperationFilterInput>;
  frzTt?: InputMaybe<BooleanOperationFilterInput>;
  grade3?: InputMaybe<IntOperationFilterInput>;
  grader?: InputMaybe<EquipmentFilterInput>;
  graderId?: InputMaybe<UuidOperationFilterInput>;
  histId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  implantTierOf?: InputMaybe<IntOperationFilterInput>;
  leftCl?: InputMaybe<IntOperationFilterInput>;
  loadDonorPartners?: InputMaybe<IntOperationFilterInput>;
  mileage?: InputMaybe<DecimalOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  msgSemenQty?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FlushFilterInput>>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  pgfToEstrus?: InputMaybe<DecimalOperationFilterInput>;
  previousFlush?: InputMaybe<DateTimeOperationFilterInput>;
  procId?: InputMaybe<StringOperationFilterInput>;
  recipOwner?: InputMaybe<AccountFilterInput>;
  recipOwnerId?: InputMaybe<UuidOperationFilterInput>;
  recoveryEtCode?: InputMaybe<StringOperationFilterInput>;
  recoveryFirm?: InputMaybe<StringOperationFilterInput>;
  righCl?: InputMaybe<IntOperationFilterInput>;
  semen?: InputMaybe<SemenFilterInput>;
  semenId?: InputMaybe<UuidOperationFilterInput>;
  semenLocation?: InputMaybe<StorageLocationFilterInput>;
  semenLocationId?: InputMaybe<UuidOperationFilterInput>;
  semenOwner?: InputMaybe<AccountFilterInput>;
  semenOwnerId?: InputMaybe<UuidOperationFilterInput>;
  semenQty?: InputMaybe<IntOperationFilterInput>;
  semenQtyOverTime?: InputMaybe<StringOperationFilterInput>;
  semenQuality?: InputMaybe<IntOperationFilterInput>;
  semenTransactionId?: InputMaybe<UuidOperationFilterInput>;
  semenType?: InputMaybe<IntOperationFilterInput>;
  sire?: InputMaybe<SireFilterInput>;
  sireId?: InputMaybe<UuidOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  soSchedule?: InputMaybe<SuperOvulationScheduleFilterInput>;
  soScheduleId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  stopId?: InputMaybe<IntOperationFilterInput>;
  togId?: InputMaybe<IntOperationFilterInput>;
  totalCollected?: InputMaybe<IntOperationFilterInput>;
  transferred?: InputMaybe<IntOperationFilterInput>;
  trfClinicRanchHaulIn?: InputMaybe<IntOperationFilterInput>;
  trfFrzEmbryos?: InputMaybe<BooleanOperationFilterInput>;
  tripCharge?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
  unFertilized?: InputMaybe<IntOperationFilterInput>;
};

export type FlushInput = {
  billDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  billStatus?: InputMaybe<Scalars['Int']['input']>;
  bredBy?: InputMaybe<Scalars['String']['input']>;
  breedingDate?: InputMaybe<Scalars['DateTime']['input']>;
  breedingId?: InputMaybe<Scalars['UUID']['input']>;
  breedingcomment?: InputMaybe<Scalars['String']['input']>;
  breedingtime?: InputMaybe<Scalars['Int']['input']>;
  clinic?: InputMaybe<Scalars['Int']['input']>;
  clinicRanchHaulIn?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  deYard?: InputMaybe<YardInput>;
  deYardId?: InputMaybe<Scalars['UUID']['input']>;
  degenerate?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  drugUsedId?: InputMaybe<Scalars['UUID']['input']>;
  embryoPlan?: InputMaybe<Scalars['Int']['input']>;
  embryos: Array<EmbryoInput>;
  errorCode?: InputMaybe<Scalars['Decimal']['input']>;
  estrusDate?: InputMaybe<Scalars['DateTime']['input']>;
  estrusToFlush?: InputMaybe<Scalars['Decimal']['input']>;
  flexFieldPartner?: InputMaybe<Scalars['String']['input']>;
  flshId?: InputMaybe<Scalars['Int']['input']>;
  flushDate?: InputMaybe<Scalars['DateTime']['input']>;
  flushTechId?: InputMaybe<Scalars['UUID']['input']>;
  flushTechnician?: InputMaybe<EquipmentInput>;
  flushTechnicianId?: InputMaybe<Scalars['UUID']['input']>;
  flushTime?: InputMaybe<Scalars['String']['input']>;
  flushToImplant?: InputMaybe<Scalars['Decimal']['input']>;
  flushType?: InputMaybe<Scalars['Int']['input']>;
  freezeComment?: InputMaybe<Scalars['String']['input']>;
  frozen?: InputMaybe<Scalars['Int']['input']>;
  frzCane?: InputMaybe<Scalars['String']['input']>;
  frzFreezeMethod?: InputMaybe<OptionSetInput>;
  frzFreezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  frzFreezeTechnician?: InputMaybe<Scalars['String']['input']>;
  frzFreezeTime?: InputMaybe<Scalars['String']['input']>;
  frzFreezer?: InputMaybe<Scalars['String']['input']>;
  frzStorageLocation?: InputMaybe<StorageLocationInput>;
  frzStorageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  frzTt?: InputMaybe<Scalars['Boolean']['input']>;
  grade3?: InputMaybe<Scalars['Int']['input']>;
  grader?: InputMaybe<EquipmentInput>;
  graderId?: InputMaybe<Scalars['UUID']['input']>;
  histId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  implantTierOf?: InputMaybe<Scalars['Int']['input']>;
  leftCl?: InputMaybe<Scalars['Int']['input']>;
  loadDonorPartners?: InputMaybe<Scalars['Int']['input']>;
  mileage?: InputMaybe<Scalars['Decimal']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  msgSemenQty?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  pgfToEstrus?: InputMaybe<Scalars['Decimal']['input']>;
  previousFlush?: InputMaybe<Scalars['DateTime']['input']>;
  procId?: InputMaybe<Scalars['String']['input']>;
  recipOwner?: InputMaybe<AccountInput>;
  recipOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  recoveryEtCode?: InputMaybe<Scalars['String']['input']>;
  recoveryFirm?: InputMaybe<Scalars['String']['input']>;
  righCl?: InputMaybe<Scalars['Int']['input']>;
  semen?: InputMaybe<SemenInput>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  semenLocation?: InputMaybe<StorageLocationInput>;
  semenLocationId?: InputMaybe<Scalars['UUID']['input']>;
  semenOwner?: InputMaybe<AccountInput>;
  semenOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  semenQty?: InputMaybe<Scalars['Int']['input']>;
  semenQtyOverTime?: InputMaybe<Scalars['String']['input']>;
  semenQuality?: InputMaybe<Scalars['Int']['input']>;
  semenTransactionId?: InputMaybe<Scalars['UUID']['input']>;
  semenType?: InputMaybe<Scalars['Int']['input']>;
  sire?: InputMaybe<SireInput>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  soSchedule?: InputMaybe<SuperOvulationScheduleInput>;
  soScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  stopId?: InputMaybe<Scalars['Int']['input']>;
  togId?: InputMaybe<Scalars['Int']['input']>;
  totalCollected?: InputMaybe<Scalars['Int']['input']>;
  transferred?: InputMaybe<Scalars['Int']['input']>;
  trfClinicRanchHaulIn?: InputMaybe<Scalars['Int']['input']>;
  trfFrzEmbryos?: InputMaybe<Scalars['Boolean']['input']>;
  tripCharge?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  unFertilized?: InputMaybe<Scalars['Int']['input']>;
};

export type FlushSortInput = {
  billDrugs?: InputMaybe<SortEnumType>;
  billStatus?: InputMaybe<SortEnumType>;
  bredBy?: InputMaybe<SortEnumType>;
  breedingDate?: InputMaybe<SortEnumType>;
  breedingId?: InputMaybe<SortEnumType>;
  breedingcomment?: InputMaybe<SortEnumType>;
  breedingtime?: InputMaybe<SortEnumType>;
  clinic?: InputMaybe<SortEnumType>;
  clinicRanchHaulIn?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  deYard?: InputMaybe<YardSortInput>;
  deYardId?: InputMaybe<SortEnumType>;
  degenerate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  donor?: InputMaybe<DonorSortInput>;
  donorId?: InputMaybe<SortEnumType>;
  drugUsedId?: InputMaybe<SortEnumType>;
  embryoPlan?: InputMaybe<SortEnumType>;
  errorCode?: InputMaybe<SortEnumType>;
  estrusDate?: InputMaybe<SortEnumType>;
  estrusToFlush?: InputMaybe<SortEnumType>;
  flexFieldPartner?: InputMaybe<SortEnumType>;
  flshId?: InputMaybe<SortEnumType>;
  flushDate?: InputMaybe<SortEnumType>;
  flushTechId?: InputMaybe<SortEnumType>;
  flushTechnician?: InputMaybe<EquipmentSortInput>;
  flushTechnicianId?: InputMaybe<SortEnumType>;
  flushTime?: InputMaybe<SortEnumType>;
  flushToImplant?: InputMaybe<SortEnumType>;
  flushType?: InputMaybe<SortEnumType>;
  freezeComment?: InputMaybe<SortEnumType>;
  frozen?: InputMaybe<SortEnumType>;
  frzCane?: InputMaybe<SortEnumType>;
  frzFreezeMethod?: InputMaybe<OptionSetSortInput>;
  frzFreezeMethodId?: InputMaybe<SortEnumType>;
  frzFreezeTechnician?: InputMaybe<SortEnumType>;
  frzFreezeTime?: InputMaybe<SortEnumType>;
  frzFreezer?: InputMaybe<SortEnumType>;
  frzStorageLocation?: InputMaybe<StorageLocationSortInput>;
  frzStorageLocationId?: InputMaybe<SortEnumType>;
  frzTt?: InputMaybe<SortEnumType>;
  grade3?: InputMaybe<SortEnumType>;
  grader?: InputMaybe<EquipmentSortInput>;
  graderId?: InputMaybe<SortEnumType>;
  histId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  implantTierOf?: InputMaybe<SortEnumType>;
  leftCl?: InputMaybe<SortEnumType>;
  loadDonorPartners?: InputMaybe<SortEnumType>;
  mileage?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  msgSemenQty?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  pgfToEstrus?: InputMaybe<SortEnumType>;
  previousFlush?: InputMaybe<SortEnumType>;
  procId?: InputMaybe<SortEnumType>;
  recipOwner?: InputMaybe<AccountSortInput>;
  recipOwnerId?: InputMaybe<SortEnumType>;
  recoveryEtCode?: InputMaybe<SortEnumType>;
  recoveryFirm?: InputMaybe<SortEnumType>;
  righCl?: InputMaybe<SortEnumType>;
  semen?: InputMaybe<SemenSortInput>;
  semenId?: InputMaybe<SortEnumType>;
  semenLocation?: InputMaybe<StorageLocationSortInput>;
  semenLocationId?: InputMaybe<SortEnumType>;
  semenOwner?: InputMaybe<AccountSortInput>;
  semenOwnerId?: InputMaybe<SortEnumType>;
  semenQty?: InputMaybe<SortEnumType>;
  semenQtyOverTime?: InputMaybe<SortEnumType>;
  semenQuality?: InputMaybe<SortEnumType>;
  semenTransactionId?: InputMaybe<SortEnumType>;
  semenType?: InputMaybe<SortEnumType>;
  sire?: InputMaybe<SireSortInput>;
  sireId?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  soSchedule?: InputMaybe<SuperOvulationScheduleSortInput>;
  soScheduleId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  stopId?: InputMaybe<SortEnumType>;
  togId?: InputMaybe<SortEnumType>;
  totalCollected?: InputMaybe<SortEnumType>;
  transferred?: InputMaybe<SortEnumType>;
  trfClinicRanchHaulIn?: InputMaybe<SortEnumType>;
  trfFrzEmbryos?: InputMaybe<SortEnumType>;
  tripCharge?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  unFertilized?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type FreezeEntriesCollectionSegment = {
  __typename: 'FreezeEntriesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<EmbryoFreezeEntry>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type FreshShipIdListInput = {
  shipmentId: Scalars['String']['input'];
};

export type FreshShipmentPayload = {
  __typename: 'FreshShipmentPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** The id of the affected fresh shipment, if applicable. */
  freshShipmentId: Maybe<Scalars['UUID']['output']>;
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

/** A segment of a collection. */
export type GetNucleusErrorLogsCollectionSegment = {
  __typename: 'GetNucleusErrorLogsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<NucleusErrorLogs>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type GetPartnershipsByDonorIdCollectionSegment = {
  __typename: 'GetPartnershipsByDonorIdCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<PartnershipItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type GetPartnershipsCollectionSegment = {
  __typename: 'GetPartnershipsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<PartnershipItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type IncubatorsCollectionSegment = {
  __typename: 'IncubatorsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<incubators>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

/** A segment of a collection. */
export type ItRequestsCollectionSegment = {
  __typename: 'ItRequestsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Request>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type KeyValuePairOfInt32AndNullableString = {
  __typename: 'KeyValuePairOfInt32AndNullableString';
  key: Scalars['Int']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type KeyValuePairOfStringAndInt32Input = {
  key: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type ListFilterInputTypeOfAccountBreedFilterInput = {
  all?: InputMaybe<AccountBreedFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AccountBreedFilterInput>;
  some?: InputMaybe<AccountBreedFilterInput>;
};

export type ListFilterInputTypeOfAccountFilterInput = {
  all?: InputMaybe<AccountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AccountFilterInput>;
  some?: InputMaybe<AccountFilterInput>;
};

export type ListFilterInputTypeOfAnnotationFilterInput = {
  all?: InputMaybe<AnnotationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AnnotationFilterInput>;
  some?: InputMaybe<AnnotationFilterInput>;
};

export type ListFilterInputTypeOfAspirationFilterInput = {
  all?: InputMaybe<AspirationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AspirationFilterInput>;
  some?: InputMaybe<AspirationFilterInput>;
};

export type ListFilterInputTypeOfAspirationPoolFilterInput = {
  all?: InputMaybe<AspirationPoolFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AspirationPoolFilterInput>;
  some?: InputMaybe<AspirationPoolFilterInput>;
};

export type ListFilterInputTypeOfCalendarFilterInput = {
  all?: InputMaybe<CalendarFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CalendarFilterInput>;
  some?: InputMaybe<CalendarFilterInput>;
};

export type ListFilterInputTypeOfCalfFilterInput = {
  all?: InputMaybe<CalfFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CalfFilterInput>;
  some?: InputMaybe<CalfFilterInput>;
};

export type ListFilterInputTypeOfCalfProcedureFilterInput = {
  all?: InputMaybe<CalfProcedureFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CalfProcedureFilterInput>;
  some?: InputMaybe<CalfProcedureFilterInput>;
};

export type ListFilterInputTypeOfDonorFilterInput = {
  all?: InputMaybe<DonorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DonorFilterInput>;
  some?: InputMaybe<DonorFilterInput>;
};

export type ListFilterInputTypeOfDonorScheduleFilterInput = {
  all?: InputMaybe<DonorScheduleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DonorScheduleFilterInput>;
  some?: InputMaybe<DonorScheduleFilterInput>;
};

export type ListFilterInputTypeOfEmbryoFilterInput = {
  all?: InputMaybe<EmbryoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmbryoFilterInput>;
  some?: InputMaybe<EmbryoFilterInput>;
};

export type ListFilterInputTypeOfEquipmentFilterInput = {
  all?: InputMaybe<EquipmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EquipmentFilterInput>;
  some?: InputMaybe<EquipmentFilterInput>;
};

export type ListFilterInputTypeOfFeatureAdGroupFilterInput = {
  all?: InputMaybe<FeatureAdGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FeatureAdGroupFilterInput>;
  some?: InputMaybe<FeatureAdGroupFilterInput>;
};

export type ListFilterInputTypeOfFeatureAdUserFilterInput = {
  all?: InputMaybe<FeatureAdUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FeatureAdUserFilterInput>;
  some?: InputMaybe<FeatureAdUserFilterInput>;
};

export type ListFilterInputTypeOfFeatureTogAccountFilterInput = {
  all?: InputMaybe<FeatureTogAccountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FeatureTogAccountFilterInput>;
  some?: InputMaybe<FeatureTogAccountFilterInput>;
};

export type ListFilterInputTypeOfFertilizationFilterInput = {
  all?: InputMaybe<FertilizationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FertilizationFilterInput>;
  some?: InputMaybe<FertilizationFilterInput>;
};

export type ListFilterInputTypeOfFlushFilterInput = {
  all?: InputMaybe<FlushFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FlushFilterInput>;
  some?: InputMaybe<FlushFilterInput>;
};

export type ListFilterInputTypeOfLocationFilterInput = {
  all?: InputMaybe<LocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LocationFilterInput>;
  some?: InputMaybe<LocationFilterInput>;
};

export type ListFilterInputTypeOfOwnershipFilterInput = {
  all?: InputMaybe<OwnershipFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OwnershipFilterInput>;
  some?: InputMaybe<OwnershipFilterInput>;
};

export type ListFilterInputTypeOfPartnershipFilterInput = {
  all?: InputMaybe<PartnershipFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PartnershipFilterInput>;
  some?: InputMaybe<PartnershipFilterInput>;
};

export type ListFilterInputTypeOfRecipientFilterInput = {
  all?: InputMaybe<RecipientFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RecipientFilterInput>;
  some?: InputMaybe<RecipientFilterInput>;
};

export type ListFilterInputTypeOfRequestEventFilterInput = {
  all?: InputMaybe<RequestEventFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestEventFilterInput>;
  some?: InputMaybe<RequestEventFilterInput>;
};

export type ListFilterInputTypeOfRequestImportantFilterInput = {
  all?: InputMaybe<RequestImportantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestImportantFilterInput>;
  some?: InputMaybe<RequestImportantFilterInput>;
};

export type ListFilterInputTypeOfRequestItIssueFilterInput = {
  all?: InputMaybe<RequestItIssueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestItIssueFilterInput>;
  some?: InputMaybe<RequestItIssueFilterInput>;
};

export type ListFilterInputTypeOfRequestSubscriptionFilterInput = {
  all?: InputMaybe<RequestSubscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestSubscriptionFilterInput>;
  some?: InputMaybe<RequestSubscriptionFilterInput>;
};

export type ListFilterInputTypeOfSemenFilterInput = {
  all?: InputMaybe<SemenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SemenFilterInput>;
  some?: InputMaybe<SemenFilterInput>;
};

export type ListFilterInputTypeOfSemenHistoryFilterInput = {
  all?: InputMaybe<SemenHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SemenHistoryFilterInput>;
  some?: InputMaybe<SemenHistoryFilterInput>;
};

export type ListFilterInputTypeOfShipmentFilterInput = {
  all?: InputMaybe<ShipmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ShipmentFilterInput>;
  some?: InputMaybe<ShipmentFilterInput>;
};

export type ListFilterInputTypeOfSireFilterInput = {
  all?: InputMaybe<SireFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SireFilterInput>;
  some?: InputMaybe<SireFilterInput>;
};

export type ListFilterInputTypeOfStorageLocationFilterInput = {
  all?: InputMaybe<StorageLocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StorageLocationFilterInput>;
  some?: InputMaybe<StorageLocationFilterInput>;
};

export type ListFilterInputTypeOfSuperOvulationScheduleFilterInput = {
  all?: InputMaybe<SuperOvulationScheduleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SuperOvulationScheduleFilterInput>;
  some?: InputMaybe<SuperOvulationScheduleFilterInput>;
};

export type ListUnsignedByteOperationFilterInput = {
  all?: InputMaybe<UnsignedByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UnsignedByteOperationFilterInput>;
  some?: InputMaybe<UnsignedByteOperationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type Location = {
  __typename: 'Location';
  accountSite: Maybe<Scalars['Int']['output']>;
  aspirationTechnician: Maybe<Equipment>;
  aspirationTechnicianId: Maybe<Scalars['UUID']['output']>;
  assignedVet: Maybe<Equipment>;
  assignedVetId: Maybe<Scalars['UUID']['output']>;
  billingDrugsType: Maybe<Scalars['Int']['output']>;
  billingGrade3: Maybe<Scalars['Int']['output']>;
  billingGrade3Freeze: Maybe<Scalars['Int']['output']>;
  billingStorageFees: Maybe<Scalars['Int']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  customerServiceRepresentative: Maybe<SystemUser>;
  customerServiceRepresentativeId: Maybe<Scalars['UUID']['output']>;
  defaultYard: Maybe<Yard>;
  defaultYardId: Maybe<Scalars['UUID']['output']>;
  fertilizationSite: Maybe<Site>;
  fertilizationSiteId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isCombinedBillingDonorHousing: Maybe<Scalars['Boolean']['output']>;
  ivfBillingGroup: Maybe<Scalars['String']['output']>;
  maxProcedures: Maybe<Scalars['Int']['output']>;
  maxTransfers: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['Int']['output']>;
  showInDropdown: Maybe<Scalars['Boolean']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  siteType: Maybe<Scalars['Int']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  travelingEmbryologist: Maybe<Equipment>;
  travelingEmbryologistId: Maybe<Scalars['UUID']['output']>;
  tripFee: Maybe<Scalars['Decimal']['output']>;
};

export type LocationFilterInput = {
  accountSite?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<LocationFilterInput>>;
  aspirationTechnician?: InputMaybe<EquipmentFilterInput>;
  aspirationTechnicianId?: InputMaybe<UuidOperationFilterInput>;
  assignedVet?: InputMaybe<EquipmentFilterInput>;
  assignedVetId?: InputMaybe<UuidOperationFilterInput>;
  billingDrugsType?: InputMaybe<IntOperationFilterInput>;
  billingGrade3?: InputMaybe<IntOperationFilterInput>;
  billingGrade3Freeze?: InputMaybe<IntOperationFilterInput>;
  billingStorageFees?: InputMaybe<IntOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  customerServiceRepresentative?: InputMaybe<SystemUserFilterInput>;
  customerServiceRepresentativeId?: InputMaybe<UuidOperationFilterInput>;
  defaultYard?: InputMaybe<YardFilterInput>;
  defaultYardId?: InputMaybe<UuidOperationFilterInput>;
  fertilizationSite?: InputMaybe<SiteFilterInput>;
  fertilizationSiteId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isCombinedBillingDonorHousing?: InputMaybe<BooleanOperationFilterInput>;
  ivfBillingGroup?: InputMaybe<StringOperationFilterInput>;
  maxProcedures?: InputMaybe<IntOperationFilterInput>;
  maxTransfers?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationFilterInput>>;
  region?: InputMaybe<IntOperationFilterInput>;
  showInDropdown?: InputMaybe<BooleanOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  siteType?: InputMaybe<IntOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  travelingEmbryologist?: InputMaybe<EquipmentFilterInput>;
  travelingEmbryologistId?: InputMaybe<UuidOperationFilterInput>;
  tripFee?: InputMaybe<DecimalOperationFilterInput>;
};

export type LocationInput = {
  accountSite?: InputMaybe<Scalars['Int']['input']>;
  aspirationTechnician?: InputMaybe<EquipmentInput>;
  aspirationTechnicianId?: InputMaybe<Scalars['UUID']['input']>;
  assignedVet?: InputMaybe<EquipmentInput>;
  assignedVetId?: InputMaybe<Scalars['UUID']['input']>;
  billingDrugsType?: InputMaybe<Scalars['Int']['input']>;
  billingGrade3?: InputMaybe<Scalars['Int']['input']>;
  billingGrade3Freeze?: InputMaybe<Scalars['Int']['input']>;
  billingStorageFees?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  customerServiceRepresentative?: InputMaybe<SystemUserInput>;
  customerServiceRepresentativeId?: InputMaybe<Scalars['UUID']['input']>;
  defaultYard?: InputMaybe<YardInput>;
  defaultYardId?: InputMaybe<Scalars['UUID']['input']>;
  fertilizationSite?: InputMaybe<SiteInput>;
  fertilizationSiteId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isCombinedBillingDonorHousing?: InputMaybe<Scalars['Boolean']['input']>;
  ivfBillingGroup?: InputMaybe<Scalars['String']['input']>;
  maxProcedures?: InputMaybe<Scalars['Int']['input']>;
  maxTransfers?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['Int']['input']>;
  showInDropdown?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  siteType?: InputMaybe<Scalars['Int']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  travelingEmbryologist?: InputMaybe<EquipmentInput>;
  travelingEmbryologistId?: InputMaybe<Scalars['UUID']['input']>;
  tripFee?: InputMaybe<Scalars['Decimal']['input']>;
};

export type LocationSortInput = {
  accountSite?: InputMaybe<SortEnumType>;
  aspirationTechnician?: InputMaybe<EquipmentSortInput>;
  aspirationTechnicianId?: InputMaybe<SortEnumType>;
  assignedVet?: InputMaybe<EquipmentSortInput>;
  assignedVetId?: InputMaybe<SortEnumType>;
  billingDrugsType?: InputMaybe<SortEnumType>;
  billingGrade3?: InputMaybe<SortEnumType>;
  billingGrade3Freeze?: InputMaybe<SortEnumType>;
  billingStorageFees?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  customerServiceRepresentative?: InputMaybe<SystemUserSortInput>;
  customerServiceRepresentativeId?: InputMaybe<SortEnumType>;
  defaultYard?: InputMaybe<YardSortInput>;
  defaultYardId?: InputMaybe<SortEnumType>;
  fertilizationSite?: InputMaybe<SiteSortInput>;
  fertilizationSiteId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isCombinedBillingDonorHousing?: InputMaybe<SortEnumType>;
  ivfBillingGroup?: InputMaybe<SortEnumType>;
  maxProcedures?: InputMaybe<SortEnumType>;
  maxTransfers?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  showInDropdown?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  siteType?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  travelingEmbryologist?: InputMaybe<EquipmentSortInput>;
  travelingEmbryologistId?: InputMaybe<SortEnumType>;
  tripFee?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type LocationsCollectionSegment = {
  __typename: 'LocationsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type MassInterimEmbryosInput = {
  cane?: InputMaybe<Scalars['String']['input']>;
  embsPerStraw?: InputMaybe<Scalars['Int']['input']>;
  embsPerVitStraw?: InputMaybe<Scalars['Int']['input']>;
  fertID?: InputMaybe<Scalars['String']['input']>;
  freezeDay?: InputMaybe<Scalars['String']['input']>;
  freezeTechID?: InputMaybe<Scalars['String']['input']>;
  freezer?: InputMaybe<Scalars['String']['input']>;
  g1Count?: InputMaybe<Scalars['Int']['input']>;
  g1CountToCreate?: InputMaybe<Scalars['Int']['input']>;
  g2Count?: InputMaybe<Scalars['Int']['input']>;
  g2CountToCreate?: InputMaybe<Scalars['Int']['input']>;
  grade1?: InputMaybe<Scalars['Int']['input']>;
  grade2?: InputMaybe<Scalars['Int']['input']>;
  graderID?: InputMaybe<Scalars['String']['input']>;
  slaughterHouse?: InputMaybe<Scalars['Boolean']['input']>;
  stageGradeCounts?: InputMaybe<Array<StageGradeCountInput>>;
  storageLoc?: InputMaybe<Scalars['String']['input']>;
};

export type MessagingConfirmation = {
  __typename: 'MessagingConfirmation';
  account: Account;
  accountId: Scalars['UUID']['output'];
  confirmedAt: Maybe<Scalars['DateTime']['output']>;
  donorSchedules: Array<DonorSchedule>;
  id: Scalars['Int']['output'];
  sentAt: Scalars['DateTime']['output'];
};

export type MessagingConfirmationFilterInput = {
  accountId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<MessagingConfirmationFilterInput>>;
  confirmedAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MessagingConfirmationFilterInput>>;
  sentAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MessagingConfirmationSortInput = {
  accountId?: InputMaybe<SortEnumType>;
  confirmedAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  sentAt?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type MessagingConfirmationsCollectionSegment = {
  __typename: 'MessagingConfirmationsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<MessagingConfirmation>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Add multiple calves to a the TOG_calfBase table. */
  addCalves: AddCalvesToCalfBasePayload;
  addClinicTransferEmbryos: ClinicTransferEmbryoPayload;
  addFavorite: Array<Scalars['ID']['output']>;
  addFeatureAccount: FeatureTogAccount;
  addFeatureGroup: FeatureAdGroup;
  addFeatureUser: FeatureAdUser;
  addIntEmbs: Array<TOA_GetFertilizationsIntEmbryos>;
  addMassInterimEmbryos: Scalars['Boolean']['output'];
  addNucleusErrorLog: NucleusErrorLogPayload;
  addPregnantStatus: Scalars['String']['output'];
  addView: MutationResponse;
  adminId: Scalars['UUID']['output'];
  applyApprovalNumberToEmbryos: Scalars['Int']['output'];
  approveEmbryoShipments: Array<Shipment>;
  approveSireSelectionRequests: Array<SireSelectionRequest>;
  approveSireSelectionRequestsWithoutSemen: Array<SireSelectionRequest>;
  breeds: Array<Breed>;
  changeConnection: Scalars['Int']['output'];
  combineShipments: FreshShipmentPayload;
  companyId: Scalars['UUID']['output'];
  createAetaResult: CreateAetaResultPayload;
  createClientIssueRequest: Request;
  createCommDairyFertilizationExcel: Array<Scalars['UnsignedByte']['output']>;
  createDonorToDoListReport: Array<Scalars['UnsignedByte']['output']>;
  createEquipment: Maybe<Equipment>;
  createFeature: Feature;
  createFertilizations: CreateFertilizationPayload;
  createFreezeValidationReport: Array<Scalars['UnsignedByte']['output']>;
  createFreshShipmentExportSealFormReport: Array<Scalars['UnsignedByte']['output']>;
  createFreshShipmentFormReport: Array<Scalars['UnsignedByte']['output']>;
  createFreshShipmentImplantFormReport: Array<Scalars['UnsignedByte']['output']>;
  createIssueManager: RequestIssueManager;
  createItRequest: Request;
  createItRequestEvent: RequestEvent;
  createNewAspPool: Scalars['String']['output'];
  createNewDonor: DonorPayload;
  /** Add semen to a the TOG_semenBase table. */
  createNewSemen: CreateNewSemenPayload;
  createNewShipmentGroup: ShipmentGroupPayload;
  createNewShipmentGroupMaster: ShipmentGroupPayload;
  createNewSire: SirePayload;
  createReportRequest: Request;
  createShippingFormReport: Scalars['String']['output'];
  createTogDonorScheduleReport: Array<Scalars['UnsignedByte']['output']>;
  deactivateDonorSchedules: DonorSchedulesPayload;
  deactivateInterimEmbryo: Scalars['Boolean']['output'];
  deactivateSoSchedule: Scalars['Boolean']['output'];
  deleteAetaResult: Scalars['Boolean']['output'];
  deleteFeature: Scalars['Boolean']['output'];
  deleteFeatureAccount: Scalars['Boolean']['output'];
  deleteFeatureGroup: Scalars['Boolean']['output'];
  deleteFeatureUser: Scalars['Boolean']['output'];
  deleteIssueManager: Scalars['Boolean']['output'];
  editBulkDonorSchedules: DonorSchedulesPayload;
  equipment_syncToTraining: Scalars['Boolean']['output'];
  exportCryoBabyLabelXlsx: Array<Scalars['UnsignedByte']['output']>;
  generateSignOffEmail: ShipmentGroupPayload;
  login: Scalars['Boolean']['output'];
  logout: Scalars['Boolean']['output'];
  massSetField: Scalars['Boolean']['output'];
  nextTogId: Scalars['Int']['output'];
  pdfCreateFreeze: Array<Scalars['UnsignedByte']['output']>;
  pdfCreateFreezeOLD: Array<Scalars['UnsignedByte']['output']>;
  pens: Array<Pen>;
  procedureByCode: CalfProcCodeBase;
  pullODSemen: PullSemenPayload;
  pullSemen: PullSemenPayload;
  rejectDiscardSemen: RejectDiscardSemenPayload;
  removeAspPool: Scalars['Boolean']['output'];
  removeFavorite: Array<Scalars['ID']['output']>;
  removeView: MutationResponse;
  reorderFavorites: Array<Scalars['ID']['output']>;
  requestToggleImportant: Request;
  requestToggleSubscribed: Request;
  returnSemen: ReturnSemenPayload;
  runOldWorkflow: Scalars['Boolean']['output'];
  runWorkflow: Scalars['Boolean']['output'];
  searchBreeds: Array<Breed>;
  searchHerdsmen: Array<Equipment>;
  searchOwners: Array<Owner>;
  searchPens: Array<Pen>;
  sendCommDairyFertilizationEmail: Scalars['Boolean']['output'];
  sendReportEmail: Scalars['Boolean']['output'];
  setDefaultView: MutationResponse;
  setSireSelectionRequestSemen: SireSelectionRequest;
  sexes: Array<StringMap>;
  shipping_runShip: Scalars['Boolean']['output'];
  shipping_runShipIntra: Scalars['Boolean']['output'];
  shipping_runShipIntraYackley: Scalars['Boolean']['output'];
  shipping_setInProgress: Shipment;
  statusId: Scalars['UUID']['output'];
  /** @deprecated Use `requestToggleSubscribed` instead */
  subscribeToRequest: Request;
  testicles: Array<StringMap>;
  testicularDevelopment: Array<StringMap>;
  timeOfDay: Array<StringMap>;
  undoShipment: FertilizationPayload;
  undoTempEmbryo: Scalars['Boolean']['output'];
  /** @deprecated Use `requestToggleSubscribed` instead */
  unsubscribeFromRequest: Request;
  updateAetaResult: UpdateAetaResultPayload;
  updateAspirationChuteside: AspirationPayload;
  updateAspirationOpuSearch: Scalars['Boolean']['output'];
  updateAspirationQcDataChuteside: Scalars['Boolean']['output'];
  updateAspirationStatusAndDonorScheduleRevisionComment: ChuteSchedulerPayload;
  updateAspirationStatusAndDonorScheduleRevisionCommentBatch: Array<ChuteSchedulerPayload>;
  updateAspirationTimes: ChuteSchedulerPayload;
  updateAspirationTimesAsync_OLD: AspirationsPayload;
  updateBillAccountCaningGroups: Scalars['Boolean']['output'];
  updateDSSuggested: UpdateSemenPayload;
  updateDSTransaction: DonorSchedulesPayload;
  updateDonorLastBredDate: Scalars['Boolean']['output'];
  updateEmbryoTransaction: Scalars['Boolean']['output'];
  updateEquipment: Maybe<Equipment>;
  updateFeature: Feature;
  updateFeatureAccount: FeatureTogAccount;
  updateFeatureGroup: FeatureAdGroup;
  updateFeatureUser: FeatureAdUser;
  updateFertTransaction: FertilizationPayload;
  updateFertTransactionFreeze: Scalars['Boolean']['output'];
  updateFertilization: Maybe<Fertilization>;
  updateFreezeEmbryos: Scalars['Boolean']['output'];
  updateFreezeTempEmbryos: Scalars['Boolean']['output'];
  updateFreshShipmentTransaction: FreshShipmentPayload;
  updateFreshTransfers: EmbryoUpdatePayload;
  updateFreshTransfersPse: UpdateFreshTransferPayload;
  updateIncubatorAssignment: FertilizationPayload;
  updateInterimEmbryoTransaction: Scalars['Boolean']['output'];
  updateMatingLabelsDupesXlsx: Array<Scalars['UnsignedByte']['output']>;
  updateMatingLabelsFreezeXlsx: Array<Scalars['UnsignedByte']['output']>;
  updateMatingLabelsXlsx: Array<Scalars['UnsignedByte']['output']>;
  updateODFreeze: Scalars['Boolean']['output'];
  updatePredictedComments: Scalars['String']['output'];
  updateQCDataChuteside: Scalars['Boolean']['output'];
  updateQCDataOpuSearch: Scalars['Boolean']['output'];
  updateQcFreshShipment: FertilizationPayload;
  updateRevisions: Array<ChuteSchedulerPayload>;
  /** Update TOG_semenBase table. */
  updateSemen: UpdateSemenPayload;
  updateShipment: Maybe<Shipment>;
  updateShipmentGroupTransaction: ShipmentGroupPayload;
  updateSire: SirePayload;
  updateTempEmbryoOwners: Scalars['Boolean']['output'];
  updateView: MutationResponse;
  upsertDonorSchedules: DonorSchedulesPayload;
  upsertPartnership: UpsertPartnershipsPayload;
  upsertReverseSort: Scalars['UUID']['output'];
  validateFreeze: Scalars['Boolean']['output'];
};


export type MutationaddCalvesArgs = {
  calves: Array<NewCalfEntryInput>;
  requirements: CalfEntryRequirementsInput;
};


export type MutationaddClinicTransferEmbryosArgs = {
  input: ClinicTransferEmbryoInput;
};


export type MutationaddFavoriteArgs = {
  appId: Scalars['ID']['input'];
};


export type MutationaddFeatureAccountArgs = {
  accountId: Scalars['UUID']['input'];
  featureId: Scalars['UUID']['input'];
};


export type MutationaddFeatureGroupArgs = {
  adGroup: Scalars['String']['input'];
  featureId: Scalars['UUID']['input'];
};


export type MutationaddFeatureUserArgs = {
  adUserId: Scalars['UUID']['input'];
  featureId: Scalars['UUID']['input'];
};


export type MutationaddIntEmbsArgs = {
  dtplus?: Scalars['Boolean']['input'];
  input: MassInterimEmbryosInput;
  type: Scalars['Int']['input'];
};


export type MutationaddMassInterimEmbryosArgs = {
  dtplus?: Scalars['Boolean']['input'];
  items: MassInterimEmbryosInput;
};


export type MutationaddNucleusErrorLogArgs = {
  errorLog: NucleusErrorLogsInput;
};


export type MutationaddPregnantStatusArgs = {
  chuteTechId: Scalars['String']['input'];
  donorId: Scalars['String']['input'];
  opuTechId: Scalars['String']['input'];
  pregnantValue: Scalars['Int']['input'];
};


export type MutationaddViewArgs = {
  input: AddViewInput;
};


export type MutationapplyApprovalNumberToEmbryosArgs = {
  updates: Array<UpdateApprovalNumberInput>;
};


export type MutationapproveEmbryoShipmentsArgs = {
  ids: Array<Scalars['UUID']['input']>;
  status: ShipmentStatus;
};


export type MutationapproveSireSelectionRequestsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationapproveSireSelectionRequestsWithoutSemenArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationchangeConnectionArgs = {
  b2c?: InputMaybe<Scalars['Boolean']['input']>;
  environmentId: Scalars['Int']['input'];
};


export type MutationcombineShipmentsArgs = {
  freshShipIdList: Array<FreshShipIdListInput>;
};


export type MutationcreateAetaResultArgs = {
  input: CreateAetaResultInput;
};


export type MutationcreateClientIssueRequestArgs = {
  input: RequestClientIssueInput;
};


export type MutationcreateCommDairyFertilizationExcelArgs = {
  d5: Scalars['Boolean']['input'];
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
};


export type MutationcreateDonorToDoListReportArgs = {
  accountIds: Array<Scalars['UUID']['input']>;
  clinicIds: Array<Scalars['Int']['input']>;
  donorIds: Array<Scalars['UUID']['input']>;
  endDate: Scalars['DateTime']['input'];
  siteIds: Array<Scalars['UUID']['input']>;
  startDate: Scalars['DateTime']['input'];
  yardIds: Array<Scalars['UUID']['input']>;
};


export type MutationcreateEquipmentArgs = {
  isActive: Scalars['Boolean']['input'];
  isEmbryologist: Scalars['Boolean']['input'];
  isHerdsman: Scalars['Boolean']['input'];
  isInTraining: Scalars['Boolean']['input'];
  isTechnician: Scalars['Boolean']['input'];
  isVeterinarian: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  siteId: Scalars['UUID']['input'];
  systemUserId: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationcreateFeatureArgs = {
  name: Scalars['String']['input'];
};


export type MutationcreateFertilizationsArgs = {
  input: CreateFertilizationInput;
};


export type MutationcreateFreezeValidationReportArgs = {
  fertilizationIds: Array<Scalars['UUID']['input']>;
};


export type MutationcreateFreshShipmentExportSealFormReportArgs = {
  freshShipmentId: Scalars['String']['input'];
  shipmentNumber: Scalars['String']['input'];
};


export type MutationcreateFreshShipmentFormReportArgs = {
  accountNumber: Scalars['String']['input'];
  shipmentNumber: Scalars['String']['input'];
};


export type MutationcreateFreshShipmentImplantFormReportArgs = {
  accountNumber: Scalars['String']['input'];
  shipmentNumber: Scalars['String']['input'];
};


export type MutationcreateIssueManagerArgs = {
  adUserId: Scalars['UUID']['input'];
  issueType: RequestIssueType;
};


export type MutationcreateItRequestArgs = {
  request: RequestInput;
};


export type MutationcreateItRequestEventArgs = {
  content: Scalars['String']['input'];
  refRequestId: InputMaybe<Scalars['Int']['input']>;
  requestId: Scalars['Int']['input'];
  type: RequestEventType;
};


export type MutationcreateNewAspPoolArgs = {
  aspirationIds: Array<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
};


export type MutationcreateNewDonorArgs = {
  input: CreateNewDonorInput;
};


export type MutationcreateNewSemenArgs = {
  newSemen: NewSemenInput;
};


export type MutationcreateNewShipmentGroupArgs = {
  input: CreateNewShipmentGroupInput;
};


export type MutationcreateNewShipmentGroupMasterArgs = {
  input: CreateNewShipmentGroupMasterInput;
};


export type MutationcreateNewSireArgs = {
  input: CreateNewSireInput;
};


export type MutationcreateReportRequestArgs = {
  input: ReportRequestInput;
};


export type MutationcreateShippingFormReportArgs = {
  sendEmail?: Scalars['Boolean']['input'];
  shipmentId: Scalars['UUID']['input'];
};


export type MutationcreateTogDonorScheduleReportArgs = {
  soScheduleIds: Array<Scalars['UUID']['input']>;
};


export type MutationdeactivateDonorSchedulesArgs = {
  donorScheduleIds: Array<Scalars['UUID']['input']>;
};


export type MutationdeactivateInterimEmbryoArgs = {
  items: Array<Scalars['String']['input']>;
};


export type MutationdeactivateSoScheduleArgs = {
  donorScheduleId: Scalars['UUID']['input'];
};


export type MutationdeleteAetaResultArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationdeleteFeatureArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationdeleteFeatureAccountArgs = {
  accountId: Scalars['UUID']['input'];
  featureId: Scalars['UUID']['input'];
};


export type MutationdeleteFeatureGroupArgs = {
  adGroup: Scalars['String']['input'];
  featureId: Scalars['UUID']['input'];
};


export type MutationdeleteFeatureUserArgs = {
  adUserId: Scalars['UUID']['input'];
  featureId: Scalars['UUID']['input'];
};


export type MutationdeleteIssueManagerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationeditBulkDonorSchedulesArgs = {
  annotationNoteText: InputMaybe<Scalars['String']['input']>;
  bulkUpdateIds: Array<Scalars['UUID']['input']>;
  input: EditBulkDonorScheduleInput;
};


export type Mutationequipment_syncToTrainingArgs = {
  equipmentId: Scalars['UUID']['input'];
};


export type MutationexportCryoBabyLabelXlsxArgs = {
  aspDate: Scalars['DateTime']['input'];
  aspSite: Scalars['String']['input'];
  labels: Array<CryoBabyLabelInput>;
  location: InputMaybe<Scalars['String']['input']>;
};


export type MutationgenerateSignOffEmailArgs = {
  fertilizationDate: Scalars['DateTime']['input'];
  fertilizationSiteId: Scalars['UUID']['input'];
  shipGroupId: Scalars['UUID']['input'];
  username: Scalars['String']['input'];
};


export type MutationloginArgs = {
  overrideEnvironmentId: InputMaybe<Scalars['Int']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationmassSetFieldArgs = {
  donorScheduleIds: Array<Scalars['UUID']['input']>;
  fields: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};


export type MutationpdfCreateFreezeArgs = {
  filename: Scalars['String']['input'];
  items: Array<PrintInfoInput>;
};


export type MutationpdfCreateFreezeOLDArgs = {
  filename: Scalars['String']['input'];
  items: Array<PrintInfoInput>;
};


export type MutationprocedureByCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationpullODSemenArgs = {
  moveNum: Scalars['Int']['input'];
  semenId: Scalars['UUID']['input'];
  semenType: Scalars['String']['input'];
};


export type MutationpullSemenArgs = {
  accountId: Scalars['UUID']['input'];
  donorScheduleDate: Scalars['DateTime']['input'];
  dsSemenLocId: Scalars['UUID']['input'];
  fertSiteId: Scalars['UUID']['input'];
  moveNum: Scalars['Int']['input'];
  semenId: Scalars['UUID']['input'];
  semenOwnerId: Scalars['UUID']['input'];
  semenType: Scalars['String']['input'];
};


export type MutationrejectDiscardSemenArgs = {
  description: Scalars['String']['input'];
  rejectNum: Scalars['Int']['input'];
  semenId: Scalars['UUID']['input'];
  semenType: Scalars['String']['input'];
};


export type MutationremoveAspPoolArgs = {
  aspirationPoolIds: Array<Scalars['String']['input']>;
};


export type MutationremoveFavoriteArgs = {
  appId: Scalars['ID']['input'];
};


export type MutationremoveViewArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationreorderFavoritesArgs = {
  appIds: Array<Scalars['ID']['input']>;
};


export type MutationrequestToggleImportantArgs = {
  id: Scalars['Int']['input'];
};


export type MutationrequestToggleSubscribedArgs = {
  id: Scalars['Int']['input'];
};


export type MutationreturnSemenArgs = {
  returnNum: Scalars['Int']['input'];
  semenId: Scalars['UUID']['input'];
  semenType: Scalars['String']['input'];
};


export type MutationrunOldWorkflowArgs = {
  entityIds: Array<Scalars['UUID']['input']>;
  workflowId: Scalars['UUID']['input'];
};


export type MutationrunWorkflowArgs = {
  entityIds: Array<Scalars['UUID']['input']>;
  workflowId: Scalars['UUID']['input'];
};


export type MutationsearchBreedsArgs = {
  breed: Scalars['String']['input'];
};


export type MutationsearchHerdsmenArgs = {
  herdsman: Scalars['String']['input'];
};


export type MutationsearchOwnersArgs = {
  owner: Scalars['String']['input'];
};


export type MutationsearchPensArgs = {
  pen: Scalars['String']['input'];
};


export type MutationsendCommDairyFertilizationEmailArgs = {
  d5: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationsendReportEmailArgs = {
  message?: Scalars['String']['input'];
  recipients: InputMaybe<Array<Scalars['String']['input']>>;
  reportUrl: Scalars['String']['input'];
  subject?: Scalars['String']['input'];
};


export type MutationsetDefaultViewArgs = {
  input: SetDefaultViewInput;
};


export type MutationsetSireSelectionRequestSemenArgs = {
  semenId: Scalars['UUID']['input'];
  semenType: Scalars['Int']['input'];
  sireSelectionRequestId: Scalars['UUID']['input'];
};


export type Mutationshipping_runShipArgs = {
  shipmentId: Scalars['UUID']['input'];
};


export type Mutationshipping_runShipIntraArgs = {
  shipmentId: Scalars['UUID']['input'];
};


export type Mutationshipping_runShipIntraYackleyArgs = {
  shipmentId: Scalars['UUID']['input'];
};


export type Mutationshipping_setInProgressArgs = {
  packedById: InputMaybe<Scalars['UUID']['input']>;
  shipmentId: Scalars['UUID']['input'];
};


export type MutationsubscribeToRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationundoShipmentArgs = {
  fertSiteId: Scalars['UUID']['input'];
  freshShipmentId: Scalars['UUID']['input'];
};


export type MutationundoTempEmbryoArgs = {
  embryo: EmbryoInput;
  fertilizationId: InputMaybe<Scalars['UUID']['input']>;
  tempEmbryo: EmbryoFreezeEntryInput;
};


export type MutationunsubscribeFromRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationupdateAetaResultArgs = {
  input: UpdateAetaResultInput;
};


export type MutationupdateAspirationChutesideArgs = {
  input: AspirationDataEntryInput;
  isReturn: Scalars['String']['input'];
};


export type MutationupdateAspirationOpuSearchArgs = {
  input: EmbryologistDataEntryInput;
  isReturn: Scalars['String']['input'];
};


export type MutationupdateAspirationQcDataChutesideArgs = {
  input: tog_chutesideqcInput;
};


export type MutationupdateAspirationStatusAndDonorScheduleRevisionCommentArgs = {
  aspirationId: Scalars['UUID']['input'];
  donorScheduleId: Scalars['UUID']['input'];
  revisionComment: Scalars['String']['input'];
  targetStatus: Scalars['String']['input'];
};


export type MutationupdateAspirationStatusAndDonorScheduleRevisionCommentBatchArgs = {
  updates: Array<UpdateAspirationStatusAndDonorScheduleRevisionCommentInput>;
};


export type MutationupdateAspirationTimesArgs = {
  chuteSchedule: Array<ChuteSchedulerInput>;
};


export type MutationupdateAspirationTimesAsync_OLDArgs = {
  idList: Array<Scalars['String']['input']>;
  interval: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};


export type MutationupdateBillAccountCaningGroupsArgs = {
  donorScheduleId: Scalars['UUID']['input'];
};


export type MutationupdateDSSuggestedArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  donorScheduleDate: Scalars['DateTime']['input'];
  dsSemenLocId: InputMaybe<Scalars['UUID']['input']>;
  fertSiteId: Scalars['UUID']['input'];
  field: Scalars['String']['input'];
  semenId: InputMaybe<Scalars['UUID']['input']>;
  semenType: InputMaybe<Scalars['String']['input']>;
  sireId: Scalars['UUID']['input'];
  value: Scalars['String']['input'];
};


export type MutationupdateDSTransactionArgs = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isIvf?: Scalars['Boolean']['input'];
  updatePredictedComments?: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};


export type MutationupdateDonorLastBredDateArgs = {
  donorId: Scalars['UUID']['input'];
  lastBredDate: Scalars['DateTime']['input'];
};


export type MutationupdateEmbryoTransactionArgs = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationupdateEquipmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEquipmentInput;
};


export type MutationupdateFeatureArgs = {
  id: Scalars['UUID']['input'];
  isEnabled: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationupdateFeatureAccountArgs = {
  accountId: Scalars['UUID']['input'];
  featureId: Scalars['UUID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationupdateFeatureGroupArgs = {
  adGroup: Scalars['String']['input'];
  featureId: Scalars['UUID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationupdateFeatureUserArgs = {
  adUserId: Scalars['UUID']['input'];
  featureId: Scalars['UUID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationupdateFertTransactionArgs = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
  updatePredictedComments?: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};


export type MutationupdateFertTransactionFreezeArgs = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationupdateFertilizationArgs = {
  ianaTimeZone: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  input: UpdateFertilizationInput;
};


export type MutationupdateFreezeEmbryosArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  crackedZona: InputMaybe<Scalars['Boolean']['input']>;
  deactivate: InputMaybe<Scalars['Boolean']['input']>;
  embryoIds: Array<Scalars['UUID']['input']>;
  freezeMethodId: InputMaybe<Scalars['UUID']['input']>;
  freezeTechId: InputMaybe<Scalars['UUID']['input']>;
  freezer: InputMaybe<Scalars['String']['input']>;
  graderId: InputMaybe<Scalars['UUID']['input']>;
  lowQuality: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  storageLocationId: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationupdateFreezeTempEmbryosArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  crackedZona: InputMaybe<Scalars['Boolean']['input']>;
  deactivate: InputMaybe<Scalars['Boolean']['input']>;
  freezeMethodId: InputMaybe<Scalars['UUID']['input']>;
  freezeTechId: InputMaybe<Scalars['UUID']['input']>;
  freezer: InputMaybe<Scalars['String']['input']>;
  lowQuality: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  storageLocationId: InputMaybe<Scalars['UUID']['input']>;
  tempEmbryoIds: Array<Scalars['UUID']['input']>;
};


export type MutationupdateFreshShipmentTransactionArgs = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationupdateFreshTransfersArgs = {
  embryoUpdates: Array<EmbryoUpdateInput>;
};


export type MutationupdateFreshTransfersPseArgs = {
  input: UpdateFreshTransferInput;
};


export type MutationupdateIncubatorAssignmentArgs = {
  fertilizationId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationupdateInterimEmbryoTransactionArgs = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationupdateMatingLabelsDupesXlsxArgs = {
  fertilizationDate: Scalars['String']['input'];
  shipGroups: Scalars['String']['input'];
  site: Scalars['String']['input'];
};


export type MutationupdateMatingLabelsFreezeXlsxArgs = {
  fertilizationDate: Scalars['String']['input'];
  site: Scalars['String']['input'];
};


export type MutationupdateMatingLabelsXlsxArgs = {
  fertilizationDate: Scalars['String']['input'];
  shipGroups: Scalars['String']['input'];
  site: Scalars['String']['input'];
};


export type MutationupdateODFreezeArgs = {
  dtplus?: Scalars['Boolean']['input'];
  input: UpdateODFreezeInput;
};


export type MutationupdatePredictedCommentsArgs = {
  fertilizationId: Scalars['String']['input'];
};


export type MutationupdateQCDataChutesideArgs = {
  aspirationDate: Scalars['String']['input'];
  input: QcDataChutesideInput;
  location: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type MutationupdateQCDataOpuSearchArgs = {
  aspirationDate: Scalars['String']['input'];
  input: QcDataOpuSearchInput;
  location: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
};


export type MutationupdateQcFreshShipmentArgs = {
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  qcEHMDate10ml: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate20ml: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate40ml: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate125ml: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate250ml: InputMaybe<Scalars['DateTime']['input']>;
  qcShippingTubeExpirationDate: Scalars['DateTime']['input'];
  shipGroupId: Scalars['String']['input'];
};


export type MutationupdateRevisionsArgs = {
  updates: Array<UpdateRevisionsInput>;
};


export type MutationupdateSemenArgs = {
  newSemen: UpdateSemenInput;
};


export type MutationupdateShipmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateShipmentInput;
};


export type MutationupdateShipmentGroupTransactionArgs = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationupdateSireArgs = {
  input: UpdateSireInput;
};


export type MutationupdateTempEmbryoOwnersArgs = {
  donorScheduleId: Scalars['UUID']['input'];
};


export type MutationupdateViewArgs = {
  input: UpdateViewInput;
};


export type MutationupsertDonorSchedulesArgs = {
  annotationNoteText: InputMaybe<Scalars['String']['input']>;
  input: UpsertDonorScheduleInput;
};


export type MutationupsertPartnershipArgs = {
  input: UpsertPartnershipInput;
};


export type MutationupsertReverseSortArgs = {
  input: UpsertReverseSortInput;
};


export type MutationvalidateFreezeArgs = {
  fertilizationDate: Scalars['String']['input'];
  fertilizationId: InputMaybe<Scalars['String']['input']>;
  fertilizationIds: Array<Scalars['UUID']['input']>;
  fertilizationSiteId: Scalars['String']['input'];
  validationDate: Scalars['DateTime']['input'];
  validatorId: Scalars['UUID']['input'];
};

export type MutationResponse = {
  __typename: 'MutationResponse';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type NewCalfEntryInput = {
  birth?: InputMaybe<Scalars['DateTime']['input']>;
  breedId?: InputMaybe<Scalars['UUID']['input']>;
  col1FeedingAmount?: InputMaybe<Scalars['String']['input']>;
  col1FeedingDate?: InputMaybe<Scalars['DateTime']['input']>;
  col1FeedingTime?: InputMaybe<Scalars['Int']['input']>;
  col2FeedingAmount?: InputMaybe<Scalars['String']['input']>;
  col2FeedingDate?: InputMaybe<Scalars['DateTime']['input']>;
  col2FeedingTime?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  ddEntryDate?: InputMaybe<Scalars['DateTime']['input']>;
  navelStatus?: InputMaybe<Scalars['String']['input']>;
  penId?: InputMaybe<Scalars['UUID']['input']>;
  registry?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  temp?: InputMaybe<Scalars['Decimal']['input']>;
  testiclesDecendedOn?: InputMaybe<Scalars['DateTime']['input']>;
  testicularDevelopment?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  yardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NewSemenInput = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  available?: InputMaybe<Scalars['Int']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  colCode?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  cssCertified?: InputMaybe<Scalars['Int']['input']>;
  donorScheduleDate: Scalars['DateTime']['input'];
  donorScheduleSemenLocation?: InputMaybe<Scalars['String']['input']>;
  donorScheduleSemenType?: InputMaybe<Scalars['String']['input']>;
  fertSiteId?: InputMaybe<Scalars['UUID']['input']>;
  move?: InputMaybe<Scalars['Int']['input']>;
  naab?: InputMaybe<Scalars['String']['input']>;
  recDate?: InputMaybe<Scalars['DateTime']['input']>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  semenType?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['Int']['input']>;
  sexed?: InputMaybe<Scalars['Int']['input']>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  storageId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NucleusCustomViews = {
  __typename: 'NucleusCustomViews';
  app: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  usage: Scalars['String']['output'];
  username: Scalars['String']['output'];
  view: Scalars['String']['output'];
};

export type NucleusErrorLogPayload = {
  __typename: 'NucleusErrorLogPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The nucleus_error_logs table that contains the newly added error log. */
  nucleusErrorLogs: Maybe<Array<NucleusErrorLogs>>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type NucleusErrorLogs = {
  __typename: 'NucleusErrorLogs';
  asUserId: Scalars['UUID']['output'];
  errorInfo: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  errorName: Maybe<Scalars['String']['output']>;
  errorStack: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  userAgent: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type NucleusErrorLogsFilterInput = {
  and?: InputMaybe<Array<NucleusErrorLogsFilterInput>>;
  asUserId?: InputMaybe<UuidOperationFilterInput>;
  errorInfo?: InputMaybe<StringOperationFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  errorName?: InputMaybe<StringOperationFilterInput>;
  errorStack?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NucleusErrorLogsFilterInput>>;
  timestamp?: InputMaybe<StringOperationFilterInput>;
  userAgent?: InputMaybe<StringOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type NucleusErrorLogsInput = {
  asUserId: Scalars['UUID']['input'];
  errorInfo?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorName?: InputMaybe<Scalars['String']['input']>;
  errorStack?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type NucleusErrorLogsSortInput = {
  asUserId?: InputMaybe<SortEnumType>;
  errorInfo?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  errorName?: InputMaybe<SortEnumType>;
  errorStack?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  timestamp?: InputMaybe<SortEnumType>;
  userAgent?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

export type NullableOftog_categoryOperationFilterInput = {
  eq?: InputMaybe<tog_category>;
  in?: InputMaybe<Array<InputMaybe<tog_category>>>;
  neq?: InputMaybe<tog_category>;
  nin?: InputMaybe<Array<InputMaybe<tog_category>>>;
};

export type NullableOftog_contaminationsOperationFilterInput = {
  eq?: InputMaybe<tog_contaminations>;
  in?: InputMaybe<Array<InputMaybe<tog_contaminations>>>;
  neq?: InputMaybe<tog_contaminations>;
  nin?: InputMaybe<Array<InputMaybe<tog_contaminations>>>;
};

export type NullableOftog_fertplanOperationFilterInput = {
  eq?: InputMaybe<tog_fertplan>;
  in?: InputMaybe<Array<InputMaybe<tog_fertplan>>>;
  neq?: InputMaybe<tog_fertplan>;
  nin?: InputMaybe<Array<InputMaybe<tog_fertplan>>>;
};

export type NullableOftog_noembryosproducedOperationFilterInput = {
  eq?: InputMaybe<tog_noembryosproduced>;
  in?: InputMaybe<Array<InputMaybe<tog_noembryosproduced>>>;
  neq?: InputMaybe<tog_noembryosproduced>;
  nin?: InputMaybe<Array<InputMaybe<tog_noembryosproduced>>>;
};

export type NullableOftog_subfamilyOperationFilterInput = {
  eq?: InputMaybe<tog_subfamily>;
  in?: InputMaybe<Array<InputMaybe<tog_subfamily>>>;
  neq?: InputMaybe<tog_subfamily>;
  nin?: InputMaybe<Array<InputMaybe<tog_subfamily>>>;
};

export type ODSemen = {
  __typename: 'ODSemen';
  accountID: Maybe<Scalars['UUID']['output']>;
  accountName: Maybe<Scalars['String']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  colCode: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  semenID: Scalars['UUID']['output'];
  semenName: Maybe<Scalars['String']['output']>;
  semenStorageID: Maybe<Scalars['UUID']['output']>;
  semenStorageName: Maybe<Scalars['String']['output']>;
  semenStorageSiteName: Maybe<Scalars['String']['output']>;
  semenTypeName: Maybe<Scalars['String']['output']>;
};

/** A segment of a collection. */
export type OpenItRequestsCollectionSegment = {
  __typename: 'OpenItRequestsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Request>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type OptionSet = {
  __typename: 'OptionSet';
  abbrev: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  description2: Maybe<Scalars['String']['output']>;
  description3: Maybe<Scalars['String']['output']>;
  filterKey: Maybe<Scalars['String']['output']>;
  freeMethodEmbryos: Array<Embryo>;
  freezeMethodFertilizations: Array<Fertilization>;
  frzFreezeMethodFertilizations: Array<Fertilization>;
  housingDonors: Array<Donor>;
  id: Scalars['UUID']['output'];
  ivfStatusDonors: Array<Donor>;
  label: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  ocvStatusDonors: Array<Donor>;
  search: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  statusDonors: Array<Donor>;
};

export type OptionSetFilterInput = {
  abbrev?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OptionSetFilterInput>>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  description2?: InputMaybe<StringOperationFilterInput>;
  description3?: InputMaybe<StringOperationFilterInput>;
  filterKey?: InputMaybe<StringOperationFilterInput>;
  freeMethodEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  freezeMethodFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  frzFreezeMethodFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  housingDonors?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  ivfStatusDonors?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  ocvStatusDonors?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
  or?: InputMaybe<Array<OptionSetFilterInput>>;
  search?: InputMaybe<StringOperationFilterInput>;
  sequence?: InputMaybe<IntOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  statusDonors?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
};

export type OptionSetInput = {
  abbrev?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description2?: InputMaybe<Scalars['String']['input']>;
  description3?: InputMaybe<Scalars['String']['input']>;
  filterKey?: InputMaybe<Scalars['String']['input']>;
  freeMethodEmbryos: Array<EmbryoInput>;
  freezeMethodFertilizations: Array<FertilizationInput>;
  frzFreezeMethodFertilizations: Array<FertilizationInput>;
  housingDonors: Array<DonorInput>;
  id: Scalars['UUID']['input'];
  ivfStatusDonors: Array<DonorInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ocvStatusDonors: Array<DonorInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  statusDonors: Array<DonorInput>;
};

export type OptionSetSortInput = {
  abbrev?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  description2?: InputMaybe<SortEnumType>;
  description3?: InputMaybe<SortEnumType>;
  filterKey?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  label?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SortEnumType>;
  sequence?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type OptionSetsCollectionSegment = {
  __typename: 'OptionSetsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<OptionSet>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type OpuEntries = {
  __typename: 'OpuEntries';
  aspTime: Maybe<Scalars['String']['output']>;
  aspirationId: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  follicles: Maybe<Scalars['String']['output']>;
  ivmCyto: Maybe<Scalars['String']['output']>;
  numInMat: Maybe<Scalars['String']['output']>;
  oocytes: Maybe<Scalars['String']['output']>;
  rowNo: Maybe<Scalars['Int']['output']>;
};

export type OpuEntriesInput = {
  aspTime?: InputMaybe<Scalars['String']['input']>;
  aspirationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  donorName?: InputMaybe<Scalars['String']['input']>;
  follicles?: InputMaybe<Scalars['String']['input']>;
  ivmCyto?: InputMaybe<Scalars['String']['input']>;
  numInMat?: InputMaybe<Scalars['String']['input']>;
  oocytes?: InputMaybe<Scalars['String']['input']>;
  rowNo?: InputMaybe<Scalars['Int']['input']>;
};

export type OpuStats = {
  __typename: 'OpuStats';
  avgFolliclesTotal: Maybe<Scalars['String']['output']>;
  avgNumInMatTotal: Maybe<Scalars['String']['output']>;
  avgOocytesTotal: Maybe<Scalars['String']['output']>;
  folliclesTotal: Maybe<Scalars['String']['output']>;
  numInMatTotal: Maybe<Scalars['String']['output']>;
  oocytesTotal: Maybe<Scalars['String']['output']>;
  techCount: Maybe<Scalars['Int']['output']>;
  techStats: Maybe<Array<OpuTechs>>;
};

export type OpuTechs = {
  __typename: 'OpuTechs';
  avgFollicles: Maybe<Scalars['String']['output']>;
  avgNumInMat: Maybe<Scalars['String']['output']>;
  avgOocytes: Maybe<Scalars['String']['output']>;
  tech: Maybe<Scalars['String']['output']>;
  techId: Maybe<Scalars['String']['output']>;
  totalFollicles: Maybe<Scalars['String']['output']>;
  totalNumInMat: Maybe<Scalars['String']['output']>;
  totalgOocytes: Maybe<Scalars['String']['output']>;
};

export type Owner = {
  __typename: 'Owner';
  code: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type OwnerBase = {
  __typename: 'OwnerBase';
  annotations: Array<Annotation>;
  id: Scalars['UUID']['output'];
  name: Maybe<Scalars['String']['output']>;
  ownerIdType: Scalars['Int']['output'];
};

export type OwnerBaseFilterInput = {
  and?: InputMaybe<Array<OwnerBaseFilterInput>>;
  annotations?: InputMaybe<ListFilterInputTypeOfAnnotationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OwnerBaseFilterInput>>;
  ownerIdType?: InputMaybe<IntOperationFilterInput>;
};

export type OwnerBaseSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownerIdType?: InputMaybe<SortEnumType>;
};

export type Ownership = {
  __typename: 'Ownership';
  accoundId: Maybe<Scalars['UUID']['output']>;
  account: Maybe<Account>;
  beginDate: Maybe<Scalars['DateTime']['output']>;
  billed: Maybe<Scalars['Int']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  donor: Maybe<Donor>;
  donorId: Scalars['UUID']['output'];
  endDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isPrimaryPartner: Scalars['Boolean']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  viewOnline: Maybe<Scalars['Int']['output']>;
};

/** A segment of a collection. */
export type OwnershipCollectionSegment = {
  __typename: 'OwnershipCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Ownership>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type OwnershipFilterInput = {
  accoundId?: InputMaybe<UuidOperationFilterInput>;
  account?: InputMaybe<AccountFilterInput>;
  and?: InputMaybe<Array<OwnershipFilterInput>>;
  beginDate?: InputMaybe<DateTimeOperationFilterInput>;
  billed?: InputMaybe<IntOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OwnershipFilterInput>>;
  percentage?: InputMaybe<FloatOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  viewOnline?: InputMaybe<IntOperationFilterInput>;
};

export type OwnershipInput = {
  accoundId?: InputMaybe<Scalars['UUID']['input']>;
  account?: InputMaybe<AccountInput>;
  beginDate?: InputMaybe<Scalars['DateTime']['input']>;
  billed?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorId: Scalars['UUID']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  viewOnline?: InputMaybe<Scalars['Int']['input']>;
};

export type OwnershipPartnership = {
  __typename: 'OwnershipPartnership';
  accountId: Scalars['UUID']['output'];
  beginDate: Maybe<Scalars['DateTime']['output']>;
  billed: Maybe<Scalars['Int']['output']>;
  donorId: Scalars['UUID']['output'];
  endDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  name: Maybe<Scalars['String']['output']>;
  percent: Maybe<Scalars['Float']['output']>;
};

export type OwnershipPartnershipFilterInput = {
  accountId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<OwnershipPartnershipFilterInput>>;
  beginDate?: InputMaybe<DateTimeOperationFilterInput>;
  billed?: InputMaybe<IntOperationFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OwnershipPartnershipFilterInput>>;
  percent?: InputMaybe<FloatOperationFilterInput>;
};

export type OwnershipPartnershipSortInput = {
  accountId?: InputMaybe<SortEnumType>;
  beginDate?: InputMaybe<SortEnumType>;
  billed?: InputMaybe<SortEnumType>;
  donorId?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  percent?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type OwnershipPartnershipsCollectionSegment = {
  __typename: 'OwnershipPartnershipsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<OwnershipPartnership>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type OwnershipSortInput = {
  accoundId?: InputMaybe<SortEnumType>;
  account?: InputMaybe<AccountSortInput>;
  beginDate?: InputMaybe<SortEnumType>;
  billed?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  donor?: InputMaybe<DonorSortInput>;
  donorId?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  percentage?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  viewOnline?: InputMaybe<SortEnumType>;
};

export type Partnership = {
  __typename: 'Partnership';
  account1: Maybe<Account>;
  account1Id: Maybe<Scalars['UUID']['output']>;
  account2: Maybe<Account>;
  account2Id: Maybe<Scalars['UUID']['output']>;
  account3: Maybe<Account>;
  account3Id: Maybe<Scalars['UUID']['output']>;
  account4: Maybe<Account>;
  account4Id: Maybe<Scalars['UUID']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  donor: Maybe<Donor>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorSchedule: Maybe<DonorSchedule>;
  donorScheduleId: Maybe<Scalars['UUID']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  importSequenceNumber: Maybe<Scalars['Int']['output']>;
  isBillingReady: Maybe<Scalars['Boolean']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  oddEven1: Maybe<Scalars['Int']['output']>;
  oddEven2: Maybe<Scalars['Int']['output']>;
  oddEven3: Maybe<Scalars['Int']['output']>;
  oddEven4: Maybe<Scalars['Int']['output']>;
  overriddenCreatedOn: Maybe<Scalars['DateTime']['output']>;
  partnershipBillingType: Maybe<Scalars['Int']['output']>;
  percent1: Maybe<Scalars['Decimal']['output']>;
  percent2: Maybe<Scalars['Decimal']['output']>;
  percent3: Maybe<Scalars['Decimal']['output']>;
  percent4: Maybe<Scalars['Decimal']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  timeZoneRuleVersionNumber: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['Int']['output']>;
  viewOnline1: Maybe<Scalars['Boolean']['output']>;
  viewOnline2: Maybe<Scalars['Boolean']['output']>;
  viewOnline3: Maybe<Scalars['Boolean']['output']>;
  viewOnline4: Maybe<Scalars['Boolean']['output']>;
};

export type PartnershipFilterInput = {
  account1?: InputMaybe<AccountFilterInput>;
  account1Id?: InputMaybe<UuidOperationFilterInput>;
  account2?: InputMaybe<AccountFilterInput>;
  account2Id?: InputMaybe<UuidOperationFilterInput>;
  account3?: InputMaybe<AccountFilterInput>;
  account3Id?: InputMaybe<UuidOperationFilterInput>;
  account4?: InputMaybe<AccountFilterInput>;
  account4Id?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<PartnershipFilterInput>>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  donorSchedule?: InputMaybe<DonorScheduleFilterInput>;
  donorScheduleId?: InputMaybe<UuidOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  importSequenceNumber?: InputMaybe<IntOperationFilterInput>;
  isBillingReady?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oddEven1?: InputMaybe<IntOperationFilterInput>;
  oddEven2?: InputMaybe<IntOperationFilterInput>;
  oddEven3?: InputMaybe<IntOperationFilterInput>;
  oddEven4?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PartnershipFilterInput>>;
  overriddenCreatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  partnershipBillingType?: InputMaybe<IntOperationFilterInput>;
  percent1?: InputMaybe<DecimalOperationFilterInput>;
  percent2?: InputMaybe<DecimalOperationFilterInput>;
  percent3?: InputMaybe<DecimalOperationFilterInput>;
  percent4?: InputMaybe<DecimalOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  timeZoneRuleVersionNumber?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
  viewOnline1?: InputMaybe<BooleanOperationFilterInput>;
  viewOnline2?: InputMaybe<BooleanOperationFilterInput>;
  viewOnline3?: InputMaybe<BooleanOperationFilterInput>;
  viewOnline4?: InputMaybe<BooleanOperationFilterInput>;
};

export type PartnershipInput = {
  account1?: InputMaybe<AccountInput>;
  account1Id?: InputMaybe<Scalars['UUID']['input']>;
  account2?: InputMaybe<AccountInput>;
  account2Id?: InputMaybe<Scalars['UUID']['input']>;
  account3?: InputMaybe<AccountInput>;
  account3Id?: InputMaybe<Scalars['UUID']['input']>;
  account4?: InputMaybe<AccountInput>;
  account4Id?: InputMaybe<Scalars['UUID']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorSchedule?: InputMaybe<DonorScheduleInput>;
  donorScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  importSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  isBillingReady?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oddEven1?: InputMaybe<Scalars['Int']['input']>;
  oddEven2?: InputMaybe<Scalars['Int']['input']>;
  oddEven3?: InputMaybe<Scalars['Int']['input']>;
  oddEven4?: InputMaybe<Scalars['Int']['input']>;
  overriddenCreatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  partnershipBillingType?: InputMaybe<Scalars['Int']['input']>;
  percent1?: InputMaybe<Scalars['Decimal']['input']>;
  percent2?: InputMaybe<Scalars['Decimal']['input']>;
  percent3?: InputMaybe<Scalars['Decimal']['input']>;
  percent4?: InputMaybe<Scalars['Decimal']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  timeZoneRuleVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  viewOnline1?: InputMaybe<Scalars['Boolean']['input']>;
  viewOnline2?: InputMaybe<Scalars['Boolean']['input']>;
  viewOnline3?: InputMaybe<Scalars['Boolean']['input']>;
  viewOnline4?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnershipItem = {
  __typename: 'PartnershipItem';
  account1: Maybe<AccountPartial>;
  account1Id: Maybe<Scalars['UUID']['output']>;
  account2: Maybe<AccountPartial>;
  account2Id: Maybe<Scalars['UUID']['output']>;
  account3: Maybe<AccountPartial>;
  account3Id: Maybe<Scalars['UUID']['output']>;
  account4: Maybe<AccountPartial>;
  account4Id: Maybe<Scalars['UUID']['output']>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorScheduleId: Maybe<Scalars['UUID']['output']>;
  oddEven1: Maybe<Scalars['Int']['output']>;
  oddEven2: Maybe<Scalars['Int']['output']>;
  oddEven3: Maybe<Scalars['Int']['output']>;
  oddEven4: Maybe<Scalars['Int']['output']>;
  partnershipBillingType: Maybe<Scalars['Int']['output']>;
  partnershipId: Maybe<Scalars['UUID']['output']>;
  percent1: Maybe<Scalars['Decimal']['output']>;
  percent2: Maybe<Scalars['Decimal']['output']>;
  percent3: Maybe<Scalars['Decimal']['output']>;
  percent4: Maybe<Scalars['Decimal']['output']>;
  type: Maybe<Scalars['Int']['output']>;
  viewOnline1: Maybe<Scalars['Boolean']['output']>;
  viewOnline2: Maybe<Scalars['Boolean']['output']>;
  viewOnline3: Maybe<Scalars['Boolean']['output']>;
  viewOnline4: Maybe<Scalars['Boolean']['output']>;
};

export type PartnershipItemFilterInput = {
  account1?: InputMaybe<AccountPartialFilterInput>;
  account1Id?: InputMaybe<UuidOperationFilterInput>;
  account2?: InputMaybe<AccountPartialFilterInput>;
  account2Id?: InputMaybe<UuidOperationFilterInput>;
  account3?: InputMaybe<AccountPartialFilterInput>;
  account3Id?: InputMaybe<UuidOperationFilterInput>;
  account4?: InputMaybe<AccountPartialFilterInput>;
  account4Id?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<PartnershipItemFilterInput>>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  donorScheduleId?: InputMaybe<UuidOperationFilterInput>;
  oddEven1?: InputMaybe<IntOperationFilterInput>;
  oddEven2?: InputMaybe<IntOperationFilterInput>;
  oddEven3?: InputMaybe<IntOperationFilterInput>;
  oddEven4?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PartnershipItemFilterInput>>;
  partnershipBillingType?: InputMaybe<IntOperationFilterInput>;
  partnershipId?: InputMaybe<UuidOperationFilterInput>;
  percent1?: InputMaybe<DecimalOperationFilterInput>;
  percent2?: InputMaybe<DecimalOperationFilterInput>;
  percent3?: InputMaybe<DecimalOperationFilterInput>;
  percent4?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
  viewOnline1?: InputMaybe<BooleanOperationFilterInput>;
  viewOnline2?: InputMaybe<BooleanOperationFilterInput>;
  viewOnline3?: InputMaybe<BooleanOperationFilterInput>;
  viewOnline4?: InputMaybe<BooleanOperationFilterInput>;
};

export type PartnershipItemSortInput = {
  account1?: InputMaybe<AccountPartialSortInput>;
  account1Id?: InputMaybe<SortEnumType>;
  account2?: InputMaybe<AccountPartialSortInput>;
  account2Id?: InputMaybe<SortEnumType>;
  account3?: InputMaybe<AccountPartialSortInput>;
  account3Id?: InputMaybe<SortEnumType>;
  account4?: InputMaybe<AccountPartialSortInput>;
  account4Id?: InputMaybe<SortEnumType>;
  donorId?: InputMaybe<SortEnumType>;
  donorScheduleId?: InputMaybe<SortEnumType>;
  oddEven1?: InputMaybe<SortEnumType>;
  oddEven2?: InputMaybe<SortEnumType>;
  oddEven3?: InputMaybe<SortEnumType>;
  oddEven4?: InputMaybe<SortEnumType>;
  partnershipBillingType?: InputMaybe<SortEnumType>;
  partnershipId?: InputMaybe<SortEnumType>;
  percent1?: InputMaybe<SortEnumType>;
  percent2?: InputMaybe<SortEnumType>;
  percent3?: InputMaybe<SortEnumType>;
  percent4?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  viewOnline1?: InputMaybe<SortEnumType>;
  viewOnline2?: InputMaybe<SortEnumType>;
  viewOnline3?: InputMaybe<SortEnumType>;
  viewOnline4?: InputMaybe<SortEnumType>;
};

export type Pen = {
  __typename: 'Pen';
  barn: Maybe<Scalars['String']['output']>;
  capacity: Maybe<Scalars['Int']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  pen: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  yard: Maybe<Yard>;
  yardId: Maybe<Scalars['UUID']['output']>;
};

export type PenFilterInput = {
  and?: InputMaybe<Array<PenFilterInput>>;
  barn?: InputMaybe<StringOperationFilterInput>;
  capacity?: InputMaybe<IntOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PenFilterInput>>;
  pen?: InputMaybe<StringOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  yard?: InputMaybe<YardFilterInput>;
  yardId?: InputMaybe<UuidOperationFilterInput>;
};

export type PenInput = {
  barn?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pen?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  yard?: InputMaybe<YardInput>;
  yardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PenSortInput = {
  barn?: InputMaybe<SortEnumType>;
  capacity?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pen?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  yard?: InputMaybe<YardSortInput>;
  yardId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PensCollectionSegment = {
  __typename: 'PensCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Pen>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Pool = {
  __typename: 'Pool';
  aspirationId: Scalars['String']['output'];
  donorName: Scalars['String']['output'];
  donorScheduleId: Maybe<Scalars['String']['output']>;
  gradeAbc: Scalars['String']['output'];
  gradeD: Scalars['String']['output'];
  gradeE: Scalars['String']['output'];
  ivmId: Scalars['String']['output'];
  semenName: Maybe<Scalars['String']['output']>;
  semenTypeName: Maybe<Scalars['String']['output']>;
  sireName: Maybe<Scalars['String']['output']>;
};

export type PrintInfoInput = {
  cane?: InputMaybe<Scalars['String']['input']>;
  embryoId?: InputMaybe<Scalars['UUID']['input']>;
  fertilizationId?: InputMaybe<Scalars['UUID']['input']>;
  intEmbryoId?: InputMaybe<Scalars['UUID']['input']>;
  recoveryCode?: InputMaybe<Scalars['String']['input']>;
  straw?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureHistoryData = {
  __typename: 'ProcedureHistoryData';
  breed: Scalars['String']['output'];
  description: Scalars['String']['output'];
  donorId: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  pregnant: Scalars['String']['output'];
  procCode: Scalars['String']['output'];
  procedure: Scalars['String']['output'];
  procedureDate: Scalars['String']['output'];
};

export type PullSemenPayload = {
  __typename: 'PullSemenPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The id of the newly pulled semen. */
  semenId: Maybe<Scalars['UUID']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type PulledSemen = {
  __typename: 'PulledSemen';
  accountId: Maybe<Scalars['UUID']['output']>;
  accountName: Maybe<Scalars['String']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  colCode: Maybe<Scalars['String']['output']>;
  donors_Sire: Maybe<Scalars['Int']['output']>;
  exportName: Maybe<Scalars['String']['output']>;
  naab: Maybe<Scalars['String']['output']>;
  name_Type: Maybe<Scalars['String']['output']>;
  pulledQuantity: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  returnNum: Maybe<Scalars['Int']['output']>;
  rowNum: Scalars['Int']['output'];
  semenId: Maybe<Scalars['UUID']['output']>;
  semenName: Maybe<Scalars['String']['output']>;
  semenStorageId: Maybe<Scalars['UUID']['output']>;
  semenStorageName: Maybe<Scalars['String']['output']>;
  semenStorageSiteName: Maybe<Scalars['String']['output']>;
  semenTypeName: Maybe<Scalars['String']['output']>;
  sireId: Maybe<Scalars['UUID']['output']>;
  sireName: Maybe<Scalars['String']['output']>;
  transactionToday: Maybe<Scalars['String']['output']>;
};

/** A segment of a collection. */
export type PulledSemenCollectionSegment = {
  __typename: 'PulledSemenCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<PulledSemenType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PulledSemenType = {
  __typename: 'PulledSemenType';
  accountID: Scalars['UUID']['output'];
  accountName: Scalars['String']['output'];
  cane: Scalars['String']['output'];
  colCode: Scalars['String']['output'];
  donors_Sire: Scalars['Int']['output'];
  exportName: Scalars['String']['output'];
  naab: Scalars['String']['output'];
  name_Type: Scalars['String']['output'];
  pulledQuantity: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  rowNum: Scalars['Int']['output'];
  semenID: Scalars['UUID']['output'];
  semenName: Scalars['String']['output'];
  semenStorageID: Scalars['UUID']['output'];
  semenStorageName: Scalars['String']['output'];
  semenStorageSiteName: Scalars['String']['output'];
  semenTypeName: Scalars['String']['output'];
  sireBreed: Scalars['String']['output'];
  sireID: Scalars['UUID']['output'];
  sireName: Scalars['String']['output'];
};

export type PulledSemenTypeFilterInput = {
  accountID?: InputMaybe<UuidOperationFilterInput>;
  accountName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<PulledSemenTypeFilterInput>>;
  cane?: InputMaybe<StringOperationFilterInput>;
  colCode?: InputMaybe<StringOperationFilterInput>;
  donors_Sire?: InputMaybe<IntOperationFilterInput>;
  exportName?: InputMaybe<StringOperationFilterInput>;
  naab?: InputMaybe<StringOperationFilterInput>;
  name_Type?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PulledSemenTypeFilterInput>>;
  pulledQuantity?: InputMaybe<IntOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  rowNum?: InputMaybe<IntOperationFilterInput>;
  semenID?: InputMaybe<UuidOperationFilterInput>;
  semenName?: InputMaybe<StringOperationFilterInput>;
  semenStorageID?: InputMaybe<UuidOperationFilterInput>;
  semenStorageName?: InputMaybe<StringOperationFilterInput>;
  semenStorageSiteName?: InputMaybe<StringOperationFilterInput>;
  semenTypeName?: InputMaybe<StringOperationFilterInput>;
  sireBreed?: InputMaybe<StringOperationFilterInput>;
  sireID?: InputMaybe<UuidOperationFilterInput>;
  sireName?: InputMaybe<StringOperationFilterInput>;
};

export type PulledSemenTypeSortInput = {
  accountID?: InputMaybe<SortEnumType>;
  accountName?: InputMaybe<SortEnumType>;
  cane?: InputMaybe<SortEnumType>;
  colCode?: InputMaybe<SortEnumType>;
  donors_Sire?: InputMaybe<SortEnumType>;
  exportName?: InputMaybe<SortEnumType>;
  naab?: InputMaybe<SortEnumType>;
  name_Type?: InputMaybe<SortEnumType>;
  pulledQuantity?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  rowNum?: InputMaybe<SortEnumType>;
  semenID?: InputMaybe<SortEnumType>;
  semenName?: InputMaybe<SortEnumType>;
  semenStorageID?: InputMaybe<SortEnumType>;
  semenStorageName?: InputMaybe<SortEnumType>;
  semenStorageSiteName?: InputMaybe<SortEnumType>;
  semenTypeName?: InputMaybe<SortEnumType>;
  sireBreed?: InputMaybe<SortEnumType>;
  sireID?: InputMaybe<SortEnumType>;
  sireName?: InputMaybe<SortEnumType>;
};

export type QcDataChuteside = {
  __typename: 'QcDataChuteside';
  chuteNumber: Scalars['Int']['output'];
  qccompleted: Scalars['Boolean']['output'];
  tog_asp_date: Scalars['String']['output'];
  tog_qc_brennerneedlelotno: Scalars['String']['output'];
  tog_qc_collectionroomtemp: Scalars['String']['output'];
  tog_qc_commentchuteside: Scalars['String']['output'];
  tog_qc_flowrate: Scalars['String']['output'];
  tog_qc_location: Scalars['String']['output'];
  tog_qc_outsidetemp: Scalars['String']['output'];
  tog_qc_outsideweatherconditions: Scalars['String']['output'];
  tog_qc_pockettubewarmertemp: Scalars['String']['output'];
  tog_qc_pumppressure: Scalars['String']['output'];
  tog_qc_pumptubewarmertemp: Scalars['String']['output'];
  tog_siteid: Scalars['String']['output'];
};

export type QcDataChutesideInput = {
  chuteNumber: Scalars['Int']['input'];
  qccompleted: Scalars['Boolean']['input'];
  tog_asp_date: Scalars['String']['input'];
  tog_qc_brennerneedlelotno: Scalars['String']['input'];
  tog_qc_collectionroomtemp: Scalars['String']['input'];
  tog_qc_commentchuteside: Scalars['String']['input'];
  tog_qc_flowrate: Scalars['String']['input'];
  tog_qc_location: Scalars['String']['input'];
  tog_qc_outsidetemp: Scalars['String']['input'];
  tog_qc_outsideweatherconditions: Scalars['String']['input'];
  tog_qc_pockettubewarmertemp: Scalars['String']['input'];
  tog_qc_pumppressure: Scalars['String']['input'];
  tog_qc_pumptubewarmertemp: Scalars['String']['input'];
  tog_siteid: Scalars['String']['input'];
};

export type QcDataOpuSearch = {
  __typename: 'QcDataOpuSearch';
  qcFreezetemp: Maybe<Scalars['String']['output']>;
  qccompleted: Maybe<Scalars['Boolean']['output']>;
  tog_asp_date: Maybe<Scalars['String']['output']>;
  tog_qc_cellstrainer: Maybe<Scalars['String']['output']>;
  tog_qc_fiftymllotno: Maybe<Scalars['String']['output']>;
  tog_qc_fiftymltubetype: Maybe<Scalars['String']['output']>;
  tog_qc_hepdate: Maybe<Scalars['String']['output']>;
  tog_qc_incubatorno: Maybe<Scalars['String']['output']>;
  tog_qc_location: Maybe<Scalars['String']['output']>;
  tog_qc_matdate: Maybe<Scalars['String']['output']>;
  tog_qc_opuflush: Maybe<Scalars['String']['output']>;
  tog_qc_opuflushdate: Maybe<Scalars['String']['output']>;
  tog_qc_opuholding: Maybe<Scalars['String']['output']>;
  tog_qc_opuholdingdate: Maybe<Scalars['String']['output']>;
  tog_qc_rinsemedialotdate: Maybe<Scalars['String']['output']>;
  tog_qc_slide_warmer: Maybe<Scalars['String']['output']>;
  tog_qc_tenmlsyringe: Maybe<Scalars['String']['output']>;
  tog_qc_thirtymlsyringe: Maybe<Scalars['String']['output']>;
  tog_qc_tokai_hit: Maybe<Scalars['String']['output']>;
  tog_qc_water_bath_temperature: Maybe<Scalars['String']['output']>;
  tog_qcairqualityint: Maybe<Scalars['Int']['output']>;
  tog_qcairqualitystring: Maybe<Scalars['String']['output']>;
  tog_qccomment: Maybe<Scalars['String']['output']>;
  tog_siteid: Maybe<Scalars['String']['output']>;
};

export type QcDataOpuSearchInput = {
  qcFreezetemp?: InputMaybe<Scalars['String']['input']>;
  qccompleted?: InputMaybe<Scalars['Boolean']['input']>;
  tog_asp_date?: InputMaybe<Scalars['String']['input']>;
  tog_qc_cellstrainer?: InputMaybe<Scalars['String']['input']>;
  tog_qc_fiftymllotno?: InputMaybe<Scalars['String']['input']>;
  tog_qc_fiftymltubetype?: InputMaybe<Scalars['String']['input']>;
  tog_qc_hepdate?: InputMaybe<Scalars['String']['input']>;
  tog_qc_incubatorno?: InputMaybe<Scalars['String']['input']>;
  tog_qc_location?: InputMaybe<Scalars['String']['input']>;
  tog_qc_matdate?: InputMaybe<Scalars['String']['input']>;
  tog_qc_opuflush?: InputMaybe<Scalars['String']['input']>;
  tog_qc_opuflushdate?: InputMaybe<Scalars['String']['input']>;
  tog_qc_opuholding?: InputMaybe<Scalars['String']['input']>;
  tog_qc_opuholdingdate?: InputMaybe<Scalars['String']['input']>;
  tog_qc_rinsemedialotdate?: InputMaybe<Scalars['String']['input']>;
  tog_qc_slide_warmer?: InputMaybe<Scalars['String']['input']>;
  tog_qc_tenmlsyringe?: InputMaybe<Scalars['String']['input']>;
  tog_qc_thirtymlsyringe?: InputMaybe<Scalars['String']['input']>;
  tog_qc_tokai_hit?: InputMaybe<Scalars['String']['input']>;
  tog_qc_water_bath_temperature?: InputMaybe<Scalars['String']['input']>;
  tog_qcairqualityint?: InputMaybe<Scalars['Int']['input']>;
  tog_qcairqualitystring?: InputMaybe<Scalars['String']['input']>;
  tog_qccomment?: InputMaybe<Scalars['String']['input']>;
  tog_siteid?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename: 'Query';
  account: Maybe<Account>;
  accountByDateAndSite: Array<AccountDto>;
  accounts: Maybe<AccountsCollectionSegment>;
  adGroups: Array<Scalars['String']['output']>;
  adUsers: Array<AdUser>;
  aetaResults: Maybe<AetaResultsCollectionSegment>;
  allConnections: Array<Connection>;
  allShipmentGroupMasters: Maybe<AllShipmentGroupMastersCollectionSegment>;
  allShipments: Maybe<AllShipmentsCollectionSegment>;
  allTopRevisions: Array<RevisionPayload>;
  annotations: Maybe<AnnotationsCollectionSegment>;
  appConfig: Maybe<AppConfigCollectionSegment>;
  apps: Array<App>;
  appsFavorites: Array<Scalars['ID']['output']>;
  aspDataPool: Array<Pool>;
  aspirationByDonorDateSite: Maybe<Array<TOG_GetAspirationByDonorDateSite>>;
  aspirationHistoryDataByDonorId: Array<AspirationHistoryData>;
  aspirationPools: Maybe<AspirationPoolsCollectionSegment>;
  aspirationSites: Array<AspirationSite>;
  aspirations: Maybe<AspirationsCollectionSegment>;
  assignTubes: Array<TOA_GetFreshShipmentFertList>;
  /** @deprecated Use `auditLogHistory` instead */
  auditLog: Maybe<AuditLogCollectionSegment>;
  /** @deprecated Use `auditLogHistory` instead */
  auditLogEntityMetadata: AuditLogTableMetadata;
  /** @deprecated Use `auditLogHistory` instead */
  auditLogEntityName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use REST endpoint GET /api/v1/AuditLog/history instead — reads from centralized audit-api */
  auditLogHistory: AuditLogCollection;
  auditLogTableMetadata: Maybe<TableMetadata>;
  avgData: Array<Avgs>;
  breeds: Maybe<BreedsCollectionSegment>;
  calves: Maybe<CalvesCollectionSegment>;
  cellLines: Maybe<CellLinesCollectionSegment>;
  checkFeatures: Array<Scalars['String']['output']>;
  chuteScheduleCombined: ChuteScheduleCombined;
  chuteSchedules: Maybe<ChuteSchedulesCollectionSegment>;
  closedItRequests: Maybe<ClosedItRequestsCollectionSegment>;
  contacts: Maybe<ContactsCollectionSegment>;
  createdFerts: Maybe<CreatedFertsCollectionSegment>;
  csrDay7: Array<TOG_CsrDay7>;
  currentEquipments: Maybe<CurrentEquipmentsCollectionSegment>;
  currentFertPredictionTechId: Maybe<Equipment>;
  day7FrozenEmbryos: Array<Day7FrozenEmbryo>;
  defaultView: Maybe<NucleusCustomViews>;
  donorProcedures: Maybe<DonorProceduresCollectionSegment>;
  donorSchedules: Maybe<DonorSchedulesCollectionSegment>;
  donorSchedulesByIds: Array<DonorSchedule>;
  donors: Maybe<DonorsCollectionSegment>;
  drugs: Maybe<DrugsCollectionSegment>;
  embFertDataByDonorId: Array<FertilizationData>;
  embryos: Maybe<EmbryosCollectionSegment>;
  entryData: Array<OpuEntries>;
  entryDataPSE: Array<OpuEntries>;
  equipment: Maybe<Equipment>;
  equipments: Maybe<EquipmentsCollectionSegment>;
  estimationHeaderVal: Scalars['String']['output'];
  features: Maybe<FeaturesCollectionSegment>;
  fertAndEmbryosFreeze: Array<FertilizationWithEmbryos>;
  fertCommentsInGridList: Maybe<FertCommentsInGridListCollectionSegment>;
  fertCommentsList: Maybe<FertCommentsListCollectionSegment>;
  fertDataByDonorIdChuteside: Array<FertilizationDataChuteside>;
  fertSites: Maybe<FertSitesCollectionSegment>;
  fertilizationDonorSchedules: Maybe<FertilizationDonorSchedulesCollectionSegment>;
  fertilizationList: Array<TOA_GetFreshShipmentFertList>;
  fertilizationListFreeze: Array<TOA_GetFertilizationsForFreezing>;
  fertilizationStorageLocations: Maybe<FertilizationStorageLocationsCollectionSegment>;
  fertilizations: Maybe<FertilizationsCollectionSegment>;
  freezeEntries: Maybe<FreezeEntriesCollectionSegment>;
  freshShipmentList: Array<TOA_GetFreshShipments>;
  freshShipmentQC: FertilizationQCResponse;
  getNucleusErrorLogs: Maybe<GetNucleusErrorLogsCollectionSegment>;
  getPartnerships: Maybe<GetPartnershipsCollectionSegment>;
  getPartnershipsByDonorId: Maybe<GetPartnershipsByDonorIdCollectionSegment>;
  getPulledSemen: Array<PulledSemen>;
  getScheduledDonors: Array<ScheduledDonorType>;
  getUnfinishedScheduledDonors: Array<ScheduledDonorType>;
  incubators: Maybe<IncubatorsCollectionSegment>;
  itRequest: Maybe<Request>;
  itRequestApps: Array<TogRequestApp>;
  itRequestDepartments: Array<TogRequestDepartment>;
  itRequestSearch: Array<Request>;
  itRequests: Maybe<ItRequestsCollectionSegment>;
  locations: Maybe<LocationsCollectionSegment>;
  me: Maybe<SystemUser>;
  messagingConfirmations: Maybe<MessagingConfirmationsCollectionSegment>;
  odSemen: Array<ODSemen>;
  odSimilarSemen: Array<ODSemen>;
  openItRequests: Maybe<OpenItRequestsCollectionSegment>;
  optionSets: Maybe<OptionSetsCollectionSegment>;
  ownership: Maybe<OwnershipCollectionSegment>;
  ownershipPartnerships: Maybe<OwnershipPartnershipsCollectionSegment>;
  pens: Maybe<PensCollectionSegment>;
  previousSchedules: Maybe<Array<TOG_schedmasterWithAspirationDate>>;
  proceduresByDonorId: Array<ProcedureHistoryData>;
  pseDay7: Array<TOG_PseDay7>;
  pseDay7Matings: Array<Fertilization>;
  pulledSemen: Maybe<PulledSemenCollectionSegment>;
  recipients: Maybe<RecipientsCollectionSegment>;
  refreshStopGoSign: Maybe<Scalars['Boolean']['output']>;
  requestIssueManagers: Maybe<RequestIssueManagersCollectionSegment>;
  scheduleMaster: Maybe<ScheduleMasterCollectionSegment>;
  scheduledDonors: Maybe<ScheduledDonorsCollectionSegment>;
  scheduledDonorsTxp: Maybe<ScheduledDonorsTxpCollectionSegment>;
  scheduledSemen: Array<ScheduledSemen>;
  semen: Maybe<SemenCollectionSegment>;
  shipGroupList: ShipGroupListResponse;
  shipment: Maybe<Shipment>;
  shipmentGroupMasters: Array<TOA_GetFreshShipmentShipGroupMasters>;
  shipmentGroups: Maybe<ShipmentGroupsCollectionSegment>;
  shipments: Maybe<ShipmentsCollectionSegment>;
  showStopSign: Scalars['Boolean']['output'];
  sireSelectionRequests: Maybe<SireSelectionRequestsCollectionSegment>;
  sires: Maybe<SiresCollectionSegment>;
  sites: Maybe<SitesCollectionSegment>;
  statsData: OpuStats;
  statsDataPSE: OpuStats;
  storageLocations: Maybe<StorageLocationsCollectionSegment>;
  stringMap: Maybe<Array<KeyValuePairOfInt32AndNullableString>>;
  stringMaps: Maybe<StringMapsCollectionSegment>;
  strippingFertilizations: Maybe<StrippingFertilizationsCollectionSegment>;
  superOvulationSchedules: Maybe<SuperOvulationSchedulesCollectionSegment>;
  systemUsers: Maybe<SystemUsersCollectionSegment>;
  techAvgData: Array<Avgs>;
  techs: Maybe<TechsCollectionSegment>;
  telemetryEvents: Maybe<TelemetryEventsCollectionSegment>;
  tempAspirationQcInfo: Maybe<tog_chutesideqc>;
  tempEmbryos: Maybe<TempEmbryosCollectionSegment>;
  todaysAspirations: Array<AspirationsToday>;
  todaysCompletedAspirationsFBD: Maybe<Array<AspirationsToday>>;
  todaysCompletedAspirationsNew: Maybe<Array<AspirationsToday>>;
  todaysQcDataChuteside: QcDataChuteside;
  todaysQcDataOpuSearch: QcDataOpuSearch;
  topRevisionsByFertilizationSite: Maybe<Scalars['String']['output']>;
  viewById: Maybe<NucleusCustomViews>;
  viewNames: Array<NucleusCustomViews>;
  yards: Maybe<YardsCollectionSegment>;
};


export type QueryaccountArgs = {
  where: InputMaybe<AccountFilterInput>;
};


export type QueryaccountByDateAndSiteArgs = {
  fertilizationDate: Scalars['DateTime']['input'];
  fertilizationSite: Scalars['UUID']['input'];
  transferDate: Scalars['DateTime']['input'];
  transferSite: Scalars['UUID']['input'];
};


export type QueryaccountsArgs = {
  order: InputMaybe<Array<AccountSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AccountFilterInput>;
};


export type QueryaetaResultsArgs = {
  order: InputMaybe<Array<AetaResultSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AetaResultFilterInput>;
};


export type QueryallConnectionsArgs = {
  order: InputMaybe<Array<ConnectionSortInput>>;
  where: InputMaybe<ConnectionFilterInput>;
};


export type QueryallShipmentGroupMastersArgs = {
  order: InputMaybe<Array<ShipmentGroupMasterSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ShipmentGroupMasterFilterInput>;
};


export type QueryallShipmentsArgs = {
  order: InputMaybe<Array<ShipmentSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ShipmentFilterInput>;
};


export type QueryallTopRevisionsArgs = {
  date: Scalars['DateTime']['input'];
};


export type QueryannotationsArgs = {
  order: InputMaybe<Array<AnnotationSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AnnotationFilterInput>;
};


export type QueryappConfigArgs = {
  order: InputMaybe<Array<AppsConfigSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AppsConfigFilterInput>;
};


export type QueryaspDataPoolArgs = {
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type QueryaspirationByDonorDateSiteArgs = {
  date: Scalars['String']['input'];
  donorId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type QueryaspirationHistoryDataByDonorIdArgs = {
  aspirationDate: Scalars['String']['input'];
  donorId: Scalars['String']['input'];
  ranch: Scalars['String']['input'];
};


export type QueryaspirationPoolsArgs = {
  order: InputMaybe<Array<AspirationPoolSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AspirationPoolFilterInput>;
};


export type QueryaspirationSitesArgs = {
  order: InputMaybe<Array<AspirationSiteSortInput>>;
  where: InputMaybe<AspirationSiteFilterInput>;
};


export type QueryaspirationsArgs = {
  order: InputMaybe<Array<AspirationSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AspirationFilterInput>;
};


export type QueryassignTubesArgs = {
  fertlist: Array<TOA_GetFreshShipmentFertListInput>;
  fertsWithTubes: Scalars['Int']['input'];
};


export type QueryauditLogArgs = {
  order: InputMaybe<Array<AuditLogSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AuditLogFilterInput>;
};


export type QueryauditLogEntityMetadataArgs = {
  entityName: Scalars['String']['input'];
  languageCode?: Scalars['String']['input'];
};


export type QueryauditLogEntityNameArgs = {
  objectId: Scalars['UUID']['input'];
};


export type QueryauditLogHistoryArgs = {
  languageCode?: Scalars['String']['input'];
  objectId: Scalars['UUID']['input'];
  order: InputMaybe<Array<AuditLogSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AuditLogFilterInput>;
};


export type QueryauditLogTableMetadataArgs = {
  languageCode?: Scalars['String']['input'];
  objectId: Scalars['UUID']['input'];
};


export type QueryavgDataArgs = {
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type QuerybreedsArgs = {
  order: InputMaybe<Array<BreedSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<BreedFilterInput>;
};


export type QuerycalvesArgs = {
  order: InputMaybe<Array<CalfSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CalfFilterInput>;
};


export type QuerycellLinesArgs = {
  order: InputMaybe<Array<CellLineSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CellLineFilterInput>;
};


export type QuerycheckFeaturesArgs = {
  features: Array<Scalars['String']['input']>;
};


export type QuerychuteScheduleCombinedArgs = {
  date: Scalars['DateTime']['input'];
  siteId: Scalars['UUID']['input'];
};


export type QuerychuteSchedulesArgs = {
  date: Scalars['DateTime']['input'];
  order: InputMaybe<Array<ChuteScheduleSortInput>>;
  siteId: Scalars['UUID']['input'];
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ChuteScheduleFilterInput>;
};


export type QueryclosedItRequestsArgs = {
  order: InputMaybe<Array<RequestSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<RequestFilterInput>;
};


export type QuerycontactsArgs = {
  order: InputMaybe<Array<ContactSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ContactFilterInput>;
};


export type QuerycreatedFertsArgs = {
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
  order: InputMaybe<Array<CreatedFertTypeSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CreatedFertTypeFilterInput>;
};


export type QuerycsrDay7Args = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  beginDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  siteId: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerycurrentEquipmentsArgs = {
  order: InputMaybe<Array<EquipmentSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<EquipmentFilterInput>;
};


export type QuerycurrentFertPredictionTechIdArgs = {
  fertilizationId: Scalars['UUID']['input'];
};


export type Queryday7FrozenEmbryosArgs = {
  beginDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  siteId: Scalars['UUID']['input'];
};


export type QuerydefaultViewArgs = {
  usage: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type QuerydonorProceduresArgs = {
  order: InputMaybe<Array<DonorProcedureSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<DonorProcedureFilterInput>;
};


export type QuerydonorSchedulesArgs = {
  order: InputMaybe<Array<DonorScheduleSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<DonorScheduleFilterInput>;
};


export type QuerydonorSchedulesByIdsArgs = {
  ids: Array<Scalars['UUID']['input']>;
  order: InputMaybe<Array<DonorScheduleSortInput>>;
  where: InputMaybe<DonorScheduleFilterInput>;
};


export type QuerydonorsArgs = {
  order: InputMaybe<Array<DonorSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<DonorFilterInput>;
};


export type QuerydrugsArgs = {
  order: InputMaybe<Array<DrugSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<DrugFilterInput>;
};


export type QueryembFertDataByDonorIdArgs = {
  donorId: Scalars['UUID']['input'];
  ranch: InputMaybe<Scalars['String']['input']>;
};


export type QueryembryosArgs = {
  order: InputMaybe<Array<EmbryoSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<EmbryoFilterInput>;
};


export type QueryentryDataArgs = {
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  techId: Scalars['String']['input'];
};


export type QueryentryDataPSEArgs = {
  aspirationDate: Scalars['String']['input'];
  pseId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type QueryequipmentArgs = {
  where: InputMaybe<EquipmentFilterInput>;
};


export type QueryequipmentsArgs = {
  order: InputMaybe<Array<EquipmentSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<EquipmentFilterInput>;
};


export type QueryestimationHeaderValArgs = {
  shipGroupId: Scalars['String']['input'];
};


export type QueryfeaturesArgs = {
  order: InputMaybe<Array<FeatureSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<FeatureFilterInput>;
};


export type QueryfertAndEmbryosFreezeArgs = {
  fertilizationDate: Scalars['String']['input'];
  fertilizationIds: Array<Scalars['UUID']['input']>;
  fertilizationSiteId: Scalars['String']['input'];
};


export type QueryfertCommentsInGridListArgs = {
  order: InputMaybe<Array<CommentTypeSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CommentTypeFilterInput>;
};


export type QueryfertCommentsListArgs = {
  order: InputMaybe<Array<CommentTypeSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CommentTypeFilterInput>;
};


export type QueryfertDataByDonorIdChutesideArgs = {
  donorId: Scalars['String']['input'];
  ranch: Scalars['String']['input'];
};


export type QueryfertSitesArgs = {
  order: InputMaybe<Array<FertSiteTypeSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<FertSiteTypeFilterInput>;
};


export type QueryfertilizationDonorSchedulesArgs = {
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
  order: InputMaybe<Array<FertilizationDonorScheduleTypeSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<FertilizationDonorScheduleTypeFilterInput>;
};


export type QueryfertilizationListArgs = {
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
};


export type QueryfertilizationListFreezeArgs = {
  fertilizationDate: Scalars['String']['input'];
  fertilizationId: InputMaybe<Scalars['String']['input']>;
  fertilizationSiteId: Scalars['String']['input'];
  searchQuery: InputMaybe<Scalars['String']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type QueryfertilizationStorageLocationsArgs = {
  fertSiteId: InputMaybe<Scalars['UUID']['input']>;
  order: InputMaybe<Array<FertilizationStorageLocationTypeSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<FertilizationStorageLocationTypeFilterInput>;
};


export type QueryfertilizationsArgs = {
  order: InputMaybe<Array<FertilizationSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<FertilizationFilterInput>;
};


export type QueryfreezeEntriesArgs = {
  order: InputMaybe<Array<EmbryoFreezeEntrySortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<EmbryoFreezeEntryFilterInput>;
};


export type QueryfreshShipmentListArgs = {
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  fertilizationSiteName: Scalars['String']['input'];
};


export type QueryfreshShipmentQCArgs = {
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupIds: Array<Scalars['UUID']['input']>;
};


export type QuerygetNucleusErrorLogsArgs = {
  order: InputMaybe<Array<NucleusErrorLogsSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<NucleusErrorLogsFilterInput>;
};


export type QuerygetPartnershipsArgs = {
  donorId: InputMaybe<Scalars['UUID']['input']>;
  donorScheduleId: InputMaybe<Scalars['UUID']['input']>;
  order: InputMaybe<Array<PartnershipItemSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<PartnershipItemFilterInput>;
};


export type QuerygetPartnershipsByDonorIdArgs = {
  donorId: InputMaybe<Scalars['UUID']['input']>;
  donorScheduleId: InputMaybe<Scalars['UUID']['input']>;
  order: InputMaybe<Array<PartnershipItemSortInput>>;
  ownershipId: InputMaybe<Scalars['UUID']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<PartnershipItemFilterInput>;
};


export type QuerygetPulledSemenArgs = {
  date: Scalars['DateTime']['input'];
  fertilizationSiteId: Scalars['UUID']['input'];
};


export type QuerygetScheduledDonorsArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  donorScheduleDate: Scalars['DateTime']['input'];
  dsSemenLocId: InputMaybe<Scalars['UUID']['input']>;
  fertilizationSiteId: Scalars['UUID']['input'];
  semenId: InputMaybe<Scalars['UUID']['input']>;
  semenType: InputMaybe<Scalars['String']['input']>;
  sireId: Scalars['UUID']['input'];
};


export type QuerygetUnfinishedScheduledDonorsArgs = {
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
};


export type QueryincubatorsArgs = {
  order: InputMaybe<Array<incubatorsSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<incubatorsFilterInput>;
};


export type QueryitRequestArgs = {
  where: InputMaybe<RequestFilterInput>;
};


export type QueryitRequestSearchArgs = {
  issueType: InputMaybe<RequestIssueType>;
  query: Scalars['String']['input'];
};


export type QueryitRequestsArgs = {
  order: InputMaybe<Array<RequestSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<RequestFilterInput>;
};


export type QuerylocationsArgs = {
  order: InputMaybe<Array<LocationSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<LocationFilterInput>;
};


export type QuerymessagingConfirmationsArgs = {
  order: InputMaybe<Array<MessagingConfirmationSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<MessagingConfirmationFilterInput>;
};


export type QueryodSemenArgs = {
  accountName: Scalars['String']['input'];
  caneCode: Scalars['String']['input'];
  colCode: Scalars['String']['input'];
  fertSiteId: Scalars['UUID']['input'];
  semenName: Scalars['String']['input'];
};


export type QueryodSimilarSemenArgs = {
  accountName: Scalars['String']['input'];
  caneCode: Scalars['String']['input'];
  colCode: Scalars['String']['input'];
  fertSiteId: Scalars['UUID']['input'];
  semenName: Scalars['String']['input'];
};


export type QueryopenItRequestsArgs = {
  order: InputMaybe<Array<RequestSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<RequestFilterInput>;
};


export type QueryoptionSetsArgs = {
  order: InputMaybe<Array<OptionSetSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<OptionSetFilterInput>;
};


export type QueryownershipArgs = {
  order: InputMaybe<Array<OwnershipSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<OwnershipFilterInput>;
};


export type QueryownershipPartnershipsArgs = {
  donorId: Scalars['UUID']['input'];
  order: InputMaybe<Array<OwnershipPartnershipSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<OwnershipPartnershipFilterInput>;
};


export type QuerypensArgs = {
  order: InputMaybe<Array<PenSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<PenFilterInput>;
};


export type QuerypreviousSchedulesArgs = {
  donorId: Scalars['UUID']['input'];
  donorScheduleId: Scalars['UUID']['input'];
  ownerId: Scalars['UUID']['input'];
};


export type QueryproceduresByDonorIdArgs = {
  donorId: Scalars['String']['input'];
  ranch: Scalars['String']['input'];
};


export type QuerypseDay7Args = {
  beginDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  siteId: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerypseDay7MatingsArgs = {
  beginDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  siteId: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerypulledSemenArgs = {
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
  order: InputMaybe<Array<PulledSemenTypeSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<PulledSemenTypeFilterInput>;
};


export type QueryrecipientsArgs = {
  order: InputMaybe<Array<RecipientSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<RecipientFilterInput>;
};


export type QueryrefreshStopGoSignArgs = {
  siteId: Scalars['String']['input'];
  val: Scalars['String']['input'];
};


export type QueryrequestIssueManagersArgs = {
  order: InputMaybe<Array<RequestIssueManagerSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<RequestIssueManagerFilterInput>;
};


export type QueryscheduleMasterArgs = {
  order: InputMaybe<Array<ScheduleMasterSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ScheduleMasterFilterInput>;
};


export type QueryscheduledDonorsArgs = {
  accountID: Scalars['String']['input'];
  donorScheduleDate: Scalars['DateTime']['input'];
  order: InputMaybe<Array<ScheduledDonorTypeSortInput>>;
  semenID: Scalars['String']['input'];
  semenType: Scalars['String']['input'];
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ScheduledDonorTypeFilterInput>;
};


export type QueryscheduledDonorsTxpArgs = {
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['String']['input'];
  order: InputMaybe<Array<ScheduledDonorTypeSortInput>>;
  sireId: Scalars['String']['input'];
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ScheduledDonorTypeFilterInput>;
};


export type QueryscheduledSemenArgs = {
  date: Scalars['DateTime']['input'];
  fertilizationSiteId: Scalars['UUID']['input'];
};


export type QuerysemenArgs = {
  order: InputMaybe<Array<SemenSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<SemenFilterInput>;
};


export type QueryshipGroupListArgs = {
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
};


export type QueryshipmentArgs = {
  where: InputMaybe<ShipmentFilterInput>;
};


export type QueryshipmentGroupMastersArgs = {
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
};


export type QueryshipmentGroupsArgs = {
  order: InputMaybe<Array<ShipmentGroupSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ShipmentGroupFilterInput>;
};


export type QueryshipmentsArgs = {
  order: InputMaybe<Array<ShipmentSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<ShipmentFilterInput>;
};


export type QueryshowStopSignArgs = {
  siteId: Scalars['String']['input'];
};


export type QuerysireSelectionRequestsArgs = {
  order: InputMaybe<Array<SireSelectionRequestSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<SireSelectionRequestFilterInput>;
};


export type QuerysiresArgs = {
  order: InputMaybe<Array<SireSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<SireFilterInput>;
};


export type QuerysitesArgs = {
  order: InputMaybe<Array<SiteSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<SiteFilterInput>;
};


export type QuerystatsDataArgs = {
  aspirationDate: Scalars['String']['input'];
  location: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
};


export type QuerystatsDataPSEArgs = {
  aspirationDate: Scalars['String']['input'];
  location: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
};


export type QuerystorageLocationsArgs = {
  order: InputMaybe<Array<StorageLocationSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<StorageLocationFilterInput>;
};


export type QuerystringMapArgs = {
  name: Scalars['String']['input'];
  objectTypeCode: InputMaybe<Scalars['Int']['input']>;
};


export type QuerystringMapsArgs = {
  order: InputMaybe<Array<StringMapSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<StringMapFilterInput>;
};


export type QuerystrippingFertilizationsArgs = {
  fertilizationDate: Scalars['DateTime']['input'];
  order: InputMaybe<Array<FertilizationSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<FertilizationFilterInput>;
};


export type QuerysuperOvulationSchedulesArgs = {
  order: InputMaybe<Array<SuperOvulationScheduleSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<SuperOvulationScheduleFilterInput>;
};


export type QuerysystemUsersArgs = {
  order: InputMaybe<Array<SystemUserSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<SystemUserFilterInput>;
};


export type QuerytechAvgDataArgs = {
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  techId: Scalars['String']['input'];
};


export type QuerytechsArgs = {
  fertSiteId: InputMaybe<Scalars['UUID']['input']>;
  order: InputMaybe<Array<TechTypeSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<TechTypeFilterInput>;
};


export type QuerytelemetryEventsArgs = {
  order: InputMaybe<Array<TogTelemetryEventSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<TogTelemetryEventFilterInput>;
};


export type QuerytempAspirationQcInfoArgs = {
  aspirationDate: Scalars['DateTime']['input'];
  chuteNumber: Scalars['Int']['input'];
  location: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
};


export type QuerytempEmbryosArgs = {
  embryoIds: Array<InputMaybe<Scalars['Int']['input']>>;
  order: InputMaybe<Array<tog_embryo_stagingSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<tog_embryo_stagingFilterInput>;
};


export type QuerytodaysAspirationsArgs = {
  date: Scalars['String']['input'];
  location?: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  techId: InputMaybe<Scalars['String']['input']>;
  type: Scalars['Int']['input'];
  vetId: InputMaybe<Scalars['String']['input']>;
};


export type QuerytodaysCompletedAspirationsFBDArgs = {
  date: Scalars['String']['input'];
  location: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type QuerytodaysCompletedAspirationsNewArgs = {
  date: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type QuerytodaysQcDataChutesideArgs = {
  date: Scalars['String']['input'];
  location: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type QuerytodaysQcDataOpuSearchArgs = {
  date: Scalars['String']['input'];
  location: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
};


export type QuerytopRevisionsByFertilizationSiteArgs = {
  date: Scalars['DateTime']['input'];
  fertilizationSiteId: Scalars['UUID']['input'];
};


export type QueryviewByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryviewNamesArgs = {
  app: Scalars['String']['input'];
  usage: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type QueryyardsArgs = {
  order: InputMaybe<Array<YardSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<YardFilterInput>;
};

export type Recipient = {
  __typename: 'Recipient';
  activityDate: Maybe<Scalars['DateTime']['output']>;
  backdays: Maybe<Scalars['Int']['output']>;
  breed: Maybe<Breed>;
  breedId: Maybe<Scalars['UUID']['output']>;
  client: Maybe<Scalars['Int']['output']>;
  color: Maybe<Color>;
  colorId: Maybe<Scalars['UUID']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  cost: Maybe<Scalars['Decimal']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  cullPr: Maybe<Scalars['Decimal']['output']>;
  culledOn: Maybe<Scalars['DateTime']['output']>;
  estimatedBirthDateOn: Maybe<Scalars['DateTime']['output']>;
  flexField: Maybe<Scalars['String']['output']>;
  flexFieldNumber: Maybe<Scalars['Decimal']['output']>;
  fosterRecipientCalfProcedures: Array<CalfProcedure>;
  fosterRecipientCalves: Array<Calf>;
  hasCalf: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  lastActivity: Maybe<Scalars['String']['output']>;
  lastDrugUsed: Maybe<Drug>;
  lastDrugUsedId: Maybe<Scalars['UUID']['output']>;
  lastEmbryo: Maybe<Embryo>;
  lastEmbryoId: Maybe<Scalars['UUID']['output']>;
  lastHeatOn: Maybe<Scalars['DateTime']['output']>;
  lastHeatTime: Maybe<Scalars['Int']['output']>;
  lastSyncOn: Maybe<Scalars['DateTime']['output']>;
  metalTag: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Use recipientCalves relation */
  numCalves: Maybe<Scalars['Int']['output']>;
  ocvStatus: Maybe<OptionSet>;
  ocvStatusId: Maybe<Scalars['UUID']['output']>;
  origin: Maybe<Scalars['String']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  pen: Maybe<Scalars['String']['output']>;
  previousHeatOn: Maybe<Scalars['DateTime']['output']>;
  previousHeatTime: Maybe<Scalars['Int']['output']>;
  previousTag: Maybe<Scalars['String']['output']>;
  /** @deprecated Use owner relation */
  ranchCode: Maybe<Scalars['String']['output']>;
  ranchTag: Maybe<Scalars['String']['output']>;
  received: Maybe<Scalars['DateTime']['output']>;
  recipProcedureEntryId: Maybe<Scalars['UUID']['output']>;
  recipientCalves: Array<Calf>;
  recipientEmbryos: Array<Embryo>;
  recipientFertilizations: Array<Fertilization>;
  recipientStatus: Maybe<OptionSet>;
  recipientStatusId: Maybe<Scalars['UUID']['output']>;
  registry: Maybe<Scalars['String']['output']>;
  shipOn: Maybe<Scalars['DateTime']['output']>;
  shipment: Maybe<Shipment>;
  shipmentId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  tag: Maybe<Scalars['String']['output']>;
  tattoo: Maybe<Scalars['String']['output']>;
  togId: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Scalars['Int']['output']>;
  yard: Maybe<Yard>;
  yardId: Maybe<Scalars['UUID']['output']>;
};

export type RecipientFilterInput = {
  activityDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<RecipientFilterInput>>;
  backdays?: InputMaybe<IntOperationFilterInput>;
  breed?: InputMaybe<BreedFilterInput>;
  breedId?: InputMaybe<UuidOperationFilterInput>;
  client?: InputMaybe<IntOperationFilterInput>;
  color?: InputMaybe<ColorFilterInput>;
  colorId?: InputMaybe<UuidOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  cost?: InputMaybe<DecimalOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  cullPr?: InputMaybe<DecimalOperationFilterInput>;
  culledOn?: InputMaybe<DateTimeOperationFilterInput>;
  estimatedBirthDateOn?: InputMaybe<DateTimeOperationFilterInput>;
  flexField?: InputMaybe<StringOperationFilterInput>;
  flexFieldNumber?: InputMaybe<DecimalOperationFilterInput>;
  fosterRecipientCalfProcedures?: InputMaybe<ListFilterInputTypeOfCalfProcedureFilterInput>;
  fosterRecipientCalves?: InputMaybe<ListFilterInputTypeOfCalfFilterInput>;
  hasCalf?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastActivity?: InputMaybe<StringOperationFilterInput>;
  lastDrugUsed?: InputMaybe<DrugFilterInput>;
  lastDrugUsedId?: InputMaybe<UuidOperationFilterInput>;
  lastEmbryo?: InputMaybe<EmbryoFilterInput>;
  lastEmbryoId?: InputMaybe<UuidOperationFilterInput>;
  lastHeatOn?: InputMaybe<DateTimeOperationFilterInput>;
  lastHeatTime?: InputMaybe<IntOperationFilterInput>;
  lastSyncOn?: InputMaybe<DateTimeOperationFilterInput>;
  metalTag?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  ocvStatus?: InputMaybe<OptionSetFilterInput>;
  ocvStatusId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RecipientFilterInput>>;
  origin?: InputMaybe<StringOperationFilterInput>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  pen?: InputMaybe<StringOperationFilterInput>;
  previousHeatOn?: InputMaybe<DateTimeOperationFilterInput>;
  previousHeatTime?: InputMaybe<IntOperationFilterInput>;
  previousTag?: InputMaybe<StringOperationFilterInput>;
  ranchTag?: InputMaybe<StringOperationFilterInput>;
  received?: InputMaybe<DateTimeOperationFilterInput>;
  recipProcedureEntryId?: InputMaybe<UuidOperationFilterInput>;
  recipientCalves?: InputMaybe<ListFilterInputTypeOfCalfFilterInput>;
  recipientEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  recipientFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  recipientStatus?: InputMaybe<OptionSetFilterInput>;
  recipientStatusId?: InputMaybe<UuidOperationFilterInput>;
  registry?: InputMaybe<StringOperationFilterInput>;
  shipOn?: InputMaybe<DateTimeOperationFilterInput>;
  shipment?: InputMaybe<ShipmentFilterInput>;
  shipmentId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  tag?: InputMaybe<StringOperationFilterInput>;
  tattoo?: InputMaybe<StringOperationFilterInput>;
  togId?: InputMaybe<IntOperationFilterInput>;
  weight?: InputMaybe<IntOperationFilterInput>;
  yard?: InputMaybe<YardFilterInput>;
  yardId?: InputMaybe<UuidOperationFilterInput>;
};

export type RecipientInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  backdays?: InputMaybe<Scalars['Int']['input']>;
  breed?: InputMaybe<BreedInput>;
  breedId?: InputMaybe<Scalars['UUID']['input']>;
  client?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<ColorInput>;
  colorId?: InputMaybe<Scalars['UUID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  cullPr?: InputMaybe<Scalars['Decimal']['input']>;
  culledOn?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedBirthDateOn?: InputMaybe<Scalars['DateTime']['input']>;
  flexField?: InputMaybe<Scalars['String']['input']>;
  flexFieldNumber?: InputMaybe<Scalars['Decimal']['input']>;
  fosterRecipientCalfProcedures: Array<CalfProcedureInput>;
  fosterRecipientCalves: Array<CalfInput>;
  hasCalf?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  lastActivity?: InputMaybe<Scalars['String']['input']>;
  lastDrugUsed?: InputMaybe<DrugInput>;
  lastDrugUsedId?: InputMaybe<Scalars['UUID']['input']>;
  lastEmbryo?: InputMaybe<EmbryoInput>;
  lastEmbryoId?: InputMaybe<Scalars['UUID']['input']>;
  lastHeatOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastHeatTime?: InputMaybe<Scalars['Int']['input']>;
  lastSyncOn?: InputMaybe<Scalars['DateTime']['input']>;
  metalTag?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  ocvStatus?: InputMaybe<OptionSetInput>;
  ocvStatusId?: InputMaybe<Scalars['UUID']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  pen?: InputMaybe<Scalars['String']['input']>;
  previousHeatOn?: InputMaybe<Scalars['DateTime']['input']>;
  previousHeatTime?: InputMaybe<Scalars['Int']['input']>;
  previousTag?: InputMaybe<Scalars['String']['input']>;
  ranchTag?: InputMaybe<Scalars['String']['input']>;
  received?: InputMaybe<Scalars['DateTime']['input']>;
  recipProcedureEntryId?: InputMaybe<Scalars['UUID']['input']>;
  recipientCalves: Array<CalfInput>;
  recipientEmbryos: Array<EmbryoInput>;
  recipientFertilizations: Array<FertilizationInput>;
  recipientStatus?: InputMaybe<OptionSetInput>;
  recipientStatusId?: InputMaybe<Scalars['UUID']['input']>;
  registry?: InputMaybe<Scalars['String']['input']>;
  shipOn?: InputMaybe<Scalars['DateTime']['input']>;
  shipment?: InputMaybe<ShipmentInput>;
  shipmentId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tattoo?: InputMaybe<Scalars['String']['input']>;
  togId?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  yard?: InputMaybe<YardInput>;
  yardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type RecipientSortInput = {
  activityDate?: InputMaybe<SortEnumType>;
  backdays?: InputMaybe<SortEnumType>;
  breed?: InputMaybe<BreedSortInput>;
  breedId?: InputMaybe<SortEnumType>;
  client?: InputMaybe<SortEnumType>;
  color?: InputMaybe<ColorSortInput>;
  colorId?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  cost?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  cullPr?: InputMaybe<SortEnumType>;
  culledOn?: InputMaybe<SortEnumType>;
  estimatedBirthDateOn?: InputMaybe<SortEnumType>;
  flexField?: InputMaybe<SortEnumType>;
  flexFieldNumber?: InputMaybe<SortEnumType>;
  hasCalf?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastActivity?: InputMaybe<SortEnumType>;
  lastDrugUsed?: InputMaybe<DrugSortInput>;
  lastDrugUsedId?: InputMaybe<SortEnumType>;
  lastEmbryo?: InputMaybe<EmbryoSortInput>;
  lastEmbryoId?: InputMaybe<SortEnumType>;
  lastHeatOn?: InputMaybe<SortEnumType>;
  lastHeatTime?: InputMaybe<SortEnumType>;
  lastSyncOn?: InputMaybe<SortEnumType>;
  metalTag?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  ocvStatus?: InputMaybe<OptionSetSortInput>;
  ocvStatusId?: InputMaybe<SortEnumType>;
  origin?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  pen?: InputMaybe<SortEnumType>;
  previousHeatOn?: InputMaybe<SortEnumType>;
  previousHeatTime?: InputMaybe<SortEnumType>;
  previousTag?: InputMaybe<SortEnumType>;
  ranchTag?: InputMaybe<SortEnumType>;
  received?: InputMaybe<SortEnumType>;
  recipProcedureEntryId?: InputMaybe<SortEnumType>;
  recipientStatus?: InputMaybe<OptionSetSortInput>;
  recipientStatusId?: InputMaybe<SortEnumType>;
  registry?: InputMaybe<SortEnumType>;
  shipOn?: InputMaybe<SortEnumType>;
  shipment?: InputMaybe<ShipmentSortInput>;
  shipmentId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<SortEnumType>;
  tattoo?: InputMaybe<SortEnumType>;
  togId?: InputMaybe<SortEnumType>;
  weight?: InputMaybe<SortEnumType>;
  yard?: InputMaybe<YardSortInput>;
  yardId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type RecipientsCollectionSegment = {
  __typename: 'RecipientsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Recipient>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type RejectDiscardSemenPayload = {
  __typename: 'RejectDiscardSemenPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The id of the newly rejected semen. */
  semenId: Maybe<Scalars['UUID']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type ReportRequestInput = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Request = {
  __typename: 'Request';
  /** @deprecated Use `issue` instead */
  clientIssue: Maybe<RequestClientIssue>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  events: Array<RequestEvent>;
  id: Scalars['Int']['output'];
  importants: Array<RequestImportant>;
  isImportant: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  issue: RequestIssue;
  /** @deprecated Use `issue` instead */
  itIssue: Maybe<RequestItIssue>;
  referencedIn: Array<RequestEvent>;
  /** @deprecated Use `issue` instead */
  reportIssue: Maybe<RequestReportIssue>;
  requestor: Maybe<SystemUser>;
  requestorId: Scalars['UUID']['output'];
  searchText: Scalars['String']['output'];
  subscriptions: Array<RequestSubscription>;
  title: Scalars['String']['output'];
  type: RequestIssueType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type RequestClientIssue = {
  __typename: 'RequestClientIssue';
  account: Account;
  accountId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  embryosPerFertilization: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  implantedOn: Scalars['String']['output'];
  request: Request;
  requestId: Scalars['Int']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type RequestClientIssueFilterInput = {
  accountId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<RequestClientIssueFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  embryosPerFertilization?: InputMaybe<FloatOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  implantedOn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RequestClientIssueFilterInput>>;
  request?: InputMaybe<RequestFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type RequestClientIssueInput = {
  accountId: Scalars['UUID']['input'];
  content: Scalars['String']['input'];
  embryosPerFertilization?: InputMaybe<Scalars['Float']['input']>;
  implantedOn: Scalars['Date']['input'];
  title: Scalars['String']['input'];
};

export type RequestClientIssueSortInput = {
  accountId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  embryosPerFertilization?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  implantedOn?: InputMaybe<SortEnumType>;
  request?: InputMaybe<RequestSortInput>;
  requestId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type RequestEvent = {
  __typename: 'RequestEvent';
  author: Maybe<SystemUser>;
  authorAdUserId: Scalars['UUID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  refRequest: Maybe<Request>;
  refRequestId: Maybe<Scalars['Int']['output']>;
  request: Request;
  requestId: Scalars['Int']['output'];
  searchText: Scalars['String']['output'];
  type: RequestEventType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type RequestEventFilterInput = {
  and?: InputMaybe<Array<RequestEventFilterInput>>;
  authorAdUserId?: InputMaybe<UuidOperationFilterInput>;
  content?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RequestEventFilterInput>>;
  refRequest?: InputMaybe<RequestFilterInput>;
  refRequestId?: InputMaybe<IntOperationFilterInput>;
  request?: InputMaybe<RequestFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  searchText?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum RequestEventType {
  APPROVED = 'APPROVED',
  COMMENT = 'COMMENT',
  COMPLETED = 'COMPLETED',
  DENIED = 'DENIED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type RequestFilterInput = {
  and?: InputMaybe<Array<RequestFilterInput>>;
  content?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  events?: InputMaybe<ListFilterInputTypeOfRequestEventFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  importants?: InputMaybe<ListFilterInputTypeOfRequestImportantFilterInput>;
  or?: InputMaybe<Array<RequestFilterInput>>;
  referencedIn?: InputMaybe<ListFilterInputTypeOfRequestEventFilterInput>;
  requestorId?: InputMaybe<UuidOperationFilterInput>;
  searchText?: InputMaybe<StringOperationFilterInput>;
  subscriptions?: InputMaybe<ListFilterInputTypeOfRequestSubscriptionFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type RequestImportant = {
  __typename: 'RequestImportant';
  adUserId: Scalars['UUID']['output'];
  request: Request;
  requestId: Scalars['Int']['output'];
};

export type RequestImportantFilterInput = {
  adUserId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<RequestImportantFilterInput>>;
  or?: InputMaybe<Array<RequestImportantFilterInput>>;
  request?: InputMaybe<RequestFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
};

export type RequestInput = {
  appId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  departmentId: Scalars['Int']['input'];
  sponsorId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type RequestIssue = RequestClientIssue | RequestItIssue | RequestReportIssue;

export type RequestIssueManager = {
  __typename: 'RequestIssueManager';
  adUserId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  issueType: RequestIssueType;
  systemUser: Maybe<SystemUser>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type RequestIssueManagerFilterInput = {
  adUserId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<RequestIssueManagerFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  issueType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RequestIssueManagerFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type RequestIssueManagerSortInput = {
  adUserId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  issueType?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type RequestIssueManagersCollectionSegment = {
  __typename: 'RequestIssueManagersCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<RequestIssueManager>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum RequestIssueType {
  CLIENT = 'CLIENT',
  IT = 'IT',
  REPORT = 'REPORT'
}

export type RequestItIssue = {
  __typename: 'RequestItIssue';
  app: TogRequestApp;
  appId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  department: TogRequestDepartment;
  departmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  request: Request;
  requestId: Scalars['Int']['output'];
  sponsor: Maybe<SystemUser>;
  sponsorId: Scalars['UUID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type RequestItIssueFilterInput = {
  and?: InputMaybe<Array<RequestItIssueFilterInput>>;
  app?: InputMaybe<TogRequestAppFilterInput>;
  appId?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  department?: InputMaybe<TogRequestDepartmentFilterInput>;
  departmentId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RequestItIssueFilterInput>>;
  request?: InputMaybe<RequestFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  sponsorId?: InputMaybe<UuidOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type RequestItIssueSortInput = {
  app?: InputMaybe<TogRequestAppSortInput>;
  appId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  department?: InputMaybe<TogRequestDepartmentSortInput>;
  departmentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  request?: InputMaybe<RequestSortInput>;
  requestId?: InputMaybe<SortEnumType>;
  sponsorId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type RequestReportIssue = {
  __typename: 'RequestReportIssue';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  request: Request;
  requestId: Scalars['Int']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type RequestReportIssueFilterInput = {
  and?: InputMaybe<Array<RequestReportIssueFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RequestReportIssueFilterInput>>;
  request?: InputMaybe<RequestFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type RequestReportIssueSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  request?: InputMaybe<RequestSortInput>;
  requestId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type RequestSortInput = {
  content?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  requestorId?: InputMaybe<SortEnumType>;
  searchText?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type RequestSubscription = {
  __typename: 'RequestSubscription';
  adUserId: Scalars['UUID']['output'];
  request: Request;
  requestId: Scalars['Int']['output'];
};

export type RequestSubscriptionFilterInput = {
  adUserId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<RequestSubscriptionFilterInput>>;
  or?: InputMaybe<Array<RequestSubscriptionFilterInput>>;
  request?: InputMaybe<RequestFilterInput>;
  requestId?: InputMaybe<IntOperationFilterInput>;
};

export type ReturnSemenPayload = {
  __typename: 'ReturnSemenPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The id of the newly returned semen. */
  semenId: Maybe<Scalars['UUID']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type RevisionPayload = {
  __typename: 'RevisionPayload';
  fertilizationSiteId: Maybe<Scalars['UUID']['output']>;
  fertilizationSiteName: Maybe<Scalars['String']['output']>;
  revisionNumber: Maybe<Scalars['String']['output']>;
};

export type ScheduleMaster = {
  __typename: 'ScheduleMaster';
  coast: Maybe<Scalars['Int']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  donorSchedules: Array<DonorSchedule>;
  id: Scalars['UUID']['output'];
  method: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nextScheduleMasterAspirations: Array<Aspiration>;
  numberOfShots: Maybe<Scalars['Int']['output']>;
  scheduleMasterAspirations: Array<Aspiration>;
  setup: Maybe<Scalars['Int']['output']>;
  soSchedules: Array<SuperOvulationSchedule>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  totalDose: Maybe<Scalars['Decimal']['output']>;
  twiceConcentration: Maybe<Scalars['Boolean']['output']>;
};

/** A segment of a collection. */
export type ScheduleMasterCollectionSegment = {
  __typename: 'ScheduleMasterCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<ScheduleMaster>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScheduleMasterFilterInput = {
  and?: InputMaybe<Array<ScheduleMasterFilterInput>>;
  coast?: InputMaybe<IntOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  donorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  method?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nextScheduleMasterAspirations?: InputMaybe<ListFilterInputTypeOfAspirationFilterInput>;
  numberOfShots?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ScheduleMasterFilterInput>>;
  scheduleMasterAspirations?: InputMaybe<ListFilterInputTypeOfAspirationFilterInput>;
  setup?: InputMaybe<IntOperationFilterInput>;
  soSchedules?: InputMaybe<ListFilterInputTypeOfSuperOvulationScheduleFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  totalDose?: InputMaybe<DecimalOperationFilterInput>;
  twiceConcentration?: InputMaybe<BooleanOperationFilterInput>;
};

export type ScheduleMasterInput = {
  coast?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donorSchedules: Array<DonorScheduleInput>;
  id: Scalars['UUID']['input'];
  method?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextScheduleMasterAspirations: Array<AspirationInput>;
  numberOfShots?: InputMaybe<Scalars['Int']['input']>;
  scheduleMasterAspirations: Array<AspirationInput>;
  setup?: InputMaybe<Scalars['Int']['input']>;
  soSchedules: Array<SuperOvulationScheduleInput>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  totalDose?: InputMaybe<Scalars['Decimal']['input']>;
  twiceConcentration?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScheduleMasterSortInput = {
  coast?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  method?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  numberOfShots?: InputMaybe<SortEnumType>;
  setup?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  totalDose?: InputMaybe<SortEnumType>;
  twiceConcentration?: InputMaybe<SortEnumType>;
};

export type ScheduledDonorType = {
  __typename: 'ScheduledDonorType';
  csr: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  donorScheduleID: Scalars['UUID']['output'];
};

export type ScheduledDonorTypeFilterInput = {
  and?: InputMaybe<Array<ScheduledDonorTypeFilterInput>>;
  csr?: InputMaybe<StringOperationFilterInput>;
  donorName?: InputMaybe<StringOperationFilterInput>;
  donorScheduleID?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ScheduledDonorTypeFilterInput>>;
};

export type ScheduledDonorTypeSortInput = {
  csr?: InputMaybe<SortEnumType>;
  donorName?: InputMaybe<SortEnumType>;
  donorScheduleID?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ScheduledDonorsCollectionSegment = {
  __typename: 'ScheduledDonorsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<ScheduledDonorType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ScheduledDonorsTxpCollectionSegment = {
  __typename: 'ScheduledDonorsTxpCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<ScheduledDonorType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScheduledSemen = {
  __typename: 'ScheduledSemen';
  accountId: Maybe<Scalars['UUID']['output']>;
  accountName: Maybe<Scalars['String']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  colCode: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  donors_Sire: Scalars['Int']['output'];
  exportName: Maybe<Scalars['String']['output']>;
  moveNum: Maybe<Scalars['Int']['output']>;
  naab: Maybe<Scalars['String']['output']>;
  name_Type: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  row: Maybe<Scalars['Int']['output']>;
  semenId: Maybe<Scalars['UUID']['output']>;
  semenName: Maybe<Scalars['String']['output']>;
  semenOwnerId: Maybe<Scalars['UUID']['output']>;
  semenSex: Maybe<Scalars['String']['output']>;
  semenSexed: Maybe<Scalars['String']['output']>;
  semenStorageId: Maybe<Scalars['UUID']['output']>;
  semenStorageName: Maybe<Scalars['String']['output']>;
  semenStorageSiteId: Maybe<Scalars['UUID']['output']>;
  semenStorageSiteName: Maybe<Scalars['String']['output']>;
  semenTypeName: Maybe<Scalars['String']['output']>;
  separateFert: Maybe<Scalars['Boolean']['output']>;
  sireId: Maybe<Scalars['UUID']['output']>;
  sireName: Maybe<Scalars['String']['output']>;
  sireRegNum: Maybe<Scalars['String']['output']>;
  suggestedToPull: Maybe<Scalars['Int']['output']>;
  transactionToday: Maybe<Scalars['String']['output']>;
};

export type SelectListGroupInput = {
  disabled: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SelectListItemInput = {
  disabled: Scalars['Boolean']['input'];
  group?: InputMaybe<SelectListGroupInput>;
  selected: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Semen = {
  __typename: 'Semen';
  backupSemenDonorSchedules: Array<DonorSchedule>;
  cane: Maybe<Scalars['String']['output']>;
  center: Maybe<Scalars['String']['output']>;
  colCode: Maybe<Scalars['String']['output']>;
  collectionDate: Maybe<Scalars['DateTime']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  concentration: Maybe<Scalars['Int']['output']>;
  cost: Maybe<Scalars['Decimal']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<SystemUser>;
  createdByApp: Maybe<Scalars['Int']['output']>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  critical: Maybe<Scalars['Int']['output']>;
  cssCertified: Maybe<Scalars['Int']['output']>;
  cssCertifiedValue: Maybe<Scalars['String']['output']>;
  dateReceived: Maybe<Scalars['DateTime']['output']>;
  embryos: Array<Embryo>;
  export: Maybe<Scalars['Int']['output']>;
  exportValue: Maybe<Scalars['String']['output']>;
  fdcLot: Maybe<Scalars['String']['output']>;
  fertilizations: Array<Fertilization>;
  flushs: Array<Flush>;
  group: Maybe<Scalars['Int']['output']>;
  history: Array<SemenHistory>;
  id: Scalars['UUID']['output'];
  ivfLabSemenDonorSchedules: Array<DonorSchedule>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  mofloNum: Maybe<Scalars['String']['output']>;
  naab: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  overriddenCreatedOn: Maybe<Scalars['DateTime']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  pulledSemenQuantity: Maybe<Scalars['Int']['output']>;
  pulledSemenRsfQuantity: Maybe<Scalars['Int']['output']>;
  pulledSemenRsmQuantity: Maybe<Scalars['Int']['output']>;
  qcHoeschtLot: Maybe<Scalars['String']['output']>;
  qcOvaHepesLot: Maybe<Scalars['String']['output']>;
  qcTrisLot: Maybe<Scalars['String']['output']>;
  qualityEmbryoDevelopmentRate: Maybe<Scalars['Float']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  quantityAdj: Maybe<Scalars['Int']['output']>;
  quantityRec: Maybe<Scalars['Int']['output']>;
  quantityToShip: Maybe<Scalars['Int']['output']>;
  quantityUsed: Maybe<Scalars['Int']['output']>;
  regtog: Maybe<Scalars['Int']['output']>;
  secondaryOwner: Maybe<Scalars['String']['output']>;
  semenDonorSchedules: Array<DonorSchedule>;
  semenOrigin: Maybe<Scalars['Int']['output']>;
  semenType: Maybe<Scalars['String']['output']>;
  sex: Maybe<Scalars['Int']['output']>;
  sexValue: Maybe<Scalars['String']['output']>;
  sexed: Maybe<Scalars['Boolean']['output']>;
  sheathFluidDate: Maybe<Scalars['DateTime']['output']>;
  shipment: Maybe<Shipment>;
  shipmentId: Maybe<Scalars['UUID']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  sire: Maybe<Sire>;
  sireId: Maybe<Scalars['UUID']['output']>;
  soldTo: Maybe<Scalars['String']['output']>;
  sortStatus: Maybe<Scalars['Int']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  storageLocation: Maybe<StorageLocation>;
  storageLocationId: Maybe<Scalars['UUID']['output']>;
  storageStartDate: Maybe<Scalars['DateTime']['output']>;
  toStorageLocation: Maybe<StorageLocation>;
  toStorageLocationId: Maybe<Scalars['UUID']['output']>;
  togCane: Maybe<Scalars['String']['output']>;
  togId: Maybe<Scalars['Int']['output']>;
  totalEmbryoDevelopmentRate: Maybe<Scalars['Float']['output']>;
  transIn: Maybe<Scalars['Int']['output']>;
  transOut: Maybe<Scalars['Int']['output']>;
  units: Maybe<Scalars['Int']['output']>;
};

/** A segment of a collection. */
export type SemenCollectionSegment = {
  __typename: 'SemenCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Semen>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SemenFilterInput = {
  and?: InputMaybe<Array<SemenFilterInput>>;
  backupSemenDonorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  cane?: InputMaybe<StringOperationFilterInput>;
  center?: InputMaybe<StringOperationFilterInput>;
  colCode?: InputMaybe<StringOperationFilterInput>;
  collectionDate?: InputMaybe<DateTimeOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  concentration?: InputMaybe<IntOperationFilterInput>;
  cost?: InputMaybe<DecimalOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdByApp?: InputMaybe<IntOperationFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  critical?: InputMaybe<IntOperationFilterInput>;
  cssCertified?: InputMaybe<IntOperationFilterInput>;
  dateReceived?: InputMaybe<DateTimeOperationFilterInput>;
  embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  export?: InputMaybe<IntOperationFilterInput>;
  fdcLot?: InputMaybe<StringOperationFilterInput>;
  fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  flushs?: InputMaybe<ListFilterInputTypeOfFlushFilterInput>;
  group?: InputMaybe<IntOperationFilterInput>;
  history?: InputMaybe<ListFilterInputTypeOfSemenHistoryFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  ivfLabSemenDonorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  mofloNum?: InputMaybe<StringOperationFilterInput>;
  naab?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SemenFilterInput>>;
  overriddenCreatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  pulledSemenQuantity?: InputMaybe<IntOperationFilterInput>;
  pulledSemenRsfQuantity?: InputMaybe<IntOperationFilterInput>;
  pulledSemenRsmQuantity?: InputMaybe<IntOperationFilterInput>;
  qcHoeschtLot?: InputMaybe<StringOperationFilterInput>;
  qcOvaHepesLot?: InputMaybe<StringOperationFilterInput>;
  qcTrisLot?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  quantityAdj?: InputMaybe<IntOperationFilterInput>;
  quantityRec?: InputMaybe<IntOperationFilterInput>;
  quantityToShip?: InputMaybe<IntOperationFilterInput>;
  quantityUsed?: InputMaybe<IntOperationFilterInput>;
  regtog?: InputMaybe<IntOperationFilterInput>;
  secondaryOwner?: InputMaybe<StringOperationFilterInput>;
  semenDonorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  semenOrigin?: InputMaybe<IntOperationFilterInput>;
  semenType?: InputMaybe<StringOperationFilterInput>;
  sex?: InputMaybe<IntOperationFilterInput>;
  sexed?: InputMaybe<BooleanOperationFilterInput>;
  sheathFluidDate?: InputMaybe<DateTimeOperationFilterInput>;
  shipment?: InputMaybe<ShipmentFilterInput>;
  shipmentId?: InputMaybe<UuidOperationFilterInput>;
  shortName?: InputMaybe<StringOperationFilterInput>;
  sire?: InputMaybe<SireFilterInput>;
  sireId?: InputMaybe<UuidOperationFilterInput>;
  soldTo?: InputMaybe<StringOperationFilterInput>;
  sortStatus?: InputMaybe<IntOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  storageLocation?: InputMaybe<StorageLocationFilterInput>;
  storageLocationId?: InputMaybe<UuidOperationFilterInput>;
  storageStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  toStorageLocation?: InputMaybe<StorageLocationFilterInput>;
  toStorageLocationId?: InputMaybe<UuidOperationFilterInput>;
  togCane?: InputMaybe<StringOperationFilterInput>;
  togId?: InputMaybe<IntOperationFilterInput>;
  transIn?: InputMaybe<IntOperationFilterInput>;
  transOut?: InputMaybe<IntOperationFilterInput>;
  units?: InputMaybe<IntOperationFilterInput>;
};

export type SemenHistory = {
  __typename: 'SemenHistory';
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdByApp: Maybe<Scalars['Int']['output']>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  newOwner: Maybe<Account>;
  newOwnerId: Maybe<Scalars['UUID']['output']>;
  previousOwner: Maybe<Account>;
  previousOwnerId: Maybe<Scalars['UUID']['output']>;
  previousStorageLocation: Maybe<StorageLocation>;
  previousStorageLocationId: Maybe<Scalars['UUID']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  quantityBeforeTransaction: Maybe<Scalars['Int']['output']>;
  semen: Maybe<Semen>;
  semenId: Maybe<Scalars['UUID']['output']>;
  sire: Maybe<Sire>;
  sireId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  storageLocation: Maybe<StorageLocation>;
  storageLocationId: Maybe<Scalars['UUID']['output']>;
  timeZoneRuleVersionNumber: Maybe<Scalars['Int']['output']>;
  transaction: Maybe<OptionSet>;
  transactionId: Maybe<Scalars['UUID']['output']>;
  transactionNumber: Maybe<Scalars['Int']['output']>;
  user: Maybe<Scalars['String']['output']>;
  utcConversionTimeZoneCode: Maybe<Scalars['Int']['output']>;
};

export type SemenHistoryFilterInput = {
  and?: InputMaybe<Array<SemenHistoryFilterInput>>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdByApp?: InputMaybe<IntOperationFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  newOwner?: InputMaybe<AccountFilterInput>;
  newOwnerId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SemenHistoryFilterInput>>;
  previousOwner?: InputMaybe<AccountFilterInput>;
  previousOwnerId?: InputMaybe<UuidOperationFilterInput>;
  previousStorageLocation?: InputMaybe<StorageLocationFilterInput>;
  previousStorageLocationId?: InputMaybe<UuidOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  quantityBeforeTransaction?: InputMaybe<IntOperationFilterInput>;
  semen?: InputMaybe<SemenFilterInput>;
  semenId?: InputMaybe<UuidOperationFilterInput>;
  sire?: InputMaybe<SireFilterInput>;
  sireId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  storageLocation?: InputMaybe<StorageLocationFilterInput>;
  storageLocationId?: InputMaybe<UuidOperationFilterInput>;
  timeZoneRuleVersionNumber?: InputMaybe<IntOperationFilterInput>;
  transaction?: InputMaybe<OptionSetFilterInput>;
  transactionId?: InputMaybe<UuidOperationFilterInput>;
  transactionNumber?: InputMaybe<IntOperationFilterInput>;
  user?: InputMaybe<StringOperationFilterInput>;
  utcConversionTimeZoneCode?: InputMaybe<IntOperationFilterInput>;
};

export type SemenHistoryInput = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdByApp?: InputMaybe<Scalars['Int']['input']>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newOwner?: InputMaybe<AccountInput>;
  newOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  previousOwner?: InputMaybe<AccountInput>;
  previousOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  previousStorageLocation?: InputMaybe<StorageLocationInput>;
  previousStorageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityBeforeTransaction?: InputMaybe<Scalars['Int']['input']>;
  semen?: InputMaybe<SemenInput>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  sire?: InputMaybe<SireInput>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  storageLocation?: InputMaybe<StorageLocationInput>;
  storageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  timeZoneRuleVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  transaction?: InputMaybe<OptionSetInput>;
  transactionId?: InputMaybe<Scalars['UUID']['input']>;
  transactionNumber?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  utcConversionTimeZoneCode?: InputMaybe<Scalars['Int']['input']>;
};

export type SemenInput = {
  backupSemenDonorSchedules: Array<DonorScheduleInput>;
  cane?: InputMaybe<Scalars['String']['input']>;
  center?: InputMaybe<Scalars['String']['input']>;
  colCode?: InputMaybe<Scalars['String']['input']>;
  collectionDate?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  concentration?: InputMaybe<Scalars['Int']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdByApp?: InputMaybe<Scalars['Int']['input']>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  critical?: InputMaybe<Scalars['Int']['input']>;
  cssCertified?: InputMaybe<Scalars['Int']['input']>;
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  embryos: Array<EmbryoInput>;
  export?: InputMaybe<Scalars['Int']['input']>;
  fdcLot?: InputMaybe<Scalars['String']['input']>;
  fertilizations: Array<FertilizationInput>;
  flushs: Array<FlushInput>;
  group?: InputMaybe<Scalars['Int']['input']>;
  history: Array<SemenHistoryInput>;
  id: Scalars['UUID']['input'];
  ivfLabSemenDonorSchedules: Array<DonorScheduleInput>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  mofloNum?: InputMaybe<Scalars['String']['input']>;
  naab?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overriddenCreatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  pulledSemenQuantity?: InputMaybe<Scalars['Int']['input']>;
  pulledSemenRsfQuantity?: InputMaybe<Scalars['Int']['input']>;
  pulledSemenRsmQuantity?: InputMaybe<Scalars['Int']['input']>;
  qcHoeschtLot?: InputMaybe<Scalars['String']['input']>;
  qcOvaHepesLot?: InputMaybe<Scalars['String']['input']>;
  qcTrisLot?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityAdj?: InputMaybe<Scalars['Int']['input']>;
  quantityRec?: InputMaybe<Scalars['Int']['input']>;
  quantityToShip?: InputMaybe<Scalars['Int']['input']>;
  quantityUsed?: InputMaybe<Scalars['Int']['input']>;
  regtog?: InputMaybe<Scalars['Int']['input']>;
  secondaryOwner?: InputMaybe<Scalars['String']['input']>;
  semenDonorSchedules: Array<DonorScheduleInput>;
  semenOrigin?: InputMaybe<Scalars['Int']['input']>;
  semenType?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['Int']['input']>;
  sexed?: InputMaybe<Scalars['Boolean']['input']>;
  sheathFluidDate?: InputMaybe<Scalars['DateTime']['input']>;
  shipment?: InputMaybe<ShipmentInput>;
  shipmentId?: InputMaybe<Scalars['UUID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  sire?: InputMaybe<SireInput>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  soldTo?: InputMaybe<Scalars['String']['input']>;
  sortStatus?: InputMaybe<Scalars['Int']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  storageLocation?: InputMaybe<StorageLocationInput>;
  storageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  storageStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  toStorageLocation?: InputMaybe<StorageLocationInput>;
  toStorageLocationId?: InputMaybe<Scalars['UUID']['input']>;
  togCane?: InputMaybe<Scalars['String']['input']>;
  togId?: InputMaybe<Scalars['Int']['input']>;
  transIn?: InputMaybe<Scalars['Int']['input']>;
  transOut?: InputMaybe<Scalars['Int']['input']>;
  units?: InputMaybe<Scalars['Int']['input']>;
};

export type SemenSortInput = {
  cane?: InputMaybe<SortEnumType>;
  center?: InputMaybe<SortEnumType>;
  colCode?: InputMaybe<SortEnumType>;
  collectionDate?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  concentration?: InputMaybe<SortEnumType>;
  cost?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdByApp?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  critical?: InputMaybe<SortEnumType>;
  cssCertified?: InputMaybe<SortEnumType>;
  dateReceived?: InputMaybe<SortEnumType>;
  export?: InputMaybe<SortEnumType>;
  fdcLot?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  mofloNum?: InputMaybe<SortEnumType>;
  naab?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  overriddenCreatedOn?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  pulledSemenQuantity?: InputMaybe<SortEnumType>;
  pulledSemenRsfQuantity?: InputMaybe<SortEnumType>;
  pulledSemenRsmQuantity?: InputMaybe<SortEnumType>;
  qcHoeschtLot?: InputMaybe<SortEnumType>;
  qcOvaHepesLot?: InputMaybe<SortEnumType>;
  qcTrisLot?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  quantityAdj?: InputMaybe<SortEnumType>;
  quantityRec?: InputMaybe<SortEnumType>;
  quantityToShip?: InputMaybe<SortEnumType>;
  quantityUsed?: InputMaybe<SortEnumType>;
  regtog?: InputMaybe<SortEnumType>;
  secondaryOwner?: InputMaybe<SortEnumType>;
  semenOrigin?: InputMaybe<SortEnumType>;
  semenType?: InputMaybe<SortEnumType>;
  sex?: InputMaybe<SortEnumType>;
  sexed?: InputMaybe<SortEnumType>;
  sheathFluidDate?: InputMaybe<SortEnumType>;
  shipment?: InputMaybe<ShipmentSortInput>;
  shipmentId?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
  sire?: InputMaybe<SireSortInput>;
  sireId?: InputMaybe<SortEnumType>;
  soldTo?: InputMaybe<SortEnumType>;
  sortStatus?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  storageLocation?: InputMaybe<StorageLocationSortInput>;
  storageLocationId?: InputMaybe<SortEnumType>;
  storageStartDate?: InputMaybe<SortEnumType>;
  toStorageLocation?: InputMaybe<StorageLocationSortInput>;
  toStorageLocationId?: InputMaybe<SortEnumType>;
  togCane?: InputMaybe<SortEnumType>;
  togId?: InputMaybe<SortEnumType>;
  transIn?: InputMaybe<SortEnumType>;
  transOut?: InputMaybe<SortEnumType>;
  units?: InputMaybe<SortEnumType>;
};

export type SetDefaultViewInput = {
  usage: Scalars['String']['input'];
  username: Scalars['String']['input'];
  viewId: Scalars['UUID']['input'];
};

export type ShipGroupListResponse = {
  __typename: 'ShipGroupListResponse';
  activeShipGroups: Array<TOA_GetFreshShipmentShipGroups>;
  signedOffShipGroups: Array<TOA_GetFreshShipmentShipGroups>;
};

export type Shipment = {
  __typename: 'Shipment';
  amount: Maybe<Scalars['Decimal']['output']>;
  billStatus: Maybe<Scalars['Int']['output']>;
  billStatusValue: Maybe<Scalars['String']['output']>;
  billTo: Maybe<Scalars['String']['output']>;
  callTag: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  donors: Array<Donor>;
  earTagColor: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  embryos: Array<Embryo>;
  hasCalves: Maybe<Scalars['Boolean']['output']>;
  hasDonors: Maybe<Scalars['Boolean']['output']>;
  hasEmbryos: Maybe<Scalars['Boolean']['output']>;
  hasRecipients: Maybe<Scalars['Boolean']['output']>;
  hasSemen: Maybe<Scalars['Boolean']['output']>;
  heatTimeSpan: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  implantDate: Maybe<Scalars['DateTime']['output']>;
  implantPrice: Maybe<Scalars['Decimal']['output']>;
  implantTierOf: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  needByDate: Maybe<Scalars['Date']['output']>;
  originalNeedByDate: Maybe<Scalars['DateTime']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  packedBy: Maybe<Equipment>;
  packedById: Maybe<Scalars['UUID']['output']>;
  packedByName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  recaneEmbryos: Array<Embryo>;
  receiveGnrh: Maybe<Scalars['String']['output']>;
  recipKickouts: Maybe<Scalars['String']['output']>;
  recipsAvail: Maybe<Scalars['String']['output']>;
  requestedBy: Maybe<Scalars['String']['output']>;
  semens: Array<Semen>;
  shipAddress: Maybe<Scalars['String']['output']>;
  shipAddress2: Maybe<Scalars['String']['output']>;
  shipAddress3: Maybe<Scalars['String']['output']>;
  shipCity: Maybe<Scalars['String']['output']>;
  shipFromSite: Maybe<Site>;
  shipFromSiteId: Maybe<Scalars['UUID']['output']>;
  shipName: Maybe<Scalars['String']['output']>;
  shipState: Maybe<Scalars['String']['output']>;
  shipTo: Maybe<Account>;
  shipToId: Maybe<Scalars['UUID']['output']>;
  shipZip: Maybe<Scalars['String']['output']>;
  shipmentCategory: Maybe<Scalars['Int']['output']>;
  shipmentCategoryValue: Maybe<Scalars['String']['output']>;
  shipmentNumber: Maybe<Scalars['String']['output']>;
  shipmentStatus: Maybe<Scalars['Int']['output']>;
  shipmentStatusValue: Maybe<Scalars['String']['output']>;
  shippingMethod: Maybe<Scalars['Int']['output']>;
  shippingMethodValue: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  tank: Maybe<Scalars['String']['output']>;
  technician1: Maybe<Scalars['String']['output']>;
  thawBy: Maybe<Scalars['String']['output']>;
  trackingNumber: Maybe<Scalars['String']['output']>;
  tripMileage: Maybe<Scalars['Decimal']['output']>;
  tripTank: Maybe<StorageLocation>;
  tripTankId: Maybe<Scalars['UUID']['output']>;
  warning: Maybe<Scalars['Int']['output']>;
};

export type ShipmentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<ShipmentFilterInput>>;
  billStatus?: InputMaybe<IntOperationFilterInput>;
  billTo?: InputMaybe<StringOperationFilterInput>;
  callTag?: InputMaybe<StringOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  donors?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
  earTagColor?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  hasCalves?: InputMaybe<BooleanOperationFilterInput>;
  hasDonors?: InputMaybe<BooleanOperationFilterInput>;
  hasEmbryos?: InputMaybe<BooleanOperationFilterInput>;
  hasRecipients?: InputMaybe<BooleanOperationFilterInput>;
  hasSemen?: InputMaybe<BooleanOperationFilterInput>;
  heatTimeSpan?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  implantDate?: InputMaybe<DateTimeOperationFilterInput>;
  implantPrice?: InputMaybe<DecimalOperationFilterInput>;
  implantTierOf?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  needByDate?: InputMaybe<LocalDateOperationFilterInput>;
  or?: InputMaybe<Array<ShipmentFilterInput>>;
  originalNeedByDate?: InputMaybe<DateTimeOperationFilterInput>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  packedBy?: InputMaybe<EquipmentFilterInput>;
  packedById?: InputMaybe<UuidOperationFilterInput>;
  packedByName?: InputMaybe<StringOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  receiveGnrh?: InputMaybe<StringOperationFilterInput>;
  recipKickouts?: InputMaybe<StringOperationFilterInput>;
  recipsAvail?: InputMaybe<StringOperationFilterInput>;
  requestedBy?: InputMaybe<StringOperationFilterInput>;
  semens?: InputMaybe<ListFilterInputTypeOfSemenFilterInput>;
  shipAddress?: InputMaybe<StringOperationFilterInput>;
  shipAddress2?: InputMaybe<StringOperationFilterInput>;
  shipAddress3?: InputMaybe<StringOperationFilterInput>;
  shipCity?: InputMaybe<StringOperationFilterInput>;
  shipFromSite?: InputMaybe<SiteFilterInput>;
  shipFromSiteId?: InputMaybe<UuidOperationFilterInput>;
  shipName?: InputMaybe<StringOperationFilterInput>;
  shipState?: InputMaybe<StringOperationFilterInput>;
  shipTo?: InputMaybe<AccountFilterInput>;
  shipToId?: InputMaybe<UuidOperationFilterInput>;
  shipZip?: InputMaybe<StringOperationFilterInput>;
  shipmentCategory?: InputMaybe<IntOperationFilterInput>;
  shipmentNumber?: InputMaybe<StringOperationFilterInput>;
  shipmentStatus?: InputMaybe<IntOperationFilterInput>;
  shippingMethod?: InputMaybe<IntOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  tank?: InputMaybe<StringOperationFilterInput>;
  technician1?: InputMaybe<StringOperationFilterInput>;
  thawBy?: InputMaybe<StringOperationFilterInput>;
  trackingNumber?: InputMaybe<StringOperationFilterInput>;
  tripMileage?: InputMaybe<DecimalOperationFilterInput>;
  tripTank?: InputMaybe<StorageLocationFilterInput>;
  tripTankId?: InputMaybe<UuidOperationFilterInput>;
  warning?: InputMaybe<IntOperationFilterInput>;
};

export type ShipmentGroup = {
  __typename: 'ShipmentGroup';
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  estimations: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type ShipmentGroupFilterInput = {
  and?: InputMaybe<Array<ShipmentGroupFilterInput>>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  estimations?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ShipmentGroupFilterInput>>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
};

export type ShipmentGroupInput = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  estimations?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
};

export type ShipmentGroupMaster = {
  __typename: 'ShipmentGroupMaster';
  billIncubator: Maybe<Scalars['Boolean']['output']>;
  billShipping: Maybe<Scalars['Boolean']['output']>;
  callTagComment: Maybe<Scalars['String']['output']>;
  callTagContact: Maybe<Contact>;
  callTagContactId: Maybe<Scalars['UUID']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  contact: Maybe<Contact>;
  contactId: Maybe<Scalars['UUID']['output']>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<Scalars['UUID']['output']>;
  freshShipCreationId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  importSequenceNumber: Maybe<Scalars['Int']['output']>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  overriddenCreatedOn: Maybe<Scalars['DateTime']['output']>;
  packagingFee: Maybe<Scalars['Boolean']['output']>;
  shipComment: Maybe<Scalars['String']['output']>;
  shipmentGroupId: Maybe<Scalars['UUID']['output']>;
  shipperId: Maybe<Scalars['String']['output']>;
  shippingMethod: Maybe<Scalars['Int']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  stateCode: Maybe<Scalars['Int']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  timeZoneRuleVersionNumber: Maybe<Scalars['Int']['output']>;
  utcConversionTimeZoneCode: Maybe<Scalars['Int']['output']>;
};

export type ShipmentGroupMasterFilterInput = {
  and?: InputMaybe<Array<ShipmentGroupMasterFilterInput>>;
  billIncubator?: InputMaybe<BooleanOperationFilterInput>;
  billShipping?: InputMaybe<BooleanOperationFilterInput>;
  callTagComment?: InputMaybe<StringOperationFilterInput>;
  callTagContact?: InputMaybe<ContactFilterInput>;
  callTagContactId?: InputMaybe<UuidOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  contactId?: InputMaybe<UuidOperationFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<UuidOperationFilterInput>;
  freshShipCreationId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  importSequenceNumber?: InputMaybe<IntOperationFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ShipmentGroupMasterFilterInput>>;
  overriddenCreatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  packagingFee?: InputMaybe<BooleanOperationFilterInput>;
  shipComment?: InputMaybe<StringOperationFilterInput>;
  shipmentGroupId?: InputMaybe<UuidOperationFilterInput>;
  shipperId?: InputMaybe<StringOperationFilterInput>;
  shippingMethod?: InputMaybe<IntOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  timeZoneRuleVersionNumber?: InputMaybe<IntOperationFilterInput>;
  utcConversionTimeZoneCode?: InputMaybe<IntOperationFilterInput>;
};

export type ShipmentGroupMasterInput = {
  billIncubator?: InputMaybe<Scalars['Boolean']['input']>;
  billShipping?: InputMaybe<Scalars['Boolean']['input']>;
  callTagComment?: InputMaybe<Scalars['String']['input']>;
  callTagContact?: InputMaybe<ContactInput>;
  callTagContactId?: InputMaybe<Scalars['UUID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<ContactInput>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<Scalars['UUID']['input']>;
  freshShipCreationId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  importSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overriddenCreatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  packagingFee?: InputMaybe<Scalars['Boolean']['input']>;
  shipComment?: InputMaybe<Scalars['String']['input']>;
  shipmentGroupId?: InputMaybe<Scalars['UUID']['input']>;
  shipperId?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode?: InputMaybe<Scalars['Int']['input']>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  timeZoneRuleVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  utcConversionTimeZoneCode?: InputMaybe<Scalars['Int']['input']>;
};

export type ShipmentGroupMasterSortInput = {
  billIncubator?: InputMaybe<SortEnumType>;
  billShipping?: InputMaybe<SortEnumType>;
  callTagComment?: InputMaybe<SortEnumType>;
  callTagContact?: InputMaybe<ContactSortInput>;
  callTagContactId?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  contact?: InputMaybe<ContactSortInput>;
  contactId?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SortEnumType>;
  freshShipCreationId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importSequenceNumber?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  overriddenCreatedOn?: InputMaybe<SortEnumType>;
  packagingFee?: InputMaybe<SortEnumType>;
  shipComment?: InputMaybe<SortEnumType>;
  shipmentGroupId?: InputMaybe<SortEnumType>;
  shipperId?: InputMaybe<SortEnumType>;
  shippingMethod?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  timeZoneRuleVersionNumber?: InputMaybe<SortEnumType>;
  utcConversionTimeZoneCode?: InputMaybe<SortEnumType>;
};

export type ShipmentGroupPayload = {
  __typename: 'ShipmentGroupPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The id of the affected shipment group, if applicable. */
  shipmentGroupId: Maybe<Scalars['UUID']['output']>;
  /** Shipments */
  shipments: Maybe<Array<tog_freshshipmentBase>>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type ShipmentGroupSortInput = {
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  estimations?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ShipmentGroupsCollectionSegment = {
  __typename: 'ShipmentGroupsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<ShipmentGroup>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ShipmentInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  billStatus?: InputMaybe<Scalars['Int']['input']>;
  billTo?: InputMaybe<Scalars['String']['input']>;
  callTag?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donors: Array<DonorInput>;
  earTagColor?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  embryos: Array<EmbryoInput>;
  hasCalves?: InputMaybe<Scalars['Boolean']['input']>;
  hasDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmbryos?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  hasSemen?: InputMaybe<Scalars['Boolean']['input']>;
  heatTimeSpan?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  implantDate?: InputMaybe<Scalars['DateTime']['input']>;
  implantPrice?: InputMaybe<Scalars['Decimal']['input']>;
  implantTierOf?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  needByDate?: InputMaybe<Scalars['Date']['input']>;
  originalNeedByDate?: InputMaybe<Scalars['DateTime']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  packedBy?: InputMaybe<EquipmentInput>;
  packedById?: InputMaybe<Scalars['UUID']['input']>;
  packedByName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receiveGnrh?: InputMaybe<Scalars['String']['input']>;
  recipKickouts?: InputMaybe<Scalars['String']['input']>;
  recipsAvail?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['String']['input']>;
  semens: Array<SemenInput>;
  shipAddress?: InputMaybe<Scalars['String']['input']>;
  shipAddress2?: InputMaybe<Scalars['String']['input']>;
  shipAddress3?: InputMaybe<Scalars['String']['input']>;
  shipCity?: InputMaybe<Scalars['String']['input']>;
  shipFromSite?: InputMaybe<SiteInput>;
  shipFromSiteId?: InputMaybe<Scalars['UUID']['input']>;
  shipName?: InputMaybe<Scalars['String']['input']>;
  shipState?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<AccountInput>;
  shipToId?: InputMaybe<Scalars['UUID']['input']>;
  shipZip?: InputMaybe<Scalars['String']['input']>;
  shipmentCategory?: InputMaybe<Scalars['Int']['input']>;
  shipmentNumber?: InputMaybe<Scalars['String']['input']>;
  shipmentStatus?: InputMaybe<Scalars['Int']['input']>;
  shippingMethod?: InputMaybe<Scalars['Int']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  tank?: InputMaybe<Scalars['String']['input']>;
  technician1?: InputMaybe<Scalars['String']['input']>;
  thawBy?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  tripMileage?: InputMaybe<Scalars['Decimal']['input']>;
  tripTank?: InputMaybe<StorageLocationInput>;
  tripTankId?: InputMaybe<Scalars['UUID']['input']>;
  warning?: InputMaybe<Scalars['Int']['input']>;
};

export type ShipmentSortInput = {
  amount?: InputMaybe<SortEnumType>;
  billStatus?: InputMaybe<SortEnumType>;
  billTo?: InputMaybe<SortEnumType>;
  callTag?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  earTagColor?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  hasCalves?: InputMaybe<SortEnumType>;
  hasDonors?: InputMaybe<SortEnumType>;
  hasEmbryos?: InputMaybe<SortEnumType>;
  hasRecipients?: InputMaybe<SortEnumType>;
  hasSemen?: InputMaybe<SortEnumType>;
  heatTimeSpan?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  implantDate?: InputMaybe<SortEnumType>;
  implantPrice?: InputMaybe<SortEnumType>;
  implantTierOf?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  needByDate?: InputMaybe<SortEnumType>;
  originalNeedByDate?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  packedBy?: InputMaybe<EquipmentSortInput>;
  packedById?: InputMaybe<SortEnumType>;
  packedByName?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  receiveGnrh?: InputMaybe<SortEnumType>;
  recipKickouts?: InputMaybe<SortEnumType>;
  recipsAvail?: InputMaybe<SortEnumType>;
  requestedBy?: InputMaybe<SortEnumType>;
  shipAddress?: InputMaybe<SortEnumType>;
  shipAddress2?: InputMaybe<SortEnumType>;
  shipAddress3?: InputMaybe<SortEnumType>;
  shipCity?: InputMaybe<SortEnumType>;
  shipFromSite?: InputMaybe<SiteSortInput>;
  shipFromSiteId?: InputMaybe<SortEnumType>;
  shipName?: InputMaybe<SortEnumType>;
  shipState?: InputMaybe<SortEnumType>;
  shipTo?: InputMaybe<AccountSortInput>;
  shipToId?: InputMaybe<SortEnumType>;
  shipZip?: InputMaybe<SortEnumType>;
  shipmentCategory?: InputMaybe<SortEnumType>;
  shipmentNumber?: InputMaybe<SortEnumType>;
  shipmentStatus?: InputMaybe<SortEnumType>;
  shippingMethod?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  tank?: InputMaybe<SortEnumType>;
  technician1?: InputMaybe<SortEnumType>;
  thawBy?: InputMaybe<SortEnumType>;
  trackingNumber?: InputMaybe<SortEnumType>;
  tripMileage?: InputMaybe<SortEnumType>;
  tripTank?: InputMaybe<StorageLocationSortInput>;
  tripTankId?: InputMaybe<SortEnumType>;
  warning?: InputMaybe<SortEnumType>;
};

export enum ShipmentStatus {
  SCHEDULED = 'SCHEDULED',
  TRANSFER_TRIP = 'TRANSFER_TRIP'
}

/** A segment of a collection. */
export type ShipmentsCollectionSegment = {
  __typename: 'ShipmentsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Shipment>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Sire = {
  __typename: 'Sire';
  birth: Maybe<Scalars['DateTime']['output']>;
  breed: Maybe<Breed>;
  breedId: Maybe<Scalars['UUID']['output']>;
  breedReg: Maybe<Scalars['String']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  clientShortName: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  countryCodeId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  donors: Array<Donor>;
  edonorId: Maybe<Scalars['String']['output']>;
  embryos: Array<Embryo>;
  fertilizations: Array<Fertilization>;
  heparin: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  psi: Maybe<Scalars['Int']['output']>;
  regPrefix: Maybe<Scalars['String']['output']>;
  registrationNumber: Maybe<Scalars['String']['output']>;
  regtog: Maybe<Scalars['Int']['output']>;
  semens: Array<Semen>;
  sexedCane: Maybe<Scalars['String']['output']>;
  sire: Maybe<Scalars['String']['output']>;
  sireCm: Maybe<Scalars['Int']['output']>;
  sireJpi: Maybe<Scalars['Int']['output']>;
  sireNm: Maybe<Scalars['Int']['output']>;
  sireTpi: Maybe<Scalars['Int']['output']>;
  stateCode: Scalars['Int']['output'];
  status: Maybe<Scalars['String']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  verified: Maybe<Scalars['Boolean']['output']>;
  yard: Maybe<Yard>;
  yardId: Maybe<Scalars['UUID']['output']>;
};

export type SireFilterInput = {
  and?: InputMaybe<Array<SireFilterInput>>;
  birth?: InputMaybe<DateTimeOperationFilterInput>;
  breed?: InputMaybe<BreedFilterInput>;
  breedId?: InputMaybe<UuidOperationFilterInput>;
  breedReg?: InputMaybe<StringOperationFilterInput>;
  cane?: InputMaybe<StringOperationFilterInput>;
  clientShortName?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  countryCodeId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  donors?: InputMaybe<ListFilterInputTypeOfDonorFilterInput>;
  edonorId?: InputMaybe<StringOperationFilterInput>;
  embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  heparin?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SireFilterInput>>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  psi?: InputMaybe<IntOperationFilterInput>;
  regPrefix?: InputMaybe<StringOperationFilterInput>;
  registrationNumber?: InputMaybe<StringOperationFilterInput>;
  regtog?: InputMaybe<IntOperationFilterInput>;
  semens?: InputMaybe<ListFilterInputTypeOfSemenFilterInput>;
  sexedCane?: InputMaybe<StringOperationFilterInput>;
  sire?: InputMaybe<StringOperationFilterInput>;
  sireCm?: InputMaybe<IntOperationFilterInput>;
  sireJpi?: InputMaybe<IntOperationFilterInput>;
  sireNm?: InputMaybe<IntOperationFilterInput>;
  sireTpi?: InputMaybe<IntOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  verified?: InputMaybe<BooleanOperationFilterInput>;
  yard?: InputMaybe<YardFilterInput>;
  yardId?: InputMaybe<UuidOperationFilterInput>;
};

export type SireInput = {
  birth?: InputMaybe<Scalars['DateTime']['input']>;
  breed?: InputMaybe<BreedInput>;
  breedId?: InputMaybe<Scalars['UUID']['input']>;
  breedReg?: InputMaybe<Scalars['String']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  clientShortName?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  countryCodeId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  donors: Array<DonorInput>;
  edonorId?: InputMaybe<Scalars['String']['input']>;
  embryos: Array<EmbryoInput>;
  fertilizations: Array<FertilizationInput>;
  heparin?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  psi?: InputMaybe<Scalars['Int']['input']>;
  regPrefix?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  regtog?: InputMaybe<Scalars['Int']['input']>;
  semens: Array<SemenInput>;
  sexedCane?: InputMaybe<Scalars['String']['input']>;
  sire?: InputMaybe<Scalars['String']['input']>;
  sireCm?: InputMaybe<Scalars['Int']['input']>;
  sireJpi?: InputMaybe<Scalars['Int']['input']>;
  sireNm?: InputMaybe<Scalars['Int']['input']>;
  sireTpi?: InputMaybe<Scalars['Int']['input']>;
  stateCode: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  yard?: InputMaybe<YardInput>;
  yardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SirePayload = {
  __typename: 'SirePayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The tog_sireBase table that contains the newly added sire. */
  sire: Maybe<Sire>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type SireSelectionRequest = {
  __typename: 'SireSelectionRequest';
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  donorSchedule: DonorSchedule;
  donorScheduleId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  semen: Maybe<Semen>;
  semenId: Maybe<Scalars['UUID']['output']>;
  semenType: Maybe<Scalars['Int']['output']>;
  semenTypeValue: Maybe<Scalars['String']['output']>;
  sire: Maybe<Sire>;
  sireId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
};

export type SireSelectionRequestFilterInput = {
  and?: InputMaybe<Array<SireSelectionRequestFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  donorSchedule?: InputMaybe<DonorScheduleFilterInput>;
  donorScheduleId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SireSelectionRequestFilterInput>>;
  semen?: InputMaybe<SemenFilterInput>;
  semenId?: InputMaybe<UuidOperationFilterInput>;
  semenType?: InputMaybe<IntOperationFilterInput>;
  sire?: InputMaybe<SireFilterInput>;
  sireId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
};

export type SireSelectionRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  donorSchedule: DonorScheduleInput;
  donorScheduleId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  semen?: InputMaybe<SemenInput>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  semenType?: InputMaybe<Scalars['Int']['input']>;
  sire?: InputMaybe<SireInput>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
};

export type SireSelectionRequestSortInput = {
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  donorSchedule?: InputMaybe<DonorScheduleSortInput>;
  donorScheduleId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  semen?: InputMaybe<SemenSortInput>;
  semenId?: InputMaybe<SortEnumType>;
  semenType?: InputMaybe<SortEnumType>;
  sire?: InputMaybe<SireSortInput>;
  sireId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SireSelectionRequestsCollectionSegment = {
  __typename: 'SireSelectionRequestsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<SireSelectionRequest>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SireSortInput = {
  birth?: InputMaybe<SortEnumType>;
  breed?: InputMaybe<BreedSortInput>;
  breedId?: InputMaybe<SortEnumType>;
  breedReg?: InputMaybe<SortEnumType>;
  cane?: InputMaybe<SortEnumType>;
  clientShortName?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  countryCodeId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  edonorId?: InputMaybe<SortEnumType>;
  heparin?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  psi?: InputMaybe<SortEnumType>;
  regPrefix?: InputMaybe<SortEnumType>;
  registrationNumber?: InputMaybe<SortEnumType>;
  regtog?: InputMaybe<SortEnumType>;
  sexedCane?: InputMaybe<SortEnumType>;
  sire?: InputMaybe<SortEnumType>;
  sireCm?: InputMaybe<SortEnumType>;
  sireJpi?: InputMaybe<SortEnumType>;
  sireNm?: InputMaybe<SortEnumType>;
  sireTpi?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  verified?: InputMaybe<SortEnumType>;
  yard?: InputMaybe<YardSortInput>;
  yardId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SiresCollectionSegment = {
  __typename: 'SiresCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Sire>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Site = {
  __typename: 'Site';
  aspirationSiteDonorSchedules: Array<DonorSchedule>;
  companyId: Scalars['UUID']['output'];
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  emailAddress: Maybe<Scalars['String']['output']>;
  fertilizationLocations: Array<Location>;
  fertilizationSiteDonorSchedules: Array<DonorSchedule>;
  flushes: Array<Flush>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  originalFreezeSiteEmbryos: Array<Embryo>;
  shipments: Array<Shipment>;
  siteEmbryos: Array<Embryo>;
  siteFertilizations: Array<Fertilization>;
  soSchedules: Array<SuperOvulationSchedule>;
  storageLocations: Array<StorageLocation>;
  trfSiteFertilizations: Array<Fertilization>;
};


export type SiteaspirationSiteDonorSchedulesArgs = {
  order: InputMaybe<Array<DonorScheduleSortInput>>;
  where: InputMaybe<DonorScheduleFilterInput>;
};


export type SitefertilizationSiteDonorSchedulesArgs = {
  order: InputMaybe<Array<DonorScheduleSortInput>>;
  where: InputMaybe<DonorScheduleFilterInput>;
};

export type SiteFilterInput = {
  and?: InputMaybe<Array<SiteFilterInput>>;
  aspirationSiteDonorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  fertilizationLocations?: InputMaybe<ListFilterInputTypeOfLocationFilterInput>;
  fertilizationSiteDonorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  flushes?: InputMaybe<ListFilterInputTypeOfFlushFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteFilterInput>>;
  originalFreezeSiteEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  shipments?: InputMaybe<ListFilterInputTypeOfShipmentFilterInput>;
  siteEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  siteFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  soSchedules?: InputMaybe<ListFilterInputTypeOfSuperOvulationScheduleFilterInput>;
  storageLocations?: InputMaybe<ListFilterInputTypeOfStorageLocationFilterInput>;
  trfSiteFertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
};

export type SiteInput = {
  aspirationSiteDonorSchedules: Array<DonorScheduleInput>;
  companyId: Scalars['UUID']['input'];
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  fertilizationLocations: Array<LocationInput>;
  fertilizationSiteDonorSchedules: Array<DonorScheduleInput>;
  flushes: Array<FlushInput>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  originalFreezeSiteEmbryos: Array<EmbryoInput>;
  shipments: Array<ShipmentInput>;
  siteEmbryos: Array<EmbryoInput>;
  siteFertilizations: Array<FertilizationInput>;
  soSchedules: Array<SuperOvulationScheduleInput>;
  storageLocations: Array<StorageLocationInput>;
  trfSiteFertilizations: Array<FertilizationInput>;
};

export type SiteSortInput = {
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  emailAddress?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SitesCollectionSegment = {
  __typename: 'SitesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Site>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SortEnumType {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StageGradeCountInput = {
  count: Scalars['Int']['input'];
  grade: Scalars['Int']['input'];
  stage: Scalars['Int']['input'];
};

export type StatsInput = {
  avgFollicles?: InputMaybe<Scalars['String']['input']>;
  avgNumInMat?: InputMaybe<Scalars['String']['input']>;
  avgOocytes?: InputMaybe<Scalars['String']['input']>;
  entries?: InputMaybe<Array<OpuEntriesInput>>;
  follicles?: InputMaybe<Scalars['String']['input']>;
  numInMat?: InputMaybe<Scalars['String']['input']>;
  oocytes?: InputMaybe<Scalars['String']['input']>;
  opuTech?: InputMaybe<Scalars['String']['input']>;
  opuTechId?: InputMaybe<Scalars['String']['input']>;
};

export type StorageLocation = {
  __typename: 'StorageLocation';
  billable: Maybe<Scalars['Boolean']['output']>;
  canister: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  donorSchedules: Array<DonorSchedule>;
  embryos: Array<Embryo>;
  fertilizations: Array<Fertilization>;
  id: Scalars['UUID']['output'];
  locationType: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  oldStorageEmbryos: Array<Embryo>;
  semens: Array<Semen>;
  shipments: Array<Shipment>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  tankp: Maybe<Scalars['String']['output']>;
  tanks: Maybe<Scalars['String']['output']>;
  toStorageSemens: Array<Semen>;
};

export type StorageLocationFilterInput = {
  and?: InputMaybe<Array<StorageLocationFilterInput>>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  canister?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  donorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  embryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  fertilizations?: InputMaybe<ListFilterInputTypeOfFertilizationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  locationType?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oldStorageEmbryos?: InputMaybe<ListFilterInputTypeOfEmbryoFilterInput>;
  or?: InputMaybe<Array<StorageLocationFilterInput>>;
  semens?: InputMaybe<ListFilterInputTypeOfSemenFilterInput>;
  shipments?: InputMaybe<ListFilterInputTypeOfShipmentFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  tankp?: InputMaybe<StringOperationFilterInput>;
  tanks?: InputMaybe<StringOperationFilterInput>;
  toStorageSemens?: InputMaybe<ListFilterInputTypeOfSemenFilterInput>;
};

export type StorageLocationInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  canister?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  donorSchedules: Array<DonorScheduleInput>;
  embryos: Array<EmbryoInput>;
  fertilizations: Array<FertilizationInput>;
  id: Scalars['UUID']['input'];
  locationType?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oldStorageEmbryos: Array<EmbryoInput>;
  semens: Array<SemenInput>;
  shipments: Array<ShipmentInput>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  tankp?: InputMaybe<Scalars['String']['input']>;
  tanks?: InputMaybe<Scalars['String']['input']>;
  toStorageSemens: Array<SemenInput>;
};

export type StorageLocationSortInput = {
  billable?: InputMaybe<SortEnumType>;
  canister?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  tankp?: InputMaybe<SortEnumType>;
  tanks?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type StorageLocationsCollectionSegment = {
  __typename: 'StorageLocationsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<StorageLocation>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type StringMap = {
  __typename: 'StringMap';
  attributeName: Scalars['String']['output'];
  attributeValue: Scalars['Int']['output'];
  companyId: Scalars['UUID']['output'];
  displayOrder: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  langId: Scalars['Int']['output'];
  objectTypeCode: Scalars['Int']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type StringMapFilterInput = {
  and?: InputMaybe<Array<StringMapFilterInput>>;
  attributeName?: InputMaybe<StringOperationFilterInput>;
  attributeValue?: InputMaybe<IntOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  displayOrder?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  langId?: InputMaybe<IntOperationFilterInput>;
  objectTypeCode?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<StringMapFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type StringMapSortInput = {
  attributeName?: InputMaybe<SortEnumType>;
  attributeValue?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  displayOrder?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  langId?: InputMaybe<SortEnumType>;
  objectTypeCode?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type StringMapsCollectionSegment = {
  __typename: 'StringMapsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<StringMap>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type StrippingFertilizationsCollectionSegment = {
  __typename: 'StrippingFertilizationsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Fertilization>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Subscription = {
  __typename: 'Subscription';
  createdEquipment: Equipment;
  onChuteSchedulesUpdated: Array<Aspiration>;
  onDonorSchedulesAdded: Array<DonorSchedule>;
  onNucleusErrorLogAdded: Array<NucleusErrorLogs>;
  onPartnershipAdded: Array<Partnership>;
  updatedEquipment: Equipment;
  updatedFertilization: Fertilization;
  updatedShipment: Shipment;
};

export type SuperOvulationSchedule = {
  __typename: 'SuperOvulationSchedule';
  aspirations: Array<Aspiration>;
  billDrugs: Maybe<Scalars['Boolean']['output']>;
  billStatus: Maybe<Scalars['Int']['output']>;
  clinic: Maybe<Scalars['Int']['output']>;
  clinicRanchHaulIn: Maybe<Scalars['Int']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  donor: Maybe<Donor>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorSchedules: Array<DonorSchedule>;
  drug: Maybe<Drug>;
  drug2: Maybe<Drug>;
  drugShipFee: Maybe<Scalars['Int']['output']>;
  dtogId: Maybe<Scalars['Int']['output']>;
  embryoComment: Maybe<Scalars['String']['output']>;
  export: Maybe<Scalars['Int']['output']>;
  flush: Maybe<Flush>;
  flushAmPm: Maybe<Scalars['Boolean']['output']>;
  flushDate: Maybe<Scalars['DateTime']['output']>;
  flushId: Maybe<Scalars['UUID']['output']>;
  freeze: Maybe<Scalars['Int']['output']>;
  freezeMethod: Maybe<OptionSet>;
  freezeMethodId: Maybe<Scalars['UUID']['output']>;
  fresh: Maybe<Scalars['Int']['output']>;
  fshDrug1Id: Maybe<Scalars['UUID']['output']>;
  fshDrug2Id: Maybe<Scalars['UUID']['output']>;
  fshNext: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  implantType: Maybe<Scalars['Int']['output']>;
  linkedAspiration: Maybe<Aspiration>;
  linkedAspirationId: Maybe<Scalars['UUID']['output']>;
  linkedDonorSchedule: Maybe<DonorSchedule>;
  linkedDonorScheduleId: Maybe<Scalars['UUID']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  owner: Maybe<Account>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  scheduleMaster: Maybe<ScheduleMaster>;
  scheduleMasterId: Maybe<Scalars['UUID']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  tempBep: Maybe<Scalars['String']['output']>;
  time: Maybe<Scalars['Boolean']['output']>;
  transfer: Maybe<Scalars['Int']['output']>;
};

export type SuperOvulationScheduleFilterInput = {
  and?: InputMaybe<Array<SuperOvulationScheduleFilterInput>>;
  aspirations?: InputMaybe<ListFilterInputTypeOfAspirationFilterInput>;
  billDrugs?: InputMaybe<BooleanOperationFilterInput>;
  billStatus?: InputMaybe<IntOperationFilterInput>;
  clinic?: InputMaybe<IntOperationFilterInput>;
  clinicRanchHaulIn?: InputMaybe<IntOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  donor?: InputMaybe<DonorFilterInput>;
  donorId?: InputMaybe<UuidOperationFilterInput>;
  donorSchedules?: InputMaybe<ListFilterInputTypeOfDonorScheduleFilterInput>;
  drug?: InputMaybe<DrugFilterInput>;
  drug2?: InputMaybe<DrugFilterInput>;
  drugShipFee?: InputMaybe<IntOperationFilterInput>;
  dtogId?: InputMaybe<IntOperationFilterInput>;
  embryoComment?: InputMaybe<StringOperationFilterInput>;
  export?: InputMaybe<IntOperationFilterInput>;
  flush?: InputMaybe<FlushFilterInput>;
  flushAmPm?: InputMaybe<BooleanOperationFilterInput>;
  flushDate?: InputMaybe<DateTimeOperationFilterInput>;
  flushId?: InputMaybe<UuidOperationFilterInput>;
  freeze?: InputMaybe<IntOperationFilterInput>;
  freezeMethod?: InputMaybe<OptionSetFilterInput>;
  freezeMethodId?: InputMaybe<UuidOperationFilterInput>;
  fresh?: InputMaybe<IntOperationFilterInput>;
  fshDrug1Id?: InputMaybe<UuidOperationFilterInput>;
  fshDrug2Id?: InputMaybe<UuidOperationFilterInput>;
  fshNext?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  implantType?: InputMaybe<IntOperationFilterInput>;
  linkedAspiration?: InputMaybe<AspirationFilterInput>;
  linkedAspirationId?: InputMaybe<UuidOperationFilterInput>;
  linkedDonorSchedule?: InputMaybe<DonorScheduleFilterInput>;
  linkedDonorScheduleId?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SuperOvulationScheduleFilterInput>>;
  owner?: InputMaybe<AccountFilterInput>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  scheduleMaster?: InputMaybe<ScheduleMasterFilterInput>;
  scheduleMasterId?: InputMaybe<UuidOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  tempBep?: InputMaybe<StringOperationFilterInput>;
  time?: InputMaybe<BooleanOperationFilterInput>;
  transfer?: InputMaybe<IntOperationFilterInput>;
};

export type SuperOvulationScheduleInput = {
  aspirations: Array<AspirationInput>;
  billDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  billStatus?: InputMaybe<Scalars['Int']['input']>;
  clinic?: InputMaybe<Scalars['Int']['input']>;
  clinicRanchHaulIn?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donor?: InputMaybe<DonorInput>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorSchedules: Array<DonorScheduleInput>;
  drug?: InputMaybe<DrugInput>;
  drug2?: InputMaybe<DrugInput>;
  drugShipFee?: InputMaybe<Scalars['Int']['input']>;
  dtogId?: InputMaybe<Scalars['Int']['input']>;
  embryoComment?: InputMaybe<Scalars['String']['input']>;
  export?: InputMaybe<Scalars['Int']['input']>;
  flush?: InputMaybe<FlushInput>;
  flushAmPm?: InputMaybe<Scalars['Boolean']['input']>;
  flushDate?: InputMaybe<Scalars['DateTime']['input']>;
  flushId?: InputMaybe<Scalars['UUID']['input']>;
  freeze?: InputMaybe<Scalars['Int']['input']>;
  freezeMethod?: InputMaybe<OptionSetInput>;
  freezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  fresh?: InputMaybe<Scalars['Int']['input']>;
  fshDrug1Id?: InputMaybe<Scalars['UUID']['input']>;
  fshDrug2Id?: InputMaybe<Scalars['UUID']['input']>;
  fshNext?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  implantType?: InputMaybe<Scalars['Int']['input']>;
  linkedAspiration?: InputMaybe<AspirationInput>;
  linkedAspirationId?: InputMaybe<Scalars['UUID']['input']>;
  linkedDonorSchedule?: InputMaybe<DonorScheduleInput>;
  linkedDonorScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  owner?: InputMaybe<AccountInput>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleMaster?: InputMaybe<ScheduleMasterInput>;
  scheduleMasterId?: InputMaybe<Scalars['UUID']['input']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  tempBep?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Boolean']['input']>;
  transfer?: InputMaybe<Scalars['Int']['input']>;
};

export type SuperOvulationScheduleSortInput = {
  billDrugs?: InputMaybe<SortEnumType>;
  billStatus?: InputMaybe<SortEnumType>;
  clinic?: InputMaybe<SortEnumType>;
  clinicRanchHaulIn?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  donor?: InputMaybe<DonorSortInput>;
  donorId?: InputMaybe<SortEnumType>;
  drug?: InputMaybe<DrugSortInput>;
  drug2?: InputMaybe<DrugSortInput>;
  drugShipFee?: InputMaybe<SortEnumType>;
  dtogId?: InputMaybe<SortEnumType>;
  embryoComment?: InputMaybe<SortEnumType>;
  export?: InputMaybe<SortEnumType>;
  flush?: InputMaybe<FlushSortInput>;
  flushAmPm?: InputMaybe<SortEnumType>;
  flushDate?: InputMaybe<SortEnumType>;
  flushId?: InputMaybe<SortEnumType>;
  freeze?: InputMaybe<SortEnumType>;
  freezeMethod?: InputMaybe<OptionSetSortInput>;
  freezeMethodId?: InputMaybe<SortEnumType>;
  fresh?: InputMaybe<SortEnumType>;
  fshDrug1Id?: InputMaybe<SortEnumType>;
  fshDrug2Id?: InputMaybe<SortEnumType>;
  fshNext?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  implantType?: InputMaybe<SortEnumType>;
  linkedAspiration?: InputMaybe<AspirationSortInput>;
  linkedAspirationId?: InputMaybe<SortEnumType>;
  linkedDonorSchedule?: InputMaybe<DonorScheduleSortInput>;
  linkedDonorScheduleId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<AccountSortInput>;
  ownerId?: InputMaybe<SortEnumType>;
  scheduleMaster?: InputMaybe<ScheduleMasterSortInput>;
  scheduleMasterId?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  tempBep?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
  transfer?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SuperOvulationSchedulesCollectionSegment = {
  __typename: 'SuperOvulationSchedulesCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<SuperOvulationSchedule>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SystemUser = {
  __typename: 'SystemUser';
  activeDirectoryGuid: Maybe<Scalars['UUID']['output']>;
  adUserId: Scalars['UUID']['output'];
  companyId: Scalars['UUID']['output'];
  contextName: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['String']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  domainName: Maybe<Scalars['String']['output']>;
  environment: Maybe<Scalars['String']['output']>;
  environmentId: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `equipments` instead */
  equipment: Maybe<Equipment>;
  /** @deprecated Use `equipments` instead */
  equipmentId: Maybe<Scalars['UUID']['output']>;
  equipments: Maybe<EquipmentsCollectionSegment>;
  firstName: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  groups: Array<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  internalEmailAddress: Maybe<Scalars['String']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  issueManagerTypes: Array<RequestIssueType>;
  lastName: Maybe<Scalars['String']['output']>;
  linkString: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  personalEmailAddress: Maybe<Scalars['String']['output']>;
  salutation: Maybe<Scalars['String']['output']>;
  supervisor: Maybe<SystemUser>;
  title: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
  xrm: Maybe<Scalars['String']['output']>;
};


export type SystemUserequipmentsArgs = {
  order: InputMaybe<Array<EquipmentSortInput>>;
  skip: InputMaybe<Scalars['Int']['input']>;
  take: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<EquipmentFilterInput>;
};

export type SystemUserFilterInput = {
  activeDirectoryGuid?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<SystemUserFilterInput>>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  contextName?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<StringOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  domainName?: InputMaybe<StringOperationFilterInput>;
  environment?: InputMaybe<StringOperationFilterInput>;
  environmentId?: InputMaybe<IntOperationFilterInput>;
  equipments?: InputMaybe<ListFilterInputTypeOfEquipmentFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  internalEmailAddress?: InputMaybe<StringOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  linkString?: InputMaybe<StringOperationFilterInput>;
  middleName?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SystemUserFilterInput>>;
  personalEmailAddress?: InputMaybe<StringOperationFilterInput>;
  salutation?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
  xrm?: InputMaybe<StringOperationFilterInput>;
};

export type SystemUserInput = {
  activeDirectoryGuid?: InputMaybe<Scalars['UUID']['input']>;
  companyId: Scalars['UUID']['input'];
  contextName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['Int']['input']>;
  equipments: Array<EquipmentInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  internalEmailAddress?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkString?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  personalEmailAddress?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  xrm?: InputMaybe<Scalars['String']['input']>;
};

export type SystemUserSortInput = {
  activeDirectoryGuid?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  contextName?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  domainName?: InputMaybe<SortEnumType>;
  environment?: InputMaybe<SortEnumType>;
  environmentId?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  internalEmailAddress?: InputMaybe<SortEnumType>;
  isDisabled?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  linkString?: InputMaybe<SortEnumType>;
  middleName?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  personalEmailAddress?: InputMaybe<SortEnumType>;
  salutation?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
  xrm?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SystemUsersCollectionSegment = {
  __typename: 'SystemUsersCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<SystemUser>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type TOA_GetFertilizationsEmbryos = {
  __typename: 'TOA_GetFertilizationsEmbryos';
  cane: Maybe<Scalars['String']['output']>;
  crackedZona: Maybe<Scalars['Boolean']['output']>;
  d7: Maybe<Scalars['Int']['output']>;
  d65: Maybe<Scalars['Int']['output']>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  dtPlus: Maybe<Scalars['String']['output']>;
  equilibrationSolutionDate: Maybe<Scalars['DateTime']['output']>;
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  freezeMethodId: Maybe<Scalars['UUID']['output']>;
  freezeMethodName: Maybe<Scalars['String']['output']>;
  freezeTechName: Maybe<Scalars['String']['output']>;
  freezer: Maybe<Scalars['String']['output']>;
  freshFrozen: Maybe<Scalars['Int']['output']>;
  freshFrozenName: Maybe<Scalars['String']['output']>;
  grade: Maybe<Scalars['Int']['output']>;
  grader7Id: Maybe<Scalars['UUID']['output']>;
  grader7Name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['UUID']['output']>;
  lowQuality: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  ownerName: Maybe<Scalars['String']['output']>;
  qc12WellPlates: Maybe<Scalars['String']['output']>;
  qc12WellPlatesOld: Maybe<Scalars['Int']['output']>;
  qcEg10: Maybe<Scalars['String']['output']>;
  qcEg10Date: Maybe<Scalars['DateTime']['output']>;
  qcSterileStrawLotNumber: Maybe<Scalars['String']['output']>;
  qcStrawLotNumber: Maybe<Scalars['String']['output']>;
  qcSucroseDate: Maybe<Scalars['DateTime']['output']>;
  qcTryPsInDate: Maybe<Scalars['DateTime']['output']>;
  qcVitStrawLotNumber: Maybe<Scalars['String']['output']>;
  qcehmDate: Maybe<Scalars['DateTime']['output']>;
  qcfreezingComment: Maybe<Scalars['String']['output']>;
  sireId: Maybe<Scalars['UUID']['output']>;
  sireName: Maybe<Scalars['String']['output']>;
  stage: Maybe<Scalars['Int']['output']>;
  storageLocationId: Maybe<Scalars['UUID']['output']>;
  storageLocationName: Maybe<Scalars['String']['output']>;
  strawLabel: Maybe<Scalars['Long']['output']>;
  strawNumber: Maybe<Scalars['Int']['output']>;
  subCane: Maybe<Scalars['String']['output']>;
  subCaneNoSuffix: Maybe<Scalars['String']['output']>;
  tt: Maybe<Scalars['Boolean']['output']>;
  vitrificationSolutionDate: Maybe<Scalars['DateTime']['output']>;
};

export type TOA_GetFertilizationsForFreezing = {
  __typename: 'TOA_GetFertilizationsForFreezing';
  account: Maybe<Scalars['String']['output']>;
  approvalNumber: Maybe<Scalars['String']['output']>;
  approvalNumberId: Maybe<Scalars['UUID']['output']>;
  billAccountCaningOption: Maybe<Scalars['Int']['output']>;
  breedCategory: Maybe<Scalars['Int']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  cleaved: Maybe<Scalars['Int']['output']>;
  contaminantPresent: Maybe<Scalars['String']['output']>;
  csr: Maybe<Scalars['String']['output']>;
  csrComment: Maybe<Scalars['String']['output']>;
  dBreed: Maybe<Scalars['String']['output']>;
  degenerates: Maybe<Scalars['Int']['output']>;
  discarded: Maybe<Scalars['Int']['output']>;
  discardedGrade1: Maybe<Scalars['Int']['output']>;
  discardedGrade2: Maybe<Scalars['Int']['output']>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  embs: Maybe<Scalars['Int']['output']>;
  export: Maybe<Scalars['String']['output']>;
  fertId: Maybe<Scalars['UUID']['output']>;
  freezeMethod: Maybe<Scalars['String']['output']>;
  frozen: Maybe<Scalars['Int']['output']>;
  heldAtTogToFreeze: Maybe<Scalars['Int']['output']>;
  heldTransfer: Maybe<Scalars['Int']['output']>;
  heldTransferLg: Maybe<Scalars['Int']['output']>;
  index: Maybe<Scalars['Int']['output']>;
  intEmbs: Maybe<Scalars['Int']['output']>;
  isDonorDuplicate: Maybe<Scalars['Boolean']['output']>;
  isPlateDuplicate: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use ivcNumber instead. */
  ivcNum: Maybe<Scalars['Int']['output']>;
  ivcNumber: Maybe<Scalars['Int']['output']>;
  noEmbryosProduced: Maybe<Scalars['String']['output']>;
  opuSite: Maybe<Scalars['String']['output']>;
  opuSiteName: Maybe<Scalars['String']['output']>;
  partners: Maybe<Scalars['String']['output']>;
  partnershipId: Maybe<Scalars['UUID']['output']>;
  plateNumber: Maybe<Scalars['Float']['output']>;
  predictedGood: Maybe<Scalars['Int']['output']>;
  predictedLow: Maybe<Scalars['Int']['output']>;
  predictedVeryLow: Maybe<Scalars['Int']['output']>;
  predictionTech: Maybe<Scalars['String']['output']>;
  programName: Maybe<Scalars['String']['output']>;
  resultsComment: Maybe<Scalars['String']['output']>;
  sBreed: Maybe<Scalars['String']['output']>;
  semenType: Maybe<Scalars['String']['output']>;
  sireId: Maybe<Scalars['UUID']['output']>;
  sireName: Maybe<Scalars['String']['output']>;
  sireTogIds: Maybe<Scalars['String']['output']>;
  siteId: Maybe<Scalars['UUID']['output']>;
  tog_export: Maybe<Scalars['Int']['output']>;
  validationDate: Maybe<Scalars['DateTime']['output']>;
  validatorId: Maybe<Scalars['UUID']['output']>;
};

export type TOA_GetFertilizationsIntEmbryos = {
  __typename: 'TOA_GetFertilizationsIntEmbryos';
  cane: Maybe<Scalars['String']['output']>;
  crackedZona: Maybe<Scalars['Boolean']['output']>;
  d7: Maybe<Scalars['Int']['output']>;
  d65: Maybe<Scalars['Int']['output']>;
  discard: Maybe<Scalars['Int']['output']>;
  embryoFreezeEntryId: Maybe<Scalars['UUID']['output']>;
  embryoId: Maybe<Scalars['UUID']['output']>;
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  freezeMethodId: Maybe<Scalars['UUID']['output']>;
  freezeMethodName: Maybe<Scalars['String']['output']>;
  freezeTech: Maybe<Scalars['String']['output']>;
  freezer: Maybe<Scalars['String']['output']>;
  grade: Maybe<Scalars['Int']['output']>;
  loadDonorPartnershipsFrozen: Maybe<Scalars['Int']['output']>;
  lowQuality: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  ownerId: Maybe<Scalars['UUID']['output']>;
  ownerName: Maybe<Scalars['String']['output']>;
  owners: Maybe<Array<TOA_GetFertilizationsIntEmbryosOwnerList>>;
  stage: Maybe<Scalars['Int']['output']>;
  storageLocationName: Maybe<Scalars['String']['output']>;
  straw: Maybe<Scalars['Int']['output']>;
  subCane: Maybe<Scalars['String']['output']>;
  tt: Maybe<Scalars['Boolean']['output']>;
};

export type TOA_GetFertilizationsIntEmbryosOwnerList = {
  __typename: 'TOA_GetFertilizationsIntEmbryosOwnerList';
  ownerId: Scalars['UUID']['output'];
  percentage: Maybe<Scalars['Float']['output']>;
  ranchCode: Maybe<Scalars['String']['output']>;
};

export type TOA_GetFreshShipmentFertList = {
  __typename: 'TOA_GetFreshShipmentFertList';
  accountNumber: Maybe<Scalars['String']['output']>;
  billIncubator: Maybe<Scalars['Boolean']['output']>;
  billIncubator2: Maybe<Scalars['Boolean']['output']>;
  billShipping: Maybe<Scalars['Boolean']['output']>;
  billShipping2: Maybe<Scalars['Boolean']['output']>;
  breedDonor: Maybe<Scalars['String']['output']>;
  breedSire: Maybe<Scalars['String']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  cleaved: Maybe<Scalars['Int']['output']>;
  colCode: Maybe<Scalars['String']['output']>;
  comments: Maybe<Scalars['String']['output']>;
  contaminantPresent: Maybe<Scalars['String']['output']>;
  csr: Maybe<Scalars['String']['output']>;
  csrComment: Maybe<Scalars['String']['output']>;
  day5esttrans: Maybe<Scalars['Int']['output']>;
  donorBreed: Maybe<Scalars['String']['output']>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorLocation: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  embryoCalcPaNm: Maybe<Scalars['Int']['output']>;
  embryoCalcPaTpi: Maybe<Scalars['Int']['output']>;
  embryoComment: Maybe<Scalars['String']['output']>;
  export: Maybe<Scalars['Int']['output']>;
  exportName: Maybe<Scalars['String']['output']>;
  fertDate: Maybe<Scalars['String']['output']>;
  fertilizationId: Scalars['UUID']['output'];
  freezeName: Maybe<Scalars['String']['output']>;
  freshShipmentComments: Maybe<Scalars['String']['output']>;
  freshShipmentId: Maybe<Scalars['UUID']['output']>;
  heldAtTogForTransfer: Maybe<Scalars['Int']['output']>;
  heldAtTogFreezeTransferLowGrade: Maybe<Scalars['Int']['output']>;
  heldAtTogToFreeze: Maybe<Scalars['Int']['output']>;
  implantType: Maybe<Scalars['Int']['output']>;
  inc1: Maybe<Scalars['String']['output']>;
  inc1Id: Maybe<Scalars['UUID']['output']>;
  inc2: Maybe<Scalars['String']['output']>;
  inc2Id: Maybe<Scalars['UUID']['output']>;
  isDuplicate: Maybe<Scalars['Boolean']['output']>;
  ivcNumber: Maybe<Scalars['Int']['output']>;
  ivfComment: Maybe<Scalars['String']['output']>;
  loadedInStraws: Maybe<Scalars['Int']['output']>;
  noEmbryosProduced: Maybe<Scalars['String']['output']>;
  origHeldAtTog: Maybe<Scalars['Int']['output']>;
  origShipped: Maybe<Scalars['Int']['output']>;
  partnerships: Maybe<Scalars['String']['output']>;
  plateNumber: Maybe<Scalars['Float']['output']>;
  predictedBy: Maybe<Scalars['String']['output']>;
  predictedGood: Maybe<Scalars['Int']['output']>;
  predictedLow: Maybe<Scalars['Int']['output']>;
  predictedVeryLow: Maybe<Scalars['Int']['output']>;
  priority: Maybe<Scalars['Int']['output']>;
  programName: Maybe<Scalars['String']['output']>;
  semenTypeName: Maybe<Scalars['String']['output']>;
  shipGroupName: Maybe<Scalars['String']['output']>;
  shipName: Maybe<Scalars['String']['output']>;
  shipmentGroupMaster2Id: Maybe<Scalars['UUID']['output']>;
  shipmentGroupMasterId: Maybe<Scalars['UUID']['output']>;
  shipped: Maybe<Scalars['Int']['output']>;
  shipped2: Maybe<Scalars['Int']['output']>;
  shippedBillable: Maybe<Scalars['Int']['output']>;
  shippedTog: Maybe<Scalars['Int']['output']>;
  shippedTog2: Maybe<Scalars['Int']['output']>;
  sireBreed: Maybe<Scalars['String']['output']>;
  sireName: Maybe<Scalars['String']['output']>;
  sireReg: Maybe<Scalars['String']['output']>;
  siteName: Maybe<Scalars['String']['output']>;
  totals: Maybe<Scalars['Int']['output']>;
  transferName: Maybe<Scalars['String']['output']>;
  tubeNumber: Maybe<Scalars['Decimal']['output']>;
};

export type TOA_GetFreshShipmentFertListInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  billIncubator?: InputMaybe<Scalars['Boolean']['input']>;
  billIncubator2?: InputMaybe<Scalars['Boolean']['input']>;
  billShipping?: InputMaybe<Scalars['Boolean']['input']>;
  billShipping2?: InputMaybe<Scalars['Boolean']['input']>;
  breedDonor?: InputMaybe<Scalars['String']['input']>;
  breedSire?: InputMaybe<Scalars['String']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  cleaved?: InputMaybe<Scalars['Int']['input']>;
  colCode?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contaminantPresent?: InputMaybe<Scalars['String']['input']>;
  csr?: InputMaybe<Scalars['String']['input']>;
  csrComment?: InputMaybe<Scalars['String']['input']>;
  day5esttrans?: InputMaybe<Scalars['Int']['input']>;
  donorBreed?: InputMaybe<Scalars['String']['input']>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorLocation?: InputMaybe<Scalars['String']['input']>;
  donorName?: InputMaybe<Scalars['String']['input']>;
  embryoCalcPaNm?: InputMaybe<Scalars['Int']['input']>;
  embryoCalcPaTpi?: InputMaybe<Scalars['Int']['input']>;
  embryoComment?: InputMaybe<Scalars['String']['input']>;
  export?: InputMaybe<Scalars['Int']['input']>;
  exportName?: InputMaybe<Scalars['String']['input']>;
  fertDate?: InputMaybe<Scalars['String']['input']>;
  fertilizationId: Scalars['UUID']['input'];
  freezeName?: InputMaybe<Scalars['String']['input']>;
  freshShipmentComments?: InputMaybe<Scalars['String']['input']>;
  freshShipmentId?: InputMaybe<Scalars['UUID']['input']>;
  heldAtTogForTransfer?: InputMaybe<Scalars['Int']['input']>;
  heldAtTogFreezeTransferLowGrade?: InputMaybe<Scalars['Int']['input']>;
  heldAtTogToFreeze?: InputMaybe<Scalars['Int']['input']>;
  implantType?: InputMaybe<Scalars['Int']['input']>;
  inc1?: InputMaybe<Scalars['String']['input']>;
  inc1Id?: InputMaybe<Scalars['UUID']['input']>;
  inc2?: InputMaybe<Scalars['String']['input']>;
  inc2Id?: InputMaybe<Scalars['UUID']['input']>;
  isDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  ivcNumber?: InputMaybe<Scalars['Int']['input']>;
  ivfComment?: InputMaybe<Scalars['String']['input']>;
  loadedInStraws?: InputMaybe<Scalars['Int']['input']>;
  noEmbryosProduced?: InputMaybe<Scalars['String']['input']>;
  origHeldAtTog?: InputMaybe<Scalars['Int']['input']>;
  origShipped?: InputMaybe<Scalars['Int']['input']>;
  partnerships?: InputMaybe<Scalars['String']['input']>;
  plateNumber?: InputMaybe<Scalars['Float']['input']>;
  predictedBy?: InputMaybe<Scalars['String']['input']>;
  predictedGood?: InputMaybe<Scalars['Int']['input']>;
  predictedLow?: InputMaybe<Scalars['Int']['input']>;
  predictedVeryLow?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  semenTypeName?: InputMaybe<Scalars['String']['input']>;
  shipGroupName?: InputMaybe<Scalars['String']['input']>;
  shipName?: InputMaybe<Scalars['String']['input']>;
  shipmentGroupMaster2Id?: InputMaybe<Scalars['UUID']['input']>;
  shipmentGroupMasterId?: InputMaybe<Scalars['UUID']['input']>;
  shipped?: InputMaybe<Scalars['Int']['input']>;
  shipped2?: InputMaybe<Scalars['Int']['input']>;
  shippedBillable?: InputMaybe<Scalars['Int']['input']>;
  shippedTog?: InputMaybe<Scalars['Int']['input']>;
  shippedTog2?: InputMaybe<Scalars['Int']['input']>;
  sireBreed?: InputMaybe<Scalars['String']['input']>;
  sireName?: InputMaybe<Scalars['String']['input']>;
  sireReg?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  totals?: InputMaybe<Scalars['Int']['input']>;
  transferName?: InputMaybe<Scalars['String']['input']>;
  tubeNumber?: InputMaybe<Scalars['Decimal']['input']>;
};

export type TOA_GetFreshShipmentShipGroupMasters = {
  __typename: 'TOA_GetFreshShipmentShipGroupMasters';
  name: Maybe<Scalars['String']['output']>;
  shipmentGroupMasterId: Scalars['UUID']['output'];
};

export type TOA_GetFreshShipmentShipGroups = {
  __typename: 'TOA_GetFreshShipmentShipGroups';
  fertDate: Maybe<Scalars['String']['output']>;
  isSignedOff: Maybe<Scalars['Boolean']['output']>;
  numMating: Maybe<Scalars['Int']['output']>;
  numTubes: Maybe<Scalars['Int']['output']>;
  shipGroupId: Maybe<Scalars['UUID']['output']>;
  shipGroupName: Maybe<Scalars['String']['output']>;
};

export type TOA_GetFreshShipments = {
  __typename: 'TOA_GetFreshShipments';
  exportStatus: Maybe<Scalars['Boolean']['output']>;
  freshShipmentId: Scalars['UUID']['output'];
  matingsCount: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  shipmentNumber: Maybe<Scalars['String']['output']>;
  shippedEmbryosCount: Maybe<Scalars['Int']['output']>;
  shipperId: Maybe<Scalars['String']['output']>;
  trackingNumber: Maybe<Scalars['String']['output']>;
  verified: Maybe<Scalars['Boolean']['output']>;
};

export type TOG_CsrDay7 = {
  __typename: 'TOG_CsrDay7';
  account: Maybe<Scalars['String']['output']>;
  breed: Maybe<Scalars['String']['output']>;
  bullBreed: Maybe<Scalars['String']['output']>;
  cleaved: Maybe<Scalars['Int']['output']>;
  clientRecip: Maybe<Scalars['String']['output']>;
  csrComments: Maybe<Scalars['String']['output']>;
  donor: Maybe<Scalars['String']['output']>;
  donorOwners: Maybe<Scalars['String']['output']>;
  donorScheduleFreezePartner: Maybe<Scalars['String']['output']>;
  donorScheduleTransferPartner: Maybe<Scalars['String']['output']>;
  embTag: Maybe<Scalars['Int']['output']>;
  embryoId: Maybe<Scalars['UUID']['output']>;
  embryoToBe: Maybe<Scalars['String']['output']>;
  export: Maybe<Scalars['String']['output']>;
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  freezePartner: Maybe<Scalars['String']['output']>;
  freezePlan: Maybe<Scalars['String']['output']>;
  freshStrawNo: Maybe<Scalars['Int']['output']>;
  grade: Maybe<Scalars['Int']['output']>;
  hldFrz: Maybe<Scalars['Int']['output']>;
  hldFrzTrfLg: Maybe<Scalars['Int']['output']>;
  hldTrf: Maybe<Scalars['Int']['output']>;
  implantType: Maybe<Scalars['String']['output']>;
  ivcNumber: Maybe<Scalars['Int']['output']>;
  numberOfPartners: Maybe<Scalars['String']['output']>;
  packagedInformation: Maybe<Scalars['String']['output']>;
  plateNumber: Maybe<Scalars['Decimal']['output']>;
  recipFrame: Maybe<Scalars['Int']['output']>;
  resultsComment: Maybe<Scalars['String']['output']>;
  shipmentGroup: Maybe<Scalars['String']['output']>;
  shippedToClient: Maybe<Scalars['Int']['output']>;
  shippingPlan: Maybe<Scalars['String']['output']>;
  sire: Maybe<Scalars['String']['output']>;
  st: Maybe<Scalars['String']['output']>;
  stage: Maybe<Scalars['Int']['output']>;
  togRecip: Maybe<Scalars['String']['output']>;
  transferPartner: Maybe<Scalars['String']['output']>;
  transferPlan: Maybe<Scalars['String']['output']>;
};

export type TOG_FacilityApprovalNumbersBase = {
  __typename: 'TOG_FacilityApprovalNumbersBase';
  createdOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  stateCode: Maybe<Scalars['Int']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  tog_approvalnumber: Maybe<Scalars['String']['output']>;
  tog_exportcountry: Maybe<Scalars['Int']['output']>;
  tog_facilityapprovalnumbersId: Scalars['UUID']['output'];
  tog_siteid: Maybe<Scalars['UUID']['output']>;
  tog_type: Maybe<Scalars['Int']['output']>;
};

export type TOG_FacilityApprovalNumbersBaseFilterInput = {
  and?: InputMaybe<Array<TOG_FacilityApprovalNumbersBaseFilterInput>>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TOG_FacilityApprovalNumbersBaseFilterInput>>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  tog_approvalnumber?: InputMaybe<StringOperationFilterInput>;
  tog_exportcountry?: InputMaybe<IntOperationFilterInput>;
  tog_facilityapprovalnumbersId?: InputMaybe<UuidOperationFilterInput>;
  tog_siteid?: InputMaybe<UuidOperationFilterInput>;
  tog_type?: InputMaybe<IntOperationFilterInput>;
};

export type TOG_FacilityApprovalNumbersBaseInput = {
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  stateCode?: InputMaybe<Scalars['Int']['input']>;
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  tog_approvalnumber?: InputMaybe<Scalars['String']['input']>;
  tog_exportcountry?: InputMaybe<Scalars['Int']['input']>;
  tog_facilityapprovalnumbersId: Scalars['UUID']['input'];
  tog_siteid?: InputMaybe<Scalars['UUID']['input']>;
  tog_type?: InputMaybe<Scalars['Int']['input']>;
};

export type TOG_FacilityApprovalNumbersBaseSortInput = {
  createdOn?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  tog_approvalnumber?: InputMaybe<SortEnumType>;
  tog_exportcountry?: InputMaybe<SortEnumType>;
  tog_facilityapprovalnumbersId?: InputMaybe<SortEnumType>;
  tog_siteid?: InputMaybe<SortEnumType>;
  tog_type?: InputMaybe<SortEnumType>;
};

export type TOG_GetAspirationByDonorDateSite = {
  __typename: 'TOG_GetAspirationByDonorDateSite';
  account: Maybe<Scalars['String']['output']>;
  accountName: Maybe<Scalars['String']['output']>;
  aspComments: Maybe<Scalars['String']['output']>;
  aspirationDate: Maybe<Scalars['DateTime']['output']>;
  aspirationId: Maybe<Scalars['UUID']['output']>;
  aspirationTime: Maybe<Scalars['String']['output']>;
  asstId: Maybe<Scalars['UUID']['output']>;
  birthDate: Maybe<Scalars['DateTime']['output']>;
  breed: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  csa: Maybe<Scalars['String']['output']>;
  csr: Maybe<Scalars['String']['output']>;
  didNotAspirate: Maybe<Scalars['Int']['output']>;
  donor: Maybe<Scalars['String']['output']>;
  donorComment: Maybe<Scalars['String']['output']>;
  donorCondition: Maybe<Scalars['String']['output']>;
  donorId: Maybe<Scalars['UUID']['output']>;
  donorLocation: Maybe<Scalars['String']['output']>;
  donorName: Maybe<Scalars['String']['output']>;
  dsAspirationComment: Maybe<Scalars['String']['output']>;
  earTag: Maybe<Scalars['String']['output']>;
  export: Maybe<Scalars['String']['output']>;
  fertPlan: Maybe<Scalars['String']['output']>;
  lastBred: Maybe<Scalars['DateTime']['output']>;
  leftCls: Maybe<Scalars['Int']['output']>;
  leftCysts: Maybe<Scalars['String']['output']>;
  leftLarge: Maybe<Scalars['Int']['output']>;
  leftMedium: Maybe<Scalars['Int']['output']>;
  leftSmall: Maybe<Scalars['Int']['output']>;
  matTime: Maybe<Scalars['String']['output']>;
  medTotal: Maybe<Scalars['String']['output']>;
  nextSched: Maybe<Scalars['String']['output']>;
  nextScheduleId: Maybe<Scalars['UUID']['output']>;
  numInMat: Maybe<Scalars['Int']['output']>;
  opuid: Maybe<Scalars['UUID']['output']>;
  poolNum: Maybe<Scalars['Int']['output']>;
  pooled: Maybe<Scalars['String']['output']>;
  pregnant: Maybe<Scalars['Int']['output']>;
  rightCls: Maybe<Scalars['Int']['output']>;
  rightCysts: Maybe<Scalars['String']['output']>;
  rightLarge: Maybe<Scalars['Int']['output']>;
  rightMedium: Maybe<Scalars['Int']['output']>;
  rightSmall: Maybe<Scalars['Int']['output']>;
  rowNum: Maybe<Scalars['Long']['output']>;
  sched: Maybe<Scalars['String']['output']>;
  scheduleId: Maybe<Scalars['UUID']['output']>;
  semenType: Maybe<Scalars['String']['output']>;
  sire: Maybe<Scalars['String']['output']>;
  siteId: Maybe<Scalars['UUID']['output']>;
  totalFollicles: Maybe<Scalars['Int']['output']>;
  totalOocytes: Maybe<Scalars['Int']['output']>;
  vetId: Maybe<Scalars['UUID']['output']>;
  weight: Maybe<Scalars['String']['output']>;
};

export type TOG_PseDay7 = {
  __typename: 'TOG_PseDay7';
  accountId: Maybe<Scalars['String']['output']>;
  cane: Maybe<Scalars['String']['output']>;
  cl: Maybe<Scalars['String']['output']>;
  deactivate: Maybe<Scalars['Int']['output']>;
  donorPartners: Maybe<Scalars['String']['output']>;
  dsImplantType: Maybe<Scalars['String']['output']>;
  embryoId: Maybe<Scalars['UUID']['output']>;
  embryoImplantType: Maybe<Scalars['String']['output']>;
  embryoPartners: Maybe<Scalars['String']['output']>;
  embryoTag: Maybe<Scalars['Int']['output']>;
  estrusSync: Maybe<Scalars['Decimal']['output']>;
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  freezeMethodId: Maybe<Scalars['UUID']['output']>;
  freshStrawNo: Maybe<Scalars['Int']['output']>;
  frozenStraw: Maybe<Scalars['Int']['output']>;
  grade: Maybe<Scalars['Int']['output']>;
  loadPartners: Maybe<Scalars['String']['output']>;
  mating: Maybe<Scalars['String']['output']>;
  plateNo: Maybe<Scalars['Decimal']['output']>;
  recipFrame: Maybe<Scalars['Int']['output']>;
  recipient: Maybe<Scalars['String']['output']>;
  semenType: Maybe<Scalars['String']['output']>;
  shipmentGroup: Maybe<Scalars['String']['output']>;
  stage: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  transferComment: Maybe<Scalars['String']['output']>;
  transferTech: Maybe<Scalars['String']['output']>;
  tt: Maybe<Scalars['Boolean']['output']>;
};

export type TOG_PseDay7Input = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  cl?: InputMaybe<Scalars['String']['input']>;
  deactivate?: InputMaybe<Scalars['Int']['input']>;
  donorPartners?: InputMaybe<Scalars['String']['input']>;
  dsImplantType?: InputMaybe<Scalars['String']['input']>;
  embryoId?: InputMaybe<Scalars['UUID']['input']>;
  embryoImplantType?: InputMaybe<Scalars['String']['input']>;
  embryoPartners?: InputMaybe<Scalars['String']['input']>;
  embryoTag?: InputMaybe<Scalars['Int']['input']>;
  estrusSync?: InputMaybe<Scalars['Decimal']['input']>;
  fertilizationId?: InputMaybe<Scalars['UUID']['input']>;
  freezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  freshStrawNo?: InputMaybe<Scalars['Int']['input']>;
  frozenStraw?: InputMaybe<Scalars['Int']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  loadPartners?: InputMaybe<Scalars['String']['input']>;
  mating?: InputMaybe<Scalars['String']['input']>;
  plateNo?: InputMaybe<Scalars['Decimal']['input']>;
  recipFrame?: InputMaybe<Scalars['Int']['input']>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  semenType?: InputMaybe<Scalars['String']['input']>;
  shipmentGroup?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transferComment?: InputMaybe<Scalars['String']['input']>;
  transferTech?: InputMaybe<Scalars['String']['input']>;
  tt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TOG_schedmasterWithAspirationDate = {
  __typename: 'TOG_schedmasterWithAspirationDate';
  aspirationDate: Maybe<Scalars['DateTime']['output']>;
  coast: Maybe<Scalars['Int']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  dead: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  donorSchedules: Array<DonorSchedule>;
  gradeAbc: Maybe<Scalars['Int']['output']>;
  gradeD: Maybe<Scalars['Int']['output']>;
  gradeE: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  leftLargeFollicles: Maybe<Scalars['Int']['output']>;
  leftMediumFollicles: Maybe<Scalars['Int']['output']>;
  leftSmallFollicles: Maybe<Scalars['Int']['output']>;
  method: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nextScheduleMasterAspirations: Array<Aspiration>;
  numberInMat: Maybe<Scalars['Int']['output']>;
  numberOfShots: Maybe<Scalars['Int']['output']>;
  rightLargeFollicles: Maybe<Scalars['Int']['output']>;
  rightMediumFollicles: Maybe<Scalars['Int']['output']>;
  rightSmallFollicles: Maybe<Scalars['Int']['output']>;
  scheduleMasterAspirations: Array<Aspiration>;
  setup: Maybe<Scalars['Int']['output']>;
  soSchedules: Array<SuperOvulationSchedule>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  totalDose: Maybe<Scalars['Decimal']['output']>;
  twiceConcentration: Maybe<Scalars['Boolean']['output']>;
};

export type TableMetadata = {
  __typename: 'TableMetadata';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type TeamStatsInput = {
  avgFolliclesTotal: Scalars['String']['input'];
  avgNumInMat: Scalars['String']['input'];
  avgOocytesTotal: Scalars['String']['input'];
  folliclesTotal: Scalars['String']['input'];
  numInMat: Scalars['String']['input'];
  oocytesTotal: Scalars['String']['input'];
  opuStats: Array<StatsInput>;
  showStopSign: Scalars['Boolean']['input'];
};

export type TechType = {
  __typename: 'TechType';
  guidValue: Scalars['UUID']['output'];
  intValue: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TechTypeFilterInput = {
  and?: InputMaybe<Array<TechTypeFilterInput>>;
  guidValue?: InputMaybe<UuidOperationFilterInput>;
  intValue?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TechTypeFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type TechTypeSortInput = {
  guidValue?: InputMaybe<SortEnumType>;
  intValue?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type TechsCollectionSegment = {
  __typename: 'TechsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<TechType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type TelemetryEventsCollectionSegment = {
  __typename: 'TelemetryEventsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<TogTelemetryEvent>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type TempEmbryosCollectionSegment = {
  __typename: 'TempEmbryosCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<tog_embryo_staging>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type TogRequestApp = {
  __typename: 'TogRequestApp';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  requests: Array<RequestItIssue>;
};

export type TogRequestAppFilterInput = {
  and?: InputMaybe<Array<TogRequestAppFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TogRequestAppFilterInput>>;
  requests?: InputMaybe<ListFilterInputTypeOfRequestItIssueFilterInput>;
};

export type TogRequestAppSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type TogRequestDepartment = {
  __typename: 'TogRequestDepartment';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  requests: Array<RequestItIssue>;
};

export type TogRequestDepartmentFilterInput = {
  and?: InputMaybe<Array<TogRequestDepartmentFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TogRequestDepartmentFilterInput>>;
  requests?: InputMaybe<ListFilterInputTypeOfRequestItIssueFilterInput>;
};

export type TogRequestDepartmentSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type TogTelemetryEvent = {
  __typename: 'TogTelemetryEvent';
  adUserId: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  jsonEvent: Scalars['String']['output'];
  mtoUserId: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type TogTelemetryEventFilterInput = {
  adUserId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<TogTelemetryEventFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jsonEvent?: InputMaybe<StringOperationFilterInput>;
  mtoUserId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TogTelemetryEventFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type TogTelemetryEventSortInput = {
  adUserId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jsonEvent?: InputMaybe<SortEnumType>;
  mtoUserId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type UnsignedByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['UnsignedByte']['input']>;
  gt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  gte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedByte']['input']>>>;
  lt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  lte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  neq?: InputMaybe<Scalars['UnsignedByte']['input']>;
  ngt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  ngte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UnsignedByte']['input']>>>;
  nlt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  nlte?: InputMaybe<Scalars['UnsignedByte']['input']>;
};

export type UpdateAetaResultInput = {
  embryoDevelopmentRate: Scalars['Float']['input'];
  embryosPerAspiration: Scalars['Float']['input'];
  id: Scalars['UUID']['input'];
  oocytesPerAspiration: Scalars['Float']['input'];
  type: AetaResultType;
  year: Scalars['Int']['input'];
};

export type UpdateAetaResultPayload = {
  __typename: 'UpdateAetaResultPayload';
  aetaResult: Maybe<AetaResult>;
};

export type UpdateApprovalNumberInput = {
  approvalNumberId: Scalars['UUID']['input'];
  embryoIds: Array<Scalars['UUID']['input']>;
  fertId: Scalars['UUID']['input'];
};

export type UpdateAspirationStatusAndDonorScheduleRevisionCommentInput = {
  aspirationId: Scalars['UUID']['input'];
  donorScheduleId: Scalars['UUID']['input'];
  revisionComment: Scalars['String']['input'];
  targetStatus: Scalars['String']['input'];
};

export type UpdateEquipmentInput = {
  isActive: Scalars['Boolean']['input'];
  isEmbryologist: Scalars['Boolean']['input'];
  isHerdsman: Scalars['Boolean']['input'];
  isInTraining: Scalars['Boolean']['input'];
  isTechnician: Scalars['Boolean']['input'];
  isVeterinarian: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  siteId: Scalars['UUID']['input'];
  systemUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateFertilizationInput = {
  contaminantPresent?: InputMaybe<Scalars['Boolean']['input']>;
  contaminationInFert?: InputMaybe<Scalars['Boolean']['input']>;
  hasFewMotileSperm: Scalars['Boolean']['input'];
  hasNoMotileSperm: Scalars['Boolean']['input'];
  hasPoorCytoplasmQuality: Scalars['Boolean']['input'];
  hasTwoCellCleavage: Scalars['Boolean']['input'];
  isFragile: Scalars['Boolean']['input'];
  isHardToStrip: Scalars['Boolean']['input'];
  ivcBroken: Scalars['Int']['input'];
  ivcComment: Scalars['String']['input'];
  ivcDead: Scalars['Int']['input'];
  ivcExtra: Scalars['Int']['input'];
  ivcImmature: Scalars['Int']['input'];
  ivcMissing: Scalars['Int']['input'];
  ivcNumber: Scalars['Int']['input'];
  ivcTechnicianId: Scalars['UUID']['input'];
  ivfNumber: Scalars['Int']['input'];
  qcIncubatorId?: InputMaybe<Scalars['UUID']['input']>;
  strippedAt: Scalars['DateTime']['input'];
  strippedAtTime: Scalars['String']['input'];
  stripperTipLotNumber: Scalars['String']['input'];
};

export type UpdateFreshTransferInput = {
  embryos: Array<TOG_PseDay7Input>;
  graderId: Scalars['String']['input'];
  loadDay: Scalars['String']['input'];
  transferDay: Scalars['DateTime']['input'];
  transferSiteId: Scalars['String']['input'];
};

export type UpdateFreshTransferPayload = {
  __typename: 'UpdateFreshTransferPayload';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateODFreezeInput = {
  cane?: InputMaybe<Scalars['String']['input']>;
  eg?: InputMaybe<Scalars['String']['input']>;
  egDate?: InputMaybe<Scalars['String']['input']>;
  ehmDate?: InputMaybe<Scalars['String']['input']>;
  embIDs?: InputMaybe<Scalars['String']['input']>;
  embsPerStraw?: InputMaybe<Scalars['String']['input']>;
  embsPerVitStraw?: InputMaybe<Scalars['String']['input']>;
  esDate?: InputMaybe<Scalars['String']['input']>;
  fertID?: InputMaybe<Scalars['UUID']['input']>;
  freezeDay?: InputMaybe<Scalars['String']['input']>;
  freezeLocationId?: InputMaybe<Scalars['UUID']['input']>;
  freezeTechID?: InputMaybe<Scalars['UUID']['input']>;
  freezer?: InputMaybe<Scalars['String']['input']>;
  freezingComment?: InputMaybe<Scalars['String']['input']>;
  graderID?: InputMaybe<Scalars['UUID']['input']>;
  intEmbIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  predictionTechID?: InputMaybe<Scalars['UUID']['input']>;
  qc12WellPlates?: InputMaybe<Scalars['String']['input']>;
  qcSterileStrawLotNumber?: InputMaybe<Scalars['String']['input']>;
  storageLocID?: InputMaybe<Scalars['UUID']['input']>;
  strawLotNo?: InputMaybe<Scalars['String']['input']>;
  sucroseDate?: InputMaybe<Scalars['String']['input']>;
  trypsinDate?: InputMaybe<Scalars['String']['input']>;
  vitStrawLotNo?: InputMaybe<Scalars['String']['input']>;
  vsDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRevisionsInput = {
  donorScheduleId: Scalars['UUID']['input'];
  revisionComment: Scalars['String']['input'];
};

export type UpdateSemenInput = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  available?: InputMaybe<Scalars['Int']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  colCode?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  cssCertified?: InputMaybe<Scalars['Int']['input']>;
  donorScheduleDate: Scalars['DateTime']['input'];
  donorScheduleSemenLocation?: InputMaybe<Scalars['String']['input']>;
  donorScheduleSemenType?: InputMaybe<Scalars['String']['input']>;
  fertSiteId: Scalars['UUID']['input'];
  move?: InputMaybe<Scalars['Int']['input']>;
  naab?: InputMaybe<Scalars['String']['input']>;
  recDate?: InputMaybe<Scalars['DateTime']['input']>;
  semenId: Scalars['UUID']['input'];
  semenType: Scalars['String']['input'];
  sex?: InputMaybe<Scalars['Int']['input']>;
  sexed?: InputMaybe<Scalars['Int']['input']>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  storageId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateSemenPayload = {
  __typename: 'UpdateSemenPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The id of the newly updated semen. */
  semenId: Maybe<Scalars['UUID']['output']>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type UpdateShipmentInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  billStatus?: InputMaybe<Scalars['Int']['input']>;
  billTo?: InputMaybe<Scalars['String']['input']>;
  callTag?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasCalves?: InputMaybe<Scalars['Boolean']['input']>;
  hasDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmbryos?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  hasSemen?: InputMaybe<Scalars['Boolean']['input']>;
  needByDate?: InputMaybe<Scalars['Date']['input']>;
  originalNeedByDate?: InputMaybe<Scalars['DateTime']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  packedById?: InputMaybe<Scalars['UUID']['input']>;
  packedByName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['String']['input']>;
  shipAddress?: InputMaybe<Scalars['String']['input']>;
  shipAddress2?: InputMaybe<Scalars['String']['input']>;
  shipAddress3?: InputMaybe<Scalars['String']['input']>;
  shipCity?: InputMaybe<Scalars['String']['input']>;
  shipFromSiteId?: InputMaybe<Scalars['UUID']['input']>;
  shipName?: InputMaybe<Scalars['String']['input']>;
  shipState?: InputMaybe<Scalars['String']['input']>;
  shipToId?: InputMaybe<Scalars['UUID']['input']>;
  shipZip?: InputMaybe<Scalars['String']['input']>;
  shipmentCategory?: InputMaybe<Scalars['Int']['input']>;
  shipmentStatus?: InputMaybe<Scalars['Int']['input']>;
  shippingMethod?: InputMaybe<Scalars['Int']['input']>;
  tank?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSireInput = {
  birth?: InputMaybe<Scalars['DateTime']['input']>;
  breedId: Scalars['UUID']['input'];
  breedReg?: InputMaybe<Scalars['String']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  heparin?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  regPrefix?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  sexedCane?: InputMaybe<Scalars['String']['input']>;
  sire: Scalars['String']['input'];
  sireId: Scalars['UUID']['input'];
};

export type UpdateViewInput = {
  id: Scalars['UUID']['input'];
  view: Scalars['String']['input'];
};

export type UpsertDonorScheduleInput = {
  accountComment?: InputMaybe<Scalars['String']['input']>;
  annotation?: InputMaybe<Scalars['String']['input']>;
  aspirationSiteId?: InputMaybe<Scalars['UUID']['input']>;
  backupCsrId?: InputMaybe<Scalars['UUID']['input']>;
  backupSemenId?: InputMaybe<Scalars['UUID']['input']>;
  backupSemenType?: InputMaybe<Scalars['Int']['input']>;
  backupSireId?: InputMaybe<Scalars['UUID']['input']>;
  billAccountCaningOption?: InputMaybe<Scalars['Int']['input']>;
  billDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  billingAccountId?: InputMaybe<Scalars['UUID']['input']>;
  billingComment?: InputMaybe<Scalars['String']['input']>;
  cane?: InputMaybe<Scalars['String']['input']>;
  clinicRanchHaulIn?: InputMaybe<Scalars['Int']['input']>;
  colCode?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  contractSemen?: InputMaybe<Scalars['Boolean']['input']>;
  createSOAuto?: InputMaybe<Scalars['Int']['input']>;
  createdByApp?: InputMaybe<Scalars['Int']['input']>;
  creditRebill?: InputMaybe<Scalars['Boolean']['input']>;
  critical?: InputMaybe<Scalars['Int']['input']>;
  csrId?: InputMaybe<Scalars['UUID']['input']>;
  csrfrztrf?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  day7pickup?: InputMaybe<Scalars['Int']['input']>;
  donorComment?: InputMaybe<Scalars['String']['input']>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorLocation?: InputMaybe<Scalars['String']['input']>;
  dow?: InputMaybe<Scalars['String']['input']>;
  drug2?: InputMaybe<Scalars['String']['input']>;
  drugShippingFee?: InputMaybe<Scalars['Int']['input']>;
  drugStatus?: InputMaybe<Scalars['Int']['input']>;
  embryoComment?: InputMaybe<Scalars['String']['input']>;
  expectedSemenQty?: InputMaybe<Scalars['Int']['input']>;
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  export?: InputMaybe<Scalars['Int']['input']>;
  fertilizationId?: InputMaybe<Scalars['UUID']['input']>;
  fertilizationSiteId?: InputMaybe<Scalars['UUID']['input']>;
  flexFieldPartner?: InputMaybe<Scalars['String']['input']>;
  freeze?: InputMaybe<Scalars['Int']['input']>;
  freezeInstructions?: InputMaybe<Scalars['String']['input']>;
  freezeMethodId?: InputMaybe<Scalars['UUID']['input']>;
  fsh2Id?: InputMaybe<Scalars['UUID']['input']>;
  fshId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  implantType?: InputMaybe<Scalars['Int']['input']>;
  ivfLabSemenId?: InputMaybe<Scalars['UUID']['input']>;
  loadDonorPartners?: InputMaybe<Scalars['Int']['input']>;
  loadDonorPartnersfrz?: InputMaybe<Scalars['Int']['input']>;
  naab?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonEUCountry?: InputMaybe<Scalars['Int']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  oocyteShipping?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  parity?: InputMaybe<Scalars['Int']['input']>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  pregnant?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  procedureTime?: InputMaybe<Scalars['Int']['input']>;
  procedureTimeComment?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  revisionComment?: InputMaybe<Scalars['String']['input']>;
  scheduleMasterId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleStatus?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  semenComment?: InputMaybe<Scalars['String']['input']>;
  semenId?: InputMaybe<Scalars['UUID']['input']>;
  semenLocationId?: InputMaybe<Scalars['UUID']['input']>;
  semenOwnerId?: InputMaybe<Scalars['UUID']['input']>;
  semenPrice?: InputMaybe<Scalars['Decimal']['input']>;
  semenReleased?: InputMaybe<Scalars['Boolean']['input']>;
  semenType?: InputMaybe<Scalars['Int']['input']>;
  separateFert?: InputMaybe<Scalars['Boolean']['input']>;
  ship?: InputMaybe<Scalars['Int']['input']>;
  shipGroup?: InputMaybe<Scalars['String']['input']>;
  shipInstructions?: InputMaybe<Scalars['String']['input']>;
  shipToFbd?: InputMaybe<Scalars['String']['input']>;
  shipmentGroupId?: InputMaybe<Scalars['UUID']['input']>;
  sireId?: InputMaybe<Scalars['UUID']['input']>;
  sireSelectionRequestId?: InputMaybe<Scalars['UUID']['input']>;
  soScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  specialBilling?: InputMaybe<Scalars['Int']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  suggestedSemenMove?: InputMaybe<Scalars['Int']['input']>;
  targetTime?: InputMaybe<Scalars['Boolean']['input']>;
  textingAccountId?: InputMaybe<Scalars['UUID']['input']>;
  textingNumber?: InputMaybe<Scalars['String']['input']>;
  transfer?: InputMaybe<Scalars['Int']['input']>;
  tt?: InputMaybe<Scalars['Boolean']['input']>;
  validationMessage?: InputMaybe<Scalars['String']['input']>;
  validationSts?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPartnershipInput = {
  account1Id?: InputMaybe<Scalars['UUID']['input']>;
  account2Id?: InputMaybe<Scalars['UUID']['input']>;
  account3Id?: InputMaybe<Scalars['UUID']['input']>;
  account4Id?: InputMaybe<Scalars['UUID']['input']>;
  donorId?: InputMaybe<Scalars['UUID']['input']>;
  donorScheduleId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  oddEven1?: InputMaybe<Scalars['Int']['input']>;
  oddEven2?: InputMaybe<Scalars['Int']['input']>;
  oddEven3?: InputMaybe<Scalars['Int']['input']>;
  oddEven4?: InputMaybe<Scalars['Int']['input']>;
  partnershipBillingType?: InputMaybe<Scalars['Int']['input']>;
  partnershipId?: InputMaybe<Scalars['UUID']['input']>;
  percent1?: InputMaybe<Scalars['Decimal']['input']>;
  percent2?: InputMaybe<Scalars['Decimal']['input']>;
  percent3?: InputMaybe<Scalars['Decimal']['input']>;
  percent4?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  viewOnline1?: InputMaybe<Scalars['Boolean']['input']>;
  viewOnline2?: InputMaybe<Scalars['Boolean']['input']>;
  viewOnline3?: InputMaybe<Scalars['Boolean']['input']>;
  viewOnline4?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertPartnershipsPayload = {
  __typename: 'UpsertPartnershipsPayload';
  /** Similar to HTTP status code, represents the status of the mutation. */
  code: Scalars['Int']['output'];
  /** Human-readable message for the UI. */
  message: Maybe<Scalars['String']['output']>;
  /** The tog_partnershipBase table that contains the newly added partnership. */
  partnership: Maybe<Array<Partnership>>;
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output'];
};

export type UpsertReverseSortInput = {
  finalDeadRate: Scalars['Int']['input'];
  initialDeadRate: Scalars['Int']['input'];
  initialMobility: Scalars['Int']['input'];
  postSortMortality: Scalars['Int']['input'];
  purity: Scalars['Int']['input'];
  semenId: Scalars['UUID']['input'];
  splitScore: Scalars['Int']['input'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type Yard = {
  __typename: 'Yard';
  billboard: Maybe<Scalars['Int']['output']>;
  category: Maybe<Scalars['String']['output']>;
  center: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  herdsman: Maybe<Equipment>;
  herdsmanId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  searchYard: Maybe<Scalars['String']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  yard: Maybe<Scalars['String']['output']>;
};

export type YardFilterInput = {
  and?: InputMaybe<Array<YardFilterInput>>;
  billboard?: InputMaybe<IntOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  center?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  herdsman?: InputMaybe<EquipmentFilterInput>;
  herdsmanId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<YardFilterInput>>;
  searchYard?: InputMaybe<StringOperationFilterInput>;
  sequence?: InputMaybe<IntOperationFilterInput>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  yard?: InputMaybe<StringOperationFilterInput>;
};

export type YardInput = {
  billboard?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  center?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  herdsman?: InputMaybe<EquipmentInput>;
  herdsmanId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  searchYard?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<SiteInput>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  yard?: InputMaybe<Scalars['String']['input']>;
};

export type YardSortInput = {
  billboard?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  center?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  herdsman?: InputMaybe<EquipmentSortInput>;
  herdsmanId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  searchYard?: InputMaybe<SortEnumType>;
  sequence?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  yard?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type YardsCollectionSegment = {
  __typename: 'YardsCollectionSegment';
  /** A flattened list of the items. */
  items: Maybe<Array<Yard>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type incubators = {
  __typename: 'incubators';
  capacity: Maybe<Scalars['Int']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<SystemUser>;
  createdById: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<SystemUser>;
  createdOnBehalfById: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  inServiceDate: Maybe<Scalars['DateTime']['output']>;
  labName: Maybe<Scalars['String']['output']>;
  make: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<SystemUser>;
  modifiedById: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<SystemUser>;
  modifiedOnBehalfById: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  serial: Maybe<Scalars['String']['output']>;
  siteId: Maybe<Scalars['UUID']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  use: Maybe<Scalars['Int']['output']>;
};

export type incubatorsFilterInput = {
  and?: InputMaybe<Array<incubatorsFilterInput>>;
  capacity?: InputMaybe<IntOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<SystemUserFilterInput>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  createdOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  inServiceDate?: InputMaybe<DateTimeOperationFilterInput>;
  labName?: InputMaybe<StringOperationFilterInput>;
  make?: InputMaybe<StringOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<SystemUserFilterInput>;
  modifiedById?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserFilterInput>;
  modifiedOnBehalfById?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<incubatorsFilterInput>>;
  serial?: InputMaybe<StringOperationFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  use?: InputMaybe<IntOperationFilterInput>;
};

export type incubatorsInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<SystemUserInput>;
  createdById?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<SystemUserInput>;
  createdOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  inServiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  labName?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modifiedBy?: InputMaybe<SystemUserInput>;
  modifiedById?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserInput>;
  modifiedOnBehalfById?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  use?: InputMaybe<Scalars['Int']['input']>;
};

export type incubatorsSortInput = {
  capacity?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SystemUserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  createdOnBehalfById?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inServiceDate?: InputMaybe<SortEnumType>;
  labName?: InputMaybe<SortEnumType>;
  make?: InputMaybe<SortEnumType>;
  model?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SystemUserSortInput>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SystemUserSortInput>;
  modifiedOnBehalfById?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  serial?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  use?: InputMaybe<SortEnumType>;
};

export enum tog_category {
  BEEF = 'BEEF',
  CROSS = 'CROSS',
  DAIRY = 'DAIRY',
  DEER = 'DEER',
  EXOTIC = 'EXOTIC',
  MEAT = 'MEAT',
  PETS = 'PETS'
}

export type tog_chutesideqc = {
  __typename: 'tog_chutesideqc';
  aspirationDate: Maybe<Scalars['DateTime']['output']>;
  chuteNumber: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  location: Maybe<Scalars['String']['output']>;
  siteId: Maybe<Scalars['UUID']['output']>;
  tog_qc_brennerneedlelotno: Maybe<Scalars['String']['output']>;
  tog_qc_collectionroomtemp: Maybe<Scalars['String']['output']>;
  tog_qc_commentchuteside: Maybe<Scalars['String']['output']>;
  tog_qc_flowrate: Maybe<Scalars['String']['output']>;
  tog_qc_outsidetemp: Maybe<Scalars['String']['output']>;
  tog_qc_outsideweatherconditions: Maybe<Scalars['String']['output']>;
  tog_qc_pockettubewarmertemp: Maybe<Scalars['String']['output']>;
  tog_qc_pumppressure: Maybe<Scalars['String']['output']>;
  tog_qc_pumptubewarmertemp: Maybe<Scalars['String']['output']>;
};

export type tog_chutesideqcInput = {
  aspirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  chuteNumber?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  tog_qc_brennerneedlelotno?: InputMaybe<Scalars['String']['input']>;
  tog_qc_collectionroomtemp?: InputMaybe<Scalars['String']['input']>;
  tog_qc_commentchuteside?: InputMaybe<Scalars['String']['input']>;
  tog_qc_flowrate?: InputMaybe<Scalars['String']['input']>;
  tog_qc_outsidetemp?: InputMaybe<Scalars['String']['input']>;
  tog_qc_outsideweatherconditions?: InputMaybe<Scalars['String']['input']>;
  tog_qc_pockettubewarmertemp?: InputMaybe<Scalars['String']['input']>;
  tog_qc_pumppressure?: InputMaybe<Scalars['String']['input']>;
  tog_qc_pumptubewarmertemp?: InputMaybe<Scalars['String']['input']>;
};

export enum tog_contaminations {
  CONTAMINANT_PRESENT = 'CONTAMINANT_PRESENT'
}

export type tog_embryo_staging = {
  __typename: 'tog_embryo_staging';
  accountId: Maybe<Scalars['UUID']['output']>;
  calfType: Maybe<Scalars['Int']['output']>;
  discard: Maybe<Scalars['Boolean']['output']>;
  farmLocationId: Maybe<Scalars['UUID']['output']>;
  fertilizationDate: Maybe<Scalars['DateTime']['output']>;
  fertilizationId: Maybe<Scalars['UUID']['output']>;
  fertilizationName: Maybe<Scalars['String']['output']>;
  fertilizationSiteId: Maybe<Scalars['UUID']['output']>;
  freshShipmentId: Maybe<Scalars['UUID']['output']>;
  froze: Maybe<Scalars['Boolean']['output']>;
  grade: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  loadDate: Maybe<Scalars['Int']['output']>;
  recip: Maybe<Scalars['String']['output']>;
  stage: Maybe<Scalars['Int']['output']>;
  strawNumber: Maybe<Scalars['Int']['output']>;
  transferDate: Maybe<Scalars['DateTime']['output']>;
  transferSiteId: Maybe<Scalars['UUID']['output']>;
};

export type tog_embryo_stagingFilterInput = {
  accountId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<tog_embryo_stagingFilterInput>>;
  calfType?: InputMaybe<IntOperationFilterInput>;
  discard?: InputMaybe<BooleanOperationFilterInput>;
  farmLocationId?: InputMaybe<UuidOperationFilterInput>;
  fertilizationDate?: InputMaybe<DateTimeOperationFilterInput>;
  fertilizationId?: InputMaybe<UuidOperationFilterInput>;
  fertilizationName?: InputMaybe<StringOperationFilterInput>;
  fertilizationSiteId?: InputMaybe<UuidOperationFilterInput>;
  freshShipmentId?: InputMaybe<UuidOperationFilterInput>;
  froze?: InputMaybe<BooleanOperationFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  loadDate?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<tog_embryo_stagingFilterInput>>;
  recip?: InputMaybe<StringOperationFilterInput>;
  stage?: InputMaybe<IntOperationFilterInput>;
  strawNumber?: InputMaybe<IntOperationFilterInput>;
  transferDate?: InputMaybe<DateTimeOperationFilterInput>;
  transferSiteId?: InputMaybe<UuidOperationFilterInput>;
};

export type tog_embryo_stagingSortInput = {
  accountId?: InputMaybe<SortEnumType>;
  calfType?: InputMaybe<SortEnumType>;
  discard?: InputMaybe<SortEnumType>;
  farmLocationId?: InputMaybe<SortEnumType>;
  fertilizationDate?: InputMaybe<SortEnumType>;
  fertilizationId?: InputMaybe<SortEnumType>;
  fertilizationName?: InputMaybe<SortEnumType>;
  fertilizationSiteId?: InputMaybe<SortEnumType>;
  freshShipmentId?: InputMaybe<SortEnumType>;
  froze?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  loadDate?: InputMaybe<SortEnumType>;
  recip?: InputMaybe<SortEnumType>;
  stage?: InputMaybe<SortEnumType>;
  strawNumber?: InputMaybe<SortEnumType>;
  transferDate?: InputMaybe<SortEnumType>;
  transferSiteId?: InputMaybe<SortEnumType>;
};

export enum tog_fertplan {
  DID_NOT_ASPIRATE = 'DID_NOT_ASPIRATE',
  DO_NOT_FERT = 'DO_NOT_FERT',
  FERT = 'FERT',
  POOL = 'POOL'
}

export type tog_freshshipmentBase = {
  __typename: 'tog_freshshipmentBase';
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  address3: Maybe<Scalars['String']['output']>;
  addressName: Maybe<Scalars['String']['output']>;
  aspDate: Maybe<Scalars['DateTime']['output']>;
  callTagComment: Maybe<Scalars['String']['output']>;
  callTagContactId: Maybe<Scalars['UUID']['output']>;
  city: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  companyId: Maybe<Scalars['UUID']['output']>;
  contactId: Maybe<Scalars['UUID']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdOn: Maybe<Scalars['DateTime']['output']>;
  createdOnBehalfBy: Maybe<Scalars['UUID']['output']>;
  ctAddress1: Maybe<Scalars['String']['output']>;
  ctAddress2: Maybe<Scalars['String']['output']>;
  ctAddress3: Maybe<Scalars['String']['output']>;
  ctAddressName: Maybe<Scalars['String']['output']>;
  ctCity: Maybe<Scalars['String']['output']>;
  ctState: Maybe<Scalars['String']['output']>;
  ctZip: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  freshShipCreationId: Maybe<Scalars['UUID']['output']>;
  freshShipmentNumber: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  importSequenceNumber: Maybe<Scalars['Int']['output']>;
  incRental: Maybe<Scalars['Boolean']['output']>;
  incShipping: Maybe<Scalars['Boolean']['output']>;
  incubator: Maybe<Scalars['String']['output']>;
  matings: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<Scalars['UUID']['output']>;
  modifiedOn: Maybe<Scalars['DateTime']['output']>;
  modifiedOnBehalfBy: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  overriddenCreatedOn: Maybe<Scalars['DateTime']['output']>;
  packFee: Maybe<Scalars['Boolean']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  shipComment: Maybe<Scalars['String']['output']>;
  shipFrom: Maybe<Scalars['UUID']['output']>;
  shipmentGroup: Maybe<Scalars['String']['output']>;
  shipmentGroupId: Maybe<Scalars['UUID']['output']>;
  shipperId: Maybe<Scalars['String']['output']>;
  shippingMethod: Maybe<Scalars['Int']['output']>;
  signOffDate: Maybe<Scalars['DateTime']['output']>;
  signOffUser: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  trackingNumber: Maybe<Scalars['String']['output']>;
  verified: Maybe<Scalars['Boolean']['output']>;
  versionNumber: Maybe<Array<Scalars['UnsignedByte']['output']>>;
  zip: Maybe<Scalars['String']['output']>;
};

export type tog_freshshipmentBaseFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  address3?: InputMaybe<StringOperationFilterInput>;
  addressName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<tog_freshshipmentBaseFilterInput>>;
  aspDate?: InputMaybe<DateTimeOperationFilterInput>;
  callTagComment?: InputMaybe<StringOperationFilterInput>;
  callTagContactId?: InputMaybe<UuidOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<UuidOperationFilterInput>;
  contactId?: InputMaybe<UuidOperationFilterInput>;
  createdBy?: InputMaybe<UuidOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  createdOnBehalfBy?: InputMaybe<UuidOperationFilterInput>;
  ctAddress1?: InputMaybe<StringOperationFilterInput>;
  ctAddress2?: InputMaybe<StringOperationFilterInput>;
  ctAddress3?: InputMaybe<StringOperationFilterInput>;
  ctAddressName?: InputMaybe<StringOperationFilterInput>;
  ctCity?: InputMaybe<StringOperationFilterInput>;
  ctState?: InputMaybe<StringOperationFilterInput>;
  ctZip?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  freshShipCreationId?: InputMaybe<UuidOperationFilterInput>;
  freshShipmentNumber?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  importSequenceNumber?: InputMaybe<IntOperationFilterInput>;
  incRental?: InputMaybe<BooleanOperationFilterInput>;
  incShipping?: InputMaybe<BooleanOperationFilterInput>;
  incubator?: InputMaybe<StringOperationFilterInput>;
  matings?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<UuidOperationFilterInput>;
  modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedOnBehalfBy?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<tog_freshshipmentBaseFilterInput>>;
  overriddenCreatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  packFee?: InputMaybe<BooleanOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  shipComment?: InputMaybe<StringOperationFilterInput>;
  shipFrom?: InputMaybe<UuidOperationFilterInput>;
  shipmentGroup?: InputMaybe<StringOperationFilterInput>;
  shipmentGroupId?: InputMaybe<UuidOperationFilterInput>;
  shipperId?: InputMaybe<StringOperationFilterInput>;
  shippingMethod?: InputMaybe<IntOperationFilterInput>;
  signOffDate?: InputMaybe<DateTimeOperationFilterInput>;
  signOffUser?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  stateCode?: InputMaybe<IntOperationFilterInput>;
  statusCode?: InputMaybe<IntOperationFilterInput>;
  trackingNumber?: InputMaybe<StringOperationFilterInput>;
  verified?: InputMaybe<BooleanOperationFilterInput>;
  versionNumber?: InputMaybe<ListUnsignedByteOperationFilterInput>;
  zip?: InputMaybe<StringOperationFilterInput>;
};

export type tog_freshshipmentBaseInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  aspDate?: InputMaybe<Scalars['DateTime']['input']>;
  callTagComment?: InputMaybe<Scalars['String']['input']>;
  callTagContactId?: InputMaybe<Scalars['UUID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOnBehalfBy?: InputMaybe<Scalars['UUID']['input']>;
  ctAddress1?: InputMaybe<Scalars['String']['input']>;
  ctAddress2?: InputMaybe<Scalars['String']['input']>;
  ctAddress3?: InputMaybe<Scalars['String']['input']>;
  ctAddressName?: InputMaybe<Scalars['String']['input']>;
  ctCity?: InputMaybe<Scalars['String']['input']>;
  ctState?: InputMaybe<Scalars['String']['input']>;
  ctZip?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  freshShipCreationId?: InputMaybe<Scalars['UUID']['input']>;
  freshShipmentNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  importSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  incRental?: InputMaybe<Scalars['Boolean']['input']>;
  incShipping?: InputMaybe<Scalars['Boolean']['input']>;
  incubator?: InputMaybe<Scalars['String']['input']>;
  matings?: InputMaybe<Scalars['Int']['input']>;
  modifiedBy?: InputMaybe<Scalars['UUID']['input']>;
  modifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedOnBehalfBy?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overriddenCreatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  packFee?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  shipComment?: InputMaybe<Scalars['String']['input']>;
  shipFrom?: InputMaybe<Scalars['UUID']['input']>;
  shipmentGroup?: InputMaybe<Scalars['String']['input']>;
  shipmentGroupId?: InputMaybe<Scalars['UUID']['input']>;
  shipperId?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<Scalars['Int']['input']>;
  signOffDate?: InputMaybe<Scalars['DateTime']['input']>;
  signOffUser?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['Int']['input'];
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  versionNumber?: InputMaybe<Array<Scalars['UnsignedByte']['input']>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type tog_freshshipmentBaseSortInput = {
  address1?: InputMaybe<SortEnumType>;
  address2?: InputMaybe<SortEnumType>;
  address3?: InputMaybe<SortEnumType>;
  addressName?: InputMaybe<SortEnumType>;
  aspDate?: InputMaybe<SortEnumType>;
  callTagComment?: InputMaybe<SortEnumType>;
  callTagContactId?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  companyId?: InputMaybe<SortEnumType>;
  contactId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  createdOnBehalfBy?: InputMaybe<SortEnumType>;
  ctAddress1?: InputMaybe<SortEnumType>;
  ctAddress2?: InputMaybe<SortEnumType>;
  ctAddress3?: InputMaybe<SortEnumType>;
  ctAddressName?: InputMaybe<SortEnumType>;
  ctCity?: InputMaybe<SortEnumType>;
  ctState?: InputMaybe<SortEnumType>;
  ctZip?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  freshShipCreationId?: InputMaybe<SortEnumType>;
  freshShipmentNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importSequenceNumber?: InputMaybe<SortEnumType>;
  incRental?: InputMaybe<SortEnumType>;
  incShipping?: InputMaybe<SortEnumType>;
  incubator?: InputMaybe<SortEnumType>;
  matings?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifiedOnBehalfBy?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  overriddenCreatedOn?: InputMaybe<SortEnumType>;
  packFee?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  shipComment?: InputMaybe<SortEnumType>;
  shipFrom?: InputMaybe<SortEnumType>;
  shipmentGroup?: InputMaybe<SortEnumType>;
  shipmentGroupId?: InputMaybe<SortEnumType>;
  shipperId?: InputMaybe<SortEnumType>;
  shippingMethod?: InputMaybe<SortEnumType>;
  signOffDate?: InputMaybe<SortEnumType>;
  signOffUser?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  statusCode?: InputMaybe<SortEnumType>;
  trackingNumber?: InputMaybe<SortEnumType>;
  verified?: InputMaybe<SortEnumType>;
  zip?: InputMaybe<SortEnumType>;
};

export enum tog_noembryosproduced {
  NO_EMBRYOS_PRODUCED = 'NO_EMBRYOS_PRODUCED'
}

export enum tog_subfamily {
  BOVINE = 'BOVINE',
  CANINE = 'CANINE',
  CAPRINE = 'CAPRINE',
  CERVIDAE = 'CERVIDAE',
  EQUINE = 'EQUINE',
  FELINE = 'FELINE',
  OVINE = 'OVINE',
  PORCINE = 'PORCINE'
}

export type CHANGE_CONNECTIONMutationVariables = Exact<{
  environmentId: Scalars['Int']['input'];
  b2c: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CHANGE_CONNECTIONMutation = { __typename: 'Mutation', changeConnection: number };

export type GET_ALL_CONNECTIONSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_ALL_CONNECTIONSQuery = { __typename: 'Query', allConnections: Array<{ __typename: 'Connection', overrideEnvironmentId: number, connectionType: string, countryName: string, languageCode: string, countryCode: string, connectionStringKey: string, crmUrl: string }> };

export type SEARCH_ACCOUNTS_MULTISELECTQueryVariables = Exact<{
  where: AccountFilterInput;
  take: Scalars['Int']['input'];
}>;


export type SEARCH_ACCOUNTS_MULTISELECTQuery = { __typename: 'Query', accounts: { __typename: 'AccountsCollectionSegment', items: Array<{ __typename: 'Account', id: string, code: string | null, name: string | null, customerServiceRepresentativeId: string | null, primaryTextingNumber: string | null, priceTier: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null, customerServiceRepresentative: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type SEARCH_ACCOUNTS_AUTOCOMPLETEQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: Scalars['Int']['input'];
}>;


export type SEARCH_ACCOUNTS_AUTOCOMPLETEQuery = { __typename: 'Query', accounts: { __typename: 'AccountsCollectionSegment', items: Array<{ __typename: 'Account', id: string, code: string | null, name: string | null, customerServiceRepresentativeId: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null, priceTier: number | null, primaryTextingNumber: string | null, customerServiceRepresentative: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type GET_ACCOUNT_BY_DATE_AND_SITEQueryVariables = Exact<{
  fertilizationDate: Scalars['DateTime']['input'];
  transferDate: Scalars['DateTime']['input'];
  fertilizationSite: Scalars['UUID']['input'];
  transferSite: Scalars['UUID']['input'];
}>;


export type GET_ACCOUNT_BY_DATE_AND_SITEQuery = { __typename: 'Query', accountByDateAndSite: Array<{ __typename: 'AccountDto', accountId: string, accountCode: string, accountName: string }> };

export type SEARCH_DONORSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<DonorSortInput> | DonorSortInput>;
  where: InputMaybe<DonorFilterInput>;
}>;


export type SEARCH_DONORSQuery = { __typename: 'Query', donors: { __typename: 'DonorsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Donor', id: string, name: string | null, breedId: string | null, ownerId: string | null, registrationNumber: string | null, tattoo: string | null, metalTag: string | null, received: string | null, pregnant: number | null, pooledDonorId: string | null, yardId: string | null, exportDonor: number | null, ranchTag: string | null, ship: string | null, lastActivity: string | null, activityDate: string | null, createdOn: string | null, birth: string | null, programName: string | null, breed: { __typename: 'Breed', code: string | null, subFamily: tog_subfamily | null } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null, priceTier: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null, customerServiceRepresentative: { __typename: 'SystemUser', id: string, fullName: string | null } | null } | null, yard: { __typename: 'Yard', name: string | null } | null }> | null } | null };

export type SEARCH_SEMEN_LOOKUPQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<SemenSortInput> | SemenSortInput>;
  where: InputMaybe<SemenFilterInput>;
}>;


export type SEARCH_SEMEN_LOOKUPQuery = { __typename: 'Query', semen: { __typename: 'SemenCollectionSegment', totalCount: number, items: Array<{ __typename: 'Semen', id: string, name: string | null, naab: string | null, quantity: number | null, quantityRec: number | null, storageLocationId: string | null, cane: string | null, colCode: string | null, sexed: boolean | null, sex: number | null, concentration: number | null, cost: number | null, semenType: string | null, dateReceived: string | null, export: number | null, cssCertified: number | null, soldTo: string | null, secondaryOwner: string | null, ownerId: string | null, comment: string | null, totalEmbryoDevelopmentRate: number | null, qualityEmbryoDevelopmentRate: number | null, storageLocation: { __typename: 'StorageLocation', siteId: string | null, id: string, name: string | null, site: { __typename: 'Site', name: string } | null } | null, sire: { __typename: 'Sire', id: string, name: string | null, cane: string | null, breedId: string | null, breedReg: string | null, registrationNumber: string | null, regPrefix: string | null, birth: string | null, heparin: number | null, breed: { __typename: 'Breed', subFamily: tog_subfamily | null } | null } | null, shipment: { __typename: 'Shipment', shipName: string | null, needByDate: string | null } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null } | null }> | null } | null };

export type UPDATE_SIREMutationVariables = Exact<{
  input: UpdateSireInput;
}>;


export type UPDATE_SIREMutation = { __typename: 'Mutation', updateSire: { __typename: 'SirePayload', code: number, success: boolean, message: string | null, sire: { __typename: 'Sire', id: string, name: string | null } | null } };

export type SEARCH_SIRESQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<SireSortInput> | SireSortInput>;
  where: InputMaybe<SireFilterInput>;
}>;


export type SEARCH_SIRESQuery = { __typename: 'Query', sires: { __typename: 'SiresCollectionSegment', totalCount: number, items: Array<{ __typename: 'Sire', id: string, name: string | null, birth: string | null, breedId: string | null, breedReg: string | null, cane: string | null, clientShortName: string | null, countryCodeId: string | null, createdById: string | null, createdOn: string | null, edonorId: string | null, heparin: number | null, modifiedById: string | null, modifiedOn: string | null, ownerId: string | null, regPrefix: string | null, registrationNumber: string | null, regtog: number | null, sexedCane: string | null, sire: string | null, sireCm: number | null, sireJpi: number | null, sireNm: number | null, sireTpi: number | null, stateCode: number, status: string | null, statusCode: number | null, yardId: string | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null } | null, yard: { __typename: 'Yard', id: string, name: string | null } | null }> | null } | null };

export type BreedFieldsFragment = { __typename: 'Breed', id: string, code: string | null, name: string | null, frameSize: number | null, type: number | null };

export type GET_BREEDSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_BREEDSQuery = { __typename: 'Query', breeds: { __typename: 'BreedsCollectionSegment', items: Array<{ __typename: 'Breed', id: string, code: string | null, name: string | null, frameSize: number | null, type: number | null }> | null } | null };

export type GET_CONTACTSQueryVariables = Exact<{
  where: InputMaybe<ContactFilterInput>;
}>;


export type GET_CONTACTSQuery = { __typename: 'Query', contacts: { __typename: 'ContactsCollectionSegment', items: Array<{ __typename: 'Contact', id: string, fullName: string | null }> | null } | null };

export type SEARCH_CONTACTS_AUTOCOMPLETEQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: Scalars['Int']['input'];
}>;


export type SEARCH_CONTACTS_AUTOCOMPLETEQuery = { __typename: 'Query', contacts: { __typename: 'ContactsCollectionSegment', items: Array<{ __typename: 'Contact', id: string, fullName: string | null, firstName: string | null, lastName: string | null, emailAddress1: string | null, company: string | null }> | null } | null };

export type SEARCH_SYSTEM_USERS_AUTOCOMPLETEQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_SYSTEM_USERS_AUTOCOMPLETEQuery = { __typename: 'Query', results: { __typename: 'SystemUsersCollectionSegment', totalCount: number, items: Array<{ __typename: 'SystemUser', id: string, fullName: string | null, internalEmailAddress: string | null }> | null } | null };

export type ADD_VIEWMutationVariables = Exact<{
  input: AddViewInput;
}>;


export type ADD_VIEWMutation = { __typename: 'Mutation', addView: { __typename: 'MutationResponse', success: boolean, message: string | null } };

export type UPDATE_VIEWMutationVariables = Exact<{
  input: UpdateViewInput;
}>;


export type UPDATE_VIEWMutation = { __typename: 'Mutation', updateView: { __typename: 'MutationResponse', success: boolean, message: string | null } };

export type REMOVE_VIEWMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type REMOVE_VIEWMutation = { __typename: 'Mutation', removeView: { __typename: 'MutationResponse', success: boolean, message: string | null } };

export type SET_DEFAULT_VIEWMutationVariables = Exact<{
  input: SetDefaultViewInput;
}>;


export type SET_DEFAULT_VIEWMutation = { __typename: 'Mutation', setDefaultView: { __typename: 'MutationResponse', success: boolean, message: string | null } };

export type GET_VIEW_NAMESQueryVariables = Exact<{
  username: Scalars['String']['input'];
  usage: Scalars['String']['input'];
  app: Scalars['String']['input'];
}>;


export type GET_VIEW_NAMESQuery = { __typename: 'Query', viewNames: Array<{ __typename: 'NucleusCustomViews', id: string, username: string, name: string, view: string, usage: string, isDefault: boolean, app: string | null }> };

export type GET_VIEW_BY_IDQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GET_VIEW_BY_IDQuery = { __typename: 'Query', viewById: { __typename: 'NucleusCustomViews', id: string, username: string, name: string, view: string, usage: string, isDefault: boolean, app: string | null } | null };

export type SEARCH_ALL_DONORS_AUTOCOMPLETEQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: Scalars['Int']['input'];
}>;


export type SEARCH_ALL_DONORS_AUTOCOMPLETEQuery = { __typename: 'Query', donors: { __typename: 'DonorsCollectionSegment', items: Array<{ __typename: 'Donor', id: string, name: string | null, breedId: string | null, ownerId: string | null, registrationNumber: string | null, tattoo: string | null, metalTag: string | null, received: string | null, pregnant: number | null, pooledDonorId: string | null, yardId: string | null, ranchTag: string | null, ship: string | null, lastActivity: string | null, activityDate: string | null, createdOn: string | null, birth: string | null, breed: { __typename: 'Breed', code: string | null } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null, customerServiceRepresentative: { __typename: 'SystemUser', id: string, fullName: string | null } | null } | null, yard: { __typename: 'Yard', name: string | null } | null }> | null } | null };

export type SEARCH_DONORS_BY_OWNER_ID_AUTOCOMPLETEQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: Scalars['Int']['input'];
  ownerId: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SEARCH_DONORS_BY_OWNER_ID_AUTOCOMPLETEQuery = { __typename: 'Query', donors: { __typename: 'DonorsCollectionSegment', items: Array<{ __typename: 'Donor', id: string, name: string | null, ownerId: string | null, owner: { __typename: 'Account', code: string | null, customerServiceRepresentative: { __typename: 'SystemUser', id: string, fullName: string | null } | null } | null }> | null } | null };

export type SEARCH_DRUGSQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_DRUGSQuery = { __typename: 'Query', drugs: { __typename: 'DrugsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Drug', id: string, name: string | null, searchName: string | null, lot: string | null, comp: string | null, pricePerBottle: number | null, pricePerCc: number | null }> | null } | null };

export type SEARCH_ASPIRATION_SITESQueryVariables = Exact<{
  where: InputMaybe<LocationFilterInput>;
}>;


export type SEARCH_ASPIRATION_SITESQuery = { __typename: 'Query', locations: { __typename: 'LocationsCollectionSegment', items: Array<{ __typename: 'Location', id: string, name: string | null, fertilizationSiteId: string | null, site: { __typename: 'Site', id: string, name: string } | null, fertilizationSite: { __typename: 'Site', id: string, name: string } | null }> | null } | null };

export type GET_EQUIPMENT_SEARCH_BY_SITEQueryVariables = Exact<{
  siteId: Scalars['UUID']['input'];
  searchTerm: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_EQUIPMENT_SEARCH_BY_SITEQuery = { __typename: 'Query', equipments: { __typename: 'EquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', id: string, name: string }> | null } | null };

export type SEARCH_FERTILIZATION_SITES_DROPDOWNQueryVariables = Exact<{
  where: InputMaybe<LocationFilterInput>;
}>;


export type SEARCH_FERTILIZATION_SITES_DROPDOWNQuery = { __typename: 'Query', locations: { __typename: 'LocationsCollectionSegment', items: Array<{ __typename: 'Location', id: string, name: string | null, fertilizationSite: { __typename: 'Site', id: string, name: string } | null }> | null } | null };

export type CREATE_NEW_DONORMutationVariables = Exact<{
  input: CreateNewDonorInput;
}>;


export type CREATE_NEW_DONORMutation = { __typename: 'Mutation', createNewDonor: { __typename: 'DonorPayload', code: number, message: string | null, success: boolean, donor: { __typename: 'Donor', id: string } | null } };

export type CREATE_NEW_SIREMutationVariables = Exact<{
  input: CreateNewSireInput;
}>;


export type CREATE_NEW_SIREMutation = { __typename: 'Mutation', createNewSire: { __typename: 'SirePayload', code: number, message: string | null, success: boolean, sire: { __typename: 'Sire', id: string } | null } };

export type GET_OPTION_SETS_BY_NAMEQueryVariables = Exact<{
  name: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_OPTION_SETS_BY_NAMEQuery = { __typename: 'Query', optionSets: { __typename: 'OptionSetsCollectionSegment', totalCount: number, items: Array<{ __typename: 'OptionSet', id: string, label: string | null, description: string | null }> | null } | null };

export type GET_RECIPIENTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  where: InputMaybe<RecipientFilterInput>;
}>;


export type GET_RECIPIENTSQuery = { __typename: 'Query', recipients: { __typename: 'RecipientsCollectionSegment', items: Array<{ __typename: 'Recipient', id: string, tag: string | null }> | null } | null };

export type SEARCH_SCHEDULE_MASTERQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_SCHEDULE_MASTERQuery = { __typename: 'Query', scheduleMaster: { __typename: 'ScheduleMasterCollectionSegment', totalCount: number, items: Array<{ __typename: 'ScheduleMaster', id: string, name: string | null, method: number | null, twiceConcentration: boolean | null }> | null } | null };

export type SEARCH_SEMENQueryVariables = Exact<{
  where: InputMaybe<SemenFilterInput>;
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_SEMENQuery = { __typename: 'Query', semen: { __typename: 'SemenCollectionSegment', items: Array<{ __typename: 'Semen', id: string, name: string | null, naab: string | null, quantity: number | null, storageLocationId: string | null, cane: string | null, colCode: string | null, export: number | null, sexed: boolean | null, sex: number | null, concentration: number | null, cost: number | null, semenType: string | null, dateReceived: string | null, soldTo: string | null, ownerId: string | null, totalEmbryoDevelopmentRate: number | null, qualityEmbryoDevelopmentRate: number | null, storageLocation: { __typename: 'StorageLocation', id: string, name: string | null, siteId: string | null, site: { __typename: 'Site', name: string } | null } | null, sire: { __typename: 'Sire', id: string, name: string | null, cane: string | null } | null, owner: { __typename: 'Account', id: string, code: string | null } | null }> | null } | null };

export type SearchSemenByAccountFragment = { __typename: 'Semen', id: string, name: string | null, cane: string | null, colCode: string | null, naab: string | null, semenType: string | null, sire: { __typename: 'Sire', id: string, name: string | null, registrationNumber: string | null, cane: string | null, breed: { __typename: 'Breed', id: string, code: string | null, name: string | null } | null } | null, storageLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null };

export type SEARCH_SEMEN_BY_ACCOUNTQueryVariables = Exact<{
  fertilizationSiteId: Scalars['UUID']['input'];
  accountCode: Scalars['String']['input'];
  search: Scalars['String']['input'];
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_SEMEN_BY_ACCOUNTQuery = { __typename: 'Query', semen: { __typename: 'SemenCollectionSegment', items: Array<{ __typename: 'Semen', id: string, name: string | null, cane: string | null, colCode: string | null, naab: string | null, semenType: string | null, sire: { __typename: 'Sire', id: string, name: string | null, registrationNumber: string | null, cane: string | null, breed: { __typename: 'Breed', id: string, code: string | null, name: string | null } | null } | null, storageLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null }> | null } | null };

export type SEARCH_SHIPMENTS_AUTOCOMPLETEQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: Scalars['Int']['input'];
}>;


export type SEARCH_SHIPMENTS_AUTOCOMPLETEQuery = { __typename: 'Query', shipments: { __typename: 'ShipmentsCollectionSegment', items: Array<{ __typename: 'Shipment', id: string, shipmentNumber: string | null, shipName: string | null, trackingNumber: string | null, date: string | null, shipFromSite: { __typename: 'Site', id: string, name: string } | null }> | null } | null };

export type SEARCH_SHIPMENT_GROUPSQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: Scalars['Int']['input'];
}>;


export type SEARCH_SHIPMENT_GROUPSQuery = { __typename: 'Query', shipmentGroups: { __typename: 'ShipmentGroupsCollectionSegment', totalCount: number, items: Array<{ __typename: 'ShipmentGroup', id: string, name: string | null, estimations: number | null }> | null } | null };

export type SEARCH_SIRES_LOOKUPQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_SIRES_LOOKUPQuery = { __typename: 'Query', sires: { __typename: 'SiresCollectionSegment', totalCount: number, items: Array<{ __typename: 'Sire', id: string, name: string | null, birth: string | null, breedId: string | null, breedReg: string | null, cane: string | null, clientShortName: string | null, countryCodeId: string | null, createdById: string | null, createdOn: string | null, edonorId: string | null, heparin: number | null, modifiedById: string | null, modifiedOn: string | null, ownerId: string | null, regPrefix: string | null, registrationNumber: string | null, regtog: number | null, sexedCane: string | null, sire: string | null, sireCm: number | null, sireJpi: number | null, sireNm: number | null, sireTpi: number | null, stateCode: number, status: string | null, statusCode: number | null, yardId: string | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null } | null, yard: { __typename: 'Yard', id: string, name: string | null } | null }> | null } | null };

export type GET_SITESQueryVariables = Exact<{
  where: InputMaybe<SiteFilterInput>;
}>;


export type GET_SITESQuery = { __typename: 'Query', sites: { __typename: 'SitesCollectionSegment', items: Array<{ __typename: 'Site', id: string, name: string }> | null } | null };

export type GET_SITES_SEARCH_MULTISELECTQueryVariables = Exact<{
  where: SiteFilterInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GET_SITES_SEARCH_MULTISELECTQuery = { __typename: 'Query', sites: { __typename: 'SitesCollectionSegment', items: Array<{ __typename: 'Site', id: string, name: string }> | null } | null };

export type GET_SITES_SEARCHQueryVariables = Exact<{
  searchTerm: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GET_SITES_SEARCHQuery = { __typename: 'Query', sites: { __typename: 'SitesCollectionSegment', items: Array<{ __typename: 'Site', id: string, name: string }> | null } | null };

export type GET_STORAGE_LOCATIONSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<StorageLocationSortInput> | StorageLocationSortInput>;
  where: InputMaybe<StorageLocationFilterInput>;
}>;


export type GET_STORAGE_LOCATIONSQuery = { __typename: 'Query', storageLocations: { __typename: 'StorageLocationsCollectionSegment', totalCount: number, items: Array<{ __typename: 'StorageLocation', id: string, name: string | null, siteId: string | null, stateCode: number }> | null } | null };

export type GET_EQUIPMENT_BY_IDQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GET_EQUIPMENT_BY_IDQuery = { __typename: 'Query', equipments: { __typename: 'EquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', id: string, name: string }> | null } | null };

export type RUN_WORKFLOWMutationVariables = Exact<{
  entityIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  workflowId: Scalars['UUID']['input'];
}>;


export type RUN_WORKFLOWMutation = { __typename: 'Mutation', runWorkflow: boolean };

export type RUN_OLD_WORKFLOWMutationVariables = Exact<{
  entityIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  workflowId: Scalars['UUID']['input'];
}>;


export type RUN_OLD_WORKFLOWMutation = { __typename: 'Mutation', runOldWorkflow: boolean };

export type GET_YARDS_MULTISELECTQueryVariables = Exact<{
  where: InputMaybe<YardFilterInput>;
}>;


export type GET_YARDS_MULTISELECTQuery = { __typename: 'Query', yards: { __typename: 'YardsCollectionSegment', items: Array<{ __typename: 'Yard', id: string, name: string | null }> | null } | null };

export type GET_YARDSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_YARDSQuery = { __typename: 'Query', yards: { __typename: 'YardsCollectionSegment', items: Array<{ __typename: 'Yard', id: string, name: string | null, yard: string | null }> | null } | null };

export type SEARCH_YARDSQueryVariables = Exact<{
  search: Scalars['String']['input'];
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_YARDSQuery = { __typename: 'Query', yards: { __typename: 'YardsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Yard', id: string, name: string | null }> | null } | null };

export type ADD_NUCLEUS_ERROR_LOGMutationVariables = Exact<{
  errorLog: NucleusErrorLogsInput;
}>;


export type ADD_NUCLEUS_ERROR_LOGMutation = { __typename: 'Mutation', addNucleusErrorLog: { __typename: 'NucleusErrorLogPayload', code: number, success: boolean, message: string | null, nucleusErrorLogs: Array<{ __typename: 'NucleusErrorLogs', id: number }> | null } };

export type GET_NUCLEUS_ERROR_LOGSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_NUCLEUS_ERROR_LOGSQuery = { __typename: 'Query', getNucleusErrorLogs: { __typename: 'GetNucleusErrorLogsCollectionSegment', items: Array<{ __typename: 'NucleusErrorLogs', id: number, username: string | null, asUserId: string, location: string | null, userAgent: string | null, timestamp: string, errorInfo: string | null, errorMessage: string | null, errorStack: string | null, errorName: string | null }> | null } | null };

export type LOGINMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LOGINMutation = { __typename: 'Mutation', login: boolean };

export type LOGOUTMutationVariables = Exact<{ [key: string]: never; }>;


export type LOGOUTMutation = { __typename: 'Mutation', logout: boolean };

export type UPDATE_ASPIRATION_CHUTESIDEMutationVariables = Exact<{
  input: AspirationDataEntryInput;
  isReturn: Scalars['String']['input'];
}>;


export type UPDATE_ASPIRATION_CHUTESIDEMutation = { __typename: 'Mutation', updateAspirationChuteside: { __typename: 'AspirationPayload', code: number, success: boolean, message: string } };

export type UPDATE_QC_DATA_CHUTESIDEMutationVariables = Exact<{
  input: QcDataChutesideInput;
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  location: Scalars['String']['input'];
}>;


export type UPDATE_QC_DATA_CHUTESIDEMutation = { __typename: 'Mutation', updateQCDataChuteside: boolean };

export type ADD_PREGNANT_STATUSMutationVariables = Exact<{
  pregnantValue: Scalars['Int']['input'];
  donorId: Scalars['String']['input'];
  opuTechId: Scalars['String']['input'];
  chuteTechId: Scalars['String']['input'];
}>;


export type ADD_PREGNANT_STATUSMutation = { __typename: 'Mutation', addPregnantStatus: string };

export type UPDATE_ASPIRATION_QC_DATA_CHUTESIDEMutationVariables = Exact<{
  input: tog_chutesideqcInput;
}>;


export type UPDATE_ASPIRATION_QC_DATA_CHUTESIDEMutation = { __typename: 'Mutation', updateAspirationQcDataChuteside: boolean };

export type UPDATE_DONOR_LAST_BRED_DATEMutationVariables = Exact<{
  donorId: Scalars['UUID']['input'];
  lastBredDate: Scalars['DateTime']['input'];
}>;


export type UPDATE_DONOR_LAST_BRED_DATEMutation = { __typename: 'Mutation', updateDonorLastBredDate: boolean };

export type GET_TODAYS_ASPIRATIONSQueryVariables = Exact<{
  date: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  vetId: InputMaybe<Scalars['String']['input']>;
  techId: InputMaybe<Scalars['String']['input']>;
  type: Scalars['Int']['input'];
  location: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_TODAYS_ASPIRATIONSQuery = { __typename: 'Query', todaysAspirations: Array<{ __typename: 'AspirationsToday', aspirationId: string | null, opuNum: string | null, aspirationTime: string | null, account: string | null, csa: string | null, breed: string | null, donor: string | null, donorName: string | null, donorRegNum: string | null, sire: string | null, semenType: string | null, donorLocation: string | null, fertSite: string | null, pooled: string | null, nonEuComment: string | null, export: string | null, medTotal: string | null, totalOocytes: string | null, numInMat: string | null, csr: string | null, matTime: string | null, aspComments: string | null, poolNum: string | null, dsAspirationComment: string | null, weight: string | null, vetId: string | null, asstId: string | null, siteId: string | null, ivmId: string | null, ivmTech: string | null, ivmMat: number | null, ivmTime: string | null, aspirationDate: string | null, scheduleId: string | null, nextSchedule: string | null, nextScheduleId: string | null, totalFollicles: string | null, ll: number | null, lm: number | null, ls: number | null, rl: number | null, rm: number | null, rs: number | null, cll: number | null, cystl: number | null, clr: number | null, cystr: number | null, comment: string | null, donorCondition: string | null, donorId: string | null, completeOrder: number | null, pregnant: string | null, embCompleteOrder: number | null, opuTech: string | null, chuteTech: string | null, totalLeft: number | null, totalRight: number | null, fertPlan: number | null, accountName: string | null, location: string | null, chuteNumber: number | null, programName: string | null }> };

export type GET_ASPIRATION_BY_DONOR_DATE_SITEQueryVariables = Exact<{
  donorId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
}>;


export type GET_ASPIRATION_BY_DONOR_DATE_SITEQuery = { __typename: 'Query', aspirationByDonorDateSite: Array<{ __typename: 'TOG_GetAspirationByDonorDateSite', rowNum: any | null, aspirationTime: string | null, account: string | null, donor: string | null, sire: string | null, semenType: string | null, donorLocation: string | null, medTotal: string | null, totalOocytes: number | null, numInMat: number | null, matTime: string | null, csr: string | null, aspComments: string | null, pooled: string | null, breed: string | null, export: string | null, poolNum: number | null, csa: string | null, donorName: string | null, dsAspirationComment: string | null, earTag: string | null, opuid: string | null, donorId: string | null, sched: string | null, aspirationId: string | null, vetId: string | null, asstId: string | null, siteId: string | null, aspirationDate: string | null, nextSched: string | null, nextScheduleId: string | null, scheduleId: string | null, leftLarge: number | null, leftMedium: number | null, leftSmall: number | null, rightLarge: number | null, rightMedium: number | null, rightSmall: number | null, leftCls: number | null, rightCls: number | null, leftCysts: string | null, rightCysts: string | null, comment: string | null, donorComment: string | null, donorCondition: string | null, totalFollicles: number | null, pregnant: number | null, didNotAspirate: number | null, lastBred: string | null, birthDate: string | null, weight: string | null, fertPlan: string | null, accountName: string | null }> | null };

export type GET_VETERINARIANSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_VETERINARIANSQuery = { __typename: 'Query', equipments: { __typename: 'EquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', id: string, name: string }> | null } | null };

export type AspirationInformationFragment = { __typename: 'Aspiration', siteId: string | null, id: string, aspTime: string | null, aspDate: string | null, donorId: string | null, fertPlan: tog_fertplan | null, nextScheduleMasterId: string | null, scheduleMasterId: string | null, nofollll: number | null, nofolllm: number | null, nofollls: number | null, totfolll: number | null, cll: number | null, cystl: string | null, nofollrl: number | null, nofollrm: number | null, nofollrs: number | null, totfollr: number | null, clr: number | null, cystr: string | null, comment: string | null, qcComment: string | null, cdComment: string | null, ivmComment: string | null, qcCommentChuteside: string | null, completeOrder: number | null, donor: { __typename: 'Donor', id: string, name: string | null, birth: string | null, pregnant: number | null, lastBred: string | null, pregnantValue: string | null, condition: string | null } | null, assistant: { __typename: 'Equipment', id: string, name: string } | null, ivmTechnician: { __typename: 'Equipment', id: string, name: string } | null, technician: { __typename: 'Equipment', id: string, name: string } | null, owner: { __typename: 'Account', name: string | null } | null };

export type GET_ASPIRATION_BY_IDQueryVariables = Exact<{
  aspirationId: Scalars['UUID']['input'];
}>;


export type GET_ASPIRATION_BY_IDQuery = { __typename: 'Query', aspirations: { __typename: 'AspirationsCollectionSegment', items: Array<{ __typename: 'Aspiration', siteId: string | null, id: string, aspTime: string | null, aspDate: string | null, donorId: string | null, fertPlan: tog_fertplan | null, nextScheduleMasterId: string | null, scheduleMasterId: string | null, nofollll: number | null, nofolllm: number | null, nofollls: number | null, totfolll: number | null, cll: number | null, cystl: string | null, nofollrl: number | null, nofollrm: number | null, nofollrs: number | null, totfollr: number | null, clr: number | null, cystr: string | null, comment: string | null, qcComment: string | null, cdComment: string | null, ivmComment: string | null, qcCommentChuteside: string | null, completeOrder: number | null, donor: { __typename: 'Donor', id: string, name: string | null, birth: string | null, pregnant: number | null, lastBred: string | null, pregnantValue: string | null, condition: string | null } | null, assistant: { __typename: 'Equipment', id: string, name: string } | null, ivmTechnician: { __typename: 'Equipment', id: string, name: string } | null, technician: { __typename: 'Equipment', id: string, name: string } | null, owner: { __typename: 'Account', name: string | null } | null }> | null } | null };

export type GET_SCHEDULESQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_SCHEDULESQuery = { __typename: 'Query', scheduleMaster: { __typename: 'ScheduleMasterCollectionSegment', items: Array<{ __typename: 'ScheduleMaster', id: string, name: string | null }> | null } | null };

export type GET_PROCEDURES_BY_DONOR_IDQueryVariables = Exact<{
  donorId: Scalars['String']['input'];
  ranch: Scalars['String']['input'];
}>;


export type GET_PROCEDURES_BY_DONOR_IDQuery = { __typename: 'Query', proceduresByDonorId: Array<{ __typename: 'ProcedureHistoryData', donorId: string, procedureDate: string, procedure: string, description: string, pregnant: string, procCode: string, owner: string, breed: string }> };

export type GET_TODAYS_QC_DATA_CHUTESIDEQueryVariables = Exact<{
  date: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  location: Scalars['String']['input'];
}>;


export type GET_TODAYS_QC_DATA_CHUTESIDEQuery = { __typename: 'Query', todaysQcDataChuteside: { __typename: 'QcDataChuteside', tog_qc_pockettubewarmertemp: string, tog_qc_pumptubewarmertemp: string, tog_qc_pumppressure: string, tog_qc_flowrate: string, tog_qc_outsidetemp: string, tog_qc_outsideweatherconditions: string, tog_qc_collectionroomtemp: string, tog_qc_brennerneedlelotno: string, qccompleted: boolean, tog_asp_date: string, tog_siteid: string, tog_qc_location: string, tog_qc_commentchuteside: string } };

export type GET_TEMP_ASPIRATION_QC_INFOQueryVariables = Exact<{
  chuteNumber: Scalars['Int']['input'];
  siteId: Scalars['String']['input'];
  aspirationDate: Scalars['DateTime']['input'];
  location: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_TEMP_ASPIRATION_QC_INFOQuery = { __typename: 'Query', tempAspirationQcInfo: { __typename: 'tog_chutesideqc', id: number | null, tog_qc_pockettubewarmertemp: string | null, tog_qc_pumptubewarmertemp: string | null, tog_qc_pumppressure: string | null, tog_qc_flowrate: string | null, tog_qc_outsidetemp: string | null, tog_qc_outsideweatherconditions: string | null, tog_qc_collectionroomtemp: string | null, tog_qc_brennerneedlelotno: string | null, aspirationDate: string | null, siteId: string | null, location: string | null, tog_qc_commentchuteside: string | null, chuteNumber: number | null } | null };

export type GET_ASPIRATION_HISTORY_BY_DONOR_IDQueryVariables = Exact<{
  donorId: Scalars['String']['input'];
  aspirationDate: Scalars['String']['input'];
  ranch: Scalars['String']['input'];
}>;


export type GET_ASPIRATION_HISTORY_BY_DONOR_IDQuery = { __typename: 'Query', aspirationHistoryDataByDonorId: Array<{ __typename: 'AspirationHistoryData', aspirationDate: string, comments: string }> };

export type GET_FERT_DATA_BY_DONOR_ID_CHUTESIDEQueryVariables = Exact<{
  donorId: Scalars['String']['input'];
  ranch: Scalars['String']['input'];
}>;


export type GET_FERT_DATA_BY_DONOR_ID_CHUTESIDEQuery = { __typename: 'Query', fertDataByDonorIdChuteside: Array<{ __typename: 'FertilizationDataChuteside', id: any | null, donorId: string, aspDate: string, tech: string, sched: string, fsh: string, follS: string, follM: string, follL: string, ooc: string, percentAbc: string, sire: string, fert: string, clv: string, viable: string, clls: string, clrs: string, cystsL: string, cystsR: string }> };

export type GET_ASPIRATION_INFO_BY_IDQueryVariables = Exact<{
  aspirationId: Scalars['UUID']['input'];
}>;


export type GET_ASPIRATION_INFO_BY_IDQuery = { __typename: 'Query', aspirations: { __typename: 'AspirationsCollectionSegment', items: Array<{ __typename: 'Aspiration', bodyConditionScore: number | null, donorCategory: number | null }> | null } | null };

export type EXPORT_CRYO_BABY_LABELSMutationVariables = Exact<{
  labels: Array<CryoBabyLabelInput> | CryoBabyLabelInput;
  aspDate: Scalars['DateTime']['input'];
  aspSite: Scalars['String']['input'];
  location: InputMaybe<Scalars['String']['input']>;
}>;


export type EXPORT_CRYO_BABY_LABELSMutation = { __typename: 'Mutation', exportCryoBabyLabelXlsx: Array<any> };

export type ADD_CALVESMutationVariables = Exact<{
  requirements: CalfEntryRequirementsInput;
  calves: Array<NewCalfEntryInput> | NewCalfEntryInput;
}>;


export type ADD_CALVESMutation = { __typename: 'Mutation', addCalves: { __typename: 'AddCalvesToCalfBasePayload', code: number, message: string | null, success: boolean, calves: Array<{ __typename: 'Calf', id: string }> | null } };

export type SEARCH_OWNERSQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_OWNERSQuery = { __typename: 'Query', accounts: { __typename: 'AccountsCollectionSegment', items: Array<{ __typename: 'Account', id: string, code: string | null, name: string | null }> | null } | null };

export type SEARCH_HERDSMENQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  selectionLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SEARCH_HERDSMENQuery = { __typename: 'Query', equipments: { __typename: 'EquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', id: string, name: string }> | null } | null };

export type GET_PENSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_PENSQuery = { __typename: 'Query', pens: { __typename: 'PensCollectionSegment', items: Array<{ __typename: 'Pen', id: string, name: string | null, yard: { __typename: 'Yard', id: string, name: string | null } | null }> | null } | null };

export type GET_SEXQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_SEXQuery = { __typename: 'Query', stringMaps: { __typename: 'StringMapsCollectionSegment', items: Array<{ __typename: 'StringMap', attributeValue: number, value: string | null }> | null } | null };

export type GET_TESTICLES_DECENDEDQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_TESTICLES_DECENDEDQuery = { __typename: 'Query', stringMaps: { __typename: 'StringMapsCollectionSegment', items: Array<{ __typename: 'StringMap', attributeValue: number, value: string | null }> | null } | null };

export type GET_TESTICULAR_DEVELOPMENTQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_TESTICULAR_DEVELOPMENTQuery = { __typename: 'Query', stringMaps: { __typename: 'StringMapsCollectionSegment', items: Array<{ __typename: 'StringMap', attributeValue: number, value: string | null }> | null } | null };

export type GET_TIME_OF_DAYQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_TIME_OF_DAYQuery = { __typename: 'Query', stringMaps: { __typename: 'StringMapsCollectionSegment', items: Array<{ __typename: 'StringMap', attributeValue: number, value: string | null }> | null } | null };

export type UPDATE_ASPIRATION_TIMESMutationVariables = Exact<{
  chuteSchedule: Array<ChuteSchedulerInput> | ChuteSchedulerInput;
}>;


export type UPDATE_ASPIRATION_TIMESMutation = { __typename: 'Mutation', updateAspirationTimes: { __typename: 'ChuteSchedulerPayload', code: number, success: boolean, message: string | null } };

export type UPDATE_REVISIONSMutationVariables = Exact<{
  updates: Array<UpdateRevisionsInput> | UpdateRevisionsInput;
}>;


export type UPDATE_REVISIONSMutation = { __typename: 'Mutation', updateRevisions: Array<{ __typename: 'ChuteSchedulerPayload', code: number, success: boolean, message: string | null }> };

export type UPDATE_ASPIRATION_STATUS_AND_DONOR_SCHEDULE_REVISION_COMMENT_BATCHMutationVariables = Exact<{
  updates: Array<UpdateAspirationStatusAndDonorScheduleRevisionCommentInput> | UpdateAspirationStatusAndDonorScheduleRevisionCommentInput;
}>;


export type UPDATE_ASPIRATION_STATUS_AND_DONOR_SCHEDULE_REVISION_COMMENT_BATCHMutation = { __typename: 'Mutation', updateAspirationStatusAndDonorScheduleRevisionCommentBatch: Array<{ __typename: 'ChuteSchedulerPayload', code: number, success: boolean, message: string | null }> };

export type CHUTE_SCHEDULE_COMBINEDQueryVariables = Exact<{
  siteId: Scalars['UUID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type CHUTE_SCHEDULE_COMBINEDQuery = { __typename: 'Query', chuteScheduleCombined: { __typename: 'ChuteScheduleCombined', scheduling: Array<{ __typename: 'ChuteScheduleRow', aspirationId: string, fertSite: string | null, aspTime: string | null, account: string | null, ranchId: string | null, csr: string | null, csa: string | null, breed: string | null, earTag: string | null, donorName: string | null, sire: string | null, sireBrd: string | null, semenType: string | null, dsSemenComment: string | null, dsAspirationComment: string | null, parity: string | null, export: string | null, storageLocation: string | null, donorLocation: string | null, aspirationComment: string | null, pooled: string | null, pool: string | null, aspirationDate: string, ptComment: string | null, collectionCode: string | null, maturationComment: string | null, shipmentGroupName: string | null, embryoPlan: string | null, schedCode: string | null, transferEmbryoComment: string | null, birthDate: string | null, programName: string | null, transfer: string | null, freezeInstructions: string | null, ship: string | null, freeze: string | null, procedureDate: string | null, rowNum: any }>, results: Array<{ __typename: 'AspirationResultRow', aspirationId: string, account: string | null, ranchId: string | null, export: string | null, storageLocation: string | null, donorLocation: string | null, aspirationComment: string | null, breed: string | null, donorName: string | null, sire: string | null, sireBrd: string | null, semenType: string | null, pooled: string | null, medTotal: string | null, totalOocytes: any, inMat: any, csr: string | null, matTime: string | null, dsAspirationComment: string | null, poolNum: number | null, ship: string | null, shipmentGroupName: string | null, transfer: string | null, transferEmbryoComment: string | null, freeze: string | null, freezeInstructions: string | null, schedCode: string | null, fertSite: string | null, collectionCode: string | null, maturationComment: string | null, embryoPlan: string | null, birthDate: string | null, opuTechnician: string | null, ivmTechnician: string | null, gradeAbc: number | null, gradeD: number | null, gradeE: number | null, dead: number | null, procedureDate: string | null, programName: string | null, donorScheduleId: string | null, revisionNumber: string | null, revisionComment: string | null }> } };

export type ALL_TOP_REVISIONSQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type ALL_TOP_REVISIONSQuery = { __typename: 'Query', allTopRevisions: Array<{ __typename: 'RevisionPayload', revisionNumber: string | null, fertilizationSiteId: string | null, fertilizationSiteName: string | null }> };

export type UPDATE_FRESH_TRANSFERSMutationVariables = Exact<{
  embryoUpdates: Array<EmbryoUpdateInput> | EmbryoUpdateInput;
}>;


export type UPDATE_FRESH_TRANSFERSMutation = { __typename: 'Mutation', updateFreshTransfers: { __typename: 'EmbryoUpdatePayload', code: number, success: boolean, message: string } };

export type GET_CSR_DAY_7QueryVariables = Exact<{
  beginDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  siteId: InputMaybe<Scalars['UUID']['input']>;
  accountId: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GET_CSR_DAY_7Query = { __typename: 'Query', csrDay7: Array<{ __typename: 'TOG_CsrDay7', embryoId: string | null, account: string | null, donor: string | null, breed: string | null, bullBreed: string | null, sire: string | null, st: string | null, transferPlan: string | null, implantType: string | null, recipFrame: number | null, export: string | null, embTag: number | null, stage: number | null, grade: number | null, freshStrawNo: number | null, embryoToBe: string | null, hldFrz: number | null, hldTrf: number | null, hldFrzTrfLg: number | null, togRecip: string | null, clientRecip: string | null, csrComments: string | null, donorOwners: string | null, shipmentGroup: string | null, ivcNumber: number | null, cleaved: number | null, shippedToClient: number | null, packagedInformation: string | null, resultsComment: string | null, shippingPlan: string | null, freezePlan: string | null, plateNumber: number | null, numberOfPartners: string | null, freezePartner: string | null, transferPartner: string | null, donorScheduleFreezePartner: string | null, donorScheduleTransferPartner: string | null, fertilizationId: string | null }> };

export type ADD_CLINIC_TRANSFER_EMBRYOSMutationVariables = Exact<{
  input: ClinicTransferEmbryoInput;
}>;


export type ADD_CLINIC_TRANSFER_EMBRYOSMutation = { __typename: 'Mutation', addClinicTransferEmbryos: { __typename: 'ClinicTransferEmbryoPayload', code: number, success: boolean, message: string } };

export type UPDATE_FRESH_TRANSFERS_PSEMutationVariables = Exact<{
  input: UpdateFreshTransferInput;
}>;


export type UPDATE_FRESH_TRANSFERS_PSEMutation = { __typename: 'Mutation', updateFreshTransfersPse: { __typename: 'UpdateFreshTransferPayload', code: number, success: boolean, message: string } };

export type GET_PSE_DAY_7QueryVariables = Exact<{
  beginDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  siteId: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GET_PSE_DAY_7Query = { __typename: 'Query', pseDay7: Array<{ __typename: 'TOG_PseDay7', embryoId: string | null, stage: number | null, grade: number | null, transferComment: string | null, semenType: string | null, mating: string | null, recipient: string | null, embryoTag: number | null, transferTech: string | null, estrusSync: number | null, deactivate: number | null, embryoPartners: string | null, donorPartners: string | null, loadPartners: string | null, cl: string | null, plateNo: number | null, dsImplantType: string | null, embryoImplantType: string | null, recipFrame: number | null, status: string | null, fertilizationId: string | null, freshStrawNo: number | null, cane: string | null, freezeMethodId: string | null, tt: boolean | null, frozenStraw: number | null, accountId: string | null, shipmentGroup: string | null }> };

export type GET_PSE_DAY_7_MATINGSQueryVariables = Exact<{
  beginDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  siteId: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GET_PSE_DAY_7_MATINGSQuery = { __typename: 'Query', pseDay7Matings: Array<{ __typename: 'Fertilization', freshShipmentId: string | null, id: string, mating: string | null, predictedGood: number | null, predictedLow: number | null, predictedVeryLow: number | null, shippedTog: number | null, heldAtTogToFreeze: number | null, heldAtTogForTransfer: number | null, heldAtTogFreezeTransferLowGrade: number | null, transferred: number | null, frozen: number | null, grade1: number | null, grade2: number | null, grade3: number | null, discardedGrade1: number | null, discardedGrade2: number | null, discarded: number | null, degenerates: number | null, procId: string | null, plateNumber: number | null }> };

export type GET_DAY_7_FROZEN_EMBRYOSQueryVariables = Exact<{
  beginDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  siteId: Scalars['UUID']['input'];
}>;


export type GET_DAY_7_FROZEN_EMBRYOSQuery = { __typename: 'Query', day7FrozenEmbryos: Array<{ __typename: 'Day7FrozenEmbryo', plateNumber: number | null, mating: string | null, cane: string | null, straw: number | null, stage: number | null, grade: number | null, freezeTime: string | null, freezeSite: string | null }> };

export type GET_PARTNERSHIPSQueryVariables = Exact<{
  donorId: Scalars['UUID']['input'];
  donorScheduleId: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GET_PARTNERSHIPSQuery = { __typename: 'Query', getPartnerships: { __typename: 'GetPartnershipsCollectionSegment', items: Array<{ __typename: 'PartnershipItem', type: number | null, account1Id: string | null, percent1: number | null, account2Id: string | null, percent2: number | null, account3Id: string | null, percent3: number | null, account4Id: string | null, percent4: number | null, partnershipBillingType: number | null, partnershipId: string | null, account1: { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account2: { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account3: { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account4: { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null }> | null } | null };

export type DonorFragment = { __typename: 'Donor', id: string, name: string | null, owner: { __typename: 'Account', id: string, code: string | null } | null, donorSchedule: Array<{ __typename: 'DonorSchedule', id: string }>, partnerships: Array<{ __typename: 'Partnership', id: string, name: string | null, type: number | null, account1Id: string | null, account2Id: string | null, account3Id: string | null, account4Id: string | null, percent1: number | null, percent2: number | null, percent3: number | null, percent4: number | null, oddEven1: number | null, oddEven2: number | null, oddEven3: number | null, oddEven4: number | null, donorId: string | null, viewOnline1: boolean | null, viewOnline2: boolean | null, viewOnline3: boolean | null, viewOnline4: boolean | null, donorScheduleId: string | null, stateCode: number, account1: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account2: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account3: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account4: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, donor: { __typename: 'Donor', name: string | null, owner: { __typename: 'Account', name: string | null } | null } | null }> };

export type DonorScheduleGeneralFragment = { __typename: 'DonorSchedule', aspirationSiteId: string | null, date: string | null, ownerId: string | null, donorId: string | null, donorLocation: string | null, procedureTime: number | null, procedureTimeComment: string | null, programName: string | null, freezeInstructions: string | null, fertilizationSiteId: string | null, priority: number | null, textingAccountId: string | null, textingNumber: string | null, specialInstructions: string | null, csrId: string | null, dow: string | null, accountComment: string | null, donorComment: string | null, pregnant: number | null, pool: boolean | null, aspirationSite: { __typename: 'Site', id: string, name: string } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null, tog90daysPastDue: number | null, priceTier: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null, isPwp: boolean | null } | null, donor: { __typename: 'Donor', id: string, name: string | null, registrationNumber: string | null, yardId: string | null, birth: string | null, nm: number | null, psi: number | null, ownerships: Array<{ __typename: 'Ownership', id: string, name: string | null, endDate: string | null, billed: number | null, viewOnline: number | null, beginDate: string | null, percentage: number | null }>, yard: { __typename: 'Yard', id: string, name: string | null } | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null } | null, fertilizationSite: { __typename: 'Site', id: string, name: string } | null, textingAccount: { __typename: 'Account', id: string, name: string | null, code: string | null } | null, csr: { __typename: 'SystemUser', id: string, fullName: string | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null };

export type DonorScheduleScheduleFragment = { __typename: 'DonorSchedule', scheduleMasterId: string | null, fshId: string | null, scheduled: boolean | null, clinicRanchHaulIn: number | null, targetTime: boolean | null, fsh2Id: string | null, drugStatus: number | null, billDrugs: boolean | null, drugShippingFee: number | null, csrId: string | null, scheduleMaster: { __typename: 'ScheduleMaster', id: string, name: string | null, method: number | null, twiceConcentration: boolean | null } | null, drug: { __typename: 'Drug', id: string, name: string | null } | null, drug2: { __typename: 'Drug', id: string, name: string | null } | null, soSchedule: { __typename: 'SuperOvulationSchedule', id: string, description: string | null } | null, csr: { __typename: 'SystemUser', id: string, fullName: string | null } | null };

export type DonorScheduleEmbryoFragment = { __typename: 'DonorSchedule', ship: number | null, shipmentGroupId: string | null, shipGroup: string | null, csrfrztrf: string | null, embryoComment: string | null, flexFieldPartner: string | null, freezeInstructions: string | null, loadDonorPartnersfrz: number | null, freeze: number | null, freezeMethodId: string | null, export: number | null, nonEUCountry: number | null, tt: boolean | null, transfer: number | null, implantType: number | null, implantTypeValue: string | null, shipmentGroup: { __typename: 'ShipmentGroup', id: string, name: string | null, estimations: number | null } | null, freezeMethod: { __typename: 'OptionSet', id: string, name: string | null, label: string | null } | null };

export type DonorScheduleSemenFragment = { __typename: 'DonorSchedule', semenId: string | null, cane: string | null, colCode: string | null, naab: string | null, sireId: string | null, semenType: number | null, semenTypeValue: string | null, separateFert: boolean | null, expectedSemenQty: number | null, creditRebill: boolean | null, semenPrice: number | null, semenLocationId: string | null, semenOwnerId: string | null, backupSemenId: string | null, backupSemenType: number | null, backupSireId: string | null, contractSemen: boolean | null, semenReleased: boolean | null, critical: number | null, semenComment: string | null, semen: { __typename: 'Semen', id: string, name: string | null, cane: string | null, colCode: string | null, naab: string | null, semenType: string | null, quantity: number | null, sex: number | null } | null, sire: { __typename: 'Sire', id: string, name: string | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null } | null, semenLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null, semenOwner: { __typename: 'Account', id: string, name: string | null } | null, backupSemen: { __typename: 'Semen', id: string, name: string | null } | null, backupSire: { __typename: 'Sire', id: string, name: string | null } | null };

export type DonorScheduleBillingFragment = { __typename: 'DonorSchedule', oocyteShipping: number | null, loadDonorPartners: number | null, billAccountCaningOption: number | null, billingAccountId: string | null, specialBilling: number | null, flexFieldPartner: string | null, billingComment: string | null, validationSts: number | null, validationMessage: string | null, billingAccount: { __typename: 'Account', id: string, code: string | null, name: string | null } | null };

export type DonorScheduleNotesFragment = { __typename: 'DonorSchedule', revision: string | null, revisionComment: string | null, annotation: { __typename: 'Annotation', noteText: string | null } | null };

export type DonorScheduleFragment = { __typename: 'DonorSchedule', id: string, name: string | null, stateCode: number, aspirationSiteId: string | null, date: string | null, ownerId: string | null, donorId: string | null, donorLocation: string | null, procedureTime: number | null, procedureTimeComment: string | null, programName: string | null, freezeInstructions: string | null, fertilizationSiteId: string | null, priority: number | null, textingAccountId: string | null, textingNumber: string | null, specialInstructions: string | null, csrId: string | null, dow: string | null, accountComment: string | null, donorComment: string | null, pregnant: number | null, pool: boolean | null, scheduleMasterId: string | null, fshId: string | null, scheduled: boolean | null, clinicRanchHaulIn: number | null, targetTime: boolean | null, fsh2Id: string | null, drugStatus: number | null, billDrugs: boolean | null, drugShippingFee: number | null, ship: number | null, shipmentGroupId: string | null, shipGroup: string | null, csrfrztrf: string | null, embryoComment: string | null, flexFieldPartner: string | null, loadDonorPartnersfrz: number | null, freeze: number | null, freezeMethodId: string | null, export: number | null, nonEUCountry: number | null, tt: boolean | null, transfer: number | null, implantType: number | null, implantTypeValue: string | null, semenId: string | null, cane: string | null, colCode: string | null, naab: string | null, sireId: string | null, semenType: number | null, semenTypeValue: string | null, separateFert: boolean | null, expectedSemenQty: number | null, creditRebill: boolean | null, semenPrice: number | null, semenLocationId: string | null, semenOwnerId: string | null, backupSemenId: string | null, backupSemenType: number | null, backupSireId: string | null, contractSemen: boolean | null, semenReleased: boolean | null, critical: number | null, semenComment: string | null, oocyteShipping: number | null, loadDonorPartners: number | null, billAccountCaningOption: number | null, billingAccountId: string | null, specialBilling: number | null, billingComment: string | null, validationSts: number | null, validationMessage: string | null, revision: string | null, revisionComment: string | null, aspirationSite: { __typename: 'Site', id: string, name: string } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null, tog90daysPastDue: number | null, priceTier: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null, isPwp: boolean | null } | null, donor: { __typename: 'Donor', id: string, name: string | null, registrationNumber: string | null, yardId: string | null, birth: string | null, nm: number | null, psi: number | null, ownerships: Array<{ __typename: 'Ownership', id: string, name: string | null, endDate: string | null, billed: number | null, viewOnline: number | null, beginDate: string | null, percentage: number | null }>, yard: { __typename: 'Yard', id: string, name: string | null } | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null } | null, fertilizationSite: { __typename: 'Site', id: string, name: string } | null, textingAccount: { __typename: 'Account', id: string, name: string | null, code: string | null } | null, csr: { __typename: 'SystemUser', id: string, fullName: string | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, scheduleMaster: { __typename: 'ScheduleMaster', id: string, name: string | null, method: number | null, twiceConcentration: boolean | null } | null, drug: { __typename: 'Drug', id: string, name: string | null } | null, drug2: { __typename: 'Drug', id: string, name: string | null } | null, soSchedule: { __typename: 'SuperOvulationSchedule', id: string, description: string | null } | null, shipmentGroup: { __typename: 'ShipmentGroup', id: string, name: string | null, estimations: number | null } | null, freezeMethod: { __typename: 'OptionSet', id: string, name: string | null, label: string | null } | null, semen: { __typename: 'Semen', id: string, name: string | null, cane: string | null, colCode: string | null, naab: string | null, semenType: string | null, quantity: number | null, sex: number | null } | null, sire: { __typename: 'Sire', id: string, name: string | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null } | null, semenLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null, semenOwner: { __typename: 'Account', id: string, name: string | null } | null, backupSemen: { __typename: 'Semen', id: string, name: string | null } | null, backupSire: { __typename: 'Sire', id: string, name: string | null } | null, billingAccount: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, annotation: { __typename: 'Annotation', noteText: string | null } | null };

export type DrugFragment = { __typename: 'Drug', id: string, name: string | null, searchName: string | null, lot: string | null, comp: string | null, pricePerBottle: number | null, pricePerCc: number | null };

export type PartnershipAccountFragment = { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null };

export type PartnershipAccountFullFragment = { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null };

export type ScheduleMasterFragment = { __typename: 'ScheduleMaster', id: string, name: string | null, method: number | null, twiceConcentration: boolean | null };

export type SemenFragment = { __typename: 'Semen', id: string, name: string | null, cane: string | null, semenType: string | null, quantity: number | null, comment: string | null };

export type SireFragment = { __typename: 'Sire', id: string, name: string | null, birth: string | null, breedId: string | null, breedReg: string | null, cane: string | null, clientShortName: string | null, countryCodeId: string | null, createdById: string | null, createdOn: string | null, edonorId: string | null, heparin: number | null, modifiedById: string | null, modifiedOn: string | null, ownerId: string | null, regPrefix: string | null, registrationNumber: string | null, regtog: number | null, sexedCane: string | null, sire: string | null, sireCm: number | null, sireJpi: number | null, sireNm: number | null, sireTpi: number | null, stateCode: number, status: string | null, statusCode: number | null, yardId: string | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null } | null, yard: { __typename: 'Yard', id: string, name: string | null } | null };

export type PartnershipFragment = { __typename: 'Partnership', id: string, name: string | null, type: number | null, account1Id: string | null, account2Id: string | null, account3Id: string | null, account4Id: string | null, percent1: number | null, percent2: number | null, percent3: number | null, percent4: number | null, oddEven1: number | null, oddEven2: number | null, oddEven3: number | null, oddEven4: number | null, donorId: string | null, viewOnline1: boolean | null, viewOnline2: boolean | null, viewOnline3: boolean | null, viewOnline4: boolean | null, donorScheduleId: string | null, stateCode: number, account1: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account2: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account3: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account4: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, donor: { __typename: 'Donor', name: string | null, owner: { __typename: 'Account', name: string | null } | null } | null };

export type UPSERT_DONOR_SCHEDULESMutationVariables = Exact<{
  input: UpsertDonorScheduleInput;
  annotationNoteText: InputMaybe<Scalars['String']['input']>;
}>;


export type UPSERT_DONOR_SCHEDULESMutation = { __typename: 'Mutation', upsertDonorSchedules: { __typename: 'DonorSchedulesPayload', code: number, message: string | null, success: boolean, donorSchedules: Array<{ __typename: 'DonorSchedule', id: string }> | null } };

export type EDIT_BULK_DONOR_SCHEDULESMutationVariables = Exact<{
  input: EditBulkDonorScheduleInput;
  bulkUpdateIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  annotationNoteText: InputMaybe<Scalars['String']['input']>;
}>;


export type EDIT_BULK_DONOR_SCHEDULESMutation = { __typename: 'Mutation', editBulkDonorSchedules: { __typename: 'DonorSchedulesPayload', code: number, message: string | null, success: boolean, donorSchedules: Array<{ __typename: 'DonorSchedule', id: string }> | null } };

export type DEACTIVATE_DONOR_SCHEDULESMutationVariables = Exact<{
  donorScheduleIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type DEACTIVATE_DONOR_SCHEDULESMutation = { __typename: 'Mutation', deactivateDonorSchedules: { __typename: 'DonorSchedulesPayload', code: number, message: string | null, success: boolean, donorSchedules: Array<{ __typename: 'DonorSchedule', id: string }> | null } };

export type UPSERT_PARTNERSHIPMutationVariables = Exact<{
  input: UpsertPartnershipInput;
}>;


export type UPSERT_PARTNERSHIPMutation = { __typename: 'Mutation', upsertPartnership: { __typename: 'UpsertPartnershipsPayload', code: number, message: string | null, success: boolean, partnership: Array<{ __typename: 'Partnership', id: string }> | null } };

export type MASS_SET_FIELDMutationVariables = Exact<{
  fields: Array<Scalars['String']['input']> | Scalars['String']['input'];
  value: Scalars['String']['input'];
  donorScheduleIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type MASS_SET_FIELDMutation = { __typename: 'Mutation', massSetField: boolean };

export type DEACTIVATE_SO_SCHEDULEMutationVariables = Exact<{
  donorScheduleId: Scalars['UUID']['input'];
}>;


export type DEACTIVATE_SO_SCHEDULEMutation = { __typename: 'Mutation', deactivateSoSchedule: boolean };

export type CREATE_NEW_SHIPMENT_GROUPMutationVariables = Exact<{
  input: CreateNewShipmentGroupInput;
}>;


export type CREATE_NEW_SHIPMENT_GROUPMutation = { __typename: 'Mutation', createNewShipmentGroup: { __typename: 'ShipmentGroupPayload', code: number, message: string | null, success: boolean, shipmentGroupId: string | null } };

export type CREATE_NEW_SHIPMENT_GROUP_MASTERMutationVariables = Exact<{
  input: CreateNewShipmentGroupMasterInput;
}>;


export type CREATE_NEW_SHIPMENT_GROUP_MASTERMutation = { __typename: 'Mutation', createNewShipmentGroupMaster: { __typename: 'ShipmentGroupPayload', code: number, message: string | null, success: boolean, shipmentGroupId: string | null } };

export type UPDATE_TEMP_EMBRYO_OWNERSMutationVariables = Exact<{
  donorScheduleId: Scalars['UUID']['input'];
}>;


export type UPDATE_TEMP_EMBRYO_OWNERSMutation = { __typename: 'Mutation', updateTempEmbryoOwners: boolean };

export type UPDATE_BILL_ACCOUNT_CANING_GROUPSMutationVariables = Exact<{
  donorScheduleId: Scalars['UUID']['input'];
}>;


export type UPDATE_BILL_ACCOUNT_CANING_GROUPSMutation = { __typename: 'Mutation', updateBillAccountCaningGroups: boolean };

export type GET_DONOR_SCHEDULESQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<DonorScheduleSortInput> | DonorScheduleSortInput>;
  where: InputMaybe<DonorScheduleFilterInput>;
}>;


export type GET_DONOR_SCHEDULESQuery = { __typename: 'Query', donorSchedules: { __typename: 'DonorSchedulesCollectionSegment', totalCount: number, items: Array<{ __typename: 'DonorSchedule', id: string, name: string | null, stateCode: number, aspirationSiteId: string | null, date: string | null, ownerId: string | null, donorId: string | null, donorLocation: string | null, procedureTime: number | null, procedureTimeComment: string | null, programName: string | null, freezeInstructions: string | null, fertilizationSiteId: string | null, priority: number | null, textingAccountId: string | null, textingNumber: string | null, specialInstructions: string | null, csrId: string | null, dow: string | null, accountComment: string | null, donorComment: string | null, pregnant: number | null, pool: boolean | null, scheduleMasterId: string | null, fshId: string | null, scheduled: boolean | null, clinicRanchHaulIn: number | null, targetTime: boolean | null, fsh2Id: string | null, drugStatus: number | null, billDrugs: boolean | null, drugShippingFee: number | null, ship: number | null, shipmentGroupId: string | null, shipGroup: string | null, csrfrztrf: string | null, embryoComment: string | null, flexFieldPartner: string | null, loadDonorPartnersfrz: number | null, freeze: number | null, freezeMethodId: string | null, export: number | null, nonEUCountry: number | null, tt: boolean | null, transfer: number | null, implantType: number | null, implantTypeValue: string | null, semenId: string | null, cane: string | null, colCode: string | null, naab: string | null, sireId: string | null, semenType: number | null, semenTypeValue: string | null, separateFert: boolean | null, expectedSemenQty: number | null, creditRebill: boolean | null, semenPrice: number | null, semenLocationId: string | null, semenOwnerId: string | null, backupSemenId: string | null, backupSemenType: number | null, backupSireId: string | null, contractSemen: boolean | null, semenReleased: boolean | null, critical: number | null, semenComment: string | null, oocyteShipping: number | null, loadDonorPartners: number | null, billAccountCaningOption: number | null, billingAccountId: string | null, specialBilling: number | null, billingComment: string | null, validationSts: number | null, validationMessage: string | null, revision: string | null, revisionComment: string | null, partnerships: Array<{ __typename: 'Partnership', id: string, name: string | null, type: number | null, account1Id: string | null, account2Id: string | null, account3Id: string | null, account4Id: string | null, percent1: number | null, percent2: number | null, percent3: number | null, percent4: number | null, oddEven1: number | null, oddEven2: number | null, oddEven3: number | null, oddEven4: number | null, donorId: string | null, viewOnline1: boolean | null, viewOnline2: boolean | null, viewOnline3: boolean | null, viewOnline4: boolean | null, donorScheduleId: string | null, stateCode: number, account1: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account2: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account3: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account4: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, donor: { __typename: 'Donor', name: string | null, owner: { __typename: 'Account', name: string | null } | null } | null }> | null, aspirationSite: { __typename: 'Site', id: string, name: string } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null, tog90daysPastDue: number | null, priceTier: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null, isPwp: boolean | null } | null, donor: { __typename: 'Donor', id: string, name: string | null, registrationNumber: string | null, yardId: string | null, birth: string | null, nm: number | null, psi: number | null, ownerships: Array<{ __typename: 'Ownership', id: string, name: string | null, endDate: string | null, billed: number | null, viewOnline: number | null, beginDate: string | null, percentage: number | null }>, yard: { __typename: 'Yard', id: string, name: string | null } | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null } | null, fertilizationSite: { __typename: 'Site', id: string, name: string } | null, textingAccount: { __typename: 'Account', id: string, name: string | null, code: string | null } | null, csr: { __typename: 'SystemUser', id: string, fullName: string | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, scheduleMaster: { __typename: 'ScheduleMaster', id: string, name: string | null, method: number | null, twiceConcentration: boolean | null } | null, drug: { __typename: 'Drug', id: string, name: string | null } | null, drug2: { __typename: 'Drug', id: string, name: string | null } | null, soSchedule: { __typename: 'SuperOvulationSchedule', id: string, description: string | null } | null, shipmentGroup: { __typename: 'ShipmentGroup', id: string, name: string | null, estimations: number | null } | null, freezeMethod: { __typename: 'OptionSet', id: string, name: string | null, label: string | null } | null, semen: { __typename: 'Semen', id: string, name: string | null, cane: string | null, colCode: string | null, naab: string | null, semenType: string | null, quantity: number | null, sex: number | null } | null, sire: { __typename: 'Sire', id: string, name: string | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null } | null, semenLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null, semenOwner: { __typename: 'Account', id: string, name: string | null } | null, backupSemen: { __typename: 'Semen', id: string, name: string | null } | null, backupSire: { __typename: 'Sire', id: string, name: string | null } | null, billingAccount: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, annotation: { __typename: 'Annotation', noteText: string | null } | null }> | null } | null };

export type GET_DONOR_SCHEDULES_BY_IDSQueryVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GET_DONOR_SCHEDULES_BY_IDSQuery = { __typename: 'Query', donorSchedulesByIds: Array<{ __typename: 'DonorSchedule', id: string, name: string | null, stateCode: number, aspirationSiteId: string | null, date: string | null, ownerId: string | null, donorId: string | null, donorLocation: string | null, procedureTime: number | null, procedureTimeComment: string | null, programName: string | null, freezeInstructions: string | null, fertilizationSiteId: string | null, priority: number | null, textingAccountId: string | null, textingNumber: string | null, specialInstructions: string | null, csrId: string | null, dow: string | null, accountComment: string | null, donorComment: string | null, pregnant: number | null, pool: boolean | null, scheduleMasterId: string | null, fshId: string | null, scheduled: boolean | null, clinicRanchHaulIn: number | null, targetTime: boolean | null, fsh2Id: string | null, drugStatus: number | null, billDrugs: boolean | null, drugShippingFee: number | null, ship: number | null, shipmentGroupId: string | null, shipGroup: string | null, csrfrztrf: string | null, embryoComment: string | null, flexFieldPartner: string | null, loadDonorPartnersfrz: number | null, freeze: number | null, freezeMethodId: string | null, export: number | null, nonEUCountry: number | null, tt: boolean | null, transfer: number | null, implantType: number | null, implantTypeValue: string | null, semenId: string | null, cane: string | null, colCode: string | null, naab: string | null, sireId: string | null, semenType: number | null, semenTypeValue: string | null, separateFert: boolean | null, expectedSemenQty: number | null, creditRebill: boolean | null, semenPrice: number | null, semenLocationId: string | null, semenOwnerId: string | null, backupSemenId: string | null, backupSemenType: number | null, backupSireId: string | null, contractSemen: boolean | null, semenReleased: boolean | null, critical: number | null, semenComment: string | null, oocyteShipping: number | null, loadDonorPartners: number | null, billAccountCaningOption: number | null, billingAccountId: string | null, specialBilling: number | null, billingComment: string | null, validationSts: number | null, validationMessage: string | null, revision: string | null, revisionComment: string | null, partnerships: Array<{ __typename: 'Partnership', id: string, name: string | null, type: number | null, account1Id: string | null, account2Id: string | null, account3Id: string | null, account4Id: string | null, percent1: number | null, percent2: number | null, percent3: number | null, percent4: number | null, oddEven1: number | null, oddEven2: number | null, oddEven3: number | null, oddEven4: number | null, donorId: string | null, viewOnline1: boolean | null, viewOnline2: boolean | null, viewOnline3: boolean | null, viewOnline4: boolean | null, donorScheduleId: string | null, stateCode: number, account1: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account2: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account3: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account4: { __typename: 'Account', id: string, code: string | null, name: string | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, donor: { __typename: 'Donor', name: string | null, owner: { __typename: 'Account', name: string | null } | null } | null }> | null, aspirationSite: { __typename: 'Site', id: string, name: string } | null, owner: { __typename: 'Account', id: string, name: string | null, code: string | null, tog90daysPastDue: number | null, priceTier: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null, isPwp: boolean | null } | null, donor: { __typename: 'Donor', id: string, name: string | null, registrationNumber: string | null, yardId: string | null, birth: string | null, nm: number | null, psi: number | null, ownerships: Array<{ __typename: 'Ownership', id: string, name: string | null, endDate: string | null, billed: number | null, viewOnline: number | null, beginDate: string | null, percentage: number | null }>, yard: { __typename: 'Yard', id: string, name: string | null } | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null } | null, fertilizationSite: { __typename: 'Site', id: string, name: string } | null, textingAccount: { __typename: 'Account', id: string, name: string | null, code: string | null } | null, csr: { __typename: 'SystemUser', id: string, fullName: string | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, scheduleMaster: { __typename: 'ScheduleMaster', id: string, name: string | null, method: number | null, twiceConcentration: boolean | null } | null, drug: { __typename: 'Drug', id: string, name: string | null } | null, drug2: { __typename: 'Drug', id: string, name: string | null } | null, soSchedule: { __typename: 'SuperOvulationSchedule', id: string, description: string | null } | null, shipmentGroup: { __typename: 'ShipmentGroup', id: string, name: string | null, estimations: number | null } | null, freezeMethod: { __typename: 'OptionSet', id: string, name: string | null, label: string | null } | null, semen: { __typename: 'Semen', id: string, name: string | null, cane: string | null, colCode: string | null, naab: string | null, semenType: string | null, quantity: number | null, sex: number | null } | null, sire: { __typename: 'Sire', id: string, name: string | null, breed: { __typename: 'Breed', id: string, name: string | null, code: string | null, subFamily: tog_subfamily | null } | null } | null, semenLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null, semenOwner: { __typename: 'Account', id: string, name: string | null } | null, backupSemen: { __typename: 'Semen', id: string, name: string | null } | null, backupSire: { __typename: 'Sire', id: string, name: string | null } | null, billingAccount: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, annotation: { __typename: 'Annotation', noteText: string | null } | null }> };

export type PARTNERSHIP_TYPEQueryVariables = Exact<{
  order: InputMaybe<Array<StringMapSortInput> | StringMapSortInput>;
  where: StringMapFilterInput;
}>;


export type PARTNERSHIP_TYPEQuery = { __typename: 'Query', stringMaps: { __typename: 'StringMapsCollectionSegment', items: Array<{ __typename: 'StringMap', attributeValue: number, value: string | null }> | null } | null };

export type GET_ALL_SHIPMENT_GROUP_MASTERSQueryVariables = Exact<{
  where: InputMaybe<ShipmentGroupMasterFilterInput>;
}>;


export type GET_ALL_SHIPMENT_GROUP_MASTERSQuery = { __typename: 'Query', allShipmentGroupMasters: { __typename: 'AllShipmentGroupMastersCollectionSegment', items: Array<{ __typename: 'ShipmentGroupMaster', id: string, name: string | null, siteId: string | null, contactId: string | null, callTagContactId: string | null, shippingMethod: number | null, shipmentGroupId: string | null, site: { __typename: 'Site', id: string, name: string } | null, contact: { __typename: 'Contact', id: string, fullName: string | null } | null }> | null } | null };

export type GET_PARTNERSHIPS_BY_DONOR_IDQueryVariables = Exact<{
  donorId: Scalars['UUID']['input'];
  ownershipId: Scalars['UUID']['input'];
  donorScheduleId: Scalars['UUID']['input'];
}>;


export type GET_PARTNERSHIPS_BY_DONOR_IDQuery = { __typename: 'Query', getPartnershipsByDonorId: { __typename: 'GetPartnershipsByDonorIdCollectionSegment', items: Array<{ __typename: 'PartnershipItem', type: number | null, account1Id: string | null, percent1: number | null, account2Id: string | null, percent2: number | null, account3Id: string | null, percent3: number | null, account4Id: string | null, percent4: number | null, donorScheduleId: string | null, donorId: string | null, account1: { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account2: { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account3: { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null, account4: { __typename: 'AccountPartial', id: string | null, code: string, name: string, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, accountStatus: number | null } | null }> | null } | null };

export type GET_PREVIOUS_SCHEDULESQueryVariables = Exact<{
  donorScheduleId: Scalars['UUID']['input'];
  donorId: Scalars['UUID']['input'];
  ownerId: Scalars['UUID']['input'];
}>;


export type GET_PREVIOUS_SCHEDULESQuery = { __typename: 'Query', previousSchedules: Array<{ __typename: 'TOG_schedmasterWithAspirationDate', id: string, description: string | null, name: string | null, aspirationDate: string | null, leftSmallFollicles: number | null, leftMediumFollicles: number | null, leftLargeFollicles: number | null, rightSmallFollicles: number | null, rightMediumFollicles: number | null, rightLargeFollicles: number | null, gradeAbc: number | null, gradeD: number | null, gradeE: number | null, dead: number | null, numberInMat: number | null }> | null };

export type TOP_REVISIONS_BY_FERTILIZATION_SITEQueryVariables = Exact<{
  fertilizationSiteId: Scalars['UUID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type TOP_REVISIONS_BY_FERTILIZATION_SITEQuery = { __typename: 'Query', topRevisionsByFertilizationSite: string | null };

export type GET_NEXT_SCHEDULEQueryVariables = Exact<{
  donorId: Scalars['UUID']['input'];
}>;


export type GET_NEXT_SCHEDULEQuery = { __typename: 'Query', aspirations: { __typename: 'AspirationsCollectionSegment', items: Array<{ __typename: 'Aspiration', fshNext: number | null, nextScheduleMaster: { __typename: 'ScheduleMaster', id: string, name: string | null, method: number | null, twiceConcentration: boolean | null } | null, scheduleMaster: { __typename: 'ScheduleMaster', id: string, name: string | null, method: number | null, twiceConcentration: boolean | null } | null }> | null } | null };

export type GET_SCHEDULED_DRUGSQueryVariables = Exact<{
  donorId: Scalars['UUID']['input'];
}>;


export type GET_SCHEDULED_DRUGSQuery = { __typename: 'Query', superOvulationSchedules: { __typename: 'SuperOvulationSchedulesCollectionSegment', items: Array<{ __typename: 'SuperOvulationSchedule', id: string, donorId: string | null, scheduleMasterId: string | null, drug: { __typename: 'Drug', id: string, name: string | null } | null, drug2: { __typename: 'Drug', id: string, name: string | null } | null }> | null } | null };

export type SCHEDULED_DONORSQueryVariables = Exact<{
  semenID: Scalars['String']['input'];
  donorScheduleDate: Scalars['DateTime']['input'];
  semenType: Scalars['String']['input'];
  accountID: Scalars['String']['input'];
}>;


export type SCHEDULED_DONORSQuery = { __typename: 'Query', scheduledDonors: { __typename: 'ScheduledDonorsCollectionSegment', items: Array<{ __typename: 'ScheduledDonorType', donorName: string | null, csr: string | null, donorScheduleID: string }> | null } | null };

export type PULLED_SEMENQueryVariables = Exact<{
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
}>;


export type PULLED_SEMENQuery = { __typename: 'Query', pulledSemen: { __typename: 'PulledSemenCollectionSegment', items: Array<{ __typename: 'PulledSemenType', rowNum: number, semenID: string, semenName: string, sireID: string, sireName: string, donors_Sire: number, semenTypeName: string, name_Type: string, accountID: string, accountName: string, semenStorageID: string, semenStorageName: string, semenStorageSiteName: string, cane: string, colCode: string, naab: string, exportName: string, quantity: number, pulledQuantity: number, sireBreed: string }> | null } | null };

export type FERTILIZATION_TECHSQueryVariables = Exact<{
  fertSiteId: InputMaybe<Scalars['UUID']['input']>;
}>;


export type FERTILIZATION_TECHSQuery = { __typename: 'Query', techs: { __typename: 'TechsCollectionSegment', items: Array<{ __typename: 'TechType', name: string, value: string }> | null } | null };

export type FERTILIZATION_DONOR_SCHEDULEQueryVariables = Exact<{
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
}>;


export type FERTILIZATION_DONOR_SCHEDULEQuery = { __typename: 'Query', fertilizationDonorSchedules: { __typename: 'FertilizationDonorSchedulesCollectionSegment', items: Array<{ __typename: 'FertilizationDonorScheduleType', donorScheduleID: string, aspirationPoolID: string | null, aspirationID: string | null, donorName: string, semenID: string | null, semenName: string, backupSemenID: string | null, backupSemenName: string, name_Type: string, semenTypeName: string, accountID: string, accountNumber: string, semenComment: string, exportName: string, matTime: string, aspDate: string, ivmMat: string, donorBreed: string, donorBreedName: string }> | null } | null };

export type CREATED_FERTSQueryVariables = Exact<{
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
}>;


export type CREATED_FERTSQuery = { __typename: 'Query', createdFerts: { __typename: 'CreatedFertsCollectionSegment', items: Array<{ __typename: 'CreatedFertType', fertID: string, fertName: string, semenType: string, accountID: string, accountNumber: string, numSemenUnits: string, ivfNum: string, matTime: string, exportValue: string, exportName: string, fertComment: string, fertComments: string }> | null } | null };

export type FERT_COMMENTSQueryVariables = Exact<{ [key: string]: never; }>;


export type FERT_COMMENTSQuery = { __typename: 'Query', fertCommentsList: { __typename: 'FertCommentsListCollectionSegment', items: Array<{ __typename: 'CommentType', text: string, value: number }> | null } | null };

export type INLINE_FERT_COMMENTSQueryVariables = Exact<{ [key: string]: never; }>;


export type INLINE_FERT_COMMENTSQuery = { __typename: 'Query', fertCommentsInGridList: { __typename: 'FertCommentsInGridListCollectionSegment', items: Array<{ __typename: 'CommentType', text: string, value: number }> | null } | null };

export type INCUBATORSQueryVariables = Exact<{
  siteId: Scalars['UUID']['input'];
}>;


export type INCUBATORSQuery = { __typename: 'Query', incubators: { __typename: 'IncubatorsCollectionSegment', items: Array<{ __typename: 'incubators', id: string, name: string | null }> | null } | null };

export type UPSERT_REVERSE_SORTMutationVariables = Exact<{
  semenId: Scalars['UUID']['input'];
  initialMobility: Scalars['Int']['input'];
  initialDeadRate: Scalars['Int']['input'];
  finalDeadRate: Scalars['Int']['input'];
  splitScore: Scalars['Int']['input'];
  postSortMortality: Scalars['Int']['input'];
  purity: Scalars['Int']['input'];
}>;


export type UPSERT_REVERSE_SORTMutation = { __typename: 'Mutation', upsertReverseSort: string };

export type CREATE_FERTILIZATIONMutationVariables = Exact<{
  semenID: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dsid: Array<Scalars['String']['input']> | Scalars['String']['input'];
  semenQtyUse: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  semenTypeList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  mofloList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  numFerts: Scalars['Int']['input'];
  fertTime: Array<Scalars['String']['input']> | Scalars['String']['input'];
  donorScheduleDate: Scalars['DateTime']['input'];
  fertDate: Scalars['DateTime']['input'];
  procTechID: Scalars['UUID']['input'];
  moveTechID: Scalars['UUID']['input'];
  fertTechID: Scalars['UUID']['input'];
  fertComment: Array<Scalars['String']['input']> | Scalars['String']['input'];
  ivfNum: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  billUnits: Scalars['Decimal']['input'];
  pooledSires: Scalars['Boolean']['input'];
  gridFertCommentsDDL: Array<Array<Scalars['Int']['input']> | Scalars['Int']['input']> | Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  fertCommentList: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  isContaminated: Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input'];
  sofDate: Scalars['DateTime']['input'];
  fertMediaLotNo: Scalars['DateTime']['input'];
  mineralOilLot: Scalars['String']['input'];
  serum: Scalars['String']['input'];
  fertPlate: Scalars['String']['input'];
  culturePlateLotNo: Scalars['String']['input'];
  cultureIncubatorNo: InputMaybe<Scalars['UUID']['input']>;
  ehmMedia: Scalars['DateTime']['input'];
  qcIsolate: Scalars['String']['input'];
}>;


export type CREATE_FERTILIZATIONMutation = { __typename: 'Mutation', createFertilizations: { __typename: 'CreateFertilizationPayload', code: number, success: boolean, message: string | null, fertilizationIds: Array<string> | null } };

export type scheduledDonorFragment = { __typename: 'ScheduledDonorType', donorName: string | null, csr: string | null, donorScheduleID: string };

export type fertilizationDonorScheduleFragment = { __typename: 'FertilizationDonorScheduleType', donorScheduleID: string, aspirationPoolID: string | null, aspirationID: string | null, donorName: string, semenID: string | null, semenName: string, backupSemenID: string | null, backupSemenName: string, name_Type: string, semenTypeName: string, accountID: string, accountNumber: string, semenComment: string, exportName: string, matTime: string, aspDate: string, ivmMat: string, donorBreed: string, donorBreedName: string };

export type pulledSemenFragment = { __typename: 'PulledSemenType', rowNum: number, semenID: string, semenName: string, sireID: string, sireName: string, donors_Sire: number, semenTypeName: string, name_Type: string, accountID: string, accountName: string, semenStorageID: string, semenStorageName: string, semenStorageSiteName: string, cane: string, colCode: string, naab: string, exportName: string, quantity: number, pulledQuantity: number, sireBreed: string };

export type createdFertsFragment = { __typename: 'CreatedFertType', fertID: string, fertName: string, semenType: string, accountID: string, accountNumber: string, numSemenUnits: string, ivfNum: string, matTime: string, exportValue: string, exportName: string, fertComment: string, fertComments: string };

export type UPDATE_FERT_TRANSACTION_FREEZEMutationVariables = Exact<{
  id: Scalars['String']['input'];
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type UPDATE_FERT_TRANSACTION_FREEZEMutation = { __typename: 'Mutation', updateFertTransactionFreeze: boolean };

export type UPDATE_EMBRYO_TRANSACTIONMutationVariables = Exact<{
  id: Scalars['String']['input'];
  field: Scalars['String']['input'];
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type UPDATE_EMBRYO_TRANSACTIONMutation = { __typename: 'Mutation', updateEmbryoTransaction: boolean };

export type UPDATE_INT_EMBRYO_TRANSACTIONMutationVariables = Exact<{
  id: Scalars['String']['input'];
  field: Scalars['String']['input'];
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type UPDATE_INT_EMBRYO_TRANSACTIONMutation = { __typename: 'Mutation', updateInterimEmbryoTransaction: boolean };

export type UPDATE_OD_FREEZEMutationVariables = Exact<{
  input: UpdateODFreezeInput;
  dtplus: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UPDATE_OD_FREEZEMutation = { __typename: 'Mutation', updateODFreeze: boolean };

export type ADD_INT_EMBRYOSMutationVariables = Exact<{
  input: MassInterimEmbryosInput;
  type: Scalars['Int']['input'];
  dtplus: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ADD_INT_EMBRYOSMutation = { __typename: 'Mutation', addIntEmbs: Array<{ __typename: 'TOA_GetFertilizationsIntEmbryos', fertilizationId: string | null, embryoId: string | null, name: string | null, cane: string | null, subCane: string | null, freezer: string | null, freezeMethodName: string | null, freezeMethodId: string | null, freezeTech: string | null, embryoFreezeEntryId: string | null, d65: number | null, d7: number | null, discard: number | null, grade: number | null, stage: number | null, straw: number | null, tt: boolean | null, crackedZona: boolean | null, lowQuality: boolean | null, storageLocationName: string | null, loadDonorPartnershipsFrozen: number | null, ownerId: string | null, ownerName: string | null, owners: Array<{ __typename: 'TOA_GetFertilizationsIntEmbryosOwnerList', ownerId: string, ranchCode: string | null, percentage: number | null }> | null }> };

export type ADD_MASS_INT_EMBRYOSMutationVariables = Exact<{
  items: MassInterimEmbryosInput;
  dtplus: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ADD_MASS_INT_EMBRYOSMutation = { __typename: 'Mutation', addMassInterimEmbryos: boolean };

export type DEACTIVATE_INT_EMBMutationVariables = Exact<{
  items: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DEACTIVATE_INT_EMBMutation = { __typename: 'Mutation', deactivateInterimEmbryo: boolean };

export type PDF_CREATE_FREEZEMutationVariables = Exact<{
  items: Array<PrintInfoInput> | PrintInfoInput;
  filename: Scalars['String']['input'];
}>;


export type PDF_CREATE_FREEZEMutation = { __typename: 'Mutation', pdfCreateFreeze: Array<any> };

export type VALIDATE_FREEZEMutationVariables = Exact<{
  fertilizationIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  fertilizationId: InputMaybe<Scalars['String']['input']>;
  validatorId: Scalars['UUID']['input'];
  validationDate: Scalars['DateTime']['input'];
}>;


export type VALIDATE_FREEZEMutation = { __typename: 'Mutation', validateFreeze: boolean };

export type APPLY_APPROVAL_NUMBER_TO_EMBRYOSMutationVariables = Exact<{
  updates: Array<UpdateApprovalNumberInput> | UpdateApprovalNumberInput;
}>;


export type APPLY_APPROVAL_NUMBER_TO_EMBRYOSMutation = { __typename: 'Mutation', applyApprovalNumberToEmbryos: number };

export type UPDATE_FREEZE_EMBRYOS_ASYNCMutationVariables = Exact<{
  embryoIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  storageLocationId: InputMaybe<Scalars['UUID']['input']>;
  freezeMethodId: InputMaybe<Scalars['UUID']['input']>;
  graderId: InputMaybe<Scalars['UUID']['input']>;
  freezeTechId: InputMaybe<Scalars['UUID']['input']>;
  accountId: InputMaybe<Scalars['UUID']['input']>;
  deactivate: InputMaybe<Scalars['Boolean']['input']>;
  crackedZona: InputMaybe<Scalars['Boolean']['input']>;
  lowQuality: InputMaybe<Scalars['Boolean']['input']>;
  freezer: InputMaybe<Scalars['String']['input']>;
}>;


export type UPDATE_FREEZE_EMBRYOS_ASYNCMutation = { __typename: 'Mutation', updateFreezeEmbryos: boolean };

export type UPDATE_FREEZE_TEMP_EMBRYOS_ASYNCMutationVariables = Exact<{
  tempEmbryoIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  storageLocationId: InputMaybe<Scalars['UUID']['input']>;
  freezeMethodId: InputMaybe<Scalars['UUID']['input']>;
  freezeTechId: InputMaybe<Scalars['UUID']['input']>;
  accountId: InputMaybe<Scalars['UUID']['input']>;
  deactivate: InputMaybe<Scalars['Boolean']['input']>;
  crackedZona: InputMaybe<Scalars['Boolean']['input']>;
  lowQuality: InputMaybe<Scalars['Boolean']['input']>;
  freezer: InputMaybe<Scalars['String']['input']>;
}>;


export type UPDATE_FREEZE_TEMP_EMBRYOS_ASYNCMutation = { __typename: 'Mutation', updateFreezeTempEmbryos: boolean };

export type CREATE_FREEZE_VALIDATION_REPORTMutationVariables = Exact<{
  fertilizationIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CREATE_FREEZE_VALIDATION_REPORTMutation = { __typename: 'Mutation', createFreezeValidationReport: Array<any> };

export type UPDATE_MATING_LABELS_FREEZEMutationVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  site: Scalars['String']['input'];
}>;


export type UPDATE_MATING_LABELS_FREEZEMutation = { __typename: 'Mutation', updateMatingLabelsFreezeXlsx: Array<any> };

export type GET_FERTILIZATION_LIST_FREEZEQueryVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  fertilizationId: InputMaybe<Scalars['String']['input']>;
  searchQuery: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_FERTILIZATION_LIST_FREEZEQuery = { __typename: 'Query', fertilizationListFreeze: Array<{ __typename: 'TOA_GetFertilizationsForFreezing', fertId: string | null, frozen: number | null, plateNumber: number | null, csr: string | null, contaminantPresent: string | null, account: string | null, opuSite: string | null, opuSiteName: string | null, donorName: string | null, donorId: string | null, dBreed: string | null, sireName: string | null, sireId: string | null, sBreed: string | null, semenType: string | null, ivcNumber: number | null, cleaved: number | null, predictedGood: number | null, predictedLow: number | null, predictedVeryLow: number | null, heldAtTogToFreeze: number | null, heldTransfer: number | null, heldTransferLg: number | null, discardedGrade1: number | null, discardedGrade2: number | null, discarded: number | null, degenerates: number | null, noEmbryosProduced: string | null, cane: string | null, export: string | null, approvalNumber: string | null, approvalNumberId: string | null, freezeMethod: string | null, programName: string | null, partners: string | null, predictionTech: string | null, csrComment: string | null, resultsComment: string | null, intEmbs: number | null, embs: number | null, validatorId: string | null, validationDate: string | null, breedCategory: number | null, isDonorDuplicate: boolean | null, isPlateDuplicate: boolean | null, index: number | null, partnershipId: string | null, billAccountCaningOption: number | null }> };

export type GET_FERT_AND_EMBRYOS_FREEZEQueryVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  fertilizationIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GET_FERT_AND_EMBRYOS_FREEZEQuery = { __typename: 'Query', fertAndEmbryosFreeze: Array<{ __typename: 'FertilizationWithEmbryos', fertId: string, liveEmbryos: Array<{ __typename: 'TOA_GetFertilizationsEmbryos', fertilizationId: string | null, id: string | null, name: string | null, donorId: string | null, donorName: string | null, sireId: string | null, sireName: string | null, cane: string | null, subCane: string | null, subCaneNoSuffix: string | null, freezeMethodId: string | null, freezeMethodName: string | null, freezer: string | null, freezeTechName: string | null, d65: number | null, d7: number | null, dtPlus: string | null, grader7Id: string | null, grader7Name: string | null, freshFrozen: number | null, freshFrozenName: string | null, grade: number | null, stage: number | null, strawNumber: number | null, strawLabel: any | null, tt: boolean | null, crackedZona: boolean | null, lowQuality: boolean | null, storageLocationName: string | null, storageLocationId: string | null, ownerName: string | null, qcEg10: string | null, qcTryPsInDate: string | null, qcehmDate: string | null, equilibrationSolutionDate: string | null, qcEg10Date: string | null, qcSucroseDate: string | null, vitrificationSolutionDate: string | null, qcfreezingComment: string | null, qcStrawLotNumber: string | null, qcVitStrawLotNumber: string | null, qcSterileStrawLotNumber: string | null, qc12WellPlates: string | null }>, tempEmbryos: Array<{ __typename: 'TOA_GetFertilizationsIntEmbryos', fertilizationId: string | null, embryoId: string | null, name: string | null, cane: string | null, subCane: string | null, freezer: string | null, freezeMethodName: string | null, freezeMethodId: string | null, freezeTech: string | null, embryoFreezeEntryId: string | null, d65: number | null, d7: number | null, discard: number | null, grade: number | null, stage: number | null, straw: number | null, tt: boolean | null, crackedZona: boolean | null, lowQuality: boolean | null, storageLocationName: string | null, loadDonorPartnershipsFrozen: number | null, ownerId: string | null, ownerName: string | null, owners: Array<{ __typename: 'TOA_GetFertilizationsIntEmbryosOwnerList', ownerId: string, ranchCode: string | null, percentage: number | null }> | null }> }> };

export type GET_FREEZE_STORAGE_LOCATIONSQueryVariables = Exact<{
  fertilizationSiteId: Scalars['UUID']['input'];
}>;


export type GET_FREEZE_STORAGE_LOCATIONSQuery = { __typename: 'Query', storageLocations: { __typename: 'StorageLocationsCollectionSegment', items: Array<{ __typename: 'StorageLocation', siteId: string | null, id: string, name: string | null }> | null } | null };

export type UPDATE_FERT_TRANSACTIONMutationVariables = Exact<{
  id: Scalars['String']['input'];
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
  updatePredictedComments: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UPDATE_FERT_TRANSACTIONMutation = { __typename: 'Mutation', updateFertTransaction: { __typename: 'FertilizationPayload', code: number, success: boolean, message: string | null } };

export type UPDATE_DS_TRANSACTIONMutationVariables = Exact<{
  id: Scalars['String']['input'];
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
  updatePredictedComments: InputMaybe<Scalars['Boolean']['input']>;
  isIvf: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UPDATE_DS_TRANSACTIONMutation = { __typename: 'Mutation', updateDSTransaction: { __typename: 'DonorSchedulesPayload', code: number, success: boolean, message: string | null } };

export type UPDATE_FRESH_SHIPMENT_TRANSACTIONMutationVariables = Exact<{
  id: Scalars['String']['input'];
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type UPDATE_FRESH_SHIPMENT_TRANSACTIONMutation = { __typename: 'Mutation', updateFreshShipmentTransaction: { __typename: 'FreshShipmentPayload', code: number, success: boolean, message: string | null } };

export type UPDATE_SHIPMENT_GROUP_TRANSACTIONMutationVariables = Exact<{
  id: Scalars['String']['input'];
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type UPDATE_SHIPMENT_GROUP_TRANSACTIONMutation = { __typename: 'Mutation', updateShipmentGroupTransaction: { __typename: 'ShipmentGroupPayload', code: number, success: boolean, message: string | null } };

export type CREATE_FRESH_SHIPMENT_IMPLANT_FORM_REPORTMutationVariables = Exact<{
  shipmentNumber: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
}>;


export type CREATE_FRESH_SHIPMENT_IMPLANT_FORM_REPORTMutation = { __typename: 'Mutation', createFreshShipmentImplantFormReport: Array<any> };

export type CREATE_FRESH_SHIPMENT_FORM_REPORTMutationVariables = Exact<{
  shipmentNumber: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
}>;


export type CREATE_FRESH_SHIPMENT_FORM_REPORTMutation = { __typename: 'Mutation', createFreshShipmentFormReport: Array<any> };

export type CREATE_FRESH_SHIPMENT_EXPORT_SEAL_FORM_REPORTMutationVariables = Exact<{
  shipmentNumber: Scalars['String']['input'];
  freshShipmentId: Scalars['String']['input'];
}>;


export type CREATE_FRESH_SHIPMENT_EXPORT_SEAL_FORM_REPORTMutation = { __typename: 'Mutation', createFreshShipmentExportSealFormReport: Array<any> };

export type UPDATE_MATING_LABELSMutationVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  site: Scalars['String']['input'];
  shipGroups: Scalars['String']['input'];
}>;


export type UPDATE_MATING_LABELSMutation = { __typename: 'Mutation', updateMatingLabelsXlsx: Array<any> };

export type UPDATE_MATING_LABELS_DUPESMutationVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  site: Scalars['String']['input'];
  shipGroups: Scalars['String']['input'];
}>;


export type UPDATE_MATING_LABELS_DUPESMutation = { __typename: 'Mutation', updateMatingLabelsDupesXlsx: Array<any> };

export type UPDATE_INCUBATOR_ASSIGNMENTMutationVariables = Exact<{
  fertilizationId: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type UPDATE_INCUBATOR_ASSIGNMENTMutation = { __typename: 'Mutation', updateIncubatorAssignment: { __typename: 'FertilizationPayload', code: number, success: boolean, message: string | null } };

export type GENERATE_SIGN_OFF_EMAILMutationVariables = Exact<{
  username: Scalars['String']['input'];
  fertilizationDate: Scalars['DateTime']['input'];
  fertilizationSiteId: Scalars['UUID']['input'];
  shipGroupId: Scalars['UUID']['input'];
}>;


export type GENERATE_SIGN_OFF_EMAILMutation = { __typename: 'Mutation', generateSignOffEmail: { __typename: 'ShipmentGroupPayload', code: number, success: boolean, message: string | null } };

export type UNDO_SHIPMENTMutationVariables = Exact<{
  freshShipmentId: Scalars['UUID']['input'];
  fertSiteId: Scalars['UUID']['input'];
}>;


export type UNDO_SHIPMENTMutation = { __typename: 'Mutation', undoShipment: { __typename: 'FertilizationPayload', code: number, success: boolean, message: string | null } };

export type COMBINE_SHIPMENTSMutationVariables = Exact<{
  freshShipIdList: Array<FreshShipIdListInput> | FreshShipIdListInput;
}>;


export type COMBINE_SHIPMENTSMutation = { __typename: 'Mutation', combineShipments: { __typename: 'FreshShipmentPayload', code: number, success: boolean, message: string | null } };

export type UPDATE_QC_FRESH_SHIPMENTMutationVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
  qcEHMDate10ml: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate20ml: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate40ml: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate125ml: InputMaybe<Scalars['DateTime']['input']>;
  qcEHMDate250ml: InputMaybe<Scalars['DateTime']['input']>;
  qcShippingTubeExpirationDate: Scalars['DateTime']['input'];
}>;


export type UPDATE_QC_FRESH_SHIPMENTMutation = { __typename: 'Mutation', updateQcFreshShipment: { __typename: 'FertilizationPayload', code: number, success: boolean, message: string | null } };

export type CREATE_COMM_DAIRY_FERTILIZATION_EXCELMutationVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
  d5: Scalars['Boolean']['input'];
}>;


export type CREATE_COMM_DAIRY_FERTILIZATION_EXCELMutation = { __typename: 'Mutation', createCommDairyFertilizationExcel: Array<any> };

export type SEND_COMM_DAIRY_FERTILIZATION_EMAILMutationVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  username: Scalars['String']['input'];
  d5: Scalars['Boolean']['input'];
}>;


export type SEND_COMM_DAIRY_FERTILIZATION_EMAILMutation = { __typename: 'Mutation', sendCommDairyFertilizationEmail: boolean };

export type GET_SHIP_GROUP_LISTQueryVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
}>;


export type GET_SHIP_GROUP_LISTQuery = { __typename: 'Query', shipGroupList: { __typename: 'ShipGroupListResponse', activeShipGroups: Array<{ __typename: 'TOA_GetFreshShipmentShipGroups', shipGroupId: string | null, shipGroupName: string | null, fertDate: string | null, numMating: number | null, numTubes: number | null }>, signedOffShipGroups: Array<{ __typename: 'TOA_GetFreshShipmentShipGroups', shipGroupId: string | null, shipGroupName: string | null, fertDate: string | null, numMating: number | null, numTubes: number | null }> } };

export type GET_FRESH_SHIPMENT_LISTQueryVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  fertilizationSiteName: Scalars['String']['input'];
}>;


export type GET_FRESH_SHIPMENT_LISTQuery = { __typename: 'Query', freshShipmentList: Array<{ __typename: 'TOA_GetFreshShipments', freshShipmentId: string, name: string | null, matingsCount: number | null, trackingNumber: string | null, shipmentNumber: string | null, shipperId: string | null, shippedEmbryosCount: number | null, exportStatus: boolean | null }> };

export type GET_FERTILIZATION_LISTQueryVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
}>;


export type GET_FERTILIZATION_LISTQuery = { __typename: 'Query', fertilizationList: Array<{ __typename: 'TOA_GetFreshShipmentFertList', fertilizationId: string, fertDate: string | null, plateNumber: number | null, predictedBy: string | null, tubeNumber: number | null, csr: string | null, accountNumber: string | null, siteName: string | null, donorName: string | null, donorId: string | null, donorBreed: string | null, breedDonor: string | null, donorLocation: string | null, sireName: string | null, sireBreed: string | null, sireReg: string | null, breedSire: string | null, semenTypeName: string | null, ivcNumber: number | null, cleaved: number | null, predictedGood: number | null, predictedLow: number | null, predictedVeryLow: number | null, origHeldAtTog: number | null, origShipped: number | null, heldAtTogToFreeze: number | null, heldAtTogFreezeTransferLowGrade: number | null, heldAtTogForTransfer: number | null, shipped: number | null, shippedTog: number | null, shipped2: number | null, shippedTog2: number | null, shipmentGroupMasterId: string | null, shipmentGroupMaster2Id: string | null, day5esttrans: number | null, export: number | null, exportName: string | null, noEmbryosProduced: string | null, contaminantPresent: string | null, embryoComment: string | null, ivfComment: string | null, csrComment: string | null, freshShipmentComments: string | null, comments: string | null, partnerships: string | null, freshShipmentId: string | null, shippedBillable: number | null, inc1: string | null, inc2: string | null, inc1Id: string | null, inc2Id: string | null, freezeName: string | null, shipName: string | null, transferName: string | null, implantType: number | null, totals: number | null, cane: string | null, colCode: string | null, billIncubator: boolean | null, billIncubator2: boolean | null, billShipping: boolean | null, billShipping2: boolean | null, shipGroupName: string | null, loadedInStraws: number | null, priority: number | null, embryoCalcPaNm: number | null, embryoCalcPaTpi: number | null, isDuplicate: boolean | null, programName: string | null }> };

export type GET_ESTIMATION_HEADER_VALQueryVariables = Exact<{
  shipGroupId: Scalars['String']['input'];
}>;


export type GET_ESTIMATION_HEADER_VALQuery = { __typename: 'Query', estimationHeaderVal: string };

export type GET_PREDICTION_TECHSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_PREDICTION_TECHSQuery = { __typename: 'Query', equipments: { __typename: 'EquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', id: string, name: string }> | null } | null };

export type GET_CURRENT_FERT_PREDICTION_TECHQueryVariables = Exact<{
  fertilizationId: Scalars['UUID']['input'];
}>;


export type GET_CURRENT_FERT_PREDICTION_TECHQuery = { __typename: 'Query', currentFertPredictionTechId: { __typename: 'Equipment', id: string, name: string } | null };

export type GET_SHIPMENT_GROUP_MASTERSQueryVariables = Exact<{
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupId: Scalars['String']['input'];
}>;


export type GET_SHIPMENT_GROUP_MASTERSQuery = { __typename: 'Query', shipmentGroupMasters: Array<{ __typename: 'TOA_GetFreshShipmentShipGroupMasters', shipmentGroupMasterId: string, name: string | null }> };

export type GET_FERTILIZATION_QC_DATAQueryVariables = Exact<{
  fertilizationId: Scalars['UUID']['input'];
}>;


export type GET_FERTILIZATION_QC_DATAQuery = { __typename: 'Query', fertilizations: { __typename: 'FertilizationsCollectionSegment', items: Array<{ __typename: 'Fertilization', qcEHMDate10ml: string | null, qcEHMDate20ml: string | null, qcEHMDate40ml: string | null, qcEHMDate125ml: string | null, qcEHMDate250ml: string | null, qcShippingTubeExpirationDate: string | null, qcSofDate: string | null }> | null } | null };

export type GET_FRESH_SHIPMENT_QCQueryVariables = Exact<{
  fertilizationDate: Scalars['String']['input'];
  fertilizationSiteId: Scalars['String']['input'];
  shipGroupIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GET_FRESH_SHIPMENT_QCQuery = { __typename: 'Query', freshShipmentQC: { __typename: 'FertilizationQCResponse', qcEHMDate10ml: string | null, qcEHMDate20ml: string | null, qcEHMDate40ml: string | null, qcEHMDate125ml: string | null, qcEHMDate250ml: string | null, qcShippingTubeExpirationDate: string | null, qcSofDate: string | null } };

export type CREATE_ISSUE_MANAGERMutationVariables = Exact<{
  adUserId: Scalars['UUID']['input'];
  issueType: RequestIssueType;
}>;


export type CREATE_ISSUE_MANAGERMutation = { __typename: 'Mutation', createIssueManager: { __typename: 'RequestIssueManager', id: number, issueType: RequestIssueType, adUserId: string, systemUser: { __typename: 'SystemUser', id: string, fullName: string | null } | null } };

export type DELETE_ISSUE_MANAGERMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DELETE_ISSUE_MANAGERMutation = { __typename: 'Mutation', deleteIssueManager: boolean };

export type CREATE_REQUEST_EVENTMutationVariables = Exact<{
  requestId: Scalars['Int']['input'];
  type: RequestEventType;
  content: Scalars['String']['input'];
  refRequestId: InputMaybe<Scalars['Int']['input']>;
}>;


export type CREATE_REQUEST_EVENTMutation = { __typename: 'Mutation', createItRequestEvent: { __typename: 'RequestEvent', id: number, createdAt: string, type: RequestEventType, content: string, updatedAt: string | null, requestId: number, refRequestId: number | null, authorAdUserId: string, author: { __typename: 'SystemUser', id: string, fullName: string | null } | null } };

export type CREATE_IT_REQUESTMutationVariables = Exact<{
  request: RequestInput;
}>;


export type CREATE_IT_REQUESTMutation = { __typename: 'Mutation', createItRequest: { __typename: 'Request', id: number } };

export type CREATE_CLIENT_ISSUE_REQUESTMutationVariables = Exact<{
  input: RequestClientIssueInput;
}>;


export type CREATE_CLIENT_ISSUE_REQUESTMutation = { __typename: 'Mutation', createClientIssueRequest: { __typename: 'Request', id: number } };

export type CREATE_REPORT_REQUESTMutationVariables = Exact<{
  input: ReportRequestInput;
}>;


export type CREATE_REPORT_REQUESTMutation = { __typename: 'Mutation', createReportRequest: { __typename: 'Request', id: number } };

export type RequestFragment = { __typename: 'Request', id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue' } | { __typename: 'RequestItIssue', id: number, sponsorId: string, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null };

export type MY_OPEN_REQUESTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<RequestSortInput> | RequestSortInput>;
  where: RequestFilterInput;
}>;


export type MY_OPEN_REQUESTSQuery = { __typename: 'Query', openItRequests: { __typename: 'OpenItRequestsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Request', id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue' } | { __typename: 'RequestItIssue', id: number, sponsorId: string, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type MY_CLOSED_REQUESTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<RequestSortInput> | RequestSortInput>;
  where: RequestFilterInput;
}>;


export type MY_CLOSED_REQUESTSQuery = { __typename: 'Query', closedItRequests: { __typename: 'ClosedItRequestsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Request', id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue' } | { __typename: 'RequestItIssue', id: number, sponsorId: string, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type MY_REQUESTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<RequestSortInput> | RequestSortInput>;
  where: RequestFilterInput;
}>;


export type MY_REQUESTSQuery = { __typename: 'Query', itRequests: { __typename: 'ItRequestsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Request', id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue' } | { __typename: 'RequestItIssue', id: number, sponsorId: string, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type ALL_REQUESTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<RequestSortInput> | RequestSortInput>;
  where: RequestFilterInput;
}>;


export type ALL_REQUESTSQuery = { __typename: 'Query', itRequests: { __typename: 'ItRequestsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Request', isImportant: boolean, id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue' } | { __typename: 'RequestItIssue', id: number, sponsorId: string, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type ALL_OPEN_REQUESTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<RequestSortInput> | RequestSortInput>;
  where: RequestFilterInput;
}>;


export type ALL_OPEN_REQUESTSQuery = { __typename: 'Query', openItRequests: { __typename: 'OpenItRequestsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Request', isImportant: boolean, id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue' } | { __typename: 'RequestItIssue', id: number, sponsorId: string, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type ALL_CLOSED_REQUESTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order: InputMaybe<Array<RequestSortInput> | RequestSortInput>;
  where: RequestFilterInput;
}>;


export type ALL_CLOSED_REQUESTSQuery = { __typename: 'Query', closedItRequests: { __typename: 'ClosedItRequestsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Request', isImportant: boolean, id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue' } | { __typename: 'RequestItIssue', id: number, sponsorId: string, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type SEARCH_REQUESTQueryVariables = Exact<{
  query: Scalars['String']['input'];
  type: InputMaybe<RequestIssueType>;
}>;


export type SEARCH_REQUESTQuery = { __typename: 'Query', itRequestSearch: Array<{ __typename: 'Request', id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue' } | { __typename: 'RequestItIssue', id: number, sponsorId: string, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> };

export type RequestEventFragment = { __typename: 'RequestEvent', id: number, createdAt: string, type: RequestEventType, content: string, updatedAt: string | null, requestId: number, refRequestId: number | null, authorAdUserId: string, author: { __typename: 'SystemUser', id: string, fullName: string | null } | null };

export type FullRequestFragment = { __typename: 'Request', isSubscribed: boolean, isImportant: boolean, id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue', id: number, implantedOn: string, embryosPerFertilization: number | null, account: { __typename: 'Account', id: string, code: string | null, name: string | null } } | { __typename: 'RequestItIssue', id: number, sponsorId: string, sponsor: { __typename: 'SystemUser', id: string, fullName: string | null } | null, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, events: Array<{ __typename: 'RequestEvent', id: number, createdAt: string, type: RequestEventType, content: string, updatedAt: string | null, requestId: number, refRequestId: number | null, authorAdUserId: string, author: { __typename: 'SystemUser', id: string, fullName: string | null } | null }>, referencedIn: Array<{ __typename: 'RequestEvent', id: number, createdAt: string, type: RequestEventType, content: string, updatedAt: string | null, requestId: number, refRequestId: number | null, authorAdUserId: string, author: { __typename: 'SystemUser', id: string, fullName: string | null } | null }>, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null };

export type IT_REQUESTQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type IT_REQUESTQuery = { __typename: 'Query', itRequest: { __typename: 'Request', isSubscribed: boolean, isImportant: boolean, id: number, createdAt: string, updatedAt: string | null, type: RequestIssueType, title: string, content: string, requestorId: string, issue: { __typename: 'RequestClientIssue', id: number, implantedOn: string, embryosPerFertilization: number | null, account: { __typename: 'Account', id: string, code: string | null, name: string | null } } | { __typename: 'RequestItIssue', id: number, sponsorId: string, sponsor: { __typename: 'SystemUser', id: string, fullName: string | null } | null, app: { __typename: 'TogRequestApp', id: number, name: string }, department: { __typename: 'TogRequestDepartment', id: number, name: string } } | { __typename: 'RequestReportIssue' }, events: Array<{ __typename: 'RequestEvent', id: number, createdAt: string, type: RequestEventType, content: string, updatedAt: string | null, requestId: number, refRequestId: number | null, authorAdUserId: string, author: { __typename: 'SystemUser', id: string, fullName: string | null } | null }>, referencedIn: Array<{ __typename: 'RequestEvent', id: number, createdAt: string, type: RequestEventType, content: string, updatedAt: string | null, requestId: number, refRequestId: number | null, authorAdUserId: string, author: { __typename: 'SystemUser', id: string, fullName: string | null } | null }>, requestor: { __typename: 'SystemUser', id: string, fullName: string | null } | null } | null };

export type TOGGLE_SUBSCRIBEDMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TOGGLE_SUBSCRIBEDMutation = { __typename: 'Mutation', requestToggleSubscribed: { __typename: 'Request', id: number, isSubscribed: boolean } };

export type TOGGLE_IMPORTANTMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TOGGLE_IMPORTANTMutation = { __typename: 'Mutation', requestToggleImportant: { __typename: 'Request', id: number, isImportant: boolean } };

export type IT_APPSQueryVariables = Exact<{ [key: string]: never; }>;


export type IT_APPSQuery = { __typename: 'Query', itRequestApps: Array<{ __typename: 'TogRequestApp', id: number, name: string }> };

export type DEPARTMENTSQueryVariables = Exact<{ [key: string]: never; }>;


export type DEPARTMENTSQuery = { __typename: 'Query', itRequestDepartments: Array<{ __typename: 'TogRequestDepartment', id: number, name: string }> };

export type RequestIssueManagerFragment = { __typename: 'RequestIssueManager', id: number, issueType: RequestIssueType, adUserId: string, systemUser: { __typename: 'SystemUser', id: string, fullName: string | null } | null };

export type IT_REQUEST_ISSUE_MANAGERSQueryVariables = Exact<{ [key: string]: never; }>;


export type IT_REQUEST_ISSUE_MANAGERSQuery = { __typename: 'Query', requestIssueManagers: { __typename: 'RequestIssueManagersCollectionSegment', items: Array<{ __typename: 'RequestIssueManager', id: number, issueType: RequestIssueType, adUserId: string, systemUser: { __typename: 'SystemUser', id: string, fullName: string | null } | null }> | null } | null };

export type AD_USERSQueryVariables = Exact<{ [key: string]: never; }>;


export type AD_USERSQuery = { __typename: 'Query', adUsers: Array<{ __typename: 'AdUser', id: string, name: string }> };

export type AppFragment = { __typename: 'App', id: string, name: string, description: string, url: string, environmentId: number };

export type ADD_LEGACY_APPS_FAVORITEMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type ADD_LEGACY_APPS_FAVORITEMutation = { __typename: 'Mutation', addFavorite: Array<string> };

export type REMOVE_LEGACY_APPS_FAVORITEMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type REMOVE_LEGACY_APPS_FAVORITEMutation = { __typename: 'Mutation', removeFavorite: Array<string> };

export type REORDER_LEGACY_APPS_FAVORITESMutationVariables = Exact<{
  appIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type REORDER_LEGACY_APPS_FAVORITESMutation = { __typename: 'Mutation', reorderFavorites: Array<string> };

export type GET_ALL_LEGACY_APPSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_ALL_LEGACY_APPSQuery = { __typename: 'Query', apps: Array<{ __typename: 'App', id: string, name: string, description: string, url: string, environmentId: number }> };

export type GET_LEGACY_APPS_FAVORITESQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_LEGACY_APPS_FAVORITESQuery = { __typename: 'Query', appsFavorites: Array<string> };

export type UPDATE_ASPIRATION_OPU_SEARCHMutationVariables = Exact<{
  input: EmbryologistDataEntryInput;
  isReturn: Scalars['String']['input'];
}>;


export type UPDATE_ASPIRATION_OPU_SEARCHMutation = { __typename: 'Mutation', updateAspirationOpuSearch: boolean };

export type CREATE_NEW_ASP_POOLMutationVariables = Exact<{
  aspirationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  siteId: Scalars['String']['input'];
}>;


export type CREATE_NEW_ASP_POOLMutation = { __typename: 'Mutation', createNewAspPool: string };

export type REMOVE_ASP_POOLMutationVariables = Exact<{
  aspirationPoolIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type REMOVE_ASP_POOLMutation = { __typename: 'Mutation', removeAspPool: boolean };

export type SAVE_QC_DATA_OPUSEARCHMutationVariables = Exact<{
  input: QcDataOpuSearchInput;
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  location: InputMaybe<Scalars['String']['input']>;
}>;


export type SAVE_QC_DATA_OPUSEARCHMutation = { __typename: 'Mutation', updateQCDataOpuSearch: boolean };

export type GET_EQUIPMENTSQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_EQUIPMENTSQuery = { __typename: 'Query', equipments: { __typename: 'EquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', name: string, id: string }> | null } | null };

export type GET_ASPIRATION_BY_DONOR_AND_IDQueryVariables = Exact<{
  donorId: Scalars['UUID']['input'];
  aspirationId: Scalars['UUID']['input'];
}>;


export type GET_ASPIRATION_BY_DONOR_AND_IDQuery = { __typename: 'Query', aspirations: { __typename: 'AspirationsCollectionSegment', items: Array<{ __typename: 'Aspiration', id: string, ivmTime: string | null, aspDate: string | null, donorId: string | null, fertPlan: tog_fertplan | null, gradeA: number | null, gradeB: number | null, gradeC: number | null, gradeD: number | null, gradeE: number | null, dead: number | null, usdaSeal: string | null, ivmCyto: number | null, ivmMat: number | null, fshType: number | null, ivmComment: string | null, dishType: number | null, ivmTechnicianId: string | null }> | null } | null };

export type GET_COMPLETED_ASPIRATIONS_TODAYQueryVariables = Exact<{
  date: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
}>;


export type GET_COMPLETED_ASPIRATIONS_TODAYQuery = { __typename: 'Query', todaysCompletedAspirationsNew: Array<{ __typename: 'AspirationsToday', aspirationId: string | null, aspirationTime: string | null, account: string | null, csa: string | null, breed: string | null, donor: string | null, donorRegNum: string | null, sire: string | null, semenType: string | null, donorLocation: string | null, fertSite: string | null, pooled: string | null, export: string | null, nonEuComment: string | null, medTotal: string | null, totalOocytes: string | null, numInMat: string | null, csr: string | null, matTime: string | null, aspComments: string | null, poolNum: string | null, dsAspirationComment: string | null, programName: string | null, vetId: string | null, asstId: string | null, siteId: string | null, ivmId: string | null, ivmTech: string | null, ivmMat: number | null, ivmTime: string | null, aspirationDate: string | null, scheduleId: string | null, totalFollicles: string | null, ll: number | null, lm: number | null, ls: number | null, rl: number | null, rm: number | null, rs: number | null, cll: number | null, cystl: number | null, clr: number | null, cystr: number | null, comment: string | null, donorCondition: string | null, donorId: string | null, completeOrder: number | null, embCompleteOrder: number | null, opuTech: string | null, chuteTech: string | null, totalLeft: number | null, totalRight: number | null, fertPlan: number | null }> | null };

export type GET_COMPLETED_ASPIRATIONS_TODAY_FBDQueryVariables = Exact<{
  date: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  location: Scalars['String']['input'];
}>;


export type GET_COMPLETED_ASPIRATIONS_TODAY_FBDQuery = { __typename: 'Query', todaysCompletedAspirationsFBD: Array<{ __typename: 'AspirationsToday', aspirationId: string | null, aspirationTime: string | null, account: string | null, csa: string | null, breed: string | null, donor: string | null, sire: string | null, semenType: string | null, donorLocation: string | null, donorRegNum: string | null, fertSite: string | null, pooled: string | null, export: string | null, nonEuComment: string | null, medTotal: string | null, totalOocytes: string | null, numInMat: string | null, csr: string | null, matTime: string | null, aspComments: string | null, poolNum: string | null, dsAspirationComment: string | null, programName: string | null, vetId: string | null, asstId: string | null, siteId: string | null, ivmId: string | null, ivmTech: string | null, ivmMat: number | null, ivmTime: string | null, aspirationDate: string | null, scheduleId: string | null, totalFollicles: string | null, ll: number | null, lm: number | null, ls: number | null, rl: number | null, rm: number | null, rs: number | null, cll: number | null, cystl: number | null, clr: number | null, cystr: number | null, comment: string | null, donorCondition: string | null, donorId: string | null, completeOrder: number | null, embCompleteOrder: number | null, opuTech: string | null, chuteTech: string | null, totalLeft: number | null, totalRight: number | null, fertPlan: number | null }> | null };

export type GET_STATS_DATAQueryVariables = Exact<{
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  location: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_STATS_DATAQuery = { __typename: 'Query', statsData: { __typename: 'OpuStats', techCount: number | null, folliclesTotal: string | null, oocytesTotal: string | null, numInMatTotal: string | null, avgFolliclesTotal: string | null, avgOocytesTotal: string | null, avgNumInMatTotal: string | null, techStats: Array<{ __typename: 'OpuTechs', techId: string | null, tech: string | null, totalFollicles: string | null, totalgOocytes: string | null, totalNumInMat: string | null, avgFollicles: string | null, avgOocytes: string | null, avgNumInMat: string | null }> | null } };

export type GET_STATS_DATA_PSEQueryVariables = Exact<{
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  location: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_STATS_DATA_PSEQuery = { __typename: 'Query', statsDataPSE: { __typename: 'OpuStats', techCount: number | null, folliclesTotal: string | null, oocytesTotal: string | null, numInMatTotal: string | null, avgFolliclesTotal: string | null, avgOocytesTotal: string | null, avgNumInMatTotal: string | null, techStats: Array<{ __typename: 'OpuTechs', techId: string | null, tech: string | null, totalFollicles: string | null, totalgOocytes: string | null, totalNumInMat: string | null, avgFollicles: string | null, avgOocytes: string | null, avgNumInMat: string | null }> | null } };

export type GET_OPU_ENTRIESQueryVariables = Exact<{
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  techId: Scalars['String']['input'];
}>;


export type GET_OPU_ENTRIESQuery = { __typename: 'Query', entryData: Array<{ __typename: 'OpuEntries', donorName: string | null, follicles: string | null, oocytes: string | null, numInMat: string | null, ivmCyto: string | null, comment: string | null, aspTime: string | null, rowNo: number | null, aspirationId: string | null }> };

export type GET_OPU_ENTRIES_PSEQueryVariables = Exact<{
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  pseId: Scalars['String']['input'];
}>;


export type GET_OPU_ENTRIES_PSEQuery = { __typename: 'Query', entryDataPSE: Array<{ __typename: 'OpuEntries', donorName: string | null, follicles: string | null, oocytes: string | null, numInMat: string | null, ivmCyto: string | null, comment: string | null, aspTime: string | null, rowNo: number | null }> };

export type GET_TECH_AVG_DATAQueryVariables = Exact<{
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  techId: Scalars['String']['input'];
}>;


export type GET_TECH_AVG_DATAQuery = { __typename: 'Query', techAvgData: Array<{ __typename: 'Avgs', blank: string, follicles: string, oocytes: string, numInMat: string, blank1: string }> };

export type GET_AVG_DATAQueryVariables = Exact<{
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
}>;


export type GET_AVG_DATAQuery = { __typename: 'Query', avgData: Array<{ __typename: 'Avgs', blank: string, follicles: string, oocytes: string, numInMat: string, blank1: string }> };

export type GET_ASP_DATA_POOLQueryVariables = Exact<{
  aspirationDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
}>;


export type GET_ASP_DATA_POOLQuery = { __typename: 'Query', aspDataPool: Array<{ __typename: 'Pool', donorName: string, gradeAbc: string, gradeD: string, gradeE: string, aspirationId: string, ivmId: string, sireName: string | null, semenTypeName: string | null, semenName: string | null, donorScheduleId: string | null }> };

export type GET_ASPIRATION_POOLS_BY_DATE_AND_SITEQueryVariables = Exact<{
  siteId: Scalars['UUID']['input'];
  poolNumArray: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GET_ASPIRATION_POOLS_BY_DATE_AND_SITEQuery = { __typename: 'Query', aspirationPools: { __typename: 'AspirationPoolsCollectionSegment', items: Array<{ __typename: 'AspirationPool', id: string, name: string | null, poolNumber: number | null }> | null } | null };

export type GET_EMB_FERT_DATA_BY_DONOR_IDQueryVariables = Exact<{
  donorId: Scalars['UUID']['input'];
  ranch: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_EMB_FERT_DATA_BY_DONOR_IDQuery = { __typename: 'Query', embFertDataByDonorId: Array<{ __typename: 'FertilizationData', id: any | null, donorId: string | null, aspDate: string | null, sched: string | null, fsh: string | null, follL: string | null, follM: string | null, follS: string | null, follicles: string | null, gradeAbc: string | null, gradeD: string | null, gradeE: string | null, oocytes: string | null, fert: string | null, clv: string | null, viable: string | null, sire: string | null, sireId: string | null }> };

export type GET_TODAYS_QC_DATA_OPUSEARCHQueryVariables = Exact<{
  date: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  location: InputMaybe<Scalars['String']['input']>;
}>;


export type GET_TODAYS_QC_DATA_OPUSEARCHQuery = { __typename: 'Query', todaysQcDataOpuSearch: { __typename: 'QcDataOpuSearch', tog_qc_hepdate: string | null, tog_qc_matdate: string | null, tog_qc_opuholdingdate: string | null, tog_qc_opuholding: string | null, tog_qc_opuflushdate: string | null, tog_qc_opuflush: string | null, tog_qccomment: string | null, tog_qc_slide_warmer: string | null, tog_qc_tokai_hit: string | null, tog_qc_water_bath_temperature: string | null, tog_qcairqualityint: number | null, tog_qcairqualitystring: string | null, tog_qc_cellstrainer: string | null, tog_qc_fiftymllotno: string | null, tog_qc_thirtymlsyringe: string | null, tog_qc_tenmlsyringe: string | null, tog_qc_fiftymltubetype: string | null, qccompleted: boolean | null, tog_qc_rinsemedialotdate: string | null, tog_qc_incubatorno: string | null, tog_asp_date: string | null, tog_siteid: string | null, tog_qc_location: string | null, qcFreezetemp: string | null } };

export type REFRESH_STOP_GO_SIGNQueryVariables = Exact<{
  val: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
}>;


export type REFRESH_STOP_GO_SIGNQuery = { __typename: 'Query', refreshStopGoSign: boolean | null };

export type SHOW_STOP_SIGNQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type SHOW_STOP_SIGNQuery = { __typename: 'Query', showStopSign: boolean };

export type PULL_SEMENMutationVariables = Exact<{
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
  semenId: Scalars['UUID']['input'];
  moveNum: Scalars['Int']['input'];
  semenType: Scalars['String']['input'];
  accountId: Scalars['UUID']['input'];
  semenOwnerId: Scalars['UUID']['input'];
  dsSemenLocId: Scalars['UUID']['input'];
}>;


export type PULL_SEMENMutation = { __typename: 'Mutation', pullSemen: { __typename: 'PullSemenPayload', code: number, success: boolean, message: string | null, semenId: string | null } };

export type RETURN_SEMENMutationVariables = Exact<{
  SemenId: Scalars['UUID']['input'];
  ReturnNum: Scalars['Int']['input'];
  SemenType: Scalars['String']['input'];
}>;


export type RETURN_SEMENMutation = { __typename: 'Mutation', returnSemen: { __typename: 'ReturnSemenPayload', code: number, success: boolean, message: string | null, semenId: string | null } };

export type REJECT_DISCARD_SEMENMutationVariables = Exact<{
  SemenId: Scalars['UUID']['input'];
  RejectNum: Scalars['Int']['input'];
  SemenType: Scalars['String']['input'];
  Description: Scalars['String']['input'];
}>;


export type REJECT_DISCARD_SEMENMutation = { __typename: 'Mutation', rejectDiscardSemen: { __typename: 'RejectDiscardSemenPayload', code: number, success: boolean, message: string | null, semenId: string | null } };

export type PULL_OD_SEMENMutationVariables = Exact<{
  semenId: Scalars['UUID']['input'];
  semenType: Scalars['String']['input'];
  moveNum: Scalars['Int']['input'];
}>;


export type PULL_OD_SEMENMutation = { __typename: 'Mutation', pullODSemen: { __typename: 'PullSemenPayload', code: number, success: boolean, message: string | null } };

export type CREATE_NEW_SEMENMutationVariables = Exact<{
  newSemen: NewSemenInput;
}>;


export type CREATE_NEW_SEMENMutation = { __typename: 'Mutation', createNewSemen: { __typename: 'CreateNewSemenPayload', code: number, success: boolean, message: string | null, semenId: string | null } };

export type UPDATE_SEMENMutationVariables = Exact<{
  newSemen: UpdateSemenInput;
}>;


export type UPDATE_SEMENMutation = { __typename: 'Mutation', updateSemen: { __typename: 'UpdateSemenPayload', code: number, success: boolean, message: string | null } };

export type UPDATE_DS_SUGGESTEDMutationVariables = Exact<{
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
  semenId: InputMaybe<Scalars['UUID']['input']>;
  semenType: InputMaybe<Scalars['String']['input']>;
  sireId: Scalars['UUID']['input'];
  accountId: InputMaybe<Scalars['UUID']['input']>;
  dsSemenLocId: InputMaybe<Scalars['UUID']['input']>;
}>;


export type UPDATE_DS_SUGGESTEDMutation = { __typename: 'Mutation', updateDSSuggested: { __typename: 'UpdateSemenPayload', code: number, success: boolean, message: string | null } };

export type SCHEDULED_SEMENQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  fertilizationSiteId: Scalars['UUID']['input'];
}>;


export type SCHEDULED_SEMENQuery = { __typename: 'Query', scheduledSemen: Array<{ __typename: 'ScheduledSemen', row: number | null, semenId: string | null, semenName: string | null, sireId: string | null, sireName: string | null, sireRegNum: string | null, donors_Sire: number, semenTypeName: string | null, semenSexed: string | null, semenSex: string | null, name_Type: string | null, accountId: string | null, accountName: string | null, semenOwnerId: string | null, semenStorageId: string | null, semenStorageName: string | null, semenStorageSiteName: string | null, cane: string | null, colCode: string | null, naab: string | null, quantity: number | null, suggestedToPull: number | null, exportName: string | null, comment: string | null, transactionToday: string | null, moveNum: number | null, separateFert: boolean | null }> };

export type GET_PULLED_SEMENQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  fertilizationSiteId: Scalars['UUID']['input'];
}>;


export type GET_PULLED_SEMENQuery = { __typename: 'Query', getPulledSemen: Array<{ __typename: 'PulledSemen', rowNum: number, semenId: string | null, semenName: string | null, sireId: string | null, sireName: string | null, donors_Sire: number | null, semenTypeName: string | null, name_Type: string | null, accountId: string | null, accountName: string | null, semenStorageId: string | null, semenStorageName: string | null, semenStorageSiteName: string | null, cane: string | null, colCode: string | null, naab: string | null, quantity: number | null, exportName: string | null, pulledQuantity: number | null, transactionToday: string | null, returnNum: number | null }> };

export type GET_SCHEDULED_DONORSQueryVariables = Exact<{
  DonorScheduleDate: Scalars['DateTime']['input'];
  fertilizationSiteId: Scalars['UUID']['input'];
  SemenId: InputMaybe<Scalars['UUID']['input']>;
  SemenType: InputMaybe<Scalars['String']['input']>;
  SireId: Scalars['UUID']['input'];
  AccountId: InputMaybe<Scalars['UUID']['input']>;
  DSSemenLocId: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GET_SCHEDULED_DONORSQuery = { __typename: 'Query', getScheduledDonors: Array<{ __typename: 'ScheduledDonorType', csr: string | null, donorName: string | null, donorScheduleID: string }> };

export type GET_UNFINISHED_SCHEDULED_DONORSQueryVariables = Exact<{
  donorScheduleDate: Scalars['DateTime']['input'];
  fertSiteId: Scalars['UUID']['input'];
}>;


export type GET_UNFINISHED_SCHEDULED_DONORSQuery = { __typename: 'Query', getUnfinishedScheduledDonors: Array<{ __typename: 'ScheduledDonorType', csr: string | null, donorName: string | null, donorScheduleID: string }> };

export type GET_OD_SIMILAR_SEMENQueryVariables = Exact<{
  fertSiteId: Scalars['UUID']['input'];
  semenName: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  caneCode: Scalars['String']['input'];
  colCode: Scalars['String']['input'];
}>;


export type GET_OD_SIMILAR_SEMENQuery = { __typename: 'Query', odSimilarSemen: Array<{ __typename: 'ODSemen', semenID: string, semenName: string | null, semenTypeName: string | null, accountName: string | null, cane: string | null, colCode: string | null, semenStorageName: string | null, quantity: number | null }> };

export type GET_OD_SEMENQueryVariables = Exact<{
  fertSiteId: Scalars['UUID']['input'];
  semenName: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  caneCode: Scalars['String']['input'];
  colCode: Scalars['String']['input'];
}>;


export type GET_OD_SEMENQuery = { __typename: 'Query', odSemen: Array<{ __typename: 'ODSemen', semenID: string, semenName: string | null, semenTypeName: string | null, accountName: string | null, cane: string | null, colCode: string | null, semenStorageName: string | null, quantity: number | null }> };

export type STRING_MAP_SEARCHQueryVariables = Exact<{
  objectTypeCode: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type STRING_MAP_SEARCHQuery = { __typename: 'Query', stringMap: Array<{ __typename: 'KeyValuePairOfInt32AndNullableString', key: number, value: string | null }> | null };

export type STORAGE_LOCATIONSQueryVariables = Exact<{
  fertSiteId: Scalars['UUID']['input'];
}>;


export type STORAGE_LOCATIONSQuery = { __typename: 'Query', storageLocations: { __typename: 'StorageLocationsCollectionSegment', items: Array<{ __typename: 'StorageLocation', id: string, name: string | null }> | null } | null };

export type UPDATE_SHIPMENTMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateShipmentInput;
}>;


export type UPDATE_SHIPMENTMutation = { __typename: 'Mutation', updateShipment: { __typename: 'Shipment', id: string, stateCode: number, ownerId: string | null, billTo: string | null, billStatus: number | null, callTag: string | null, comment: string | null, createdOn: string | null, modifiedOn: string | null, date: string | null, email: string | null, hasEmbryos: boolean | null, hasSemen: boolean | null, hasDonors: boolean | null, hasRecipients: boolean | null, hasCalves: boolean | null, needByDate: string | null, originalNeedByDate: string | null, packedById: string | null, phone: string | null, requestedBy: string | null, shipAddress: string | null, shipAddress2: string | null, shipAddress3: string | null, shipCity: string | null, shipFromSiteId: string | null, shipmentNumber: string | null, shipmentStatus: number | null, shipmentStatusValue: string | null, shipName: string | null, shippingMethod: number | null, shippingMethodValue: string | null, shipState: string | null, shipToId: string | null, shipZip: string | null, tank: string | null, trackingNumber: string | null, amount: number | null, shipmentCategory: number | null, owner: { __typename: 'Account', id: string, code: string | null, name: string | null, aging30: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, aging365Plus: number | null, ranchAddress: { __typename: 'CustomerAddress', id: string, country: string | null } | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, modifiedBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, packedBy: { __typename: 'Equipment', id: string, name: string, siteId: string | null } | null, shipFromSite: { __typename: 'Site', id: string, name: string } | null, shipTo: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, recaneEmbryos: Array<{ __typename: 'Embryo', id: string, cane: string | null, name: string | null, creation: string | null }> } | null };

export type SHIPPING_SET_IN_PROGRESSMutationVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
  packedById: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SHIPPING_SET_IN_PROGRESSMutation = { __typename: 'Mutation', shipping_setInProgress: { __typename: 'Shipment', id: string, shipmentStatus: number | null, shipmentStatusValue: string | null, packedById: string | null, packedBy: { __typename: 'Equipment', id: string, name: string, siteId: string | null } | null } };

export type CREATE_SHIPPING_FORM_REPORTMutationVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
  sendEmail: Scalars['Boolean']['input'];
}>;


export type CREATE_SHIPPING_FORM_REPORTMutation = { __typename: 'Mutation', createShippingFormReport: string };

export type SHIPPING_RUN_SHIPMutationVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type SHIPPING_RUN_SHIPMutation = { __typename: 'Mutation', shipping_runShip: boolean };

export type SHIPPING_RUN_SHIP_INTRAMutationVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type SHIPPING_RUN_SHIP_INTRAMutation = { __typename: 'Mutation', shipping_runShipIntra: boolean };

export type SHIPPING_RUN_SHIP_INTRA_YACKLEYMutationVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type SHIPPING_RUN_SHIP_INTRA_YACKLEYMutation = { __typename: 'Mutation', shipping_runShipIntraYackley: boolean };

export type ShippingShipmentFragment = { __typename: 'Shipment', id: string, stateCode: number, shipmentNumber: string | null, hasEmbryos: boolean | null, hasSemen: boolean | null, hasCalves: boolean | null, hasRecipients: boolean | null, hasDonors: boolean | null, needByDate: string | null, shipFromSiteId: string | null, tank: string | null, shipmentStatus: number | null, shipmentStatusValue: string | null, shippingMethod: number | null, shippingMethodValue: string | null, comment: string | null, createdOn: string | null, date: string | null, shipName: string | null, shipState: string | null, trackingNumber: string | null, shipTo: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, owner: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, packedBy: { __typename: 'Equipment', id: string, name: string, siteId: string | null } | null, recaneEmbryos: Array<{ __typename: 'Embryo', id: string, cane: string | null, name: string | null, creation: string | null }> };

export type SHIPPING_SHIPMENTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  order: InputMaybe<Array<ShipmentSortInput> | ShipmentSortInput>;
  where: ShipmentFilterInput;
}>;


export type SHIPPING_SHIPMENTSQuery = { __typename: 'Query', shipments: { __typename: 'ShipmentsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Shipment', id: string, stateCode: number, shipmentNumber: string | null, hasEmbryos: boolean | null, hasSemen: boolean | null, hasCalves: boolean | null, hasRecipients: boolean | null, hasDonors: boolean | null, needByDate: string | null, shipFromSiteId: string | null, tank: string | null, shipmentStatus: number | null, shipmentStatusValue: string | null, shippingMethod: number | null, shippingMethodValue: string | null, comment: string | null, createdOn: string | null, date: string | null, shipName: string | null, shipState: string | null, trackingNumber: string | null, shipTo: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, owner: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, packedBy: { __typename: 'Equipment', id: string, name: string, siteId: string | null } | null, recaneEmbryos: Array<{ __typename: 'Embryo', id: string, cane: string | null, name: string | null, creation: string | null }> }> | null } | null };

export type ALL_SHIPMENTSQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: InputMaybe<Scalars['Int']['input']>;
  order: InputMaybe<Array<ShipmentSortInput> | ShipmentSortInput>;
  where: ShipmentFilterInput;
}>;


export type ALL_SHIPMENTSQuery = { __typename: 'Query', allShipments: { __typename: 'AllShipmentsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Shipment', id: string, stateCode: number, shipmentNumber: string | null, hasEmbryos: boolean | null, hasSemen: boolean | null, hasCalves: boolean | null, hasRecipients: boolean | null, hasDonors: boolean | null, needByDate: string | null, shipFromSiteId: string | null, tank: string | null, shipmentStatus: number | null, shipmentStatusValue: string | null, shippingMethod: number | null, shippingMethodValue: string | null, comment: string | null, createdOn: string | null, date: string | null, shipName: string | null, shipState: string | null, trackingNumber: string | null, shipTo: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, owner: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, packedBy: { __typename: 'Equipment', id: string, name: string, siteId: string | null } | null, recaneEmbryos: Array<{ __typename: 'Embryo', id: string, cane: string | null, name: string | null, creation: string | null }> }> | null } | null };

export type ShippingAccountSearchFragment = { __typename: 'Account', id: string, code: string | null, name: string | null, aging30: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, aging365Plus: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, ranchAddress: { __typename: 'CustomerAddress', id: string, line1: string | null, line2: string | null, line3: string | null, city: string | null, stateOrProvince: string | null, postalCode: string | null } | null };

export type SHIPPING_ACCOUNT_SEARCHQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SHIPPING_ACCOUNT_SEARCHQuery = { __typename: 'Query', results: { __typename: 'AccountsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Account', id: string, code: string | null, name: string | null, aging30: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, aging365Plus: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, ranchAddress: { __typename: 'CustomerAddress', id: string, line1: string | null, line2: string | null, line3: string | null, city: string | null, stateOrProvince: string | null, postalCode: string | null } | null }> | null } | null };

export type ShippingEquipmentSearchFragment = { __typename: 'Equipment', id: string, name: string, siteId: string | null };

export type SHIPPING_EQUIPMENT_SEARCHQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SHIPPING_EQUIPMENT_SEARCHQuery = { __typename: 'Query', results: { __typename: 'EquipmentsCollectionSegment', totalCount: number, items: Array<{ __typename: 'Equipment', id: string, name: string, siteId: string | null }> | null } | null };

export type ShippingSiteSearchFragment = { __typename: 'Site', id: string, name: string };

export type SHIPPING_SITESQueryVariables = Exact<{ [key: string]: never; }>;


export type SHIPPING_SITESQuery = { __typename: 'Query', sites: { __typename: 'SitesCollectionSegment', totalCount: number, items: Array<{ __typename: 'Site', id: string, name: string }> | null } | null };

export type SHIPPING_SITE_SEARCHQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SHIPPING_SITE_SEARCHQuery = { __typename: 'Query', results: { __typename: 'SitesCollectionSegment', totalCount: number, items: Array<{ __typename: 'Site', id: string, name: string }> | null } | null };

export type ShipmentFragment = { __typename: 'Shipment', id: string, stateCode: number, ownerId: string | null, billTo: string | null, billStatus: number | null, callTag: string | null, comment: string | null, createdOn: string | null, modifiedOn: string | null, date: string | null, email: string | null, hasEmbryos: boolean | null, hasSemen: boolean | null, hasDonors: boolean | null, hasRecipients: boolean | null, hasCalves: boolean | null, needByDate: string | null, originalNeedByDate: string | null, packedById: string | null, phone: string | null, requestedBy: string | null, shipAddress: string | null, shipAddress2: string | null, shipAddress3: string | null, shipCity: string | null, shipFromSiteId: string | null, shipmentNumber: string | null, shipmentStatus: number | null, shipmentStatusValue: string | null, shipName: string | null, shippingMethod: number | null, shippingMethodValue: string | null, shipState: string | null, shipToId: string | null, shipZip: string | null, tank: string | null, trackingNumber: string | null, amount: number | null, shipmentCategory: number | null, owner: { __typename: 'Account', id: string, code: string | null, name: string | null, aging30: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, aging365Plus: number | null, ranchAddress: { __typename: 'CustomerAddress', id: string, country: string | null } | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, modifiedBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, packedBy: { __typename: 'Equipment', id: string, name: string, siteId: string | null } | null, shipFromSite: { __typename: 'Site', id: string, name: string } | null, shipTo: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, recaneEmbryos: Array<{ __typename: 'Embryo', id: string, cane: string | null, name: string | null, creation: string | null }> };

export type SHIPMENTQueryVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type SHIPMENTQuery = { __typename: 'Query', shipment: { __typename: 'Shipment', id: string, stateCode: number, ownerId: string | null, billTo: string | null, billStatus: number | null, callTag: string | null, comment: string | null, createdOn: string | null, modifiedOn: string | null, date: string | null, email: string | null, hasEmbryos: boolean | null, hasSemen: boolean | null, hasDonors: boolean | null, hasRecipients: boolean | null, hasCalves: boolean | null, needByDate: string | null, originalNeedByDate: string | null, packedById: string | null, phone: string | null, requestedBy: string | null, shipAddress: string | null, shipAddress2: string | null, shipAddress3: string | null, shipCity: string | null, shipFromSiteId: string | null, shipmentNumber: string | null, shipmentStatus: number | null, shipmentStatusValue: string | null, shipName: string | null, shippingMethod: number | null, shippingMethodValue: string | null, shipState: string | null, shipToId: string | null, shipZip: string | null, tank: string | null, trackingNumber: string | null, amount: number | null, shipmentCategory: number | null, owner: { __typename: 'Account', id: string, code: string | null, name: string | null, aging30: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, aging365Plus: number | null, ranchAddress: { __typename: 'CustomerAddress', id: string, country: string | null } | null } | null, createdBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, modifiedBy: { __typename: 'SystemUser', id: string, fullName: string | null } | null, packedBy: { __typename: 'Equipment', id: string, name: string, siteId: string | null } | null, shipFromSite: { __typename: 'Site', id: string, name: string } | null, shipTo: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, recaneEmbryos: Array<{ __typename: 'Embryo', id: string, cane: string | null, name: string | null, creation: string | null }> } | null };

export type ShipmentEmbryoFragment = { __typename: 'Embryo', id: string, fertilizationId: string | null, status: number | null, freshFrozen: number | null, ownerId: string | null, soldTo: string | null, strawDisclaimer: string | null, strawNumber: number | null, cane: string | null, stage: number | null, grade: number | null, storageLocationId: string | null, siteId: string | null, shipmentId: string | null, creation: string | null, stateCode: number, statusCode: number | null, lastAct: string | null, name: string | null, statusValue: string | null, methodValue: string | null, sex: number | null, donorId: string | null, sireId: string | null, embTag: string | null, breedId: string | null, freshStrawNo: number | null, freezeMethodId: string | null, freezer: string | null, dtPlus: boolean | null, tt: boolean | null, freezeComment: string | null, export: number | null, freezeTechId: string | null, recoveryFirmCode: string | null, freezeTime: string | null, receivedOn: string | null, grader7Id: string | null, crackedZona: boolean | null, owner: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, storageLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null, site: { __typename: 'Site', id: string, name: string } | null, donor: { __typename: 'Donor', id: string, name: string | null } | null, sire: { __typename: 'Sire', id: string, name: string | null } | null, freezeMethod: { __typename: 'OptionSet', name: string | null } | null };

export type EMBRYOSQueryVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type EMBRYOSQuery = { __typename: 'Query', embryos: { __typename: 'EmbryosCollectionSegment', items: Array<{ __typename: 'Embryo', id: string, fertilizationId: string | null, status: number | null, freshFrozen: number | null, ownerId: string | null, soldTo: string | null, strawDisclaimer: string | null, strawNumber: number | null, cane: string | null, stage: number | null, grade: number | null, storageLocationId: string | null, siteId: string | null, shipmentId: string | null, creation: string | null, stateCode: number, statusCode: number | null, lastAct: string | null, name: string | null, statusValue: string | null, methodValue: string | null, sex: number | null, donorId: string | null, sireId: string | null, embTag: string | null, breedId: string | null, freshStrawNo: number | null, freezeMethodId: string | null, freezer: string | null, dtPlus: boolean | null, tt: boolean | null, freezeComment: string | null, export: number | null, freezeTechId: string | null, recoveryFirmCode: string | null, freezeTime: string | null, receivedOn: string | null, grader7Id: string | null, crackedZona: boolean | null, owner: { __typename: 'Account', id: string, code: string | null, name: string | null } | null, storageLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null, site: { __typename: 'Site', id: string, name: string } | null, donor: { __typename: 'Donor', id: string, name: string | null } | null, sire: { __typename: 'Sire', id: string, name: string | null } | null, freezeMethod: { __typename: 'OptionSet', name: string | null } | null }> | null } | null };

export type ShipmentSemenFragment = { __typename: 'Semen', id: string, name: string | null, cane: string | null, togCane: string | null, quantity: number | null, quantityToShip: number | null, sexed: boolean | null, sex: number | null, concentration: number | null, cost: number | null, dateReceived: string | null, colCode: string | null, soldTo: string | null, storageLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null, sire: { __typename: 'Sire', id: string, name: string | null } | null };

export type SEMENQueryVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type SEMENQuery = { __typename: 'Query', semen: { __typename: 'SemenCollectionSegment', items: Array<{ __typename: 'Semen', id: string, name: string | null, cane: string | null, togCane: string | null, quantity: number | null, quantityToShip: number | null, sexed: boolean | null, sex: number | null, concentration: number | null, cost: number | null, dateReceived: string | null, colCode: string | null, soldTo: string | null, storageLocation: { __typename: 'StorageLocation', id: string, name: string | null } | null, sire: { __typename: 'Sire', id: string, name: string | null } | null }> | null } | null };

export type ShipmentDonorFragment = { __typename: 'Donor', id: string };

export type DONORSQueryVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type DONORSQuery = { __typename: 'Query', donors: { __typename: 'DonorsCollectionSegment', items: Array<{ __typename: 'Donor', id: string }> | null } | null };

export type ShipmentRecipientFragment = { __typename: 'Recipient', id: string, received: string | null, activityDate: string | null, lastActivity: string | null, metalTag: string | null, owner: { __typename: 'Account', name: string | null } | null, yard: { __typename: 'Yard', yard: string | null, name: string | null } | null, recipientStatus: { __typename: 'OptionSet', name: string | null } | null };

export type RECIPIENTSQueryVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type RECIPIENTSQuery = { __typename: 'Query', recipients: { __typename: 'RecipientsCollectionSegment', items: Array<{ __typename: 'Recipient', id: string, received: string | null, activityDate: string | null, lastActivity: string | null, metalTag: string | null, owner: { __typename: 'Account', name: string | null } | null, yard: { __typename: 'Yard', yard: string | null, name: string | null } | null, recipientStatus: { __typename: 'OptionSet', name: string | null } | null }> | null } | null };

export type ShipmentCalfFragment = { __typename: 'Calf', id: string, method: number | null, tattoo: string | null, sex: number | null, birth: string | null, ship: string | null, createdOn: string | null, owner: { __typename: 'Account', name: string | null, code: string | null } | null, donor: { __typename: 'Donor', name: string | null } | null, recipient: { __typename: 'Recipient', tag: string | null } | null, status: { __typename: 'OptionSet', name: string | null } | null, yard: { __typename: 'Yard', name: string | null } | null, pen: { __typename: 'Pen', name: string | null } | null };

export type GET_CALVESQueryVariables = Exact<{
  shipmentId: Scalars['UUID']['input'];
}>;


export type GET_CALVESQuery = { __typename: 'Query', calves: { __typename: 'CalvesCollectionSegment', items: Array<{ __typename: 'Calf', id: string, method: number | null, tattoo: string | null, sex: number | null, birth: string | null, ship: string | null, createdOn: string | null, owner: { __typename: 'Account', name: string | null, code: string | null } | null, donor: { __typename: 'Donor', name: string | null } | null, recipient: { __typename: 'Recipient', tag: string | null } | null, status: { __typename: 'OptionSet', name: string | null } | null, yard: { __typename: 'Yard', name: string | null } | null, pen: { __typename: 'Pen', name: string | null } | null }> | null } | null };

export type SHIPPING_ACCOUNT_DETAILSQueryVariables = Exact<{
  accountId: Scalars['UUID']['input'];
}>;


export type SHIPPING_ACCOUNT_DETAILSQuery = { __typename: 'Query', account: { __typename: 'Account', id: string, code: string | null, name: string | null, aging30: number | null, aging60: number | null, aging90: number | null, aging120: number | null, aging180: number | null, aging365: number | null, aging365Plus: number | null, tog90daysPastDue: number | null, tog90DayOverrideExpireDate: string | null, customerServiceRepresentative: { __typename: 'SystemUser', id: string, fullName: string | null } | null, billingAddress: { __typename: 'CustomerAddress', id: string, composite: string | null } | null, ranchAddress: { __typename: 'CustomerAddress', id: string, composite: string | null } | null, annotations: Array<{ __typename: 'Annotation', id: string, createdOn: string | null, noteText: string | null, owner: { __typename: 'OwnerBase', id: string, name: string | null } }> } | null };

export type STRIPPING_UPDATE_FERTILIZATIONMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateFertilizationInput;
  timeZone: Scalars['String']['input'];
}>;


export type STRIPPING_UPDATE_FERTILIZATIONMutation = { __typename: 'Mutation', updateFertilization: { __typename: 'Fertilization', id: string } | null };

export type StrippingFertilizationFragment = { __typename: 'Fertilization', id: string, qcCultureIncubator: string | null, ivcNumber: number | null, ivfNumber: number | null, ivcBroken: number | null, ivcDead: number | null, ivcMissing: number | null, ivcImmature: number | null, ivcExtra: number | null, hasNoMotileSperm: boolean | null, hasFewMotileSperm: boolean | null, isHardToStrip: boolean | null, isFragile: boolean | null, hasTwoCellCleavage: boolean | null, hasPoorCytoplasmQuality: boolean | null, contaminationInFert: tog_contaminations | null, stripperTipLotNumber: string | null, ivcComment: string | null, ivfDate: string | null, strippedAt: string | null, donorSchedule: { __typename: 'DonorSchedule', id: string, semenType: number | null, semenTypeValue: string | null, donor: { __typename: 'Donor', id: string, name: string | null } | null, sire: { __typename: 'Sire', id: string, name: string | null } | null } | null, semen: { __typename: 'Semen', colCode: string | null } | null, qcIncubator: { __typename: 'incubators', id: string, name: string | null } | null, ivcTechnician: { __typename: 'Equipment', id: string, name: string } | null, aspirationPool: { __typename: 'AspirationPool', id: string, name: string | null, donorsInPool: string | null } | null, breed: { __typename: 'Breed', id: string, color: string | null } | null };

export type STRIPPING_FERTILIZATONSQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  siteId: InputMaybe<Scalars['UUID']['input']>;
  timeZone: Scalars['String']['input'];
}>;


export type STRIPPING_FERTILIZATONSQuery = { __typename: 'Query', strippingFertilizations: { __typename: 'StrippingFertilizationsCollectionSegment', items: Array<{ __typename: 'Fertilization', id: string, qcCultureIncubator: string | null, ivcNumber: number | null, ivfNumber: number | null, ivcBroken: number | null, ivcDead: number | null, ivcMissing: number | null, ivcImmature: number | null, ivcExtra: number | null, hasNoMotileSperm: boolean | null, hasFewMotileSperm: boolean | null, isHardToStrip: boolean | null, isFragile: boolean | null, hasTwoCellCleavage: boolean | null, hasPoorCytoplasmQuality: boolean | null, contaminationInFert: tog_contaminations | null, stripperTipLotNumber: string | null, ivcComment: string | null, ivfDate: string | null, strippedAt: string | null, donorSchedule: { __typename: 'DonorSchedule', id: string, semenType: number | null, semenTypeValue: string | null, donor: { __typename: 'Donor', id: string, name: string | null } | null, sire: { __typename: 'Sire', id: string, name: string | null } | null } | null, semen: { __typename: 'Semen', colCode: string | null } | null, qcIncubator: { __typename: 'incubators', id: string, name: string | null } | null, ivcTechnician: { __typename: 'Equipment', id: string, name: string } | null, aspirationPool: { __typename: 'AspirationPool', id: string, name: string | null, donorsInPool: string | null } | null, breed: { __typename: 'Breed', id: string, color: string | null } | null }> | null } | null };

export type STRIPPING_TECHNICIANSQueryVariables = Exact<{
  where: EquipmentFilterInput;
}>;


export type STRIPPING_TECHNICIANSQuery = { __typename: 'Query', currentEquipments: { __typename: 'CurrentEquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', id: string, name: string }> | null } | null };

export type ALL_STRIPPING_TECHNICIANSQueryVariables = Exact<{ [key: string]: never; }>;


export type ALL_STRIPPING_TECHNICIANSQuery = { __typename: 'Query', equipments: { __typename: 'EquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', id: string, name: string }> | null } | null };

export type ME_EQUIPMENTSQueryVariables = Exact<{ [key: string]: never; }>;


export type ME_EQUIPMENTSQuery = { __typename: 'Query', me: { __typename: 'SystemUser', id: string, equipments: { __typename: 'EquipmentsCollectionSegment', items: Array<{ __typename: 'Equipment', id: string }> | null } | null } | null };

export type MEQueryVariables = Exact<{ [key: string]: never; }>;


export type MEQuery = { __typename: 'Query', me: { __typename: 'SystemUser', id: string, adUserId: string, username: string | null, fullName: string | null, internalEmailAddress: string | null, groups: Array<string>, issueManagerTypes: Array<RequestIssueType>, environmentId: number | null, environment: string | null, country: string | null } | null };

export type SystemUserPreviewFragment = { __typename: 'SystemUser', id: string, fullName: string | null, internalEmailAddress: string | null };

export type GET_ASPIRATION_SITESQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_ASPIRATION_SITESQuery = { __typename: 'Query', aspirationSites: Array<{ __typename: 'AspirationSite', id: string, name: string, fertilizationSiteId: string | null, fertilizationSite: { __typename: 'Site', id: string, name: string } | null }> };

export type GET_FERTILIZATION_SITESQueryVariables = Exact<{ [key: string]: never; }>;


export type GET_FERTILIZATION_SITESQuery = { __typename: 'Query', sites: { __typename: 'SitesCollectionSegment', items: Array<{ __typename: 'Site', id: string, name: string }> | null } | null };

export type GET_SITE_BY_IDQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GET_SITE_BY_IDQuery = { __typename: 'Query', sites: { __typename: 'SitesCollectionSegment', items: Array<{ __typename: 'Site', id: string, name: string }> | null } | null };

export type STRING_MAP_REQUESTQueryVariables = Exact<{
  objectTypeCode: Scalars['Int']['input'];
  attributeName: Scalars['String']['input'];
}>;


export type STRING_MAP_REQUESTQuery = { __typename: 'Query', stringMaps: { __typename: 'StringMapsCollectionSegment', items: Array<{ __typename: 'StringMap', attributeValue: number, value: string | null }> | null } | null };

export type STRING_MAPQueryVariables = Exact<{
  objectTypeCode: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type STRING_MAPQuery = { __typename: 'Query', stringMap: Array<{ __typename: 'KeyValuePairOfInt32AndNullableString', label: string | null, value: number }> | null };

export type SEND_REPORT_EMAILMutationVariables = Exact<{
  reportUrl: Scalars['String']['input'];
  subject: InputMaybe<Scalars['String']['input']>;
  message: InputMaybe<Scalars['String']['input']>;
  recipients: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SEND_REPORT_EMAILMutation = { __typename: 'Mutation', sendReportEmail: boolean };

export const BreedFieldsFragmentDoc = `
    fragment BreedFields on Breed {
  id
  code
  name
  frameSize
  type
}
    `;
export const SearchSemenByAccountFragmentDoc = `
    fragment SearchSemenByAccount on Semen {
  id
  name
  sire {
    id
    name
    breed {
      id
      code
      name
    }
    registrationNumber
    cane
  }
  cane
  colCode
  naab
  semenType
  storageLocation {
    id
    name
  }
}
    `;
export const AspirationInformationFragmentDoc = `
    fragment AspirationInformation on Aspiration {
  siteId
  id
  aspTime
  aspDate
  donorId
  fertPlan
  nextScheduleMasterId
  scheduleMasterId
  nofollll
  nofolllm
  nofollls
  totfolll
  cll
  cystl
  nofollrl
  nofollrm
  nofollrs
  totfollr
  clr
  cystr
  comment
  qcComment
  cdComment
  ivmComment
  qcCommentChuteside
  comment
  completeOrder
  fertPlan
  donor {
    id
    name
    birth
    pregnant
    lastBred
    pregnantValue
    condition
  }
  assistant {
    id
    name
  }
  ivmTechnician {
    id
    name
  }
  technician {
    id
    name
  }
  owner {
    name
  }
}
    `;
export const PartnershipAccountFullFragmentDoc = `
    fragment PartnershipAccountFull on Account {
  id
  code
  name
  aging60
  aging90
  aging120
  aging180
  aging365
  tog90daysPastDue
  tog90DayOverrideExpireDate
  accountStatus
}
    `;
export const PartnershipFragmentDoc = `
    fragment Partnership on Partnership {
  id
  name
  type
  account1Id
  account1 {
    ...PartnershipAccountFull
  }
  account2Id
  account2 {
    ...PartnershipAccountFull
  }
  account3Id
  account3 {
    ...PartnershipAccountFull
  }
  account4Id
  account4 {
    ...PartnershipAccountFull
  }
  percent1
  percent2
  percent3
  percent4
  oddEven1
  oddEven2
  oddEven3
  oddEven4
  donorId
  donor {
    name
    owner {
      name
    }
  }
  viewOnline1
  viewOnline2
  viewOnline3
  viewOnline4
  donorScheduleId
  stateCode
}
    ${PartnershipAccountFullFragmentDoc}`;
export const DonorFragmentDoc = `
    fragment Donor on Donor {
  id
  name
  owner {
    id
    code
  }
  donorSchedule {
    id
  }
  partnerships {
    ...Partnership
  }
}
    ${PartnershipFragmentDoc}`;
export const DonorScheduleGeneralFragmentDoc = `
    fragment DonorScheduleGeneral on DonorSchedule {
  aspirationSiteId
  aspirationSite {
    id
    name
  }
  date
  ownerId
  owner {
    id
    name
    code
    tog90daysPastDue
    priceTier
    aging60
    aging90
    aging120
    aging180
    aging365
    tog90DayOverrideExpireDate
    accountStatus
    isPwp
  }
  donorId
  donor {
    id
    name
    registrationNumber
    ownerships {
      id
      name
      endDate
      billed
      viewOnline
      beginDate
      percentage
    }
    yardId
    yard {
      id
      name
    }
    birth
    breed {
      id
      name
      code
      subFamily
    }
    nm
    psi
  }
  donorLocation
  procedureTime
  procedureTimeComment
  programName
  freezeInstructions
  fertilizationSiteId
  fertilizationSite {
    id
    name
  }
  priority
  textingAccountId
  textingAccount {
    id
    name
    code
  }
  textingNumber
  specialInstructions
  csrId
  csr {
    id
    fullName
  }
  dow
  accountComment
  donorComment
  pregnant
  pool
  createdBy {
    id
    fullName
  }
}
    `;
export const DonorScheduleScheduleFragmentDoc = `
    fragment DonorScheduleSchedule on DonorSchedule {
  scheduleMasterId
  scheduleMaster {
    id
    name
    method
    twiceConcentration
  }
  fshId
  drug {
    id
    name
  }
  scheduled
  clinicRanchHaulIn
  targetTime
  fsh2Id
  drug2 {
    id
    name
  }
  drugStatus
  billDrugs
  drugShippingFee
  soSchedule {
    id
    description
  }
  csr {
    id
    fullName
  }
  csrId
}
    `;
export const DonorScheduleEmbryoFragmentDoc = `
    fragment DonorScheduleEmbryo on DonorSchedule {
  ship
  shipmentGroupId
  shipmentGroup {
    id
    name
    estimations
  }
  shipGroup
  csrfrztrf
  embryoComment
  flexFieldPartner
  freezeInstructions
  loadDonorPartnersfrz
  freeze
  freezeMethodId
  freezeMethod {
    id
    name
    label
  }
  export
  nonEUCountry
  tt
  transfer
  implantType
  implantTypeValue
}
    `;
export const DonorScheduleSemenFragmentDoc = `
    fragment DonorScheduleSemen on DonorSchedule {
  semenId
  semen {
    id
    name
    cane
    colCode
    naab
    semenType
    quantity
    sex
  }
  cane
  colCode
  naab
  sireId
  sire {
    id
    name
    breed {
      id
      name
      code
      subFamily
    }
  }
  semenType
  semenTypeValue
  separateFert
  expectedSemenQty
  creditRebill
  semenPrice
  semenLocationId
  semenLocation {
    id
    name
  }
  semenOwnerId
  semenOwner {
    id
    name
  }
  backupSemenId
  backupSemen {
    id
    name
  }
  backupSemenType
  backupSireId
  backupSire {
    id
    name
  }
  contractSemen
  semenReleased
  critical
  semenComment
}
    `;
export const DonorScheduleBillingFragmentDoc = `
    fragment DonorScheduleBilling on DonorSchedule {
  oocyteShipping
  loadDonorPartners
  billAccountCaningOption
  billingAccountId
  billingAccount {
    id
    code
    name
  }
  specialBilling
  flexFieldPartner
  billingComment
  validationSts
  validationMessage
}
    `;
export const DonorScheduleNotesFragmentDoc = `
    fragment DonorScheduleNotes on DonorSchedule {
  revision
  revisionComment
  annotation {
    noteText
  }
}
    `;
export const DonorScheduleFragmentDoc = `
    fragment DonorSchedule on DonorSchedule {
  id
  name
  stateCode
  ...DonorScheduleGeneral
  ...DonorScheduleSchedule
  ...DonorScheduleEmbryo
  ...DonorScheduleSemen
  ...DonorScheduleBilling
  ...DonorScheduleNotes
}
    ${DonorScheduleGeneralFragmentDoc}
${DonorScheduleScheduleFragmentDoc}
${DonorScheduleEmbryoFragmentDoc}
${DonorScheduleSemenFragmentDoc}
${DonorScheduleBillingFragmentDoc}
${DonorScheduleNotesFragmentDoc}`;
export const DrugFragmentDoc = `
    fragment Drug on Drug {
  id
  name
  searchName
  lot
  comp
  pricePerBottle
  pricePerCc
}
    `;
export const PartnershipAccountFragmentDoc = `
    fragment PartnershipAccount on AccountPartial {
  id
  code
  name
  aging60
  aging90
  aging120
  aging180
  aging365
  tog90daysPastDue
  tog90DayOverrideExpireDate
  accountStatus
}
    `;
export const ScheduleMasterFragmentDoc = `
    fragment ScheduleMaster on ScheduleMaster {
  id
  name
  method
  twiceConcentration
}
    `;
export const SemenFragmentDoc = `
    fragment Semen on Semen {
  id
  name
  cane
  semenType
  quantity
  comment
}
    `;
export const SireFragmentDoc = `
    fragment Sire on Sire {
  id
  name
  breed {
    id
    name
    code
    subFamily
  }
  birth
  breedId
  breedReg
  cane
  clientShortName
  countryCodeId
  createdById
  createdOn
  edonorId
  heparin
  id
  modifiedById
  modifiedOn
  name
  owner {
    id
    name
    code
  }
  ownerId
  regPrefix
  registrationNumber
  regtog
  sexedCane
  sire
  sireCm
  sireJpi
  sireNm
  sireTpi
  stateCode
  status
  statusCode
  yard {
    id
    name
  }
  yardId
}
    `;
export const scheduledDonorFragmentDoc = `
    fragment scheduledDonor on ScheduledDonorType {
  donorName
  csr
  donorScheduleID
}
    `;
export const fertilizationDonorScheduleFragmentDoc = `
    fragment fertilizationDonorSchedule on FertilizationDonorScheduleType {
  donorScheduleID
  aspirationPoolID
  aspirationID
  donorName
  semenID
  semenName
  backupSemenID
  backupSemenName
  name_Type
  semenTypeName
  accountID
  accountNumber
  semenComment
  exportName
  matTime
  aspDate
  ivmMat
  donorBreed
  donorBreedName
}
    `;
export const pulledSemenFragmentDoc = `
    fragment pulledSemen on PulledSemenType {
  rowNum
  semenID
  semenName
  sireID
  sireName
  donors_Sire
  semenTypeName
  name_Type
  accountID
  accountName
  semenStorageID
  semenStorageName
  semenStorageSiteName
  cane
  colCode
  naab
  exportName
  quantity
  pulledQuantity
  sireBreed
}
    `;
export const createdFertsFragmentDoc = `
    fragment createdFerts on CreatedFertType {
  fertID
  fertName
  semenType
  accountID
  accountNumber
  numSemenUnits
  ivfNum
  matTime
  exportValue
  exportName
  fertComment
  fertComments
}
    `;
export const RequestFragmentDoc = `
    fragment Request on Request {
  id
  createdAt
  updatedAt
  type
  title
  content
  issue {
    ... on RequestItIssue {
      id
      app {
        id
        name
      }
      department {
        id
        name
      }
      sponsorId
    }
  }
  requestorId
  requestor {
    id
    fullName
  }
}
    `;
export const RequestEventFragmentDoc = `
    fragment RequestEvent on RequestEvent {
  id
  createdAt
  type
  content
  updatedAt
  requestId
  refRequestId
  authorAdUserId
  author {
    id
    fullName
  }
}
    `;
export const FullRequestFragmentDoc = `
    fragment FullRequest on Request {
  ...Request
  isSubscribed
  isImportant
  issue {
    ... on RequestItIssue {
      id
      sponsor {
        id
        fullName
      }
    }
    ... on RequestClientIssue {
      id
      implantedOn
      account {
        id
        code
        name
      }
      embryosPerFertilization
    }
  }
  events {
    ...RequestEvent
  }
  referencedIn {
    ...RequestEvent
  }
}
    ${RequestFragmentDoc}
${RequestEventFragmentDoc}`;
export const RequestIssueManagerFragmentDoc = `
    fragment RequestIssueManager on RequestIssueManager {
  id
  issueType
  adUserId
  systemUser {
    id
    fullName
  }
}
    `;
export const AppFragmentDoc = `
    fragment App on App {
  id
  name
  description
  url
  environmentId
}
    `;
export const ShippingShipmentFragmentDoc = `
    fragment ShippingShipment on Shipment {
  id
  stateCode
  shipmentNumber
  hasEmbryos
  hasSemen
  hasCalves
  hasRecipients
  hasDonors
  needByDate
  shipFromSiteId
  shipTo {
    id
    code
    name
  }
  tank
  owner {
    id
    code
    name
  }
  shipmentStatus
  shipmentStatusValue
  shippingMethod
  shippingMethodValue
  comment
  createdBy {
    id
    fullName
  }
  createdOn
  date
  shipName
  shipState
  trackingNumber
  packedBy {
    id
    name
    siteId
  }
  recaneEmbryos {
    id
    cane
    name
    creation
  }
}
    `;
export const ShippingAccountSearchFragmentDoc = `
    fragment ShippingAccountSearch on Account {
  id
  code
  name
  aging30
  aging60
  aging90
  aging120
  aging180
  aging365
  aging365Plus
  tog90daysPastDue
  tog90DayOverrideExpireDate
  ranchAddress {
    id
    line1
    line2
    line3
    city
    stateOrProvince
    postalCode
  }
}
    `;
export const ShippingEquipmentSearchFragmentDoc = `
    fragment ShippingEquipmentSearch on Equipment {
  id
  name
  siteId
}
    `;
export const ShippingSiteSearchFragmentDoc = `
    fragment ShippingSiteSearch on Site {
  id
  name
}
    `;
export const ShipmentFragmentDoc = `
    fragment Shipment on Shipment {
  id
  stateCode
  ownerId
  owner {
    id
    code
    name
    aging30
    aging60
    aging90
    aging120
    aging180
    aging365
    tog90daysPastDue
    tog90DayOverrideExpireDate
    aging365Plus
    ranchAddress {
      id
      country
    }
  }
  billTo
  billStatus
  callTag
  comment
  createdBy {
    id
    fullName
  }
  createdOn
  modifiedOn
  modifiedBy {
    id
    fullName
  }
  date
  email
  hasEmbryos
  hasSemen
  hasDonors
  hasRecipients
  hasCalves
  needByDate
  originalNeedByDate
  packedById
  packedBy {
    id
    name
    siteId
  }
  phone
  requestedBy
  shipAddress
  shipAddress2
  shipAddress3
  shipCity
  shipFromSiteId
  shipFromSite {
    id
    name
  }
  shipmentNumber
  shipmentStatus
  shipmentStatusValue
  shipName
  shippingMethod
  shippingMethodValue
  shipState
  shipToId
  shipTo {
    id
    code
    name
  }
  shipZip
  tank
  trackingNumber
  amount
  shipmentCategory
  recaneEmbryos {
    id
    cane
    name
    creation
  }
}
    `;
export const ShipmentEmbryoFragmentDoc = `
    fragment ShipmentEmbryo on Embryo {
  id
  fertilizationId
  status
  freshFrozen
  ownerId
  owner {
    id
    code
    name
  }
  soldTo
  strawDisclaimer
  strawNumber
  cane
  stage
  grade
  storageLocationId
  storageLocation {
    id
    name
  }
  siteId
  site {
    id
    name
  }
  shipmentId
  creation
  stateCode
  statusCode
  lastAct
  name
  statusValue
  methodValue
  sex
  donorId
  donor {
    id
    name
  }
  sireId
  sire {
    id
    name
  }
  embTag
  sex
  breedId
  freshStrawNo
  fertilizationId
  freezeMethodId
  freezeMethod {
    name
  }
  freezer
  dtPlus
  tt
  freezeComment
  export
  freezeTechId
  recoveryFirmCode
  freezeTime
  receivedOn
  grader7Id
  crackedZona
}
    `;
export const ShipmentSemenFragmentDoc = `
    fragment ShipmentSemen on Semen {
  id
  name
  cane
  togCane
  quantity
  quantityToShip
  storageLocation {
    id
    name
  }
  sexed
  sex
  concentration
  cost
  dateReceived
  colCode
  soldTo
  sire {
    id
    name
  }
}
    `;
export const ShipmentDonorFragmentDoc = `
    fragment ShipmentDonor on Donor {
  id
}
    `;
export const ShipmentRecipientFragmentDoc = `
    fragment ShipmentRecipient on Recipient {
  id
  received
  owner {
    name
  }
  yard {
    yard
    name
  }
  recipientStatus {
    name
  }
  activityDate
  lastActivity
  metalTag
}
    `;
export const ShipmentCalfFragmentDoc = `
    fragment ShipmentCalf on Calf {
  id
  owner {
    name
    code
  }
  donor {
    name
  }
  recipient {
    tag
  }
  status {
    name
  }
  yard {
    name
  }
  pen {
    name
  }
  method
  tattoo
  sex
  birth
  ship
  createdOn
}
    `;
export const StrippingFertilizationFragmentDoc = `
    fragment StrippingFertilization on Fertilization {
  id
  donorSchedule {
    id
    donor {
      id
      name
    }
    sire {
      id
      name
    }
    semenType
    semenTypeValue
  }
  semen {
    colCode
  }
  qcCultureIncubator
  qcIncubator {
    id
    name
  }
  ivcNumber
  ivfNumber
  ivcBroken
  ivcDead
  ivcMissing
  ivcImmature
  ivcExtra
  hasNoMotileSperm
  hasFewMotileSperm
  isHardToStrip
  isFragile
  hasTwoCellCleavage
  hasPoorCytoplasmQuality
  contaminationInFert
  stripperTipLotNumber
  ivcComment
  ivcTechnician {
    id
    name
  }
  aspirationPool {
    id
    name
    donorsInPool
  }
  breed {
    id
    color
  }
  ivfDate
  strippedAt(ianaTimeZone: $timeZone)
}
    `;
export const SystemUserPreviewFragmentDoc = `
    fragment SystemUserPreview on SystemUser {
  id
  fullName
  internalEmailAddress
}
    `;
export const CHANGE_CONNECTION = `
    mutation CHANGE_CONNECTION($environmentId: Int!, $b2c: Boolean) {
  changeConnection(environmentId: $environmentId, b2c: $b2c)
}
    `;
export const GET_ALL_CONNECTIONS = `
    query GET_ALL_CONNECTIONS {
  allConnections(
    order: {countryName: ASC, connectionType: ASC, overrideEnvironmentId: ASC}
  ) {
    overrideEnvironmentId
    connectionType
    countryName
    languageCode
    countryCode
    connectionStringKey
    crmUrl
  }
}
    `;
export const SEARCH_ACCOUNTS_MULTISELECT = `
    query SEARCH_ACCOUNTS_MULTISELECT($where: AccountFilterInput!, $take: Int!) {
  accounts(take: $take, where: $where, order: {name: ASC}) {
    items {
      id
      code
      name
      customerServiceRepresentativeId
      customerServiceRepresentative {
        id
        fullName
      }
      primaryTextingNumber
      priceTier
      aging60
      aging90
      aging120
      aging180
      aging365
      tog90daysPastDue
      tog90DayOverrideExpireDate
      accountStatus
    }
  }
}
    `;
export const SEARCH_ACCOUNTS_AUTOCOMPLETE = `
    query SEARCH_ACCOUNTS_AUTOCOMPLETE($search: String!, $selectionLimit: Int!) {
  accounts(
    take: $selectionLimit
    where: {and: [{or: [{code: {contains: $search}}, {name: {contains: $search}}]}, {stateCode: {eq: 0}}]}
    order: {name: ASC}
  ) {
    items {
      id
      code
      name
      customerServiceRepresentativeId
      customerServiceRepresentative {
        id
        fullName
      }
      aging60
      aging90
      aging120
      aging180
      aging365
      tog90daysPastDue
      tog90DayOverrideExpireDate
      accountStatus
      priceTier
      primaryTextingNumber
    }
  }
}
    `;
export const GET_ACCOUNT_BY_DATE_AND_SITE = `
    query GET_ACCOUNT_BY_DATE_AND_SITE($fertilizationDate: DateTime!, $transferDate: DateTime!, $fertilizationSite: UUID!, $transferSite: UUID!) {
  accountByDateAndSite(
    fertilizationDate: $fertilizationDate
    transferDate: $transferDate
    fertilizationSite: $fertilizationSite
    transferSite: $transferSite
  ) {
    accountId
    accountCode
    accountName
  }
}
    `;
export const SEARCH_DONORS = `
    query SEARCH_DONORS($skip: Int!, $take: Int!, $order: [DonorSortInput!], $where: DonorFilterInput) {
  donors(skip: $skip, take: $take, order: $order, where: $where) {
    totalCount
    items {
      id
      name
      breedId
      breed {
        code
        subFamily
      }
      ownerId
      owner {
        id
        name
        code
        customerServiceRepresentative {
          id
          fullName
        }
        priceTier
        aging60
        aging90
        aging120
        aging180
        aging365
        tog90daysPastDue
        tog90DayOverrideExpireDate
        accountStatus
      }
      registrationNumber
      tattoo
      metalTag
      received
      pregnant
      pooledDonorId
      yardId
      yard {
        name
      }
      exportDonor
      ranchTag
      ship
      lastActivity
      activityDate
      createdOn
      birth
      programName
    }
  }
}
    `;
export const SEARCH_SEMEN_LOOKUP = `
    query SEARCH_SEMEN_LOOKUP($skip: Int!, $take: Int!, $order: [SemenSortInput!], $where: SemenFilterInput) {
  semen(skip: $skip, take: $take, order: $order, where: $where) {
    totalCount
    items {
      id
      name
      naab
      quantity
      quantityRec
      storageLocationId
      storageLocation {
        siteId
        id
        name
        site {
          name
        }
      }
      sire {
        id
        name
        cane
        name
        breedId
        breed {
          subFamily
        }
        breedReg
        registrationNumber
        regPrefix
        birth
        heparin
      }
      cane
      colCode
      sexed
      sex
      concentration
      cost
      semenType
      dateReceived
      export
      cssCertified
      soldTo
      secondaryOwner
      shipment {
        shipName
        needByDate
      }
      owner {
        id
        name
        code
      }
      ownerId
      comment
      totalEmbryoDevelopmentRate
      qualityEmbryoDevelopmentRate
    }
  }
}
    `;
export const UPDATE_SIRE = `
    mutation UPDATE_SIRE($input: UpdateSireInput!) {
  updateSire(input: $input) {
    code
    success
    message
    sire {
      id
      name
    }
  }
}
    `;
export const SEARCH_SIRES = `
    query SEARCH_SIRES($skip: Int!, $take: Int!, $order: [SireSortInput!], $where: SireFilterInput) {
  sires(skip: $skip, take: $take, order: $order, where: $where) {
    totalCount
    items {
      ...Sire
    }
  }
}
    ${SireFragmentDoc}`;
export const GET_BREEDS = `
    query GET_BREEDS {
  breeds(order: {name: ASC}, where: {subFamily: {eq: BOVINE}}) {
    items {
      ...BreedFields
    }
  }
}
    ${BreedFieldsFragmentDoc}`;
export const GET_CONTACTS = `
    query GET_CONTACTS($where: ContactFilterInput) {
  contacts(where: $where) {
    items {
      id
      fullName
    }
  }
}
    `;
export const SEARCH_CONTACTS_AUTOCOMPLETE = `
    query SEARCH_CONTACTS_AUTOCOMPLETE($search: String!, $selectionLimit: Int!) {
  contacts(
    take: $selectionLimit
    where: {and: [{or: [{fullName: {contains: $search}}, {firstName: {contains: $search}}, {lastName: {contains: $search}}, {emailAddress1: {contains: $search}}]}, {stateCode: {eq: 0}}]}
    order: {fullName: ASC}
  ) {
    items {
      id
      fullName
      firstName
      lastName
      emailAddress1
      company
    }
  }
}
    `;
export const SEARCH_SYSTEM_USERS_AUTOCOMPLETE = `
    query SEARCH_SYSTEM_USERS_AUTOCOMPLETE($search: String, $selectionLimit: Int) {
  results: systemUsers(
    take: $selectionLimit
    where: {or: [{fullName: {contains: $search}}, {internalEmailAddress: {contains: $search}}]}
    order: {fullName: ASC}
  ) {
    totalCount
    items {
      ...SystemUserPreview
    }
  }
}
    ${SystemUserPreviewFragmentDoc}`;
export const ADD_VIEW = `
    mutation ADD_VIEW($input: AddViewInput!) {
  addView(input: $input) {
    success
    message
  }
}
    `;
export const UPDATE_VIEW = `
    mutation UPDATE_VIEW($input: UpdateViewInput!) {
  updateView(input: $input) {
    success
    message
  }
}
    `;
export const REMOVE_VIEW = `
    mutation REMOVE_VIEW($id: UUID!) {
  removeView(id: $id) {
    success
    message
  }
}
    `;
export const SET_DEFAULT_VIEW = `
    mutation SET_DEFAULT_VIEW($input: SetDefaultViewInput!) {
  setDefaultView(input: $input) {
    success
    message
  }
}
    `;
export const GET_VIEW_NAMES = `
    query GET_VIEW_NAMES($username: String!, $usage: String!, $app: String!) {
  viewNames(username: $username, usage: $usage, app: $app) {
    id
    username
    name
    view
    usage
    isDefault
    app
  }
}
    `;
export const GET_VIEW_BY_ID = `
    query GET_VIEW_BY_ID($id: UUID!) {
  viewById(id: $id) {
    id
    username
    name
    view
    usage
    isDefault
    app
  }
}
    `;
export const SEARCH_ALL_DONORS_AUTOCOMPLETE = `
    query SEARCH_ALL_DONORS_AUTOCOMPLETE($search: String!, $selectionLimit: Int!) {
  donors(
    take: $selectionLimit
    where: {and: [{or: [{name: {contains: $search}}, {registrationNumber: {contains: $search}}]}, {name: {neq: null}}, {name: {neq: ""}}, {stateCode: {eq: 0}}]}
    order: {donorName: ASC}
  ) {
    items {
      id
      name
      breedId
      breed {
        code
      }
      ownerId
      owner {
        id
        name
        code
        customerServiceRepresentative {
          id
          fullName
        }
      }
      registrationNumber
      tattoo
      metalTag
      received
      pregnant
      pooledDonorId
      yardId
      yard {
        name
      }
      ranchTag
      ship
      lastActivity
      activityDate
      createdOn
      birth
    }
  }
}
    `;
export const SEARCH_DONORS_BY_OWNER_ID_AUTOCOMPLETE = `
    query SEARCH_DONORS_BY_OWNER_ID_AUTOCOMPLETE($search: String!, $selectionLimit: Int!, $ownerId: UUID) {
  donors(
    take: $selectionLimit
    where: {and: [{name: {contains: $search}}, {name: {neq: null}}, {name: {neq: ""}}, {stateCode: {eq: 0}}, {ownerId: {eq: $ownerId}}]}
    order: {name: ASC}
  ) {
    items {
      id
      name
      ownerId
      owner {
        code
        customerServiceRepresentative {
          id
          fullName
        }
      }
    }
  }
}
    `;
export const SEARCH_DRUGS = `
    query SEARCH_DRUGS($search: String!, $selectionLimit: Int) {
  drugs(
    take: $selectionLimit
    where: {name: {contains: $search}}
    order: {name: ASC}
  ) {
    totalCount
    items {
      ...Drug
    }
  }
}
    ${DrugFragmentDoc}`;
export const SEARCH_ASPIRATION_SITES = `
    query SEARCH_ASPIRATION_SITES($where: LocationFilterInput) {
  locations(where: $where, order: {site: {name: ASC}}) {
    items {
      id
      name
      site {
        id
        name
      }
      fertilizationSite {
        id
        name
      }
      fertilizationSiteId
    }
  }
}
    `;
export const GET_EQUIPMENT_SEARCH_BY_SITE = `
    query GET_EQUIPMENT_SEARCH_BY_SITE($siteId: UUID!, $searchTerm: String) {
  equipments(
    where: {name: {contains: $searchTerm}, siteId: {eq: $siteId}, farmlocation: {eq: true}}
    order: {name: ASC}
  ) {
    items {
      id
      name
    }
  }
}
    `;
export const SEARCH_FERTILIZATION_SITES_DROPDOWN = `
    query SEARCH_FERTILIZATION_SITES_DROPDOWN($where: LocationFilterInput) {
  locations(where: $where, order: {name: ASC}) {
    items {
      id
      name
      fertilizationSite {
        id
        name
      }
    }
  }
}
    `;
export const CREATE_NEW_DONOR = `
    mutation CREATE_NEW_DONOR($input: CreateNewDonorInput!) {
  createNewDonor(input: $input) {
    code
    message
    success
    donor {
      id
    }
  }
}
    `;
export const CREATE_NEW_SIRE = `
    mutation CREATE_NEW_SIRE($input: CreateNewSireInput!) {
  createNewSire(input: $input) {
    code
    message
    success
    sire {
      id
    }
  }
}
    `;
export const GET_OPTION_SETS_BY_NAME = `
    query GET_OPTION_SETS_BY_NAME($name: String) {
  optionSets(take: 100, where: {name: {contains: $name}}, order: {label: ASC}) {
    totalCount
    items {
      id
      label
      description
    }
  }
}
    `;
export const GET_RECIPIENTS = `
    query GET_RECIPIENTS($skip: Int!, $take: Int!, $where: RecipientFilterInput) {
  recipients(skip: $skip, take: $take, where: $where) {
    items {
      id
      tag
    }
  }
}
    `;
export const SEARCH_SCHEDULE_MASTER = `
    query SEARCH_SCHEDULE_MASTER($search: String!, $selectionLimit: Int) {
  scheduleMaster(
    take: $selectionLimit
    where: {name: {contains: $search}}
    order: {name: ASC}
  ) {
    totalCount
    items {
      ...ScheduleMaster
    }
  }
}
    ${ScheduleMasterFragmentDoc}`;
export const SEARCH_SEMEN = `
    query SEARCH_SEMEN($where: SemenFilterInput, $selectionLimit: Int) {
  semen(take: $selectionLimit, where: $where, order: {name: ASC}) {
    items {
      id
      name
      naab
      quantity
      storageLocationId
      storageLocation {
        id
        name
        siteId
        site {
          name
        }
      }
      sire {
        id
        name
        cane
      }
      cane
      colCode
      export
      sexed
      sex
      concentration
      cost
      semenType
      dateReceived
      soldTo
      owner {
        id
        code
      }
      ownerId
      totalEmbryoDevelopmentRate
      qualityEmbryoDevelopmentRate
    }
  }
}
    `;
export const SEARCH_SEMEN_BY_ACCOUNT = `
    query SEARCH_SEMEN_BY_ACCOUNT($fertilizationSiteId: UUID!, $accountCode: String!, $search: String!, $selectionLimit: Int) {
  semen(
    take: $selectionLimit
    where: {storageLocation: {siteId: {eq: $fertilizationSiteId}}, owner: {code: {eq: $accountCode}}, quantity: {gt: 0}, sire: {name: {contains: $search}}}
    order: {quantity: DESC}
  ) {
    items {
      ...SearchSemenByAccount
    }
  }
}
    ${SearchSemenByAccountFragmentDoc}`;
export const SEARCH_SHIPMENTS_AUTOCOMPLETE = `
    query SEARCH_SHIPMENTS_AUTOCOMPLETE($search: String!, $selectionLimit: Int!) {
  shipments(
    take: $selectionLimit
    where: {or: [{shipmentNumber: {contains: $search}}, {shipName: {contains: $search}}, {trackingNumber: {contains: $search}}]}
    order: {date: DESC}
  ) {
    items {
      id
      shipmentNumber
      shipName
      trackingNumber
      date
      shipFromSite {
        id
        name
      }
    }
  }
}
    `;
export const SEARCH_SHIPMENT_GROUPS = `
    query SEARCH_SHIPMENT_GROUPS($search: String!, $selectionLimit: Int!) {
  shipmentGroups(
    take: $selectionLimit
    where: {name: {contains: $search}}
    order: {name: ASC}
  ) {
    totalCount
    items {
      id
      name
      estimations
    }
  }
}
    `;
export const SEARCH_SIRES_LOOKUP = `
    query SEARCH_SIRES_LOOKUP($search: String!, $selectionLimit: Int) {
  sires(
    take: $selectionLimit
    where: {name: {contains: $search}}
    order: {name: ASC}
  ) {
    totalCount
    items {
      ...Sire
    }
  }
}
    ${SireFragmentDoc}`;
export const GET_SITES = `
    query GET_SITES($where: SiteFilterInput) {
  sites(where: $where, order: {name: ASC}) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_SITES_SEARCH_MULTISELECT = `
    query GET_SITES_SEARCH_MULTISELECT($where: SiteFilterInput!, $skip: Int = 0, $take: Int = 15) {
  sites(where: $where, skip: $skip, take: $take, order: {name: ASC}) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_SITES_SEARCH = `
    query GET_SITES_SEARCH($searchTerm: String, $skip: Int = 0, $take: Int = 15) {
  sites(
    where: {name: {contains: $searchTerm}}
    skip: $skip
    take: $take
    order: {name: ASC}
  ) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_STORAGE_LOCATIONS = `
    query GET_STORAGE_LOCATIONS($skip: Int!, $take: Int!, $order: [StorageLocationSortInput!], $where: StorageLocationFilterInput) {
  storageLocations(skip: $skip, take: $take, order: $order, where: $where) {
    totalCount
    items {
      id
      name
      siteId
      stateCode
    }
  }
}
    `;
export const GET_EQUIPMENT_BY_ID = `
    query GET_EQUIPMENT_BY_ID($id: UUID!) {
  equipments(where: {id: {eq: $id}}) {
    items {
      id
      name
    }
  }
}
    `;
export const RUN_WORKFLOW = `
    mutation RUN_WORKFLOW($entityIds: [UUID!]!, $workflowId: UUID!) {
  runWorkflow(entityIds: $entityIds, workflowId: $workflowId)
}
    `;
export const RUN_OLD_WORKFLOW = `
    mutation RUN_OLD_WORKFLOW($entityIds: [UUID!]!, $workflowId: UUID!) {
  runOldWorkflow(entityIds: $entityIds, workflowId: $workflowId)
}
    `;
export const GET_YARDS_MULTISELECT = `
    query GET_YARDS_MULTISELECT($where: YardFilterInput) {
  yards(where: $where, order: {name: ASC}) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_YARDS = `
    query GET_YARDS {
  yards(order: {name: ASC}) {
    items {
      id
      name
      yard
    }
  }
}
    `;
export const SEARCH_YARDS = `
    query SEARCH_YARDS($search: String!, $selectionLimit: Int) {
  yards(
    take: $selectionLimit
    where: {name: {contains: $search}}
    order: {yard: ASC}
  ) {
    totalCount
    items {
      id
      name
    }
  }
}
    `;
export const ADD_NUCLEUS_ERROR_LOG = `
    mutation ADD_NUCLEUS_ERROR_LOG($errorLog: NucleusErrorLogsInput!) {
  addNucleusErrorLog(errorLog: $errorLog) {
    code
    success
    message
    nucleusErrorLogs {
      id
    }
  }
}
    `;
export const GET_NUCLEUS_ERROR_LOGS = `
    query GET_NUCLEUS_ERROR_LOGS {
  getNucleusErrorLogs {
    items {
      id
      username
      asUserId
      location
      userAgent
      timestamp
      errorInfo
      errorMessage
      errorStack
      errorName
    }
  }
}
    `;
export const LOGIN = `
    mutation LOGIN($username: String!, $password: String!) {
  login(username: $username, password: $password)
}
    `;
export const LOGOUT = `
    mutation LOGOUT {
  logout
}
    `;
export const UPDATE_ASPIRATION_CHUTESIDE = `
    mutation UPDATE_ASPIRATION_CHUTESIDE($input: AspirationDataEntryInput!, $isReturn: String!) {
  updateAspirationChuteside(input: $input, isReturn: $isReturn) {
    code
    success
    message
  }
}
    `;
export const UPDATE_QC_DATA_CHUTESIDE = `
    mutation UPDATE_QC_DATA_CHUTESIDE($input: QcDataChutesideInput!, $aspirationDate: String!, $siteId: String!, $location: String!) {
  updateQCDataChuteside(
    input: $input
    aspirationDate: $aspirationDate
    siteId: $siteId
    location: $location
  )
}
    `;
export const ADD_PREGNANT_STATUS = `
    mutation ADD_PREGNANT_STATUS($pregnantValue: Int!, $donorId: String!, $opuTechId: String!, $chuteTechId: String!) {
  addPregnantStatus(
    pregnantValue: $pregnantValue
    donorId: $donorId
    opuTechId: $opuTechId
    chuteTechId: $chuteTechId
  )
}
    `;
export const UPDATE_ASPIRATION_QC_DATA_CHUTESIDE = `
    mutation UPDATE_ASPIRATION_QC_DATA_CHUTESIDE($input: tog_chutesideqcInput!) {
  updateAspirationQcDataChuteside(input: $input)
}
    `;
export const UPDATE_DONOR_LAST_BRED_DATE = `
    mutation UPDATE_DONOR_LAST_BRED_DATE($donorId: UUID!, $lastBredDate: DateTime!) {
  updateDonorLastBredDate(donorId: $donorId, lastBredDate: $lastBredDate)
}
    `;
export const GET_TODAYS_ASPIRATIONS = `
    query GET_TODAYS_ASPIRATIONS($date: String!, $siteId: String!, $vetId: String, $techId: String, $type: Int!, $location: String) {
  todaysAspirations(
    date: $date
    siteId: $siteId
    vetId: $vetId
    techId: $techId
    type: $type
    location: $location
  ) {
    aspirationId
    opuNum
    aspirationTime
    account
    csa
    breed
    donor
    donorName
    donorRegNum
    sire
    semenType
    donorLocation
    fertSite
    pooled
    nonEuComment
    export
    medTotal
    totalOocytes
    numInMat
    csr
    matTime
    aspComments
    poolNum
    dsAspirationComment
    weight
    vetId
    asstId
    siteId
    ivmId
    ivmTech
    ivmMat
    ivmTime
    aspirationDate
    scheduleId
    nextSchedule
    nextScheduleId
    totalFollicles
    ll
    lm
    ls
    rl
    rm
    rs
    cll
    cystl
    clr
    cystr
    comment
    donorCondition
    donorId
    completeOrder
    pregnant
    embCompleteOrder
    opuTech
    chuteTech
    totalLeft
    totalRight
    fertPlan
    accountName
    weight
    location
    chuteNumber
    programName
  }
}
    `;
export const GET_ASPIRATION_BY_DONOR_DATE_SITE = `
    query GET_ASPIRATION_BY_DONOR_DATE_SITE($donorId: String!, $date: String!, $siteId: String!) {
  aspirationByDonorDateSite(donorId: $donorId, date: $date, siteId: $siteId) {
    rowNum
    aspirationTime
    account
    donor
    sire
    semenType
    donorLocation
    medTotal
    totalOocytes
    numInMat
    matTime
    csr
    aspComments
    pooled
    breed
    export
    poolNum
    csa
    donorName
    dsAspirationComment
    earTag
    opuid
    donorId
    sched
    aspirationId
    vetId
    asstId
    siteId
    aspirationDate
    nextSched
    nextScheduleId
    scheduleId
    leftLarge
    leftMedium
    leftSmall
    rightLarge
    rightMedium
    rightSmall
    leftCls
    rightCls
    leftCysts
    rightCysts
    comment
    donorComment
    donorCondition
    totalFollicles
    pregnant
    didNotAspirate
    lastBred
    birthDate
    weight
    fertPlan
    accountName
  }
}
    `;
export const GET_VETERINARIANS = `
    query GET_VETERINARIANS {
  equipments(where: {veterinarian: {eq: true}}, order: {name: ASC}) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_ASPIRATION_BY_ID = `
    query GET_ASPIRATION_BY_ID($aspirationId: UUID!) {
  aspirations(where: {id: {eq: $aspirationId}, stateCode: {eq: 0}}) {
    items {
      ...AspirationInformation
    }
  }
}
    ${AspirationInformationFragmentDoc}`;
export const GET_SCHEDULES = `
    query GET_SCHEDULES {
  scheduleMaster(where: {and: [{stateCode: {eq: 0}}, {method: {eq: 100000001}}]}) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_PROCEDURES_BY_DONOR_ID = `
    query GET_PROCEDURES_BY_DONOR_ID($donorId: String!, $ranch: String!) {
  proceduresByDonorId(donorId: $donorId, ranch: $ranch) {
    donorId
    procedureDate
    procedure
    description
    pregnant
    procCode
    owner
    breed
  }
}
    `;
export const GET_TODAYS_QC_DATA_CHUTESIDE = `
    query GET_TODAYS_QC_DATA_CHUTESIDE($date: String!, $siteId: String!, $location: String!) {
  todaysQcDataChuteside(date: $date, siteId: $siteId, location: $location) {
    tog_qc_pockettubewarmertemp
    tog_qc_pumptubewarmertemp
    tog_qc_pumppressure
    tog_qc_flowrate
    tog_qc_outsidetemp
    tog_qc_outsideweatherconditions
    tog_qc_collectionroomtemp
    tog_qc_brennerneedlelotno
    qccompleted
    tog_asp_date
    tog_siteid
    tog_qc_location
    tog_qc_commentchuteside
  }
}
    `;
export const GET_TEMP_ASPIRATION_QC_INFO = `
    query GET_TEMP_ASPIRATION_QC_INFO($chuteNumber: Int!, $siteId: String!, $aspirationDate: DateTime!, $location: String) {
  tempAspirationQcInfo(
    chuteNumber: $chuteNumber
    siteId: $siteId
    aspirationDate: $aspirationDate
    location: $location
  ) {
    id
    tog_qc_pockettubewarmertemp
    tog_qc_pumptubewarmertemp
    tog_qc_pumppressure
    tog_qc_flowrate
    tog_qc_outsidetemp
    tog_qc_outsideweatherconditions
    tog_qc_collectionroomtemp
    tog_qc_brennerneedlelotno
    aspirationDate
    siteId
    location
    tog_qc_commentchuteside
    chuteNumber
  }
}
    `;
export const GET_ASPIRATION_HISTORY_BY_DONOR_ID = `
    query GET_ASPIRATION_HISTORY_BY_DONOR_ID($donorId: String!, $aspirationDate: String!, $ranch: String!) {
  aspirationHistoryDataByDonorId(
    donorId: $donorId
    aspirationDate: $aspirationDate
    ranch: $ranch
  ) {
    aspirationDate
    comments
  }
}
    `;
export const GET_FERT_DATA_BY_DONOR_ID_CHUTESIDE = `
    query GET_FERT_DATA_BY_DONOR_ID_CHUTESIDE($donorId: String!, $ranch: String!) {
  fertDataByDonorIdChuteside(donorId: $donorId, ranch: $ranch) {
    id
    donorId
    aspDate
    tech
    sched
    fsh
    follS
    follM
    follL
    ooc
    percentAbc
    sire
    fert
    clv
    viable
    clls
    clrs
    cystsL
    cystsR
  }
}
    `;
export const GET_ASPIRATION_INFO_BY_ID = `
    query GET_ASPIRATION_INFO_BY_ID($aspirationId: UUID!) {
  aspirations(where: {id: {eq: $aspirationId}}) {
    items {
      bodyConditionScore
      donorCategory
    }
  }
}
    `;
export const EXPORT_CRYO_BABY_LABELS = `
    mutation EXPORT_CRYO_BABY_LABELS($labels: [CryoBabyLabelInput!]!, $aspDate: DateTime!, $aspSite: String!, $location: String) {
  exportCryoBabyLabelXlsx(
    labels: $labels
    aspDate: $aspDate
    aspSite: $aspSite
    location: $location
  )
}
    `;
export const ADD_CALVES = `
    mutation ADD_CALVES($requirements: CalfEntryRequirementsInput!, $calves: [NewCalfEntryInput!]!) {
  addCalves(requirements: $requirements, calves: $calves) {
    code
    message
    success
    calves {
      id
    }
  }
}
    `;
export const SEARCH_OWNERS = `
    query SEARCH_OWNERS($search: String, $selectionLimit: Int) {
  accounts(
    take: $selectionLimit
    where: {and: [{or: [{code: {contains: $search}}, {name: {contains: $search}}]}, {stateCode: {eq: 0}}]}
    order: {name: ASC}
  ) {
    items {
      id
      code
      name
    }
  }
}
    `;
export const SEARCH_HERDSMEN = `
    query SEARCH_HERDSMEN($search: String, $selectionLimit: Int) {
  equipments(
    take: $selectionLimit
    where: {name: {contains: $search}}
    order: {name: ASC}
  ) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_PENS = `
    query GET_PENS {
  pens(order: {name: ASC}, where: {name: {neq: null}}) {
    items {
      id
      name
      yard {
        id
        name
      }
    }
  }
}
    `;
export const GET_SEX = `
    query GET_SEX {
  stringMaps(
    where: {and: [{objectTypeCode: {eq: 10008}}, {attributeName: {eq: "tog_sex"}}]}
  ) {
    items {
      attributeValue
      value
    }
  }
}
    `;
export const GET_TESTICLES_DECENDED = `
    query GET_TESTICLES_DECENDED {
  stringMaps(
    where: {and: [{objectTypeCode: {eq: 10008}}, {attributeName: {eq: "tog_testiclesdecended"}}]}
  ) {
    items {
      attributeValue
      value
    }
  }
}
    `;
export const GET_TESTICULAR_DEVELOPMENT = `
    query GET_TESTICULAR_DEVELOPMENT {
  stringMaps(
    where: {and: [{objectTypeCode: {eq: 10008}}, {attributeName: {eq: "tog_testicular_dev"}}]}
  ) {
    items {
      attributeValue
      value
    }
  }
}
    `;
export const GET_TIME_OF_DAY = `
    query GET_TIME_OF_DAY {
  stringMaps(
    where: {and: [{objectTypeCode: {eq: 10010}}, {attributeName: {eq: "tog_timeofday"}}]}
  ) {
    items {
      attributeValue
      value
    }
  }
}
    `;
export const UPDATE_ASPIRATION_TIMES = `
    mutation UPDATE_ASPIRATION_TIMES($chuteSchedule: [ChuteSchedulerInput!]!) {
  updateAspirationTimes(chuteSchedule: $chuteSchedule) {
    code
    success
    message
  }
}
    `;
export const UPDATE_REVISIONS = `
    mutation UPDATE_REVISIONS($updates: [UpdateRevisionsInput!]!) {
  updateRevisions(updates: $updates) {
    code
    success
    message
  }
}
    `;
export const UPDATE_ASPIRATION_STATUS_AND_DONOR_SCHEDULE_REVISION_COMMENT_BATCH = `
    mutation UPDATE_ASPIRATION_STATUS_AND_DONOR_SCHEDULE_REVISION_COMMENT_BATCH($updates: [UpdateAspirationStatusAndDonorScheduleRevisionCommentInput!]!) {
  updateAspirationStatusAndDonorScheduleRevisionCommentBatch(updates: $updates) {
    code
    success
    message
  }
}
    `;
export const CHUTE_SCHEDULE_COMBINED = `
    query CHUTE_SCHEDULE_COMBINED($siteId: UUID!, $date: DateTime!) {
  chuteScheduleCombined(siteId: $siteId, date: $date) {
    scheduling {
      aspirationId
      rowNum: donor
      fertSite
      aspTime
      account
      ranchId
      csr
      csa
      breed
      earTag
      donorName
      sire
      sireBrd
      semenType
      dsSemenComment
      dsAspirationComment
      parity
      export
      storageLocation
      donorLocation
      aspirationComment
      pooled
      pool
      aspirationDate
      ptComment
      collectionCode
      maturationComment
      shipmentGroupName
      embryoPlan
      schedCode
      transferEmbryoComment
      birthDate
      programName
      transfer
      freezeInstructions
      ship
      freeze
      procedureDate
    }
    results {
      aspirationId
      account
      ranchId
      export
      storageLocation
      donorLocation
      aspirationComment
      breed
      donorName
      sire
      sireBrd
      semenType
      pooled
      medTotal
      totalOocytes
      inMat
      csr
      matTime
      dsAspirationComment
      poolNum
      ship
      shipmentGroupName
      transfer
      transferEmbryoComment
      freeze
      freezeInstructions
      schedCode
      fertSite
      collectionCode
      maturationComment
      embryoPlan
      birthDate
      opuTechnician
      ivmTechnician
      gradeAbc
      gradeD
      gradeE
      dead
      procedureDate
      programName
      donorScheduleId
      revisionNumber
      revisionComment
    }
  }
}
    `;
export const ALL_TOP_REVISIONS = `
    query ALL_TOP_REVISIONS($date: DateTime!) {
  allTopRevisions(date: $date) {
    revisionNumber
    fertilizationSiteId
    fertilizationSiteName
  }
}
    `;
export const UPDATE_FRESH_TRANSFERS = `
    mutation UPDATE_FRESH_TRANSFERS($embryoUpdates: [EmbryoUpdateInput!]!) {
  updateFreshTransfers(embryoUpdates: $embryoUpdates) {
    code
    success
    message
  }
}
    `;
export const GET_CSR_DAY_7 = `
    query GET_CSR_DAY_7($beginDate: DateTime!, $endDate: DateTime!, $siteId: UUID, $accountId: UUID) {
  csrDay7(
    beginDate: $beginDate
    endDate: $endDate
    siteId: $siteId
    accountId: $accountId
  ) {
    embryoId
    account
    donor
    breed
    bullBreed
    sire
    st
    transferPlan
    implantType
    recipFrame
    export
    embTag
    stage
    grade
    freshStrawNo
    embryoToBe
    hldFrz
    hldTrf
    hldFrzTrfLg
    togRecip
    clientRecip
    csrComments
    donorOwners
    shipmentGroup
    ivcNumber
    cleaved
    shippedToClient
    packagedInformation
    resultsComment
    shippingPlan
    freezePlan
    plateNumber
    numberOfPartners
    freezePartner
    transferPartner
    donorScheduleFreezePartner
    donorScheduleTransferPartner
    fertilizationId
  }
}
    `;
export const ADD_CLINIC_TRANSFER_EMBRYOS = `
    mutation ADD_CLINIC_TRANSFER_EMBRYOS($input: ClinicTransferEmbryoInput!) {
  addClinicTransferEmbryos(input: $input) {
    code
    success
    message
  }
}
    `;
export const UPDATE_FRESH_TRANSFERS_PSE = `
    mutation UPDATE_FRESH_TRANSFERS_PSE($input: UpdateFreshTransferInput!) {
  updateFreshTransfersPse(input: $input) {
    code
    success
    message
  }
}
    `;
export const GET_PSE_DAY_7 = `
    query GET_PSE_DAY_7($beginDate: DateTime!, $endDate: DateTime!, $siteId: UUID) {
  pseDay7(beginDate: $beginDate, endDate: $endDate, siteId: $siteId) {
    embryoId
    stage
    grade
    transferComment
    semenType
    mating
    recipient
    embryoTag
    transferTech
    estrusSync
    deactivate
    embryoPartners
    donorPartners
    loadPartners
    cl
    plateNo
    dsImplantType
    embryoImplantType
    recipFrame
    status
    fertilizationId
    freshStrawNo
    cane
    freezeMethodId
    tt
    frozenStraw
    accountId
    shipmentGroup
  }
}
    `;
export const GET_PSE_DAY_7_MATINGS = `
    query GET_PSE_DAY_7_MATINGS($beginDate: DateTime!, $endDate: DateTime!, $siteId: UUID) {
  pseDay7Matings(beginDate: $beginDate, endDate: $endDate, siteId: $siteId) {
    freshShipmentId
    id
    mating
    predictedGood
    predictedLow
    predictedVeryLow
    shippedTog
    heldAtTogToFreeze
    heldAtTogForTransfer
    heldAtTogFreezeTransferLowGrade
    transferred
    frozen
    grade1
    grade2
    grade3
    discardedGrade1
    discardedGrade2
    discarded
    degenerates
    procId
    plateNumber
  }
}
    `;
export const GET_DAY_7_FROZEN_EMBRYOS = `
    query GET_DAY_7_FROZEN_EMBRYOS($beginDate: DateTime!, $endDate: DateTime!, $siteId: UUID!) {
  day7FrozenEmbryos(beginDate: $beginDate, endDate: $endDate, siteId: $siteId) {
    plateNumber
    mating
    cane
    straw
    stage
    grade
    freezeTime
    freezeSite
  }
}
    `;
export const GET_PARTNERSHIPS = `
    query GET_PARTNERSHIPS($donorId: UUID!, $donorScheduleId: UUID) {
  getPartnerships(donorId: $donorId, donorScheduleId: $donorScheduleId) {
    items {
      type
      account1Id
      account1 {
        ...PartnershipAccount
      }
      percent1
      account2Id
      account2 {
        ...PartnershipAccount
      }
      percent2
      account3Id
      account3 {
        ...PartnershipAccount
      }
      percent3
      account4Id
      account4 {
        ...PartnershipAccount
      }
      percent4
      partnershipBillingType
      partnershipId
    }
  }
}
    ${PartnershipAccountFragmentDoc}`;
export const UPSERT_DONOR_SCHEDULES = `
    mutation UPSERT_DONOR_SCHEDULES($input: UpsertDonorScheduleInput!, $annotationNoteText: String) {
  upsertDonorSchedules(input: $input, annotationNoteText: $annotationNoteText) {
    code
    message
    success
    donorSchedules {
      id
    }
  }
}
    `;
export const EDIT_BULK_DONOR_SCHEDULES = `
    mutation EDIT_BULK_DONOR_SCHEDULES($input: EditBulkDonorScheduleInput!, $bulkUpdateIds: [UUID!]!, $annotationNoteText: String) {
  editBulkDonorSchedules(
    input: $input
    bulkUpdateIds: $bulkUpdateIds
    annotationNoteText: $annotationNoteText
  ) {
    code
    message
    success
    donorSchedules {
      id
    }
  }
}
    `;
export const DEACTIVATE_DONOR_SCHEDULES = `
    mutation DEACTIVATE_DONOR_SCHEDULES($donorScheduleIds: [UUID!]!) {
  deactivateDonorSchedules(donorScheduleIds: $donorScheduleIds) {
    code
    message
    success
    donorSchedules {
      id
    }
  }
}
    `;
export const UPSERT_PARTNERSHIP = `
    mutation UPSERT_PARTNERSHIP($input: UpsertPartnershipInput!) {
  upsertPartnership(input: $input) {
    code
    message
    success
    partnership {
      id
    }
  }
}
    `;
export const MASS_SET_FIELD = `
    mutation MASS_SET_FIELD($fields: [String!]!, $value: String!, $donorScheduleIds: [UUID!]!) {
  massSetField(
    fields: $fields
    value: $value
    donorScheduleIds: $donorScheduleIds
  )
}
    `;
export const DEACTIVATE_SO_SCHEDULE = `
    mutation DEACTIVATE_SO_SCHEDULE($donorScheduleId: UUID!) {
  deactivateSoSchedule(donorScheduleId: $donorScheduleId)
}
    `;
export const CREATE_NEW_SHIPMENT_GROUP = `
    mutation CREATE_NEW_SHIPMENT_GROUP($input: CreateNewShipmentGroupInput!) {
  createNewShipmentGroup(input: $input) {
    code
    message
    success
    shipmentGroupId
  }
}
    `;
export const CREATE_NEW_SHIPMENT_GROUP_MASTER = `
    mutation CREATE_NEW_SHIPMENT_GROUP_MASTER($input: CreateNewShipmentGroupMasterInput!) {
  createNewShipmentGroupMaster(input: $input) {
    code
    message
    success
    shipmentGroupId
  }
}
    `;
export const UPDATE_TEMP_EMBRYO_OWNERS = `
    mutation UPDATE_TEMP_EMBRYO_OWNERS($donorScheduleId: UUID!) {
  updateTempEmbryoOwners(donorScheduleId: $donorScheduleId)
}
    `;
export const UPDATE_BILL_ACCOUNT_CANING_GROUPS = `
    mutation UPDATE_BILL_ACCOUNT_CANING_GROUPS($donorScheduleId: UUID!) {
  updateBillAccountCaningGroups(donorScheduleId: $donorScheduleId)
}
    `;
export const GET_DONOR_SCHEDULES = `
    query GET_DONOR_SCHEDULES($skip: Int!, $take: Int!, $order: [DonorScheduleSortInput!], $where: DonorScheduleFilterInput) {
  donorSchedules(skip: $skip, take: $take, order: $order, where: $where) {
    totalCount
    items {
      ...DonorSchedule
      partnerships {
        ...Partnership
      }
    }
  }
}
    ${DonorScheduleFragmentDoc}
${PartnershipFragmentDoc}`;
export const GET_DONOR_SCHEDULES_BY_IDS = `
    query GET_DONOR_SCHEDULES_BY_IDS($ids: [UUID!]!) {
  donorSchedulesByIds(ids: $ids) {
    ...DonorSchedule
    partnerships {
      ...Partnership
    }
  }
}
    ${DonorScheduleFragmentDoc}
${PartnershipFragmentDoc}`;
export const PARTNERSHIP_TYPE = `
    query PARTNERSHIP_TYPE($order: [StringMapSortInput!], $where: StringMapFilterInput!) {
  stringMaps(order: $order, where: $where) {
    items {
      attributeValue
      value
    }
  }
}
    `;
export const GET_ALL_SHIPMENT_GROUP_MASTERS = `
    query GET_ALL_SHIPMENT_GROUP_MASTERS($where: ShipmentGroupMasterFilterInput) {
  allShipmentGroupMasters(where: $where) {
    items {
      id
      name
      siteId
      site {
        id
        name
      }
      contactId
      contact {
        id
        fullName
      }
      callTagContactId
      shippingMethod
      shipmentGroupId
    }
  }
}
    `;
export const GET_PARTNERSHIPS_BY_DONOR_ID = `
    query GET_PARTNERSHIPS_BY_DONOR_ID($donorId: UUID!, $ownershipId: UUID!, $donorScheduleId: UUID!) {
  getPartnershipsByDonorId(
    donorId: $donorId
    ownershipId: $ownershipId
    donorScheduleId: $donorScheduleId
  ) {
    items {
      type
      account1Id
      account1 {
        ...PartnershipAccount
      }
      percent1
      account2Id
      account2 {
        ...PartnershipAccount
      }
      percent2
      account3Id
      account3 {
        ...PartnershipAccount
      }
      percent3
      account4Id
      account4 {
        ...PartnershipAccount
      }
      percent4
      donorScheduleId
      donorId
    }
  }
}
    ${PartnershipAccountFragmentDoc}`;
export const GET_PREVIOUS_SCHEDULES = `
    query GET_PREVIOUS_SCHEDULES($donorScheduleId: UUID!, $donorId: UUID!, $ownerId: UUID!) {
  previousSchedules(
    donorScheduleId: $donorScheduleId
    donorId: $donorId
    ownerId: $ownerId
  ) {
    id
    description
    name
    aspirationDate
    leftSmallFollicles
    leftMediumFollicles
    leftLargeFollicles
    rightSmallFollicles
    rightMediumFollicles
    rightLargeFollicles
    gradeAbc
    gradeD
    gradeE
    dead
    numberInMat
  }
}
    `;
export const TOP_REVISIONS_BY_FERTILIZATION_SITE = `
    query TOP_REVISIONS_BY_FERTILIZATION_SITE($fertilizationSiteId: UUID!, $date: DateTime!) {
  topRevisionsByFertilizationSite(
    fertilizationSiteId: $fertilizationSiteId
    date: $date
  )
}
    `;
export const GET_NEXT_SCHEDULE = `
    query GET_NEXT_SCHEDULE($donorId: UUID!) {
  aspirations(
    take: 1
    where: {and: [{donorId: {eq: $donorId}}, {stateCode: {eq: 0}}, {or: [{scheduleMasterId: {neq: null}}, {nextScheduleMasterId: {neq: null}}]}]}
    order: {aspDate: DESC}
  ) {
    items {
      fshNext
      nextScheduleMaster {
        id
        name
        method
        twiceConcentration
      }
      scheduleMaster {
        id
        name
        method
        twiceConcentration
      }
    }
  }
}
    `;
export const GET_SCHEDULED_DRUGS = `
    query GET_SCHEDULED_DRUGS($donorId: UUID!) {
  superOvulationSchedules(
    take: 1
    where: {and: [{donorId: {eq: $donorId}}, {stateCode: {eq: 0}}]}
    order: {flushDate: DESC}
  ) {
    items {
      id
      donorId
      scheduleMasterId
      drug {
        id
        name
      }
      drug2 {
        id
        name
      }
    }
  }
}
    `;
export const SCHEDULED_DONORS = `
    query SCHEDULED_DONORS($semenID: String!, $donorScheduleDate: DateTime!, $semenType: String!, $accountID: String!) {
  scheduledDonors(
    semenID: $semenID
    donorScheduleDate: $donorScheduleDate
    semenType: $semenType
    accountID: $accountID
  ) {
    items {
      donorName
      csr
      donorScheduleID
    }
  }
}
    `;
export const PULLED_SEMEN = `
    query PULLED_SEMEN($donorScheduleDate: DateTime!, $fertSiteId: UUID!) {
  pulledSemen(donorScheduleDate: $donorScheduleDate, fertSiteId: $fertSiteId) {
    items {
      rowNum
      semenID
      semenName
      sireID
      sireName
      donors_Sire
      semenTypeName
      name_Type
      accountID
      accountName
      semenStorageID
      semenStorageName
      semenStorageSiteName
      cane
      colCode
      naab
      exportName
      quantity
      pulledQuantity
      sireBreed
    }
  }
}
    `;
export const FERTILIZATION_TECHS = `
    query FERTILIZATION_TECHS($fertSiteId: UUID) {
  techs(fertSiteId: $fertSiteId) {
    items {
      name
      value
    }
  }
}
    `;
export const FERTILIZATION_DONOR_SCHEDULE = `
    query FERTILIZATION_DONOR_SCHEDULE($donorScheduleDate: DateTime!, $fertSiteId: UUID!) {
  fertilizationDonorSchedules(
    donorScheduleDate: $donorScheduleDate
    fertSiteId: $fertSiteId
  ) {
    items {
      donorScheduleID
      aspirationPoolID
      aspirationID
      donorName
      semenID
      semenName
      backupSemenID
      backupSemenName
      name_Type
      semenTypeName
      accountID
      accountNumber
      semenComment
      exportName
      matTime
      aspDate
      ivmMat
      donorBreed
      donorBreedName
    }
  }
}
    `;
export const CREATED_FERTS = `
    query CREATED_FERTS($donorScheduleDate: DateTime!, $fertSiteId: UUID!) {
  createdFerts(donorScheduleDate: $donorScheduleDate, fertSiteId: $fertSiteId) {
    items {
      fertID
      fertName
      semenType
      accountID
      accountNumber
      numSemenUnits
      ivfNum
      matTime
      exportValue
      exportName
      fertComment
      fertComments
    }
  }
}
    `;
export const FERT_COMMENTS = `
    query FERT_COMMENTS {
  fertCommentsList {
    items {
      text
      value
    }
  }
}
    `;
export const INLINE_FERT_COMMENTS = `
    query INLINE_FERT_COMMENTS {
  fertCommentsInGridList {
    items {
      text
      value
    }
  }
}
    `;
export const INCUBATORS = `
    query INCUBATORS($siteId: UUID!) {
  incubators(where: {and: [{siteId: {eq: $siteId}}, {use: {eq: 100000001}}]}) {
    items {
      id
      name
    }
  }
}
    `;
export const UPSERT_REVERSE_SORT = `
    mutation UPSERT_REVERSE_SORT($semenId: UUID!, $initialMobility: Int!, $initialDeadRate: Int!, $finalDeadRate: Int!, $splitScore: Int!, $postSortMortality: Int!, $purity: Int!) {
  upsertReverseSort(
    input: {semenId: $semenId, initialMobility: $initialMobility, initialDeadRate: $initialDeadRate, finalDeadRate: $finalDeadRate, splitScore: $splitScore, postSortMortality: $postSortMortality, purity: $purity}
  )
}
    `;
export const CREATE_FERTILIZATION = `
    mutation CREATE_FERTILIZATION($semenID: [String!]!, $dsid: [String!]!, $semenQtyUse: [Int!]!, $semenTypeList: [String!]!, $mofloList: [String!]!, $numFerts: Int!, $fertTime: [String!]!, $donorScheduleDate: DateTime!, $fertDate: DateTime!, $procTechID: UUID!, $moveTechID: UUID!, $fertTechID: UUID!, $fertComment: [String!]!, $ivfNum: [Int!]!, $billUnits: Decimal!, $pooledSires: Boolean!, $gridFertCommentsDDL: [[Int!]!]!, $fertCommentList: [Int!]!, $isContaminated: [Boolean!]!, $sofDate: DateTime!, $fertMediaLotNo: DateTime!, $mineralOilLot: String!, $serum: String!, $fertPlate: String!, $culturePlateLotNo: String!, $cultureIncubatorNo: UUID, $ehmMedia: DateTime!, $qcIsolate: String!) {
  createFertilizations(
    input: {semenID: $semenID, dsid: $dsid, semenQtyUse: $semenQtyUse, semenTypeList: $semenTypeList, mofloList: $mofloList, numFerts: $numFerts, fertTime: $fertTime, donorScheduleDate: $donorScheduleDate, fertDate: $fertDate, procTechID: $procTechID, moveTechID: $moveTechID, fertTechID: $fertTechID, fertComment: $fertComment, ivfNum: $ivfNum, billUnits: $billUnits, pooledSires: $pooledSires, gridFertCommentsDDL: $gridFertCommentsDDL, fertCommentList: $fertCommentList, sofDate: $sofDate, fertMediaLotNo: $fertMediaLotNo, mineralOilLot: $mineralOilLot, serum: $serum, fertPlate: $fertPlate, culturePlateLotNo: $culturePlateLotNo, cultureIncubatorNo: $cultureIncubatorNo, ehmMedia: $ehmMedia, qcIsolate: $qcIsolate, isContaminated: $isContaminated}
  ) {
    code
    success
    message
    fertilizationIds
  }
}
    `;
export const UPDATE_FERT_TRANSACTION_FREEZE = `
    mutation UPDATE_FERT_TRANSACTION_FREEZE($id: String!, $field: String!, $value: String!) {
  updateFertTransactionFreeze(id: $id, field: $field, value: $value)
}
    `;
export const UPDATE_EMBRYO_TRANSACTION = `
    mutation UPDATE_EMBRYO_TRANSACTION($id: String!, $field: String!, $value: String) {
  updateEmbryoTransaction(id: $id, field: $field, value: $value)
}
    `;
export const UPDATE_INT_EMBRYO_TRANSACTION = `
    mutation UPDATE_INT_EMBRYO_TRANSACTION($id: String!, $field: String!, $value: String) {
  updateInterimEmbryoTransaction(id: $id, field: $field, value: $value)
}
    `;
export const UPDATE_OD_FREEZE = `
    mutation UPDATE_OD_FREEZE($input: UpdateODFreezeInput!, $dtplus: Boolean) {
  updateODFreeze(input: $input, dtplus: $dtplus)
}
    `;
export const ADD_INT_EMBRYOS = `
    mutation ADD_INT_EMBRYOS($input: MassInterimEmbryosInput!, $type: Int!, $dtplus: Boolean) {
  addIntEmbs(input: $input, type: $type, dtplus: $dtplus) {
    fertilizationId
    embryoId
    name
    cane
    subCane
    freezer
    freezeMethodName
    freezeMethodId
    freezeTech
    embryoFreezeEntryId
    d65
    d7
    discard
    grade
    stage
    straw
    tt
    crackedZona
    lowQuality
    storageLocationName
    loadDonorPartnershipsFrozen
    ownerId
    ownerName
    owners {
      ownerId
      ranchCode
      percentage
    }
  }
}
    `;
export const ADD_MASS_INT_EMBRYOS = `
    mutation ADD_MASS_INT_EMBRYOS($items: MassInterimEmbryosInput!, $dtplus: Boolean) {
  addMassInterimEmbryos(items: $items, dtplus: $dtplus)
}
    `;
export const DEACTIVATE_INT_EMB = `
    mutation DEACTIVATE_INT_EMB($items: [String!]!) {
  deactivateInterimEmbryo(items: $items)
}
    `;
export const PDF_CREATE_FREEZE = `
    mutation PDF_CREATE_FREEZE($items: [PrintInfoInput!]!, $filename: String!) {
  pdfCreateFreeze(items: $items, filename: $filename)
}
    `;
export const VALIDATE_FREEZE = `
    mutation VALIDATE_FREEZE($fertilizationIds: [UUID!]!, $fertilizationDate: String!, $fertilizationSiteId: String!, $fertilizationId: String, $validatorId: UUID!, $validationDate: DateTime!) {
  validateFreeze(
    fertilizationIds: $fertilizationIds
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    fertilizationId: $fertilizationId
    validatorId: $validatorId
    validationDate: $validationDate
  )
}
    `;
export const APPLY_APPROVAL_NUMBER_TO_EMBRYOS = `
    mutation APPLY_APPROVAL_NUMBER_TO_EMBRYOS($updates: [UpdateApprovalNumberInput!]!) {
  applyApprovalNumberToEmbryos(updates: $updates)
}
    `;
export const UPDATE_FREEZE_EMBRYOS_ASYNC = `
    mutation UPDATE_FREEZE_EMBRYOS_ASYNC($embryoIds: [UUID!]!, $name: String, $storageLocationId: UUID, $freezeMethodId: UUID, $graderId: UUID, $freezeTechId: UUID, $accountId: UUID, $deactivate: Boolean, $crackedZona: Boolean, $lowQuality: Boolean, $freezer: String) {
  updateFreezeEmbryos(
    embryoIds: $embryoIds
    name: $name
    storageLocationId: $storageLocationId
    freezeMethodId: $freezeMethodId
    graderId: $graderId
    freezeTechId: $freezeTechId
    accountId: $accountId
    deactivate: $deactivate
    crackedZona: $crackedZona
    lowQuality: $lowQuality
    freezer: $freezer
  )
}
    `;
export const UPDATE_FREEZE_TEMP_EMBRYOS_ASYNC = `
    mutation UPDATE_FREEZE_TEMP_EMBRYOS_ASYNC($tempEmbryoIds: [UUID!]!, $name: String, $storageLocationId: UUID, $freezeMethodId: UUID, $freezeTechId: UUID, $accountId: UUID, $deactivate: Boolean, $crackedZona: Boolean, $lowQuality: Boolean, $freezer: String) {
  updateFreezeTempEmbryos(
    tempEmbryoIds: $tempEmbryoIds
    name: $name
    storageLocationId: $storageLocationId
    freezeMethodId: $freezeMethodId
    freezeTechId: $freezeTechId
    accountId: $accountId
    deactivate: $deactivate
    crackedZona: $crackedZona
    lowQuality: $lowQuality
    freezer: $freezer
  )
}
    `;
export const CREATE_FREEZE_VALIDATION_REPORT = `
    mutation CREATE_FREEZE_VALIDATION_REPORT($fertilizationIds: [UUID!]!) {
  createFreezeValidationReport(fertilizationIds: $fertilizationIds)
}
    `;
export const UPDATE_MATING_LABELS_FREEZE = `
    mutation UPDATE_MATING_LABELS_FREEZE($fertilizationDate: String!, $site: String!) {
  updateMatingLabelsFreezeXlsx(fertilizationDate: $fertilizationDate, site: $site)
}
    `;
export const GET_FERTILIZATION_LIST_FREEZE = `
    query GET_FERTILIZATION_LIST_FREEZE($fertilizationDate: String!, $fertilizationSiteId: String!, $fertilizationId: String, $searchQuery: String) {
  fertilizationListFreeze(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    fertilizationId: $fertilizationId
    searchQuery: $searchQuery
  ) {
    fertId
    frozen
    plateNumber
    csr
    contaminantPresent
    account
    opuSite
    opuSiteName
    donorName
    donorId
    dBreed
    sireName
    sireId
    sBreed
    semenType
    ivcNumber
    cleaved
    predictedGood
    predictedLow
    predictedVeryLow
    heldAtTogToFreeze
    heldTransfer
    heldTransferLg
    discardedGrade1
    discardedGrade2
    discarded
    degenerates
    noEmbryosProduced
    cane
    export
    approvalNumber
    approvalNumberId
    freezeMethod
    programName
    partners
    predictionTech
    csrComment
    resultsComment
    intEmbs
    embs
    validatorId
    validationDate
    breedCategory
    isDonorDuplicate
    isPlateDuplicate
    index
    partnershipId
    billAccountCaningOption
  }
}
    `;
export const GET_FERT_AND_EMBRYOS_FREEZE = `
    query GET_FERT_AND_EMBRYOS_FREEZE($fertilizationDate: String!, $fertilizationSiteId: String!, $fertilizationIds: [UUID!]!) {
  fertAndEmbryosFreeze(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    fertilizationIds: $fertilizationIds
  ) {
    fertId
    liveEmbryos {
      fertilizationId
      id
      name
      donorId
      donorName
      sireId
      sireName
      cane
      subCane
      subCaneNoSuffix
      freezeMethodId
      freezeMethodName
      freezer
      freezeTechName
      d65
      d7
      dtPlus
      grader7Id
      grader7Name
      freshFrozen
      freshFrozenName
      grade
      stage
      strawNumber
      strawLabel
      tt
      crackedZona
      lowQuality
      storageLocationName
      storageLocationId
      ownerName
      qcEg10
      qcTryPsInDate
      qcehmDate
      equilibrationSolutionDate
      qcEg10Date
      qcSucroseDate
      vitrificationSolutionDate
      qcfreezingComment
      qcStrawLotNumber
      qcVitStrawLotNumber
      qcSterileStrawLotNumber
      qc12WellPlates
    }
    tempEmbryos {
      fertilizationId
      embryoId
      name
      cane
      subCane
      freezer
      freezeMethodName
      freezeMethodId
      freezeTech
      embryoFreezeEntryId
      d65
      d7
      discard
      grade
      stage
      straw
      tt
      crackedZona
      lowQuality
      storageLocationName
      loadDonorPartnershipsFrozen
      ownerId
      ownerName
      owners {
        ownerId
        ranchCode
        percentage
      }
    }
  }
}
    `;
export const GET_FREEZE_STORAGE_LOCATIONS = `
    query GET_FREEZE_STORAGE_LOCATIONS($fertilizationSiteId: UUID!) {
  storageLocations(
    where: {and: [{siteId: {eq: $fertilizationSiteId}}, {stateCode: {eq: 0}}]}
    order: {name: ASC}
  ) {
    items {
      siteId
      id
      name
    }
  }
}
    `;
export const UPDATE_FERT_TRANSACTION = `
    mutation UPDATE_FERT_TRANSACTION($id: String!, $field: String!, $value: String!, $updatePredictedComments: Boolean) {
  updateFertTransaction(
    id: $id
    field: $field
    value: $value
    updatePredictedComments: $updatePredictedComments
  ) {
    code
    success
    message
  }
}
    `;
export const UPDATE_DS_TRANSACTION = `
    mutation UPDATE_DS_TRANSACTION($id: String!, $field: String!, $value: String!, $updatePredictedComments: Boolean, $isIvf: Boolean) {
  updateDSTransaction(
    id: $id
    field: $field
    value: $value
    updatePredictedComments: $updatePredictedComments
    isIvf: $isIvf
  ) {
    code
    success
    message
  }
}
    `;
export const UPDATE_FRESH_SHIPMENT_TRANSACTION = `
    mutation UPDATE_FRESH_SHIPMENT_TRANSACTION($id: String!, $field: String!, $value: String!) {
  updateFreshShipmentTransaction(id: $id, field: $field, value: $value) {
    code
    success
    message
  }
}
    `;
export const UPDATE_SHIPMENT_GROUP_TRANSACTION = `
    mutation UPDATE_SHIPMENT_GROUP_TRANSACTION($id: String!, $field: String!, $value: String!) {
  updateShipmentGroupTransaction(id: $id, field: $field, value: $value) {
    code
    success
    message
  }
}
    `;
export const CREATE_FRESH_SHIPMENT_IMPLANT_FORM_REPORT = `
    mutation CREATE_FRESH_SHIPMENT_IMPLANT_FORM_REPORT($shipmentNumber: String!, $accountNumber: String!) {
  createFreshShipmentImplantFormReport(
    shipmentNumber: $shipmentNumber
    accountNumber: $accountNumber
  )
}
    `;
export const CREATE_FRESH_SHIPMENT_FORM_REPORT = `
    mutation CREATE_FRESH_SHIPMENT_FORM_REPORT($shipmentNumber: String!, $accountNumber: String!) {
  createFreshShipmentFormReport(
    shipmentNumber: $shipmentNumber
    accountNumber: $accountNumber
  )
}
    `;
export const CREATE_FRESH_SHIPMENT_EXPORT_SEAL_FORM_REPORT = `
    mutation CREATE_FRESH_SHIPMENT_EXPORT_SEAL_FORM_REPORT($shipmentNumber: String!, $freshShipmentId: String!) {
  createFreshShipmentExportSealFormReport(
    shipmentNumber: $shipmentNumber
    freshShipmentId: $freshShipmentId
  )
}
    `;
export const UPDATE_MATING_LABELS = `
    mutation UPDATE_MATING_LABELS($fertilizationDate: String!, $site: String!, $shipGroups: String!) {
  updateMatingLabelsXlsx(
    fertilizationDate: $fertilizationDate
    site: $site
    shipGroups: $shipGroups
  )
}
    `;
export const UPDATE_MATING_LABELS_DUPES = `
    mutation UPDATE_MATING_LABELS_DUPES($fertilizationDate: String!, $site: String!, $shipGroups: String!) {
  updateMatingLabelsDupesXlsx(
    fertilizationDate: $fertilizationDate
    site: $site
    shipGroups: $shipGroups
  )
}
    `;
export const UPDATE_INCUBATOR_ASSIGNMENT = `
    mutation UPDATE_INCUBATOR_ASSIGNMENT($fertilizationId: String!, $value: String!) {
  updateIncubatorAssignment(fertilizationId: $fertilizationId, value: $value) {
    code
    success
    message
  }
}
    `;
export const GENERATE_SIGN_OFF_EMAIL = `
    mutation GENERATE_SIGN_OFF_EMAIL($username: String!, $fertilizationDate: DateTime!, $fertilizationSiteId: UUID!, $shipGroupId: UUID!) {
  generateSignOffEmail(
    username: $username
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    shipGroupId: $shipGroupId
  ) {
    code
    success
    message
  }
}
    `;
export const UNDO_SHIPMENT = `
    mutation UNDO_SHIPMENT($freshShipmentId: UUID!, $fertSiteId: UUID!) {
  undoShipment(freshShipmentId: $freshShipmentId, fertSiteId: $fertSiteId) {
    code
    success
    message
  }
}
    `;
export const COMBINE_SHIPMENTS = `
    mutation COMBINE_SHIPMENTS($freshShipIdList: [FreshShipIdListInput!]!) {
  combineShipments(freshShipIdList: $freshShipIdList) {
    code
    success
    message
  }
}
    `;
export const UPDATE_QC_FRESH_SHIPMENT = `
    mutation UPDATE_QC_FRESH_SHIPMENT($fertilizationDate: String!, $fertilizationSiteId: String!, $shipGroupId: String!, $qcEHMDate10ml: DateTime, $qcEHMDate20ml: DateTime, $qcEHMDate40ml: DateTime, $qcEHMDate125ml: DateTime, $qcEHMDate250ml: DateTime, $qcShippingTubeExpirationDate: DateTime!) {
  updateQcFreshShipment(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    shipGroupId: $shipGroupId
    qcEHMDate10ml: $qcEHMDate10ml
    qcEHMDate20ml: $qcEHMDate20ml
    qcEHMDate40ml: $qcEHMDate40ml
    qcEHMDate125ml: $qcEHMDate125ml
    qcEHMDate250ml: $qcEHMDate250ml
    qcShippingTubeExpirationDate: $qcShippingTubeExpirationDate
  ) {
    code
    success
    message
  }
}
    `;
export const CREATE_COMM_DAIRY_FERTILIZATION_EXCEL = `
    mutation CREATE_COMM_DAIRY_FERTILIZATION_EXCEL($fertilizationDate: String!, $fertilizationSiteId: String!, $shipGroupId: String!, $d5: Boolean!) {
  createCommDairyFertilizationExcel(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    shipGroupId: $shipGroupId
    d5: $d5
  )
}
    `;
export const SEND_COMM_DAIRY_FERTILIZATION_EMAIL = `
    mutation SEND_COMM_DAIRY_FERTILIZATION_EMAIL($fertilizationDate: String!, $fertilizationSiteId: String!, $shipGroupId: String!, $email: String!, $username: String!, $d5: Boolean!) {
  sendCommDairyFertilizationEmail(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    shipGroupId: $shipGroupId
    email: $email
    username: $username
    d5: $d5
  )
}
    `;
export const GET_SHIP_GROUP_LIST = `
    query GET_SHIP_GROUP_LIST($fertilizationDate: String!, $fertilizationSiteId: String!) {
  shipGroupList(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
  ) {
    activeShipGroups {
      shipGroupId
      shipGroupName
      fertDate
      numMating
      numTubes
    }
    signedOffShipGroups {
      shipGroupId
      shipGroupName
      fertDate
      numMating
      numTubes
    }
  }
}
    `;
export const GET_FRESH_SHIPMENT_LIST = `
    query GET_FRESH_SHIPMENT_LIST($fertilizationDate: String!, $fertilizationSiteId: String!, $fertilizationSiteName: String!) {
  freshShipmentList(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    fertilizationSiteName: $fertilizationSiteName
  ) {
    freshShipmentId
    name
    matingsCount
    trackingNumber
    shipmentNumber
    shipperId
    shippedEmbryosCount
    exportStatus
  }
}
    `;
export const GET_FERTILIZATION_LIST = `
    query GET_FERTILIZATION_LIST($fertilizationDate: String!, $fertilizationSiteId: String!, $shipGroupId: String!) {
  fertilizationList(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    shipGroupId: $shipGroupId
  ) {
    fertilizationId
    fertDate
    plateNumber
    predictedBy
    tubeNumber
    csr
    accountNumber
    siteName
    donorName
    donorId
    donorBreed
    breedDonor
    donorLocation
    sireName
    sireBreed
    sireReg
    breedSire
    semenTypeName
    ivcNumber
    cleaved
    predictedGood
    predictedLow
    predictedVeryLow
    origHeldAtTog
    origShipped
    heldAtTogToFreeze
    heldAtTogFreezeTransferLowGrade
    heldAtTogForTransfer
    shipped
    shippedTog
    shipped2
    shippedTog2
    shipmentGroupMasterId
    shipmentGroupMaster2Id
    day5esttrans
    export
    exportName
    noEmbryosProduced
    contaminantPresent
    embryoComment
    ivfComment
    csrComment
    freshShipmentComments
    comments
    partnerships
    freshShipmentId
    shippedBillable
    inc1
    inc2
    inc1Id
    inc2Id
    freezeName
    shipName
    transferName
    implantType
    totals
    cane
    colCode
    billIncubator
    billIncubator2
    billShipping
    billShipping2
    shipGroupName
    loadedInStraws
    priority
    embryoCalcPaNm
    embryoCalcPaTpi
    isDuplicate
    programName
  }
}
    `;
export const GET_ESTIMATION_HEADER_VAL = `
    query GET_ESTIMATION_HEADER_VAL($shipGroupId: String!) {
  estimationHeaderVal(shipGroupId: $shipGroupId)
}
    `;
export const GET_PREDICTION_TECHS = `
    query GET_PREDICTION_TECHS {
  equipments(
    where: {or: [{farmlocation: {eq: false}}, {farmlocation: {eq: null}}]}
    order: {name: ASC}
  ) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_CURRENT_FERT_PREDICTION_TECH = `
    query GET_CURRENT_FERT_PREDICTION_TECH($fertilizationId: UUID!) {
  currentFertPredictionTechId(fertilizationId: $fertilizationId) {
    id
    name
  }
}
    `;
export const GET_SHIPMENT_GROUP_MASTERS = `
    query GET_SHIPMENT_GROUP_MASTERS($fertilizationSiteId: String!, $shipGroupId: String!) {
  shipmentGroupMasters(
    fertilizationSiteId: $fertilizationSiteId
    shipGroupId: $shipGroupId
  ) {
    shipmentGroupMasterId
    name
  }
}
    `;
export const GET_FERTILIZATION_QC_DATA = `
    query GET_FERTILIZATION_QC_DATA($fertilizationId: UUID!) {
  fertilizations(where: {id: {eq: $fertilizationId}}) {
    items {
      qcEHMDate10ml
      qcEHMDate20ml
      qcEHMDate40ml
      qcEHMDate125ml
      qcEHMDate250ml
      qcShippingTubeExpirationDate
      qcSofDate
    }
  }
}
    `;
export const GET_FRESH_SHIPMENT_QC = `
    query GET_FRESH_SHIPMENT_QC($fertilizationDate: String!, $fertilizationSiteId: String!, $shipGroupIds: [UUID!]!) {
  freshShipmentQC(
    fertilizationDate: $fertilizationDate
    fertilizationSiteId: $fertilizationSiteId
    shipGroupIds: $shipGroupIds
  ) {
    qcEHMDate10ml
    qcEHMDate20ml
    qcEHMDate40ml
    qcEHMDate125ml
    qcEHMDate250ml
    qcShippingTubeExpirationDate
    qcSofDate
  }
}
    `;
export const CREATE_ISSUE_MANAGER = `
    mutation CREATE_ISSUE_MANAGER($adUserId: UUID!, $issueType: RequestIssueType!) {
  createIssueManager(adUserId: $adUserId, issueType: $issueType) {
    ...RequestIssueManager
  }
}
    ${RequestIssueManagerFragmentDoc}`;
export const DELETE_ISSUE_MANAGER = `
    mutation DELETE_ISSUE_MANAGER($id: Int!) {
  deleteIssueManager(id: $id)
}
    `;
export const CREATE_REQUEST_EVENT = `
    mutation CREATE_REQUEST_EVENT($requestId: Int!, $type: RequestEventType!, $content: String!, $refRequestId: Int) {
  createItRequestEvent(
    requestId: $requestId
    type: $type
    content: $content
    refRequestId: $refRequestId
  ) {
    ...RequestEvent
  }
}
    ${RequestEventFragmentDoc}`;
export const CREATE_IT_REQUEST = `
    mutation CREATE_IT_REQUEST($request: RequestInput!) {
  createItRequest(request: $request) {
    id
  }
}
    `;
export const CREATE_CLIENT_ISSUE_REQUEST = `
    mutation CREATE_CLIENT_ISSUE_REQUEST($input: RequestClientIssueInput!) {
  createClientIssueRequest(input: $input) {
    id
  }
}
    `;
export const CREATE_REPORT_REQUEST = `
    mutation CREATE_REPORT_REQUEST($input: ReportRequestInput!) {
  createReportRequest(input: $input) {
    id
  }
}
    `;
export const MY_OPEN_REQUESTS = `
    query MY_OPEN_REQUESTS($skip: Int!, $take: Int!, $order: [RequestSortInput!], $where: RequestFilterInput!) {
  openItRequests(skip: $skip, take: $take, order: $order, where: $where) {
    items {
      ...Request
    }
    totalCount
  }
}
    ${RequestFragmentDoc}`;
export const MY_CLOSED_REQUESTS = `
    query MY_CLOSED_REQUESTS($skip: Int!, $take: Int!, $order: [RequestSortInput!], $where: RequestFilterInput!) {
  closedItRequests(skip: $skip, take: $take, order: $order, where: $where) {
    items {
      ...Request
    }
    totalCount
  }
}
    ${RequestFragmentDoc}`;
export const MY_REQUESTS = `
    query MY_REQUESTS($skip: Int!, $take: Int!, $order: [RequestSortInput!], $where: RequestFilterInput!) {
  itRequests(skip: $skip, take: $take, order: $order, where: $where) {
    items {
      ...Request
    }
    totalCount
  }
}
    ${RequestFragmentDoc}`;
export const ALL_REQUESTS = `
    query ALL_REQUESTS($skip: Int!, $take: Int!, $order: [RequestSortInput!], $where: RequestFilterInput!) {
  itRequests(skip: $skip, take: $take, order: $order, where: $where) {
    items {
      ...Request
      isImportant
    }
    totalCount
  }
}
    ${RequestFragmentDoc}`;
export const ALL_OPEN_REQUESTS = `
    query ALL_OPEN_REQUESTS($skip: Int!, $take: Int!, $order: [RequestSortInput!], $where: RequestFilterInput!) {
  openItRequests(skip: $skip, take: $take, order: $order, where: $where) {
    items {
      ...Request
      isImportant
    }
    totalCount
  }
}
    ${RequestFragmentDoc}`;
export const ALL_CLOSED_REQUESTS = `
    query ALL_CLOSED_REQUESTS($skip: Int!, $take: Int!, $order: [RequestSortInput!], $where: RequestFilterInput!) {
  closedItRequests(skip: $skip, take: $take, order: $order, where: $where) {
    items {
      ...Request
      isImportant
    }
    totalCount
  }
}
    ${RequestFragmentDoc}`;
export const SEARCH_REQUEST = `
    query SEARCH_REQUEST($query: String!, $type: RequestIssueType) {
  itRequestSearch(query: $query, issueType: $type) {
    ...Request
  }
}
    ${RequestFragmentDoc}`;
export const IT_REQUEST = `
    query IT_REQUEST($id: Int!) {
  itRequest(where: {id: {eq: $id}}) {
    ...FullRequest
  }
}
    ${FullRequestFragmentDoc}`;
export const TOGGLE_SUBSCRIBED = `
    mutation TOGGLE_SUBSCRIBED($id: Int!) {
  requestToggleSubscribed(id: $id) {
    id
    isSubscribed
  }
}
    `;
export const TOGGLE_IMPORTANT = `
    mutation TOGGLE_IMPORTANT($id: Int!) {
  requestToggleImportant(id: $id) {
    id
    isImportant
  }
}
    `;
export const IT_APPS = `
    query IT_APPS {
  itRequestApps {
    id
    name
  }
}
    `;
export const DEPARTMENTS = `
    query DEPARTMENTS {
  itRequestDepartments {
    id
    name
  }
}
    `;
export const IT_REQUEST_ISSUE_MANAGERS = `
    query IT_REQUEST_ISSUE_MANAGERS {
  requestIssueManagers(order: [{issueType: ASC}, {createdAt: ASC}]) {
    items {
      ...RequestIssueManager
    }
  }
}
    ${RequestIssueManagerFragmentDoc}`;
export const AD_USERS = `
    query AD_USERS {
  adUsers {
    id
    name
  }
}
    `;
export const ADD_LEGACY_APPS_FAVORITE = `
    mutation ADD_LEGACY_APPS_FAVORITE($appId: ID!) {
  addFavorite(appId: $appId)
}
    `;
export const REMOVE_LEGACY_APPS_FAVORITE = `
    mutation REMOVE_LEGACY_APPS_FAVORITE($appId: ID!) {
  removeFavorite(appId: $appId)
}
    `;
export const REORDER_LEGACY_APPS_FAVORITES = `
    mutation REORDER_LEGACY_APPS_FAVORITES($appIds: [ID!]!) {
  reorderFavorites(appIds: $appIds)
}
    `;
export const GET_ALL_LEGACY_APPS = `
    query GET_ALL_LEGACY_APPS {
  apps {
    ...App
  }
}
    ${AppFragmentDoc}`;
export const GET_LEGACY_APPS_FAVORITES = `
    query GET_LEGACY_APPS_FAVORITES {
  appsFavorites
}
    `;
export const UPDATE_ASPIRATION_OPU_SEARCH = `
    mutation UPDATE_ASPIRATION_OPU_SEARCH($input: EmbryologistDataEntryInput!, $isReturn: String!) {
  updateAspirationOpuSearch(input: $input, isReturn: $isReturn)
}
    `;
export const CREATE_NEW_ASP_POOL = `
    mutation CREATE_NEW_ASP_POOL($aspirationIds: [String!]!, $siteId: String!) {
  createNewAspPool(aspirationIds: $aspirationIds, siteId: $siteId)
}
    `;
export const REMOVE_ASP_POOL = `
    mutation REMOVE_ASP_POOL($aspirationPoolIds: [String!]!) {
  removeAspPool(aspirationPoolIds: $aspirationPoolIds)
}
    `;
export const SAVE_QC_DATA_OPUSEARCH = `
    mutation SAVE_QC_DATA_OPUSEARCH($input: QcDataOpuSearchInput!, $aspirationDate: String!, $siteId: String!, $location: String) {
  updateQCDataOpuSearch(
    input: $input
    aspirationDate: $aspirationDate
    siteId: $siteId
    location: $location
  )
}
    `;
export const GET_EQUIPMENTS = `
    query GET_EQUIPMENTS {
  equipments(where: {embryologist: {eq: true}}, order: {name: ASC}) {
    items {
      name
      id
    }
  }
}
    `;
export const GET_ASPIRATION_BY_DONOR_AND_ID = `
    query GET_ASPIRATION_BY_DONOR_AND_ID($donorId: UUID!, $aspirationId: UUID!) {
  aspirations(
    where: {and: [{donorId: {eq: $donorId}}, {id: {eq: $aspirationId}}]}
  ) {
    items {
      id
      ivmTime
      aspDate
      donorId
      fertPlan
      gradeA
      gradeB
      gradeC
      gradeD
      gradeE
      dead
      usdaSeal
      ivmCyto
      ivmMat
      fshType
      ivmComment
      dishType
      ivmTechnicianId
    }
  }
}
    `;
export const GET_COMPLETED_ASPIRATIONS_TODAY = `
    query GET_COMPLETED_ASPIRATIONS_TODAY($date: String!, $siteId: String!) {
  todaysCompletedAspirationsNew(date: $date, siteId: $siteId) {
    aspirationId
    aspirationTime
    account
    csa
    breed
    donor
    donorRegNum
    sire
    semenType
    donorLocation
    fertSite
    pooled
    export
    nonEuComment
    medTotal
    totalOocytes
    numInMat
    csr
    matTime
    aspComments
    poolNum
    dsAspirationComment
    programName
    vetId
    asstId
    siteId
    ivmId
    ivmTech
    ivmMat
    ivmTime
    aspirationDate
    scheduleId
    totalFollicles
    ll
    lm
    ls
    rl
    rm
    rs
    cll
    cystl
    clr
    cystr
    comment
    donorCondition
    donorId
    completeOrder
    embCompleteOrder
    opuTech
    chuteTech
    totalLeft
    totalRight
    fertPlan
  }
}
    `;
export const GET_COMPLETED_ASPIRATIONS_TODAY_FBD = `
    query GET_COMPLETED_ASPIRATIONS_TODAY_FBD($date: String!, $siteId: String!, $location: String!) {
  todaysCompletedAspirationsFBD(date: $date, siteId: $siteId, location: $location) {
    aspirationId
    aspirationTime
    account
    csa
    breed
    donor
    sire
    semenType
    donorLocation
    donorRegNum
    fertSite
    pooled
    export
    nonEuComment
    medTotal
    totalOocytes
    numInMat
    csr
    matTime
    aspComments
    poolNum
    dsAspirationComment
    programName
    vetId
    asstId
    siteId
    ivmId
    ivmTech
    ivmMat
    ivmTime
    aspirationDate
    scheduleId
    totalFollicles
    ll
    lm
    ls
    rl
    rm
    rs
    cll
    cystl
    clr
    cystr
    comment
    donorCondition
    donorId
    completeOrder
    embCompleteOrder
    opuTech
    chuteTech
    totalLeft
    totalRight
    fertPlan
  }
}
    `;
export const GET_STATS_DATA = `
    query GET_STATS_DATA($aspirationDate: String!, $siteId: String!, $location: String) {
  statsData(aspirationDate: $aspirationDate, siteId: $siteId, location: $location) {
    techCount
    techStats {
      techId
      tech
      totalFollicles
      totalgOocytes
      totalNumInMat
      avgFollicles
      avgOocytes
      avgNumInMat
    }
    folliclesTotal
    oocytesTotal
    numInMatTotal
    avgFolliclesTotal
    avgOocytesTotal
    avgNumInMatTotal
  }
}
    `;
export const GET_STATS_DATA_PSE = `
    query GET_STATS_DATA_PSE($aspirationDate: String!, $siteId: String!, $location: String) {
  statsDataPSE(
    aspirationDate: $aspirationDate
    siteId: $siteId
    location: $location
  ) {
    techCount
    techStats {
      techId
      tech
      totalFollicles
      totalgOocytes
      totalNumInMat
      avgFollicles
      avgOocytes
      avgNumInMat
    }
    folliclesTotal
    oocytesTotal
    numInMatTotal
    avgFolliclesTotal
    avgOocytesTotal
    avgNumInMatTotal
  }
}
    `;
export const GET_OPU_ENTRIES = `
    query GET_OPU_ENTRIES($aspirationDate: String!, $siteId: String!, $techId: String!) {
  entryData(aspirationDate: $aspirationDate, siteId: $siteId, techId: $techId) {
    donorName
    follicles
    oocytes
    numInMat
    ivmCyto
    comment
    aspTime
    rowNo
    aspirationId
  }
}
    `;
export const GET_OPU_ENTRIES_PSE = `
    query GET_OPU_ENTRIES_PSE($aspirationDate: String!, $siteId: String!, $pseId: String!) {
  entryDataPSE(aspirationDate: $aspirationDate, siteId: $siteId, pseId: $pseId) {
    donorName
    follicles
    oocytes
    numInMat
    ivmCyto
    comment
    aspTime
    rowNo
  }
}
    `;
export const GET_TECH_AVG_DATA = `
    query GET_TECH_AVG_DATA($aspirationDate: String!, $siteId: String!, $techId: String!) {
  techAvgData(aspirationDate: $aspirationDate, siteId: $siteId, techId: $techId) {
    blank
    follicles
    oocytes
    numInMat
    blank1
  }
}
    `;
export const GET_AVG_DATA = `
    query GET_AVG_DATA($aspirationDate: String!, $siteId: String!) {
  avgData(aspirationDate: $aspirationDate, siteId: $siteId) {
    blank
    follicles
    oocytes
    numInMat
    blank1
  }
}
    `;
export const GET_ASP_DATA_POOL = `
    query GET_ASP_DATA_POOL($aspirationDate: String!, $siteId: String!) {
  aspDataPool(aspirationDate: $aspirationDate, siteId: $siteId) {
    donorName
    gradeAbc
    gradeD
    gradeE
    aspirationId
    ivmId
    sireName
    semenTypeName
    semenName
    donorScheduleId
  }
}
    `;
export const GET_ASPIRATION_POOLS_BY_DATE_AND_SITE = `
    query GET_ASPIRATION_POOLS_BY_DATE_AND_SITE($siteId: UUID!, $poolNumArray: [Int!]!) {
  aspirationPools(
    where: {opuSite: {id: {eq: $siteId}}, poolNumber: {in: $poolNumArray}}
  ) {
    items {
      id
      name
      poolNumber
    }
  }
}
    `;
export const GET_EMB_FERT_DATA_BY_DONOR_ID = `
    query GET_EMB_FERT_DATA_BY_DONOR_ID($donorId: UUID!, $ranch: String) {
  embFertDataByDonorId(donorId: $donorId, ranch: $ranch) {
    id
    donorId
    aspDate
    sched
    fsh
    follL
    follM
    follS
    follicles
    gradeAbc
    gradeD
    gradeE
    oocytes
    fert
    clv
    viable
    sire
    sireId
  }
}
    `;
export const GET_TODAYS_QC_DATA_OPUSEARCH = `
    query GET_TODAYS_QC_DATA_OPUSEARCH($date: String!, $siteId: String!, $location: String) {
  todaysQcDataOpuSearch(date: $date, siteId: $siteId, location: $location) {
    tog_qc_hepdate
    tog_qc_matdate
    tog_qc_opuholdingdate
    tog_qc_opuholding
    tog_qc_opuflushdate
    tog_qc_opuflush
    tog_qccomment
    tog_qc_slide_warmer
    tog_qc_tokai_hit
    tog_qc_water_bath_temperature
    tog_qcairqualityint
    tog_qcairqualitystring
    tog_qc_cellstrainer
    tog_qc_fiftymllotno
    tog_qc_thirtymlsyringe
    tog_qc_tenmlsyringe
    tog_qc_fiftymltubetype
    qccompleted
    tog_qc_rinsemedialotdate
    tog_qc_incubatorno
    tog_asp_date
    tog_siteid
    tog_qc_location
    qcFreezetemp
  }
}
    `;
export const REFRESH_STOP_GO_SIGN = `
    query REFRESH_STOP_GO_SIGN($val: String!, $siteId: String!) {
  refreshStopGoSign(val: $val, siteId: $siteId)
}
    `;
export const SHOW_STOP_SIGN = `
    query SHOW_STOP_SIGN($siteId: String!) {
  showStopSign(siteId: $siteId)
}
    `;
export const PULL_SEMEN = `
    mutation PULL_SEMEN($donorScheduleDate: DateTime!, $fertSiteId: UUID!, $semenId: UUID!, $moveNum: Int!, $semenType: String!, $accountId: UUID!, $semenOwnerId: UUID!, $dsSemenLocId: UUID!) {
  pullSemen(
    donorScheduleDate: $donorScheduleDate
    fertSiteId: $fertSiteId
    semenId: $semenId
    moveNum: $moveNum
    semenType: $semenType
    accountId: $accountId
    semenOwnerId: $semenOwnerId
    dsSemenLocId: $dsSemenLocId
  ) {
    code
    success
    message
    semenId
  }
}
    `;
export const RETURN_SEMEN = `
    mutation RETURN_SEMEN($SemenId: UUID!, $ReturnNum: Int!, $SemenType: String!) {
  returnSemen(semenId: $SemenId, returnNum: $ReturnNum, semenType: $SemenType) {
    code
    success
    message
    semenId
  }
}
    `;
export const REJECT_DISCARD_SEMEN = `
    mutation REJECT_DISCARD_SEMEN($SemenId: UUID!, $RejectNum: Int!, $SemenType: String!, $Description: String!) {
  rejectDiscardSemen(
    semenId: $SemenId
    rejectNum: $RejectNum
    semenType: $SemenType
    description: $Description
  ) {
    code
    success
    message
    semenId
  }
}
    `;
export const PULL_OD_SEMEN = `
    mutation PULL_OD_SEMEN($semenId: UUID!, $semenType: String!, $moveNum: Int!) {
  pullODSemen(semenId: $semenId, semenType: $semenType, moveNum: $moveNum) {
    code
    success
    message
  }
}
    `;
export const CREATE_NEW_SEMEN = `
    mutation CREATE_NEW_SEMEN($newSemen: NewSemenInput!) {
  createNewSemen(newSemen: $newSemen) {
    code
    success
    message
    semenId
  }
}
    `;
export const UPDATE_SEMEN = `
    mutation UPDATE_SEMEN($newSemen: UpdateSemenInput!) {
  updateSemen(newSemen: $newSemen) {
    code
    success
    message
  }
}
    `;
export const UPDATE_DS_SUGGESTED = `
    mutation UPDATE_DS_SUGGESTED($field: String!, $value: String!, $donorScheduleDate: DateTime!, $fertSiteId: UUID!, $semenId: UUID, $semenType: String, $sireId: UUID!, $accountId: UUID, $dsSemenLocId: UUID) {
  updateDSSuggested(
    field: $field
    value: $value
    donorScheduleDate: $donorScheduleDate
    fertSiteId: $fertSiteId
    semenId: $semenId
    semenType: $semenType
    sireId: $sireId
    accountId: $accountId
    dsSemenLocId: $dsSemenLocId
  ) {
    code
    success
    message
  }
}
    `;
export const SCHEDULED_SEMEN = `
    query SCHEDULED_SEMEN($date: DateTime!, $fertilizationSiteId: UUID!) {
  scheduledSemen(date: $date, fertilizationSiteId: $fertilizationSiteId) {
    row
    semenId
    semenName
    sireId
    sireName
    sireRegNum
    donors_Sire
    semenTypeName
    semenSexed
    semenSex
    name_Type
    accountId
    accountName
    semenOwnerId
    semenStorageId
    semenStorageName
    semenStorageSiteName
    cane
    colCode
    naab
    quantity
    suggestedToPull
    exportName
    comment
    transactionToday
    moveNum
    separateFert
  }
}
    `;
export const GET_PULLED_SEMEN = `
    query GET_PULLED_SEMEN($date: DateTime!, $fertilizationSiteId: UUID!) {
  getPulledSemen(date: $date, fertilizationSiteId: $fertilizationSiteId) {
    rowNum
    semenId
    semenName
    sireId
    sireName
    donors_Sire
    semenTypeName
    name_Type
    accountId
    accountName
    semenStorageId
    semenStorageName
    semenStorageSiteName
    cane
    colCode
    naab
    quantity
    exportName
    pulledQuantity
    transactionToday
    returnNum
  }
}
    `;
export const GET_SCHEDULED_DONORS = `
    query GET_SCHEDULED_DONORS($DonorScheduleDate: DateTime!, $fertilizationSiteId: UUID!, $SemenId: UUID, $SemenType: String, $SireId: UUID!, $AccountId: UUID, $DSSemenLocId: UUID) {
  getScheduledDonors(
    donorScheduleDate: $DonorScheduleDate
    fertilizationSiteId: $fertilizationSiteId
    semenId: $SemenId
    semenType: $SemenType
    sireId: $SireId
    accountId: $AccountId
    dsSemenLocId: $DSSemenLocId
  ) {
    csr
    donorName
    donorScheduleID
  }
}
    `;
export const GET_UNFINISHED_SCHEDULED_DONORS = `
    query GET_UNFINISHED_SCHEDULED_DONORS($donorScheduleDate: DateTime!, $fertSiteId: UUID!) {
  getUnfinishedScheduledDonors(
    donorScheduleDate: $donorScheduleDate
    fertSiteId: $fertSiteId
  ) {
    csr
    donorName
    donorScheduleID
  }
}
    `;
export const GET_OD_SIMILAR_SEMEN = `
    query GET_OD_SIMILAR_SEMEN($fertSiteId: UUID!, $semenName: String!, $accountName: String!, $caneCode: String!, $colCode: String!) {
  odSimilarSemen(
    fertSiteId: $fertSiteId
    semenName: $semenName
    accountName: $accountName
    caneCode: $caneCode
    colCode: $colCode
  ) {
    semenID
    semenName
    semenTypeName
    accountName
    cane
    colCode
    semenStorageName
    quantity
  }
}
    `;
export const GET_OD_SEMEN = `
    query GET_OD_SEMEN($fertSiteId: UUID!, $semenName: String!, $accountName: String!, $caneCode: String!, $colCode: String!) {
  odSemen(
    fertSiteId: $fertSiteId
    semenName: $semenName
    accountName: $accountName
    caneCode: $caneCode
    colCode: $colCode
  ) {
    semenID
    semenName
    semenTypeName
    accountName
    cane
    colCode
    semenStorageName
    quantity
  }
}
    `;
export const STRING_MAP_SEARCH = `
    query STRING_MAP_SEARCH($objectTypeCode: Int!, $name: String!) {
  stringMap(objectTypeCode: $objectTypeCode, name: $name) {
    key
    value
  }
}
    `;
export const STORAGE_LOCATIONS = `
    query STORAGE_LOCATIONS($fertSiteId: UUID!) {
  storageLocations(
    where: {stateCode: {eq: 0}, siteId: {eq: $fertSiteId}, or: [{locationType: {eq: 100000001}}, {locationType: {eq: 100000002}}]}
    order: {name: ASC}
  ) {
    items {
      id
      name
    }
  }
}
    `;
export const UPDATE_SHIPMENT = `
    mutation UPDATE_SHIPMENT($id: ID!, $input: UpdateShipmentInput!) {
  updateShipment(id: $id, input: $input) {
    ...Shipment
  }
}
    ${ShipmentFragmentDoc}`;
export const SHIPPING_SET_IN_PROGRESS = `
    mutation SHIPPING_SET_IN_PROGRESS($shipmentId: UUID!, $packedById: UUID) {
  shipping_setInProgress(shipmentId: $shipmentId, packedById: $packedById) {
    id
    shipmentStatus
    shipmentStatusValue
    packedById
    packedBy {
      id
      name
      siteId
    }
  }
}
    `;
export const CREATE_SHIPPING_FORM_REPORT = `
    mutation CREATE_SHIPPING_FORM_REPORT($shipmentId: UUID!, $sendEmail: Boolean!) {
  createShippingFormReport(shipmentId: $shipmentId, sendEmail: $sendEmail)
}
    `;
export const SHIPPING_RUN_SHIP = `
    mutation SHIPPING_RUN_SHIP($shipmentId: UUID!) {
  shipping_runShip(shipmentId: $shipmentId)
}
    `;
export const SHIPPING_RUN_SHIP_INTRA = `
    mutation SHIPPING_RUN_SHIP_INTRA($shipmentId: UUID!) {
  shipping_runShipIntra(shipmentId: $shipmentId)
}
    `;
export const SHIPPING_RUN_SHIP_INTRA_YACKLEY = `
    mutation SHIPPING_RUN_SHIP_INTRA_YACKLEY($shipmentId: UUID!) {
  shipping_runShipIntraYackley(shipmentId: $shipmentId)
}
    `;
export const SHIPPING_SHIPMENTS = `
    query SHIPPING_SHIPMENTS($skip: Int!, $order: [ShipmentSortInput!], $where: ShipmentFilterInput!) {
  shipments(skip: $skip, order: $order, where: $where) {
    totalCount
    items {
      ...ShippingShipment
    }
  }
}
    ${ShippingShipmentFragmentDoc}`;
export const ALL_SHIPMENTS = `
    query ALL_SHIPMENTS($skip: Int!, $take: Int, $order: [ShipmentSortInput!], $where: ShipmentFilterInput!) {
  allShipments(skip: $skip, take: $take, order: $order, where: $where) {
    totalCount
    items {
      ...ShippingShipment
    }
  }
}
    ${ShippingShipmentFragmentDoc}`;
export const SHIPPING_ACCOUNT_SEARCH = `
    query SHIPPING_ACCOUNT_SEARCH($query: String!) {
  results: accounts(
    where: {or: [{code: {contains: $query}}, {name: {contains: $query}}, {primaryContact: {fullName: {contains: $query}}}]}
    order: {name: ASC}
    take: 100
  ) {
    totalCount
    items {
      ...ShippingAccountSearch
    }
  }
}
    ${ShippingAccountSearchFragmentDoc}`;
export const SHIPPING_EQUIPMENT_SEARCH = `
    query SHIPPING_EQUIPMENT_SEARCH($query: String!) {
  results: equipments(
    where: {or: [{name: {contains: $query}}]}
    order: {name: ASC}
    take: 100
  ) {
    totalCount
    items {
      ...ShippingEquipmentSearch
    }
  }
}
    ${ShippingEquipmentSearchFragmentDoc}`;
export const SHIPPING_SITES = `
    query SHIPPING_SITES {
  sites(where: {shipments: {any: true}}, order: {name: ASC}) {
    totalCount
    items {
      ...ShippingSiteSearch
    }
  }
}
    ${ShippingSiteSearchFragmentDoc}`;
export const SHIPPING_SITE_SEARCH = `
    query SHIPPING_SITE_SEARCH($query: String!) {
  results: sites(
    where: {or: [{name: {contains: $query}}]}
    order: {name: ASC}
    take: 100
  ) {
    totalCount
    items {
      ...ShippingSiteSearch
    }
  }
}
    ${ShippingSiteSearchFragmentDoc}`;
export const SHIPMENT = `
    query SHIPMENT($shipmentId: UUID!) {
  shipment(where: {id: {eq: $shipmentId}}) {
    ...Shipment
  }
}
    ${ShipmentFragmentDoc}`;
export const EMBRYOS = `
    query EMBRYOS($shipmentId: UUID!) {
  embryos(where: {shipmentId: {eq: $shipmentId}}) {
    items {
      ...ShipmentEmbryo
    }
  }
}
    ${ShipmentEmbryoFragmentDoc}`;
export const SEMEN = `
    query SEMEN($shipmentId: UUID!) {
  semen(where: {shipmentId: {eq: $shipmentId}}) {
    items {
      ...ShipmentSemen
    }
  }
}
    ${ShipmentSemenFragmentDoc}`;
export const DONORS = `
    query DONORS($shipmentId: UUID!) {
  donors(where: {shipmentId: {eq: $shipmentId}}) {
    items {
      ...ShipmentDonor
    }
  }
}
    ${ShipmentDonorFragmentDoc}`;
export const RECIPIENTS = `
    query RECIPIENTS($shipmentId: UUID!) {
  recipients(where: {shipmentId: {eq: $shipmentId}}) {
    items {
      ...ShipmentRecipient
    }
  }
}
    ${ShipmentRecipientFragmentDoc}`;
export const GET_CALVES = `
    query GET_CALVES($shipmentId: UUID!) {
  calves(where: {shipmentId: {eq: $shipmentId}}) {
    items {
      ...ShipmentCalf
    }
  }
}
    ${ShipmentCalfFragmentDoc}`;
export const SHIPPING_ACCOUNT_DETAILS = `
    query SHIPPING_ACCOUNT_DETAILS($accountId: UUID!) {
  account(where: {id: {eq: $accountId}}) {
    id
    code
    name
    customerServiceRepresentative {
      id
      fullName
    }
    billingAddress {
      id
      composite
    }
    ranchAddress {
      id
      composite
    }
    aging30
    aging60
    aging90
    aging120
    aging180
    aging365
    aging365Plus
    tog90daysPastDue
    tog90DayOverrideExpireDate
    annotations(order: {createdOn: ASC}) {
      id
      createdOn
      noteText
      owner {
        id
        name
      }
    }
  }
}
    `;
export const STRIPPING_UPDATE_FERTILIZATION = `
    mutation STRIPPING_UPDATE_FERTILIZATION($id: ID!, $input: UpdateFertilizationInput!, $timeZone: String!) {
  updateFertilization(id: $id, input: $input, ianaTimeZone: $timeZone) {
    id
  }
}
    `;
export const STRIPPING_FERTILIZATONS = `
    query STRIPPING_FERTILIZATONS($date: DateTime!, $siteId: UUID, $timeZone: String!) {
  strippingFertilizations(
    fertilizationDate: $date
    where: {siteId: {eq: $siteId}}
  ) {
    items {
      ...StrippingFertilization
    }
  }
}
    ${StrippingFertilizationFragmentDoc}`;
export const STRIPPING_TECHNICIANS = `
    query STRIPPING_TECHNICIANS($where: EquipmentFilterInput!) {
  currentEquipments(where: $where, order: {name: ASC}) {
    items {
      id
      name
    }
  }
}
    `;
export const ALL_STRIPPING_TECHNICIANS = `
    query ALL_STRIPPING_TECHNICIANS {
  equipments(order: {name: ASC}) {
    items {
      id
      name
    }
  }
}
    `;
export const ME_EQUIPMENTS = `
    query ME_EQUIPMENTS {
  me {
    id
    equipments(take: 1, order: {createdOn: ASC}) {
      items {
        id
      }
    }
  }
}
    `;
export const ME = `
    query ME {
  me {
    id
    adUserId
    username
    fullName
    internalEmailAddress
    groups
    issueManagerTypes
    environmentId
    environment
    country
  }
}
    `;
export const GET_ASPIRATION_SITES = `
    query GET_ASPIRATION_SITES {
  aspirationSites {
    id
    name
    fertilizationSiteId
    fertilizationSite {
      id
      name
    }
  }
}
    `;
export const GET_FERTILIZATION_SITES = `
    query GET_FERTILIZATION_SITES {
  sites(
    where: {fertilizationLocations: {any: true}, id: {nin: ["0db92e50-d0ed-ee11-82e3-0022482fd8ca", "5cae9acc-f633-eb11-81e5-005056975fe0", "ea0f81c1-d096-eb11-8207-005056975140"]}}
    order: {name: ASC}
  ) {
    items {
      id
      name
    }
  }
}
    `;
export const GET_SITE_BY_ID = `
    query GET_SITE_BY_ID($id: UUID!) {
  sites(where: {id: {eq: $id}}) {
    items {
      id
      name
    }
  }
}
    `;
export const STRING_MAP_REQUEST = `
    query STRING_MAP_REQUEST($objectTypeCode: Int!, $attributeName: String!) {
  stringMaps(
    where: {and: [{objectTypeCode: {eq: $objectTypeCode}}, {attributeName: {eq: $attributeName}}]}
    order: {displayOrder: ASC}
  ) {
    items {
      attributeValue
      value
    }
  }
}
    `;
export const STRING_MAP = `
    query STRING_MAP($objectTypeCode: Int!, $name: String!) {
  stringMap(objectTypeCode: $objectTypeCode, name: $name) {
    label: value
    value: key
  }
}
    `;
export const SEND_REPORT_EMAIL = `
    mutation SEND_REPORT_EMAIL($reportUrl: String!, $subject: String, $message: String, $recipients: [String!]) {
  sendReportEmail(
    reportUrl: $reportUrl
    subject: $subject
    message: $message
    recipients: $recipients
  )
}
    `;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    CHANGE_CONNECTION: build.mutation<CHANGE_CONNECTIONMutation, CHANGE_CONNECTIONMutationVariables>({
      query: (variables) => ({ document: CHANGE_CONNECTION, variables })
    }),
    GET_ALL_CONNECTIONS: build.query<GET_ALL_CONNECTIONSQuery, GET_ALL_CONNECTIONSQueryVariables | void>({
      query: (variables) => ({ document: GET_ALL_CONNECTIONS, variables })
    }),
    SEARCH_ACCOUNTS_MULTISELECT: build.query<SEARCH_ACCOUNTS_MULTISELECTQuery, SEARCH_ACCOUNTS_MULTISELECTQueryVariables>({
      query: (variables) => ({ document: SEARCH_ACCOUNTS_MULTISELECT, variables })
    }),
    SEARCH_ACCOUNTS_AUTOCOMPLETE: build.query<SEARCH_ACCOUNTS_AUTOCOMPLETEQuery, SEARCH_ACCOUNTS_AUTOCOMPLETEQueryVariables>({
      query: (variables) => ({ document: SEARCH_ACCOUNTS_AUTOCOMPLETE, variables })
    }),
    GET_ACCOUNT_BY_DATE_AND_SITE: build.query<GET_ACCOUNT_BY_DATE_AND_SITEQuery, GET_ACCOUNT_BY_DATE_AND_SITEQueryVariables>({
      query: (variables) => ({ document: GET_ACCOUNT_BY_DATE_AND_SITE, variables })
    }),
    SEARCH_DONORS: build.query<SEARCH_DONORSQuery, SEARCH_DONORSQueryVariables>({
      query: (variables) => ({ document: SEARCH_DONORS, variables })
    }),
    SEARCH_SEMEN_LOOKUP: build.query<SEARCH_SEMEN_LOOKUPQuery, SEARCH_SEMEN_LOOKUPQueryVariables>({
      query: (variables) => ({ document: SEARCH_SEMEN_LOOKUP, variables })
    }),
    UPDATE_SIRE: build.mutation<UPDATE_SIREMutation, UPDATE_SIREMutationVariables>({
      query: (variables) => ({ document: UPDATE_SIRE, variables })
    }),
    SEARCH_SIRES: build.query<SEARCH_SIRESQuery, SEARCH_SIRESQueryVariables>({
      query: (variables) => ({ document: SEARCH_SIRES, variables })
    }),
    GET_BREEDS: build.query<GET_BREEDSQuery, GET_BREEDSQueryVariables | void>({
      query: (variables) => ({ document: GET_BREEDS, variables })
    }),
    GET_CONTACTS: build.query<GET_CONTACTSQuery, GET_CONTACTSQueryVariables | void>({
      query: (variables) => ({ document: GET_CONTACTS, variables })
    }),
    SEARCH_CONTACTS_AUTOCOMPLETE: build.query<SEARCH_CONTACTS_AUTOCOMPLETEQuery, SEARCH_CONTACTS_AUTOCOMPLETEQueryVariables>({
      query: (variables) => ({ document: SEARCH_CONTACTS_AUTOCOMPLETE, variables })
    }),
    SEARCH_SYSTEM_USERS_AUTOCOMPLETE: build.query<SEARCH_SYSTEM_USERS_AUTOCOMPLETEQuery, SEARCH_SYSTEM_USERS_AUTOCOMPLETEQueryVariables | void>({
      query: (variables) => ({ document: SEARCH_SYSTEM_USERS_AUTOCOMPLETE, variables })
    }),
    ADD_VIEW: build.mutation<ADD_VIEWMutation, ADD_VIEWMutationVariables>({
      query: (variables) => ({ document: ADD_VIEW, variables })
    }),
    UPDATE_VIEW: build.mutation<UPDATE_VIEWMutation, UPDATE_VIEWMutationVariables>({
      query: (variables) => ({ document: UPDATE_VIEW, variables })
    }),
    REMOVE_VIEW: build.mutation<REMOVE_VIEWMutation, REMOVE_VIEWMutationVariables>({
      query: (variables) => ({ document: REMOVE_VIEW, variables })
    }),
    SET_DEFAULT_VIEW: build.mutation<SET_DEFAULT_VIEWMutation, SET_DEFAULT_VIEWMutationVariables>({
      query: (variables) => ({ document: SET_DEFAULT_VIEW, variables })
    }),
    GET_VIEW_NAMES: build.query<GET_VIEW_NAMESQuery, GET_VIEW_NAMESQueryVariables>({
      query: (variables) => ({ document: GET_VIEW_NAMES, variables })
    }),
    GET_VIEW_BY_ID: build.query<GET_VIEW_BY_IDQuery, GET_VIEW_BY_IDQueryVariables>({
      query: (variables) => ({ document: GET_VIEW_BY_ID, variables })
    }),
    SEARCH_ALL_DONORS_AUTOCOMPLETE: build.query<SEARCH_ALL_DONORS_AUTOCOMPLETEQuery, SEARCH_ALL_DONORS_AUTOCOMPLETEQueryVariables>({
      query: (variables) => ({ document: SEARCH_ALL_DONORS_AUTOCOMPLETE, variables })
    }),
    SEARCH_DONORS_BY_OWNER_ID_AUTOCOMPLETE: build.query<SEARCH_DONORS_BY_OWNER_ID_AUTOCOMPLETEQuery, SEARCH_DONORS_BY_OWNER_ID_AUTOCOMPLETEQueryVariables>({
      query: (variables) => ({ document: SEARCH_DONORS_BY_OWNER_ID_AUTOCOMPLETE, variables })
    }),
    SEARCH_DRUGS: build.query<SEARCH_DRUGSQuery, SEARCH_DRUGSQueryVariables>({
      query: (variables) => ({ document: SEARCH_DRUGS, variables })
    }),
    SEARCH_ASPIRATION_SITES: build.query<SEARCH_ASPIRATION_SITESQuery, SEARCH_ASPIRATION_SITESQueryVariables | void>({
      query: (variables) => ({ document: SEARCH_ASPIRATION_SITES, variables })
    }),
    GET_EQUIPMENT_SEARCH_BY_SITE: build.query<GET_EQUIPMENT_SEARCH_BY_SITEQuery, GET_EQUIPMENT_SEARCH_BY_SITEQueryVariables>({
      query: (variables) => ({ document: GET_EQUIPMENT_SEARCH_BY_SITE, variables })
    }),
    SEARCH_FERTILIZATION_SITES_DROPDOWN: build.query<SEARCH_FERTILIZATION_SITES_DROPDOWNQuery, SEARCH_FERTILIZATION_SITES_DROPDOWNQueryVariables | void>({
      query: (variables) => ({ document: SEARCH_FERTILIZATION_SITES_DROPDOWN, variables })
    }),
    CREATE_NEW_DONOR: build.mutation<CREATE_NEW_DONORMutation, CREATE_NEW_DONORMutationVariables>({
      query: (variables) => ({ document: CREATE_NEW_DONOR, variables })
    }),
    CREATE_NEW_SIRE: build.mutation<CREATE_NEW_SIREMutation, CREATE_NEW_SIREMutationVariables>({
      query: (variables) => ({ document: CREATE_NEW_SIRE, variables })
    }),
    GET_OPTION_SETS_BY_NAME: build.query<GET_OPTION_SETS_BY_NAMEQuery, GET_OPTION_SETS_BY_NAMEQueryVariables | void>({
      query: (variables) => ({ document: GET_OPTION_SETS_BY_NAME, variables })
    }),
    GET_RECIPIENTS: build.query<GET_RECIPIENTSQuery, GET_RECIPIENTSQueryVariables>({
      query: (variables) => ({ document: GET_RECIPIENTS, variables })
    }),
    SEARCH_SCHEDULE_MASTER: build.query<SEARCH_SCHEDULE_MASTERQuery, SEARCH_SCHEDULE_MASTERQueryVariables>({
      query: (variables) => ({ document: SEARCH_SCHEDULE_MASTER, variables })
    }),
    SEARCH_SEMEN: build.query<SEARCH_SEMENQuery, SEARCH_SEMENQueryVariables | void>({
      query: (variables) => ({ document: SEARCH_SEMEN, variables })
    }),
    SEARCH_SEMEN_BY_ACCOUNT: build.query<SEARCH_SEMEN_BY_ACCOUNTQuery, SEARCH_SEMEN_BY_ACCOUNTQueryVariables>({
      query: (variables) => ({ document: SEARCH_SEMEN_BY_ACCOUNT, variables })
    }),
    SEARCH_SHIPMENTS_AUTOCOMPLETE: build.query<SEARCH_SHIPMENTS_AUTOCOMPLETEQuery, SEARCH_SHIPMENTS_AUTOCOMPLETEQueryVariables>({
      query: (variables) => ({ document: SEARCH_SHIPMENTS_AUTOCOMPLETE, variables })
    }),
    SEARCH_SHIPMENT_GROUPS: build.query<SEARCH_SHIPMENT_GROUPSQuery, SEARCH_SHIPMENT_GROUPSQueryVariables>({
      query: (variables) => ({ document: SEARCH_SHIPMENT_GROUPS, variables })
    }),
    SEARCH_SIRES_LOOKUP: build.query<SEARCH_SIRES_LOOKUPQuery, SEARCH_SIRES_LOOKUPQueryVariables>({
      query: (variables) => ({ document: SEARCH_SIRES_LOOKUP, variables })
    }),
    GET_SITES: build.query<GET_SITESQuery, GET_SITESQueryVariables | void>({
      query: (variables) => ({ document: GET_SITES, variables })
    }),
    GET_SITES_SEARCH_MULTISELECT: build.query<GET_SITES_SEARCH_MULTISELECTQuery, GET_SITES_SEARCH_MULTISELECTQueryVariables>({
      query: (variables) => ({ document: GET_SITES_SEARCH_MULTISELECT, variables })
    }),
    GET_SITES_SEARCH: build.query<GET_SITES_SEARCHQuery, GET_SITES_SEARCHQueryVariables | void>({
      query: (variables) => ({ document: GET_SITES_SEARCH, variables })
    }),
    GET_STORAGE_LOCATIONS: build.query<GET_STORAGE_LOCATIONSQuery, GET_STORAGE_LOCATIONSQueryVariables>({
      query: (variables) => ({ document: GET_STORAGE_LOCATIONS, variables })
    }),
    GET_EQUIPMENT_BY_ID: build.query<GET_EQUIPMENT_BY_IDQuery, GET_EQUIPMENT_BY_IDQueryVariables>({
      query: (variables) => ({ document: GET_EQUIPMENT_BY_ID, variables })
    }),
    RUN_WORKFLOW: build.mutation<RUN_WORKFLOWMutation, RUN_WORKFLOWMutationVariables>({
      query: (variables) => ({ document: RUN_WORKFLOW, variables })
    }),
    RUN_OLD_WORKFLOW: build.mutation<RUN_OLD_WORKFLOWMutation, RUN_OLD_WORKFLOWMutationVariables>({
      query: (variables) => ({ document: RUN_OLD_WORKFLOW, variables })
    }),
    GET_YARDS_MULTISELECT: build.query<GET_YARDS_MULTISELECTQuery, GET_YARDS_MULTISELECTQueryVariables | void>({
      query: (variables) => ({ document: GET_YARDS_MULTISELECT, variables })
    }),
    GET_YARDS: build.query<GET_YARDSQuery, GET_YARDSQueryVariables | void>({
      query: (variables) => ({ document: GET_YARDS, variables })
    }),
    SEARCH_YARDS: build.query<SEARCH_YARDSQuery, SEARCH_YARDSQueryVariables>({
      query: (variables) => ({ document: SEARCH_YARDS, variables })
    }),
    ADD_NUCLEUS_ERROR_LOG: build.mutation<ADD_NUCLEUS_ERROR_LOGMutation, ADD_NUCLEUS_ERROR_LOGMutationVariables>({
      query: (variables) => ({ document: ADD_NUCLEUS_ERROR_LOG, variables })
    }),
    GET_NUCLEUS_ERROR_LOGS: build.query<GET_NUCLEUS_ERROR_LOGSQuery, GET_NUCLEUS_ERROR_LOGSQueryVariables | void>({
      query: (variables) => ({ document: GET_NUCLEUS_ERROR_LOGS, variables })
    }),
    LOGIN: build.mutation<LOGINMutation, LOGINMutationVariables>({
      query: (variables) => ({ document: LOGIN, variables })
    }),
    LOGOUT: build.mutation<LOGOUTMutation, LOGOUTMutationVariables | void>({
      query: (variables) => ({ document: LOGOUT, variables })
    }),
    UPDATE_ASPIRATION_CHUTESIDE: build.mutation<UPDATE_ASPIRATION_CHUTESIDEMutation, UPDATE_ASPIRATION_CHUTESIDEMutationVariables>({
      query: (variables) => ({ document: UPDATE_ASPIRATION_CHUTESIDE, variables })
    }),
    UPDATE_QC_DATA_CHUTESIDE: build.mutation<UPDATE_QC_DATA_CHUTESIDEMutation, UPDATE_QC_DATA_CHUTESIDEMutationVariables>({
      query: (variables) => ({ document: UPDATE_QC_DATA_CHUTESIDE, variables })
    }),
    ADD_PREGNANT_STATUS: build.mutation<ADD_PREGNANT_STATUSMutation, ADD_PREGNANT_STATUSMutationVariables>({
      query: (variables) => ({ document: ADD_PREGNANT_STATUS, variables })
    }),
    UPDATE_ASPIRATION_QC_DATA_CHUTESIDE: build.mutation<UPDATE_ASPIRATION_QC_DATA_CHUTESIDEMutation, UPDATE_ASPIRATION_QC_DATA_CHUTESIDEMutationVariables>({
      query: (variables) => ({ document: UPDATE_ASPIRATION_QC_DATA_CHUTESIDE, variables })
    }),
    UPDATE_DONOR_LAST_BRED_DATE: build.mutation<UPDATE_DONOR_LAST_BRED_DATEMutation, UPDATE_DONOR_LAST_BRED_DATEMutationVariables>({
      query: (variables) => ({ document: UPDATE_DONOR_LAST_BRED_DATE, variables })
    }),
    GET_TODAYS_ASPIRATIONS: build.query<GET_TODAYS_ASPIRATIONSQuery, GET_TODAYS_ASPIRATIONSQueryVariables>({
      query: (variables) => ({ document: GET_TODAYS_ASPIRATIONS, variables })
    }),
    GET_ASPIRATION_BY_DONOR_DATE_SITE: build.query<GET_ASPIRATION_BY_DONOR_DATE_SITEQuery, GET_ASPIRATION_BY_DONOR_DATE_SITEQueryVariables>({
      query: (variables) => ({ document: GET_ASPIRATION_BY_DONOR_DATE_SITE, variables })
    }),
    GET_VETERINARIANS: build.query<GET_VETERINARIANSQuery, GET_VETERINARIANSQueryVariables | void>({
      query: (variables) => ({ document: GET_VETERINARIANS, variables })
    }),
    GET_ASPIRATION_BY_ID: build.query<GET_ASPIRATION_BY_IDQuery, GET_ASPIRATION_BY_IDQueryVariables>({
      query: (variables) => ({ document: GET_ASPIRATION_BY_ID, variables })
    }),
    GET_SCHEDULES: build.query<GET_SCHEDULESQuery, GET_SCHEDULESQueryVariables | void>({
      query: (variables) => ({ document: GET_SCHEDULES, variables })
    }),
    GET_PROCEDURES_BY_DONOR_ID: build.query<GET_PROCEDURES_BY_DONOR_IDQuery, GET_PROCEDURES_BY_DONOR_IDQueryVariables>({
      query: (variables) => ({ document: GET_PROCEDURES_BY_DONOR_ID, variables })
    }),
    GET_TODAYS_QC_DATA_CHUTESIDE: build.query<GET_TODAYS_QC_DATA_CHUTESIDEQuery, GET_TODAYS_QC_DATA_CHUTESIDEQueryVariables>({
      query: (variables) => ({ document: GET_TODAYS_QC_DATA_CHUTESIDE, variables })
    }),
    GET_TEMP_ASPIRATION_QC_INFO: build.query<GET_TEMP_ASPIRATION_QC_INFOQuery, GET_TEMP_ASPIRATION_QC_INFOQueryVariables>({
      query: (variables) => ({ document: GET_TEMP_ASPIRATION_QC_INFO, variables })
    }),
    GET_ASPIRATION_HISTORY_BY_DONOR_ID: build.query<GET_ASPIRATION_HISTORY_BY_DONOR_IDQuery, GET_ASPIRATION_HISTORY_BY_DONOR_IDQueryVariables>({
      query: (variables) => ({ document: GET_ASPIRATION_HISTORY_BY_DONOR_ID, variables })
    }),
    GET_FERT_DATA_BY_DONOR_ID_CHUTESIDE: build.query<GET_FERT_DATA_BY_DONOR_ID_CHUTESIDEQuery, GET_FERT_DATA_BY_DONOR_ID_CHUTESIDEQueryVariables>({
      query: (variables) => ({ document: GET_FERT_DATA_BY_DONOR_ID_CHUTESIDE, variables })
    }),
    GET_ASPIRATION_INFO_BY_ID: build.query<GET_ASPIRATION_INFO_BY_IDQuery, GET_ASPIRATION_INFO_BY_IDQueryVariables>({
      query: (variables) => ({ document: GET_ASPIRATION_INFO_BY_ID, variables })
    }),
    EXPORT_CRYO_BABY_LABELS: build.mutation<EXPORT_CRYO_BABY_LABELSMutation, EXPORT_CRYO_BABY_LABELSMutationVariables>({
      query: (variables) => ({ document: EXPORT_CRYO_BABY_LABELS, variables })
    }),
    ADD_CALVES: build.mutation<ADD_CALVESMutation, ADD_CALVESMutationVariables>({
      query: (variables) => ({ document: ADD_CALVES, variables })
    }),
    SEARCH_OWNERS: build.query<SEARCH_OWNERSQuery, SEARCH_OWNERSQueryVariables | void>({
      query: (variables) => ({ document: SEARCH_OWNERS, variables })
    }),
    SEARCH_HERDSMEN: build.query<SEARCH_HERDSMENQuery, SEARCH_HERDSMENQueryVariables | void>({
      query: (variables) => ({ document: SEARCH_HERDSMEN, variables })
    }),
    GET_PENS: build.query<GET_PENSQuery, GET_PENSQueryVariables | void>({
      query: (variables) => ({ document: GET_PENS, variables })
    }),
    GET_SEX: build.query<GET_SEXQuery, GET_SEXQueryVariables | void>({
      query: (variables) => ({ document: GET_SEX, variables })
    }),
    GET_TESTICLES_DECENDED: build.query<GET_TESTICLES_DECENDEDQuery, GET_TESTICLES_DECENDEDQueryVariables | void>({
      query: (variables) => ({ document: GET_TESTICLES_DECENDED, variables })
    }),
    GET_TESTICULAR_DEVELOPMENT: build.query<GET_TESTICULAR_DEVELOPMENTQuery, GET_TESTICULAR_DEVELOPMENTQueryVariables | void>({
      query: (variables) => ({ document: GET_TESTICULAR_DEVELOPMENT, variables })
    }),
    GET_TIME_OF_DAY: build.query<GET_TIME_OF_DAYQuery, GET_TIME_OF_DAYQueryVariables | void>({
      query: (variables) => ({ document: GET_TIME_OF_DAY, variables })
    }),
    UPDATE_ASPIRATION_TIMES: build.mutation<UPDATE_ASPIRATION_TIMESMutation, UPDATE_ASPIRATION_TIMESMutationVariables>({
      query: (variables) => ({ document: UPDATE_ASPIRATION_TIMES, variables })
    }),
    UPDATE_REVISIONS: build.mutation<UPDATE_REVISIONSMutation, UPDATE_REVISIONSMutationVariables>({
      query: (variables) => ({ document: UPDATE_REVISIONS, variables })
    }),
    UPDATE_ASPIRATION_STATUS_AND_DONOR_SCHEDULE_REVISION_COMMENT_BATCH: build.mutation<UPDATE_ASPIRATION_STATUS_AND_DONOR_SCHEDULE_REVISION_COMMENT_BATCHMutation, UPDATE_ASPIRATION_STATUS_AND_DONOR_SCHEDULE_REVISION_COMMENT_BATCHMutationVariables>({
      query: (variables) => ({ document: UPDATE_ASPIRATION_STATUS_AND_DONOR_SCHEDULE_REVISION_COMMENT_BATCH, variables })
    }),
    CHUTE_SCHEDULE_COMBINED: build.query<CHUTE_SCHEDULE_COMBINEDQuery, CHUTE_SCHEDULE_COMBINEDQueryVariables>({
      query: (variables) => ({ document: CHUTE_SCHEDULE_COMBINED, variables })
    }),
    ALL_TOP_REVISIONS: build.query<ALL_TOP_REVISIONSQuery, ALL_TOP_REVISIONSQueryVariables>({
      query: (variables) => ({ document: ALL_TOP_REVISIONS, variables })
    }),
    UPDATE_FRESH_TRANSFERS: build.mutation<UPDATE_FRESH_TRANSFERSMutation, UPDATE_FRESH_TRANSFERSMutationVariables>({
      query: (variables) => ({ document: UPDATE_FRESH_TRANSFERS, variables })
    }),
    GET_CSR_DAY_7: build.query<GET_CSR_DAY_7Query, GET_CSR_DAY_7QueryVariables>({
      query: (variables) => ({ document: GET_CSR_DAY_7, variables })
    }),
    ADD_CLINIC_TRANSFER_EMBRYOS: build.mutation<ADD_CLINIC_TRANSFER_EMBRYOSMutation, ADD_CLINIC_TRANSFER_EMBRYOSMutationVariables>({
      query: (variables) => ({ document: ADD_CLINIC_TRANSFER_EMBRYOS, variables })
    }),
    UPDATE_FRESH_TRANSFERS_PSE: build.mutation<UPDATE_FRESH_TRANSFERS_PSEMutation, UPDATE_FRESH_TRANSFERS_PSEMutationVariables>({
      query: (variables) => ({ document: UPDATE_FRESH_TRANSFERS_PSE, variables })
    }),
    GET_PSE_DAY_7: build.query<GET_PSE_DAY_7Query, GET_PSE_DAY_7QueryVariables>({
      query: (variables) => ({ document: GET_PSE_DAY_7, variables })
    }),
    GET_PSE_DAY_7_MATINGS: build.query<GET_PSE_DAY_7_MATINGSQuery, GET_PSE_DAY_7_MATINGSQueryVariables>({
      query: (variables) => ({ document: GET_PSE_DAY_7_MATINGS, variables })
    }),
    GET_DAY_7_FROZEN_EMBRYOS: build.query<GET_DAY_7_FROZEN_EMBRYOSQuery, GET_DAY_7_FROZEN_EMBRYOSQueryVariables>({
      query: (variables) => ({ document: GET_DAY_7_FROZEN_EMBRYOS, variables })
    }),
    GET_PARTNERSHIPS: build.query<GET_PARTNERSHIPSQuery, GET_PARTNERSHIPSQueryVariables>({
      query: (variables) => ({ document: GET_PARTNERSHIPS, variables })
    }),
    UPSERT_DONOR_SCHEDULES: build.mutation<UPSERT_DONOR_SCHEDULESMutation, UPSERT_DONOR_SCHEDULESMutationVariables>({
      query: (variables) => ({ document: UPSERT_DONOR_SCHEDULES, variables })
    }),
    EDIT_BULK_DONOR_SCHEDULES: build.mutation<EDIT_BULK_DONOR_SCHEDULESMutation, EDIT_BULK_DONOR_SCHEDULESMutationVariables>({
      query: (variables) => ({ document: EDIT_BULK_DONOR_SCHEDULES, variables })
    }),
    DEACTIVATE_DONOR_SCHEDULES: build.mutation<DEACTIVATE_DONOR_SCHEDULESMutation, DEACTIVATE_DONOR_SCHEDULESMutationVariables>({
      query: (variables) => ({ document: DEACTIVATE_DONOR_SCHEDULES, variables })
    }),
    UPSERT_PARTNERSHIP: build.mutation<UPSERT_PARTNERSHIPMutation, UPSERT_PARTNERSHIPMutationVariables>({
      query: (variables) => ({ document: UPSERT_PARTNERSHIP, variables })
    }),
    MASS_SET_FIELD: build.mutation<MASS_SET_FIELDMutation, MASS_SET_FIELDMutationVariables>({
      query: (variables) => ({ document: MASS_SET_FIELD, variables })
    }),
    DEACTIVATE_SO_SCHEDULE: build.mutation<DEACTIVATE_SO_SCHEDULEMutation, DEACTIVATE_SO_SCHEDULEMutationVariables>({
      query: (variables) => ({ document: DEACTIVATE_SO_SCHEDULE, variables })
    }),
    CREATE_NEW_SHIPMENT_GROUP: build.mutation<CREATE_NEW_SHIPMENT_GROUPMutation, CREATE_NEW_SHIPMENT_GROUPMutationVariables>({
      query: (variables) => ({ document: CREATE_NEW_SHIPMENT_GROUP, variables })
    }),
    CREATE_NEW_SHIPMENT_GROUP_MASTER: build.mutation<CREATE_NEW_SHIPMENT_GROUP_MASTERMutation, CREATE_NEW_SHIPMENT_GROUP_MASTERMutationVariables>({
      query: (variables) => ({ document: CREATE_NEW_SHIPMENT_GROUP_MASTER, variables })
    }),
    UPDATE_TEMP_EMBRYO_OWNERS: build.mutation<UPDATE_TEMP_EMBRYO_OWNERSMutation, UPDATE_TEMP_EMBRYO_OWNERSMutationVariables>({
      query: (variables) => ({ document: UPDATE_TEMP_EMBRYO_OWNERS, variables })
    }),
    UPDATE_BILL_ACCOUNT_CANING_GROUPS: build.mutation<UPDATE_BILL_ACCOUNT_CANING_GROUPSMutation, UPDATE_BILL_ACCOUNT_CANING_GROUPSMutationVariables>({
      query: (variables) => ({ document: UPDATE_BILL_ACCOUNT_CANING_GROUPS, variables })
    }),
    GET_DONOR_SCHEDULES: build.query<GET_DONOR_SCHEDULESQuery, GET_DONOR_SCHEDULESQueryVariables>({
      query: (variables) => ({ document: GET_DONOR_SCHEDULES, variables })
    }),
    GET_DONOR_SCHEDULES_BY_IDS: build.query<GET_DONOR_SCHEDULES_BY_IDSQuery, GET_DONOR_SCHEDULES_BY_IDSQueryVariables>({
      query: (variables) => ({ document: GET_DONOR_SCHEDULES_BY_IDS, variables })
    }),
    PARTNERSHIP_TYPE: build.query<PARTNERSHIP_TYPEQuery, PARTNERSHIP_TYPEQueryVariables>({
      query: (variables) => ({ document: PARTNERSHIP_TYPE, variables })
    }),
    GET_ALL_SHIPMENT_GROUP_MASTERS: build.query<GET_ALL_SHIPMENT_GROUP_MASTERSQuery, GET_ALL_SHIPMENT_GROUP_MASTERSQueryVariables | void>({
      query: (variables) => ({ document: GET_ALL_SHIPMENT_GROUP_MASTERS, variables })
    }),
    GET_PARTNERSHIPS_BY_DONOR_ID: build.query<GET_PARTNERSHIPS_BY_DONOR_IDQuery, GET_PARTNERSHIPS_BY_DONOR_IDQueryVariables>({
      query: (variables) => ({ document: GET_PARTNERSHIPS_BY_DONOR_ID, variables })
    }),
    GET_PREVIOUS_SCHEDULES: build.query<GET_PREVIOUS_SCHEDULESQuery, GET_PREVIOUS_SCHEDULESQueryVariables>({
      query: (variables) => ({ document: GET_PREVIOUS_SCHEDULES, variables })
    }),
    TOP_REVISIONS_BY_FERTILIZATION_SITE: build.query<TOP_REVISIONS_BY_FERTILIZATION_SITEQuery, TOP_REVISIONS_BY_FERTILIZATION_SITEQueryVariables>({
      query: (variables) => ({ document: TOP_REVISIONS_BY_FERTILIZATION_SITE, variables })
    }),
    GET_NEXT_SCHEDULE: build.query<GET_NEXT_SCHEDULEQuery, GET_NEXT_SCHEDULEQueryVariables>({
      query: (variables) => ({ document: GET_NEXT_SCHEDULE, variables })
    }),
    GET_SCHEDULED_DRUGS: build.query<GET_SCHEDULED_DRUGSQuery, GET_SCHEDULED_DRUGSQueryVariables>({
      query: (variables) => ({ document: GET_SCHEDULED_DRUGS, variables })
    }),
    SCHEDULED_DONORS: build.query<SCHEDULED_DONORSQuery, SCHEDULED_DONORSQueryVariables>({
      query: (variables) => ({ document: SCHEDULED_DONORS, variables })
    }),
    PULLED_SEMEN: build.query<PULLED_SEMENQuery, PULLED_SEMENQueryVariables>({
      query: (variables) => ({ document: PULLED_SEMEN, variables })
    }),
    FERTILIZATION_TECHS: build.query<FERTILIZATION_TECHSQuery, FERTILIZATION_TECHSQueryVariables | void>({
      query: (variables) => ({ document: FERTILIZATION_TECHS, variables })
    }),
    FERTILIZATION_DONOR_SCHEDULE: build.query<FERTILIZATION_DONOR_SCHEDULEQuery, FERTILIZATION_DONOR_SCHEDULEQueryVariables>({
      query: (variables) => ({ document: FERTILIZATION_DONOR_SCHEDULE, variables })
    }),
    CREATED_FERTS: build.query<CREATED_FERTSQuery, CREATED_FERTSQueryVariables>({
      query: (variables) => ({ document: CREATED_FERTS, variables })
    }),
    FERT_COMMENTS: build.query<FERT_COMMENTSQuery, FERT_COMMENTSQueryVariables | void>({
      query: (variables) => ({ document: FERT_COMMENTS, variables })
    }),
    INLINE_FERT_COMMENTS: build.query<INLINE_FERT_COMMENTSQuery, INLINE_FERT_COMMENTSQueryVariables | void>({
      query: (variables) => ({ document: INLINE_FERT_COMMENTS, variables })
    }),
    INCUBATORS: build.query<INCUBATORSQuery, INCUBATORSQueryVariables>({
      query: (variables) => ({ document: INCUBATORS, variables })
    }),
    UPSERT_REVERSE_SORT: build.mutation<UPSERT_REVERSE_SORTMutation, UPSERT_REVERSE_SORTMutationVariables>({
      query: (variables) => ({ document: UPSERT_REVERSE_SORT, variables })
    }),
    CREATE_FERTILIZATION: build.mutation<CREATE_FERTILIZATIONMutation, CREATE_FERTILIZATIONMutationVariables>({
      query: (variables) => ({ document: CREATE_FERTILIZATION, variables })
    }),
    UPDATE_FERT_TRANSACTION_FREEZE: build.mutation<UPDATE_FERT_TRANSACTION_FREEZEMutation, UPDATE_FERT_TRANSACTION_FREEZEMutationVariables>({
      query: (variables) => ({ document: UPDATE_FERT_TRANSACTION_FREEZE, variables })
    }),
    UPDATE_EMBRYO_TRANSACTION: build.mutation<UPDATE_EMBRYO_TRANSACTIONMutation, UPDATE_EMBRYO_TRANSACTIONMutationVariables>({
      query: (variables) => ({ document: UPDATE_EMBRYO_TRANSACTION, variables })
    }),
    UPDATE_INT_EMBRYO_TRANSACTION: build.mutation<UPDATE_INT_EMBRYO_TRANSACTIONMutation, UPDATE_INT_EMBRYO_TRANSACTIONMutationVariables>({
      query: (variables) => ({ document: UPDATE_INT_EMBRYO_TRANSACTION, variables })
    }),
    UPDATE_OD_FREEZE: build.mutation<UPDATE_OD_FREEZEMutation, UPDATE_OD_FREEZEMutationVariables>({
      query: (variables) => ({ document: UPDATE_OD_FREEZE, variables })
    }),
    ADD_INT_EMBRYOS: build.mutation<ADD_INT_EMBRYOSMutation, ADD_INT_EMBRYOSMutationVariables>({
      query: (variables) => ({ document: ADD_INT_EMBRYOS, variables })
    }),
    ADD_MASS_INT_EMBRYOS: build.mutation<ADD_MASS_INT_EMBRYOSMutation, ADD_MASS_INT_EMBRYOSMutationVariables>({
      query: (variables) => ({ document: ADD_MASS_INT_EMBRYOS, variables })
    }),
    DEACTIVATE_INT_EMB: build.mutation<DEACTIVATE_INT_EMBMutation, DEACTIVATE_INT_EMBMutationVariables>({
      query: (variables) => ({ document: DEACTIVATE_INT_EMB, variables })
    }),
    PDF_CREATE_FREEZE: build.mutation<PDF_CREATE_FREEZEMutation, PDF_CREATE_FREEZEMutationVariables>({
      query: (variables) => ({ document: PDF_CREATE_FREEZE, variables })
    }),
    VALIDATE_FREEZE: build.mutation<VALIDATE_FREEZEMutation, VALIDATE_FREEZEMutationVariables>({
      query: (variables) => ({ document: VALIDATE_FREEZE, variables })
    }),
    APPLY_APPROVAL_NUMBER_TO_EMBRYOS: build.mutation<APPLY_APPROVAL_NUMBER_TO_EMBRYOSMutation, APPLY_APPROVAL_NUMBER_TO_EMBRYOSMutationVariables>({
      query: (variables) => ({ document: APPLY_APPROVAL_NUMBER_TO_EMBRYOS, variables })
    }),
    UPDATE_FREEZE_EMBRYOS_ASYNC: build.mutation<UPDATE_FREEZE_EMBRYOS_ASYNCMutation, UPDATE_FREEZE_EMBRYOS_ASYNCMutationVariables>({
      query: (variables) => ({ document: UPDATE_FREEZE_EMBRYOS_ASYNC, variables })
    }),
    UPDATE_FREEZE_TEMP_EMBRYOS_ASYNC: build.mutation<UPDATE_FREEZE_TEMP_EMBRYOS_ASYNCMutation, UPDATE_FREEZE_TEMP_EMBRYOS_ASYNCMutationVariables>({
      query: (variables) => ({ document: UPDATE_FREEZE_TEMP_EMBRYOS_ASYNC, variables })
    }),
    CREATE_FREEZE_VALIDATION_REPORT: build.mutation<CREATE_FREEZE_VALIDATION_REPORTMutation, CREATE_FREEZE_VALIDATION_REPORTMutationVariables>({
      query: (variables) => ({ document: CREATE_FREEZE_VALIDATION_REPORT, variables })
    }),
    UPDATE_MATING_LABELS_FREEZE: build.mutation<UPDATE_MATING_LABELS_FREEZEMutation, UPDATE_MATING_LABELS_FREEZEMutationVariables>({
      query: (variables) => ({ document: UPDATE_MATING_LABELS_FREEZE, variables })
    }),
    GET_FERTILIZATION_LIST_FREEZE: build.query<GET_FERTILIZATION_LIST_FREEZEQuery, GET_FERTILIZATION_LIST_FREEZEQueryVariables>({
      query: (variables) => ({ document: GET_FERTILIZATION_LIST_FREEZE, variables })
    }),
    GET_FERT_AND_EMBRYOS_FREEZE: build.query<GET_FERT_AND_EMBRYOS_FREEZEQuery, GET_FERT_AND_EMBRYOS_FREEZEQueryVariables>({
      query: (variables) => ({ document: GET_FERT_AND_EMBRYOS_FREEZE, variables })
    }),
    GET_FREEZE_STORAGE_LOCATIONS: build.query<GET_FREEZE_STORAGE_LOCATIONSQuery, GET_FREEZE_STORAGE_LOCATIONSQueryVariables>({
      query: (variables) => ({ document: GET_FREEZE_STORAGE_LOCATIONS, variables })
    }),
    UPDATE_FERT_TRANSACTION: build.mutation<UPDATE_FERT_TRANSACTIONMutation, UPDATE_FERT_TRANSACTIONMutationVariables>({
      query: (variables) => ({ document: UPDATE_FERT_TRANSACTION, variables })
    }),
    UPDATE_DS_TRANSACTION: build.mutation<UPDATE_DS_TRANSACTIONMutation, UPDATE_DS_TRANSACTIONMutationVariables>({
      query: (variables) => ({ document: UPDATE_DS_TRANSACTION, variables })
    }),
    UPDATE_FRESH_SHIPMENT_TRANSACTION: build.mutation<UPDATE_FRESH_SHIPMENT_TRANSACTIONMutation, UPDATE_FRESH_SHIPMENT_TRANSACTIONMutationVariables>({
      query: (variables) => ({ document: UPDATE_FRESH_SHIPMENT_TRANSACTION, variables })
    }),
    UPDATE_SHIPMENT_GROUP_TRANSACTION: build.mutation<UPDATE_SHIPMENT_GROUP_TRANSACTIONMutation, UPDATE_SHIPMENT_GROUP_TRANSACTIONMutationVariables>({
      query: (variables) => ({ document: UPDATE_SHIPMENT_GROUP_TRANSACTION, variables })
    }),
    CREATE_FRESH_SHIPMENT_IMPLANT_FORM_REPORT: build.mutation<CREATE_FRESH_SHIPMENT_IMPLANT_FORM_REPORTMutation, CREATE_FRESH_SHIPMENT_IMPLANT_FORM_REPORTMutationVariables>({
      query: (variables) => ({ document: CREATE_FRESH_SHIPMENT_IMPLANT_FORM_REPORT, variables })
    }),
    CREATE_FRESH_SHIPMENT_FORM_REPORT: build.mutation<CREATE_FRESH_SHIPMENT_FORM_REPORTMutation, CREATE_FRESH_SHIPMENT_FORM_REPORTMutationVariables>({
      query: (variables) => ({ document: CREATE_FRESH_SHIPMENT_FORM_REPORT, variables })
    }),
    CREATE_FRESH_SHIPMENT_EXPORT_SEAL_FORM_REPORT: build.mutation<CREATE_FRESH_SHIPMENT_EXPORT_SEAL_FORM_REPORTMutation, CREATE_FRESH_SHIPMENT_EXPORT_SEAL_FORM_REPORTMutationVariables>({
      query: (variables) => ({ document: CREATE_FRESH_SHIPMENT_EXPORT_SEAL_FORM_REPORT, variables })
    }),
    UPDATE_MATING_LABELS: build.mutation<UPDATE_MATING_LABELSMutation, UPDATE_MATING_LABELSMutationVariables>({
      query: (variables) => ({ document: UPDATE_MATING_LABELS, variables })
    }),
    UPDATE_MATING_LABELS_DUPES: build.mutation<UPDATE_MATING_LABELS_DUPESMutation, UPDATE_MATING_LABELS_DUPESMutationVariables>({
      query: (variables) => ({ document: UPDATE_MATING_LABELS_DUPES, variables })
    }),
    UPDATE_INCUBATOR_ASSIGNMENT: build.mutation<UPDATE_INCUBATOR_ASSIGNMENTMutation, UPDATE_INCUBATOR_ASSIGNMENTMutationVariables>({
      query: (variables) => ({ document: UPDATE_INCUBATOR_ASSIGNMENT, variables })
    }),
    GENERATE_SIGN_OFF_EMAIL: build.mutation<GENERATE_SIGN_OFF_EMAILMutation, GENERATE_SIGN_OFF_EMAILMutationVariables>({
      query: (variables) => ({ document: GENERATE_SIGN_OFF_EMAIL, variables })
    }),
    UNDO_SHIPMENT: build.mutation<UNDO_SHIPMENTMutation, UNDO_SHIPMENTMutationVariables>({
      query: (variables) => ({ document: UNDO_SHIPMENT, variables })
    }),
    COMBINE_SHIPMENTS: build.mutation<COMBINE_SHIPMENTSMutation, COMBINE_SHIPMENTSMutationVariables>({
      query: (variables) => ({ document: COMBINE_SHIPMENTS, variables })
    }),
    UPDATE_QC_FRESH_SHIPMENT: build.mutation<UPDATE_QC_FRESH_SHIPMENTMutation, UPDATE_QC_FRESH_SHIPMENTMutationVariables>({
      query: (variables) => ({ document: UPDATE_QC_FRESH_SHIPMENT, variables })
    }),
    CREATE_COMM_DAIRY_FERTILIZATION_EXCEL: build.mutation<CREATE_COMM_DAIRY_FERTILIZATION_EXCELMutation, CREATE_COMM_DAIRY_FERTILIZATION_EXCELMutationVariables>({
      query: (variables) => ({ document: CREATE_COMM_DAIRY_FERTILIZATION_EXCEL, variables })
    }),
    SEND_COMM_DAIRY_FERTILIZATION_EMAIL: build.mutation<SEND_COMM_DAIRY_FERTILIZATION_EMAILMutation, SEND_COMM_DAIRY_FERTILIZATION_EMAILMutationVariables>({
      query: (variables) => ({ document: SEND_COMM_DAIRY_FERTILIZATION_EMAIL, variables })
    }),
    GET_SHIP_GROUP_LIST: build.query<GET_SHIP_GROUP_LISTQuery, GET_SHIP_GROUP_LISTQueryVariables>({
      query: (variables) => ({ document: GET_SHIP_GROUP_LIST, variables })
    }),
    GET_FRESH_SHIPMENT_LIST: build.query<GET_FRESH_SHIPMENT_LISTQuery, GET_FRESH_SHIPMENT_LISTQueryVariables>({
      query: (variables) => ({ document: GET_FRESH_SHIPMENT_LIST, variables })
    }),
    GET_FERTILIZATION_LIST: build.query<GET_FERTILIZATION_LISTQuery, GET_FERTILIZATION_LISTQueryVariables>({
      query: (variables) => ({ document: GET_FERTILIZATION_LIST, variables })
    }),
    GET_ESTIMATION_HEADER_VAL: build.query<GET_ESTIMATION_HEADER_VALQuery, GET_ESTIMATION_HEADER_VALQueryVariables>({
      query: (variables) => ({ document: GET_ESTIMATION_HEADER_VAL, variables })
    }),
    GET_PREDICTION_TECHS: build.query<GET_PREDICTION_TECHSQuery, GET_PREDICTION_TECHSQueryVariables | void>({
      query: (variables) => ({ document: GET_PREDICTION_TECHS, variables })
    }),
    GET_CURRENT_FERT_PREDICTION_TECH: build.query<GET_CURRENT_FERT_PREDICTION_TECHQuery, GET_CURRENT_FERT_PREDICTION_TECHQueryVariables>({
      query: (variables) => ({ document: GET_CURRENT_FERT_PREDICTION_TECH, variables })
    }),
    GET_SHIPMENT_GROUP_MASTERS: build.query<GET_SHIPMENT_GROUP_MASTERSQuery, GET_SHIPMENT_GROUP_MASTERSQueryVariables>({
      query: (variables) => ({ document: GET_SHIPMENT_GROUP_MASTERS, variables })
    }),
    GET_FERTILIZATION_QC_DATA: build.query<GET_FERTILIZATION_QC_DATAQuery, GET_FERTILIZATION_QC_DATAQueryVariables>({
      query: (variables) => ({ document: GET_FERTILIZATION_QC_DATA, variables })
    }),
    GET_FRESH_SHIPMENT_QC: build.query<GET_FRESH_SHIPMENT_QCQuery, GET_FRESH_SHIPMENT_QCQueryVariables>({
      query: (variables) => ({ document: GET_FRESH_SHIPMENT_QC, variables })
    }),
    CREATE_ISSUE_MANAGER: build.mutation<CREATE_ISSUE_MANAGERMutation, CREATE_ISSUE_MANAGERMutationVariables>({
      query: (variables) => ({ document: CREATE_ISSUE_MANAGER, variables })
    }),
    DELETE_ISSUE_MANAGER: build.mutation<DELETE_ISSUE_MANAGERMutation, DELETE_ISSUE_MANAGERMutationVariables>({
      query: (variables) => ({ document: DELETE_ISSUE_MANAGER, variables })
    }),
    CREATE_REQUEST_EVENT: build.mutation<CREATE_REQUEST_EVENTMutation, CREATE_REQUEST_EVENTMutationVariables>({
      query: (variables) => ({ document: CREATE_REQUEST_EVENT, variables })
    }),
    CREATE_IT_REQUEST: build.mutation<CREATE_IT_REQUESTMutation, CREATE_IT_REQUESTMutationVariables>({
      query: (variables) => ({ document: CREATE_IT_REQUEST, variables })
    }),
    CREATE_CLIENT_ISSUE_REQUEST: build.mutation<CREATE_CLIENT_ISSUE_REQUESTMutation, CREATE_CLIENT_ISSUE_REQUESTMutationVariables>({
      query: (variables) => ({ document: CREATE_CLIENT_ISSUE_REQUEST, variables })
    }),
    CREATE_REPORT_REQUEST: build.mutation<CREATE_REPORT_REQUESTMutation, CREATE_REPORT_REQUESTMutationVariables>({
      query: (variables) => ({ document: CREATE_REPORT_REQUEST, variables })
    }),
    MY_OPEN_REQUESTS: build.query<MY_OPEN_REQUESTSQuery, MY_OPEN_REQUESTSQueryVariables>({
      query: (variables) => ({ document: MY_OPEN_REQUESTS, variables })
    }),
    MY_CLOSED_REQUESTS: build.query<MY_CLOSED_REQUESTSQuery, MY_CLOSED_REQUESTSQueryVariables>({
      query: (variables) => ({ document: MY_CLOSED_REQUESTS, variables })
    }),
    MY_REQUESTS: build.query<MY_REQUESTSQuery, MY_REQUESTSQueryVariables>({
      query: (variables) => ({ document: MY_REQUESTS, variables })
    }),
    ALL_REQUESTS: build.query<ALL_REQUESTSQuery, ALL_REQUESTSQueryVariables>({
      query: (variables) => ({ document: ALL_REQUESTS, variables })
    }),
    ALL_OPEN_REQUESTS: build.query<ALL_OPEN_REQUESTSQuery, ALL_OPEN_REQUESTSQueryVariables>({
      query: (variables) => ({ document: ALL_OPEN_REQUESTS, variables })
    }),
    ALL_CLOSED_REQUESTS: build.query<ALL_CLOSED_REQUESTSQuery, ALL_CLOSED_REQUESTSQueryVariables>({
      query: (variables) => ({ document: ALL_CLOSED_REQUESTS, variables })
    }),
    SEARCH_REQUEST: build.query<SEARCH_REQUESTQuery, SEARCH_REQUESTQueryVariables>({
      query: (variables) => ({ document: SEARCH_REQUEST, variables })
    }),
    IT_REQUEST: build.query<IT_REQUESTQuery, IT_REQUESTQueryVariables>({
      query: (variables) => ({ document: IT_REQUEST, variables })
    }),
    TOGGLE_SUBSCRIBED: build.mutation<TOGGLE_SUBSCRIBEDMutation, TOGGLE_SUBSCRIBEDMutationVariables>({
      query: (variables) => ({ document: TOGGLE_SUBSCRIBED, variables })
    }),
    TOGGLE_IMPORTANT: build.mutation<TOGGLE_IMPORTANTMutation, TOGGLE_IMPORTANTMutationVariables>({
      query: (variables) => ({ document: TOGGLE_IMPORTANT, variables })
    }),
    IT_APPS: build.query<IT_APPSQuery, IT_APPSQueryVariables | void>({
      query: (variables) => ({ document: IT_APPS, variables })
    }),
    DEPARTMENTS: build.query<DEPARTMENTSQuery, DEPARTMENTSQueryVariables | void>({
      query: (variables) => ({ document: DEPARTMENTS, variables })
    }),
    IT_REQUEST_ISSUE_MANAGERS: build.query<IT_REQUEST_ISSUE_MANAGERSQuery, IT_REQUEST_ISSUE_MANAGERSQueryVariables | void>({
      query: (variables) => ({ document: IT_REQUEST_ISSUE_MANAGERS, variables })
    }),
    AD_USERS: build.query<AD_USERSQuery, AD_USERSQueryVariables | void>({
      query: (variables) => ({ document: AD_USERS, variables })
    }),
    ADD_LEGACY_APPS_FAVORITE: build.mutation<ADD_LEGACY_APPS_FAVORITEMutation, ADD_LEGACY_APPS_FAVORITEMutationVariables>({
      query: (variables) => ({ document: ADD_LEGACY_APPS_FAVORITE, variables })
    }),
    REMOVE_LEGACY_APPS_FAVORITE: build.mutation<REMOVE_LEGACY_APPS_FAVORITEMutation, REMOVE_LEGACY_APPS_FAVORITEMutationVariables>({
      query: (variables) => ({ document: REMOVE_LEGACY_APPS_FAVORITE, variables })
    }),
    REORDER_LEGACY_APPS_FAVORITES: build.mutation<REORDER_LEGACY_APPS_FAVORITESMutation, REORDER_LEGACY_APPS_FAVORITESMutationVariables>({
      query: (variables) => ({ document: REORDER_LEGACY_APPS_FAVORITES, variables })
    }),
    GET_ALL_LEGACY_APPS: build.query<GET_ALL_LEGACY_APPSQuery, GET_ALL_LEGACY_APPSQueryVariables | void>({
      query: (variables) => ({ document: GET_ALL_LEGACY_APPS, variables })
    }),
    GET_LEGACY_APPS_FAVORITES: build.query<GET_LEGACY_APPS_FAVORITESQuery, GET_LEGACY_APPS_FAVORITESQueryVariables | void>({
      query: (variables) => ({ document: GET_LEGACY_APPS_FAVORITES, variables })
    }),
    UPDATE_ASPIRATION_OPU_SEARCH: build.mutation<UPDATE_ASPIRATION_OPU_SEARCHMutation, UPDATE_ASPIRATION_OPU_SEARCHMutationVariables>({
      query: (variables) => ({ document: UPDATE_ASPIRATION_OPU_SEARCH, variables })
    }),
    CREATE_NEW_ASP_POOL: build.mutation<CREATE_NEW_ASP_POOLMutation, CREATE_NEW_ASP_POOLMutationVariables>({
      query: (variables) => ({ document: CREATE_NEW_ASP_POOL, variables })
    }),
    REMOVE_ASP_POOL: build.mutation<REMOVE_ASP_POOLMutation, REMOVE_ASP_POOLMutationVariables>({
      query: (variables) => ({ document: REMOVE_ASP_POOL, variables })
    }),
    SAVE_QC_DATA_OPUSEARCH: build.mutation<SAVE_QC_DATA_OPUSEARCHMutation, SAVE_QC_DATA_OPUSEARCHMutationVariables>({
      query: (variables) => ({ document: SAVE_QC_DATA_OPUSEARCH, variables })
    }),
    GET_EQUIPMENTS: build.query<GET_EQUIPMENTSQuery, GET_EQUIPMENTSQueryVariables | void>({
      query: (variables) => ({ document: GET_EQUIPMENTS, variables })
    }),
    GET_ASPIRATION_BY_DONOR_AND_ID: build.query<GET_ASPIRATION_BY_DONOR_AND_IDQuery, GET_ASPIRATION_BY_DONOR_AND_IDQueryVariables>({
      query: (variables) => ({ document: GET_ASPIRATION_BY_DONOR_AND_ID, variables })
    }),
    GET_COMPLETED_ASPIRATIONS_TODAY: build.query<GET_COMPLETED_ASPIRATIONS_TODAYQuery, GET_COMPLETED_ASPIRATIONS_TODAYQueryVariables>({
      query: (variables) => ({ document: GET_COMPLETED_ASPIRATIONS_TODAY, variables })
    }),
    GET_COMPLETED_ASPIRATIONS_TODAY_FBD: build.query<GET_COMPLETED_ASPIRATIONS_TODAY_FBDQuery, GET_COMPLETED_ASPIRATIONS_TODAY_FBDQueryVariables>({
      query: (variables) => ({ document: GET_COMPLETED_ASPIRATIONS_TODAY_FBD, variables })
    }),
    GET_STATS_DATA: build.query<GET_STATS_DATAQuery, GET_STATS_DATAQueryVariables>({
      query: (variables) => ({ document: GET_STATS_DATA, variables })
    }),
    GET_STATS_DATA_PSE: build.query<GET_STATS_DATA_PSEQuery, GET_STATS_DATA_PSEQueryVariables>({
      query: (variables) => ({ document: GET_STATS_DATA_PSE, variables })
    }),
    GET_OPU_ENTRIES: build.query<GET_OPU_ENTRIESQuery, GET_OPU_ENTRIESQueryVariables>({
      query: (variables) => ({ document: GET_OPU_ENTRIES, variables })
    }),
    GET_OPU_ENTRIES_PSE: build.query<GET_OPU_ENTRIES_PSEQuery, GET_OPU_ENTRIES_PSEQueryVariables>({
      query: (variables) => ({ document: GET_OPU_ENTRIES_PSE, variables })
    }),
    GET_TECH_AVG_DATA: build.query<GET_TECH_AVG_DATAQuery, GET_TECH_AVG_DATAQueryVariables>({
      query: (variables) => ({ document: GET_TECH_AVG_DATA, variables })
    }),
    GET_AVG_DATA: build.query<GET_AVG_DATAQuery, GET_AVG_DATAQueryVariables>({
      query: (variables) => ({ document: GET_AVG_DATA, variables })
    }),
    GET_ASP_DATA_POOL: build.query<GET_ASP_DATA_POOLQuery, GET_ASP_DATA_POOLQueryVariables>({
      query: (variables) => ({ document: GET_ASP_DATA_POOL, variables })
    }),
    GET_ASPIRATION_POOLS_BY_DATE_AND_SITE: build.query<GET_ASPIRATION_POOLS_BY_DATE_AND_SITEQuery, GET_ASPIRATION_POOLS_BY_DATE_AND_SITEQueryVariables>({
      query: (variables) => ({ document: GET_ASPIRATION_POOLS_BY_DATE_AND_SITE, variables })
    }),
    GET_EMB_FERT_DATA_BY_DONOR_ID: build.query<GET_EMB_FERT_DATA_BY_DONOR_IDQuery, GET_EMB_FERT_DATA_BY_DONOR_IDQueryVariables>({
      query: (variables) => ({ document: GET_EMB_FERT_DATA_BY_DONOR_ID, variables })
    }),
    GET_TODAYS_QC_DATA_OPUSEARCH: build.query<GET_TODAYS_QC_DATA_OPUSEARCHQuery, GET_TODAYS_QC_DATA_OPUSEARCHQueryVariables>({
      query: (variables) => ({ document: GET_TODAYS_QC_DATA_OPUSEARCH, variables })
    }),
    REFRESH_STOP_GO_SIGN: build.query<REFRESH_STOP_GO_SIGNQuery, REFRESH_STOP_GO_SIGNQueryVariables>({
      query: (variables) => ({ document: REFRESH_STOP_GO_SIGN, variables })
    }),
    SHOW_STOP_SIGN: build.query<SHOW_STOP_SIGNQuery, SHOW_STOP_SIGNQueryVariables>({
      query: (variables) => ({ document: SHOW_STOP_SIGN, variables })
    }),
    PULL_SEMEN: build.mutation<PULL_SEMENMutation, PULL_SEMENMutationVariables>({
      query: (variables) => ({ document: PULL_SEMEN, variables })
    }),
    RETURN_SEMEN: build.mutation<RETURN_SEMENMutation, RETURN_SEMENMutationVariables>({
      query: (variables) => ({ document: RETURN_SEMEN, variables })
    }),
    REJECT_DISCARD_SEMEN: build.mutation<REJECT_DISCARD_SEMENMutation, REJECT_DISCARD_SEMENMutationVariables>({
      query: (variables) => ({ document: REJECT_DISCARD_SEMEN, variables })
    }),
    PULL_OD_SEMEN: build.mutation<PULL_OD_SEMENMutation, PULL_OD_SEMENMutationVariables>({
      query: (variables) => ({ document: PULL_OD_SEMEN, variables })
    }),
    CREATE_NEW_SEMEN: build.mutation<CREATE_NEW_SEMENMutation, CREATE_NEW_SEMENMutationVariables>({
      query: (variables) => ({ document: CREATE_NEW_SEMEN, variables })
    }),
    UPDATE_SEMEN: build.mutation<UPDATE_SEMENMutation, UPDATE_SEMENMutationVariables>({
      query: (variables) => ({ document: UPDATE_SEMEN, variables })
    }),
    UPDATE_DS_SUGGESTED: build.mutation<UPDATE_DS_SUGGESTEDMutation, UPDATE_DS_SUGGESTEDMutationVariables>({
      query: (variables) => ({ document: UPDATE_DS_SUGGESTED, variables })
    }),
    SCHEDULED_SEMEN: build.query<SCHEDULED_SEMENQuery, SCHEDULED_SEMENQueryVariables>({
      query: (variables) => ({ document: SCHEDULED_SEMEN, variables })
    }),
    GET_PULLED_SEMEN: build.query<GET_PULLED_SEMENQuery, GET_PULLED_SEMENQueryVariables>({
      query: (variables) => ({ document: GET_PULLED_SEMEN, variables })
    }),
    GET_SCHEDULED_DONORS: build.query<GET_SCHEDULED_DONORSQuery, GET_SCHEDULED_DONORSQueryVariables>({
      query: (variables) => ({ document: GET_SCHEDULED_DONORS, variables })
    }),
    GET_UNFINISHED_SCHEDULED_DONORS: build.query<GET_UNFINISHED_SCHEDULED_DONORSQuery, GET_UNFINISHED_SCHEDULED_DONORSQueryVariables>({
      query: (variables) => ({ document: GET_UNFINISHED_SCHEDULED_DONORS, variables })
    }),
    GET_OD_SIMILAR_SEMEN: build.query<GET_OD_SIMILAR_SEMENQuery, GET_OD_SIMILAR_SEMENQueryVariables>({
      query: (variables) => ({ document: GET_OD_SIMILAR_SEMEN, variables })
    }),
    GET_OD_SEMEN: build.query<GET_OD_SEMENQuery, GET_OD_SEMENQueryVariables>({
      query: (variables) => ({ document: GET_OD_SEMEN, variables })
    }),
    STRING_MAP_SEARCH: build.query<STRING_MAP_SEARCHQuery, STRING_MAP_SEARCHQueryVariables>({
      query: (variables) => ({ document: STRING_MAP_SEARCH, variables })
    }),
    STORAGE_LOCATIONS: build.query<STORAGE_LOCATIONSQuery, STORAGE_LOCATIONSQueryVariables>({
      query: (variables) => ({ document: STORAGE_LOCATIONS, variables })
    }),
    UPDATE_SHIPMENT: build.mutation<UPDATE_SHIPMENTMutation, UPDATE_SHIPMENTMutationVariables>({
      query: (variables) => ({ document: UPDATE_SHIPMENT, variables })
    }),
    SHIPPING_SET_IN_PROGRESS: build.mutation<SHIPPING_SET_IN_PROGRESSMutation, SHIPPING_SET_IN_PROGRESSMutationVariables>({
      query: (variables) => ({ document: SHIPPING_SET_IN_PROGRESS, variables })
    }),
    CREATE_SHIPPING_FORM_REPORT: build.mutation<CREATE_SHIPPING_FORM_REPORTMutation, CREATE_SHIPPING_FORM_REPORTMutationVariables>({
      query: (variables) => ({ document: CREATE_SHIPPING_FORM_REPORT, variables })
    }),
    SHIPPING_RUN_SHIP: build.mutation<SHIPPING_RUN_SHIPMutation, SHIPPING_RUN_SHIPMutationVariables>({
      query: (variables) => ({ document: SHIPPING_RUN_SHIP, variables })
    }),
    SHIPPING_RUN_SHIP_INTRA: build.mutation<SHIPPING_RUN_SHIP_INTRAMutation, SHIPPING_RUN_SHIP_INTRAMutationVariables>({
      query: (variables) => ({ document: SHIPPING_RUN_SHIP_INTRA, variables })
    }),
    SHIPPING_RUN_SHIP_INTRA_YACKLEY: build.mutation<SHIPPING_RUN_SHIP_INTRA_YACKLEYMutation, SHIPPING_RUN_SHIP_INTRA_YACKLEYMutationVariables>({
      query: (variables) => ({ document: SHIPPING_RUN_SHIP_INTRA_YACKLEY, variables })
    }),
    SHIPPING_SHIPMENTS: build.query<SHIPPING_SHIPMENTSQuery, SHIPPING_SHIPMENTSQueryVariables>({
      query: (variables) => ({ document: SHIPPING_SHIPMENTS, variables })
    }),
    ALL_SHIPMENTS: build.query<ALL_SHIPMENTSQuery, ALL_SHIPMENTSQueryVariables>({
      query: (variables) => ({ document: ALL_SHIPMENTS, variables })
    }),
    SHIPPING_ACCOUNT_SEARCH: build.query<SHIPPING_ACCOUNT_SEARCHQuery, SHIPPING_ACCOUNT_SEARCHQueryVariables>({
      query: (variables) => ({ document: SHIPPING_ACCOUNT_SEARCH, variables })
    }),
    SHIPPING_EQUIPMENT_SEARCH: build.query<SHIPPING_EQUIPMENT_SEARCHQuery, SHIPPING_EQUIPMENT_SEARCHQueryVariables>({
      query: (variables) => ({ document: SHIPPING_EQUIPMENT_SEARCH, variables })
    }),
    SHIPPING_SITES: build.query<SHIPPING_SITESQuery, SHIPPING_SITESQueryVariables | void>({
      query: (variables) => ({ document: SHIPPING_SITES, variables })
    }),
    SHIPPING_SITE_SEARCH: build.query<SHIPPING_SITE_SEARCHQuery, SHIPPING_SITE_SEARCHQueryVariables>({
      query: (variables) => ({ document: SHIPPING_SITE_SEARCH, variables })
    }),
    SHIPMENT: build.query<SHIPMENTQuery, SHIPMENTQueryVariables>({
      query: (variables) => ({ document: SHIPMENT, variables })
    }),
    EMBRYOS: build.query<EMBRYOSQuery, EMBRYOSQueryVariables>({
      query: (variables) => ({ document: EMBRYOS, variables })
    }),
    SEMEN: build.query<SEMENQuery, SEMENQueryVariables>({
      query: (variables) => ({ document: SEMEN, variables })
    }),
    DONORS: build.query<DONORSQuery, DONORSQueryVariables>({
      query: (variables) => ({ document: DONORS, variables })
    }),
    RECIPIENTS: build.query<RECIPIENTSQuery, RECIPIENTSQueryVariables>({
      query: (variables) => ({ document: RECIPIENTS, variables })
    }),
    GET_CALVES: build.query<GET_CALVESQuery, GET_CALVESQueryVariables>({
      query: (variables) => ({ document: GET_CALVES, variables })
    }),
    SHIPPING_ACCOUNT_DETAILS: build.query<SHIPPING_ACCOUNT_DETAILSQuery, SHIPPING_ACCOUNT_DETAILSQueryVariables>({
      query: (variables) => ({ document: SHIPPING_ACCOUNT_DETAILS, variables })
    }),
    STRIPPING_UPDATE_FERTILIZATION: build.mutation<STRIPPING_UPDATE_FERTILIZATIONMutation, STRIPPING_UPDATE_FERTILIZATIONMutationVariables>({
      query: (variables) => ({ document: STRIPPING_UPDATE_FERTILIZATION, variables })
    }),
    STRIPPING_FERTILIZATONS: build.query<STRIPPING_FERTILIZATONSQuery, STRIPPING_FERTILIZATONSQueryVariables>({
      query: (variables) => ({ document: STRIPPING_FERTILIZATONS, variables })
    }),
    STRIPPING_TECHNICIANS: build.query<STRIPPING_TECHNICIANSQuery, STRIPPING_TECHNICIANSQueryVariables>({
      query: (variables) => ({ document: STRIPPING_TECHNICIANS, variables })
    }),
    ALL_STRIPPING_TECHNICIANS: build.query<ALL_STRIPPING_TECHNICIANSQuery, ALL_STRIPPING_TECHNICIANSQueryVariables | void>({
      query: (variables) => ({ document: ALL_STRIPPING_TECHNICIANS, variables })
    }),
    ME_EQUIPMENTS: build.query<ME_EQUIPMENTSQuery, ME_EQUIPMENTSQueryVariables | void>({
      query: (variables) => ({ document: ME_EQUIPMENTS, variables })
    }),
    ME: build.query<MEQuery, MEQueryVariables | void>({
      query: (variables) => ({ document: ME, variables })
    }),
    GET_ASPIRATION_SITES: build.query<GET_ASPIRATION_SITESQuery, GET_ASPIRATION_SITESQueryVariables | void>({
      query: (variables) => ({ document: GET_ASPIRATION_SITES, variables })
    }),
    GET_FERTILIZATION_SITES: build.query<GET_FERTILIZATION_SITESQuery, GET_FERTILIZATION_SITESQueryVariables | void>({
      query: (variables) => ({ document: GET_FERTILIZATION_SITES, variables })
    }),
    GET_SITE_BY_ID: build.query<GET_SITE_BY_IDQuery, GET_SITE_BY_IDQueryVariables>({
      query: (variables) => ({ document: GET_SITE_BY_ID, variables })
    }),
    STRING_MAP_REQUEST: build.query<STRING_MAP_REQUESTQuery, STRING_MAP_REQUESTQueryVariables>({
      query: (variables) => ({ document: STRING_MAP_REQUEST, variables })
    }),
    STRING_MAP: build.query<STRING_MAPQuery, STRING_MAPQueryVariables>({
      query: (variables) => ({ document: STRING_MAP, variables })
    }),
    SEND_REPORT_EMAIL: build.mutation<SEND_REPORT_EMAILMutation, SEND_REPORT_EMAILMutationVariables>({
      query: (variables) => ({ document: SEND_REPORT_EMAIL, variables })
    }),
  }),
});

export { injectedRtkApi as api };


